import { r as registerInstance, h, H as Host, c as createEvent, g as getElement, F as Fragment } from './index-91db3414.js';
import { M as MOBILE_SIZE, a as DEFAULT_Z_INDICES } from './constants-fce138fa.js';

const cpslAlertCss = ":host{--container-gap:8px;--container-padding-top:14px;--container-padding-bottom:14px;--container-padding-start:16px;--container-padding-end:16px;--container-font-size:var(--cpsl-font-size-body-m);--container-border-width:1px;--container-border-radius:var(--cpsl-border-radius-alert);--container-background-color:var(--cpsl-color-background-0);--container-color:var(--cpsl-color-text-primary);--container-icon-color:var(--container-color);--container-align-items:center;--container-justify-content:center;--title-container-gap:8px;--title-container-align-items:center;--title-container-justify-content:center;display:inline-block;font-family:var(--cpsl-font-family, inherit)}:host(.error){--container-border-color:var(--cpsl-color-utility-red)}:host(.error):host(.filled){--container-background-color:var(--cpsl-color-utility-red-light)}:host(.warning){--container-border-color:var(--cpsl-color-utility-yellow)}:host(.warning):host(.filled){--container-background-color:var(--cpsl-color-utility-yellow-light)}:host(.success){--container-border-color:var(--cpsl-color-utility-green)}:host(.success):host(.filled){--container-background-color:var(--cpsl-color-utility-green-light)}:host cpsl-icon{--icon-color:var(--container-icon-color);--height:20px;--width:20px}.alert-container{border-radius:var(--container-border-radius);-webkit-padding-start:var(--container-padding-start);padding-inline-start:var(--container-padding-start);-webkit-padding-end:var(--container-padding-end);padding-inline-end:var(--container-padding-end);padding-top:var(--container-padding-top);padding-bottom:var(--container-padding-bottom);font-size:var(--container-font-size);display:flex;flex-direction:column;align-items:var(--container-align-items);justify-content:var(--container-justify-content);gap:var(--container-gap);border-style:solid;border-width:var(--container-border-width);border-color:var(--container-border-color);background-color:var(--container-background-color);color:var(--container-color)}.title-container{display:flex;align-items:var(--title-container-align-items);justify-content:var(--title-container-justify-content);gap:var(--title-container-gap)}";
const CpslAlertStyle0 = cpslAlertCss;

const CpslAlert = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.icon = undefined;
        this.noIcon = undefined;
        this.variant = 'error';
        this.filled = undefined;
    }
    get iconType() {
        if (this.icon) {
            return this.icon;
        }
        switch (this.variant) {
            case 'custom': {
                return undefined;
            }
            case 'success': {
                return 'checkCircle';
            }
            case 'warning': {
                return 'alertCircle';
            }
            case 'error':
            default: {
                return 'alertCircle';
            }
        }
    }
    render() {
        return (h(Host, { key: '1450ede6418154fb7275ebd9d08705e98e73a816', class: { error: this.variant === 'error', warning: this.variant === 'warning', success: this.variant === 'success', filled: this.filled } }, h("div", { key: 'ab93670dc1e4b986835406d74013a062335af671', class: "alert-container" }, h("div", { key: 'ceac200df75f373f8b90bf1528d69910449fe831', class: "title-container" }, !this.noIcon && this.iconType && h("cpsl-icon", { key: 'cbf0a1568ea39b1187f7505738fa6176cdee22e7', icon: this.iconType }), h("slot", { key: 'b7e43b76c6d64e922dcef55b44c6007532b4c9f7' })), h("slot", { key: 'd2f2960d6fc715e94b45a8aaf10d69e6bdd89aa8', name: "subtitle" }))));
    }
};
CpslAlert.style = CpslAlertStyle0;

const cpslAppBarCss = ":host{display:block;position:relative;top:0;width:100%;z-index:10000}.container{display:flex;width:100%}";
const CpslAppBarStyle0 = cpslAppBarCss;

const CpslAppBar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.height = undefined;
        this.position = 'fixed';
        this.zIndexOverride = undefined;
    }
    render() {
        return (h(Host, { key: '281c1ebcc7ad61ccbd6878fb31d9b52a5860c273', style: Object.assign({
                // position: this.position,
                height: `${this.height}px`
            }, (this.zIndexOverride ? { zIndex: `${this.zIndexOverride}` } : {})) }, h("div", { key: '90fdd0e77212ac8a1c861e2402b34b15a9d26f7b', class: "container", part: "container", style: {
                position: this.position,
                height: `${this.height}px`,
            } }, h("slot", { key: '6aa42ab3e08a7d0629082a0bbba2831b1c9374f2' })), this.position === 'fixed' && (h("div", { key: '99169fc7212b22fcaa2e490ee2f6a7aad750e5a3', style: {
                height: `${this.height}px`,
            } }))));
    }
};
CpslAppBar.style = CpslAppBarStyle0;

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/*!
 * GSAP 3.12.5
 * https://gsap.com
 *
 * @license Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

/* eslint-disable */
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
},
    _defaults = {
  duration: .5,
  overwrite: false,
  delay: 0
},
    _suppressOverwrites,
    _reverting$1,
    _context,
    _bigNum$1 = 1e8,
    _tinyNum = 1 / _bigNum$1,
    _2PI = Math.PI * 2,
    _HALF_PI = _2PI / 4,
    _gsID = 0,
    _sqrt = Math.sqrt,
    _cos = Math.cos,
    _sin = Math.sin,
    _isString = function _isString(value) {
  return typeof value === "string";
},
    _isFunction = function _isFunction(value) {
  return typeof value === "function";
},
    _isNumber = function _isNumber(value) {
  return typeof value === "number";
},
    _isUndefined = function _isUndefined(value) {
  return typeof value === "undefined";
},
    _isObject = function _isObject(value) {
  return typeof value === "object";
},
    _isNotFalse = function _isNotFalse(value) {
  return value !== false;
},
    _windowExists$1 = function _windowExists() {
  return typeof window !== "undefined";
},
    _isFuncOrString = function _isFuncOrString(value) {
  return _isFunction(value) || _isString(value);
},
    _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
    // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray,
    _strictNumExp = /(?:-?\.?\d|\.)+/gi,
    //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
    //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
    _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
    //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/,
    _delimitedValueExp = /[^,'"\[\]\s]+/gi,
    // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
    _globalTimeline,
    _win$1,
    _coreInitted,
    _doc$1,
    _globals = {},
    _installScope = {},
    _coreReady,
    _install = function _install(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
},
    _missingPlugin = function _missingPlugin(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
},
    _warn = function _warn(message, suppress) {
  return !suppress && console.warn(message);
},
    _addGlobal = function _addGlobal(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
},
    _emptyFunc = function _emptyFunc() {
  return 0;
},
    _startAtRevertConfig = {
  suppressEvents: true,
  isStart: true,
  kill: false
},
    _revertConfigNoKill = {
  suppressEvents: true,
  kill: false
},
    _revertConfig = {
  suppressEvents: true
},
    _reservedProps = {},
    _lazyTweens = [],
    _lazyLookup = {},
    _lastRenderedFrame,
    _plugins = {},
    _effects = {},
    _nextGCFrame = 30,
    _harnessPlugins = [],
    _callbackNames = "",
    _harness = function _harness(targets) {
  var target = targets[0],
      harnessPlugin,
      i;
  _isObject(target) || _isFunction(target) || (targets = [targets]);

  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
    i = _harnessPlugins.length;

    while (i-- && !_harnessPlugins[i].targetTest(target)) {}

    harnessPlugin = _harnessPlugins[i];
  }

  i = targets.length;

  while (i--) {
    targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
  }

  return targets;
},
    _getCache = function _getCache(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
},
    _getProperty = function _getProperty(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
},
    _forEachName = function _forEachName(names, func) {
  return (names = names.split(",")).forEach(func) || names;
},
    //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
  return Math.round(value * 100000) / 100000 || 0;
},
    _roundPrecise = function _roundPrecise(value) {
  return Math.round(value * 10000000) / 10000000 || 0;
},
    // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
  var operator = value.charAt(0),
      end = parseFloat(value.substr(2));
  start = parseFloat(start);
  return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
},
    _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
  //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
  var l = toFind.length,
      i = 0;

  for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

  return i < l;
},
    _lazyRender = function _lazyRender() {
  var l = _lazyTweens.length,
      a = _lazyTweens.slice(0),
      i,
      tween;

  _lazyLookup = {};
  _lazyTweens.length = 0;

  for (i = 0; i < l; i++) {
    tween = a[i];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
},
    _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
  _lazyTweens.length && !_reverting$1 && _lazyRender();
  animation.render(time, suppressEvents, force || _reverting$1 && time < 0 && (animation._initted || animation._startAt));
  _lazyTweens.length && !_reverting$1 && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
},
    _numericIfPossible = function _numericIfPossible(value) {
  var n = parseFloat(value);
  return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
},
    _passThrough = function _passThrough(p) {
  return p;
},
    _setDefaults = function _setDefaults(obj, defaults) {
  for (var p in defaults) {
    p in obj || (obj[p] = defaults[p]);
  }

  return obj;
},
    _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
  return function (obj, defaults) {
    for (var p in defaults) {
      p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    }
  };
},
    _merge = function _merge(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }

  return base;
},
    _mergeDeep = function _mergeDeep(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }

  return base;
},
    _copyExcluding = function _copyExcluding(obj, excluding) {
  var copy = {},
      p;

  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }

  return copy;
},
    _inheritDefaults = function _inheritDefaults(vars) {
  var parent = vars.parent || _globalTimeline,
      func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }

  return vars;
},
    _arraysMatch = function _arraysMatch(a1, a2) {
  var i = a1.length,
      match = i === a2.length;

  while (match && i-- && a1[i] === a2[i]) {}

  return i < 0;
},
    _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = parent[lastProp],
      t;

  if (sortBy) {
    t = child[sortBy];

    while (prev && prev[sortBy] > t) {
      prev = prev._prev;
    }
  }

  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }

  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }

  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
},
    _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }

  if (lastProp === void 0) {
    lastProp = "_last";
  }

  var prev = child._prev,
      next = child._next;

  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }

  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }

  child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
},
    _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
  child._act = 0;
},
    _uncache = function _uncache(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
    var a = animation;

    while (a) {
      a._dirty = 1;
      a = a.parent;
    }
  }

  return animation;
},
    _recacheAncestors = function _recacheAncestors(animation) {
  var parent = animation.parent;

  while (parent && parent.parent) {
    //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }

  return animation;
},
    _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
  return tween._startAt && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
},
    _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
},
    _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
},
    // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
},
    _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
},
    _setEnd = function _setEnd(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
},
    _alignPlayhead = function _alignPlayhead(animation, totalTime) {
  // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
  var parent = animation._dp;

  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

    _setEnd(animation);

    parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
  }

  return animation;
},

/*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/
_postAddChecks = function _postAddChecks(timeline, child) {
  var t;

  if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
    // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
    t = _parentToChildTotalTime(timeline.rawTime(), child);

    if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
      child.render(t, true);
    }
  } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.


  if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
    //in case any of the ancestors had completed but should now be enabled...
    if (timeline._dur < timeline.duration()) {
      t = timeline;

      while (t._dp) {
        t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.

        t = t._dp;
      }
    }

    timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
  }
},
    _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

  _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

  _isFromOrFromStart(child) || (timeline._recent = child);
  skipChecks || _postAddChecks(timeline, child);
  timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)

  return timeline;
},
    _scrollTrigger = function _scrollTrigger(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
},
    _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
  _initTween(tween, time, tTime);

  if (!tween._initted) {
    return 1;
  }

  if (!force && tween._pt && !_reverting$1 && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);

    tween._lazy = [tTime, suppressEvents];
    return 1;
  }
},
    _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
},
    // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
},
    _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio,
      ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
      // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
  repeatDelay = tween._rDelay,
      tTime = 0,
      pt,
      iteration,
      prevIteration;

  if (repeatDelay && tween._repeat) {
    // in case there's a zero-duration tween that has a repeat with a repeatDelay
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

    if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
      // if iteration changed
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }

  if (ratio !== prevRatio || _reverting$1 || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
      // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
      return;
    }

    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

    suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.

    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }

    totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);

      if (!suppressEvents && !_reverting$1) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
},
    _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
  var child;

  if (time > prevTime) {
    child = animation._first;

    while (child && child._start <= time) {
      if (child.data === "isPause" && child._start > prevTime) {
        return child;
      }

      child = child._next;
    }
  } else {
    child = animation._last;

    while (child && child._start >= time) {
      if (child.data === "isPause" && child._start < prevTime) {
        return child;
      }

      child = child._prev;
    }
  }
},
    _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
  var repeat = animation._repeat,
      dur = _roundPrecise(duration) || 0,
      totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
  animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
},
    _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
},
    _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
},
    _parsePosition = function _parsePosition(animation, position, percentAnimation) {
  var labels = animation.labels,
      recent = animation._recent || _zeroPosition,
      clippedDuration = animation.duration() >= _bigNum$1 ? recent.endTime(false) : animation._dur,
      //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
  i,
      offset,
      isPercent;

  if (_isString(position) && (isNaN(position) || position in labels)) {
    //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i = position.indexOf("=");

    if (offset === "<" || offset === ">") {
      i >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }

    if (i < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }

    offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }

    return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
  }

  return position == null ? clippedDuration : +position;
},
    _createTweenType = function _createTweenType(type, params, timeline) {
  var isLegacy = _isNumber(params[1]),
      varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
      vars = params[varsIndex],
      irVars,
      parent;

  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline;

  if (type) {
    irVars = vars;
    parent = timeline;

    while (parent && !("immediateRender" in irVars)) {
      // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }

    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
  }

  return new Tween(params[0], vars, params[varsIndex + 1]);
},
    _conditionalReturn = function _conditionalReturn(value, func) {
  return value || value === 0 ? func(value) : func;
},
    _clamp = function _clamp(min, max, value) {
  return value < min ? min : value > max ? max : value;
},
    getUnit = function getUnit(value, v) {
  return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
},
    // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
  return _conditionalReturn(value, function (v) {
    return _clamp(min, max, v);
  });
},
    _slice = [].slice,
    _isArrayLike = function _isArrayLike(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win$1;
},
    _flatten = function _flatten(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }

  return ar.forEach(function (value) {
    var _accumulator;

    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
},
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
  return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc$1).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
},
    selector = function selector(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function (v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc$1.createElement("div") : value);
  };
},
    shuffle = function shuffle(a) {
  return a.sort(function () {
    return .5 - Math.random();
  });
},
    // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
  if (_isFunction(v)) {
    return v;
  }

  var vars = _isObject(v) ? v : {
    each: v
  },
      //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
  ease = _parseEase(vars.ease),
      from = vars.from || 0,
      base = parseFloat(vars.base) || 0,
      cache = {},
      isDecimal = from > 0 && from < 1,
      ratios = isNaN(from) || isDecimal,
      axis = vars.axis,
      ratioX = from,
      ratioY = from;

  if (_isString(from)) {
    ratioX = ratioY = {
      center: .5,
      edges: .5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }

  return function (i, target, a) {
    var l = (a || vars).length,
        distances = cache[l],
        originX,
        originY,
        x,
        y,
        d,
        j,
        max,
        min,
        wrapAt;

    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum$1])[1];

      if (!wrapAt) {
        max = -_bigNum$1;

        while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

        wrapAt < l && wrapAt--;
      }

      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
      originY = wrapAt === _bigNum$1 ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum$1;

      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }

      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0; //unit

      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }

    l = (distances[i] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
  };
},
    _roundModifier = function _roundModifier(v) {
  //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())

  return function (raw) {
    var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);

    return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
  };
},
    snap = function snap(snapTo, value) {
  var isArray = _isArray(snapTo),
      radius,
      is2D;

  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum$1;

    if (snapTo.values) {
      snapTo = toArray(snapTo.values);

      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }

  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function (raw) {
    var x = parseFloat(is2D ? raw.x : raw),
        y = parseFloat(is2D ? raw.y : 0),
        min = _bigNum$1,
        closest = 0,
        i = snapTo.length,
        dx,
        dy;

    while (i--) {
      if (is2D) {
        dx = snapTo[i].x - x;
        dy = snapTo[i].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i] - x);
      }

      if (dx < min) {
        min = dx;
        closest = i;
      }
    }

    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
},
    random = function random(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
},
    pipe = function pipe() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function (value) {
    return functions.reduce(function (v, f) {
      return f(v);
    }, value);
  };
},
    unitize = function unitize(func, unit) {
  return function (value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
},
    normalize = function normalize(min, max, value) {
  return mapRange(min, max, 0, 1, value);
},
    _wrapArray = function _wrapArray(a, wrapper, value) {
  return _conditionalReturn(value, function (index) {
    return a[~~wrapper(index)];
  });
},
    wrap = function wrap(min, max, value) {
  // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
    return (range + (value - min) % range) % range + min;
  });
},
    wrapYoyo = function wrapYoyo(min, max, value) {
  var range = max - min,
      total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
    value = (total + (value - min) % total) % total || 0;
    return min + (value > range ? total - value : value);
  });
},
    _replaceRandom = function _replaceRandom(value) {
  //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
  var prev = 0,
      s = "",
      i,
      nums,
      end,
      isArray;

  while (~(i = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i);
    isArray = value.charAt(i + 7) === "[";
    nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }

  return s + value.substr(prev, value.length - prev);
},
    mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin,
      outRange = outMax - outMin;
  return _conditionalReturn(value, function (value) {
    return outMin + ((value - inMin) / inRange * outRange || 0);
  });
},
    interpolate = function interpolate(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function (p) {
    return (1 - p) * start + p * end;
  };

  if (!func) {
    var isString = _isString(start),
        master = {},
        p,
        i,
        interpolators,
        l,
        il;

    progress === true && (mutate = 1) && (progress = null);

    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;

      for (i = 1; i < l; i++) {
        interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
      }

      l--;

      func = function func(p) {
        p *= l;
        var i = Math.min(il, ~~p);
        return interpolators[i](p - i);
      };

      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }

    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }

      func = function func(p) {
        return _renderPropTweens(p, master) || (isString ? start.p : start);
      };
    }
  }

  return _conditionalReturn(progress, func);
},
    _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
  //used for nextLabel() and previousLabel()
  var labels = timeline.labels,
      min = _bigNum$1,
      p,
      distance,
      label;

  for (p in labels) {
    distance = labels[p] - fromTime;

    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }

  return label;
},
    _callback = function _callback(animation, type, executeLazyFirst) {
  var v = animation.vars,
      callback = v[type],
      prevContext = _context,
      context = animation._ctx,
      params,
      scope,
      result;

  if (!callback) {
    return;
  }

  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.

  context && (_context = context);
  result = params ? callback.apply(scope, params) : callback.call(scope);
  _context = prevContext;
  return result;
},
    _interrupt = function _interrupt(animation) {
  _removeFromParent(animation);

  animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting$1);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
},
    _quickTween,
    _registerPluginQueue = [],
    _createPlugin = function _createPlugin(config) {
  if (!config) return;
  config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.

  if (_windowExists$1() || config.headless) {
    // edge case: some build tools may pass in a null/undefined value
    var name = config.name,
        isFunc = _isFunction(config),
        Plugin = name && !isFunc && config.init ? function () {
      this._props = [];
    } : config,
        //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
      init: _emptyFunc,
      render: _renderPropTweens,
      add: _addPropTween,
      kill: _killPropTweensOf,
      modifier: _addPluginModifier,
      rawVars: 0
    },
        statics = {
      targetTest: 0,
      get: 0,
      getSetter: _getSetter,
      aliases: {},
      register: 0
    };

    _wake();

    if (config !== Plugin) {
      if (_plugins[name]) {
        return;
      }

      _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods


      _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods


      _plugins[Plugin.prop = name] = Plugin;

      if (config.targetTest) {
        _harnessPlugins.push(Plugin);

        _reservedProps[name] = 1;
      }

      name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }

    _addGlobal(name, Plugin);

    config.register && config.register(gsap, Plugin, PropTween);
  } else {
    _registerPluginQueue.push(config);
  }
},

/*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */
_255 = 255,
    _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
},
    // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
  h += h < 0 ? 1 : h > 1 ? -1 : 0;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
},
    splitColor = function splitColor(v, toHSL, forceAlpha) {
  var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
      r,
      g,
      b,
      h,
      s,
      l,
      max,
      min,
      d,
      wasHSL;

  if (!a) {
    if (v.substr(-1) === ",") {
      //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
      v = v.substr(0, v.length - 1);
    }

    if (_colorLookup[v]) {
      a = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        //for shorthand like #9F0 or #9F0F (could have alpha)
        r = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }

      if (v.length === 9) {
        // hex with alpha, like #fd5e53ff
        a = parseInt(v.substr(1, 6), 16);
        return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
      }

      v = parseInt(v.substr(1), 16);
      a = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a = wasHSL = v.match(_strictNumExp);

      if (!toHSL) {
        h = +a[0] % 360 / 360;
        s = +a[1] / 100;
        l = +a[2] / 100;
        g = l <= .5 ? l * (s + 1) : l + s - l * s;
        r = l * 2 - g;
        a.length > 3 && (a[3] *= 1); //cast as number

        a[0] = _hue(h + 1 / 3, r, g);
        a[1] = _hue(h, r, g);
        a[2] = _hue(h - 1 / 3, r, g);
      } else if (~v.indexOf("=")) {
        //if relative values are found, just return the raw strings with the relative prefixes in place.
        a = v.match(_numExp);
        forceAlpha && a.length < 4 && (a[3] = 1);
        return a;
      }
    } else {
      a = v.match(_strictNumExp) || _colorLookup.transparent;
    }

    a = a.map(Number);
  }

  if (toHSL && !wasHSL) {
    r = a[0] / _255;
    g = a[1] / _255;
    b = a[2] / _255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
      h *= 60;
    }

    a[0] = ~~(h + .5);
    a[1] = ~~(s * 100 + .5);
    a[2] = ~~(l * 100 + .5);
  }

  forceAlpha && a.length < 4 && (a[3] = 1);
  return a;
},
    _colorOrderData = function _colorOrderData(v) {
  // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
  var values = [],
      c = [],
      i = -1;
  v.split(_colorExp).forEach(function (v) {
    var a = v.match(_numWithUnitExp) || [];
    values.push.apply(values, a);
    c.push(i += a.length + 1);
  });
  values.c = c;
  return values;
},
    _formatColors = function _formatColors(s, toHSL, orderMatchData) {
  var result = "",
      colors = (s + result).match(_colorExp),
      type = toHSL ? "hsla(" : "rgba(",
      i = 0,
      c,
      shell,
      d,
      l;

  if (!colors) {
    return s;
  }

  colors = colors.map(function (color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });

  if (orderMatchData) {
    d = _colorOrderData(s);
    c = orderMatchData.c;

    if (c.join(result) !== d.c.join(result)) {
      shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }

  if (!shell) {
    shell = s.split(_colorExp);
    l = shell.length - 1;

    for (; i < l; i++) {
      result += shell[i] + colors[i];
    }
  }

  return result + shell[l];
},
    _colorExp = function () {
  var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
      //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
  p;

  for (p in _colorLookup) {
    s += "|" + p + "\\b";
  }

  return new RegExp(s + ")", "gi");
}(),
    _hslExp = /hsl[a]?\(/,
    _colorStringFilter = function _colorStringFilter(a) {
  var combined = a.join(" "),
      toHSL;
  _colorExp.lastIndex = 0;

  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a[1] = _formatColors(a[1], toHSL);
    a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.

    return true;
  }
},

/*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */
_tickerActive,
    _ticker = function () {
  var _getTime = Date.now,
      _lagThreshold = 500,
      _adjustedLag = 33,
      _startTime = _getTime(),
      _lastUpdate = _startTime,
      _gap = 1000 / 240,
      _nextTime = _gap,
      _listeners = [],
      _id,
      _req,
      _raf,
      _self,
      _delta,
      _i,
      _tick = function _tick(v) {
    var elapsed = _getTime() - _lastUpdate,
        manual = v === true,
        overlap,
        dispatch,
        time,
        frame;

    (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;

    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1000;
      _self.time = time = time / 1000;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }

    manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.

    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };

  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1000 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists$1()) {
          _win$1 = _coreInitted = window;
          _doc$1 = _win$1.document || {};
          _globals.gsap = gsap;
          (_win$1.gsapVersions || (_win$1.gsapVersions = [])).push(gsap.version);

          _install(_installScope || _win$1.GreenSockGlobals || !_win$1.gsap && _win$1 || {});

          _registerPluginQueue.forEach(_createPlugin);
        }

        _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
        _id && _self.sleep();

        _req = _raf || function (f) {
          return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
        };

        _tickerActive = 1;

        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited

      _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
    },
    fps: function fps(_fps) {
      _gap = 1000 / (_fps || 240);
      _nextTime = _self.time * 1000 + _gap;
    },
    add: function add(callback, once, prioritize) {
      var func = once ? function (t, d, f, v) {
        callback(t, d, f, v);

        _self.remove(func);
      } : callback;

      _self.remove(callback);

      _listeners[prioritize ? "unshift" : "push"](func);

      _wake();

      return func;
    },
    remove: function remove(callback, i) {
      ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
    },
    _listeners: _listeners
  };
  return _self;
}(),
    _wake = function _wake() {
  return !_tickerActive && _ticker.wake();
},
    //also ensures the core classes are initialized.

/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/
_easeMap = {},
    _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
    _quotesExp = /["']/g,
    _parseObjectInString = function _parseObjectInString(value) {
  //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
  var obj = {},
      split = value.substr(1, value.length - 3).split(":"),
      key = split[0],
      i = 1,
      l = split.length,
      index,
      val,
      parsedVal;

  for (; i < l; i++) {
    val = split[i];
    index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }

  return obj;
},
    _valueInParentheses = function _valueInParentheses(value) {
  var open = value.indexOf("(") + 1,
      close = value.indexOf(")"),
      nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
},
    _configEaseFromString = function _configEaseFromString(name) {
  //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
  var split = (name + "").split("("),
      ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
},
    _invertEase = function _invertEase(ease) {
  return function (p) {
    return 1 - ease(1 - p);
  };
},
    // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
  var child = timeline._first,
      ease;

  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }

    child = child._next;
  }
},
    _parseEase = function _parseEase(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
},
    _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut(p) {
      return 1 - easeIn(1 - p);
    };
  }

  if (easeInOut === void 0) {
    easeInOut = function easeInOut(p) {
      return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }

  var ease = {
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut
  },
      lowercaseName;

  _forEachName(names, function (name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });

  return ease;
},
    _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
  return function (p) {
    return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
  };
},
    _configElastic = function _configElastic(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1,
      //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
  p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
      p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
      easeOut = function easeOut(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  p2 = _2PI / p2; //precalculate to optimize

  ease.config = function (amplitude, period) {
    return _configElastic(type, amplitude, period);
  };

  return ease;
},
    _configBack = function _configBack(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }

  var easeOut = function easeOut(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  },
      ease = type === "out" ? easeOut : type === "in" ? function (p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);

  ease.config = function (overshoot) {
    return _configBack(type, overshoot);
  };

  return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };


_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
  var power = i < 5 ? i + 1 : i;

  _insertEase(name + ",Power" + (power - 1), i ? function (p) {
    return Math.pow(p, power);
  } : function (p) {
    return p;
  }, function (p) {
    return 1 - Math.pow(1 - p, power);
  }, function (p) {
    return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});

_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

(function (n, c) {
  var n1 = 1 / c,
      n2 = 2 * n1,
      n3 = 2.5 * n1,
      easeOut = function easeOut(p) {
    return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
  };

  _insertEase("Bounce", function (p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);

_insertEase("Expo", function (p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});

_insertEase("Circ", function (p) {
  return -(_sqrt(1 - p * p) - 1);
});

_insertEase("Sine", function (p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});

_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }

    var p1 = 1 / steps,
        p2 = steps + (immediateStart ? 0 : 1),
        p3 = immediateStart ? 1 : 0,
        max = 1 - _tinyNum;
    return function (p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];

_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
  return _callbackNames += name + "," + name + "Params,";
});
/*
 * --------------------------------------------------------------------------------------
 * CACHE
 * --------------------------------------------------------------------------------------
 */


var GSCache = function GSCache(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
/*
 * --------------------------------------------------------------------------------------
 * ANIMATION
 * --------------------------------------------------------------------------------------
 */

var Animation = /*#__PURE__*/function () {
  function Animation(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;

    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }

    this._ts = 1;

    _setDuration(this, +vars.duration, 1, 1);

    this.data = vars.data;

    if (_context) {
      this._ctx = _context;

      _context.data.push(this);
    }

    _tickerActive || _ticker.wake();
  }

  var _proto = Animation.prototype;

  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }

    return this._delay;
  };

  _proto.duration = function duration(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };

  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }

    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };

  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();

    if (!arguments.length) {
      return this._tTime;
    }

    var parent = this._dp;

    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);

      !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
      //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.

      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }

        parent = parent.parent;
      }

      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }

    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
      this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
      //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
      //   this._lock = 1;

      _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
      //}

    }

    return this;
  };

  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
  };

  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  };

  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;

    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  } // potential future addition:
  // isPlayingBackwards() {
  // 	let animation = this,
  // 		orientation = 1; // 1 = forward, -1 = backward
  // 	while (animation) {
  // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
  // 		animation = animation.parent;
  // 	}
  // 	return orientation < 0;
  // }
  ;

  _proto.timeScale = function timeScale(value, suppressEvents) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
    }

    if (this._rts === value) {
      return this;
    }

    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
    // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
    //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
    // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.

    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.

    this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), suppressEvents !== false);

    _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.


    return _recacheAncestors(this);
  };

  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }

    if (this._ps !== value) {
      this._ps = value;

      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.

        this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
      } else {
        _wake();

        this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.

        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
      }
    }

    return this;
  };

  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }

    return this._start;
  };

  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };

  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp; // _dp = detached parent

    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };

  _proto.revert = function revert(config) {
    if (config === void 0) {
      config = _revertConfig;
    }

    var prevIsReverting = _reverting$1;
    _reverting$1 = config;

    if (this._initted || this._startAt) {
      this.timeline && this.timeline.revert(config);
      this.totalTime(-0.01, config.suppressEvents);
    }

    this.data !== "nested" && config.kill !== false && this.kill();
    _reverting$1 = prevIsReverting;
    return this;
  };

  _proto.globalTime = function globalTime(rawTime) {
    var animation = this,
        time = arguments.length ? rawTime : animation.rawTime();

    while (animation) {
      time = animation._start + time / (Math.abs(animation._ts) || 1);
      animation = animation._dp;
    }

    return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
  };

  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }

    return this._repeat === -2 ? Infinity : this._repeat;
  };

  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;

      _onUpdateTotalDuration(this);

      return time ? this.time(time) : this;
    }

    return this._rDelay;
  };

  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }

    return this._yoyo;
  };

  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };

  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };

  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };

  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };

  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };

  _proto.resume = function resume() {
    return this.paused(false);
  };

  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.

      return this;
    }

    return this._rts < 0;
  };

  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };

  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp,
        start = this._start,
        rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };

  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;

    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }

      return this;
    }

    return vars[type];
  };

  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function (resolve) {
      var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
          _resolve = function _resolve() {
        var _then = self.then;
        self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)

        _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
        resolve(f);
        self.then = _then;
      };

      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };

  _proto.kill = function kill() {
    _interrupt(this);
  };

  return Animation;
}();

_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
/*
 * -------------------------------------------------
 * TIMELINE
 * -------------------------------------------------
 */


var Timeline = /*#__PURE__*/function (_Animation) {
  _inheritsLoose(Timeline, _Animation);

  function Timeline(vars, position) {
    var _this;

    if (vars === void 0) {
      vars = {};
    }

    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }

  var _proto2 = Timeline.prototype;

  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);

    return this;
  };

  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);

    return this;
  };

  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);

    return this;
  };

  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };

  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  } //ONLY for backward compatibility! Maybe delete?
  ;

  _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };

  _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };

  _proto2.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._dirty ? this.totalDuration() : this._tDur,
        dur = this._dur,
        tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
        // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
    crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
        time,
        child,
        next,
        iteration,
        cycleDuration,
        prevPaused,
        pauseTween,
        timeScale,
        prevStart,
        prevIteration,
        yoyo,
        isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }

      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;

      if (crossingStart) {
        dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.

        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion

        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */


        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1,
              doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.

          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.

          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
            return this;
          }

          dur = this._dur; // in case the duration changed in the onRepeat

          tDur = this._tDur;

          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -0.0001;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }

          this._lock = 0;

          if (!this._ts && !prevPaused) {
            return this;
          } //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.


          _propagateYoyoEase(this, isYoyo);
        }
      }

      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }

      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
      }

      if (!prevTime && time && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      if (time >= prevTime && totalTime >= 0) {
        child = this._first;

        while (child) {
          next = child._next;

          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.

        while (child) {
          next = child._prev;

          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
              return this.render(totalTime, suppressEvents, force);
            }

            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting$1 && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.

            if (time !== this._time || !this._ts && !prevPaused) {
              //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)

              break;
            }
          }

          child = next;
        }
      }

      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

        if (this._ts) {
          //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
          this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.

          _setEnd(this);

          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
          _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto2.add = function add(child, position) {
    var _this2 = this;

    _isNumber(position) || (position = _parsePosition(this, position, child));

    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function (obj) {
          return _this2.add(obj, position);
        });
        return this;
      }

      if (_isString(child)) {
        return this.addLabel(child, position);
      }

      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }

    return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
  };

  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }

    if (tweens === void 0) {
      tweens = true;
    }

    if (timelines === void 0) {
      timelines = true;
    }

    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum$1;
    }

    var a = [],
        child = this._first;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a.push(child);
        } else {
          timelines && a.push(child);
          nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
        }
      }

      child = child._next;
    }

    return a;
  };

  _proto2.getById = function getById(id) {
    var animations = this.getChildren(1, 1, 1),
        i = animations.length;

    while (i--) {
      if (animations[i].vars.id === id) {
        return animations[i];
      }
    }
  };

  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }

    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }

    _removeLinkedListItem(this, child);

    if (child === this._recent) {
      this._recent = this._last;
    }

    return _uncache(this);
  };

  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }

    this._forcing = 1;

    if (!this._dp && this._ts) {
      //special case for the global timeline (or any other that has no parent or detached parent).
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }

    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

    this._forcing = 0;
    return this;
  };

  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };

  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };

  _proto2.addPause = function addPause(position, callback, params) {
    var t = Tween.delayedCall(0, callback || _emptyFunc, params);
    t.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t, _parsePosition(this, position));
  };

  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);

    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }

      child = child._next;
    }
  };

  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive),
        i = tweens.length;

    while (i--) {
      _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
    }

    return this;
  };

  _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
    var a = [],
        parsedTargets = toArray(targets),
        child = this._first,
        isGlobalTime = _isNumber(onlyActive),
        // a number is interpreted as a global time. If the animation spans
    children;

    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
          a.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a.push.apply(a, children);
      }

      child = child._next;
    }

    return a;
  } // potential future feature - targets() on timelines
  // targets() {
  // 	let result = [];
  // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
  // 	return result.filter((v, i) => result.indexOf(v) === i);
  // }
  ;

  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};

    var tl = this,
        endTime = _parsePosition(tl, position),
        _vars = vars,
        startAt = _vars.startAt,
        _onStart = _vars.onStart,
        onStartParams = _vars.onStartParams,
        immediateRender = _vars.immediateRender,
        initted,
        tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();

        if (!initted) {
          var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
          initted = 1;
        }

        _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
      }
    }, vars));

    return immediateRender ? tween.render(0) : tween;
  };

  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };

  _proto2.recent = function recent() {
    return this._recent;
  };

  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };

  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }

    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };

  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };

  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }

    var child = this._first,
        labels = this.labels,
        p;

    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }

      child = child._next;
    }

    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }

    return _uncache(this);
  };

  _proto2.invalidate = function invalidate(soft) {
    var child = this._first;
    this._lock = 0;

    while (child) {
      child.invalidate(soft);
      child = child._next;
    }

    return _Animation.prototype.invalidate.call(this, soft);
  };

  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }

    var child = this._first,
        next;

    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }

    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };

  _proto2.totalDuration = function totalDuration(value) {
    var max = 0,
        self = this,
        child = self._last,
        prevStart = _bigNum$1,
        prev,
        start,
        parent;

    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }

    if (self._dirty) {
      parent = self.parent;

      while (child) {
        prev = child._prev; //record it here in case the tween changes position in the sequence...

        child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.

        start = child._start;

        if (start > prevStart && self._sort && child._ts && !self._lock) {
          //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
          self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().

          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }

        if (start < 0 && child._ts) {
          //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
          max -= start;

          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }

          self.shiftChildren(-start, false, -1e999);
          prevStart = 0;
        }

        child._end > max && child._ts && (max = child._end);
        child = prev;
      }

      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

      self._dirty = 0;
    }

    return self._tDur;
  };

  Timeline.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

      _lastRenderedFrame = _ticker.frame;
    }

    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
        while (child && !child._ts) {
          child = child._next;
        }

        child || _ticker.sleep();
      }
    }
  };

  return Timeline;
}(Animation);

_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});

var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
  //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
      index = 0,
      matchIndex = 0,
      result,
      startNums,
      color,
      endNum,
      chunk,
      startNum,
      hasRandom,
      a;
  pt.b = start;
  pt.e = end;
  start += ""; //ensure values are strings

  end += "";

  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }

  if (stringFilter) {
    a = [start, end];
    stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.

    start = a[0];
    end = a[1];
  }

  startNums = start.match(_complexStringNumExp) || [];

  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);

    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }

    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.

      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }

  pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)

  pt.fp = funcParam;

  if (_relExp.test(end) || hasRandom) {
    pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
  }

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop],
      parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
      setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
      pt;

  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (end.charAt(1) === "=") {
      pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

      if (pt || pt === 0) {
        // to avoid isNaN, like if someone passes in a value like "!= whatever"
        end = pt;
      }
    }
  }

  if (!optional || parsedStart !== end || _forceAllPropTweens) {
    if (!isNaN(parsedStart * end) && end !== "") {
      // fun fact: any number multiplied by "" is evaluated as the number 0!
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }

    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
},
    //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }

  var copy = {},
      p;

  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }

  return copy;
},
    _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i;

  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.

      i = plugin._props.length;

      while (i--) {
        ptLookup[plugin._props[i]] = pt;
      }
    }
  }

  return plugin;
},
    _overwritingTween,
    //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens,
    _initTween = function _initTween(tween, time, tTime) {
  var vars = tween.vars,
      ease = vars.ease,
      startAt = vars.startAt,
      immediateRender = vars.immediateRender,
      lazy = vars.lazy,
      onUpdate = vars.onUpdate,
      runBackwards = vars.runBackwards,
      yoyoEase = vars.yoyoEase,
      keyframes = vars.keyframes,
      autoRevert = vars.autoRevert,
      dur = tween._dur,
      prevStartAt = tween._startAt,
      targets = tween._targets,
      parent = tween.parent,
      fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
      autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
      tl = tween.timeline,
      cleanVars,
      i,
      p,
      pt,
      target,
      hasPriority,
      gsData,
      harness,
      plugin,
      ptLookup,
      index,
      harnessVars,
      overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

  if (yoyoEase && tween._yoyo && !tween._repeat) {
    //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }

  tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.

  if (!tl || keyframes && !vars.stagger) {
    //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.

    cleanVars = _copyExcluding(vars, _reservedProps);

    if (prevStartAt) {
      prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.

      time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
      // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.

      prevStartAt._lazy = 0;
    }

    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent: parent,
        immediateRender: true,
        lazy: !prevStartAt && _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate: onUpdate && function () {
          return _callback(tween, "onUpdate");
        },
        stagger: 0
      }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);


      tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.

      tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween

      time < 0 && (_reverting$1 || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.

      if (immediateRender) {
        if (dur && time <= 0 && tTime <= 0) {
          // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
          time && (tween._zTime = time);
          return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
        }
      }
    } else if (runBackwards && dur) {
      //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
      if (!prevStartAt) {
        time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0

        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
          immediateRender: immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})

        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})

        _removeFromParent(tween._startAt = Tween.set(targets, p));

        tween._startAt._dp = 0; // don't allow it to get put back into root timeline!

        tween._startAt._sat = tween; // used in globalTime()

        time < 0 && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
        tween._zTime = time;

        if (!immediateRender) {
          _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded

        } else if (!time) {
          return;
        }
      }
    }

    tween._pt = tween._ptCache = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;

    for (i = 0; i < targets.length; i++) {
      target = targets[i];
      gsData = target._gsap || _harness(targets)[i]._gsap;
      tween._ptLookup[i] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)

      index = fullTargets === targets ? i : fullTargets.indexOf(target);

      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

        plugin._props.forEach(function (name) {
          ptLookup[name] = pt;
        });

        plugin.priority && (hasPriority = 1);
      }

      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }

      tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;

        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!


        overwritten = !tween.parent;
        _overwritingTween = 0;
      }

      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }

    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
  }

  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.

  keyframes && time <= 0 && tl.render(_bigNum$1, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
},
    _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
  var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
      pt,
      rootPT,
      lookup,
      i;

  if (!ptCache) {
    ptCache = tween._ptCache[property] = [];
    lookup = tween._ptLookup;
    i = tween._targets.length;

    while (i--) {
      pt = lookup[i][property];

      if (pt && pt.d && pt.d._pt) {
        // it's a plugin, so find the nested PropTween
        pt = pt.d._pt;

        while (pt && pt.p !== property && pt.fp !== property) {
          // "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
          pt = pt._next;
        }
      }

      if (!pt) {
        // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
        // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
        _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.

        tween.vars[property] = "+=0";

        _initTween(tween, time);

        _forceAllPropTweens = 0;
        return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
      }

      ptCache.push(pt);
    }
  }

  i = ptCache.length;

  while (i--) {
    rootPT = ptCache[i];
    pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.

    pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
    pt.c = value - pt.s;
    rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)

    rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
  }
},
    _addAliasesToVars = function _addAliasesToVars(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0,
      propertyAliases = harness && harness.aliases,
      copy,
      p,
      i,
      aliases;

  if (!propertyAliases) {
    return vars;
  }

  copy = _merge({}, vars);

  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i = aliases.length;

      while (i--) {
        copy[aliases[i]] = copy[p];
      }
    }
  }

  return copy;
},
    // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
  var ease = obj.ease || easeEach || "power1.inOut",
      p,
      a;

  if (_isArray(obj)) {
    a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease

    obj.forEach(function (value, i) {
      return a.push({
        t: i / (obj.length - 1) * 100,
        v: value,
        e: ease
      });
    });
  } else {
    for (p in obj) {
      a = allProps[p] || (allProps[p] = []);
      p === "ease" || a.push({
        t: parseFloat(prop),
        v: obj[p],
        e: ease
      });
    }
  }
},
    _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
  return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
},
    _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
    _staggerPropsToSkip = {};

_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
  return _staggerPropsToSkip[name] = 1;
});
/*
 * --------------------------------------------------------------------------------------
 * TWEEN
 * --------------------------------------------------------------------------------------
 */


var Tween = /*#__PURE__*/function (_Animation2) {
  _inheritsLoose(Tween, _Animation2);

  function Tween(targets, vars, position, skipInherit) {
    var _this3;

    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }

    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars,
        duration = _this3$vars.duration,
        delay = _this3$vars.delay,
        immediateRender = _this3$vars.immediateRender,
        stagger = _this3$vars.stagger,
        overwrite = _this3$vars.overwrite,
        keyframes = _this3$vars.keyframes,
        defaults = _this3$vars.defaults,
        scrollTrigger = _this3$vars.scrollTrigger,
        yoyoEase = _this3$vars.yoyoEase,
        parent = vars.parent || _globalTimeline,
        parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
        tl,
        i,
        copy,
        l,
        p,
        curTarget,
        staggerFunc,
        staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property

    _this3._overwrite = overwrite;

    if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults || {},
        targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
      }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.

      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;

      if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        l = parsedTargets.length;
        staggerFunc = stagger && distribute(stagger);

        if (_isObject(stagger)) {
          //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }

        for (i = 0; i < l; i++) {
          copy = _copyExcluding(vars, _staggerPropsToSkip);
          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.

          copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

          if (!stagger && l === 1 && copy.delay) {
            // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }

          tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
          tl._ease = _easeMap.none;
        }

        tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
      } else if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));

        tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
        var time = 0,
            a,
            kf,
            v;

        if (_isArray(keyframes)) {
          keyframes.forEach(function (frame) {
            return tl.to(parsedTargets, frame, ">");
          });
          tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
        } else {
          copy = {};

          for (p in keyframes) {
            p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
          }

          for (p in copy) {
            a = copy[p].sort(function (a, b) {
              return a.t - b.t;
            });
            time = 0;

            for (i = 0; i < a.length; i++) {
              kf = a[i];
              v = {
                ease: kf.e,
                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
              };
              v[p] = kf.v;
              tl.to(parsedTargets, v, time);
              time += v.duration;
            }
          }

          tl.duration() < duration && tl.to({}, {
            duration: duration - tl.duration()
          }); // in case keyframes didn't go to 100%
        }
      }

      duration || _this3.duration(duration = tl.duration());
    } else {
      _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
    }

    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);

      _globalTimeline.killTweensOf(parsedTargets);

      _overwritingTween = 0;
    }

    _addToTimeline(parent, _assertThisInitialized(_this3), position);

    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);

    if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)

      _this3.render(Math.max(0, -delay) || 0); //in case delay is negative

    }

    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }

  var _proto3 = Tween.prototype;

  _proto3.render = function render(totalTime, suppressEvents, force) {
    var prevTime = this._time,
        tDur = this._tDur,
        dur = this._dur,
        isNegative = totalTime < 0,
        tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
        time,
        pt,
        iteration,
        cycleDuration,
        prevIteration,
        isYoyo,
        ratio,
        timeline,
        yoyoEase;

    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
      //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
      time = tTime;
      timeline = this.timeline;

      if (this._repeat) {
        //adjust the time for repeats and yoyos
        cycleDuration = dur + this._rDelay;

        if (this._repeat < -1 && isNegative) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }

        time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)

        if (tTime === tDur) {
          // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);

          if (iteration && iteration === _roundPrecise(tTime / cycleDuration)) {
            time = dur;
            iteration--;
          }

          time > dur && (time = dur);
        }

        isYoyo = this._yoyo && iteration & 1;

        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }

        prevIteration = _animationCycle(this._tTime, cycleDuration);

        if (time === prevTime && !force && this._initted && iteration === prevIteration) {
          //could be during the repeatDelay part. No need to render and fire callbacks.
          this._tTime = tTime;
          return this;
        }

        if (iteration !== prevIteration) {
          timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality

          if (this.vars.repeatRefresh && !isYoyo && !this._lock && this._time !== cycleDuration && this._initted) {
            // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
            this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.

            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }

      if (!this._initted) {
        if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
          this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.

          return this;
        }

        if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
          // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
          return this;
        }

        if (dur !== this._dur) {
          // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
          return this.render(totalTime, suppressEvents, force);
        }
      }

      this._tTime = tTime;
      this._time = time;

      if (!this._act && this._ts) {
        this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.

        this._lazy = 0;
      }

      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }

      if (time && !prevTime && !suppressEvents && !iteration) {
        _callback(this, "onStart");

        if (this._tTime !== tTime) {
          // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
          return this;
        }
      }

      pt = this._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);

      if (this._onUpdate && !suppressEvents) {
        isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.

        _callback(this, "onUpdate");
      }

      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.

        if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
          // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }

    return this;
  };

  _proto3.targets = function targets() {
    return this._targets;
  };

  _proto3.invalidate = function invalidate(soft) {
    // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
    (!soft || !this.vars.runBackwards) && (this._startAt = 0);
    this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate(soft);
    return _Animation2.prototype.invalidate.call(this, soft);
  };

  _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
    _tickerActive || _ticker.wake();
    this._ts || this.play();
    var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
        ratio;
    this._initted || _initTween(this, time);
    ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
    // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
    // if (_isObject(property)) { // performance optimization
    // 	for (p in property) {
    // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
    // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    // 		}
    // 	}
    // } else {

    if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
      return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
    } //}


    _alignPlayhead(this, 0);

    this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
    return this.render(0);
  };

  _proto3.kill = function kill(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }

    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }

    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.

      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.

      return this;
    }

    var parsedTargets = this._targets,
        killingTargets = targets ? toArray(targets) : parsedTargets,
        propTweenLookup = this._ptLookup,
        firstPT = this._pt,
        overwrittenProps,
        curLookup,
        curOverwriteProps,
        props,
        p,
        pt,
        i;

    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }

    overwrittenProps = this._op = this._op || [];

    if (vars !== "all") {
      //so people can pass in a comma-delimited list of property names
      if (_isString(vars)) {
        p = {};

        _forEachName(vars, function (name) {
          return p[name] = 1;
        });

        vars = p;
      }

      vars = _addAliasesToVars(parsedTargets, vars);
    }

    i = parsedTargets.length;

    while (i--) {
      if (~killingTargets.indexOf(parsedTargets[i])) {
        curLookup = propTweenLookup[i];

        if (vars === "all") {
          overwrittenProps[i] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
          props = vars;
        }

        for (p in props) {
          pt = curLookup && curLookup[p];

          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }

            delete curLookup[p];
          }

          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }

    this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.

    return this;
  };

  Tween.to = function to(targets, vars) {
    return new Tween(targets, vars, arguments[2]);
  };

  Tween.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };

  Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay: delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
  };

  Tween.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };

  Tween.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween(targets, vars);
  };

  Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };

  return Tween;
}(Animation);

_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.


_forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
  Tween[name] = function () {
    var tl = new Timeline(),
        params = _slice.call(arguments, 0);

    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */


var _setterPlain = function _setterPlain(target, property, value) {
  return target[property] = value;
},
    _setterFunc = function _setterFunc(target, property, value) {
  return target[property](value);
},
    _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
  return target[property](data.fp, value);
},
    _setterAttribute = function _setterAttribute(target, property, value) {
  return target.setAttribute(property, value);
},
    _getSetter = function _getSetter(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
},
    _renderPlain = function _renderPlain(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
},
    _renderBoolean = function _renderBoolean(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
},
    _renderComplexString = function _renderComplexString(ratio, data) {
  var pt = data._pt,
      s = "";

  if (!ratio && data.b) {
    //b = beginning string
    s = data.b;
  } else if (ratio === 1 && data.e) {
    //e = ending string
    s = data.e;
  } else {
    while (pt) {
      s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.

      pt = pt._next;
    }

    s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
  }

  data.set(data.t, data.p, s, data);
},
    _renderPropTweens = function _renderPropTweens(ratio, data) {
  var pt = data._pt;

  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
},
    _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
  var pt = this._pt,
      next;

  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
},
    _killPropTweensOf = function _killPropTweensOf(property) {
  var pt = this._pt,
      hasNonDependentRemaining,
      next;

  while (pt) {
    next = pt._next;

    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }

    pt = next;
  }

  return !hasNonDependentRemaining;
},
    _setterWithModifier = function _setterWithModifier(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
},
    _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
  var pt = parent._pt,
      next,
      pt2,
      first,
      last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)

  while (pt) {
    next = pt._next;
    pt2 = first;

    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }

    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }

    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }

    pt = next;
  }

  parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)


var PropTween = /*#__PURE__*/function () {
  function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;

    if (next) {
      next._prev = this;
    }
  }

  var _proto4 = PropTween.prototype;

  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)

    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target; //modifier target

    this.tween = tween;
  };

  return PropTween;
}(); //Initialization tasks

_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
  return _reservedProps[name] = 1;
});

_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;

var _media = [],
    _listeners = {},
    _emptyArray = [],
    _lastMediaTime = 0,
    _contextID = 0,
    _dispatch = function _dispatch(type) {
  return (_listeners[type] || _emptyArray).map(function (f) {
    return f();
  });
},
    _onMediaChange = function _onMediaChange() {
  var time = Date.now(),
      matches = [];

  if (time - _lastMediaTime > 2) {
    _dispatch("matchMediaInit");

    _media.forEach(function (c) {
      var queries = c.queries,
          conditions = c.conditions,
          match,
          p,
          anyMatch,
          toggled;

      for (p in queries) {
        match = _win$1.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.

        match && (anyMatch = 1);

        if (match !== conditions[p]) {
          conditions[p] = match;
          toggled = 1;
        }
      }

      if (toggled) {
        c.revert();
        anyMatch && matches.push(c);
      }
    });

    _dispatch("matchMediaRevert");

    matches.forEach(function (c) {
      return c.onMatch(c, function (func) {
        return c.add(null, func);
      });
    });
    _lastMediaTime = time;

    _dispatch("matchMedia");
  }
};

var Context = /*#__PURE__*/function () {
  function Context(func, scope) {
    this.selector = scope && selector(scope);
    this.data = [];
    this._r = []; // returned/cleanup functions

    this.isReverted = false;
    this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely

    func && this.add(func);
  }

  var _proto5 = Context.prototype;

  _proto5.add = function add(name, func, scope) {
    // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
    // if (name && _isFunction(name.revert)) {
    // 	this.data.push(name);
    // 	return (name._ctx = this);
    // }
    if (_isFunction(name)) {
      scope = func;
      func = name;
      name = _isFunction;
    }

    var self = this,
        f = function f() {
      var prev = _context,
          prevSelector = self.selector,
          result;
      prev && prev !== self && prev.data.push(self);
      scope && (self.selector = selector(scope));
      _context = self;
      result = func.apply(self, arguments);
      _isFunction(result) && self._r.push(result);
      _context = prev;
      self.selector = prevSelector;
      self.isReverted = false;
      return result;
    };

    self.last = f;
    return name === _isFunction ? f(self, function (func) {
      return self.add(null, func);
    }) : name ? self[name] = f : f;
  };

  _proto5.ignore = function ignore(func) {
    var prev = _context;
    _context = null;
    func(this);
    _context = prev;
  };

  _proto5.getTweens = function getTweens() {
    var a = [];
    this.data.forEach(function (e) {
      return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
    });
    return a;
  };

  _proto5.clear = function clear() {
    this._r.length = this.data.length = 0;
  };

  _proto5.kill = function kill(revert, matchMedia) {
    var _this4 = this;

    if (revert) {
      (function () {
        var tweens = _this4.getTweens(),
            i = _this4.data.length,
            t;

        while (i--) {
          // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
          t = _this4.data[i];

          if (t.data === "isFlip") {
            t.revert();
            t.getChildren(true, true, false).forEach(function (tween) {
              return tweens.splice(tweens.indexOf(tween), 1);
            });
          }
        } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort


        tweens.map(function (t) {
          return {
            g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
            t: t
          };
        }).sort(function (a, b) {
          return b.g - a.g || -Infinity;
        }).forEach(function (o) {
          return o.t.revert(revert);
        }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.

        i = _this4.data.length;

        while (i--) {
          // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
          t = _this4.data[i];

          if (t instanceof Timeline) {
            if (t.data !== "nested") {
              t.scrollTrigger && t.scrollTrigger.revert();
              t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
            }
          } else {
            !(t instanceof Tween) && t.revert && t.revert(revert);
          }
        }

        _this4._r.forEach(function (f) {
          return f(revert, _this4);
        });

        _this4.isReverted = true;
      })();
    } else {
      this.data.forEach(function (e) {
        return e.kill && e.kill();
      });
    }

    this.clear();

    if (matchMedia) {
      var i = _media.length;

      while (i--) {
        // previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
        _media[i].id === this.id && _media.splice(i, 1);
      }
    }
  };

  _proto5.revert = function revert(config) {
    this.kill(config || {});
  };

  return Context;
}();

var MatchMedia = /*#__PURE__*/function () {
  function MatchMedia(scope) {
    this.contexts = [];
    this.scope = scope;
    _context && _context.data.push(this);
  }

  var _proto6 = MatchMedia.prototype;

  _proto6.add = function add(conditions, func, scope) {
    _isObject(conditions) || (conditions = {
      matches: conditions
    });
    var context = new Context(0, scope || this.scope),
        cond = context.conditions = {},
        mq,
        p,
        active;
    _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()

    this.contexts.push(context);
    func = context.add("onMatch", func);
    context.queries = conditions;

    for (p in conditions) {
      if (p === "all") {
        active = 1;
      } else {
        mq = _win$1.matchMedia(conditions[p]);

        if (mq) {
          _media.indexOf(context) < 0 && _media.push(context);
          (cond[p] = mq.matches) && (active = 1);
          mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
        }
      }
    }

    active && func(context, function (f) {
      return context.add(null, f);
    });
    return this;
  } // refresh() {
  // 	let time = _lastMediaTime,
  // 		media = _media;
  // 	_lastMediaTime = -1;
  // 	_media = this.contexts;
  // 	_onMediaChange();
  // 	_lastMediaTime = time;
  // 	_media = media;
  // }
  ;

  _proto6.revert = function revert(config) {
    this.kill(config || {});
  };

  _proto6.kill = function kill(revert) {
    this.contexts.forEach(function (c) {
      return c.kill(revert, true);
    });
  };

  return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */


var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    args.forEach(function (config) {
      return _createPlugin(config);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in

    var getter = _getCache(target || {}).get,
        format = unit ? _passThrough : _numericIfPossible;

    unit === "native" && (unit = "");
    return !target ? target : !property ? function (property, unit, uncache) {
      return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);

    if (target.length > 1) {
      var setters = target.map(function (t) {
        return gsap.quickSetter(t, property, unit);
      }),
          l = setters.length;
      return function (value) {
        var i = l;

        while (i--) {
          setters[i](value);
        }
      };
    }

    target = target[0] || {};

    var Plugin = _plugins[property],
        cache = _getCache(target),
        p = cache.harness && (cache.harness.aliases || {})[property] || property,
        // in case it's an alias, like "rotate" for "rotation".
    setter = Plugin ? function (value) {
      var p = new Plugin();
      _quickTween._pt = 0;
      p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p.render(1, p);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);

    return Plugin ? setter : function (value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  quickTo: function quickTo(target, property, vars) {
    var _merge2;

    var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})),
        func = function func(value, start, startIsRelative) {
      return tween.resetTo(property, value, start, startIsRelative);
    };

    func.tween = tween;
    return func;
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name,
        effect = _ref3.effect,
        plugins = _ref3.plugins,
        defaults = _ref3.defaults,
        extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function (pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });

    _effects[name] = function (targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
    };

    if (extendTimeline) {
      Timeline.prototype[name] = function (targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }

    var tl = new Timeline(vars),
        child,
        next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

    _globalTimeline.remove(tl);

    tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).

    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;

    while (child) {
      next = child._next;

      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }

      child = next;
    }

    _addToTimeline(_globalTimeline, tl, 0);

    return tl;
  },
  context: function context(func, scope) {
    return func ? new Context(func, scope) : _context;
  },
  matchMedia: function matchMedia(scope) {
    return new MatchMedia(scope);
  },
  matchMediaRefresh: function matchMediaRefresh() {
    return _media.forEach(function (c) {
      var cond = c.conditions,
          found,
          p;

      for (p in cond) {
        if (cond[p]) {
          cond[p] = false;
          found = 1;
        }
      }

      found && c.revert();
    }) || _onMediaChange();
  },
  addEventListener: function addEventListener(type, callback) {
    var a = _listeners[type] || (_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
  },
  removeEventListener: function removeEventListener(type, callback) {
    var a = _listeners[type],
        i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
  },
  utils: {
    wrap: wrap,
    wrapYoyo: wrapYoyo,
    distribute: distribute,
    random: random,
    snap: snap,
    normalize: normalize,
    getUnit: getUnit,
    clamp: clamp,
    splitColor: splitColor,
    toArray: toArray,
    selector: selector,
    mapRange: mapRange,
    pipe: pipe,
    unitize: unitize,
    interpolate: interpolate,
    shuffle: shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween: PropTween,
    globals: _addGlobal,
    Tween: Tween,
    Timeline: Timeline,
    Animation: Animation,
    getCache: _getCache,
    _removeLinkedListItem: _removeLinkedListItem,
    reverting: function reverting() {
      return _reverting$1;
    },
    context: function context(toAdd) {
      if (toAdd && _context) {
        _context.data.push(toAdd);

        toAdd._ctx = _context;
      }

      return _context;
    },
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};

_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
  return _gsap[name] = Tween[name];
});

_ticker.add(Timeline.updateRoot);

_quickTween = _gsap.to({}, {
  duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------

var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
  var pt = plugin._pt;

  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }

  return pt;
},
    _addModifiers = function _addModifiers(tween, modifiers) {
  var targets = tween._targets,
      p,
      i,
      pt;

  for (p in modifiers) {
    i = targets.length;

    while (i--) {
      pt = tween._ptLookup[i][p];

      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          // is a plugin
          pt = _getPluginPropTween(pt, p);
        }

        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
      }
    }
  }
},
    _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
  return {
    name: name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init(target, vars, tween) {
      tween._onInit = function (tween) {
        var temp, p;

        if (_isString(vars)) {
          temp = {};

          _forEachName(vars, function (name) {
            return temp[name] = 1;
          }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.


          vars = temp;
        }

        if (modifier) {
          temp = {};

          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }

          vars = temp;
        }

        _addModifiers(tween, vars);
      };
    }
  };
}; //register core plugins


var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt, v;
    this.tween = tween;

    for (p in vars) {
      v = target.getAttribute(p) || "";
      pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
      pt.op = p;
      pt.b = v; // record the beginning value so we can revert()

      this._props.push(p);
    }
  },
  render: function render(ratio, data) {
    var pt = data._pt;

    while (pt) {
      _reverting$1 ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)

      pt = pt._next;
    }
  }
}, {
  name: "endArray",
  init: function init(target, value) {
    var i = value.length;

    while (i--) {
      this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.

Tween.version = Timeline.version = gsap.version = "3.12.5";
_coreReady = 1;
_windowExists$1() && _wake();

/*!
 * CSSPlugin 3.12.5
 * https://gsap.com
 *
 * Copyright 2008-2024, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for
 * Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/

var _win,
    _doc,
    _docElement,
    _pluginInitted,
    _tempDiv,
    _recentSetterPlugin,
    _reverting,
    _windowExists = function _windowExists() {
  return typeof window !== "undefined";
},
    _transformProps = {},
    _RAD2DEG = 180 / Math.PI,
    _DEG2RAD = Math.PI / 180,
    _atan2 = Math.atan2,
    _bigNum = 1e8,
    _capsExp = /([A-Z])/g,
    _horizontalExp = /(left|right|width|margin|padding|x)/i,
    _complexExp = /[\s,\(]\S/,
    _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
},
    _renderCSSProp = function _renderCSSProp(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
},
    _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
},
    //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
},
    _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
},
    _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
},
    _setterCSSStyle = function _setterCSSStyle(target, property, value) {
  return target.style[property] = value;
},
    _setterCSSProp = function _setterCSSProp(target, property, value) {
  return target.style.setProperty(property, value);
},
    _setterTransform = function _setterTransform(target, property, value) {
  return target._gsap[property] = value;
},
    _setterScale = function _setterScale(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
},
    _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
},
    _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
},
    _transformProp = "transform",
    _transformOriginProp = _transformProp + "Origin",
    _saveStyle = function _saveStyle(property, isNotCSS) {
  var _this = this;

  var target = this.target,
      style = target.style,
      cache = target._gsap;

  if (property in _transformProps && style) {
    this.tfm = this.tfm || {};

    if (property !== "transform") {
      property = _propertyAliases[property] || property;
      ~property.indexOf(",") ? property.split(",").forEach(function (a) {
        return _this.tfm[a] = _get(target, a);
      }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.

      property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
    } else {
      return _propertyAliases.transform.split(",").forEach(function (p) {
        return _saveStyle.call(_this, p, isNotCSS);
      });
    }

    if (this.props.indexOf(_transformProp) >= 0) {
      return;
    }

    if (cache.svg) {
      this.svgo = target.getAttribute("data-svg-origin");
      this.props.push(_transformOriginProp, isNotCSS, "");
    }

    property = _transformProp;
  }

  (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
},
    _removeIndependentTransforms = function _removeIndependentTransforms(style) {
  if (style.translate) {
    style.removeProperty("translate");
    style.removeProperty("scale");
    style.removeProperty("rotate");
  }
},
    _revertStyle = function _revertStyle() {
  var props = this.props,
      target = this.target,
      style = target.style,
      cache = target._gsap,
      i,
      p;

  for (i = 0; i < props.length; i += 3) {
    // stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
  }

  if (this.tfm) {
    for (p in this.tfm) {
      cache[p] = this.tfm[p];
    }

    if (cache.svg) {
      cache.renderTransform();
      target.setAttribute("data-svg-origin", this.svgo || "");
    }

    i = _reverting();

    if ((!i || !i.isStart) && !style[_transformProp]) {
      _removeIndependentTransforms(style);

      if (cache.zOrigin && style[_transformOriginProp]) {
        style[_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.

        cache.zOrigin = 0;
        cache.renderTransform();
      }

      cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
    }
  }
},
    _getStyleSaver = function _getStyleSaver(target, properties) {
  var saver = {
    target: target,
    props: [],
    revert: _revertStyle,
    save: _saveStyle
  };
  target._gsap || gsap.core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.

  properties && properties.split(",").forEach(function (p) {
    return saver.save(p);
  });
  return saver;
},
    _supports3D,
    _createElement = function _createElement(type, ns) {
  var e = _doc.createElementNS ? _doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.

  return e && e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
},
    _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
},
    _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
    _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
  var e = element || _tempDiv,
      s = e.style,
      i = 5;

  if (property in s && !preferPrefix) {
    return property;
  }

  property = property.charAt(0).toUpperCase() + property.substr(1);

  while (i-- && !(_prefixes[i] + property in s)) {}

  return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
},
    _initCore = function _initCore() {
  if (_windowExists() && window.document) {
    _win = window;
    _doc = _win.document;
    _docElement = _doc.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.

    _supports3D = !!_checkPropPrefix("perspective");
    _reverting = gsap.core.reverting;
    _pluginInitted = 1;
  }
},
    _getBBoxHack = function _getBBoxHack(swapIfPossible) {
  //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
      oldParent = this.parentNode,
      oldSibling = this.nextSibling,
      oldCSS = this.style.cssText,
      bbox;

  _docElement.appendChild(svg);

  svg.appendChild(this);
  this.style.display = "block";

  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox; //store the original

      this.getBBox = _getBBoxHack;
    } catch (e) {}
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }

  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }

  _docElement.removeChild(svg);

  this.style.cssText = oldCSS;
  return bbox;
},
    _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
  var i = attributesArray.length;

  while (i--) {
    if (target.hasAttribute(attributesArray[i])) {
      return target.getAttribute(attributesArray[i]);
    }
  }
},
    _getBBox = function _getBBox(target) {
  var bounds;

  try {
    bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }

  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.

  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
},
    _isSVG = function _isSVG(e) {
  return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
},
    //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
  if (property) {
    var style = target.style,
        first2Chars;

    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }

    if (style.removeProperty) {
      first2Chars = property.substr(0, 2);

      if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
        //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
        property = "-" + property;
      }

      style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
      style.removeAttribute(property);
    }
  }
},
    _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;

  plugin._props.push(property);

  return pt;
},
    _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
},
    _nonStandardLayouts = {
  grid: 1,
  flex: 1
},
    //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
  var curValue = parseFloat(value) || 0,
      curUnit = (value + "").trim().substr((curValue + "").length) || "px",
      // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
  style = _tempDiv.style,
      horizontal = _horizontalExp.test(property),
      isRootSVG = target.tagName.toLowerCase() === "svg",
      measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
      amount = 100,
      toPixels = unit === "px",
      toPercent = unit === "%",
      px,
      parent,
      cache,
      isSVG;

  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }

  curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);

  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }

  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }

  if (!parent || parent === _doc || !parent.appendChild) {
    parent = _doc.body;
  }

  cache = parent._gsap;

  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
    return _round(curValue / cache.width * amount);
  } else {
    if (toPercent && (property === "height" || property === "width")) {
      // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
      var v = target.style[property];
      target.style[property] = amount + unit;
      px = target[measureProperty];
      v ? target.style[property] = v : _removeProperty(target, property);
    } else {
      (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
      parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.

      parent.appendChild(_tempDiv);
      px = _tempDiv[measureProperty];
      parent.removeChild(_tempDiv);
      style.position = "absolute";
    }

    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }

  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
},
    _get = function _get(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();

  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];

    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }

  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];

    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
  }

  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
},
    _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
  // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
  if (!start || start === "none") {
    // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
    var p = _checkPropPrefix(prop, target, 1),
        s = p && _getComputedProperty(target, p, 1);

    if (s && s !== start) {
      prop = p;
      start = s;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
  }

  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
      index = 0,
      matchIndex = 0,
      a,
      result,
      startValues,
      startNum,
      color,
      startValue,
      endValue,
      endNum,
      chunk,
      endUnit,
      startUnit,
      endValues;
  pt.b = start;
  pt.e = end;
  start += ""; // ensure values are strings

  end += "";

  if (end === "auto") {
    startValue = target.style[prop];
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
  }

  a = [start, end];

  _colorStringFilter(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().


  start = a[0];
  end = a[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];

  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }

      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;

        if (!endUnit) {
          //if something like "perspective:300" is passed in and we must add a unit to the end
          endUnit = endUnit || _config.units[prop] || startUnit;

          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }

        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        } // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.


        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }

  _relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).

  this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.

  return pt;
},
    _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
},
    _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
  var split = value.split(" "),
      x = split[0],
      y = split[1] || "50%";

  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    //the user provided them in the wrong order, so flip them
    value = x;
    x = y;
    y = value;
  }

  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
},
    _renderClearProps = function _renderClearProps(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t,
        style = target.style,
        props = data.u,
        cache = target._gsap,
        prop,
        clearTransforms,
        i;

    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i = props.length;

      while (--i > -1) {
        prop = props[i];

        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }

        _removeProperty(target, prop);
      }
    }

    if (clearTransforms) {
      _removeProperty(target, _transformProp);

      if (cache) {
        cache.svg && target.removeAttribute("transform");

        _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.


        cache.uncache = 1;

        _removeIndependentTransforms(style);
      }
    }
  }
},
    // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;

      plugin._props.push(property);

      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */

},

/*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */
_identity2DMatrix = [1, 0, 0, 1, 0, 0],
    _rotationalProperties = {},
    _isNullTransform = function _isNullTransform(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
},
    _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
  var matrixString = _getComputedProperty(target, _transformProp);

  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
},
    _getMatrix = function _getMatrix(target, force2D) {
  var cache = target._gsap || _getCache(target),
      style = target.style,
      matrix = _getComputedTransformMatrixAsArray(target),
      parent,
      nextSibling,
      temp,
      addedToDOM;

  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.

    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;

    if (!parent || !target.offsetParent) {
      // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
      addedToDOM = 1; //flag

      nextSibling = target.nextElementSibling;

      _docElement.appendChild(target); //we must add it to the DOM in order to get values properly

    }

    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");

    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }

  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
},
    _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap,
      matrix = matrixArray || _getMatrix(target, true),
      xOriginOld = cache.xOrigin || 0,
      yOriginOld = cache.yOrigin || 0,
      xOffsetOld = cache.xOffset || 0,
      yOffsetOld = cache.yOffset || 0,
      a = matrix[0],
      b = matrix[1],
      c = matrix[2],
      d = matrix[3],
      tx = matrix[4],
      ty = matrix[5],
      originSplit = origin.split(" "),
      xOrigin = parseFloat(originSplit[0]) || 0,
      yOrigin = parseFloat(originSplit[1]) || 0,
      bounds,
      determinant,
      x,
      y;

  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
  } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
    //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
    x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
  }

  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }

  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).

  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }

  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
},
    _parseTransform = function _parseTransform(target, uncache) {
  var cache = target._gsap || new GSCache(target);

  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }

  var style = target.style,
      invertedScaleX = cache.scaleX < 0,
      px = "px",
      deg = "deg",
      cs = getComputedStyle(target),
      origin = _getComputedProperty(target, _transformOriginProp) || "0",
      x,
      y,
      z,
      scaleX,
      scaleY,
      rotation,
      rotationX,
      rotationY,
      skewX,
      skewY,
      perspective,
      xOrigin,
      yOrigin,
      matrix,
      angle,
      cos,
      sin,
      a,
      b,
      c,
      d,
      a12,
      a22,
      t1,
      t2,
      t3,
      a13,
      a23,
      a33,
      a42,
      a43,
      a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));

  if (cs.translate) {
    // accommodate independent transforms by combining them into normal ones.
    if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
      style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
    }

    style.scale = style.rotate = style.translate = "none";
  }

  matrix = _getMatrix(target, cache.svg);

  if (cache.svg) {
    if (cache.uncache) {
      // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
      t2 = target.getBBox();
      origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
      t1 = "";
    } else {
      t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
    }

    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }

  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;

  if (matrix !== _identity2DMatrix) {
    a = matrix[0]; //a11

    b = matrix[1]; //a21

    c = matrix[2]; //a31

    d = matrix[3]; //a41

    x = a12 = matrix[4];
    y = a22 = matrix[5]; //2D matrix

    if (matrix.length === 6) {
      scaleX = Math.sqrt(a * a + b * b);
      scaleY = Math.sqrt(d * d + c * c);
      rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).

      skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

      if (cache.svg) {
        x -= xOrigin - (xOrigin * a + yOrigin * c);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      } //3D matrix

    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG; //rotationX

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      } //rotationY


      angle = _atan2(-c, a33);
      rotationY = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a = t1;
        b = t2;
        c = t3;
      } //rotationZ


      angle = _atan2(b, a);
      rotation = angle * _RAD2DEG;

      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a * sin;
        a22 = a22 * cos - a12 * sin;
        a = t1;
        a12 = t2;
      }

      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }

      scaleX = _round(Math.sqrt(a * a + b * b + c * c));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }

    if (cache.svg) {
      //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }

  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }

  uncache = uncache || cache.uncache;
  cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;

  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }

  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
},
    _firstTwoOnly = function _firstTwoOnly(value) {
  return (value = value.split(" "))[0] + " " + value[1];
},
    //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
},
    _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;

  _renderCSSTransforms(ratio, cache);
},
    _zeroDeg = "0deg",
    _zeroPx = "0px",
    _endParenthesis = ") ",
    _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
  var _ref = cache || this,
      xPercent = _ref.xPercent,
      yPercent = _ref.yPercent,
      x = _ref.x,
      y = _ref.y,
      z = _ref.z,
      rotation = _ref.rotation,
      rotationY = _ref.rotationY,
      rotationX = _ref.rotationX,
      skewX = _ref.skewX,
      skewY = _ref.skewY,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      transformPerspective = _ref.transformPerspective,
      force3D = _ref.force3D,
      target = _ref.target,
      zOrigin = _ref.zOrigin,
      transforms = "",
      use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)


  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD,
        a13 = Math.sin(angle),
        a33 = Math.cos(angle),
        cos;

    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }

  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }

  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }

  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }

  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }

  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }

  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }

  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }

  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }

  target.style[_transformProp] = transforms || "translate(0, 0)";
},
    _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
  var _ref2 = cache || this,
      xPercent = _ref2.xPercent,
      yPercent = _ref2.yPercent,
      x = _ref2.x,
      y = _ref2.y,
      rotation = _ref2.rotation,
      skewX = _ref2.skewX,
      skewY = _ref2.skewY,
      scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY,
      target = _ref2.target,
      xOrigin = _ref2.xOrigin,
      yOrigin = _ref2.yOrigin,
      xOffset = _ref2.xOffset,
      yOffset = _ref2.yOffset,
      forceCSS = _ref2.forceCSS,
      tx = parseFloat(x),
      ty = parseFloat(y),
      a11,
      a21,
      a12,
      a22,
      temp;

  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);

  if (skewY) {
    //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }

  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;

    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;

      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }

    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }

  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }

  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }

  if (xPercent || yPercent) {
    //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }

  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
},
    _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
  var cap = 360,
      isString = _isString(endValue),
      endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
      change = endNum - startNum,
      finalValue = startNum + change + "deg",
      direction,
      pt;

  if (isString) {
    direction = endValue.split("_")[1];

    if (direction === "short") {
      change %= cap;

      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }

    if (direction === "cw" && change < 0) {
      change = (change + cap * _bigNum) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * _bigNum) % cap - ~~(change / cap) * cap;
    }
  }

  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";

  plugin._props.push(property);

  return pt;
},
    _assign = function _assign(target, source) {
  // Internet Explorer doesn't have Object.assign(), so we recreate it here.
  for (var p in source) {
    target[p] = source[p];
  }

  return target;
},
    _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
  //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
  var startCache = _assign({}, target._gsap),
      exclude = "perspective,force3D,transformOrigin,svgOrigin",
      style = target.style,
      endCache,
      p,
      startValue,
      endValue,
      startNum,
      endNum,
      startUnit,
      endUnit;

  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);

    _removeProperty(target, _transformProp);

    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }

  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];

    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;

      plugin._props.push(p);
    }
  }

  _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.


_forEachName("padding,margin,Width,Radius", function (name, index) {
  var t = "Top",
      r = "Right",
      b = "Bottom",
      l = "Left",
      props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
    return index < 2 ? name + side : "border" + side + name;
  });

  _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
    var a, vars;

    if (arguments.length < 4) {
      // getter, passed target, property, and unit (from _get())
      a = props.map(function (prop) {
        return _get(plugin, prop, property);
      });
      vars = a.join(" ");
      return vars.split(a[0]).length === 5 ? a[0] : vars;
    }

    a = (endValue + "").split(" ");
    vars = {};
    props.forEach(function (prop, i) {
      return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});

var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init(target, vars, tween, index, targets) {
    var props = this._props,
        style = target.style,
        startAt = tween.vars.startAt,
        startValue,
        endValue,
        endNum,
        startNum,
        type,
        specialProp,
        p,
        startUnit,
        endUnit,
        relative,
        isTransformRelated,
        transformPropTween,
        cache,
        smooth,
        hasPriority,
        inlineProps;
    _pluginInitted || _initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps

    this.styles = this.styles || _getStyleSaver(target);
    inlineProps = this.styles.props;
    this.tween = tween;

    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }

      endValue = vars[p];

      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        // plugins
        continue;
      }

      type = typeof endValue;
      specialProp = _specialProps[p];

      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }

      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }

      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        //CSS variable
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;

        if (!_colorExp.test(startValue)) {
          // colors don't have units
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }

        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
        inlineProps.push(p, 0, style[p]);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          getUnit(startValue + "") || startValue === "auto" || (startValue += _config.units[p] || getUnit(_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.

          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
        } else {
          startValue = _get(target, p);
        }

        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);

        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
              startNum = 0;
            }

            inlineProps.push("visibility", 0, style.visibility);

            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }

          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }

        isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---

        if (isTransformRelated) {
          this.styles.save(p);

          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.

            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)

            transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
          }

          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
            this._pt.u = 0;
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
            endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.

            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!

              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }

            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);

            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);

            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);

            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }

        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0); // protect against NaN

          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;

          if (startUnit !== endUnit && endUnit !== "%") {
            //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
            this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
          } else if (p !== "parseTransform") {
            _missingPlugin(p, endValue);

            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
        }

        isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
        props.push(p);
      }
    }

    hasPriority && _sortPropTweensByPriority(this);
  },
  render: function render(ratio, data) {
    if (data.tween._time || !_reverting()) {
      var pt = data._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
    } else {
      data.styles.revert();
    }
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty: _removeProperty,
    _getMatrix: _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;
gsap.core.getStyleSaver = _getStyleSaver;

(function (positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
    _transformProps[name] = 1;
  });

  _forEachName(rotation, function (name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });

  _propertyAliases[all[13]] = positionAndScale + "," + rotation;

  _forEachName(aliases, function (name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
  _config.units[name] = "px";
});

gsap.registerPlugin(CSSPlugin);

var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap;

const cpslAuthModalCss = ":host{--container-width:560px;--container-gap:8px;--card-box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.08);display:block;z-index:10011;position:relative}:host cpsl-overlay{z-index:10011}@media (max-width: 480px){:host(.include-mobile-styling) .modal-wrapper{scale:none;top:100%;left:0;height:unset;opacity:1}:host(.include-mobile-styling) .modal-container{width:100%;max-width:none;border-bottom-left-radius:0px;border-bottom-right-radius:0px}:host(.include-mobile-styling) .modal-body-card{--card-border-radius-bl:0px;--card-border-radius-br:0px}}:host(.force-mobile-media) .modal-wrapper{scale:none;top:100%;left:0;height:unset;opacity:1}:host(.force-mobile-media) .modal-container{width:100%;max-width:none;border-bottom-left-radius:0px;border-bottom-right-radius:0px}:host(.force-mobile-media) .modal-body-card{--card-border-radius-bl:0px;--card-border-radius-br:0px}:host(.no-overlay){z-index:0}:host(.no-overlay) .modal-body-card{--card-border-width:1px}:host(.no-overlay) .modal-container{max-height:unset}.modal-wrapper{z-index:10011;position:fixed;top:0;left:0;display:none;height:100%;width:100%;justify-content:center;align-items:center;scale:0.8;opacity:0;transform:none}.modal-container{position:relative;overflow:hidden;width:var(--container-width);display:flex;flex-direction:column;gap:var(--container-gap);max-width:95vw;max-height:95vh;max-height:95dvh;overflow:auto;-ms-overflow-style:none;scrollbar-width:none;}.modal-container ::-webkit-scrollbar{display:none}.modal-container.no-footer{gap:0px}.modal-body-card{--card-padding-top:16px;--card-padding-bottom:16px;--card-padding-start:16px;--card-padding-end:16px;--card-border-width:0px}.body::part(card-container){box-shadow:var(--card-box-shadow);width:100%}.no-opacity{opacity:0}.mobile-footer{margin-top:16px}.footer-hidden{height:0px;visibility:hidden;--card-padding-top:0px;--card-padding-bottom:0px;--card-padding-start:0px;--card-padding-end:0px;--card-border-width:0px}";
const CpslAuthModalStyle0 = cpslAuthModalCss;

const mm = gsapWithCSS.matchMedia();
const CpslAuthModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslModalEntering = createEvent(this, "cpslModalEntering", 7);
        this.cpslModalEntered = createEvent(this, "cpslModalEntered", 7);
        this.cpslModalExiting = createEvent(this, "cpslModalExiting", 7);
        this.cpslModalExited = createEvent(this, "cpslModalExited", 7);
        this.cpslModalRequestClose = createEvent(this, "cpslModalRequestClose", 7);
        this.hasFooter = undefined;
        this.isMobile = undefined;
        this.enterTransitionDuration = 0.15;
        this.exitTransitionDuration = 0.15;
        this.noOverlay = undefined;
        this.open = undefined;
        this.zIndexOverride = undefined;
    }
    toggleModal() {
        if (this.hasAnimatedIn) {
            this.handleAnimation();
        }
    }
    componentDidLoad() {
        this.handleAnimation();
        this.hasAnimatedIn = true;
        mm.add(`(min-width: ${MOBILE_SIZE + 1}px)`, () => {
            gsapWithCSS.timeline({}).set(this.modalWrapperEl, { yPercent: 0, scale: this.open ? 1 : 0.8, opacity: this.open ? 1 : 0 });
            this.isMobile = false;
        });
        mm.add(`(max-width: ${MOBILE_SIZE}px)`, () => {
            gsapWithCSS.timeline({}).set(this.modalWrapperEl, { scale: 1, opacity: 1, yPercent: this.open ? -100 : 0 });
            this.isMobile = true;
        });
        this.hasFooter = this.footerSlotEl.assignedNodes().length >= 1;
        this.footerSlotEl.addEventListener('slotchange', () => {
            if (this.footerSlotEl.assignedNodes().length >= 1) {
                this.hasFooter = true;
            }
            else {
                this.hasFooter = false;
            }
        });
    }
    handleAnimation() {
        if (typeof window !== 'undefined') {
            if (this.open) {
                if (window.innerWidth >= MOBILE_SIZE + 1) {
                    gsapWithCSS
                        .timeline({
                        onStart: () => {
                            this.cpslModalEntering.emit();
                        },
                        onComplete: () => {
                            this.cpslModalEntered.emit();
                        },
                    })
                        .set(this.modalWrapperEl, { display: 'flex', yPercent: 0 })
                        .to(this.modalWrapperEl, {
                        scale: 1,
                        opacity: 1,
                        duration: this.enterTransitionDuration,
                    });
                }
                else {
                    gsapWithCSS
                        .timeline({
                        onStart: () => {
                            this.cpslModalEntering.emit();
                        },
                        onComplete: () => {
                            this.cpslModalEntered.emit();
                        },
                    })
                        .set(this.modalWrapperEl, { display: 'flex', scale: 1, opacity: 1 })
                        .to(this.modalWrapperEl, {
                        yPercent: -100,
                        duration: this.enterTransitionDuration,
                    });
                }
            }
            else {
                if (window.innerWidth >= MOBILE_SIZE + 1) {
                    gsapWithCSS
                        .timeline({
                        onStart: () => {
                            this.cpslModalExiting.emit();
                        },
                        onComplete: () => {
                            var _a;
                            this.cpslModalExited.emit();
                            (_a = this.modalWrapperEl) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'none');
                        },
                    })
                        .to(this.modalWrapperEl, {
                        scale: 0.8,
                        opacity: 0,
                        duration: this.exitTransitionDuration,
                    });
                }
                else {
                    gsapWithCSS
                        .timeline({
                        onStart: () => {
                            this.cpslModalExiting.emit();
                        },
                        onComplete: () => {
                            var _a;
                            this.cpslModalExited.emit();
                            (_a = this.modalWrapperEl) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'none');
                        },
                    })
                        .to(this.modalWrapperEl, {
                        yPercent: 0,
                        duration: this.exitTransitionDuration,
                    })
                        .set(this.modalContainerEl, { y: 0 });
                }
            }
        }
    }
    get footerEl() {
        return this.el.shadowRoot.getElementById('modal-footer');
    }
    get modalWrapperEl() {
        return this.el.shadowRoot.getElementById('modal-wrapper');
    }
    get modalContainerEl() {
        return this.el.shadowRoot.getElementById('modal-container');
    }
    get footerSlotEl() {
        return this.footerEl.querySelectorAll('slot')[0];
    }
    get Modal() {
        return (h("div", { class: { 'modal-container': true, 'no-footer': !this.hasFooter }, part: "modal-container", id: "modal-container" }, h("cpsl-card", { id: "modal-body-card", class: { 'modal-body-card': true, 'body': true }, part: "modal-body-card" }, h("slot", { name: "body" }), this.isMobile && (h("div", { class: "mobile-footer", part: "modal-mobile-footer" }, h("slot", { name: "footer" })))), h("cpsl-card", { id: "modal-footer", part: "modal-footer", class: { 'footer-hidden': !this.hasFooter, 'modal-body-card': true }, style: { display: !this.isMobile ? 'block' : 'none' } }, h("slot", { name: "footer" }))));
    }
    render() {
        if (this.noOverlay) {
            return (h(Host, { style: this.zIndexOverride ? { zIndex: `${this.zIndexOverride}` } : {}, class: "no-overlay" }, this.Modal));
        }
        return (h(Host, { style: this.zIndexOverride ? { zIndex: `${this.zIndexOverride}` } : {}, class: { 'include-mobile-styling': true } }, h("cpsl-overlay", { zIndexOverride: this.zIndexOverride ? this.zIndexOverride : undefined, id: "overlay", open: this.open, enterTransitionDuration: this.enterTransitionDuration, exitTransitionDuration: this.exitTransitionDuration }), h("div", { id: "modal-wrapper", class: "modal-wrapper" }, this.Modal)));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "open": ["toggleModal"]
    }; }
};
CpslAuthModal.style = CpslAuthModalStyle0;

const cpslAvatarCss = ":host{--container-border-color:var(--cpsl-color-avatar-border);--container-border-width:1px;--container-border-radius:var(--cpsl-border-radius-avatar);--container-background-color:var(--cpsl-color-avatar-surface);--container-padding:4px;--container-height:40px;--container-width:40px;display:block;height:100%;width:100%}span{display:inline-block;height:var(--container-height);width:var(--container-width);border:var(--container-border-width) solid var(--container-border-color);border-radius:var(--container-border-radius);padding:var(--container-padding);background-color:var(--container-background-color)}span.round{border-radius:1000px}span.round img{border-radius:1000px}img{width:100%;height:100%;border-radius:var(--container-border-radius);object-fit:cover}";
const CpslAvatarStyle0 = cpslAvatarCss;

const CpslAvatar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.alt = undefined;
        this.src = undefined;
        this.size = undefined;
        this.variant = 'square';
    }
    render() {
        var _a;
        return (h(Host, { key: '58a67ffe4a40ece11edde2c8e20bbca8b3d16976' }, h("span", { key: '910593a08ccaa4cc45148e75b8e9368e82ddbbd1', class: { round: this.variant === 'round' }, style: this.size
                ? {
                    width: this.size,
                    height: this.size,
                }
                : {} }, h("img", { key: '8e0bed38daf1e45c30c83461cd68412efcd27083', src: this.src, alt: (_a = this.alt) !== null && _a !== void 0 ? _a : 'avatar' }))));
    }
};
CpslAvatar.style = CpslAvatarStyle0;

const cpslButtonCss = ":host{--button-border-width:1px;--button-border-width-start:var(--button-border-width);--button-border-width-end:var(--button-border-width);--button-border-width-top:var(--button-border-width);--button-border-width-bottom:var(--button-border-width);--button-gap:8px;--button-justify-content:center;--button-border-radius-top-start:var(--button-border-radius);--button-border-radius-top-end:var(--button-border-radius);--button-border-radius-bottom-end:var(--button-border-radius);--button-border-radius-bottom-start:var(--button-border-radius);--button-padding-start:16px;--button-padding-end:16px;--button-icon-size:var(--cpls-font-size-body-l);--button-font-weight:500;--button-primary-color:var(--cpsl-color-primary-button-text);--button-primary-background-color:var(--cpsl-color-primary-button-surface-default);--button-primary-border-color:var(--cpsl-color-primary-button-border-default);--button-primary-icon-color:var(--cpsl-color-primary-button-text);--button-primary-disabled-color:var(--cpsl-color-text-disabled);--button-primary-disabled-background-color:var(--cpsl-color-primary-button-surface-disabled);--button-primary-disabled-border-color:var(--cpsl-color-primary-button-border-disabled);--button-primary-disabled-icon-color:var(--cpsl-color-text-disabled);--button-primary-hover-color:var(--cpsl-color-primary-button-text);--button-primary-hover-background-color:var(--cpsl-color-primary-button-surface-hover);--button-primary-hover-border-color:var(--cpsl-color-primary-button-surface-hover);--button-primary-hover-icon-color:var(--cpsl-color-primary-button-text);--button-primary-active-color:var(--cpsl-color-primary-button-text);--button-primary-active-background-color:var(--cpsl-color-primary-button-surface-pressed);--button-primary-active-border-color:var(--cpsl-color-primary-button-surface-pressed);--button-primary-active-icon-color:var(--cpsl-color-primary-button-text);--button-secondary-color:var(--cpsl-color-secondary-button-text);--button-secondary-background-color:var(--cpsl-color-secondary-button-surface-default);--button-secondary-border-color:var(--cpsl-color-secondary-button-border-default);--button-secondary-icon-color:var(--cpsl-color-secondary-button-text);--button-secondary-disabled-color:var(--cpsl-color-text-disabled);--button-secondary-disabled-background-color:var(--cpsl-color-secondary-button-surface-disabled);--button-secondary-disabled-border-color:var(--cpsl-color-secondary-button-border-disabled);--button-secondary-disabled-icon-color:var(--cpsl-color-secondary-button-text);--button-secondary-hover-color:var(--cpsl-color-secondary-button-text);--button-secondary-hover-background-color:var(--cpsl-color-secondary-button-surface-hover);--button-secondary-hover-border-color:var(--cpsl-color-secondary-button-border-default);--button-secondary-hover-icon-color:var(--cpsl-color-secondary-button-text);--button-secondary-active-color:var(--cpsl-color-secondary-button-text);--button-secondary-active-background-color:var(--cpsl-color-secondary-button-surface-pressed);--button-secondary-active-border-color:var(--cpsl-color-secondary-button-border-default);--button-secondary-active-icon-color:var(--cpsl-color-secondary-button-text);--button-tertiary-color:var(--cpsl-color-tertiary-button-text);--button-tertiary-background-color:var(--cpsl-color-tertiary-button-surface-default);--button-tertiary-border-color:var(--cpsl-color-tertiary-button-border-default);--button-tertiary-icon-color:var(--cpsl-color-tertiary-button-text);--button-tertiary-disabled-color:var(--cpsl-color-text-disabled);--button-tertiary-disabled-background-color:var(--cpsl-color-tertiary-button-surface-disabled);--button-tertiary-disabled-border-color:var(--cpsl-color-tertiary-button-border-disabled);--button-tertiary-disabled-icon-color:var(--cpsl-color-tertiary-button-text);--button-tertiary-hover-color:var(--cpsl-color-tertiary-button-text);--button-tertiary-hover-background-color:var(--cpsl-color-tertiary-button-surface-hover);--button-tertiary-hover-border-color:var(--cpsl-color-tertiary-button-surface-hover);--button-tertiary-hover-icon-color:var(--cpsl-color-tertiary-button-text);--button-tertiary-active-color:var(--cpsl-color-tertiary-button-text);--button-tertiary-active-background-color:var(--cpsl-color-tertiary-button-surface-pressed);--button-tertiary-active-border-color:var(--cpsl-color-tertiary-button-surface-pressed);--button-tertiary-active-icon-color:var(--cpsl-color-tertiary-button-text);--button-ghost-color:var(--cpsl-color-ghost-button-default);--button-ghost-disabled-color:var(--cpsl-color-ghost-button-disabled);--button-ghost-hover-color:var(--cpsl-color-ghost-button-hover);--button-destructive-color:var(--cpsl-color-destructive-button-text);--button-destructive-background-color:var(--cpsl-color-destructive-button-surface-default);--button-destructive-border-color:var(--cpsl-color-destructive-button-border-default);--button-destructive-icon-color:var(--cpsl-color-destructive-button-text);--button-destructive-disabled-color:var(--cpsl-color-text-disabled);--button-destructive-disabled-background-color:var(--cpsl-color-destructive-button-surface-disabled);--button-destructive-disabled-border-color:var(--cpsl-color-destructive-button-border-disabled);--button-destructive-disabled-icon-color:var(--cpsl-color-destructive-button-text);--button-destructive-hover-color:var(--cpsl-color-destructive-button-text);--button-destructive-hover-background-color:var(--cpsl-color-destructive-button-surface-hover);--button-destructive-hover-border-color:var(--cpsl-color-destructive-button-border-default);--button-destructive-hover-icon-color:var(--cpsl-color-destructive-button-text);--button-destructive-active-color:var(--cpsl-color-destructive-button-text);--button-destructive-active-background-color:var(--cpsl-color-destructive-button-surface-pressed);--button-destructive-active-border-color:var(--cpsl-color-destructive-button-border-default);--button-destructive-active-icon-color:var(--cpsl-color-destructive-button-text);height:fit-content;width:fit-content;display:inline-block;font-family:var(--cpsl-font-family, inherit);-webkit-tap-highlight-color:transparent}:host a{height:fit-content;width:auto !important}:host(.full-width){width:100%;display:block}:host(.full-width) .button-native{width:100%}:host(.xSmall){--button-font-size:var(--cpsl-font-size-body-xs);--button-padding-top:8px;--button-padding-bottom:8px;--button-icon-size:var(--cpsl-font-size-body-s);--button-border-radius:8px}:host(.xSmall.primary){--button-padding-top:9px;--button-padding-bottom:9px;--button-border-radius:8px}:host(.xSmall.secondary){--button-border-radius:8px}:host(.xSmall.tertiary){--button-padding-top:9px;--button-padding-bottom:9px;--button-border-radius:8px}:host(.small){--button-font-size:var(--cpsl-font-size-body-s);--button-padding-top:12px;--button-padding-bottom:12px;--button-icon-size:var(--cpsl-font-size-body-m)}:host(.small.primary){--button-padding-top:13px;--button-padding-bottom:13px}:host(.small.tertiary){--button-padding-top:13px;--button-padding-bottom:13px}:host(.medium){--button-font-size:var(--cpsl-font-size-body-m);--button-padding-top:14px;--button-padding-bottom:14px;--button-icon-size:var(--cpsl-font-size-body-l)}:host(.medium) :host(.primary){--button-padding-top:15px;--button-padding-bottom:15px}:host(.medium) :host(.tertiary){--button-padding-top:15px;--button-padding-bottom:15px}:host(.medium.primary){--button-padding-top:15px;--button-padding-bottom:15px}:host(.medium.tertiary){--button-padding-top:15px;--button-padding-bottom:15px}:host(.disabled){cursor:default;pointer-events:none}:host ::slotted(cpsl-icon){--height:var(--button-icon-size);--width:var(--button-icon-size)}:host(.primary){--button-border-radius:var(--cpsl-border-radius-primary-button);--button-color:var(--button-primary-color);--button-background-color:var(--button-primary-background-color);--button-border-color:var(--button-primary-border-color);--button-padding-start:17px;--button-padding-end:17px;--button-border-width:0px}:host(.primary) ::slotted(cpsl-icon){--icon-color:var(--button-primary-icon-color)}:host(.primary):host(.disabled){--button-color:var(--button-primary-disabled-color);--button-background-color:var(--button-primary-disabled-background-color);--button-border-color:var(--button-primary-disabled-border-color);--button-outline-color:transparent}:host(.primary):host(.disabled) ::slotted(cpsl-icon){--icon-color:var(--button-primary-disabled-icon-color)}:host(.primary):host(.disabled) ::slotted(cpsl-spinner){--background-color:var(--button-primary-disabled-background-color)}:host(.primary) :not(.disabled):hover{--button-color:var(--button-primary-hover-color);--button-background-color:var(--button-primary-hover-background-color);--button-border-color:var(--button-primary-hover-border-color)}:host(.primary) :not(.disabled):hover ::slotted(cpsl-icon){--icon-color:var(--button-primary-hover-icon-color)}:host(.primary) :not(.disabled):active{--button-color:var(--button-primary-active-color);--button-background-color:var(--button-primary-active-background-color);--button-border-color:var(--button-primary-active-border-color)}:host(.primary) :not(.disabled):active ::slotted(cpsl-icon){--icon-color:var(--button-primary-active-icon-color)}:host(.primary) :not(.disabled):focus-visible{--button-outline-color:var(--cpsl-color-primary-button-outline)}:host(.secondary){--button-border-radius:var(--cpsl-border-radius-destructive-button);--button-color:var(--button-secondary-color);--button-background-color:var(--button-secondary-background-color);--button-border-color:var(--button-secondary-border-color)}:host(.secondary) ::slotted(cpsl-icon){--icon-color:var(--button-secondary-icon-color)}:host(.secondary):host(.disabled){--button-color:var(--button-secondary-disabled-color);--button-background-color:var(--button-secondary-disabled-background-color);--button-border-color:var(--button-secondary-disabled-border-color);--button-outline-color:transparent}:host(.secondary):host(.disabled) ::slotted(cpsl-icon){--icon-color:var(--button-secondary-disabled-icon-color)}:host(.secondary):host(.disabled) ::slotted(cpsl-spinner){--background-color:var(--button-secondary-disabled-icon-color)}:host(.secondary) :not(.disabled):hover{--button-color:var(--button-secondary-hover-color);--button-border-color:var(--button-secondary-hover-border-color);--button-background-color:var(--button-secondary-hover-background-color)}:host(.secondary) :not(.disabled):hover ::slotted(cpsl-icon){--icon-color:var(--button-secondary-hover-icon-color)}:host(.secondary) :not(.disabled):active{--button-color:var(--button-secondary-active-color);--button-border-color:var(--button-secondary-active-border-color);--button-background-color:var(--button-secondary-active-background-color)}:host(.secondary) :not(.disabled):active ::slotted(cpsl-icon){--icon-color:var(--button-secondary-active-icon-color)}:host(.secondary) :not(.disabled):focus-visible{--button-outline-color:var(--cpsl-color-secondary-button-outline)}:host(.tertiary){--button-border-radius:var(--cpsl-border-radius-tertiary-button);--button-color:var(--button-tertiary-color);--button-background-color:var(--button-tertiary-background-color);--button-border-color:var(--button-tertiary-border-color);--button-padding-start:17px;--button-padding-end:17px;--button-border-width:0px}:host(.tertiary) ::slotted(cpsl-icon){--icon-color:var(--button-tertiary-icon-color)}:host(.tertiary):host(.disabled){--button-color:var(--button-tertiary-disabled-color);--button-background-color:var(--button-tertiary-disabled-background-color);--button-border-color:var(--button-tertiary-disabled-border-color);--button-outline-color:transparent}:host(.tertiary):host(.disabled) ::slotted(cpsl-icon){--icon-color:var(--button-tertiary-disabled-icon-color)}:host(.tertiary):host(.disabled) ::slotted(cpsl-spinner){--background-color:var(--button-tertiary-disabled-icon-color)}:host(.tertiary) :not(.disabled):hover{--button-color:var(--button-tertiary-hover-color);--button-background-color:var(--button-tertiary-hover-background-color);--button-border-color:var(--button-tertiary-hover-border-color)}:host(.tertiary) :not(.disabled):hover ::slotted(cpsl-icon){--icon-color:var(--button-tertiary-hover-icon-color)}:host(.tertiary) :not(.disabled):active{--button-color:var(--button-tertiary-active-color);--button-background-color:var(--button-tertiary-active-background-color);--button-border-color:var(--button-tertiary-active-border-color)}:host(.tertiary) :not(.disabled):active ::slotted(cpsl-icon){--icon-color:var(--button-tertiary-active-icon-color)}:host(.tertiary) :not(.disabled):focus-visible{--button-outline-color:var(--cpsl-color-tertiary-button-outline)}:host(.ghost){--button-color:var(--button-ghost-color);--button-background-color:transparent;--button-border-color:transparent;--button-outline-color:transparent;--button-padding-start:0px;--button-padding-end:0px;--button-padding-top:0px;--button-padding-bottom:0px;--button-border-width:0px}:host(.ghost) ::slotted(cpsl-icon){--icon-color:var(--button-ghost-color)}:host(.ghost):host(.disabled){--button-color:var(--button-ghost-disabled-color)}:host(.ghost):host(.disabled) ::slotted(cpsl-icon){--icon-color:var(--button-ghost-disabled-color)}:host(.ghost):host(.disabled) ::slotted(cpsl-spinner){--background-color:var(--button-ghost-disabled-color)}:host(.ghost) :not(.disabled):hover{--button-color:var(--button-ghost-hover-color)}:host(.ghost) :not(.disabled):hover ::slotted(cpsl-icon){--icon-color:var(--button-ghost-hover-color)}:host(.destructive){--button-border-radius:var(--cpsl-border-radius-secondary-button);--button-color:var(--button-destructive-color);--button-background-color:var(--button-destructive-background-color);--button-border-color:var(--button-destructive-border-color)}:host(.destructive) ::slotted(cpsl-icon){--icon-color:var(--button-destructive-icon-color)}:host(.destructive):host(.disabled){--button-color:var(--button-destructive-disabled-color);--button-background-color:var(--button-destructive-disabled-background-color);--button-border-color:var(--button-destructive-disabled-border-color);--button-outline-color:transparent}:host(.destructive):host(.disabled) ::slotted(cpsl-icon){--icon-color:var(--button-destructive-disabled-icon-color)}:host(.destructive) :not(.disabled):hover{--button-color:var(--button-destructive-hover-color);--button-border-color:var(--button-destructive-hover-border-color);--button-background-color:var(--button-destructive-hover-background-color)}:host(.destructive) :not(.disabled):hover ::slotted(cpsl-icon){--icon-color:var(--button-destructive-hover-icon-color)}:host(.destructive) :not(.disabled):active{--button-color:var(--button-destructive-active-color);--button-border-color:var(--button-destructive-active-border-color);--button-background-color:var(--button-destructive-active-background-color)}:host(.destructive) :not(.disabled):active ::slotted(cpsl-icon){--icon-color:var(--button-destructive-active-icon-color)}:host(.destructive) :not(.disabled):focus-visible{--button-outline-color:var(--cpsl-color-destructive-button-outline)}.button-native{border-top-left-radius:var(--button-border-radius-top-start);border-top-right-radius:var(--button-border-radius-top-end);border-bottom-right-radius:var(--button-border-radius-bottom-end);border-bottom-left-radius:var(--button-border-radius-bottom-start);-webkit-padding-start:var(--button-padding-start);padding-inline-start:var(--button-padding-start);-webkit-padding-end:var(--button-padding-end);padding-inline-end:var(--button-padding-end);padding-top:var(--button-padding-top);padding-bottom:var(--button-padding-bottom);font-size:var(--button-font-size);font-weight:var(--button-font-weight);font-family:inherit;white-space:nowrap;text-decoration:none;border:0px solid transparent;border-width:var(--button-border-width-top) var(--button-border-width-end) var(--button-border-width-bottom) var(--button-border-width-start);cursor:pointer;color:var(--button-color);background:var(--button-background-color);border-color:var(--button-border-color);display:flex;justify-content:var(--button-justify-content);align-items:center;height:100%;gap:var(--button-gap);word-break:break-all;outline-color:var(--button-outline-color);-webkit-tap-highlight-color:transparent}:host-context([dir=rtl]) .button-native{border-top-left-radius:var(--button-border-radius-top-end);border-top-right-radius:var(--button-border-radius-top-start);border-bottom-right-radius:var(--button-border-radius-bottom-start);border-bottom-left-radius:var(--button-border-radius-bottom-end)}[dir=rtl] .button-native{border-top-left-radius:var(--button-border-radius-top-end);border-top-right-radius:var(--button-border-radius-top-start);border-bottom-right-radius:var(--button-border-radius-bottom-start);border-bottom-left-radius:var(--button-border-radius-bottom-end)}@supports selector(:dir(rtl)){.button-native:dir(rtl){border-top-left-radius:var(--button-border-radius-top-end);border-top-right-radius:var(--button-border-radius-top-start);border-bottom-right-radius:var(--button-border-radius-bottom-start);border-bottom-left-radius:var(--button-border-radius-bottom-end)}}:host ::slotted(cpsl-text){--color-override:var(--button-color)}:host ::slotted(cpsl-icon-group){--container-border-color:var(--button-background-color)}:host ::slotted(cpsl-spinner){--background-color:var(--button-background-color)}";
const CpslButtonStyle0 = cpslButtonCss;

const CpslButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.as = 'button';
        this.disabled = false;
        this.fullWidth = false;
        this.href = undefined;
        this.size = 'medium';
        this.target = undefined;
        this.type = 'button';
        this.variant = 'primary';
    }
    render() {
        return (h(Host, { key: '0fd0606bdefb9664a01e2e9686065f5833e9190d', class: {
                // VARIANTS
                'primary': this.variant === 'primary',
                'secondary': this.variant === 'secondary',
                'tertiary': this.variant === 'tertiary',
                'ghost': this.variant === 'ghost',
                'destructive': this.variant === 'destructive',
                // STATE
                'disabled': this.disabled,
                'full-width': this.fullWidth,
                // SIZES
                'xSmall': this.size === 'xSmall',
                'small': this.size === 'small',
                'medium': this.size === 'medium',
            } }, h(this.as, { key: '61b2fa9127eb03f9a3a4292f5161fe141ad545a5', href: this.href, target: this.target, part: "button-native", class: "button-native", type: this.type }, h("slot", { key: '2a3f3e90edace6f165cb1ead835a8dff1fc01cd6', name: "start" }), h("slot", { key: 'c0d5f828589bc74e40a6df43b85e3c04f1f25309' }), h("slot", { key: '11ea165fbc4141e49df46c2f09f203e052a5dfd1', name: "end" }))));
    }
};
CpslButton.style = CpslButtonStyle0;

const cpslButtonGroupCss = ":host{--button-size:32px;display:flex}:host ::slotted(cpsl-button:first-child){--button-border-radius-top-end:0px;--button-border-radius-bottom-end:0px}:host ::slotted(cpsl-button:last-child){--button-border-width-start:0px;--button-border-radius-top-start:0px;--button-border-radius-bottom-start:0px}:host ::slotted(cpsl-button:not(:first-child):not(:last-child)){--button-border-width-start:0px;--button-border-radius-top-start:0px;--button-border-radius-bottom-start:0px;--button-border-radius-top-end:0px;--button-border-radius-bottom-end:0px}:host ::slotted(cpsl-button){--button-color:var(--cpsl-color-text-tertiary);--button-padding-start:0px;--button-padding-end:0px;--button-padding-top:0px;--button-padding-bottom:0px;--button-border-radius:var(--cpsl-border-radius-button-group);height:var(--button-size);width:var(--button-size)}:host ::slotted(cpsl-button.selected){--button-color:var(--cpsl-color-text-primary)}";
const CpslButtonGroupStyle0 = cpslButtonGroupCss;

const CpslButtonGroup = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selectedId = undefined;
    }
    selectItem() {
        this.buttonSlots.forEach(item => {
            if (item.id === this.selectedId) {
                item.classList.add('selected');
            }
            else {
                item.classList.remove('selected');
            }
        });
    }
    componentWillRender() {
        var _a;
        this.buttonSlots.forEach(item => {
            item.setAttribute('variant', 'secondary');
            item.setAttribute('full-width', 'true');
            this.selectItem();
        });
        if ((_a = this.otherSlots) === null || _a === void 0 ? void 0 : _a.length) {
            console.error('cpsl-button is the only valid child of cpsl-button-group');
            this.otherSlots.forEach(item => item.remove());
        }
    }
    get buttonSlots() {
        return this.el.querySelectorAll('cpsl-button');
    }
    get otherSlots() {
        return this.el.querySelectorAll('&> *:not(cpsl-button)');
    }
    render() {
        return (h(Host, { key: '91ccfcaf08be6fc45076376b19e63b5b58ab9b15' }, h("slot", { key: '9af22dc4fcbd76ebc32e476d1682e2fe41b33f81' })));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "selectedId": ["selectItem"]
    }; }
};
CpslButtonGroup.style = CpslButtonGroupStyle0;

const cpslCardCss = ":host{--card-padding-top:24px;--card-padding-end:24px;--card-padding-bottom:24px;--card-padding-start:24px;--card-border-width:1px;--card-border-color:var(--cpsl-color-card-border);--card-border-radius-tl:var(--cpsl-border-radius-card);--card-border-radius-tr:var(--cpsl-border-radius-card);--card-border-radius-bl:var(--cpsl-border-radius-card);--card-border-radius-br:var(--cpsl-border-radius-card);--card-background-color:var(--cpsl-color-card-surface);display:block}.card{-webkit-padding-start:var(--card-padding-start);padding-inline-start:var(--card-padding-start);-webkit-padding-end:var(--card-padding-end);padding-inline-end:var(--card-padding-end);padding-top:var(--card-padding-top);padding-bottom:var(--card-padding-bottom);display:block;box-sizing:border-box;overflow:hidden;border:var(--card-border-width) solid var(--card-border-color);border-radius:var(--card-border-radius-tl) var(--card-border-radius-tr) var(--card-border-radius-br) var(--card-border-radius-bl);background:var(--card-background-color)}";
const CpslCardStyle0 = cpslCardCss;

const CpslCard = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    render() {
        return (h(Host, { key: '21177f5a9ceec0246dc1fa89a052bfdadacc3063' }, h("div", { key: '0940e0aaf62b24e1be0e99c736069b5bb463854c', class: { card: true }, part: "card-container" }, h("slot", { key: '6317e03f97be9841c03b040845591043bf203e36' }))));
    }
};
CpslCard.style = CpslCardStyle0;

const cpslCheckboxCss = ":host{--container-height:20px;--container-width:20px;--container-border-radius:var(--cpsl-border-radius-checkbox);--container-border-width:2px;--container-background-color-default:var(--cpsl-color-checkbox-surface-default);--container-border-color-default:var(--cpsl-color-checkbox-border-default);--container-background-color-checked:var(--cpsl-color-checkbox-surface-checked);--container-border-color-checked:var(--cpsl-color-checkbox-border-checked);--icon-height:16px;--icon-width:16px;--checkbox-icon-color:var(--cpsl-color-checkbox-icon);display:block;position:relative;height:var(--container-height);width:var(--container-width);cursor:pointer}input{position:absolute;width:100%;height:100%;margin:0px;opacity:0}span.container{display:flex;align-items:center;justify-content:center;position:relative;box-sizing:border-box;width:100%;height:100%;border-radius:var(--container-border-radius);border:var(--container-border-width) solid;background:var(--container-background-color-default);border-color:var(--container-border-color-default);transition:all 0.15s ease-in-out}span.container cpsl-icon{--height:var(--icon-height);--width:var(--icon-width);opacity:0;--icon-color:var(--checkbox-icon-color);transition:all 0.15s ease-in-out}span.container.checked{background:var(--container-background-color-checked);border-color:var(--container-border-color-checked)}span.container.checked cpsl-icon{opacity:1}";
const CpslCheckboxStyle0 = cpslCheckboxCss;

const CpslCheckbox = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslCheckboxChanged = createEvent(this, "cpslCheckboxChanged", 7);
        this.handleCheckboxClick = () => {
            this.cpslCheckboxChanged.emit(!this.checked);
        };
        this.checked = undefined;
    }
    render() {
        return (h(Host, { key: '236c0b027e72c0c25dbc2fd3183a77400c815f8c' }, h("input", { key: '8c350e21268b87d485b16796b2058c4e47f46e75', type: "checkbox", checked: this.checked }), h("span", { key: 'b1d8fc6dd380b67eb8940f55bba47810c54ee189', onClick: this.handleCheckboxClick, class: { container: true, checked: this.checked } }, h("cpsl-icon", { key: '2b3ddcad1e2b9007bda8135a810b75a1a2cfaeca', icon: "check" }))));
    }
};
CpslCheckbox.style = CpslCheckboxStyle0;

const cpslCodeInputCss = ":host{--input-width:40px;--input-height:54px;--input-border-radius:var(--cpsl-border-radius-input);--input-border-color:var(--cpsl-color-input-border-placeholder);--input-border-width:1px;--input-background-color:var(--cpsl-color-input-surface-default);--input-border-error-color:var(--cpsl-color-input-border-error);--input-font-size:clamp(20px, 1.25rem, 30px);--input-color:var(--cpsl-color-text-primary);--helper-text-color:var(--cpsl-color-text-secondary);--helper-text-error-color:var(--cpsl-color-text-error);--helper-text-icon-color:var(--cpsl-color-text-secondary);--helper-text-icon-error-color:var(--cpsl-color-text-error);--helper-text-icon-size:16px;--helper-text-font-size:12px;--helper-text-margin-top:6px;display:block;font-family:var(--cpsl-font-family, inherit)}.code-container{display:flex;gap:8px}.code-input{font-family:var(--cpsl-font-family, inherit);border-radius:var(--input-border-radius);font-size:var(--input-font-size);border-color:var(--input-border-color);border-width:var(--input-border-width);border-style:solid;font-size:var(--input-font-size);color:var(--input-color);width:var(--input-width);height:var(--input-height);background:var(--input-background-color);box-sizing:border-box;text-align:center;outline:none}.code-input.has-value{--input-border-color:var(--cpsl-color-accent-32)}.code-input:focus{--input-border-color:var(--cpsl-color-input-border-active)}.code-input::-webkit-outer-spin-button,.code-input::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.code-input .error-container{border-color:var(--input-border-error-color)}input[type=number]{-moz-appearance:textfield}.helper-text-container{flex-basis:100%;display:flex;align-items:center;gap:4px;color:var(--helper-text-color);font-size:var(--helper-text-font-size);margin-top:var(--helper-text-margin-top)}.helper-text-container cpsl-icon{--height:var(--helper-text-icon-size);--width:var(--helper-text-icon-size);--icon-color:var(--helper-text-icon-color)}.error-text{color:var(--helper-text-error-color)}.error-text cpsl-icon{--icon-color:var(--helper-text-icon-error-color)}";
const CpslCodeInputStyle0 = cpslCodeInputCss;

const CpslCodeInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslInput = createEvent(this, "cpslInput", 7);
        this.handleInput = (ind, ev) => {
            var _a;
            const inputElements = this.inputs;
            // If getting an insertFromPaste remove the last element value since the value setting is handled in the paste event
            if (ev.inputType === 'insertFromPaste') {
                inputElements[Math.min(this.length - 1, ind)].value = '';
                return;
            }
            if (ev.inputType === 'insertText') {
                if (this.type === 'number' && isNaN(parseInt(ev.data))) {
                    inputElements[ind].value = '';
                    return;
                }
                const newCode = `${(_a = this.code) !== null && _a !== void 0 ? _a : ''}${ev.data}`;
                inputElements[Math.min(this.length - 1, newCode.length)].focus();
                this.cpslInput.emit({ value: newCode });
                this.code = newCode;
            }
        };
        this.handleKeyDown = (ind, ev) => {
            const inputElements = this.inputs;
            switch (ev.key) {
                case 'Backspace': {
                    let newCode;
                    if (!inputElements[ind].value) {
                        inputElements[Math.max(0, ind - 1)].value = '';
                        inputElements[Math.max(0, ind - 1)].focus();
                        newCode = this.code.substring(0, ind - 1);
                    }
                    else {
                        newCode = this.code.substring(0, ind);
                    }
                    this.cpslInput.emit({ value: newCode });
                    this.code = newCode;
                    break;
                }
                case 'ArrowLeft': {
                    setTimeout(() => {
                        this.inputs[ind].setSelectionRange(1, 1);
                    }, 0);
                    break;
                }
            }
        };
        this.handleFocus = (ind) => {
            const inputElements = this.inputs;
            for (const input of inputElements) {
                if (!input.value) {
                    input.focus();
                    break;
                }
                else if (input.id === `code-input-${this.length - 1}`) {
                    input.focus();
                    break;
                }
            }
            setTimeout(() => {
                inputElements[ind].setSelectionRange(1, 1);
            }, 0);
        };
        this.handlePaste = (e) => {
            const inputElements = this.inputs;
            const pastedCode = e.clipboardData.getData('text');
            if (this.type === 'number' && isNaN(parseInt(pastedCode))) {
                // Remove illegal value from the first input. Not using a timeout here doesn't change the value properly.
                setTimeout(() => {
                    inputElements[0].value = '';
                }, 0);
                return;
            }
            this.cpslInput.emit({
                value: pastedCode,
            });
            inputElements.forEach((input, index) => {
                input.value = pastedCode.charAt(index);
            });
            inputElements[Math.min(this.length - 1, pastedCode.length)].focus();
        };
        this.code = undefined;
        this.errorText = undefined;
        this.helperText = undefined;
        this.length = undefined;
        this.type = 'number';
    }
    get inputs() {
        return Array.from(this.el.shadowRoot.querySelectorAll('input'));
    }
    render() {
        var _a;
        return (h(Host, { key: '9c620c8eb41b595e672e2b7d22944e37de630f73' }, h("div", { key: 'd8e870d0b15b90cfccd78ba5f15cf7b9c0680f0a', class: "code-container" }, new Array(this.length).fill(0).map((_, i) => {
            var _a, _b;
            return (h("input", { class: { 'code-input': true, 'error': Boolean(this.errorText), 'has-value': ((_a = this.code) === null || _a === void 0 ? void 0 : _a[i]) !== undefined }, id: `code-input-${i}`, onKeyDown: ev => this.handleKeyDown(i, ev), onInput: ev => this.handleInput(i, ev), onFocus: () => this.handleFocus(i), onPaste: this.handlePaste, min: 0, max: 9, value: (_b = this.code) === null || _b === void 0 ? void 0 : _b[i], inputMode: this.type === 'number' ? 'numeric' : 'text' }));
        })), (this.errorText || this.helperText) && (h("div", { key: '532bccdc9d9135f4728c503c77b3795440a3607a', class: { 'helper-text-container': true, 'error-text': Boolean(this.errorText) } }, h("cpsl-icon", { key: '02db8b47b661f64f2fb3073827aef50d7b94f1f3', icon: this.errorText ? 'alertCircle' : 'infoCircle' }), h("span", { key: '228b294db359a308d3e76f2ce3c5d17b2d039781' }, (_a = this.errorText) !== null && _a !== void 0 ? _a : this.helperText)))));
    }
    get el() { return getElement(this); }
};
CpslCodeInput.style = CpslCodeInputStyle0;

const cpslDividerCss = ":host{--divider-height:1px;--divider-color:var(--cpsl-color-divider);display:flex;align-items:center;height:24px;width:100%;color:var(--cpsl-color-text-subtle);font-family:var(--cpsl-font-family, inherit);font-size:clamp(14px, 0.875rem, 21px);font-weight:500;gap:16px}:host div{flex:1;background:var(--divider-color);height:var(--divider-height)}";
const CpslDividerStyle0 = cpslDividerCss;

const CpslDivider = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    render() {
        return (h(Host, { key: 'd5cffdef9344f7dcac4aae1bc2acca8c02d69946' }, h("div", { key: 'e07f8107804df83537a3b8e40d124c66d2fc6f44' }), h("slot", { key: 'd97f02d46a63d32d107838b5aa50654a9593cc8a' }), h("div", { key: '2316aed010b91a65c961e2f30cc2cde03b892429' })));
    }
};
CpslDivider.style = CpslDividerStyle0;

const cpslDrawerCss = ":host{display:flex;position:fixed;z-index:10004}:host(.left){left:0;top:0;transition:left}:host(.right){right:0;top:0;transition:right}:host(.top){top:0;left:0;transition:top}:host(.bottom){bottom:0;left:0;transition:bottom}.container{flex:1;overflow:auto;z-index:10004}";
const CpslDrawerStyle0 = cpslDrawerCss;

const CpslDrawer = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.closedAnchorPosition = undefined;
        this.showTransition = undefined;
        this.anchor = undefined;
        this.anchorPosition = undefined;
        this.noOverlay = undefined;
        this.open = undefined;
        this.size = undefined;
        this.transitionDuration = 0.15;
        this.transitionFunction = 'ease-in-out';
        this.variant = 'temporary';
        this.zIndexOverride = undefined;
    }
    componentDidLoad() {
        this.closedAnchorPosition = `-${this.getContainerHeight()}px`;
        // Show transition after initial render
        setTimeout(() => {
            this.showTransition = true;
        }, 100);
    }
    getContainerHeight() {
        var _a;
        return (_a = this.containerEl) === null || _a === void 0 ? void 0 : _a.clientHeight;
    }
    get containerEl() {
        return this.el.shadowRoot.getElementById('container');
    }
    render() {
        var _a;
        const setHeight = this.anchor === 'top' || this.anchor === 'bottom';
        const startingAnchor = (_a = `${this.anchorPosition}px`) !== null && _a !== void 0 ? _a : '0px';
        const size = this.size === 'auto' ? 'auto' : `${this.size}px`;
        return (h(Host, { key: 'a658bc7f4a536ad193ffa83045fc9ee051ce00c8', style: Object.assign({ width: setHeight ? '100vw' : size, height: setHeight ? size : '100vh', transitionDuration: `${this.showTransition ? this.transitionDuration : 0}s`, transitionTimingFunction: `${this.transitionFunction}`, [this.anchor]: this.open || this.variant === 'permanent' ? startingAnchor : this.closedAnchorPosition, opacity: this.closedAnchorPosition === undefined ? '0' : '1' }, (this.zIndexOverride ? { zIndex: `${this.zIndexOverride}` } : {})), class: {
                top: this.anchor === 'top',
                bottom: this.anchor === 'bottom',
                left: this.anchor === 'left',
                right: this.anchor === 'right',
            } }, this.variant === 'temporary' && !this.noOverlay && h("cpsl-overlay", { key: '4af453a7893322c7327e4ae2daa36c510d79f63a', open: this.open, zIndexOverride: DEFAULT_Z_INDICES.modal + 1 }), h("div", { key: 'd223fe6203a4b927a4c7b4254fbf74bd0c5b7ba4', id: "container", class: "container", part: "container" }, h("slot", { key: 'c297bc0a9ce799ea62e84a7c15b3d56279424091' }))));
    }
    get el() { return getElement(this); }
};
CpslDrawer.style = CpslDrawerStyle0;

const AlertCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const AlertTriangle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="alert-triangle">
<path id="Icon" d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const AlignVerticalCenter = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M12 2V8.5M12 8.5L16 4.5M12 8.5L8 4.5M12 22V15.5M12 15.5L16 19.5M12 15.5L8 19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const AngelListBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.7703 10.0969C18.3188 8.56875 19.8984 4.14844 19.8984 2.73281C19.8984 1.48594 19.1625 0.440625 17.85 0.440625C15.7594 0.440625 13.8844 6.61406 13.2984 8.08594C12.8438 6.75 10.7156 0 8.84063 0C7.38282 0 6.69844 1.07344 6.69844 2.42344C6.69844 4.07812 8.30156 8.36719 8.88281 10.0172C8.5875 9.90938 8.26875 9.81562 7.94531 9.81562C6.84844 9.81562 5.68125 11.1797 5.68125 12.2812C5.68125 12.6984 5.91094 13.2844 6.05625 13.6734C4.32656 14.1422 3.66094 15.2953 3.66094 17.0344C3.65625 20.4187 6.8625 24 11.3719 24C16.9031 24 20.3438 19.8469 20.3438 14.4891C20.3438 12.4688 20.0203 10.6453 17.7703 10.0969ZM16.1109 5.0625C16.2984 4.48594 17.1 2.04844 17.85 2.04844C18.2531 2.04844 18.3609 2.46563 18.3609 2.79844C18.3609 3.69375 16.5516 8.63906 16.1531 9.73594L14.5594 9.45469L16.1109 5.0625ZM8.17032 2.26406C8.17032 1.70625 8.85 0.121875 10.3406 4.47188L11.9625 9.17344C11.2313 9.1125 10.6641 9.03281 10.3031 9.23906C9.79219 7.88906 8.17032 3.62812 8.17032 2.26406ZM8.0625 11.4375C9.43594 11.4375 11.2078 15.8719 11.2078 16.4719C11.2078 16.7109 10.9781 17.0062 10.7109 17.0062C9.73125 17.0062 7.10625 13.4016 7.10625 12.4266C7.11094 12.0656 7.70156 11.4375 8.0625 11.4375ZM16.7016 20.1703C15.3375 21.6703 13.5938 22.4484 11.5594 22.4484C8.775 22.4484 6.57656 20.9203 5.51719 18.3094C4.71563 16.275 5.69532 15.1078 6.48282 15.1078C7.01719 15.1078 9.02813 17.9344 9.02813 18.5344C9.02813 18.7641 8.66719 18.9234 8.47969 18.9234C7.725 18.9234 7.42969 18.1969 6.08438 16.5141C4.69219 17.9062 7.04532 20.5875 8.81719 20.5875C10.0406 20.5875 10.8375 19.4531 10.5984 18.6188C10.7719 18.6188 10.9875 18.6328 11.1469 18.5906C11.1984 19.8609 11.5734 21.375 13.1016 21.4828C13.1016 21.4406 13.1953 21.15 13.1953 21.1359C13.1953 20.3203 12.6984 19.6078 12.6984 18.7781C12.6984 17.4516 13.7156 16.1672 14.7469 15.4172C15.1219 15.1359 15.5766 14.9625 16.0172 14.8031C16.4719 14.6297 16.9547 14.4281 17.3016 14.0812C17.25 13.5562 17.0344 13.0922 16.5094 13.0922C15.2109 13.0922 10.8563 13.2797 10.8563 11.2313C10.8563 10.9172 10.8609 10.6172 11.6719 10.6172C13.1859 10.6172 17.0297 10.9922 18.1547 11.9813C19.0031 12.7359 19.2938 17.2875 16.7016 20.1703ZM12.0797 14.2641C12.5344 14.4094 13.0031 14.4516 13.4719 14.5453C13.125 14.7984 12.8156 15.1078 12.5203 15.4406C12.3891 15.0422 12.2297 14.6531 12.0797 14.2641Z" fill="black"/>
</svg>
`;

const AngelList = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M17.7703 10.0969C18.3188 8.56875 19.8984 4.14844 19.8984 2.73281C19.8984 1.48594 19.1625 0.440625 17.85 0.440625C15.7594 0.440625 13.8844 6.61406 13.2984 8.08594C12.8438 6.75 10.7156 0 8.84063 0C7.38282 0 6.69844 1.07344 6.69844 2.42344C6.69844 4.07812 8.30156 8.36719 8.88281 10.0172C8.5875 9.90938 8.26875 9.81562 7.94531 9.81562C6.84844 9.81562 5.68125 11.1797 5.68125 12.2812C5.68125 12.6984 5.91094 13.2844 6.05625 13.6734C4.32656 14.1422 3.66094 15.2953 3.66094 17.0344C3.65625 20.4187 6.8625 24 11.3719 24C16.9031 24 20.3438 19.8469 20.3438 14.4891C20.3438 12.4688 20.0203 10.6453 17.7703 10.0969ZM16.1109 5.0625C16.2984 4.48594 17.1 2.04844 17.85 2.04844C18.2531 2.04844 18.3609 2.46563 18.3609 2.79844C18.3609 3.69375 16.5516 8.63906 16.1531 9.73594L14.5594 9.45469L16.1109 5.0625ZM8.17032 2.26406C8.17032 1.70625 8.85 0.121875 10.3406 4.47188L11.9625 9.17344C11.2313 9.1125 10.6641 9.03281 10.3031 9.23906C9.79219 7.88906 8.17032 3.62812 8.17032 2.26406ZM8.0625 11.4375C9.43594 11.4375 11.2078 15.8719 11.2078 16.4719C11.2078 16.7109 10.9781 17.0062 10.7109 17.0062C9.73125 17.0062 7.10625 13.4016 7.10625 12.4266C7.11094 12.0656 7.70156 11.4375 8.0625 11.4375ZM16.7016 20.1703C15.3375 21.6703 13.5938 22.4484 11.5594 22.4484C8.775 22.4484 6.57656 20.9203 5.51719 18.3094C4.71563 16.275 5.69532 15.1078 6.48282 15.1078C7.01719 15.1078 9.02813 17.9344 9.02813 18.5344C9.02813 18.7641 8.66719 18.9234 8.47969 18.9234C7.725 18.9234 7.42969 18.1969 6.08438 16.5141C4.69219 17.9062 7.04532 20.5875 8.81719 20.5875C10.0406 20.5875 10.8375 19.4531 10.5984 18.6188C10.7719 18.6188 10.9875 18.6328 11.1469 18.5906C11.1984 19.8609 11.5734 21.375 13.1016 21.4828C13.1016 21.4406 13.1953 21.15 13.1953 21.1359C13.1953 20.3203 12.6984 19.6078 12.6984 18.7781C12.6984 17.4516 13.7156 16.1672 14.7469 15.4172C15.1219 15.1359 15.5766 14.9625 16.0172 14.8031C16.4719 14.6297 16.9547 14.4281 17.3016 14.0812C17.25 13.5562 17.0344 13.0922 16.5094 13.0922C15.2109 13.0922 10.8563 13.2797 10.8563 11.2313C10.8563 10.9172 10.8609 10.6172 11.6719 10.6172C13.1859 10.6172 17.0297 10.9922 18.1547 11.9813C19.0031 12.7359 19.2938 17.2875 16.7016 20.1703ZM12.0797 14.2641C12.5344 14.4094 13.0031 14.4516 13.4719 14.5453C13.125 14.7984 12.8156 15.1078 12.5203 15.4406C12.3891 15.0422 12.2297 14.6531 12.0797 14.2641Z"/>
</svg>
`;

const AppleBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.8428 17.1449C20.5101 17.9135 20.1163 18.6211 19.66 19.2715C19.0381 20.1583 18.5288 20.7721 18.1364 21.113C17.528 21.6724 16.8762 21.959 16.1782 21.9753C15.6771 21.9753 15.0728 21.8327 14.3693 21.5434C13.6636 21.2555 13.015 21.113 12.422 21.113C11.8 21.113 11.133 21.2555 10.4195 21.5434C9.70493 21.8327 9.12928 21.9834 8.68916 21.9984C8.01981 22.0269 7.35264 21.7322 6.68668 21.113C6.26164 20.7422 5.72999 20.1067 5.09309 19.2063C4.40976 18.2449 3.84796 17.13 3.40784 15.8589C2.93648 14.486 2.7002 13.1565 2.7002 11.8694C2.7002 10.3951 3.01878 9.12345 3.65689 8.05784C4.1584 7.20191 4.82557 6.52672 5.66059 6.03105C6.49562 5.53539 7.39786 5.2828 8.36949 5.26664C8.90114 5.26664 9.59833 5.43109 10.4647 5.75429C11.3287 6.07858 11.8834 6.24303 12.1266 6.24303C12.3085 6.24303 12.9247 6.05074 13.9694 5.66738C14.9573 5.31186 15.7911 5.16466 16.4742 5.22264C18.3251 5.37202 19.7157 6.10167 20.6405 7.41619C18.9851 8.4192 18.1662 9.82403 18.1825 11.6262C18.1975 13.03 18.7067 14.1981 19.7076 15.1256C20.1611 15.5561 20.6676 15.8888 21.2312 16.1251C21.109 16.4795 20.98 16.819 20.8428 17.1449ZM16.5978 0.440369C16.5978 1.54062 16.1958 2.56792 15.3946 3.51878C14.4277 4.64917 13.2582 5.30236 11.99 5.19929C11.9738 5.06729 11.9645 4.92837 11.9645 4.78239C11.9645 3.72615 12.4243 2.59576 13.2408 1.67152C13.6485 1.20356 14.167 0.814453 14.7957 0.504058C15.4231 0.198295 16.0166 0.0292007 16.5747 0.000244141C16.591 0.147331 16.5978 0.294426 16.5978 0.440355V0.440369Z" fill="black"/>
</svg>
`;

const Apple = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M20.8426 17.1449C20.5099 17.9135 20.1161 18.6211 19.6598 19.2715C19.0379 20.1583 18.5286 20.7721 18.1362 21.113C17.5278 21.6724 16.876 21.959 16.178 21.9753C15.6769 21.9753 15.0726 21.8327 14.3691 21.5434C13.6634 21.2555 13.0148 21.113 12.4218 21.113C11.7998 21.113 11.1328 21.2555 10.4193 21.5434C9.70473 21.8327 9.12909 21.9834 8.68896 21.9984C8.01962 22.0269 7.35244 21.7322 6.68649 21.113C6.26144 20.7422 5.72979 20.1067 5.0929 19.2063C4.40956 18.2449 3.84776 17.13 3.40764 15.8589C2.93629 14.486 2.7 13.1565 2.7 11.8694C2.7 10.3951 3.01858 9.12345 3.65669 8.05784C4.1582 7.20191 4.82537 6.52672 5.6604 6.03105C6.49542 5.53539 7.39766 5.2828 8.3693 5.26664C8.90095 5.26664 9.59813 5.43109 10.4645 5.75429C11.3285 6.07858 11.8832 6.24303 12.1264 6.24303C12.3083 6.24303 12.9245 6.05074 13.9692 5.66738C14.9571 5.31186 15.7909 5.16466 16.474 5.22264C18.3249 5.37202 19.7155 6.10167 20.6403 7.41619C18.9849 8.4192 18.166 9.82403 18.1823 11.6262C18.1973 13.03 18.7065 14.1981 19.7074 15.1256C20.1609 15.5561 20.6674 15.8888 21.231 16.1251C21.1088 16.4795 20.9798 16.819 20.8426 17.1449ZM16.5976 0.440369C16.5976 1.54062 16.1956 2.56792 15.3944 3.51878C14.4275 4.64917 13.258 5.30236 11.9898 5.19929C11.9736 5.06729 11.9643 4.92837 11.9643 4.78239C11.9643 3.72615 12.4241 2.59576 13.2406 1.67152C13.6483 1.20356 14.1668 0.814453 14.7955 0.504058C15.4229 0.198295 16.0164 0.0292007 16.5745 0.000244141C16.5908 0.147331 16.5976 0.294426 16.5976 0.440355V0.440369Z"/>
</svg>
`;

const ArbitrumBrand = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns:xodm="http://www.corel.com/coreldraw/odm/2003" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 2500 2500" style="enable-background:new 0 0 2500 2500;" xml:space="preserve"><script xmlns=""/><script xmlns=""/>
<style type="text/css">
	.st0{fill:none;}
	.st1{fill:#213147;}
	.st2{fill:#12AAFF;}
	.st3{fill:#9DCCED;}
	.st4{fill:#FFFFFF;}
</style>
<g id="Layer_x0020_1">
	<g id="_2405588477232">
		<rect class="st0" width="2500" height="2500"/>
		<g>
			<g>
				<path class="st1" d="M226,760v980c0,63,33,120,88,152l849,490c54,31,121,31,175,0l849-490c54-31,88-89,88-152V760      c0-63-33-120-88-152l-849-490c-54-31-121-31-175,0L314,608c-54,31-87,89-87,152H226z"/>
				<g>
					<g>
						<g>
							<path class="st2" d="M1435,1440l-121,332c-3,9-3,19,0,29l208,571l241-139l-289-793C1467,1422,1442,1422,1435,1440z"/>
						</g>
						<g>
							<path class="st2" d="M1678,882c-7-18-32-18-39,0l-121,332c-3,9-3,19,0,29l341,935l241-139L1678,883V882z"/>
						</g>
					</g>
				</g>
				<g>
					<path class="st3" d="M1250,155c6,0,12,2,17,5l918,530c11,6,17,18,17,30v1060c0,12-7,24-17,30l-918,530c-5,3-11,5-17,5       s-12-2-17-5l-918-530c-11-6-17-18-17-30V719c0-12,7-24,17-30l918-530c5-3,11-5,17-5l0,0V155z M1250,0c-33,0-65,8-95,25L237,555       c-59,34-95,96-95,164v1060c0,68,36,130,95,164l918,530c29,17,62,25,95,25s65-8,95-25l918-530c59-34,95-96,95-164V719       c0-68-36-130-95-164L1344,25c-29-17-62-25-95-25l0,0H1250z"/>
				</g>
				<polygon class="st1" points="642,2179 727,1947 897,2088 738,2234     "/>
				<g>
					<path class="st4" d="M1172,644H939c-17,0-33,11-39,27L401,2039l241,139l550-1507c5-14-5-28-19-28L1172,644z"/>
					<path class="st4" d="M1580,644h-233c-17,0-33,11-39,27L738,2233l241,139l620-1701c5-14-5-28-19-28V644z"/>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>`;

const ArrowCircleBrokenDownLeft = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.00017 9.00001V15M9.00017 15H15.0002M9.00017 15L19 4.99995M21.6606 9.41045C22.5515 12.7466 21.6883 16.4538 19.071 19.0711C15.1658 22.9763 8.83412 22.9763 4.92887 19.0711C1.02363 15.1658 1.02363 8.83418 4.92887 4.92893C7.54616 2.31164 11.2533 1.44846 14.5895 2.33938" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const ArrowCircleDownFilled = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect y="32" width="32" height="32" rx="16" transform="rotate(-90 0 32)" fill="#EBEBEB" />
  <path d="M16 10.1667L16 21.8333M16 21.8333L21.8334 16M16 21.8333L10.1667 16" stroke="#616161" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

const ArrowNarrow = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12H20M20 12L14 6M20 12L14 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Arrow = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M5 12H19M19 12L12 5M19 12L12 19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Asterisk = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V9.58579L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L9.58579 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H9.58579L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L11 14.4142V20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20V14.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L14.4142 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H14.4142L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L13 9.58579V4Z" fill="currentColor"/>
</svg>
`;

const BackupKit = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M20 12C20 16.9084 14.646 20.4784 12.698 21.6149C12.4766 21.744 12.3659 21.8086 12.2097 21.8421C12.0884 21.8681 11.9116 21.8681 11.7903 21.8421C11.6341 21.8086 11.5234 21.744 11.302 21.6149C9.35396 20.4784 4 16.9084 4 12V7.21759C4 6.41808 4 6.01833 4.13076 5.6747C4.24627 5.37113 4.43398 5.10027 4.67766 4.88552C4.95349 4.64243 5.3278 4.50207 6.0764 4.22134L6.0764 4.22134L11.4382 2.21067C11.6461 2.13271 11.75 2.09373 11.857 2.07827C11.9518 2.06457 12.0482 2.06457 12.143 2.07827C12.25 2.09373 12.3539 2.13271 12.5618 2.21067L17.9236 4.22134C18.6722 4.50207 19.0465 4.64243 19.3223 4.88552C19.566 5.10027 19.7537 5.37113 19.8692 5.6747C20 6.01833 20 6.41808 20 7.21759V12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 10.7222C8 10.7222 8.8442 9.65986 9.53004 9.02598C10.2159 8.3921 11.1636 8 12.2105 8C14.3034 8 16 9.567 16 11.5C16 13.433 14.3034 15 12.2105 15C10.8967 15 9.73898 14.3824 9.05918 13.4444M8 10.7222V8.38889M8 10.7222H10.5263" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Bank = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const BaseBrand = `<svg width="111" height="111" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z" fill="#0052FF"/>
</svg>
`;

const Brush = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M20 10V3.6C20 3.03995 20 2.75992 19.891 2.54601C19.7951 2.35785 19.6422 2.20487 19.454 2.10899C19.2401 2 18.9601 2 18.4 2H5.6C5.03995 2 4.75992 2 4.54601 2.10899C4.35785 2.20487 4.20487 2.35785 4.10899 2.54601C4 2.75992 4 3.03995 4 3.6V10M20 10H4M20 10V10.2C20 11.8802 20 12.7202 19.673 13.362C19.3854 13.9265 18.9265 14.3854 18.362 14.673C17.7202 15 16.8802 15 15.2 15H8.8C7.11984 15 6.27976 15 5.63803 14.673C5.07354 14.3854 4.6146 13.9265 4.32698 13.362C4 12.7202 4 11.8802 4 10.2V10M14.5 15V19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5V15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const CeloBrand = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns:xodm="http://www.corel.com/coreldraw/odm/2003" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 2500 2500" style="enable-background:new 0 0 2500 2500;" xml:space="preserve"><script xmlns=""/><script xmlns=""/>
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FCFF52;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;}
</style>
<g id="Layer_x0020_1">
	<g id="_1942792544736">
		<circle class="st0" cx="1250" cy="1250" r="1250"/>
		<path class="st1" d="M1949.3,546.2H550.7v1407.7h1398.7v-491.4h-232.1c-80,179.3-260.1,304.1-466.2,304.1    c-284.1,0-514.2-233.6-514.2-517.5c0-284,230.1-515.6,514.2-515.6c210.1,0,390.2,128.9,470.2,312.1h228.1V546.2z"/>
	</g>
</g>
</svg>`;

const CheckCircleFilled = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="check-circle">
<path id="Solid" fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM17.2071 9.70711C17.5976 9.31658 17.5976 8.68342 17.2071 8.29289C16.8166 7.90237 16.1834 7.90237 15.7929 8.29289L10.5 13.5858L8.20711 11.2929C7.81658 10.9024 7.18342 10.9024 6.79289 11.2929C6.40237 11.6834 6.40237 12.3166 6.79289 12.7071L9.79289 15.7071C10.1834 16.0976 10.8166 16.0976 11.2071 15.7071L17.2071 9.70711Z"/>
</g>
</svg>
`;

const CheckCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const CheckSquare = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Check = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M20 6L9 17L4 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const ChevronDown = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M3.52864 5.52851C3.78899 5.26816 4.2111 5.26816 4.47145 5.52851L8.00004 9.05711L11.5286 5.52851C11.789 5.26816 12.2111 5.26816 12.4714 5.52851C12.7318 5.78886 12.7318 6.21097 12.4714 6.47132L8.47145 10.4713C8.2111 10.7317 7.78899 10.7317 7.52864 10.4713L3.52864 6.47132C3.26829 6.21097 3.26829 5.78886 3.52864 5.52851Z"
    fill="#141414" />
</svg>`;

const ChevronRight = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const ChevronSelectorVertical = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-selector-vertical">
<path id="Icon" d="M7 15L12 20L17 15M7 9L12 4L17 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const ChevronUp = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M18 15L12 9L6 15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Clock = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Close = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"  xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L7 17M7 7L17 17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const ClubhouseBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.74167 17.875C0.783333 17.875 0 18.6583 0 19.6167C0 20.575 0.783333 21.3583 1.74167 21.3583C2.7 21.3583 3.48333 20.575 3.48333 19.6167C3.48333 18.6583 2.70833 17.875 1.74167 17.875Z" fill="#6515DD"/>
<path d="M23.1833 2.66669L12.2166 6.16669V2.70835L0.391602 6.48335V16.5084L10.5916 13.25V16.6917L23.9999 12.4167L20.3666 8.86669L23.1833 2.66669ZM10.5916 11.5334L2.02494 14.2667V7.67502L10.5916 4.94169V11.5334ZM20.9666 11.675L12.2166 14.4667V7.88335L20.2749 5.30835L18.4249 9.20835L20.9666 11.675Z" fill="#6515DD"/>
</svg>
`;

const Clubhouse = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M1.74167 17.875C0.783333 17.875 0 18.6583 0 19.6167C0 20.575 0.783333 21.3583 1.74167 21.3583C2.7 21.3583 3.48333 20.575 3.48333 19.6167C3.48333 18.6583 2.70833 17.875 1.74167 17.875Z"/>
<path d="M23.1833 2.66663L12.2166 6.16663V2.70829L0.391602 6.48329V16.5083L10.5916 13.25V16.6916L23.9999 12.4166L20.3666 8.86663L23.1833 2.66663ZM10.5916 11.5333L2.02494 14.2666V7.67496L10.5916 4.94163V11.5333ZM20.9666 11.675L12.2166 14.4666V7.88329L20.2749 5.30829L18.4249 9.20829L20.9666 11.675Z"/>
</svg>
`;

const Code = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Copy07 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="copy-07">
<path id="Icon" d="M10.5 2.0028C9.82495 2.01194 9.4197 2.05103 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8.05103 3.4197 8.01194 3.82495 8.0028 4.5M19.5 2.0028C20.1751 2.01194 20.5803 2.05103 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C21.949 3.4197 21.9881 3.82494 21.9972 4.49999M21.9972 13.5C21.9881 14.175 21.949 14.5803 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.5803 15.949 20.1751 15.9881 19.5 15.9972M22 7.99999V9.99999M14.0001 2H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const Copy = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Cosmos = `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2500 2500">
  <title>cosmos-atom-logo</title>
  <circle cx="1250" cy="1250" r="1250" style="fill:#2e3148"/>
  <circle cx="1250" cy="1250" r="725.31" style="fill:#1b1e36"/>
  <path d="M1252.57,159.47c-134.93,0-244.34,489.4-244.34,1093.11s109.41,1093.11,244.34,1093.11,244.34-489.4,244.34-1093.11S1387.5,159.47,1252.57,159.47ZM1269.44,2284c-15.43,20.58-30.86,5.14-30.86,5.14-62.14-72-93.21-205.76-93.21-205.76-108.69-349.79-82.82-1100.82-82.82-1100.82,51.08-596.24,144-737.09,175.62-768.36a19.29,19.29,0,0,1,24.74-2c45.88,32.51,84.36,168.47,84.36,168.47,113.63,421.81,103.34,817.9,103.34,817.9,10.29,344.65-56.94,730.45-56.94,730.45C1341.92,2222.22,1269.44,2284,1269.44,2284Z" style="fill:#6f7390"/>
  <path d="M2200.72,708.59c-67.18-117.08-546.09,31.58-1070,332s-893.47,638.89-826.34,755.92,546.09-31.58,1070-332,893.47-638.89,826.34-755.92h0ZM366.36,1780.45c-25.72-3.24-19.91-24.38-19.91-24.38C378,1666.36,478.4,1572.84,478.4,1572.84c249.43-268.36,913.79-619.65,913.79-619.65,542.54-252.42,711.06-241.77,753.81-230a19.29,19.29,0,0,1,14,20.58c-5.14,56-104.17,157-104.17,157C1746.71,1209.36,1398,1397.58,1398,1397.58c-293.83,180.5-661.93,314.09-661.93,314.09-280.09,100.93-369.7,68.78-369.7,68.78h0Z" style="fill:#6f7390"/>
  <path d="M2198.35,1800.41c67.7-116.77-300.93-456.79-823-759.47S374.43,587.76,306.79,704.73s300.93,456.79,823.3,759.47S2130.71,1917.39,2198.35,1800.41ZM351.65,749.85c-10-23.71,11.11-29.42,11.11-29.42C456.22,702.78,587.5,743,587.5,743c357.15,81.33,994,480.25,994,480.25,490.33,343.11,565.53,494.24,576.8,537.14a19.29,19.29,0,0,1-10.7,22.43c-51.13,23.41-188.07-11.47-188.07-11.47-422.07-113.17-759.62-320.52-759.62-320.52-303.29-163.58-603.19-415.28-603.19-415.28-227.88-191.87-245-285.44-245-285.44Z" style="fill:#6f7390"/>
  <circle cx="1250" cy="1250" r="128.6" style="fill:#b7b9c8"/>
  <ellipse cx="1777.26" cy="756.17" rx="74.59" ry="77.16" style="fill:#b7b9c8"/>
  <ellipse cx="552.98" cy="1018.52" rx="74.59" ry="77.16" style="fill:#b7b9c8"/>
  <ellipse cx="1098.25" cy="1965.02" rx="74.59" ry="77.16" style="fill:#b7b9c8"/>
</svg>
`;

const CreditCard02 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="credit-card-02">
<path id="Icon" d="M22 10H2M11 14H6M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const CreditCard = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M22 10H2M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Cube03 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="cube-03">
<path id="Icon" d="M3.5 8H16M16 8V20.5M16 8L20.5 3.5M21 15.3373V3.8C21 3.51997 21 3.37996 20.9455 3.273C20.8976 3.17892 20.8211 3.10243 20.727 3.0545C20.62 3 20.48 3 20.2 3H8.66274C8.41815 3 8.29586 3 8.18077 3.02763C8.07873 3.05213 7.98119 3.09253 7.89172 3.14736C7.7908 3.2092 7.70432 3.29568 7.53137 3.46863L3.46863 7.53137C3.29568 7.70432 3.2092 7.7908 3.14736 7.89172C3.09253 7.98119 3.05213 8.07873 3.02763 8.18077C3 8.29586 3 8.41815 3 8.66274V20.2C3 20.48 3 20.62 3.0545 20.727C3.10243 20.8211 3.17892 20.8976 3.273 20.9455C3.37996 21 3.51997 21 3.8 21H15.3373C15.5818 21 15.7041 21 15.8192 20.9724C15.9213 20.9479 16.0188 20.9075 16.1083 20.8526C16.2092 20.7908 16.2957 20.7043 16.4686 20.5314L20.5314 16.4686C20.7043 16.2957 20.7908 16.2092 20.8526 16.1083C20.9075 16.0188 20.9479 15.9213 20.9724 15.8192C21 15.7041 21 15.5818 21 15.3373Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const CubeOutline = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="cube-outline">
<path id="Icon" d="M9.75 20.75L11.223 21.5683C11.5066 21.7259 11.6484 21.8047 11.7986 21.8356C11.9315 21.8629 12.0685 21.8629 12.2015 21.8356C12.3516 21.8047 12.4934 21.7259 12.777 21.5683L14.25 20.75M5.25 18.25L3.82297 17.4572C3.52346 17.2908 3.37368 17.2076 3.26463 17.0893C3.16816 16.9846 3.09515 16.8605 3.05048 16.7253C3 16.5725 3 16.4012 3 16.0586V14.5M3 9.50002V7.94147C3 7.59883 3 7.42751 3.05048 7.27471C3.09515 7.13953 3.16816 7.01545 3.26463 6.91076C3.37368 6.79242 3.52345 6.70922 3.82297 6.54282L5.25 5.75002M9.75 3.25002L11.223 2.43171C11.5066 2.27415 11.6484 2.19537 11.7986 2.16448C11.9315 2.13715 12.0685 2.13715 12.2015 2.16448C12.3516 2.19537 12.4934 2.27415 12.777 2.43171L14.25 3.25002M18.75 5.75002L20.177 6.54282C20.4766 6.70922 20.6263 6.79242 20.7354 6.91076C20.8318 7.01545 20.9049 7.13953 20.9495 7.27471C21 7.4275 21 7.59883 21 7.94147V9.50002M21 14.5V16.0586C21 16.4012 21 16.5725 20.9495 16.7253C20.9049 16.8605 20.8318 16.9846 20.7354 17.0893C20.6263 17.2076 20.4766 17.2908 20.177 17.4572L18.75 18.25M9.75 10.75L12 12M12 12L14.25 10.75M12 12V14.5M3 7.00002L5.25 8.25002M18.75 8.25002L21 7.00002M12 19.5V22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const Cube = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 8H16M16 8V20.5M16 8L20.5 3.5M21 15.3373V3.8C21 3.51997 21 3.37996 20.9455 3.273C20.8976 3.17892 20.8211 3.10243 20.727 3.0545C20.62 3 20.48 3 20.2 3H8.66274C8.41815 3 8.29586 3 8.18077 3.02763C8.07873 3.05213 7.98119 3.09253 7.89172 3.14736C7.7908 3.2092 7.70432 3.29568 7.53137 3.46863L3.46863 7.53137C3.29568 7.70432 3.2092 7.7908 3.14736 7.89172C3.09253 7.98119 3.05213 8.07873 3.02763 8.18077C3 8.29586 3 8.41815 3 8.66274V20.2C3 20.48 3 20.62 3.0545 20.727C3.10243 20.8211 3.17892 20.8976 3.273 20.9455C3.37996 21 3.51997 21 3.8 21H15.3373C15.5818 21 15.7041 21 15.8192 20.9724C15.9213 20.9479 16.0188 20.9075 16.1083 20.8526C16.2092 20.7908 16.2957 20.7043 16.4686 20.5314L20.5314 16.4686C20.7043 16.2957 20.7908 16.2092 20.8526 16.1083C20.9075 16.0188 20.9479 15.9213 20.9724 15.8192C21 15.7041 21 15.5818 21 15.3373Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const CurrencyDollar = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13 2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2V3H10C7.23858 3 5 5.23858 5 8C5 10.7614 7.23858 13 10 13H11V19H10C8.34315 19 7 17.6569 7 16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16C5 18.7614 7.23858 21 10 21H11V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V21H14C16.7614 21 19 18.7614 19 16C19 13.2386 16.7614 11 14 11H13V5H14C15.6569 5 17 6.34315 17 8C17 8.55228 17.4477 9 18 9C18.5523 9 19 8.55228 19 8C19 5.23858 16.7614 3 14 3H13V2ZM11 5H10C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11H11V5ZM13 13V19H14C15.6569 19 17 17.6569 17 16C17 14.3431 15.6569 13 14 13H13Z" fill="black"/>
</svg>
`;

const DecentBrand = `<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.778 2.78753C14.0232 2.78753 14.984 4.90478 15.5758 6.3203C15.9631 7.2468 16.7703 8.7695 17.7174 9.6841C18.9174 6.8477 19.7749 1e-05 20.9598 0C22.4868 1e-05 25.2514 4.71852 25.2514 10.4107C25.2514 16.1232 22.4888 20.8962 20.96 20.8962C19.7774 20.8962 18.9206 14.0677 17.7252 11.2048C16.773 12.1181 15.9607 13.6496 15.5717 14.58C14.98 15.9955 14.0191 18.1128 12.7739 18.1128C11.5287 18.1128 10.5679 15.9955 9.97612 14.58C9.54017 13.5372 8.57227 11.739 7.47171 10.9028C6.84001 11.4891 6.29866 12.5072 6.04207 13.121C5.65917 14.0369 5.03745 15.4069 4.23174 15.4069C3.42602 15.4069 2.8043 14.0369 2.4214 13.121C2.05134 12.2358 1.07371 10.5066 0.101214 10.4476C0.0674785 10.4496 0.0337325 10.4496 0 10.4476C0.0337143 10.4455 0.0674613 10.4455 0.101214 10.4476C1.07268 10.3887 2.03506 8.6625 2.40511 7.7773C2.78801 6.8614 3.40973 5.4914 4.21545 5.4914C5.02116 5.4914 5.64288 6.8614 6.02578 7.7773C6.28377 8.3944 6.82965 9.4203 7.4658 10.005C8.57048 9.1721 9.5429 7.3663 9.98018 6.3203C10.5719 4.90478 11.5328 2.78753 12.778 2.78753Z" fill="#9969FF"/>
</svg>
`;

const Decent = `<svg width="26" height="21" viewBox="0 0 26 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M12.778 2.78753C14.0232 2.78753 14.984 4.90478 15.5758 6.3203C15.9631 7.2468 16.7703 8.7695 17.7174 9.6841C18.9174 6.8477 19.7749 1e-05 20.9598 0C22.4868 1e-05 25.2514 4.71852 25.2514 10.4107C25.2514 16.1232 22.4888 20.8962 20.96 20.8962C19.7774 20.8962 18.9206 14.0677 17.7252 11.2048C16.773 12.1181 15.9607 13.6496 15.5717 14.58C14.98 15.9955 14.0191 18.1128 12.7739 18.1128C11.5287 18.1128 10.5679 15.9955 9.97612 14.58C9.54017 13.5372 8.57227 11.739 7.47171 10.9028C6.84001 11.4891 6.29866 12.5072 6.04207 13.121C5.65917 14.0369 5.03745 15.4069 4.23174 15.4069C3.42602 15.4069 2.8043 14.0369 2.4214 13.121C2.05134 12.2358 1.07371 10.5066 0.101214 10.4476C0.0674785 10.4496 0.0337325 10.4496 0 10.4476C0.0337143 10.4455 0.0674613 10.4455 0.101214 10.4476C1.07268 10.3887 2.03506 8.6625 2.40511 7.7773C2.78801 6.8614 3.40973 5.4914 4.21545 5.4914C5.02116 5.4914 5.64288 6.8614 6.02578 7.7773C6.28377 8.3944 6.82965 9.4203 7.4658 10.005C8.57048 9.1721 9.5429 7.3663 9.98018 6.3203C10.5719 4.90478 11.5328 2.78753 12.778 2.78753Z" fill="currentColor"/>
</svg>
`;

const Dell = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="svg3794" clip-path="url(#clip0_1570_457)">
<g id="layer1">
<g id="g3460">
<path id="path3462" d="M12.0008 1.3683C9.06597 1.3683 6.40812 2.55872 4.48381 4.4845C2.55875 6.40589 1.36906 9.0652 1.36906 12.0015C1.36906 14.9356 2.55875 17.5931 4.48381 19.5152C6.40812 21.4384 9.06597 22.6311 12.0008 22.6311C14.9364 22.6311 17.5957 21.4384 19.5171 19.5152C21.4414 17.5931 22.6285 14.9356 22.6285 12.0015C22.6285 9.0652 21.4414 6.40589 19.5171 4.4845C17.5957 2.55872 14.9364 1.3683 12.0008 1.3683ZM12.0008 0.0800438C18.5831 0.0800438 23.9201 5.41772 23.9201 12.0015C23.9201 18.5831 18.5831 23.92 12.0008 23.92C5.41922 23.92 0.0800781 18.5831 0.0800781 12.0015C0.0800781 5.41772 5.41922 0.0800438 12.0008 0.0800438Z"/>
</g>
<g id="g3464">
<path id="path3466" d="M6.36322 11.9044C6.36322 11.2097 5.90229 10.8151 5.24974 10.8151H4.85036V12.9944H5.23838C5.84513 12.9944 6.36322 12.6646 6.36322 11.9044ZM13.4673 12.6885L10.5251 15.0052L7.83613 12.8881C7.44812 13.8203 6.51051 14.4677 5.43074 14.4677H3.12939V9.34105H5.43074C6.63728 9.34105 7.50674 10.1083 7.8354 10.9257L10.5251 8.81088L11.5214 9.59497L9.05624 11.5325L9.52999 11.9033L11.9944 9.96686L12.9921 10.7488L10.5273 12.6885L11.0003 13.06L13.4673 11.1199V9.34105H15.2557V12.9713H17.0397V14.4739H13.4673V12.6885ZM19.3051 12.972H21.0884V14.4739H17.5149V9.34105H19.3051V12.972Z"/>
</g>
</g>
</g>
</svg>
`;

const DiscordBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.88806 10.068C9.20406 10.068 8.66406 10.668 8.66406 11.4C8.66406 12.132 9.21606 12.732 9.88806 12.732C10.5721 12.732 11.1121 12.132 11.1121 11.4C11.1241 10.668 10.5721 10.068 9.88806 10.068ZM14.2681 10.068C13.5841 10.068 13.0441 10.668 13.0441 11.4C13.0441 12.132 13.5961 12.732 14.2681 12.732C14.9521 12.732 15.4921 12.132 15.4921 11.4C15.4921 10.668 14.9521 10.068 14.2681 10.068Z" fill="#7289DA"/>
<path d="M20.1001 0H4.02006C2.66406 0 1.56006 1.104 1.56006 2.472V18.696C1.56006 20.064 2.66406 21.168 4.02006 21.168H17.6281L16.9921 18.948L18.5281 20.376L19.9801 21.72L22.5601 24V2.472C22.5601 1.104 21.4561 0 20.1001 0ZM15.4681 15.672C15.4681 15.672 15.0361 15.156 14.6761 14.7C16.2481 14.256 16.8481 13.272 16.8481 13.272C16.3561 13.596 15.8881 13.824 15.4681 13.98C14.8681 14.232 14.2921 14.4 13.7281 14.496C12.5761 14.712 11.5201 14.652 10.6201 14.484C9.93606 14.352 9.34806 14.16 8.85606 13.968C8.58006 13.86 8.28006 13.728 7.98006 13.56C7.94406 13.536 7.90806 13.524 7.87206 13.5C7.84806 13.488 7.83606 13.476 7.82406 13.464C7.60806 13.344 7.48806 13.26 7.48806 13.26C7.48806 13.26 8.06406 14.22 9.58806 14.676C9.22806 15.132 8.78406 15.672 8.78406 15.672C6.13206 15.588 5.12406 13.848 5.12406 13.848C5.12406 9.984 6.85206 6.852 6.85206 6.852C8.58006 5.556 10.2241 5.592 10.2241 5.592L10.3441 5.736C8.18406 6.36 7.18806 7.308 7.18806 7.308C7.18806 7.308 7.45206 7.164 7.89606 6.96C9.18006 6.396 10.2001 6.24 10.6201 6.204C10.6921 6.192 10.7521 6.18 10.8241 6.18C11.5561 6.084 12.3841 6.06 13.2481 6.156C14.3881 6.288 15.6121 6.624 16.8601 7.308C16.8601 7.308 15.9121 6.408 13.8721 5.784L14.0401 5.592C14.0401 5.592 15.6841 5.556 17.4121 6.852C17.4121 6.852 19.1401 9.984 19.1401 13.848C19.1401 13.848 18.1201 15.588 15.4681 15.672Z" fill="#7289DA"/>
</svg>
`;

const Discord = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.88806 10.068C9.20406 10.068 8.66406 10.668 8.66406 11.4C8.66406 12.132 9.21606 12.732 9.88806 12.732C10.5721 12.732 11.1121 12.132 11.1121 11.4C11.1241 10.668 10.5721 10.068 9.88806 10.068ZM14.2681 10.068C13.5841 10.068 13.0441 10.668 13.0441 11.4C13.0441 12.132 13.5961 12.732 14.2681 12.732C14.9521 12.732 15.4921 12.132 15.4921 11.4C15.4921 10.668 14.9521 10.068 14.2681 10.068Z" />
<path d="M20.1001 0H4.02006C2.66406 0 1.56006 1.104 1.56006 2.472V18.696C1.56006 20.064 2.66406 21.168 4.02006 21.168H17.6281L16.9921 18.948L18.5281 20.376L19.9801 21.72L22.5601 24V2.472C22.5601 1.104 21.4561 0 20.1001 0ZM15.4681 15.672C15.4681 15.672 15.0361 15.156 14.6761 14.7C16.2481 14.256 16.8481 13.272 16.8481 13.272C16.3561 13.596 15.8881 13.824 15.4681 13.98C14.8681 14.232 14.2921 14.4 13.7281 14.496C12.5761 14.712 11.5201 14.652 10.6201 14.484C9.93606 14.352 9.34806 14.16 8.85606 13.968C8.58006 13.86 8.28006 13.728 7.98006 13.56C7.94406 13.536 7.90806 13.524 7.87206 13.5C7.84806 13.488 7.83606 13.476 7.82406 13.464C7.60806 13.344 7.48806 13.26 7.48806 13.26C7.48806 13.26 8.06406 14.22 9.58806 14.676C9.22806 15.132 8.78406 15.672 8.78406 15.672C6.13206 15.588 5.12406 13.848 5.12406 13.848C5.12406 9.984 6.85206 6.852 6.85206 6.852C8.58006 5.556 10.2241 5.592 10.2241 5.592L10.3441 5.736C8.18406 6.36 7.18806 7.308 7.18806 7.308C7.18806 7.308 7.45206 7.164 7.89606 6.96C9.18006 6.396 10.2001 6.24 10.6201 6.204C10.6921 6.192 10.7521 6.18 10.8241 6.18C11.5561 6.084 12.3841 6.06 13.2481 6.156C14.3881 6.288 15.6121 6.624 16.8601 7.308C16.8601 7.308 15.9121 6.408 13.8721 5.784L14.0401 5.592C14.0401 5.592 15.6841 5.556 17.4121 6.852C17.4121 6.852 19.1401 9.984 19.1401 13.848C19.1401 13.848 18.1201 15.588 15.4681 15.672Z"/>
</svg>
`;

const Dot = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
<path d="M5 2.5C3.61929 2.5 2.5 3.61929 2.5 5C2.5 6.38071 3.61929 7.5 5 7.5C6.38071 7.5 7.5 6.38071 7.5 5C7.5 3.61929 6.38071 2.5 5 2.5Z"/>
</svg>`;

const Dots = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z"
      stroke="#ADADAD"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`;

const DownloadCloud = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M8 17L12 21M12 21L16 17M12 21V12M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Download = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M8 12.0001L12 16.0001M12 16.0001L16 12.0001M12 16.0001V6.80006C12 5.40935 12 4.714 11.4495 3.93546C11.0837 3.41818 10.0306 2.77974 9.40278 2.69468C8.45789 2.56666 8.09907 2.75384 7.38143 3.1282C4.18333 4.79649 2 8.14331 2 12.0001C2 17.5229 6.47715 22.0001 12 22.0001C17.5228 22.0001 22 17.5229 22 12.0001C22 8.29865 19.989 5.06693 17 3.33788" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const DribbbleBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57969 18.4203 0.375 12 0.375C5.57969 0.375 0.375 5.57969 0.375 12C0.375 18.4203 5.57969 23.625 12 23.625Z" fill="#EA4C89"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.37527 0 0 5.37527 0 12C0 18.6248 5.37527 24 12 24C18.6117 24 24 18.6248 24 12C24 5.37527 18.6117 0 12 0ZM19.9262 5.53145C21.3579 7.27549 22.217 9.50107 22.243 11.9089C21.9046 11.8439 18.5206 11.154 15.1106 11.5835C15.0325 11.4143 14.9675 11.2321 14.8894 11.0499C14.6811 10.5554 14.4469 10.0477 14.2126 9.56618C17.9869 8.0304 19.705 5.81779 19.9262 5.53145ZM12 1.77007C14.603 1.77007 16.9848 2.74621 18.7939 4.34707C18.6117 4.60738 17.0629 6.67679 13.4186 8.04338C11.7397 4.95878 9.87855 2.43384 9.5922 2.04338C10.3601 1.86117 11.1671 1.77007 12 1.77007ZM7.63995 2.73319C7.91325 3.09761 9.73538 5.63558 11.4404 8.65508C6.65076 9.9306 2.42083 9.90458 1.96529 9.90458C2.62907 6.72885 4.77657 4.08676 7.63995 2.73319ZM1.74404 12.0131C1.74404 11.9089 1.74404 11.8048 1.74404 11.7007C2.18655 11.7136 7.15835 11.7787 12.2733 10.243C12.5727 10.8156 12.846 11.4013 13.1063 11.9869C12.9761 12.026 12.8329 12.0651 12.7028 12.1041C7.41865 13.8091 4.60738 18.4685 4.3731 18.859C2.7462 17.0499 1.74404 14.6421 1.74404 12.0131ZM12 22.256C9.6312 22.256 7.44469 21.449 5.71367 20.0954C5.89588 19.718 7.97827 15.7094 13.757 13.692C13.783 13.679 13.7961 13.679 13.8221 13.666C15.2668 17.4013 15.8525 20.5379 16.0087 21.436C14.7722 21.9696 13.4186 22.256 12 22.256ZM17.7136 20.4989C17.6096 19.8742 17.0629 16.8807 15.7223 13.1974C18.9371 12.6898 21.7484 13.5228 22.0998 13.6399C21.6573 16.4902 20.0173 18.9501 17.7136 20.4989Z" fill="#C32361"/>
</svg>
`;

const Dribbble = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.37527 0 0 5.37527 0 12C0 18.6248 5.37527 24 12 24C18.6117 24 24 18.6248 24 12C24 5.37527 18.6117 0 12 0ZM19.9262 5.53145C21.3579 7.27549 22.217 9.50107 22.243 11.9089C21.9046 11.8439 18.5206 11.154 15.1106 11.5835C15.0325 11.4143 14.9675 11.2321 14.8894 11.0499C14.6811 10.5554 14.4469 10.0477 14.2126 9.56618C17.9869 8.0304 19.705 5.81779 19.9262 5.53145ZM12 1.77007C14.603 1.77007 16.9848 2.74621 18.7939 4.34707C18.6117 4.60738 17.0629 6.67679 13.4186 8.04338C11.7397 4.95878 9.87855 2.43384 9.5922 2.04338C10.3601 1.86117 11.1671 1.77007 12 1.77007ZM7.63995 2.73319C7.91325 3.09761 9.73538 5.63558 11.4404 8.65508C6.65076 9.9306 2.42083 9.90458 1.96529 9.90458C2.62907 6.72885 4.77657 4.08676 7.63995 2.73319ZM1.74404 12.0131C1.74404 11.9089 1.74404 11.8048 1.74404 11.7007C2.18655 11.7136 7.15835 11.7787 12.2733 10.243C12.5727 10.8156 12.846 11.4013 13.1063 11.9869C12.9761 12.026 12.8329 12.0651 12.7028 12.1041C7.41865 13.8091 4.60738 18.4685 4.3731 18.859C2.7462 17.0499 1.74404 14.6421 1.74404 12.0131ZM12 22.256C9.6312 22.256 7.44469 21.449 5.71367 20.0954C5.89588 19.718 7.97827 15.7094 13.757 13.692C13.783 13.679 13.7961 13.679 13.8221 13.666C15.2668 17.4013 15.8525 20.5379 16.0087 21.436C14.7722 21.9696 13.4186 22.256 12 22.256ZM17.7136 20.4989C17.6096 19.8742 17.0629 16.8807 15.7223 13.1974C18.9371 12.6898 21.7484 13.5228 22.0998 13.6399C21.6573 16.4902 20.0173 18.9501 17.7136 20.4989Z" />
</svg>
`;

const Earth = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4250)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C18.627 0 24 5.37305 24 12C24 18.627 18.627 24 12 24C5.37305 24 0 18.627 0 12C0 5.37305 5.37305 0 12 0Z" fill="#2394E0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.297 18.1992C1.58997 17.127 1.06067 15.9258 0.750122 14.6387L2.8634 15.6582L2.87512 16.2891C2.87512 16.5215 2.48059 17.0137 2.35364 17.2012L2.297 18.1992ZM15.295 1.26953C19.3224 2.60742 22.3439 6.15234 22.9259 10.4688L22.545 10.4277C22.4767 10.7207 22.4142 10.7266 22.4142 11.0781C22.4142 11.3887 22.8048 11.5957 22.8048 12.25C22.8048 12.4258 22.3927 12.7754 22.3751 12.8379L21.7638 12.1211V13.0332L21.672 13.0293L21.5079 11.3457L21.1661 11.4531L20.7599 10.2012L19.422 11.5996L19.4064 12.623L18.9689 12.916L18.504 10.291L18.2267 10.4941L17.5978 9.64453L16.6583 9.67188L16.299 9.25977L15.9298 9.36133L15.2052 8.53125L15.0646 8.62695L15.5138 9.77539H16.0353V9.51563H16.295C16.4825 10.0352 16.6857 9.72656 16.6857 10.0371C16.6857 11.1211 15.3478 11.918 14.4708 12.1211C14.5177 12.3164 14.5001 12.5117 14.7306 12.5117C15.2208 12.5117 14.9767 12.4258 15.5118 12.3809C15.4865 13.4883 14.2423 14.8105 13.7111 15.6328L13.9493 17.3301C14.0118 17.6992 13.1837 18.0879 12.9025 18.5039L13.0372 19.1543L12.6564 19.3086C12.59 19.9766 11.9415 20.7168 11.213 20.7168H10.4318C10.4318 19.8027 9.77942 18.4961 9.77942 17.8496C9.77942 17.3008 10.0392 17.2266 10.0392 16.5469C10.0392 15.918 9.38879 15.0176 9.38879 14.8535V13.8105H8.86731C8.78918 13.5195 8.83801 13.4199 8.47669 13.4199H8.34583C7.77747 13.4199 7.87317 13.6797 7.30286 13.6797H6.78137C6.31067 13.6797 5.47864 12.1719 5.47864 11.9863V10.4238C5.47864 9.75 6.09583 9.01562 6.52161 8.73047V8.08008L7.10754 7.48438L7.43372 7.42969C8.13293 7.42969 8.04895 7.03906 8.47669 7.03906H9.64856V7.95117L10.9376 8.50195L11.0587 7.94531C11.6427 8.08203 11.795 8.3418 12.5138 8.3418H12.7736C13.2677 8.3418 13.295 7.68555 13.295 7.16992L12.2521 7.27344L11.797 6.28516L11.3458 6.4043C11.4279 6.75781 11.4708 6.61133 11.4708 6.91016C11.4708 7.08594 11.3263 7.10547 11.2091 7.16992L10.7579 6.02539L9.78723 5.33203L9.65833 5.45898L10.4845 6.32812C10.3751 6.64062 10.3615 7.54102 9.90637 6.91016L10.3322 6.70508L9.26965 5.5918L8.63293 5.83984L8.00403 6.44141C7.93762 6.92578 7.80676 7.16992 7.29895 7.16992C6.96106 7.16992 7.16418 7.08203 6.64661 7.03906V5.73633H7.81848L7.43762 4.86914L7.297 4.95508V4.69336L9.20129 3.81641C9.16614 3.54297 9.12122 3.68945 9.12122 3.39062C9.12122 3.37305 9.24817 3.13281 9.25208 3.12891L9.74426 3.43555L9.62708 2.875L8.86731 3.03125L8.72668 2.34961C9.32825 2.0332 10.6544 0.916016 11.0763 0.916016H11.4669C11.879 0.916016 12.9806 1.32227 13.1603 1.56641L12.1154 1.46094L12.8907 2.09961L12.965 1.82617L13.5431 1.66797L13.5509 1.30664H13.8126V1.69727L15.295 1.26953Z" fill="#A1E367"/>
</g>
<defs>
<clipPath id="clip0_2087_4250">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Edit02 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="edit-02">
<path id="Icon" d="M18 10.0001L14 6.00006M2.5 21.5001L5.88437 21.124C6.29786 21.0781 6.5046 21.0551 6.69785 20.9925C6.86929 20.937 7.03245 20.8586 7.18289 20.7594C7.35245 20.6476 7.49955 20.5005 7.79373 20.2063L21 7.00006C22.1046 5.89549 22.1046 4.10463 21 3.00006C19.8955 1.89549 18.1046 1.89549 17 3.00006L3.79373 16.2063C3.49955 16.5005 3.35246 16.6476 3.24064 16.8172C3.14143 16.9676 3.06301 17.1308 3.00751 17.3022C2.94496 17.4955 2.92198 17.7022 2.87604 18.1157L2.5 21.5001Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const EmptyCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C12.5917 2 13.1713 2.05139 13.7348 2.14994M17.738 3.809C18.6922 4.47869 19.5241 5.31089 20.1934 6.26541M21.8501 10.2656C21.9486 10.8289 22 11.4085 22 12C22 12.5915 21.9486 13.1711 21.8501 13.7344M20.1892 17.7406C19.5203 18.693 18.6896 19.5233 17.7369 20.1917M13.7328 21.8504C13.17 21.9487 12.591 22 12 22" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 22C11.4083 22 10.8287 21.9486 10.2652 21.8501M6.26201 20.191C5.30778 19.5213 4.47592 18.6891 3.80662 17.7346M2.14986 13.7344C2.05136 13.1711 2 12.5915 2 12C2 11.4085 2.05136 10.8289 2.14986 10.2656M3.81084 6.25939C4.47967 5.30704 5.31041 4.47667 6.26306 3.80826M10.2672 2.14959C10.83 2.05126 11.409 2 12 2" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Ethereum = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M15 9.99996L10 13.3333L5 9.99996L10 1.66663L15 9.99996Z" fill="black"/>
  <path d="M10 14.1666L5 10.8333L10 18.3333L15 10.8333L10 14.1666Z" fill="black"/>
</svg>
`;

const EyeOff = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Eye = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const FacebookBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21158)">
<path d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z" fill="#1877F2"/>
<path d="M16.6711 15.4688L17.2031 12H13.875V9.75C13.875 8.80102 14.34 7.875 15.8306 7.875H17.3438V4.92188C17.3438 4.92188 15.9705 4.6875 14.6576 4.6875C11.9166 4.6875 10.125 6.34875 10.125 9.35625V12H7.07812V15.4688H10.125V23.8542C11.3674 24.0486 12.6326 24.0486 13.875 23.8542V15.4688H16.6711Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_106_21158">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Facebook = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21329)">
<path d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z" />
</g>
<defs>
<clipPath id="clip0_106_21329">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FarcasterBrand = `<svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2332_9702)">
<path d="M5.50705 0.0720215H26.0971V4.16702H31.9521L30.7251 8.26302H29.6861V24.833C30.2071 24.833 30.6301 25.249 30.6301 25.763V26.88H30.8191C31.3411 26.88 31.7641 27.297 31.7641 27.811V28.928H21.1851V27.811C21.1851 27.297 21.6081 26.88 22.1301 26.88H22.3191V25.763C22.3191 25.316 22.6391 24.943 23.0651 24.853L23.0451 15.71C22.7111 12.057 19.5961 9.19402 15.8021 9.19402C12.0081 9.19402 8.89305 12.057 8.55905 15.71L8.53905 24.845C9.04305 24.919 9.66305 25.302 9.66305 25.763V26.88H9.85205C10.3731 26.88 10.7961 27.297 10.7961 27.811V28.928H0.218053V27.811C0.218053 27.297 0.641053 26.88 1.16205 26.88H1.35105V25.763C1.35105 25.249 1.77405 24.833 2.29605 24.833V8.26302H1.25705L0.0290527 4.16702H5.50705V0.0720215Z" fill="#8A63D2"/>
</g>
<defs>
<clipPath id="clip0_2332_9702">
<rect width="32" height="29" fill="white"/>
</clipPath>
</defs>
</svg>`;

const Farcaster = `<svg width="32" height="29" viewBox="0 0 32 29" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2332_9702)">
<path d="M5.50705 0.0720215H26.0971V4.16702H31.9521L30.7251 8.26302H29.6861V24.833C30.2071 24.833 30.6301 25.249 30.6301 25.763V26.88H30.8191C31.3411 26.88 31.7641 27.297 31.7641 27.811V28.928H21.1851V27.811C21.1851 27.297 21.6081 26.88 22.1301 26.88H22.3191V25.763C22.3191 25.316 22.6391 24.943 23.0651 24.853L23.0451 15.71C22.7111 12.057 19.5961 9.19402 15.8021 9.19402C12.0081 9.19402 8.89305 12.057 8.55905 15.71L8.53905 24.845C9.04305 24.919 9.66305 25.302 9.66305 25.763V26.88H9.85205C10.3731 26.88 10.7961 27.297 10.7961 27.811V28.928H0.218053V27.811C0.218053 27.297 0.641053 26.88 1.16205 26.88H1.35105V25.763C1.35105 25.249 1.77405 24.833 2.29605 24.833V8.26302H1.25705L0.0290527 4.16702H5.50705V0.0720215Z"/>
</g>
<defs>
<clipPath id="clip0_2332_9702">
<rect width="32" height="29" fill="white"/>
</clipPath>
</defs>
</svg>`;

const FigmaBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21188)">
<path d="M8.00006 24C10.2081 24 12.0001 22.208 12.0001 20V15.9999H8.00006C5.79205 15.9999 4 17.792 4 20C4 22.208 5.79205 24 8.00006 24Z" fill="#0ACF83"/>
<path d="M4 12C4 9.79197 5.79205 7.99994 8.00006 7.99994H12.0001V15.9999H8.00006C5.79205 16 4 14.208 4 12Z" fill="#A259FF"/>
<path d="M4 4.00003C4 1.79203 5.79205 0 8.00006 0H12.0001V7.99997H8.00006C5.79205 7.99997 4 6.20803 4 4.00003Z" fill="#F24E1E"/>
<path d="M12 0H16.0001C18.2081 0 20.0001 1.79203 20.0001 4.00003C20.0001 6.20803 18.2081 7.99997 16.0001 7.99997H12V0Z" fill="#FF7262"/>
<path d="M20.0001 12C20.0001 14.208 18.2081 16 16.0001 16C13.792 16 12 14.208 12 12C12 9.79197 13.792 7.99994 16.0001 7.99994C18.2081 7.99994 20.0001 9.79197 20.0001 12Z" fill="#1ABCFE"/>
</g>
<defs>
<clipPath id="clip0_106_21188">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Figma = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 2C7.51349 2 6.81155 2.28629 6.29747 2.78895C5.78414 3.29087 5.5 3.96677 5.5 4.66667C5.5 5.36657 5.78414 6.04247 6.29747 6.54438C6.81155 7.04705 7.51349 7.33333 8.25 7.33333H11V2H8.25ZM13 2V7.33333H15.75C16.1142 7.33333 16.4744 7.26316 16.8097 7.12736C17.145 6.99157 17.4482 6.79311 17.7025 6.54438C17.9569 6.29571 18.1574 6.00171 18.2938 5.67977C18.4301 5.35788 18.5 5.0137 18.5 4.66667C18.5 4.31964 18.4301 3.97545 18.2938 3.65356C18.1574 3.33162 17.9569 3.03763 17.7025 2.78895C17.4482 2.54022 17.145 2.34177 16.8097 2.20598C16.4744 2.07017 16.1142 2 15.75 2H13ZM18.6884 8.33334C18.8324 8.22191 18.9702 8.10211 19.1008 7.9744C19.5429 7.54211 19.8948 7.02769 20.1353 6.45991C20.3759 5.89208 20.5 5.28266 20.5 4.66667C20.5 4.05067 20.3759 3.44126 20.1353 2.87342C19.8948 2.30564 19.5429 1.79122 19.1008 1.35894C18.6587 0.926696 18.1351 0.584984 17.5605 0.352241C16.9858 0.119512 16.3707 0 15.75 0H8.25C6.99738 0 5.79167 0.486331 4.89923 1.35894C4.00603 2.23228 3.5 3.42165 3.5 4.66667C3.5 5.91169 4.00603 7.10105 4.89923 7.9744C5.03021 8.10247 5.16794 8.22222 5.31158 8.33333C5.16794 8.44445 5.03021 8.5642 4.89923 8.69227C4.00603 9.56562 3.5 10.755 3.5 12C3.5 13.245 4.00603 14.4344 4.89923 15.3077C5.03022 15.4358 5.16795 15.5556 5.31159 15.6667C5.16795 15.7778 5.03022 15.8975 4.89923 16.0256C4.00603 16.899 3.5 18.0883 3.5 19.3333C3.5 20.5784 4.00603 21.7677 4.89923 22.6411C5.79167 23.5137 6.99738 24 8.25 24C9.5026 24 10.7083 23.5137 11.6008 22.6411C12.494 21.7677 13 20.5784 13 19.3333V15.8051C13.2922 16.0089 13.6073 16.1799 13.9395 16.3144C14.5142 16.5472 15.1293 16.6667 15.75 16.6667C16.3707 16.6667 16.9858 16.5472 17.5605 16.3144C18.1351 16.0817 18.6587 15.74 19.1008 15.3077C19.5429 14.8754 19.8948 14.361 20.1353 13.7932C20.3759 13.2254 20.5 12.616 20.5 12C20.5 11.384 20.3759 10.7746 20.1353 10.2068C19.8948 9.63898 19.5429 9.12456 19.1008 8.69227C18.9702 8.56456 18.8324 8.44476 18.6884 8.33334ZM11 14.6667V9.33333H8.25C7.51349 9.33333 6.81155 9.61962 6.29747 10.1223C5.78414 10.6242 5.5 11.3001 5.5 12C5.5 12.6999 5.78414 13.3758 6.29747 13.8777C6.81155 14.3804 7.51349 14.6667 8.25 14.6667H11ZM11 16.6667H8.25C7.51349 16.6667 6.81155 16.953 6.29747 17.4556C5.78414 17.9575 5.5 18.6334 5.5 19.3333C5.5 20.0332 5.78414 20.7091 6.29747 21.2111C6.81155 21.7137 7.51349 22 8.25 22C8.98651 22 9.6884 21.7137 10.2025 21.2111C10.7159 20.7091 11 20.0332 11 19.3333V16.6667ZM15.75 9.33333C15.3858 9.33333 15.0256 9.4035 14.6903 9.53931C14.355 9.6751 14.0518 9.87356 13.7975 10.1223C13.5431 10.371 13.3426 10.665 13.2062 10.9869C13.0699 11.3088 13 11.653 13 12C13 12.347 13.0699 12.6912 13.2062 13.0131C13.3426 13.335 13.5431 13.629 13.7975 13.8777C14.0518 14.1264 14.355 14.3249 14.6903 14.4607C15.0256 14.5965 15.3858 14.6667 15.75 14.6667C16.1142 14.6667 16.4744 14.5965 16.8097 14.4607C17.145 14.3249 17.4482 14.1264 17.7025 13.8777C17.9569 13.629 18.1574 13.335 18.2938 13.0131C18.4301 12.6912 18.5 12.347 18.5 12C18.5 11.653 18.4301 11.3088 18.2938 10.9869C18.1574 10.665 17.9569 10.371 17.7025 10.1223C17.4482 9.87356 17.145 9.6751 16.8097 9.53931C16.4744 9.4035 16.1142 9.33333 15.75 9.33333Z" />
</svg>
`;

const File = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M14 2.26946V6.4C14 6.96005 14 7.24008 14.109 7.45399C14.2049 7.64215 14.3578 7.79513 14.546 7.89101C14.7599 8 15.0399 8 15.6 8H19.7305M20 9.98822V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H12.0118C12.7455 2 13.1124 2 13.4577 2.08289C13.7638 2.15638 14.0564 2.27759 14.3249 2.44208C14.6276 2.6276 14.887 2.88703 15.4059 3.40589L18.5941 6.59411C19.113 7.11297 19.3724 7.3724 19.5579 7.67515C19.7224 7.94356 19.8436 8.2362 19.9171 8.5423C20 8.88757 20 9.25445 20 9.98822Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Folder = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="folder">
<path id="Icon" d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const GithubBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21439)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.3724 0 0 5.3808 0 12.0204C0 17.3304 3.438 21.8364 8.2068 23.4252C8.8068 23.5356 9.0252 23.1648 9.0252 22.8456C9.0252 22.5612 9.0156 21.804 9.0096 20.802C5.6712 21.528 4.9668 19.1904 4.9668 19.1904C4.422 17.8008 3.6348 17.4312 3.6348 17.4312C2.5452 16.6872 3.7176 16.7016 3.7176 16.7016C4.9212 16.7856 5.5548 17.94 5.5548 17.94C6.6252 19.776 8.364 19.2456 9.0468 18.9384C9.1572 18.162 9.4668 17.6328 9.81 17.3328C7.146 17.0292 4.344 15.9972 4.344 11.3916C4.344 10.08 4.812 9.006 5.5788 8.166C5.4552 7.8624 5.0436 6.6396 5.6964 4.986C5.6964 4.986 6.7044 4.662 8.9964 6.2172C9.97532 5.95022 10.9853 5.81423 12 5.8128C13.02 5.8176 14.046 5.9508 15.0048 6.2172C17.2956 4.662 18.3012 4.9848 18.3012 4.9848C18.9564 6.6396 18.5436 7.8624 18.4212 8.166C19.1892 9.006 19.6548 10.08 19.6548 11.3916C19.6548 16.0092 16.848 17.0256 14.1756 17.3232C14.6064 17.694 14.9892 18.4272 14.9892 19.5492C14.9892 21.1548 14.9748 22.452 14.9748 22.8456C14.9748 23.1672 15.1908 23.5416 15.8004 23.424C18.19 22.6225 20.2672 21.0904 21.7386 19.0441C23.2099 16.9977 24.001 14.5408 24 12.0204C24 5.3808 18.6264 0 12 0Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_106_21439">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Github = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21435)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.3724 0 0 5.3808 0 12.0204C0 17.3304 3.438 21.8364 8.2068 23.4252C8.8068 23.5356 9.0252 23.1648 9.0252 22.8456C9.0252 22.5612 9.0156 21.804 9.0096 20.802C5.6712 21.528 4.9668 19.1904 4.9668 19.1904C4.422 17.8008 3.6348 17.4312 3.6348 17.4312C2.5452 16.6872 3.7176 16.7016 3.7176 16.7016C4.9212 16.7856 5.5548 17.94 5.5548 17.94C6.6252 19.776 8.364 19.2456 9.0468 18.9384C9.1572 18.162 9.4668 17.6328 9.81 17.3328C7.146 17.0292 4.344 15.9972 4.344 11.3916C4.344 10.08 4.812 9.006 5.5788 8.166C5.4552 7.8624 5.0436 6.6396 5.6964 4.986C5.6964 4.986 6.7044 4.662 8.9964 6.2172C9.97532 5.95022 10.9853 5.81423 12 5.8128C13.02 5.8176 14.046 5.9508 15.0048 6.2172C17.2956 4.662 18.3012 4.9848 18.3012 4.9848C18.9564 6.6396 18.5436 7.8624 18.4212 8.166C19.1892 9.006 19.6548 10.08 19.6548 11.3916C19.6548 16.0092 16.848 17.0256 14.1756 17.3232C14.6064 17.694 14.9892 18.4272 14.9892 19.5492C14.9892 21.1548 14.9748 22.452 14.9748 22.8456C14.9748 23.1672 15.1908 23.5416 15.8004 23.424C18.19 22.6225 20.2672 21.0904 21.7386 19.0441C23.2099 16.9977 24.001 14.5408 24 12.0204C24 5.3808 18.6264 0 12 0Z" />
</g>
<defs>
<clipPath id="clip0_106_21435">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Globe = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2 12H22M2 12C2 17.5228 6.47715 22 12 22M2 12C2 6.47715 6.47715 2 12 2M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22M12 2C9.49872 4.73835 8.07725 8.29203 8 12C8.07725 15.708 9.49872 19.2616 12 22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const GoogleBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21172)">
<path d="M23.7663 12.2764C23.7663 11.4607 23.7001 10.6406 23.559 9.83807H12.2402V14.4591H18.722C18.453 15.9494 17.5888 17.2678 16.3233 18.1056V21.1039H20.1903C22.4611 19.0139 23.7663 15.9274 23.7663 12.2764Z" fill="#4285F4"/>
<path d="M12.24 24.0008C15.4764 24.0008 18.2058 22.9382 20.1944 21.1039L16.3274 18.1055C15.2516 18.8375 13.8626 19.252 12.2444 19.252C9.11376 19.252 6.45934 17.1399 5.50693 14.3003H1.51648V17.3912C3.55359 21.4434 7.70278 24.0008 12.24 24.0008Z" fill="#34A853"/>
<path d="M5.50277 14.3003C5.00011 12.8099 5.00011 11.1961 5.50277 9.70575V6.61481H1.51674C-0.185266 10.0056 -0.185266 14.0004 1.51674 17.3912L5.50277 14.3003Z" fill="#FBBC04"/>
<path d="M12.24 4.74966C13.9508 4.7232 15.6043 5.36697 16.8433 6.54867L20.2694 3.12262C18.1 1.0855 15.2207 -0.034466 12.24 0.000808666C7.70277 0.000808666 3.55359 2.55822 1.51648 6.61481L5.50252 9.70575C6.45052 6.86173 9.10935 4.74966 12.24 4.74966Z" fill="#EA4335"/>
</g>
<defs>
<clipPath id="clip0_106_21172">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Google = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21357)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.8424 6.54781C15.6034 5.36611 13.9499 4.72235 12.239 4.74881C9.10842 4.74881 6.4496 6.86086 5.50158 9.70486V9.70493C4.99892 11.1953 4.99892 12.8091 5.50158 14.2994H5.50598C6.4584 17.139 9.11282 19.2511 12.2434 19.2511C13.8595 19.2511 15.2468 18.8378 16.3221 18.1077V18.1047C17.5876 17.2669 18.4518 15.9486 18.7208 14.4582H12.239V9.83722H23.5578C23.6989 10.6397 23.7651 11.4599 23.7651 12.2756C23.7651 15.9254 22.4607 19.0112 20.1911 21.1012L20.1935 21.103C18.2049 22.9373 15.4755 24 12.239 24C7.70183 24 3.55265 21.4426 1.51553 17.3904V17.3904C-0.186456 13.9996 -0.186452 10.0048 1.51555 6.61398H1.51557L1.51553 6.61395C3.55265 2.55737 7.70183 -4.58262e-05 12.239 -4.58262e-05C15.2197 -0.0353205 18.099 1.08465 20.2684 3.12176L16.8424 6.54781Z" />
</g>
<defs>
<clipPath id="clip0_106_21357">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GridDots = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const HelpCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const HeroAlertCircle = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" >
<path d="M32.0002 21.3333V32M32.0002 42.6667H32.0268M58.6668 32C58.6668 46.7276 46.7278 58.6667 32.0002 58.6667C17.2726 58.6667 5.3335 46.7276 5.3335 32C5.3335 17.2724 17.2726 5.33333 32.0002 5.33333C46.7278 5.33333 58.6668 17.2724 58.6668 32Z" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const HeroCheckmarkCapsule = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M55.219 14.1144C56.2604 15.1558 56.2604 16.8442 55.219 17.8856L25.8856 47.2189C24.8442 48.2603 23.1558 48.2603 22.1144 47.2189L8.78105 33.8856C7.73965 32.8442 7.73965 31.1558 8.78105 30.1144C9.82245 29.073 11.5109 29.073 12.5523 30.1144L24 41.5621L51.4477 14.1144C52.4891 13.073 54.1776 13.073 55.219 14.1144Z" fill="url(#paint0_linear_887_2080)"/>
<defs>
<linearGradient id="paint0_linear_887_2080" x1="56" y1="30.6667" x2="8" y2="30.6667" gradientUnits="userSpaceOnUse">
<stop stop-color="#BC82F3"/>
<stop offset="0.485" stop-color="#FF6778"/>
<stop offset="1" stop-color="#FFBA71"/>
</linearGradient>
</defs>
</svg>
  `;

const HeroCheckmark = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="currentColor">
<path fill-rule="evenodd" clip-rule="evenodd" d="M55.219 14.1144C56.2604 15.1558 56.2604 16.8442 55.219 17.8856L25.8856 47.2189C24.8442 48.2603 23.1558 48.2603 22.1144 47.2189L8.78105 33.8856C7.73965 32.8442 7.73965 31.1558 8.78105 30.1144C9.82245 29.073 11.5109 29.073 12.5523 30.1144L24 41.5621L51.4477 14.1144C52.4891 13.073 54.1776 13.073 55.219 14.1144Z"/>
</svg>`;

const HeroEmail = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<g clip-path="url(#clip0_1824_12406)">
<path d="M32 45.5L0 27L32 12L64 27L32 45.5Z" class="background-16"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 0H51C53.2091 0 55 1.79086 55 4V51C55 53.2091 53.2091 55 51 55H13C10.7909 55 9 53.2091 9 51V4C9 1.79086 10.7909 0 13 0ZM24.6852 23.8262C24.1488 23.2803 24.1351 22.3834 24.1216 21.5039C24.1121 20.8824 24.1027 20.2696 23.909 19.7957C23.7141 19.3188 23.2892 18.8665 22.86 18.4095C22.2593 17.77 21.6499 17.1213 21.6499 16.383C21.6499 15.6495 22.2446 15.0181 22.8397 14.3862L22.8397 14.3862C23.2717 13.9275 23.7039 13.4686 23.909 12.9702C24.1136 12.4732 24.122 11.8477 24.1304 11.2204C24.1421 10.3523 24.1538 9.48056 24.6852 8.93975C25.2217 8.39388 26.1032 8.3799 26.9674 8.36619C27.5782 8.3565 28.1804 8.34695 28.6461 8.14986C29.1148 7.9515 29.5593 7.51919 30.0084 7.08239C30.6368 6.47113 31.2744 5.85107 31.9999 5.85107C32.7207 5.85107 33.3412 6.4562 33.9622 7.06176C34.413 7.50135 34.864 7.94115 35.3537 8.14986C35.8422 8.35804 36.4568 8.36659 37.0733 8.37516C37.9264 8.38703 38.7831 8.39895 39.3146 8.93975C39.851 9.48562 39.8647 10.3826 39.8782 11.262C39.8877 11.8836 39.8971 12.4964 40.0908 12.9702C40.2858 13.4472 40.7106 13.8994 41.1398 14.3564C41.7406 14.996 42.3499 15.6447 42.3499 16.383C42.3499 17.1164 41.7552 17.7479 41.1601 18.3798C40.7281 18.8385 40.2959 19.2974 40.0908 19.7957C39.8862 20.2928 39.8778 20.9182 39.8694 21.5456C39.8577 22.4136 39.846 23.2854 39.3146 23.8262C38.7781 24.3721 37.8966 24.3861 37.0324 24.3998C36.4216 24.4095 35.8194 24.419 35.3537 24.6161C34.885 24.8145 34.4405 25.2468 33.9914 25.6836C33.363 26.2948 32.7254 26.9149 31.9999 26.9149C31.2791 26.9149 30.6586 26.3098 30.0376 25.7042C29.5868 25.2646 29.1358 24.8248 28.6461 24.6161C28.1576 24.4079 27.543 24.3994 26.9265 24.3908C26.0734 24.3789 25.2167 24.367 24.6852 23.8262ZM37.4391 13.2424C37.8733 13.7141 37.8496 14.4546 37.3862 14.8965L31.2494 20.7476C30.8068 21.1695 30.1183 21.1692 29.6761 20.7469L26.6129 17.8213C26.1498 17.3791 26.1267 16.6385 26.5614 16.1672C26.996 15.696 27.7238 15.6725 28.1869 16.1148L30.4637 18.2894L35.8136 13.1886C36.2771 12.7467 37.0048 12.7708 37.4391 13.2424Z" class="foreground-0" opacity="0.95"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32 45.5045L0 27.009V64H2.86102e-05H64L64 27.009L32 45.5045Z" class="background-16"/>
</g>
<defs>
<clipPath id="clip0_1824_12406">
<rect width="64" height="64" fill="white"/>
</clipPath>
</defs>
</svg>`;

const HeroExternalConnection = `<svg width="121" height="121" viewBox="0 0 121 121" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_757_7415)">
<g opacity="0.2" filter="url(#filter0_f_757_7415)">
<ellipse cx="-1.16699" cy="-7.49935" rx="45" ry="42.6667" class="accent-0"/>
</g>
<g opacity="0.2" filter="url(#filter1_f_757_7415)">
<ellipse cx="144.754" cy="105.906" rx="71" ry="42.6667" transform="rotate(-60.6789 144.754 105.906)" class="accent-0"/>
</g>
<g opacity="0.2" filter="url(#filter2_f_757_7415)">
<ellipse cx="19.1795" cy="144.825" rx="76" ry="42.6667" transform="rotate(17.6093 19.1795 144.825)" class="accent-0"/>
</g>
<g opacity="0.2" filter="url(#filter3_f_757_7415)">
<ellipse cx="-35.049" cy="77.6958" rx="45" ry="42.6667" transform="rotate(84.0267 -35.049 77.6958)" class="foreground-0"/>
</g>
<g opacity="0.2" filter="url(#filter4_f_757_7415)">
<ellipse cx="93.618" cy="-26.3042" rx="45" ry="42.6667" transform="rotate(84.0267 93.618 -26.3042)" class="foreground-0"/>
</g>
<g opacity="0.2" filter="url(#filter5_f_757_7415)">
<ellipse cx="150.951" cy="22.3628" rx="45" ry="42.6667" transform="rotate(84.0267 150.951 22.3628)" class="foreground-0"/>
</g>
<g opacity="0.2" filter="url(#filter6_f_757_7415)">
<ellipse cx="96.285" cy="151.03" rx="45" ry="42.6667" transform="rotate(84.0267 96.285 151.03)" class="foreground-0"/>
</g>
</g>
<rect x="0.833333" y="0.833333" width="119.333" height="119.333" rx="59.6667" stroke="url(#paint0_linear_757_7415)" stroke-width="0.666667"/>
<defs>
<filter id="filter0_f_757_7415" x="-64.8337" y="-68.8327" width="127.333" height="122.666" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<filter id="filter1_f_757_7415" x="75.1673" y="21.8861" width="139.172" height="168.039" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<filter id="filter2_f_757_7415" x="-73.0798" y="79.4339" width="184.518" height="130.783" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<filter id="filter3_f_757_7415" x="-96.4118" y="14.0501" width="122.726" height="127.291" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<filter id="filter4_f_757_7415" x="32.2552" y="-89.9499" width="122.726" height="127.291" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<filter id="filter5_f_757_7415" x="89.5882" y="-41.2829" width="122.726" height="127.291" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<filter id="filter6_f_757_7415" x="34.9222" y="87.3841" width="122.726" height="127.291" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="9.33333" result="effect1_foregroundBlur_757_7415"/>
</filter>
<linearGradient id="paint0_linear_757_7415" x1="103.544" y1="0.499998" x2="17.4562" y2="120.5" gradientUnits="userSpaceOnUse">
<stop class="foreground-0"/>
<stop offset="0.5" class="accent-0"/>
<stop offset="1" class="foreground-0"/>
</linearGradient>
<clipPath id="clip0_757_7415">
<rect x="0.5" y="0.5" width="120" height="120" rx="60" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const HeroLock = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M40 21V27H38.4H17.6H16V21C16 14.3726 21.3726 9 28 9C34.6274 9 40 14.3726 40 21ZM12 27.0776V21C12 12.1634 19.1634 5 28 5C36.8366 5 44 12.1634 44 21V27.0776C46.0449 27.1844 47.4687 27.438 48.6764 28.0404C50.511 28.9555 52.0026 30.4158 52.9373 32.2119C54 34.2538 54 36.9268 54 42.2727V42.2727V46.7273V46.7273C54 52.0732 54 54.7462 52.9373 56.7881C52.0026 58.5842 50.511 60.0445 48.6764 60.9596C46.5908 62 43.8605 62 38.4001 62H38.4H17.6H17.5999C12.1395 62 9.40922 62 7.32359 60.9596C5.48901 60.0445 3.99745 58.5842 3.06269 56.7881C2 54.7462 2 52.0732 2 46.7273V42.2727C2 36.9268 2 34.2538 3.06269 32.2119C3.99745 30.4158 5.48901 28.9555 7.32359 28.0404C8.53128 27.438 9.9551 27.1844 12 27.0776ZM25.5238 41.1428C25.5238 39.7753 26.6324 38.6667 28 38.6667C29.3675 38.6667 30.4762 39.7753 30.4762 41.1428V47.8571C30.4762 49.2247 29.3675 50.3333 28 50.3333C26.6324 50.3333 25.5238 49.2247 25.5238 47.8571V41.1428Z" class="background-16"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M28.7762 31.7246C28.8022 33.3946 28.8288 35.098 29.8654 36.1346C30.8924 37.1616 32.5479 37.1842 34.1963 37.2068C35.3876 37.2231 36.5753 37.2393 37.5192 37.6346C38.4656 38.0309 39.3371 38.8661 40.2081 39.7009C41.4081 40.8508 42.6072 42 44 42C45.402 42 46.6339 40.8225 47.8484 39.6617C48.7162 38.8323 49.5751 38.0113 50.4808 37.6346C51.3806 37.2603 52.5443 37.2422 53.7246 37.2238C55.3946 37.1978 57.098 37.1712 58.1346 36.1346C59.1616 35.1076 59.1842 33.4521 59.2068 31.8037C59.2231 30.6124 59.2393 29.4247 59.6346 28.4808C60.0309 27.5344 60.8661 26.6629 61.7009 25.7919C62.8508 24.5919 64 23.3928 64 22C64 20.598 62.8225 19.3661 61.6617 18.1516C60.8323 17.2838 60.0113 16.4249 59.6346 15.5192C59.2603 14.6194 59.2422 13.4557 59.2238 12.2754C59.1978 10.6054 59.1712 8.90199 58.1346 7.86538C57.1076 6.8384 55.4521 6.81577 53.8037 6.79324C52.6124 6.77695 51.4247 6.76071 50.4808 6.36539C49.5344 5.96905 48.6629 5.13387 47.7919 4.2991C46.5919 3.14915 45.3928 2 44 2C42.598 2 41.3661 3.17749 40.1516 4.33828C39.2838 5.16775 38.4249 5.98869 37.5192 6.36539C36.6194 6.73966 35.4557 6.7578 34.2754 6.7762C32.6054 6.80223 30.902 6.82878 29.8654 7.86538C28.8384 8.89237 28.8158 10.5479 28.7932 12.1963C28.7769 13.3876 28.7607 14.5753 28.3654 15.5192C27.9691 16.4656 27.1339 17.3371 26.2991 18.2081C25.1492 19.4081 24 20.6072 24 22C24 23.402 25.1775 24.6339 26.3383 25.8484C27.1677 26.7162 27.9887 27.5751 28.3654 28.4808C28.7397 29.3806 28.7578 30.5443 28.7762 31.7246ZM53.9607 18.9561C54.8287 18.1281 54.861 16.7533 54.033 15.8854C53.205 15.0175 51.8302 14.9851 50.9623 15.8131L41.1743 25.1508L37.039 21.199C36.1718 20.3703 34.7969 20.4014 33.9682 21.2687C33.1395 22.1359 33.1707 23.5107 34.0379 24.3395L39.6725 29.7241C40.5115 30.5259 41.8326 30.5264 42.6723 29.7254L53.9607 18.9561Z" class="foreground-0" opacity="0.95"/>
</svg>`;

const HeroPasskey = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<g clip-path="url(#clip0_1824_12403)">
<path d="M29 32C12.9837 32 0 45.0717 0 61.1964C8.82609 63.3121 32.7826 66.274 58 61.1964C58 45.0717 45.0163 32 29 32Z" class="background-16"/>
<circle cx="28.5" cy="14.5" r="14.5" class="background-16"/>
<path opacity="0.95" fill-rule="evenodd" clip-rule="evenodd" d="M38.2909 37.5818C38.2848 39.2105 38.598 40.8245 39.2127 42.3327L28.3636 53.1818V60.2727H35.4546V56.0182H39.7091V51.7636H43.9636L46.3036 49.4236C47.8118 50.0384 49.4259 50.3516 51.0546 50.3455C53.579 50.3455 56.0467 49.5969 58.1456 48.1944C60.2446 46.7919 61.8806 44.7985 62.8466 42.4663C63.8127 40.134 64.0654 37.5677 63.5729 35.0918C63.0804 32.6159 61.8648 30.3416 60.0798 28.5566C58.2948 26.7715 56.0205 25.5559 53.5446 25.0634C51.0687 24.571 48.5024 24.8237 46.1701 25.7898C43.8379 26.7558 41.8445 28.3918 40.442 30.4907C39.0395 32.5897 38.2909 35.0574 38.2909 37.5818ZM56.7272 40.4182C56.7272 41.9847 55.4573 43.2545 53.8908 43.2545C52.3243 43.2545 51.0545 41.9847 51.0545 40.4182C51.0545 38.8517 52.3243 37.5818 53.8908 37.5818C55.4573 37.5818 56.7272 38.8517 56.7272 40.4182Z" class="foreground-0"/>
</g>
<defs>
<clipPath id="clip0_1824_12403">
<rect width="64" height="64" fill="white"/>
</clipPath>
</defs>
</svg>`;

const HeroPhone = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3 1.79086 4.79086 0 7 0H35C37.2091 0 39 1.79086 39 4V60C39 62.2091 37.2091 64 35 64H7C4.79086 64 3 62.2091 3 60V4ZM25 56C25 58.2091 23.2091 60 21 60C18.7909 60 17 58.2091 17 56C17 53.7909 18.7909 52 21 52C23.2091 52 25 53.7909 25 56ZM15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6H27C27.5523 6 28 5.55228 28 5C28 4.44772 27.5523 4 27 4H15Z" class="background-16"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.4926 43.1833C20.5226 45.1038 20.5531 47.0627 21.7452 48.2548C22.9262 49.4358 24.8301 49.4619 26.7257 49.4878C28.0958 49.5065 29.4616 49.5252 30.5471 49.9798C31.6354 50.4356 32.6376 51.3961 33.6394 52.356C35.0193 53.6785 36.3983 55 38 55C39.6123 55 41.029 53.6459 42.4256 52.311C43.4236 51.3571 44.4114 50.413 45.4529 49.9798C46.4877 49.5494 47.8259 49.5285 49.1833 49.5074C51.1038 49.4774 53.0627 49.4469 54.2548 48.2548C55.4358 47.0738 55.4619 45.1699 55.4878 43.2743C55.5065 41.9042 55.5252 40.5384 55.9798 39.4529C56.4356 38.3646 57.3961 37.3624 58.356 36.3606C59.6785 34.9807 61 33.6017 61 32C61 30.3877 59.6459 28.971 58.311 27.5744C57.3571 26.5764 56.413 25.5886 55.9798 24.5471C55.5494 23.5123 55.5285 22.1741 55.5074 20.8167C55.4774 18.8962 55.4469 16.9373 54.2548 15.7452C53.0738 14.5642 51.1699 14.5381 49.2743 14.5122C47.9042 14.4935 46.5384 14.4748 45.4529 14.0202C44.3646 13.5644 43.3624 12.6039 42.3606 11.644C40.9807 10.3215 39.6017 9 38 9C36.3877 9 34.971 10.3541 33.5744 11.689C32.5764 12.6429 31.5886 13.587 30.5471 14.0202C29.5123 14.4506 28.1741 14.4715 26.8167 14.4926C24.8962 14.5226 22.9373 14.5531 21.7452 15.7452C20.5642 16.9262 20.5381 18.8301 20.5122 20.7257C20.4935 22.0958 20.4748 23.4616 20.0202 24.5471C19.5644 25.6354 18.6039 26.6376 17.644 27.6394C16.3215 29.0193 15 30.3983 15 32C15 33.6123 16.3541 35.029 17.689 36.4256C18.6429 37.4236 19.587 38.4114 20.0202 39.4529C20.4506 40.4877 20.4715 41.8259 20.4926 43.1833ZM49.4549 28.4995C50.453 27.5473 50.4902 25.9663 49.538 24.9682C48.5858 23.9701 47.0048 23.9329 46.0067 24.8851L34.7505 35.6235L29.9949 31.0788C28.9976 30.1258 27.4165 30.1617 26.4635 31.159C25.5104 32.1563 25.5463 33.7373 26.5436 34.6904L33.0234 40.8827C33.9882 41.8047 35.5075 41.8054 36.4732 40.8842L49.4549 28.4995Z" class="foreground-0" opacity="0.95"/>
</svg>`;

const HeroPlusCircleCapsule = `<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="plus-circle">
<g id="Icon">
<path d="M19.9999 13.7988V26.9798M13.4095 20.3893H26.5904M36.4761 20.3893C36.4761 29.4888 29.0995 36.8655 19.9999 36.8655C10.9004 36.8655 3.52374 29.4888 3.52374 20.3893C3.52374 11.2897 10.9004 3.9131 19.9999 3.9131C29.0995 3.9131 36.4761 11.2897 36.4761 20.3893Z" stroke="url(#paint0_linear_1604_26695)" stroke-width="2.24" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
<defs>
<linearGradient id="paint0_linear_1604_26695" x1="36.4761" y1="20.3893" x2="3.52374" y2="20.3893" gradientUnits="userSpaceOnUse">
<stop stop-color="#BC82F3"/>
<stop offset="0.485" stop-color="#FF6778"/>
<stop offset="1" stop-color="#FFBA71"/>
</linearGradient>
</defs>
</svg>
`;

const HeroPlusCircle = `<svg width="40" height="41" viewBox="0 0 40 41" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="plus-circle">
<g id="Icon">
<path d="M19.9999 13.7988V26.9798M13.4095 20.3893H26.5904M36.4761 20.3893C36.4761 29.4888 29.0995 36.8655 19.9999 36.8655C10.9004 36.8655 3.52374 29.4888 3.52374 20.3893C3.52374 11.2897 10.9004 3.9131 19.9999 3.9131C29.0995 3.9131 36.4761 11.2897 36.4761 20.3893Z" stroke-width="2.24" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
`;

const HeroWallet = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
<path opacity="0.95" fill-rule="evenodd" clip-rule="evenodd" d="M10 17C7.79086 17 6 18.7909 6 21V54C6 56.2091 7.79086 58 10 58H59C61.2091 58 63 56.2091 63 54V45H49C47.8954 45 47 44.1046 47 43V33C47 31.8954 47.8954 31 49 31H63V21C63 18.7909 61.2091 17 59 17H10Z" class="background-16"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M50 33C49.4477 33 49 33.4477 49 34V42C49 42.5523 49.4477 43 50 43H63C63.5523 43 64 42.5523 64 42V34C64 33.4477 63.5523 33 63 33H50ZM57 40.625C58.4497 40.625 59.625 39.4497 59.625 38C59.625 36.5503 58.4497 35.375 57 35.375C55.5503 35.375 54.375 36.5503 54.375 38C54.375 39.4497 55.5503 40.625 57 40.625Z" class="background-16"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.7762 34.7246C4.80223 36.3946 4.82878 38.098 5.86538 39.1346C6.89237 40.1616 8.54788 40.1842 10.1963 40.2068C11.3876 40.2231 12.5753 40.2393 13.5192 40.6346C14.4656 41.0309 15.3371 41.8661 16.2081 42.7009C17.4081 43.8508 18.6072 45 20 45C21.402 45 22.6339 43.8225 23.8484 42.6617C24.7162 41.8323 25.5751 41.0113 26.4808 40.6346C27.3806 40.2603 28.5443 40.2422 29.7246 40.2238C31.3946 40.1978 33.098 40.1712 34.1346 39.1346C35.1616 38.1076 35.1842 36.4521 35.2068 34.8037C35.2231 33.6124 35.2393 32.4247 35.6346 31.4808C36.0309 30.5344 36.8661 29.6629 37.7009 28.7919C38.8508 27.5919 40 26.3928 40 25C40 23.598 38.8225 22.3661 37.6617 21.1516C36.8323 20.2838 36.0113 19.4249 35.6346 18.5192C35.2603 17.6194 35.2422 16.4557 35.2238 15.2754C35.1978 13.6054 35.1712 11.902 34.1346 10.8654C33.1076 9.8384 31.4521 9.81577 29.8037 9.79324C28.6124 9.77695 27.4247 9.76071 26.4808 9.36539C25.5344 8.96905 24.6629 8.13387 23.7919 7.2991C22.5919 6.14915 21.3928 5 20 5C18.598 5 17.3661 6.17749 16.1516 7.33828C15.2838 8.16775 14.4249 8.98869 13.5192 9.36539C12.6194 9.73966 11.4557 9.7578 10.2754 9.7762C8.60535 9.80223 6.90199 9.82878 5.86538 10.8654C4.8384 11.8924 4.81577 13.5479 4.79324 15.1963C4.77695 16.3876 4.76071 17.5753 4.36539 18.5192C3.96905 19.4656 3.13387 20.3371 2.2991 21.2081C1.14915 22.4081 0 23.6072 0 25C0 26.402 1.17749 27.6339 2.33828 28.8484C3.16775 29.7162 3.98869 30.5751 4.36539 31.4808C4.73966 32.3806 4.7578 33.5443 4.7762 34.7246ZM29.9607 21.9561C30.8287 21.1281 30.861 19.7533 30.033 18.8854C29.205 18.0175 27.8302 17.9851 26.9623 18.8131L17.1743 28.1508L13.039 24.199C12.1718 23.3703 10.7969 23.4014 9.9682 24.2687C9.13946 25.1359 9.17065 26.5107 10.0379 27.3395L15.6725 32.7241C16.5115 33.5259 17.8326 33.5264 18.6723 32.7254L29.9607 21.9561Z" class="foreground-0" opacity="0.95"/>
</svg>`;

const Home = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9 21V13.6C9 13.0399 9 12.7599 9.10899 12.546C9.20487 12.3578 9.35785 12.2049 9.54601 12.109C9.75992 12 10.0399 12 10.6 12H13.4C13.9601 12 14.2401 12 14.454 12.109C14.6422 12.2049 14.7951 12.3578 14.891 12.546C15 12.7599 15 13.0399 15 13.6V21M11.0177 2.764L4.23539 8.03912C3.78202 8.39175 3.55534 8.56806 3.39203 8.78886C3.24737 8.98444 3.1396 9.20478 3.07403 9.43905C3 9.70352 3 9.9907 3 10.5651V17.8C3 18.9201 3 19.4801 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4801 21 18.9201 21 17.8V10.5651C21 9.9907 21 9.70352 20.926 9.43905C20.8604 9.20478 20.7526 8.98444 20.608 8.78886C20.4447 8.56806 20.218 8.39175 19.7646 8.03913L12.9823 2.764C12.631 2.49075 12.4553 2.35412 12.2613 2.3016C12.0902 2.25526 11.9098 2.25526 11.7387 2.3016C11.5447 2.35412 11.369 2.49075 11.0177 2.764Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Hp = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Layer 2">
<g id="Layer 1">
<path id="Vector" d="M12 24C11.8806 24 11.7617 24 11.6433 23.9944L14.0956 17.2544H17.4706C18.0633 17.2544 18.7133 16.7989 18.915 16.2428L21.5756 8.93445C22.0106 7.73833 21.3256 6.75944 20.0522 6.75944H15.3711L11.4444 17.5556L9.21389 23.6744C3.93 22.4178 0 17.6667 0 12C0 6.49556 3.70667 1.85667 8.76 0.444444L6.46222 6.76111L2.64111 17.2544H5.18444L8.43333 8.33667H10.3444L7.09556 17.255H9.63778L12.6667 8.93445C13.1022 7.73833 12.4167 6.75944 11.145 6.75944H9.00611L11.4606 0.0127778C11.6394 0.00425926 11.8193 0 12 0C18.6272 0 24 5.37278 24 12C24 18.6272 18.6272 24 12 24ZM19.2606 8.33H17.35L14.6739 15.6722H16.585L19.2606 8.33Z" />
</g>
</g>
</svg>
`;

const Image$1 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const InfoCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const InstagramBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21165)">
<path d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z" fill="#000100"/>
<path d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z" fill="#000100"/>
<path d="M19.8469 5.5922C19.8469 6.38908 19.2 7.03127 18.4078 7.03127C17.6109 7.03127 16.9688 6.38439 16.9688 5.5922C16.9688 4.79533 17.6156 4.15314 18.4078 4.15314C19.2 4.15314 19.8469 4.80001 19.8469 5.5922Z" fill="#000100"/>
</g>
<defs>
<clipPath id="clip0_106_21165">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Instagram = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21341)">
<path d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z" />
<path d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z" />
<path d="M19.8469 5.59214C19.8469 6.38902 19.2 7.0312 18.4078 7.0312C17.6109 7.0312 16.9688 6.38433 16.9688 5.59214C16.9688 4.79526 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.79995 19.8469 5.59214Z" />
</g>
<defs>
<clipPath id="clip0_106_21341">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Key = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M17 8.99994C17 8.48812 16.8047 7.9763 16.4142 7.58579C16.0237 7.19526 15.5118 7 15 7M15 15C18.3137 15 21 12.3137 21 9C21 5.68629 18.3137 3 15 3C11.6863 3 9 5.68629 9 9C9 9.27368 9.01832 9.54308 9.05381 9.80704C9.11218 10.2412 9.14136 10.4583 9.12172 10.5956C9.10125 10.7387 9.0752 10.8157 9.00469 10.9419C8.937 11.063 8.81771 11.1823 8.57913 11.4209L3.46863 16.5314C3.29568 16.7043 3.2092 16.7908 3.14736 16.8917C3.09253 16.9812 3.05213 17.0787 3.02763 17.1808C3 17.2959 3 17.4182 3 17.6627V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H7V19H9V17H11L12.5791 15.4209C12.8177 15.1823 12.937 15.063 13.0581 14.9953C13.1843 14.9248 13.2613 14.8987 13.4044 14.8783C13.5417 14.8586 13.7588 14.8878 14.193 14.9462C14.4569 14.9817 14.7263 15 15 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Laptop = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="laptop-02">
<path id="Icon" d="M21 16V7.2C21 6.0799 21 5.51984 20.782 5.09202C20.5903 4.71569 20.2843 4.40973 19.908 4.21799C19.4802 4 18.9201 4 17.8 4H6.2C5.07989 4 4.51984 4 4.09202 4.21799C3.71569 4.40973 3.40973 4.71569 3.21799 5.09202C3 5.51984 3 6.0799 3 7.2V16M4.66667 20H19.3333C19.9533 20 20.2633 20 20.5176 19.9319C21.2078 19.7469 21.7469 19.2078 21.9319 18.5176C22 18.2633 22 17.9533 22 17.3333C22 17.0233 22 16.8683 21.9659 16.7412C21.8735 16.3961 21.6039 16.1265 21.2588 16.0341C21.1317 16 20.9767 16 20.6667 16H3.33333C3.02334 16 2.86835 16 2.74118 16.0341C2.39609 16.1265 2.12654 16.3961 2.03407 16.7412C2 16.8683 2 17.0233 2 17.3333C2 17.9533 2 18.2633 2.06815 18.5176C2.25308 19.2078 2.79218 19.7469 3.48236 19.9319C3.73669 20 4.04669 20 4.66667 20Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const Lenovo = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Platform=Lenovo, Style=Black, State=Default" clip-path="url(#clip0_1570_449)">
<path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM10.7758 15.4768H17V18H8V5H10.7758V15.4768Z"/>
</g>
</svg>
`;

const Lg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group">
<path id="Subtract" fill-rule="evenodd" clip-rule="evenodd" d="M20.485 3.51495C25.1715 8.2014 25.1717 15.7993 20.4855 20.4855C15.7994 25.1717 8.20135 25.1715 3.51498 20.485C-1.17147 15.7986 -1.1717 8.20063 3.51452 3.51449C8.20066 -1.17165 15.7986 -1.1715 20.485 3.51495ZM14.9492 12.381H21.0516L21.051 12.4062C20.8418 17.1673 16.8908 20.9623 12.054 20.9623C7.08053 20.9623 3.04838 16.9506 3.04838 12.0036C3.04838 7.0566 7.08122 3.04559 12.054 3.04559C12.1976 3.04559 12.3409 3.04874 12.4839 3.05512V2.15795C12.3409 2.15203 12.1972 2.14911 12.0527 2.14911C6.58118 2.14911 2.14575 6.55794 2.14575 12.0036C2.14575 17.4493 6.58257 21.8588 12.0534 21.8588C17.5243 21.8588 21.9603 17.4473 21.9603 12.0043C21.9603 11.8271 21.9556 11.6521 21.9461 11.477H14.9492V12.381ZM12.4834 16.1469H14.9358L14.9378 17.0502H12.4854V17.0563H11.5767V6.93274H12.4834V16.1469ZM8.35921 9.66025C8.63282 9.65894 8.89991 9.57655 9.12679 9.42352C9.3536 9.27058 9.53007 9.05384 9.63383 8.80066C9.73766 8.54749 9.7641 8.26919 9.70992 8.00103C9.65565 7.73279 9.52323 7.48669 9.32932 7.2937C9.13532 7.10071 8.88853 6.96943 8.62006 6.91655C8.35167 6.86367 8.07352 6.8915 7.82089 6.99649C7.56818 7.10155 7.35228 7.27902 7.20041 7.50667C7.04854 7.73425 6.96753 8.00172 6.96753 8.27533C6.96791 8.45764 7.00427 8.63811 7.07444 8.80635C7.14469 8.97467 7.24729 9.12747 7.37649 9.25605C7.50577 9.38463 7.6591 9.48655 7.82765 9.55588C7.99628 9.62528 8.1769 9.66071 8.35921 9.66025Z"/>
</g>
</svg>
`;

const Lightning01 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 2L4.09347 12.6879C3.74466 13.1064 3.57026 13.3157 3.56759 13.4925C3.56528 13.6461 3.63375 13.7923 3.75327 13.8889C3.89076 14 4.16319 14 4.70805 14H12L11 22L19.9066 11.3121C20.2554 10.8936 20.4298 10.6843 20.4324 10.5075C20.4348 10.3539 20.3663 10.2077 20.2468 10.1111C20.1093 10 19.8368 10 19.292 10H12L13 2Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Lightning = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M13 2L4.09347 12.6879C3.74466 13.1064 3.57026 13.3157 3.56759 13.4925C3.56528 13.6461 3.63375 13.7923 3.75327 13.8889C3.89076 14 4.16319 14 4.70805 14H12L11 22L19.9066 11.3121C20.2554 10.8936 20.4298 10.6843 20.4324 10.5075C20.4348 10.3539 20.3663 10.2077 20.2468 10.1111C20.1093 10 19.8368 10 19.292 10H12L13 2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const LinkExternal = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const LinkedinBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21170)">
<path d="M22.2283 0H1.77167C1.30179 0 0.851161 0.186657 0.518909 0.518909C0.186657 0.851161 0 1.30179 0 1.77167V22.2283C0 22.6982 0.186657 23.1488 0.518909 23.4811C0.851161 23.8133 1.30179 24 1.77167 24H22.2283C22.6982 24 23.1488 23.8133 23.4811 23.4811C23.8133 23.1488 24 22.6982 24 22.2283V1.77167C24 1.30179 23.8133 0.851161 23.4811 0.518909C23.1488 0.186657 22.6982 0 22.2283 0ZM7.15333 20.445H3.545V8.98333H7.15333V20.445ZM5.34667 7.395C4.93736 7.3927 4.53792 7.2692 4.19873 7.04009C3.85955 6.81098 3.59584 6.48653 3.44088 6.10769C3.28591 5.72885 3.24665 5.31259 3.32803 4.91145C3.40941 4.51032 3.6078 4.14228 3.89816 3.85378C4.18851 3.56529 4.55782 3.36927 4.95947 3.29046C5.36112 3.21165 5.77711 3.25359 6.15495 3.41099C6.53279 3.56838 6.85554 3.83417 7.08247 4.17481C7.30939 4.51546 7.43032 4.91569 7.43 5.325C7.43386 5.59903 7.38251 5.87104 7.27901 6.1248C7.17551 6.37857 7.02198 6.6089 6.82757 6.80207C6.63316 6.99523 6.40185 7.14728 6.14742 7.24915C5.893 7.35102 5.62067 7.40062 5.34667 7.395ZM20.4533 20.455H16.8467V14.1933C16.8467 12.3467 16.0617 11.7767 15.0483 11.7767C13.9783 11.7767 12.9283 12.5833 12.9283 14.24V20.455H9.32V8.99167H12.79V10.58H12.8367C13.185 9.875 14.405 8.67 16.2667 8.67C18.28 8.67 20.455 9.865 20.455 13.365L20.4533 20.455Z" fill="#0A66C2"/>
</g>
<defs>
<clipPath id="clip0_106_21170">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Linkedin = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21351)">
<path d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5562 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516Z" />
</g>
<defs>
<clipPath id="clip0_106_21351">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LockKeyholeCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="lock-keyhole-circle">
<g id="Icon">
<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.7316 13.1947C13.661 12.9831 13.6257 12.8772 13.6276 12.7907C13.6295 12.6996 13.6417 12.6519 13.6836 12.5711C13.7235 12.4942 13.83 12.395 14.0432 12.1967C14.6318 11.649 15 10.8675 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 10.8675 9.36818 11.649 9.95681 12.1967C10.17 12.395 10.2765 12.4942 10.3164 12.5711C10.3583 12.6519 10.3705 12.6996 10.3724 12.7907C10.3743 12.8772 10.339 12.9831 10.2684 13.1947L9.35099 15.947C9.23249 16.3025 9.17324 16.4803 9.20877 16.6218C9.23987 16.7456 9.31718 16.8529 9.42484 16.9216C9.54783 17 9.7352 17 10.1099 17H13.8901C14.2648 17 14.4522 17 14.5752 16.9216C14.6828 16.8529 14.7601 16.7456 14.7912 16.6218C14.8268 16.4803 14.7675 16.3025 14.649 15.947L13.7316 13.1947Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
`;

const LogOut = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M16 17L21 12M21 12L16 7M21 12H9M12 17C12 17.93 12 18.395 11.8978 18.7765C11.6204 19.8117 10.8117 20.6204 9.77646 20.8978C9.39496 21 8.92997 21 8 21H7.5C6.10218 21 5.40326 21 4.85195 20.7716C4.11687 20.4672 3.53284 19.8831 3.22836 19.1481C3 18.5967 3 17.8978 3 16.5V7.5C3 6.10217 3 5.40326 3.22836 4.85195C3.53284 4.11687 4.11687 3.53284 4.85195 3.22836C5.40326 3 6.10218 3 7.5 3H8C8.92997 3 9.39496 3 9.77646 3.10222C10.8117 3.37962 11.6204 4.18827 11.8978 5.22354C12 5.60504 12 6.07003 12 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Mail = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Menu = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Monitor = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 21H16M12 17V21M6.8 17H17.2C18.8802 17 19.7202 17 20.362 16.673C20.9265 16.3854 21.3854 15.9265 21.673 15.362C22 14.7202 22 13.8802 22 12.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V12.2C2 13.8802 2 14.7202 2.32698 15.362C2.6146 15.9265 3.07354 16.3854 3.63803 16.673C4.27976 17 5.11984 17 6.8 17Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const MoonpayBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_794_1613)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.3097 7.38029C21.0397 7.38029 21.7531 7.16396 22.36 6.75838C22.9668 6.35302 23.4398 5.77664 23.7191 5.1024C23.9984 4.42816 24.0715 3.686 23.9291 2.97031C23.7866 2.2544 23.4353 1.59687 22.9192 1.08083C22.4029 0.564779 21.7455 0.213234 21.0298 0.0708705C20.3138 -0.0714827 19.5719 0.00164933 18.8977 0.280939C18.2235 0.560229 17.6471 1.03308 17.2415 1.64005C16.8361 2.2468 16.6196 2.96032 16.6196 3.69011C16.6196 4.1747 16.715 4.65472 16.9004 5.1024C17.0859 5.55009 17.3578 5.95697 17.7005 6.29961C18.0431 6.64225 18.4498 6.91416 18.8977 7.0995C19.3454 7.28507 19.8252 7.38029 20.3097 7.38029ZM8.99487 24C7.21585 24 5.47678 23.4724 3.99766 22.4842C2.51837 21.4958 1.36548 20.0911 0.684692 18.4475C0.00390273 16.8038 -0.174236 14.9953 0.172842 13.2503C0.519899 11.5056 1.37657 9.9028 2.63453 8.6448C3.89242 7.38701 5.49523 6.53035 7.23995 6.18327C8.98488 5.8361 10.7934 6.01426 12.437 6.69501C14.0806 7.37596 15.4853 8.52867 16.4738 10.0081C17.4619 11.4872 17.9895 13.2263 17.9895 15.0052C17.9897 16.1864 17.7571 17.3562 17.3051 18.4475C16.853 19.5387 16.1903 20.5305 15.3551 21.3658C14.5198 22.2008 13.5284 22.8635 12.437 23.3156C11.3457 23.7676 10.176 24.0002 8.99487 24Z" fill="#6F19F8"/>
</g>
<defs>
<clipPath id="clip0_794_1613">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MoreLoginOptions = `<svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group 4">
<path id="Vector" d="M2.1 16C2.98366 16 3.7 15.2836 3.7 14.4C3.7 13.5163 2.98366 12.8 2.1 12.8C1.21634 12.8 0.5 13.5163 0.5 14.4C0.5 15.2836 1.21634 16 2.1 16Z"/>
<path id="Vector_2" d="M2.1 9.60002C2.98366 9.60002 3.7 8.88368 3.7 8.00002C3.7 7.11637 2.98366 6.40002 2.1 6.40002C1.21634 6.40002 0.5 7.11637 0.5 8.00002C0.5 8.88368 1.21634 9.60002 2.1 9.60002Z"/>
<path id="Vector_3" d="M2.1 3.2C2.98366 3.2 3.7 2.48366 3.7 1.6C3.7 0.716344 2.98366 0 2.1 0C1.21634 0 0.5 0.716344 0.5 1.6C0.5 2.48366 1.21634 3.2 2.1 3.2Z"/>
<path id="Vector_4" d="M8.4999 16C9.38356 16 10.0999 15.2836 10.0999 14.4C10.0999 13.5163 9.38356 12.8 8.4999 12.8C7.61625 12.8 6.8999 13.5163 6.8999 14.4C6.8999 15.2836 7.61625 16 8.4999 16Z"/>
<path id="Vector_5" d="M8.4999 9.60002C9.38356 9.60002 10.0999 8.88368 10.0999 8.00002C10.0999 7.11637 9.38356 6.40002 8.4999 6.40002C7.61625 6.40002 6.8999 7.11637 6.8999 8.00002C6.8999 8.88368 7.61625 9.60002 8.4999 9.60002Z"/>
<path id="Vector_6" d="M8.4999 3.2C9.38356 3.2 10.0999 2.48366 10.0999 1.6C10.0999 0.716344 9.38356 0 8.4999 0C7.61625 0 6.8999 0.716344 6.8999 1.6C6.8999 2.48366 7.61625 3.2 8.4999 3.2Z"/>
<path id="Vector_7" d="M14.9 16C15.7837 16 16.5 15.2836 16.5 14.4C16.5 13.5163 15.7837 12.8 14.9 12.8C14.0164 12.8 13.3 13.5163 13.3 14.4C13.3 15.2836 14.0164 16 14.9 16Z"/>
<path id="Vector_8" d="M14.9 9.60002C15.7837 9.60002 16.5 8.88368 16.5 8.00002C16.5 7.11637 15.7837 6.40002 14.9 6.40002C14.0164 6.40002 13.3 7.11637 13.3 8.00002C13.3 8.88368 14.0164 9.60002 14.9 9.60002Z"/>
<path id="Vector_9" d="M14.9 3.2C15.7837 3.2 16.5 2.48366 16.5 1.6C16.5 0.716344 15.7837 0 14.9 0C14.0164 0 13.3 0.716344 13.3 1.6C13.3 2.48366 14.0164 3.2 14.9 3.2Z"/>
</g>
</svg>
`;

const Motorola = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_1570_470)">
<path id="Vector" d="M11.9981 0C9.62469 0 7.30461 0.703792 5.33122 2.02237C3.35783 3.34095 1.81977 5.21509 0.911515 7.40781C0.00326324 9.60052 -0.2344 12.0133 0.228623 14.3411C0.691646 16.6689 1.83454 18.8071 3.51277 20.4853C5.191 22.1635 7.3292 23.3064 9.65697 23.7694C11.9847 24.2325 14.3975 23.9948 16.5903 23.0866C18.783 22.1783 20.6571 20.6403 21.9757 18.6669C23.2943 16.6935 23.9981 14.3734 23.9981 12C23.9981 8.8174 22.7338 5.76518 20.4834 3.51474C18.2329 1.2643 15.1807 0 11.9981 0ZM19.5441 17.692C18.4561 14.153 17.068 12 15.483 12C14.194 12 12.9971 13.452 12.0051 15.938C11.0151 13.455 9.81705 12 8.51405 12C6.94605 12 5.55707 14.148 4.46407 17.692H3.65605L8.43105 2.992L12 13.97L15.5681 2.99103L20.3431 17.691L19.5441 17.692Z" />
</g>
</svg>
`;

const NobleBrand = `<svg width="114" height="114" viewBox="0 0 114 114" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M105.511 69.7245C105.514 74.4502 104.603 79.0595 102.797 83.4226C100.988 87.7924 98.3773 91.6967 95.0417 95.0355C91.696 98.3777 87.7883 100.985 83.425 102.791C79.0684 104.593 74.4689 105.511 69.7564 105.511H69.7298H69.7232H69.5835C62.0342 105.511 54.5414 103.05 48.4687 98.5773C42.356 94.0744 37.7632 87.5962 35.4785 80.117C34.4542 76.7448 33.9354 73.2563 33.942 69.7379V43.3494C33.9454 40.8352 34.9231 38.4741 36.7023 36.6949C38.4816 34.919 40.8428 33.9413 43.3504 33.938C45.8613 33.9446 48.2226 34.929 49.9985 36.7015C51.7711 38.4774 52.7521 40.8386 52.7588 43.3461V69.7279C52.7621 74.2573 54.5314 78.5207 57.744 81.7232C60.1252 84.0977 63.1283 85.6973 66.4274 86.3458C69.7232 87.0009 73.112 86.6651 76.2216 85.3781C79.3278 84.0911 81.9584 81.9361 83.8308 79.1393C85.7064 76.3458 86.7008 73.0934 86.7075 69.7245V16.9709C86.7075 15.7304 86.9469 14.5166 87.4225 13.3693C87.8947 12.2253 88.5798 11.1977 89.4612 10.3197C90.3391 9.44508 91.3634 8.75669 92.5108 8.28113C94.8022 7.33667 97.4129 7.33334 99.7076 8.28113C100.855 8.75669 101.879 9.44508 102.757 10.3197C103.635 11.1977 104.32 12.2253 104.796 13.3693C105.271 14.5166 105.511 15.7304 105.511 16.9709V69.7245ZM31.358 31.3474C28.152 34.5532 26.3827 38.8166 26.3794 43.3461V96.1031C26.3794 98.6139 25.4016 100.975 23.6224 102.754C20.0706 106.313 13.8715 106.313 10.3163 102.754C8.54038 100.975 7.56263 98.6139 7.56263 96.1031V43.3494C7.56928 34.7727 10.6588 26.4754 16.2626 19.9838C21.8698 13.4923 29.6253 9.22892 38.1091 7.97185C39.8551 7.71246 41.6077 7.58276 43.3537 7.58276C50.0949 7.58276 56.7463 9.49164 62.4998 13.1332C65.2168 14.8525 67.6679 16.9177 69.803 19.2589C69.8229 19.2389 69.8362 19.2156 69.8562 19.1957L69.9061 19.3852C73.4147 23.2662 76.0619 27.8954 77.6017 32.9702L77.7481 33.4524C78.6826 36.6716 79.1548 40.0005 79.1582 43.3461V69.7245C79.1582 71.5902 78.6094 73.396 77.5718 74.9457C76.5342 76.4954 75.0775 77.6926 73.3548 78.411C72.2341 78.8765 71.0501 79.096 69.8562 79.1093V79.126C69.8096 79.126 69.7664 79.1127 69.7198 79.1127C69.1212 79.1127 68.5193 79.0728 67.9206 78.953C67.5748 78.8865 67.2389 78.7801 66.9063 78.6737V78.6271C66.6802 78.554 66.4474 78.5174 66.2279 78.4243C64.5051 77.7059 63.0485 76.5087 62.0109 74.959C60.9733 73.406 60.4245 71.6002 60.4245 69.7379V45.8469H60.4179V43.3427C60.4112 41.0913 59.9722 38.8998 59.1109 36.8312C58.2462 34.7594 56.9991 32.9037 55.4061 31.3174C53.813 29.7344 51.9507 28.5007 49.8688 27.646C47.7902 26.7913 45.582 26.3324 43.3537 26.3723C38.8241 26.3756 34.5639 28.1448 31.358 31.3474ZM108.095 4.97884C104.889 1.7763 100.632 0.0104134 96.1059 0.00376225H96.0992C91.573 0.0170646 87.3194 1.78628 84.1201 4.98881C80.9274 8.19134 79.1648 12.4448 79.1582 16.9709V18.8764C74.3891 11.9093 67.6646 6.4554 59.7561 3.22293C49.902 -0.794369 38.9472 -1.0704 28.8969 2.47467C20.4031 5.48764 13.1631 10.9682 7.96171 18.3244C2.76032 25.6839 0.00665139 34.3371 0 43.3461V96.1031C0 100.636 1.76594 104.896 4.97191 108.102C8.17455 111.308 12.4381 113.073 16.971 113.073C21.5039 113.073 25.7641 111.308 28.9701 108.102C32.1761 104.896 33.942 100.636 33.942 96.1031V94.2108C38.7144 101.175 45.4323 106.629 53.3408 109.854C63.1882 113.872 74.1397 114.134 84.1866 110.599C92.6771 107.59 99.9105 102.106 105.115 94.7495C110.313 87.39 113.067 78.7435 113.074 69.7379V16.9675C113.067 12.4414 111.298 8.1847 108.095 4.97884Z" fill="url(#paint0_linear_23_198)"/>
<defs>
<linearGradient id="paint0_linear_23_198" x1="-4.98854" y1="112.238" x2="112.426" y2="-13.5472" gradientUnits="userSpaceOnUse">
<stop offset="0.05" stop-color="#A0ADFF"/>
<stop offset="1" stop-color="#4C52D8"/>
</linearGradient>
</defs>
</svg>
`;

const OptimismBrand = `<?xml version="1.0" encoding="UTF-8"?>
<!-- Generator: Adobe Illustrator 26.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve"><script xmlns=""/><script xmlns=""/>
<style type="text/css">
	.st0{fill:#FF0420;}
	.st1{fill:#FFFFFF;}
</style>
<circle class="st0" cx="250" cy="250" r="250"/>
<path class="st1" d="M177.1,316.4c-14.9,0-27.1-3.5-36.6-10.5c-9.4-7.1-14.1-17.3-14.1-30.4c0-2.8,0.3-6.1,0.9-10.1  c1.6-9,3.9-19.8,6.9-32.5c8.5-34.4,30.5-51.6,65.9-51.6c9.6,0,18.3,1.6,25.9,4.9c7.6,3.1,13.6,7.9,18,14.3  c4.4,6.3,6.6,13.8,6.6,22.5c0,2.6-0.3,5.9-0.9,9.9c-1.9,11.1-4.1,22-6.8,32.5c-4.4,17.1-11.9,30-22.7,38.5  C209.5,312.3,195.1,316.4,177.1,316.4z M179.8,289.4c7,0,12.9-2.1,17.8-6.2c5-4.1,8.6-10.4,10.7-19c2.9-11.8,5.1-22,6.6-30.8  c0.5-2.6,0.8-5.3,0.8-8.1c0-11.4-5.9-17.1-17.8-17.1c-7,0-13,2.1-18,6.2c-4.9,4.1-8.4,10.4-10.5,19c-2.3,8.4-4.5,18.6-6.8,30.8  c-0.5,2.5-0.8,5.1-0.8,7.9C161.7,283.7,167.8,289.4,179.8,289.4z"/>
<path class="st1" d="M259.3,314.6c-1.4,0-2.4-0.4-3.2-1.3c-0.6-1-0.8-2.1-0.6-3.4l25.9-122c0.2-1.4,0.9-2.5,2.1-3.4  c1.1-0.9,2.3-1.3,3.6-1.3H337c13.9,0,25,2.9,33.4,8.6c8.5,5.8,12.8,14.1,12.8,25c0,3.1-0.4,6.4-1.1,9.8c-3.1,14.4-9.4,25-19,31.9  c-9.4,6.9-22.3,10.3-38.7,10.3h-25.3l-8.6,41.1c-0.3,1.4-0.9,2.5-2.1,3.4c-1.1,0.9-2.3,1.3-3.6,1.3H259.3z M325.7,242.9  c5.3,0,9.8-1.4,13.7-4.3c4-2.9,6.6-7,7.9-12.4c0.4-2.1,0.6-4,0.6-5.6c0-3.6-1.1-6.4-3.2-8.3c-2.1-2-5.8-3-10.9-3h-22.5l-7.1,33.6  H325.7z"/>
</svg>`;

const ParaBlackBg = `<svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none" stroke="none">
  <mask id="path-1-outside-1_1233_12577" maskUnits="userSpaceOnUse" x="0" y="0" width="70" height="70" fill="black" stroke="none">
    <rect fill="white" stroke="none" width="70" height="70"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M22 6C13.1634 6 6 13.1634 6 22V48C6 56.8366 13.1634 64 22 64H48C56.8366 64 64 56.8366 64 48V22C64 13.1634 56.8366 6 48 6H22ZM43.3492 31.4798C43.1164 32.304 42.2266 32.7122 41.4512 32.3839C40.7521 32.088 40.4018 31.2956 40.5734 30.5424C40.6825 30.0639 40.761 29.6082 40.8092 29.1752C40.9038 28.3504 40.9028 27.6172 40.8061 26.9757C40.7094 26.3342 40.518 25.8027 40.2318 25.3813C39.9545 24.9516 39.5923 24.6421 39.1452 24.4528C38.3507 24.1165 37.4722 24.2491 36.5095 24.8505C35.5509 25.4418 34.5636 26.4892 33.5472 27.9929C32.5352 29.4864 31.5492 31.4173 30.5893 33.7858C29.6127 36.1952 28.9636 38.2987 28.6418 40.0965C28.3289 41.886 28.3066 43.33 28.5747 44.4285C28.8518 45.5187 29.3852 46.231 30.1748 46.5653C30.6124 46.7505 31.0714 46.8007 31.5517 46.7157C32.0409 46.6225 32.5374 46.3943 33.0413 46.031C33.55 45.6698 34.0544 45.1746 34.5546 44.5455C34.8167 44.2201 35.0719 43.8595 35.3205 43.4637C35.7311 42.8097 36.5338 42.5078 37.2329 42.8133C38.0024 43.1494 38.3409 44.0803 37.9267 44.8236C37.4178 45.7366 36.8734 46.586 36.2933 47.3716C35.4331 48.5451 34.5331 49.5214 33.5931 50.3006C32.6572 51.0696 31.7182 51.585 30.7762 51.8469C29.8382 52.0985 28.934 52.04 28.0635 51.6715C26.7791 51.1278 25.8924 50.0016 25.4034 48.2931C24.9143 46.5846 24.87 44.3976 25.2703 41.7323C25.6706 39.0669 26.5564 36.0425 27.9277 32.659C29.3032 29.2653 30.7717 26.4876 32.3333 24.3259C33.8991 22.1539 35.446 20.6405 36.9738 19.7858C38.5018 18.9311 39.9031 18.7736 41.178 19.3133C41.9914 19.6577 42.648 20.2239 43.1479 21.0121C43.6477 21.8003 43.9779 22.7869 44.1385 23.972C44.3032 25.1469 44.2832 26.4957 44.0784 28.0186C43.9385 29.0998 43.6955 30.2535 43.3492 31.4798ZM38.3702 36.6062C38.7112 35.7648 39.6549 35.3653 40.4781 35.7138L40.557 35.7473C41.3803 36.0957 41.7711 37.0602 41.4302 37.9016C41.0892 38.7429 40.1455 39.1424 39.3223 38.7939L39.2433 38.7605C38.4201 38.412 38.0292 37.4474 38.3702 36.6062Z"/>
  </mask>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 6C13.1634 6 6 13.1634 6 22V48C6 56.8366 13.1634 64 22 64H48C56.8366 64 64 56.8366 64 48V22C64 13.1634 56.8366 6 48 6H22ZM43.3492 31.4798C43.1164 32.304 42.2266 32.7122 41.4512 32.3839C40.7521 32.088 40.4018 31.2956 40.5734 30.5424C40.6825 30.0639 40.761 29.6082 40.8092 29.1752C40.9038 28.3504 40.9028 27.6172 40.8061 26.9757C40.7094 26.3342 40.518 25.8027 40.2318 25.3813C39.9545 24.9516 39.5923 24.6421 39.1452 24.4528C38.3507 24.1165 37.4722 24.2491 36.5095 24.8505C35.5509 25.4418 34.5636 26.4892 33.5472 27.9929C32.5352 29.4864 31.5492 31.4173 30.5893 33.7858C29.6127 36.1952 28.9636 38.2987 28.6418 40.0965C28.3289 41.886 28.3066 43.33 28.5747 44.4285C28.8518 45.5187 29.3852 46.231 30.1748 46.5653C30.6124 46.7505 31.0714 46.8007 31.5517 46.7157C32.0409 46.6225 32.5374 46.3943 33.0413 46.031C33.55 45.6698 34.0544 45.1746 34.5546 44.5455C34.8167 44.2201 35.0719 43.8595 35.3205 43.4637C35.7311 42.8097 36.5338 42.5078 37.2329 42.8133C38.0024 43.1494 38.3409 44.0803 37.9267 44.8236C37.4178 45.7366 36.8734 46.586 36.2933 47.3716C35.4331 48.5451 34.5331 49.5214 33.5931 50.3006C32.6572 51.0696 31.7182 51.585 30.7762 51.8469C29.8382 52.0985 28.934 52.04 28.0635 51.6715C26.7791 51.1278 25.8924 50.0016 25.4034 48.2931C24.9143 46.5846 24.87 44.3976 25.2703 41.7323C25.6706 39.0669 26.5564 36.0425 27.9277 32.659C29.3032 29.2653 30.7717 26.4876 32.3333 24.3259C33.8991 22.1539 35.446 20.6405 36.9738 19.7858C38.5018 18.9311 39.9031 18.7736 41.178 19.3133C41.9914 19.6577 42.648 20.2239 43.1479 21.0121C43.6477 21.8003 43.9779 22.7869 44.1385 23.972C44.3032 25.1469 44.2832 26.4957 44.0784 28.0186C43.9385 29.0998 43.6955 30.2535 43.3492 31.4798ZM38.3702 36.6062C38.7112 35.7648 39.6549 35.3653 40.4781 35.7138L40.557 35.7473C41.3803 36.0957 41.7711 37.0602 41.4302 37.9016C41.0892 38.7429 40.1455 39.1424 39.3223 38.7939L39.2433 38.7605C38.4201 38.412 38.0292 37.4474 38.3702 36.6062Z" fill="black" stroke="none"/>
  <path d="M41.4512 32.3839L43.7905 26.8587L43.79 26.8585L41.4512 32.3839ZM43.3492 31.4798L37.575 29.8491L37.575 29.8493L43.3492 31.4798ZM40.5734 30.5424L46.4234 31.8758L46.4234 31.8755L40.5734 30.5424ZM40.8092 29.1752L34.8483 28.4913L34.847 28.5018L34.8459 28.5124L40.8092 29.1752ZM40.8061 26.9757L34.873 27.8695L34.8731 27.8699L40.8061 26.9757ZM40.2318 25.3813L35.1903 28.6345L35.2285 28.6936L35.268 28.7519L40.2318 25.3813ZM39.1452 24.4528L41.4845 18.9276L41.4842 18.9275L39.1452 24.4528ZM36.5095 24.8505L39.6593 29.9572L39.674 29.9482L39.6886 29.9391L36.5095 24.8505ZM33.5472 27.9929L38.5142 31.3589L38.5183 31.3527L33.5472 27.9929ZM30.5893 33.7858L36.1499 36.0395L36.1499 36.0394L30.5893 33.7858ZM28.6418 40.0965L22.7357 39.0393L22.7335 39.0513L22.7314 39.0632L28.6418 40.0965ZM28.5747 44.4285L22.7459 45.8513L22.7526 45.8788L22.7596 45.9063L28.5747 44.4285ZM30.1748 46.5653L32.5138 41.04L32.5137 41.0399L30.1748 46.5653ZM31.5517 46.7157L32.5973 52.6239L32.636 52.617L32.6746 52.6097L31.5517 46.7157ZM33.0413 46.031L29.567 41.1393L29.5497 41.1516L29.5325 41.164L33.0413 46.031ZM34.5546 44.5455L29.8815 40.7823L29.8698 40.7968L29.8581 40.8115L34.5546 44.5455ZM35.3205 43.4637L40.4017 46.6545L40.4019 46.6542L35.3205 43.4637ZM37.2329 42.8133L34.8307 48.3114L34.8309 48.3115L37.2329 42.8133ZM37.9267 44.8236L43.1677 47.7445L43.1678 47.7443L37.9267 44.8236ZM36.2933 47.3716L31.4664 43.8078L31.4602 43.8161L31.4541 43.8245L36.2933 47.3716ZM33.5931 50.3006L37.4023 54.9363L37.4123 54.9281L37.4222 54.9199L33.5931 50.3006ZM30.7762 51.8469L32.3306 57.642L32.3568 57.635L32.383 57.6277L30.7762 51.8469ZM28.0635 51.6715L25.7245 57.1968L25.7246 57.1968L28.0635 51.6715ZM25.2703 41.7323L19.3369 40.8411L25.2703 41.7323ZM27.9277 32.659L22.3671 30.4053L22.3671 30.4054L27.9277 32.659ZM32.3333 24.3259L37.197 27.8394L37.2005 27.8346L32.3333 24.3259ZM36.9738 19.7858L34.0447 14.5494L34.0446 14.5495L36.9738 19.7858ZM41.178 19.3133L38.839 24.8386L38.839 24.8386L41.178 19.3133ZM43.1479 21.0121L48.215 17.7989L48.2148 17.7987L43.1479 21.0121ZM44.1385 23.972L38.1928 24.7777L38.1947 24.7914L38.1966 24.8052L44.1385 23.972ZM44.0784 28.0186L38.1319 27.2189L38.1299 27.234L38.1279 27.2492L44.0784 28.0186ZM40.4781 35.7138L38.1389 41.2391L38.1393 41.2392L40.4781 35.7138ZM38.3702 36.6062L32.8096 34.3523L32.8095 34.3524L38.3702 36.6062ZM40.557 35.7473L42.8959 30.2219L42.8959 30.2219L40.557 35.7473ZM41.4302 37.9016L35.8695 35.6479L35.8695 35.6479L41.4302 37.9016ZM39.3223 38.7939L41.6614 33.2686L41.6611 33.2685L39.3223 38.7939ZM39.2433 38.7605L36.9041 44.2857L36.9045 44.2858L39.2433 38.7605ZM12 22C12 16.4772 16.4772 12 22 12V0C9.84973 0 0 9.84974 0 22H12ZM12 48V22H0V48H12ZM22 58C16.4772 58 12 53.5228 12 48H0C0 60.1503 9.84974 70 22 70V58ZM48 58H22V70H48V58ZM58 48C58 53.5228 53.5228 58 48 58V70C60.1503 70 70 60.1503 70 48H58ZM58 22V48H70V22H58ZM48 12C53.5228 12 58 16.4772 58 22H70C70 9.84974 60.1503 0 48 0V12ZM22 12H48V0H22V12ZM39.1119 37.9091C43.1283 39.6096 47.8845 37.4976 49.1234 33.1103L37.575 29.8493C38.3484 27.1104 41.325 25.8149 43.7905 26.8587L39.1119 37.9091ZM34.7234 29.2091C33.993 32.4141 35.3893 36.3333 39.1123 37.9093L43.79 26.8585C46.1149 27.8427 46.8106 30.1771 46.4234 31.8758L34.7234 29.2091ZM34.8459 28.5124C34.8257 28.6941 34.7882 28.9249 34.7234 29.2093L46.4234 31.8755C46.5767 31.2029 46.6964 30.5224 46.7724 29.838L34.8459 28.5124ZM34.8731 27.8699C34.8726 27.867 34.8986 28.0529 34.8483 28.4913L46.77 29.8591C46.909 28.6479 46.9329 27.3675 46.7391 26.0815L34.8731 27.8699ZM35.268 28.7519C34.9316 28.2564 34.8747 27.8809 34.873 27.8695L46.7391 26.082C46.5441 24.7875 46.1044 23.349 45.1956 22.0107L35.268 28.7519ZM36.8059 29.978C36.0843 29.6724 35.529 29.1593 35.1903 28.6345L45.2733 22.1281C44.3801 20.7439 43.1004 19.6117 41.4845 18.9276L36.8059 29.978ZM39.6886 29.9391C39.66 29.9569 39.349 30.1478 38.7858 30.2328C38.1645 30.3266 37.4605 30.2551 36.8061 29.9781L41.4842 18.9275C38.3417 17.5971 35.3736 18.4855 33.3305 19.7619L39.6886 29.9391ZM38.5183 31.3527C38.8899 30.803 39.1925 30.4323 39.416 30.1952C39.644 29.9533 39.7309 29.9131 39.6593 29.9572L33.3597 19.7438C31.3676 20.9725 29.8113 22.8056 28.5762 24.6331L38.5183 31.3527ZM36.1499 36.0394C37.0113 33.9142 37.8136 32.3927 38.5142 31.3589L28.5803 24.6269C27.2567 26.5801 26.087 28.9205 25.0286 31.5321L36.1499 36.0394ZM34.5479 41.1536C34.7728 39.8974 35.2698 38.2109 36.1499 36.0395L25.0286 31.5321C23.9556 34.1794 23.1544 36.7001 22.7357 39.0393L34.5479 41.1536ZM34.4036 43.0057C34.4186 43.0671 34.3843 42.9595 34.3897 42.6145C34.3949 42.276 34.4369 41.7892 34.5522 41.1298L22.7314 39.0632C22.3524 41.2312 22.1981 43.6072 22.7459 45.8513L34.4036 43.0057ZM32.5137 41.0399C33.1342 41.3026 33.6409 41.7241 33.9853 42.184C34.2995 42.6036 34.3833 42.9246 34.3899 42.9507L22.7596 45.9063C23.3419 48.1976 24.8058 50.808 27.8359 52.0906L32.5137 41.0399ZM30.5061 40.8075C31.1358 40.6961 31.8549 40.761 32.5138 41.04L27.8358 52.0906C29.37 52.74 31.007 52.9053 32.5973 52.6239L30.5061 40.8075ZM29.5325 41.164C29.5686 41.138 29.8719 40.9278 30.4287 40.8217L32.6746 52.6097C34.2098 52.3172 35.5063 51.6506 36.5501 50.8981L29.5325 41.164ZM29.8581 40.8115C29.7408 40.959 29.6529 41.0531 29.598 41.107C29.543 41.1609 29.5313 41.1647 29.567 41.1393L36.5156 50.9228C37.5941 50.1568 38.4952 49.2303 39.251 48.2796L29.8581 40.8115ZM30.2392 40.2729C30.1009 40.4932 29.9803 40.6596 29.8815 40.7823L39.2277 48.3088C39.653 47.7806 40.0429 47.2258 40.4017 46.6545L30.2392 40.2729ZM39.6351 37.3151C35.8524 35.6624 32.0098 37.4531 30.2391 40.2732L40.4019 46.6542C39.4525 48.1663 37.2151 49.3531 34.8307 48.3114L39.6351 37.3151ZM43.1678 47.7443C45.377 43.78 43.5159 39.0105 39.6349 37.315L34.8309 48.3115C32.489 47.2883 31.3048 44.3806 32.6856 41.9029L43.1678 47.7443ZM41.1202 50.9355C41.862 49.9308 42.5432 48.865 43.1677 47.7445L32.6857 41.9026C32.2924 42.6082 31.8847 43.2411 31.4664 43.8078L41.1202 50.9355ZM37.4222 54.9199C38.8059 53.7729 40.0348 52.4163 41.1325 50.9188L31.4541 43.8245C30.8315 44.6739 30.2603 45.2699 29.764 45.6813L37.4222 54.9199ZM32.383 57.6277C34.299 57.0952 35.9701 56.1132 37.4023 54.9363L29.7838 45.665C29.3444 46.0261 29.1375 46.0749 29.1694 46.066L32.383 57.6277ZM25.7246 57.1968C27.8623 58.1018 30.1391 58.2299 32.3306 57.642L29.2217 46.0518C29.3397 46.0201 29.5351 45.9883 29.7817 46.0042C30.0303 46.0203 30.2447 46.0794 30.4024 46.1462L25.7246 57.1968ZM19.635 49.9442C20.4742 52.8761 22.3289 55.7594 25.7245 57.1968L30.4025 46.1462C30.5433 46.2058 30.6916 46.29 30.8327 46.3985C30.9732 46.5066 31.0778 46.6166 31.1492 46.7073C31.2882 46.8838 31.2516 46.9213 31.1717 46.642L19.635 49.9442ZM19.3369 40.8411C18.8687 43.9582 18.8195 47.0952 19.635 49.9442L31.1717 46.642C31.0091 46.074 30.8713 44.8371 31.2037 42.6235L19.3369 40.8411ZM22.3671 30.4054C20.8764 34.0835 19.8271 37.577 19.3369 40.8411L31.2037 42.6235C31.5141 40.5568 32.2365 38.0016 33.4884 34.9127L22.3671 30.4054ZM27.4697 20.8124C25.5433 23.4789 23.8614 26.7183 22.3671 30.4053L33.4884 34.9127C34.745 31.8123 36 29.4963 37.197 27.8394L27.4697 20.8124ZM34.0446 14.5495C31.4558 15.9977 29.2989 18.2749 27.4662 20.8172L37.2005 27.8346C38.4993 26.0329 39.4362 25.2834 39.9031 25.0222L34.0446 14.5495ZM43.517 13.788C40.0946 12.3392 36.72 13.0529 34.0447 14.5494L39.903 25.0222C40.1329 24.8937 40.1008 24.9599 39.8409 24.9891C39.7081 25.0041 39.5398 25.0061 39.3499 24.979C39.1593 24.9518 38.9856 24.9007 38.839 24.8386L43.517 13.788ZM48.2148 17.7987C47.1009 16.0423 45.5191 14.6356 43.517 13.788L38.839 24.8386C38.6823 24.7723 38.5149 24.6718 38.3621 24.54C38.2115 24.4102 38.1224 24.2909 38.0809 24.2255L48.2148 17.7987ZM50.0841 23.1663C49.839 21.3571 49.2885 19.4919 48.215 17.7989L38.0808 24.2253C38.0068 24.1087 38.1168 24.2167 38.1928 24.7777L50.0841 23.1663ZM50.0248 28.8184C50.2823 26.9039 50.3395 24.9874 50.0803 23.1389L38.1966 24.8052C38.2669 25.3064 38.2841 26.0876 38.1319 27.2189L50.0248 28.8184ZM49.1233 33.1105C49.5364 31.6478 49.8457 30.2041 50.0288 28.7881L38.1279 27.2492C38.0314 27.9955 37.8545 28.8593 37.575 29.8491L49.1233 33.1105ZM42.8172 30.1886C38.8273 28.4994 34.3752 30.4897 32.8096 34.3523L43.9307 38.86C43.0471 41.04 40.4825 42.2313 38.1389 41.2391L42.8172 30.1886ZM42.8959 30.2219L42.8169 30.1884L38.1393 41.2392L38.2182 41.2727L42.8959 30.2219ZM46.9909 40.1552C48.5308 36.3556 46.8159 31.8812 42.8959 30.2219L38.2182 41.2726C35.9446 40.3102 35.0115 37.7649 35.8695 35.6479L46.9909 40.1552ZM36.9832 44.3192C40.973 46.0082 45.4253 44.0182 46.9909 40.1552L35.8695 35.6479C36.7532 33.4675 39.318 32.2766 41.6614 33.2686L36.9832 44.3192ZM36.9045 44.2858L36.9834 44.3193L41.6611 33.2685L41.5821 33.2351L36.9045 44.2858ZM32.8095 34.3524C31.2694 38.1525 32.9849 42.6264 36.9041 44.2857L41.5825 33.2352C43.8554 34.1975 44.789 36.7424 43.9308 38.8599L32.8095 34.3524Z" fill="white" stroke="none" mask="url(#path-1-outside-1_1233_12577)"/>
</svg>`;

const ParaBrand = `<svg width="843" height="207" viewBox="0 0 843 207" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 0H144C183.764 0 216 32.2355 216 72C216 111.765 183.764 144 144 144H96C82.7452 144 72 154.745 72 168V204H0V132H36C49.2548 132 60 121.255 60 108L60 0Z" fill="#FF4E00"/>
<path d="M319.68 203.8H288V19H381.72C419.472 19 442.44 44.08 442.44 77.08C442.44 114.304 416.568 137.008 381.72 137.008H319.68V203.8ZM319.68 47.512V108.496H380.136C399.936 108.496 410.232 93.712 410.232 77.08C410.232 59.656 398.352 47.512 380.136 47.512H319.68Z" fill="#161514"/>
<path d="M500.768 206.048C468.56 206.048 447.44 190.472 447.704 164.336C447.968 131.6 480.44 124.736 507.632 121.568C528.752 119.192 544.328 118.4 544.592 107.312C544.328 93.584 533.768 84.608 515.816 84.608C497.336 84.608 484.136 94.64 482.288 109.16H450.872C453.776 79.592 480.176 59 516.344 59C554.096 59 574.952 79.592 574.952 109.424V172.784C574.952 176.744 577.064 178.856 581.816 178.856H589.472V203.144H574.688C560.432 203.144 551.72 197.336 549.344 186.776C548.816 185.456 548.288 183.608 548.024 182.024C539.84 197.072 524.528 206.048 500.768 206.048ZM507.104 181.496C528.488 181.496 544.592 169.352 544.592 150.608V131.072C539.312 139.256 525.848 141.104 511.064 142.952C493.64 145.064 479.12 147.44 479.12 162.224C479.12 174.368 488.888 181.496 507.104 181.496Z" fill="#161514"/>
<path d="M640.88 203.504H609.728V63.584H634.808L638.504 91.04C647.48 72.032 663.848 62 687.08 62H692.36V92.36H687.08C658.04 92.36 640.88 107.936 640.88 134.336V203.504Z" fill="#161514"/>
<path d="M753.794 206.048C721.586 206.048 700.466 190.472 700.73 164.336C700.994 131.6 733.466 124.736 760.658 121.568C781.778 119.192 797.354 118.4 797.618 107.312C797.354 93.584 786.794 84.608 768.842 84.608C750.362 84.608 737.162 94.64 735.314 109.16H703.898C706.802 79.592 733.202 59 769.37 59C807.122 59 827.978 79.592 827.978 109.424V172.784C827.978 176.744 830.09 178.856 834.842 178.856H842.498V203.144H827.714C813.458 203.144 804.746 197.336 802.37 186.776C801.842 185.456 801.314 183.608 801.05 182.024C792.866 197.072 777.554 206.048 753.794 206.048ZM760.13 181.496C781.514 181.496 797.618 169.352 797.618 150.608V131.072C792.338 139.256 778.874 141.104 764.09 142.952C746.666 145.064 732.146 147.44 732.146 162.224C732.146 174.368 741.914 181.496 760.13 181.496Z" fill="#161514"/>
</svg>
`;

const ParaIconBrand = `<svg width="216" height="204" viewBox="0 0 216 204" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 0H144C183.764 0 216 32.2355 216 72C216 111.765 183.764 144 144 144H96C82.7452 144 72 154.745 72 168V204H0V132H36C49.2548 132 60 121.255 60 108L60 0Z" fill="#FF4E00"/>
</svg>
`;

const ParaIconQr = `<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="path-1-outside-1_121_5893" maskUnits="userSpaceOnUse" x="0" y="0" width="70" height="70" fill="black">
<rect fill="white" width="70" height="70"/>
<path d="M6 22C6 13.1634 13.1634 6 22 6H48C56.8366 6 64 13.1634 64 22V48C64 56.8366 56.8366 64 48 64H22C13.1634 64 6 56.8366 6 48V22Z"/>
</mask>
<path d="M6 22C6 13.1634 13.1634 6 22 6H48C56.8366 6 64 13.1634 64 22V48C64 56.8366 56.8366 64 48 64H22C13.1634 64 6 56.8366 6 48V22Z" fill="#FF4E00"/>
<path d="M22 12H48V0H22V12ZM58 22V48H70V22H58ZM48 58H22V70H48V58ZM12 48V22H0V48H12ZM22 58C16.4772 58 12 53.5228 12 48H0C0 60.1503 9.84974 70 22 70V58ZM58 48C58 53.5228 53.5228 58 48 58V70C60.1503 70 70 60.1503 70 48H58ZM48 12C53.5228 12 58 16.4772 58 22H70C70 9.84973 60.1503 0 48 0V12ZM22 0C9.84973 0 0 9.84974 0 22H12C12 16.4772 16.4772 12 22 12V0Z" fill="white" mask="url(#path-1-outside-1_121_5893)"/>
<path d="M29.9608 24H39.7059C44.3191 24 48.0588 27.7397 48.0588 32.3529C48.0588 36.9661 44.3191 40.7059 39.7059 40.7059H34.1373C32.5995 40.7059 31.3529 41.9525 31.3529 43.4902V47.6667H23V39.3137H27.1765C28.7142 39.3137 29.9608 38.0671 29.9608 36.5294L29.9608 24Z" fill="#FCF9F7"/>
</svg>
`;

const ParaIcon = `<svg width="216" height="204" viewBox="0 0 216 204" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 0H144C183.764 0 216 32.2355 216 72C216 111.765 183.764 144 144 144H96C82.7452 144 72 154.745 72 168V204H0V132H36C49.2548 132 60 121.255 60 108L60 0Z"/>
</svg>
`;

const ParaLogo = `<svg width="66" height="18" viewBox="0 0 66 18" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1065_1067)">
<path d="M8.90893 5.98154C8.79593 6.37659 8.36391 6.57225 7.98741 6.41488C7.64799 6.27305 7.4779 5.89324 7.56125 5.53225C7.61419 5.30292 7.65233 5.08449 7.6757 4.87695C7.72165 4.48163 7.72115 4.13023 7.6742 3.82275C7.62728 3.51526 7.53433 3.26052 7.39539 3.05853C7.26076 2.85258 7.0849 2.70424 6.8678 2.6135C6.48209 2.45231 6.05553 2.51587 5.58813 2.80414C5.12272 3.08752 4.64333 3.58956 4.14988 4.31029C3.65849 5.0261 3.17976 5.95161 2.71371 7.08679C2.23959 8.24161 1.9244 9.24985 1.76818 10.1115C1.61628 10.9692 1.60543 11.6613 1.73562 12.1878C1.87013 12.7104 2.1291 13.0518 2.51249 13.212C2.72496 13.3008 2.9478 13.3248 3.18098 13.2841C3.4185 13.2394 3.65959 13.13 3.90425 12.9559C4.15121 12.7828 4.39612 12.5454 4.63897 12.2439C4.76621 12.0879 4.89014 11.9151 5.01082 11.7254C5.2102 11.4119 5.5999 11.2672 5.93935 11.4136C6.31297 11.5748 6.47729 12.021 6.2762 12.3772C6.02913 12.8148 5.76478 13.2219 5.48314 13.5985C5.06553 14.1609 4.62853 14.6288 4.17213 15.0023C3.71776 15.3709 3.26186 15.6179 2.80446 15.7434C2.34908 15.864 1.91005 15.836 1.4874 15.6594C0.863804 15.3988 0.433286 14.859 0.195844 14.0401C-0.0415976 13.2212 -0.0631333 12.173 0.131237 10.8955C0.325607 9.61802 0.755687 8.16844 1.42148 6.54674C2.08929 4.92015 2.80228 3.58879 3.5605 2.55268C4.32072 1.51165 5.07175 0.786304 5.81357 0.376648C6.55541 -0.0330046 7.2358 -0.108495 7.85478 0.150177C8.24973 0.315224 8.56852 0.58663 8.8112 0.964396C9.05387 1.34216 9.21418 1.81505 9.29215 2.38307C9.37214 2.94618 9.36242 3.59269 9.26298 4.32262C9.19509 4.84082 9.07707 5.39378 8.90893 5.98154Z" />
<path d="M6.49147 8.43862C6.65703 8.03538 7.11524 7.84389 7.5149 8.01093L7.55325 8.02695C7.95294 8.19397 8.14272 8.65626 7.97718 9.0595C7.81163 9.46274 7.35342 9.65423 6.95374 9.4872L6.91539 9.47117C6.51573 9.30414 6.32592 8.84184 6.49147 8.43862Z" />
<path d="M21.3294 13.6657C21.0839 13.8198 20.8008 13.9683 20.4803 14.1113C20.1599 14.2544 19.8075 14.3644 19.4229 14.4414C19.0384 14.5295 18.6219 14.5735 18.1733 14.5735C17.3082 14.5735 16.5231 14.4194 15.8182 14.1113C15.1133 13.7923 14.5098 13.3631 14.0078 12.824C13.5058 12.2738 13.116 11.6467 12.8383 10.9425C12.5712 10.2273 12.4377 9.46806 12.4377 8.66485C12.4377 7.80662 12.5819 7.00891 12.8703 6.2717C13.1587 5.5345 13.5646 4.89082 14.0879 4.34067C14.6113 3.79051 15.2201 3.3614 15.9143 3.05331C16.6086 2.74523 17.3616 2.59119 18.1733 2.59119C18.7714 2.59119 19.3322 2.67371 19.8555 2.83875C20.3789 3.0038 20.8541 3.21835 21.2814 3.48244L20.945 4.22514C20.5711 3.98307 20.1492 3.77951 19.6793 3.61447C19.2093 3.44942 18.7127 3.3669 18.1893 3.3669C17.5164 3.3669 16.8809 3.50443 16.2828 3.77951C15.6847 4.04358 15.156 4.4177 14.6967 4.90181C14.2481 5.37495 13.8957 5.93059 13.6393 6.56878C13.383 7.20694 13.2548 7.89464 13.2548 8.63184C13.2548 9.33603 13.367 10.0017 13.5913 10.6289C13.8262 11.2561 14.1573 11.8062 14.5846 12.2793C15.0225 12.7525 15.5458 13.1266 16.1547 13.4016C16.7634 13.6657 17.4417 13.7978 18.1893 13.7978C18.7447 13.7978 19.2521 13.7207 19.7113 13.5667C20.1813 13.4016 20.5978 13.1981 20.961 12.956L21.3294 13.6657Z" />
<path d="M26.4465 14.5732C25.8484 14.5732 25.3036 14.4357 24.8124 14.1606C24.3317 13.8745 23.9472 13.4784 23.6589 12.9723C23.381 12.4661 23.2422 11.8775 23.2422 11.2063C23.2422 10.4911 23.3918 9.88041 23.6909 9.37428C23.9899 8.85715 24.3958 8.46653 24.9084 8.20247C25.421 7.92739 26.0032 7.78986 26.6548 7.78986C27.2102 7.78986 27.7336 7.9604 28.2248 8.30149C28.7268 8.64257 29.0846 9.0717 29.2983 9.58883L29.1861 9.8199L29.2822 7.98789H29.9552V14.4412H29.202V12.4441L29.3623 12.7412C29.2875 12.9613 29.1595 13.1813 28.9779 13.4014C28.7963 13.6104 28.572 13.8085 28.3049 13.9956C28.0486 14.1716 27.7601 14.3146 27.4397 14.4247C27.1301 14.5237 26.7991 14.5732 26.4465 14.5732ZM26.6067 13.913C27.0767 13.913 27.4986 13.814 27.8724 13.6159C28.257 13.4069 28.5666 13.1208 28.8015 12.7577C29.0366 12.3946 29.1701 11.9765 29.202 11.5034V10.5791C29.1168 10.172 28.9457 9.80891 28.6894 9.48981C28.4437 9.17072 28.1395 8.91766 27.7763 8.73059C27.4131 8.54355 27.018 8.45004 26.5907 8.45004C26.1206 8.45004 25.6881 8.56555 25.293 8.79662C24.8979 9.01667 24.5826 9.33027 24.3477 9.73738C24.1128 10.1445 23.9953 10.6231 23.9953 11.1733C23.9953 11.6794 24.1128 12.1415 24.3477 12.5597C24.5826 12.9668 24.8979 13.2969 25.293 13.5499C25.6989 13.792 26.1368 13.913 26.6067 13.913Z" />
<path d="M36.2611 14.5732C35.663 14.5732 35.1023 14.4137 34.5789 14.0946C34.0555 13.7645 33.6709 13.3409 33.4252 12.8237L33.5535 12.5431V17.544H32.8005V7.93838H33.4734L33.5535 10.051L33.4092 9.57234C33.6869 9.05519 34.0928 8.63158 34.6268 8.30149C35.161 7.9604 35.7431 7.78986 36.3732 7.78986C36.9713 7.78986 37.5106 7.93838 37.9913 8.23546C38.4719 8.53256 38.8511 8.93967 39.1288 9.4568C39.4172 9.96293 39.5615 10.5461 39.5615 11.2063C39.5615 11.8554 39.4118 12.4386 39.1128 12.9558C38.8243 13.4619 38.4292 13.858 37.9272 14.1441C37.4359 14.4302 36.8806 14.5732 36.2611 14.5732ZM36.1329 13.9295C36.6243 13.9295 37.0674 13.8085 37.4627 13.5664C37.8684 13.3244 38.1889 12.9998 38.424 12.5927C38.6695 12.1745 38.7924 11.7124 38.7924 11.2063C38.7924 10.6891 38.6749 10.227 38.44 9.8199C38.2048 9.40179 37.8898 9.0717 37.4947 8.82963C37.1101 8.58757 36.6722 8.46653 36.181 8.46653C35.7109 8.46653 35.2838 8.57657 34.8993 8.79662C34.5147 9.01667 34.2051 9.31377 33.97 9.68787C33.735 10.062 33.5962 10.4856 33.5535 10.9587V11.4869C33.5854 11.938 33.7191 12.3506 33.954 12.7247C34.1997 13.0988 34.5093 13.3959 34.8833 13.6159C35.2677 13.825 35.6844 13.9295 36.1329 13.9295Z" />
<path d="M43.2706 14.5734C42.9075 14.5734 42.5283 14.5074 42.1332 14.3754C41.738 14.2323 41.4176 14.0068 41.1719 13.6987L41.5243 13.1871C41.738 13.4181 41.9889 13.6052 42.2774 13.7482C42.5764 13.8803 42.8915 13.9463 43.2225 13.9463C43.4682 13.9463 43.6979 13.9133 43.9115 13.8472C44.1358 13.7702 44.3174 13.6437 44.4563 13.4676C44.5951 13.2916 44.6644 13.055 44.6644 12.7579C44.6644 12.4499 44.5791 12.2133 44.4081 12.0482C44.2479 11.8832 44.0397 11.7512 43.7832 11.6521C43.5377 11.5421 43.276 11.4431 42.9983 11.355C42.5391 11.201 42.1599 10.9919 41.8607 10.7279C41.5724 10.4638 41.4282 10.0897 41.4282 9.60558C41.4282 9.25348 41.5083 8.9454 41.6685 8.68132C41.8395 8.41726 42.069 8.2137 42.3575 8.07065C42.6458 7.91662 42.9716 7.8396 43.3348 7.8396C43.6658 7.8396 43.9916 7.89461 44.312 8.00464C44.643 8.11466 44.9421 8.30172 45.2092 8.56578L44.8728 9.11045C44.7018 8.86838 44.4722 8.70334 44.1838 8.61531C43.9061 8.52729 43.6604 8.47776 43.4468 8.46677C43.2652 8.46677 43.0731 8.50528 42.8701 8.5823C42.6779 8.65932 42.5123 8.77486 42.3735 8.92889C42.2452 9.07194 42.1811 9.26447 42.1811 9.50654C42.1811 9.75961 42.2506 9.96869 42.3895 10.1337C42.5283 10.2878 42.7045 10.4143 42.9182 10.5133C43.1424 10.6123 43.3721 10.7059 43.607 10.7939C43.9169 10.8929 44.2051 11.014 44.4722 11.157C44.7499 11.289 44.9742 11.4706 45.145 11.7017C45.3266 11.9217 45.4175 12.2188 45.4175 12.5929C45.4175 12.967 45.3374 13.3081 45.1772 13.6162C45.017 13.9133 44.7767 14.1498 44.4563 14.3259C44.1464 14.4909 43.7513 14.5734 43.2706 14.5734Z" />
<path d="M49.6658 14.6229C49.0783 14.6229 48.6084 14.4469 48.2559 14.0948C47.9035 13.7317 47.7165 13.2641 47.6953 12.6919V7.9881H48.4482V12.4608C48.4696 12.8789 48.5977 13.2255 48.8328 13.5006C49.0783 13.7757 49.4415 13.9242 49.9221 13.9462C50.328 13.9462 50.7072 13.8362 51.0596 13.6161C51.4122 13.3961 51.695 13.099 51.9088 12.7249C52.1331 12.3398 52.2452 11.9052 52.2452 11.421V7.9881H52.9981V14.4414H52.3253L52.2452 12.4113L52.3573 12.8569C52.2506 13.187 52.0582 13.4896 51.7805 13.7647C51.5137 14.0288 51.1932 14.2378 50.8193 14.3919C50.4561 14.5459 50.0717 14.6229 49.6658 14.6229Z" />
<path d="M55.8464 1.89771H56.5996V14.4411H55.8464V1.89771Z" />
<path d="M62.1687 14.5734C61.5171 14.5734 60.9403 14.4249 60.4383 14.1278C59.9363 13.8307 59.5412 13.4291 59.2529 12.923C58.9752 12.4058 58.8362 11.8282 58.8362 11.19C58.8362 10.5628 58.9858 9.99067 59.2849 9.47354C59.5839 8.95639 59.9844 8.54378 60.4865 8.23568C60.9991 7.92761 61.5652 7.77356 62.1847 7.77356C62.9324 7.77356 63.5571 7.99913 64.0591 8.45026C64.5719 8.90138 64.9403 9.49003 65.1646 10.2162L59.6854 12.3948L59.4611 11.8337L64.4756 9.82012L64.3154 10.0512C64.134 9.61107 63.8561 9.23147 63.4824 8.91238C63.1192 8.59329 62.6707 8.43374 62.1365 8.43374C61.6559 8.43374 61.2234 8.55477 60.8388 8.79684C60.4545 9.03891 60.1447 9.3635 59.9097 9.77061C59.6854 10.1777 59.5733 10.6399 59.5733 11.157C59.5733 11.6411 59.68 12.0922 59.8938 12.5104C60.1179 12.9285 60.4277 13.2641 60.8229 13.5171C61.218 13.7702 61.6721 13.8967 62.1847 13.8967C62.5265 13.8967 62.8523 13.8307 63.1619 13.6987C63.4824 13.5666 63.7654 13.3961 64.0112 13.187L64.3955 13.7482C64.0965 13.9903 63.7495 14.1883 63.3543 14.3424C62.9698 14.4964 62.5746 14.5734 62.1687 14.5734Z" />
</g>
<defs>
<clipPath id="clip0_1065_1067">
<rect width="65.1646" height="17.5443" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ParaRingsDark = `<svg width="136" height="143" viewBox="0 0 136 143" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="68" cy="75" r="29.5" stroke="#1F1F1F"/>
<circle cx="68" cy="75" r="49.5" stroke="#1F1F1F"/>
<circle cx="68" cy="75" r="67.5" stroke="#1F1F1F"/>
<path d="M89.02 57.6576C88.3792 59.8805 85.9296 60.9815 83.7947 60.096C81.8701 59.2979 80.9057 57.1608 81.3783 55.1295C81.6785 53.8391 81.8947 52.61 82.0272 51.4422C82.2878 49.2178 82.285 47.2405 82.0188 45.5103C81.7527 43.7801 81.2256 42.3467 80.4378 41.2101C79.6744 40.0512 78.6773 39.2165 77.4463 38.706C75.2591 37.7989 72.8404 38.1566 70.1901 39.7786C67.5512 41.3732 64.8329 44.1982 62.0349 48.2537C59.2486 52.2815 56.534 57.4892 53.8914 63.8768C51.203 70.3748 49.4158 76.0481 48.53 80.8965C47.6687 85.7227 47.6071 89.6171 48.3453 92.5798C49.1081 95.5201 50.5765 97.4412 52.7504 98.3427C53.9552 98.8423 55.2188 98.9776 56.541 98.7484C57.8878 98.497 59.2548 97.8816 60.6421 96.9019C62.0424 95.9275 63.4311 94.5922 64.8081 92.8955C65.5296 92.0178 66.2324 91.0453 66.9167 89.9778C68.0472 88.214 70.2569 87.3998 72.1817 88.2236C74.3002 89.1303 75.232 91.6409 74.0917 93.6454C72.6908 96.1079 71.1918 98.3985 69.5948 100.517C67.2268 103.682 64.749 106.315 62.161 108.417C59.5846 110.491 56.9995 111.881 54.406 112.587C51.8238 113.266 49.3344 113.108 46.9379 112.114C43.4019 110.648 40.9608 107.61 39.6144 103.003C38.268 98.3948 38.1459 92.4966 39.2481 85.3082C40.3502 78.1198 42.7889 69.9631 46.5641 60.838C50.3508 51.6853 54.3936 44.1938 58.6929 38.3637C63.0036 32.5059 67.2621 28.4245 71.4685 26.1194C75.6749 23.8143 79.5329 23.3895 83.0427 24.845C85.2821 25.7737 87.0898 27.3009 88.4659 29.4266C89.8418 31.5522 90.7509 34.2132 91.193 37.4094C91.6465 40.5779 91.5914 44.2158 91.0275 48.323C90.6426 51.2389 89.9734 54.3504 89.02 57.6576Z" fill="#FAFAFA"/>
<path d="M74.8659 71.539C75.8469 69.3089 78.5617 68.2499 80.9296 69.1737L81.1568 69.2623C83.5248 70.186 84.6493 72.7426 83.6685 74.9727C82.6876 77.2028 79.9728 78.2618 77.6048 77.338L77.3776 77.2494C75.0097 76.3257 73.8851 73.769 74.8659 71.539Z" fill="#FAFAFA"/>
<rect x="12.5" y="48.5" width="19" height="19" rx="3.5" fill="black"/>
<rect x="12.5" y="48.5" width="19" height="19" rx="3.5" stroke="#1F1F1F"/>
<path d="M20.0125 52.0719C20.8012 51.7495 21.6464 51.5835 22.5 51.5835V54.7918C22.0732 54.7918 21.6506 54.8748 21.2563 55.0361C20.862 55.1973 20.5037 55.4336 20.2019 55.7315C19.9001 56.0294 19.6607 56.3831 19.4974 56.7724C19.3341 57.1616 19.25 57.5788 19.25 58.0002H16C16 57.1575 16.1681 56.3231 16.4948 55.5446C16.8215 54.7661 17.3002 54.0588 17.9038 53.4629C18.5074 52.867 19.2239 52.3944 20.0125 52.0719Z" fill="#155EEF"/>
<path d="M16 58C16 58.8426 16.1681 59.6771 16.4948 60.4556C16.8215 61.2341 17.3002 61.9414 17.9038 62.5373C18.5074 63.1331 19.2239 63.6057 20.0125 63.9282C20.8012 64.2507 21.6464 64.4167 22.5 64.4167C23.3536 64.4167 24.1988 64.2507 24.9875 63.9282C25.7761 63.6057 26.4926 63.1331 27.0962 62.5373C27.6998 61.9414 28.1785 61.2341 28.5052 60.4556C28.8319 59.6771 29 58.8426 29 58H25.75C25.75 58.4213 25.6659 58.8385 25.5026 59.2278C25.3393 59.617 25.0999 59.9707 24.7981 60.2686C24.4963 60.5666 24.138 60.8029 23.7437 60.9641C23.3494 61.1254 22.9268 61.2083 22.5 61.2083C22.0732 61.2083 21.6506 61.1254 21.2563 60.9641C20.862 60.8029 20.5037 60.5666 20.2019 60.2686C19.9001 59.9707 19.6607 59.617 19.4974 59.2278C19.3341 58.8385 19.25 58.4213 19.25 58H16Z" fill="#84ADFF"/>
<path d="M22.5001 55.9585C21.3578 55.9585 20.4319 56.8726 20.4319 58.0002H24.5682C24.5682 56.8726 23.6423 55.9585 22.5001 55.9585Z" fill="#84ADFF"/>
<path d="M22.5001 60.042C21.3578 60.042 20.4319 59.1279 20.4319 58.0003H24.5682C24.5682 59.1279 23.6423 60.042 22.5001 60.042Z" fill="#155EEF"/>
<rect x="8.5" y="108.5" width="19" height="19" rx="3.5" fill="black"/>
<rect x="8.5" y="108.5" width="19" height="19" rx="3.5" stroke="#1F1F1F"/>
<path d="M22.5521 113.489C22.4146 113.354 22.2771 113.219 22.1396 113.083C21.727 112.651 21.2869 112.219 20.7368 111.949C20.1042 111.625 19.4166 111.706 18.7289 111.706C17.6838 111.706 15.0708 111.706 13.5305 111.706L14.5757 113.083C16.4735 113.083 19.4441 113.083 20.8193 113.083C21.3969 113.083 21.892 113.192 22.3596 113.489C22.4421 113.516 22.5246 113.516 22.5521 113.489Z" fill="#66C61C"/>
<path d="M23.7072 115.704C23.5697 115.568 23.4321 115.433 23.2946 115.298C22.882 114.866 22.442 114.434 21.8919 114.164C21.2593 113.84 20.5716 113.921 19.884 113.921C18.9763 113.921 16.8035 113.921 15.2632 113.921L16.3084 115.298C18.1787 115.298 20.7367 115.298 22.0019 115.298C22.5795 115.298 23.0746 115.406 23.5422 115.704C23.5972 115.731 23.6522 115.731 23.7072 115.704Z" fill="#4CA30D"/>
<path d="M25.0001 117.865C24.8626 117.73 24.725 117.595 24.5875 117.459C24.175 117.027 23.7349 116.595 23.1848 116.325C22.5522 116.001 21.8645 116.082 21.1769 116.082C20.3243 116.082 18.4539 116.082 16.9412 116.082L17.9863 117.459C19.8017 117.459 22.1121 117.459 23.2673 117.459C23.8449 117.459 24.34 117.568 24.8076 117.865C24.8901 117.892 24.9451 117.919 25.0001 117.865Z" fill="#3B7C0F"/>
<path d="M13.4204 121.511C13.5579 121.647 13.6955 121.782 13.833 121.917C14.2456 122.349 14.6856 122.781 15.2357 123.051C15.8683 123.375 16.556 123.294 17.2436 123.294H22.442L21.3968 121.917C19.499 121.917 16.5285 121.917 15.1532 121.917C14.5756 121.917 14.0805 121.809 13.6129 121.511C13.5304 121.484 13.4754 121.484 13.4204 121.511Z" fill="#66C61C"/>
<path d="M12.2651 119.297C12.4027 119.432 12.5402 119.567 12.6777 119.702C13.0903 120.134 13.5304 120.566 14.0805 120.836C14.7131 121.161 15.4007 121.08 16.0883 121.08H20.7091L19.664 119.702C17.7936 119.702 15.2357 119.702 13.9704 119.702C13.3928 119.702 12.8977 119.594 12.4302 119.297C12.3752 119.27 12.3201 119.27 12.2651 119.297Z" fill="#4CA30D"/>
<path d="M11 117.108C11.1375 117.243 11.275 117.378 11.4126 117.513C11.8251 117.946 12.2652 118.378 12.8153 118.648C13.4479 118.972 14.1356 118.891 14.8232 118.891H19.0589L18.0138 117.513C16.1984 117.513 13.888 117.513 12.7328 117.513C12.1552 117.513 11.6601 117.405 11.1925 117.108C11.11 117.081 11.055 117.081 11 117.108Z" fill="#3B7C0F"/>
<rect x="91.5" y="98.5" width="19" height="19" rx="3.5" fill="black"/>
<rect x="91.5" y="98.5" width="19" height="19" rx="3.5" stroke="#1F1F1F"/>
<path d="M106.162 108C104.886 109.158 103.032 109.887 100.968 109.887C98.9046 109.887 97.0504 109.158 95.7744 108C97.0504 106.842 98.9046 106.113 100.968 106.113C103.032 106.113 104.886 106.842 106.162 108Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M94 111.775C94 108.648 97.1198 106.113 100.968 106.113C98.9045 106.113 97.0503 106.842 95.7744 108C97.0503 109.158 98.9046 109.887 100.968 109.887C103.032 109.887 104.886 109.158 106.162 108C107.266 109.002 107.937 110.324 107.937 111.775V113.913C107.937 114.191 107.659 114.417 107.317 114.417H94.6194C94.2773 114.417 94 114.191 94 113.913V111.775ZM106.162 108C106.162 108 106.162 108 106.162 108V108Z" fill="#7CD4FD"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M98.3546 109.476C97.3596 109.148 96.4788 108.64 95.7744 108C97.0503 106.842 98.9046 106.113 100.968 106.113C103.032 106.113 104.886 106.842 106.162 108C106.162 108 106.162 108 106.162 108C107.266 106.998 107.937 105.676 107.937 104.226V102.087C107.937 101.809 107.659 101.583 107.317 101.583L94.6194 101.583C94.2773 101.583 94 101.809 94 102.087L94 104.226C94 106.602 95.8012 108.636 98.3546 109.476Z" fill="#0BA5EC"/>
<rect x="116.5" y="28.5" width="19" height="19" rx="3.5" fill="black"/>
<rect x="116.5" y="28.5" width="19" height="19" rx="3.5" stroke="#1F1F1F"/>
<path d="M128.682 31.5835H123.318L119 35.5417V40.4586L123.318 44.4168H128.682L133 40.4586V35.5417L128.682 31.5835ZM124.06 40.5204L121.294 37.9847L124.06 35.449C125.106 34.4903 126.827 34.4903 127.872 35.449L130.639 37.9847L127.872 40.5204C126.827 41.4791 125.14 41.4791 124.06 40.5204Z" fill="#444CE7"/>
<rect x="42.5" y="0.5" width="19" height="19" rx="3.5" fill="black"/>
<rect x="42.5" y="0.5" width="19" height="19" rx="3.5" stroke="#1F1F1F"/>
<path d="M51.5 3.5835C47.9101 3.5835 45 6.45634 45 10.0002C45 13.544 47.9101 16.4168 51.5 16.4168C54.7208 16.4168 57.3944 14.1044 57.9101 11.0696H57.8635C57.3824 12.9146 55.6858 14.2779 53.6667 14.2779C51.2734 14.2779 49.3333 12.3627 49.3333 10.0002C49.3333 7.63761 51.2734 5.72239 53.6667 5.72239C55.6858 5.72239 57.3824 7.08568 57.8635 8.93072H57.9101C57.3944 5.89594 54.7208 3.5835 51.5 3.5835Z" fill="#A4BCFD"/>
<path d="M45 10.0002C45 6.45634 47.9102 3.5835 51.5 3.5835C54.7207 3.5835 57.3944 5.89594 57.9101 8.93072H53.5301C53.0491 7.08568 51.3525 5.72239 49.3333 5.72239C46.9401 5.72239 45 7.63761 45 10.0002Z" fill="#3538CD"/>
<path d="M45 10.0003C45 13.5442 47.9102 16.417 51.5 16.417C54.7207 16.417 57.3944 14.1045 57.9101 11.0698H53.5301C53.0491 12.9148 51.3525 14.2781 49.3333 14.2781C46.9401 14.2781 45 12.3629 45 10.0003Z" fill="#3538CD"/>
</svg>
`;

const ParaRings = `<svg width="136" height="143" viewBox="0 0 136 143" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="68" cy="75" r="29.5" stroke="#E0E0E0"/>
<circle cx="68" cy="75" r="49.5" stroke="#E0E0E0"/>
<circle cx="68" cy="75" r="67.5" stroke="#E0E0E0"/>
<path d="M89.02 57.6576C88.3792 59.8805 85.9296 60.9815 83.7947 60.096C81.8701 59.2979 80.9057 57.1608 81.3783 55.1295C81.6785 53.8391 81.8947 52.61 82.0272 51.4422C82.2878 49.2178 82.285 47.2405 82.0188 45.5103C81.7527 43.7801 81.2256 42.3467 80.4378 41.2101C79.6744 40.0512 78.6773 39.2165 77.4463 38.706C75.2591 37.7989 72.8404 38.1566 70.1901 39.7786C67.5512 41.3732 64.8329 44.1982 62.0349 48.2537C59.2486 52.2815 56.534 57.4892 53.8914 63.8768C51.203 70.3748 49.4158 76.0481 48.53 80.8965C47.6687 85.7227 47.6071 89.6171 48.3453 92.5798C49.1081 95.5201 50.5765 97.4412 52.7504 98.3427C53.9552 98.8423 55.2188 98.9776 56.541 98.7484C57.8878 98.497 59.2548 97.8816 60.6421 96.9019C62.0424 95.9275 63.4311 94.5922 64.8081 92.8955C65.5296 92.0178 66.2324 91.0453 66.9167 89.9778C68.0472 88.214 70.2569 87.3998 72.1817 88.2236C74.3002 89.1303 75.232 91.6409 74.0917 93.6454C72.6908 96.1079 71.1918 98.3985 69.5948 100.517C67.2268 103.682 64.749 106.315 62.161 108.417C59.5846 110.491 56.9995 111.881 54.406 112.587C51.8238 113.266 49.3344 113.108 46.9379 112.114C43.4019 110.648 40.9608 107.61 39.6144 103.003C38.268 98.3948 38.1459 92.4966 39.2481 85.3082C40.3502 78.1198 42.7889 69.9631 46.5641 60.838C50.3508 51.6853 54.3936 44.1938 58.6929 38.3637C63.0036 32.5059 67.2621 28.4245 71.4685 26.1194C75.6749 23.8143 79.5329 23.3895 83.0427 24.845C85.2821 25.7737 87.0898 27.3009 88.4659 29.4266C89.8418 31.5522 90.7509 34.2132 91.193 37.4094C91.6465 40.5779 91.5914 44.2158 91.0275 48.323C90.6426 51.2389 89.9734 54.3504 89.02 57.6576Z" fill="#121212"/>
<path d="M74.866 71.5389C75.8469 69.3088 78.5617 68.2498 80.9296 69.1735L81.1569 69.2622C83.5249 70.1858 84.6493 72.7425 83.6685 74.9726C82.6877 77.2026 79.9729 78.2617 77.6049 77.3379L77.3776 77.2493C75.0097 76.3255 73.8852 73.7688 74.866 71.5389Z" fill="#121212"/>
<rect x="12.5" y="48.5" width="19" height="19" rx="3.5" fill="white"/>
<rect x="12.5" y="48.5" width="19" height="19" rx="3.5" stroke="#E0E0E0"/>
<path d="M20.0125 52.0718C20.8012 51.7493 21.6464 51.5833 22.5 51.5833V54.7917C22.0732 54.7917 21.6506 54.8747 21.2563 55.0359C20.862 55.1971 20.5037 55.4335 20.2019 55.7314C19.9001 56.0293 19.6607 56.383 19.4974 56.7722C19.3341 57.1615 19.25 57.5787 19.25 58H16C16 57.1574 16.1681 56.323 16.4948 55.5444C16.8215 54.7659 17.3002 54.0586 17.9038 53.4627C18.5074 52.8669 19.2239 52.3943 20.0125 52.0718Z" fill="#155EEF"/>
<path d="M16 58C16 58.8426 16.1681 59.6771 16.4948 60.4556C16.8215 61.2341 17.3002 61.9414 17.9038 62.5373C18.5074 63.1331 19.2239 63.6057 20.0125 63.9282C20.8012 64.2507 21.6464 64.4167 22.5 64.4167C23.3536 64.4167 24.1988 64.2507 24.9875 63.9282C25.7761 63.6057 26.4926 63.1331 27.0962 62.5373C27.6998 61.9414 28.1785 61.2341 28.5052 60.4556C28.8319 59.6771 29 58.8426 29 58H25.75C25.75 58.4213 25.6659 58.8385 25.5026 59.2278C25.3393 59.617 25.0999 59.9707 24.7981 60.2686C24.4963 60.5666 24.138 60.8029 23.7437 60.9641C23.3494 61.1254 22.9268 61.2083 22.5 61.2083C22.0732 61.2083 21.6506 61.1254 21.2563 60.9641C20.862 60.8029 20.5037 60.5666 20.2019 60.2686C19.9001 59.9707 19.6607 59.617 19.4974 59.2278C19.3341 58.8385 19.25 58.4213 19.25 58H16Z" fill="#84ADFF"/>
<path d="M22.5 55.9583C21.3578 55.9583 20.4318 56.8724 20.4318 58H24.5682C24.5682 56.8724 23.6422 55.9583 22.5 55.9583Z" fill="#84ADFF"/>
<path d="M22.5 60.0417C21.3578 60.0417 20.4318 59.1276 20.4318 58H24.5682C24.5682 59.1276 23.6422 60.0417 22.5 60.0417Z" fill="#155EEF"/>
<rect x="8.5" y="108.5" width="19" height="19" rx="3.5" fill="white"/>
<rect x="8.5" y="108.5" width="19" height="19" rx="3.5" stroke="#E0E0E0"/>
<path d="M22.5521 113.488C22.4145 113.353 22.277 113.218 22.1395 113.083C21.7269 112.651 21.2868 112.219 20.7367 111.949C20.1041 111.625 19.4165 111.706 18.7289 111.706C17.6837 111.706 15.0707 111.706 13.5305 111.706L14.5756 113.083C16.4735 113.083 19.444 113.083 20.8193 113.083C21.3969 113.083 21.892 113.191 22.3595 113.488C22.4421 113.515 22.5246 113.515 22.5521 113.488Z" fill="#66C61C"/>
<path d="M23.7073 115.704C23.5698 115.569 23.4322 115.434 23.2947 115.298C22.8821 114.866 22.4421 114.434 21.892 114.164C21.2593 113.84 20.5717 113.921 19.8841 113.921C18.9764 113.921 16.8036 113.921 15.2633 113.921L16.3085 115.298C18.1788 115.298 20.7368 115.298 22.002 115.298C22.5796 115.298 23.0747 115.406 23.5423 115.704C23.5973 115.731 23.6523 115.731 23.7073 115.704Z" fill="#4CA30D"/>
<path d="M25 117.865C24.8625 117.73 24.725 117.595 24.5874 117.459C24.1749 117.027 23.7348 116.595 23.1847 116.325C22.5521 116.001 21.8644 116.082 21.1768 116.082C20.3242 116.082 18.4538 116.082 16.9411 116.082L17.9863 117.459C19.8016 117.459 22.112 117.459 23.2672 117.459C23.8448 117.459 24.3399 117.568 24.8075 117.865C24.89 117.892 24.945 117.919 25 117.865Z" fill="#3B7C0F"/>
<path d="M13.4205 121.512C13.558 121.647 13.6955 121.782 13.833 121.917C14.2456 122.349 14.6857 122.781 15.2358 123.051C15.8684 123.375 16.556 123.294 17.2437 123.294H22.4421L21.3969 121.917C19.4991 121.917 16.5285 121.917 15.1533 121.917C14.5757 121.917 14.0806 121.809 13.613 121.512C13.5305 121.485 13.4755 121.485 13.4205 121.512Z" fill="#66C61C"/>
<path d="M12.2652 119.296C12.4028 119.432 12.5403 119.567 12.6778 119.702C13.0904 120.134 13.5305 120.566 14.0806 120.836C14.7132 121.16 15.4008 121.079 16.0884 121.079H20.7092L19.664 119.702C17.7937 119.702 15.2358 119.702 13.9705 119.702C13.3929 119.702 12.8978 119.594 12.4303 119.296C12.3752 119.269 12.3202 119.269 12.2652 119.296Z" fill="#4CA30D"/>
<path d="M11 117.108C11.1375 117.243 11.275 117.378 11.4126 117.513C11.8251 117.946 12.2652 118.378 12.8153 118.648C13.4479 118.972 14.1356 118.891 14.8232 118.891H19.0589L18.0138 117.513C16.1984 117.513 13.888 117.513 12.7328 117.513C12.1552 117.513 11.6601 117.405 11.1925 117.108C11.11 117.081 11.055 117.081 11 117.108Z" fill="#3B7C0F"/>
<rect x="91.5" y="98.5" width="19" height="19" rx="3.5" fill="white"/>
<rect x="91.5" y="98.5" width="19" height="19" rx="3.5" stroke="#E0E0E0"/>
<path d="M106.162 108C104.886 109.158 103.032 109.887 100.968 109.887C98.9045 109.887 97.0503 109.158 95.7744 108C97.0503 106.842 98.9045 106.113 100.968 106.113C103.032 106.113 104.886 106.842 106.162 108Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M94 111.774C94 108.648 97.1198 106.113 100.968 106.113C98.9045 106.113 97.0503 106.842 95.7744 108C97.0503 109.158 98.9046 109.887 100.968 109.887C103.032 109.887 104.886 109.158 106.162 108C107.266 109.002 107.937 110.324 107.937 111.774V113.913C107.937 114.191 107.659 114.417 107.317 114.417H94.6194C94.2773 114.417 94 114.191 94 113.913V111.774ZM106.162 108C106.162 108 106.162 108 106.162 108V108Z" fill="#7CD4FD"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M98.3546 109.475C97.3596 109.148 96.4788 108.64 95.7744 108C97.0503 106.842 98.9046 106.113 100.968 106.113C103.032 106.113 104.886 106.842 106.162 108C106.162 108 106.162 108 106.162 108C107.266 106.998 107.937 105.676 107.937 104.225V102.087C107.937 101.809 107.659 101.583 107.317 101.583L94.6194 101.583C94.2773 101.583 94 101.809 94 102.087L94 104.225C94 106.601 95.8012 108.635 98.3546 109.475Z" fill="#0BA5EC"/>
<rect x="116.5" y="28.5" width="19" height="19" rx="3.5" fill="white"/>
<rect x="116.5" y="28.5" width="19" height="19" rx="3.5" stroke="#E0E0E0"/>
<path d="M128.682 31.5833H123.318L119 35.5416V40.4584L123.318 44.4167H128.682L133 40.4584V35.5416L128.682 31.5833ZM124.06 40.5203L121.294 37.9845L124.06 35.4488C125.106 34.4902 126.827 34.4902 127.872 35.4488L130.639 37.9845L127.872 40.5203C126.827 41.4789 125.14 41.4789 124.06 40.5203Z" fill="#444CE7"/>
<rect x="42.5" y="0.5" width="19" height="19" rx="3.5" fill="white"/>
<rect x="42.5" y="0.5" width="19" height="19" rx="3.5" stroke="#E0E0E0"/>
<path d="M51.5 3.58334C47.9101 3.58334 45 6.45618 45 10C45 13.5438 47.9101 16.4167 51.5 16.4167C54.7208 16.4167 57.3944 14.1042 57.9101 11.0695H57.8635C57.3824 12.9145 55.6858 14.2778 53.6667 14.2778C51.2734 14.2778 49.3333 12.3626 49.3333 10C49.3333 7.63745 51.2734 5.72223 53.6667 5.72223C55.6858 5.72223 57.3824 7.08553 57.8635 8.93057H57.9101C57.3944 5.89579 54.7208 3.58334 51.5 3.58334Z" fill="#A4BCFD"/>
<path d="M45 10C45 6.45618 47.9102 3.58334 51.5 3.58334C54.7207 3.58334 57.3944 5.89579 57.9101 8.93057H53.5301C53.0491 7.08553 51.3525 5.72223 49.3333 5.72223C46.9401 5.72223 45 7.63746 45 10Z" fill="#3538CD"/>
<path d="M45 10C45 13.5438 47.9102 16.4167 51.5 16.4167C54.7207 16.4167 57.3944 14.1042 57.9101 11.0695H53.5301C53.0491 12.9145 51.3525 14.2778 49.3333 14.2778C46.9401 14.2778 45 12.3626 45 10Z" fill="#3538CD"/>
</svg>
`;

const Para = `<svg width="843" height="207" viewBox="0 0 843 207" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<path d="M60 0H144C183.764 0 216 32.2355 216 72C216 111.765 183.764 144 144 144H96C82.7452 144 72 154.745 72 168V204H0V132H36C49.2548 132 60 121.255 60 108L60 0Z"/>
<path d="M319.68 203.8H288V19H381.72C419.472 19 442.44 44.08 442.44 77.08C442.44 114.304 416.568 137.008 381.72 137.008H319.68V203.8ZM319.68 47.512V108.496H380.136C399.936 108.496 410.232 93.712 410.232 77.08C410.232 59.656 398.352 47.512 380.136 47.512H319.68Z"/>
<path d="M500.768 206.048C468.56 206.048 447.44 190.472 447.704 164.336C447.968 131.6 480.44 124.736 507.632 121.568C528.752 119.192 544.328 118.4 544.592 107.312C544.328 93.584 533.768 84.608 515.816 84.608C497.336 84.608 484.136 94.64 482.288 109.16H450.872C453.776 79.592 480.176 59 516.344 59C554.096 59 574.952 79.592 574.952 109.424V172.784C574.952 176.744 577.064 178.856 581.816 178.856H589.472V203.144H574.688C560.432 203.144 551.72 197.336 549.344 186.776C548.816 185.456 548.288 183.608 548.024 182.024C539.84 197.072 524.528 206.048 500.768 206.048ZM507.104 181.496C528.488 181.496 544.592 169.352 544.592 150.608V131.072C539.312 139.256 525.848 141.104 511.064 142.952C493.64 145.064 479.12 147.44 479.12 162.224C479.12 174.368 488.888 181.496 507.104 181.496Z"/>
<path d="M640.88 203.504H609.728V63.584H634.808L638.504 91.04C647.48 72.032 663.848 62 687.08 62H692.36V92.36H687.08C658.04 92.36 640.88 107.936 640.88 134.336V203.504Z"/>
<path d="M753.794 206.048C721.586 206.048 700.466 190.472 700.73 164.336C700.994 131.6 733.466 124.736 760.658 121.568C781.778 119.192 797.354 118.4 797.618 107.312C797.354 93.584 786.794 84.608 768.842 84.608C750.362 84.608 737.162 94.64 735.314 109.16H703.898C706.802 79.592 733.202 59 769.37 59C807.122 59 827.978 79.592 827.978 109.424V172.784C827.978 176.744 830.09 178.856 834.842 178.856H842.498V203.144H827.714C813.458 203.144 804.746 197.336 802.37 186.776C801.842 185.456 801.314 183.608 801.05 182.024C792.866 197.072 777.554 206.048 753.794 206.048ZM760.13 181.496C781.514 181.496 797.618 169.352 797.618 150.608V131.072C792.338 139.256 778.874 141.104 764.09 142.952C746.666 145.064 732.146 147.44 732.146 162.224C732.146 174.368 741.914 181.496 760.13 181.496Z"/>
</svg>
`;

const Passcode = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 12H12.005M17 12H17.005M7 12H7.005M5.2 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H5.2C4.0799 17 3.51984 17 3.09202 16.782C2.71569 16.5903 2.40973 16.2843 2.21799 15.908C2 15.4802 2 14.9201 2 13.8V10.2C2 9.0799 2 8.51984 2.21799 8.09202C2.40973 7.71569 2.71569 7.40973 3.09202 7.21799C3.51984 7 4.0799 7 5.2 7ZM12.25 12C12.25 12.1381 12.1381 12.25 12 12.25C11.8619 12.25 11.75 12.1381 11.75 12C11.75 11.8619 11.8619 11.75 12 11.75C12.1381 11.75 12.25 11.8619 12.25 12ZM17.25 12C17.25 12.1381 17.1381 12.25 17 12.25C16.8619 12.25 16.75 12.1381 16.75 12C16.75 11.8619 16.8619 11.75 17 11.75C17.1381 11.75 17.25 11.8619 17.25 12ZM7.25 12C7.25 12.1381 7.13807 12.25 7 12.25C6.86193 12.25 6.75 12.1381 6.75 12C6.75 11.8619 6.86193 11.75 7 11.75C7.13807 11.75 7.25 11.8619 7.25 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Phone = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M12 17.5H12.01M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22ZM12.5 17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5C11.5 17.2239 11.7239 17 12 17C12.2761 17 12.5 17.2239 12.5 17.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const PintrestBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21185)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="white"/>
<path d="M12 0C5.37284 0 0 5.37284 0 12C0 17.0864 3.16049 21.4321 7.62469 23.1802C7.51605 22.2321 7.42716 20.7704 7.6642 19.7333C7.88148 18.7951 9.06667 13.7679 9.06667 13.7679C9.06667 13.7679 8.71111 13.0469 8.71111 11.9901C8.71111 10.321 9.67901 9.07654 10.884 9.07654C11.9111 9.07654 12.4049 9.84691 12.4049 10.7654C12.4049 11.7926 11.7531 13.3333 11.4074 14.7654C11.121 15.9605 12.0099 16.9383 13.1852 16.9383C15.3185 16.9383 16.958 14.6864 16.958 11.4469C16.958 8.57284 14.8938 6.5679 11.9407 6.5679C8.52346 6.5679 6.51852 9.12593 6.51852 11.7728C6.51852 12.8 6.91358 13.9062 7.40741 14.5086C7.50617 14.6272 7.51605 14.7358 7.48642 14.8543C7.39753 15.2296 7.19012 16.0494 7.15062 16.2173C7.10123 16.4346 6.97284 16.484 6.74568 16.3753C5.24444 15.6741 4.30617 13.4914 4.30617 11.7235C4.30617 7.94074 7.05185 4.4642 12.237 4.4642C16.3951 4.4642 19.6346 7.42716 19.6346 11.3975C19.6346 15.5358 17.0272 18.8642 13.4123 18.8642C12.1975 18.8642 11.0519 18.2321 10.6667 17.4815C10.6667 17.4815 10.0642 19.7728 9.91605 20.3358C9.64938 21.3827 8.91852 22.6864 8.42469 23.4864C9.55062 23.8321 10.7358 24.0198 11.9802 24.0198C18.6074 24.0198 23.9802 18.6469 23.9802 12.0198C24 5.37284 18.6272 0 12 0Z" fill="#E60019"/>
</g>
<defs>
<clipPath id="clip0_106_21185">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Pintrest = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21375)">
<path d="M12 0C5.37188 0 0 5.37188 0 12C0 17.0859 3.16406 21.4266 7.62656 23.175C7.52344 22.2234 7.425 20.7703 7.66875 19.7344C7.88906 18.7969 9.075 13.7719 9.075 13.7719C9.075 13.7719 8.71406 13.0547 8.71406 11.9906C8.71406 10.3219 9.67969 9.075 10.8844 9.075C11.9062 9.075 12.4031 9.84375 12.4031 10.7672C12.4031 11.7984 11.7469 13.3359 11.4094 14.7609C11.1281 15.9562 12.0094 16.9313 13.1859 16.9313C15.3187 16.9313 16.9594 14.6812 16.9594 11.4375C16.9594 8.56406 14.8969 6.55313 11.9484 6.55313C8.53594 6.55313 6.52969 9.1125 6.52969 11.7609C6.52969 12.7922 6.92812 13.8984 7.425 14.4984C7.52344 14.6156 7.5375 14.7234 7.50937 14.8406C7.42031 15.2203 7.21406 16.0359 7.17656 16.2C7.125 16.4203 7.00313 16.4672 6.77344 16.3594C5.27344 15.6609 4.33594 13.4719 4.33594 11.7094C4.33594 7.92188 7.0875 4.44844 12.2625 4.44844C16.425 4.44844 19.6594 7.41563 19.6594 11.3813C19.6594 15.5156 17.0531 18.8438 13.4344 18.8438C12.2203 18.8438 11.0766 18.2109 10.6828 17.4656C10.6828 17.4656 10.0828 19.7578 9.9375 20.3203C9.66562 21.3609 8.93437 22.6688 8.44687 23.4656C9.57187 23.8125 10.7625 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0Z" />
</g>
<defs>
<clipPath id="clip0_106_21375">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PlusCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="plus-circle">
<path id="Icon" d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>`;

const Plus = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="plus">
<path id="Icon" d="M12 5V19M5 12H19" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const PolygonBrand = `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 24.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38.4 33.5" style="enable-background:new 0 0 38.4 33.5;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#8247E5;}
</style>
<g>
	<path class="st0" d="M29,10.2c-0.7-0.4-1.6-0.4-2.4,0L21,13.5l-3.8,2.1l-5.5,3.3c-0.7,0.4-1.6,0.4-2.4,0L5,16.3
		c-0.7-0.4-1.2-1.2-1.2-2.1v-5c0-0.8,0.4-1.6,1.2-2.1l4.3-2.5c0.7-0.4,1.6-0.4,2.4,0L16,7.2c0.7,0.4,1.2,1.2,1.2,2.1v3.3l3.8-2.2V7
		c0-0.8-0.4-1.6-1.2-2.1l-8-4.7c-0.7-0.4-1.6-0.4-2.4,0L1.2,5C0.4,5.4,0,6.2,0,7v9.4c0,0.8,0.4,1.6,1.2,2.1l8.1,4.7
		c0.7,0.4,1.6,0.4,2.4,0l5.5-3.2l3.8-2.2l5.5-3.2c0.7-0.4,1.6-0.4,2.4,0l4.3,2.5c0.7,0.4,1.2,1.2,1.2,2.1v5c0,0.8-0.4,1.6-1.2,2.1
		L29,28.8c-0.7,0.4-1.6,0.4-2.4,0l-4.3-2.5c-0.7-0.4-1.2-1.2-1.2-2.1V21l-3.8,2.2v3.3c0,0.8,0.4,1.6,1.2,2.1l8.1,4.7
		c0.7,0.4,1.6,0.4,2.4,0l8.1-4.7c0.7-0.4,1.2-1.2,1.2-2.1V17c0-0.8-0.4-1.6-1.2-2.1L29,10.2z"/>
</g>
</svg>
`;

const Polygon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.0738 5.40664C11.7786 5.23751 11.3948 5.23751 11.0701 5.40664L8.7675 6.70333L7.20293 7.54902L4.90037 8.84568C4.60516 9.01481 4.2214 9.01481 3.89668 8.84568L2.06642 7.83086C1.77122 7.66173 1.56458 7.35168 1.56458 7.01341V5.01199C1.56458 4.67373 1.7417 4.36365 2.06642 4.19452L3.86715 3.20791C4.16236 3.03877 4.54612 3.03877 4.87084 3.20791L6.67159 4.19452C6.96677 4.36365 7.17343 4.67373 7.17343 5.01199V6.30869L8.738 5.43483V4.13814C8.738 3.79987 8.5609 3.48979 8.23616 3.32066L4.90037 1.46019C4.60516 1.29106 4.2214 1.29106 3.89668 1.46019L0.501845 3.32066C0.177122 3.48979 0 3.79987 0 4.13814V7.88727C0 8.22553 0.177122 8.53563 0.501845 8.70476L3.89668 10.5652C4.19187 10.7343 4.57564 10.7343 4.90037 10.5652L7.20293 9.29671L8.7675 8.42286L11.0701 7.15435C11.3653 6.98522 11.7491 6.98522 12.0738 7.15435L13.8745 8.14096C14.1697 8.31009 14.3764 8.6202 14.3764 8.95845V10.9598C14.3764 11.2981 14.1993 11.6082 13.8745 11.7773L12.0738 12.7921C11.7786 12.9613 11.3948 12.9613 11.0701 12.7921L9.26939 11.8055C8.97416 11.6364 8.7675 11.3263 8.7675 10.988V9.69137L7.20293 10.5652V11.8619C7.20293 12.2001 7.38008 12.5102 7.70476 12.6794L11.0996 14.5398C11.3948 14.709 11.7786 14.709 12.1033 14.5398L15.4982 12.6794C15.7933 12.5102 16 12.2001 16 11.8619V8.11275C16 7.7745 15.8228 7.46445 15.4982 7.29532L12.0738 5.40664Z"
    fill="#8247E5" />
</svg>`;

const PuzzlePiece = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5V6H13.5C14.8978 6 15.5967 6 16.1481 6.22836C16.8831 6.53284 17.4672 7.11687 17.7716 7.85195C18 8.40326 18 9.10218 18 10.5H19.5C20.8807 10.5 22 11.6193 22 13C22 14.3807 20.8807 15.5 19.5 15.5H18V17.2C18 18.8802 18 19.7202 17.673 20.362C17.3854 20.9265 16.9265 21.3854 16.362 21.673C15.7202 22 14.8802 22 13.2 22H12.5V20.25C12.5 19.0074 11.4926 18 10.25 18C9.00736 18 8 19.0074 8 20.25V22H6.8C5.11984 22 4.27976 22 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V15.5H3.5C4.88071 15.5 6 14.3807 6 13C6 11.6193 4.88071 10.5 3.5 10.5H2C2 9.10218 2 8.40326 2.22836 7.85195C2.53284 7.11687 3.11687 6.53284 3.85195 6.22836C4.40326 6 5.10218 6 6.5 6H7.5V4.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const QrCode02 = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
<path d="M6.5 6.5H6.51M17.5 6.5H17.51M6.5 17.5H6.51M13 13H13.01M17.5 17.5H17.51M17 21H21V17M14 16.5V21M21 14H16.5M15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10ZM4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10ZM4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const QrCode = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M7 12H12V17M3.01 12H3M8.01 17H8M12.01 21H12M21.01 12H21M3 17H4.5M15.5 12H17.5M3 21H8M12 2V8M17.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V17.6C21 17.0399 21 16.7599 20.891 16.546C20.7951 16.3578 20.6422 16.2049 20.454 16.109C20.2401 16 19.9601 16 19.4 16H17.6C17.0399 16 16.7599 16 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16 16.7599 16 17.0399 16 17.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21ZM17.6 8H19.4C19.9601 8 20.2401 8 20.454 7.89101C20.6422 7.79513 20.7951 7.64215 20.891 7.45399C21 7.24008 21 6.96005 21 6.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H17.6C17.0399 3 16.7599 3 16.546 3.10899C16.3578 3.20487 16.2049 3.35785 16.109 3.54601C16 3.75992 16 4.03995 16 4.6V6.4C16 6.96005 16 7.24008 16.109 7.45399C16.2049 7.64215 16.3578 7.79513 16.546 7.89101C16.7599 8 17.0399 8 17.6 8ZM4.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V6.4C3 6.96005 3 7.24008 3.10899 7.45399C3.20487 7.64215 3.35785 7.79513 3.54601 7.89101C3.75992 8 4.03995 8 4.6 8Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const RampNetworkBrand = `<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.0204 12.6656L13.7622 16.4664C13.9145 16.6214 14 16.8312 14 17.0498C14 17.2684 13.9145 17.4782 13.7622 17.6333L10.9029 20.5311C10.6661 20.7652 10.3482 20.8962 10.0172 20.8962C9.68616 20.8962 9.36827 20.7652 9.13148 20.5311L0.365454 11.777C0.249692 11.6614 0.157776 11.5237 0.0950404 11.3718C0.0323051 11.2199 0 11.057 0 10.8924C0 10.7277 0.0323051 10.5648 0.0950404 10.4129C0.157776 10.261 0.249692 10.1233 0.365454 10.0077L9.13108 1.2614C9.36787 1.0273 9.68575 0.89624 10.0168 0.89624C10.3478 0.89624 10.6657 1.0273 10.9025 1.2614L13.7618 4.15922C13.9141 4.31428 13.9996 4.52403 13.9996 4.74267C13.9996 4.96131 13.9141 5.17106 13.7618 5.32612L10.0204 9.12726C9.78891 9.35849 9.60508 9.63395 9.47962 9.93765C9.35415 10.2414 9.28955 10.5673 9.28955 10.8964C9.28955 11.2256 9.35415 11.5515 9.47962 11.8552C9.60508 12.1589 9.78891 12.4344 10.0204 12.6656ZM21.9802 12.6656L18.2378 16.4664C18.0855 16.6214 18 16.8312 18 17.0498C18 17.2684 18.0855 17.4782 18.2378 17.6333L21.0976 20.5311C21.3344 20.7652 21.6523 20.8962 21.9834 20.8962C22.3145 20.8962 22.6324 20.7652 22.8692 20.5311L31.6345 11.777C31.7503 11.6614 31.8422 11.5237 31.9049 11.3718C31.9677 11.2199 32 11.057 32 10.8924C32 10.7277 31.9677 10.5648 31.9049 10.4129C31.8422 10.261 31.7503 10.1233 31.6345 10.0077L22.87 1.2614C22.6332 1.0273 22.3153 0.89624 21.9842 0.89624C21.6531 0.89624 21.3352 1.0273 21.0984 1.2614L18.2386 4.15922C18.0863 4.31428 18.0008 4.52403 18.0008 4.74267C18.0008 4.96131 18.0863 5.17106 18.2386 5.32612L21.981 9.12685C22.2125 9.35814 22.3964 9.63367 22.5218 9.93744C22.6473 10.2412 22.7118 10.5672 22.7117 10.8964C22.7117 11.2256 22.647 11.5516 22.5214 11.8553C22.3958 12.159 22.2118 12.4345 21.9802 12.6656ZM11 10.8964C11 11.1677 11.1077 11.4278 11.2994 11.6197L15.2764 15.5969C15.4682 15.7886 15.7284 15.8962 15.9996 15.8962C16.2708 15.8962 16.5309 15.7886 16.7228 15.5969L20.7006 11.6197C20.8923 11.4278 21 11.1677 21 10.8964C21 10.6252 20.8923 10.3651 20.7006 10.1732L16.7232 6.19563C16.5313 6.00392 16.2712 5.89624 16 5.89624C15.7288 5.89624 15.4687 6.00392 15.2768 6.19563L11.2994 10.1732C11.1077 10.3651 11 10.6252 11 10.8964Z" fill="#21BF73"/>
</svg>
`;

const RampNetwork = `<svg width="32" height="21" viewBox="0 0 32 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.0204 12.6656L13.7622 16.4664C13.9145 16.6214 14 16.8312 14 17.0498C14 17.2684 13.9145 17.4782 13.7622 17.6333L10.9029 20.5311C10.6661 20.7652 10.3482 20.8962 10.0172 20.8962C9.68616 20.8962 9.36827 20.7652 9.13148 20.5311L0.365454 11.777C0.249692 11.6614 0.157776 11.5237 0.0950404 11.3718C0.0323051 11.2199 0 11.057 0 10.8924C0 10.7277 0.0323051 10.5648 0.0950404 10.4129C0.157776 10.261 0.249692 10.1233 0.365454 10.0077L9.13108 1.2614C9.36787 1.0273 9.68575 0.89624 10.0168 0.89624C10.3478 0.89624 10.6657 1.0273 10.9025 1.2614L13.7618 4.15922C13.9141 4.31428 13.9996 4.52403 13.9996 4.74267C13.9996 4.96131 13.9141 5.17106 13.7618 5.32612L10.0204 9.12726C9.78891 9.35849 9.60508 9.63395 9.47962 9.93765C9.35415 10.2414 9.28955 10.5673 9.28955 10.8964C9.28955 11.2256 9.35415 11.5515 9.47962 11.8552C9.60508 12.1589 9.78891 12.4344 10.0204 12.6656ZM21.9802 12.6656L18.2378 16.4664C18.0855 16.6214 18 16.8312 18 17.0498C18 17.2684 18.0855 17.4782 18.2378 17.6333L21.0976 20.5311C21.3344 20.7652 21.6523 20.8962 21.9834 20.8962C22.3145 20.8962 22.6324 20.7652 22.8692 20.5311L31.6345 11.777C31.7503 11.6614 31.8422 11.5237 31.9049 11.3718C31.9677 11.2199 32 11.057 32 10.8924C32 10.7277 31.9677 10.5648 31.9049 10.4129C31.8422 10.261 31.7503 10.1233 31.6345 10.0077L22.87 1.2614C22.6332 1.0273 22.3153 0.89624 21.9842 0.89624C21.6531 0.89624 21.3352 1.0273 21.0984 1.2614L18.2386 4.15922C18.0863 4.31428 18.0008 4.52403 18.0008 4.74267C18.0008 4.96131 18.0863 5.17106 18.2386 5.32612L21.981 9.12685C22.2125 9.35814 22.3964 9.63367 22.5218 9.93744C22.6473 10.2412 22.7118 10.5672 22.7117 10.8964C22.7117 11.2256 22.647 11.5516 22.5214 11.8553C22.3958 12.159 22.2118 12.4345 21.9802 12.6656ZM11 10.8964C11 11.1677 11.1077 11.4278 11.2994 11.6197L15.2764 15.5969C15.4682 15.7886 15.7284 15.8962 15.9996 15.8962C16.2708 15.8962 16.5309 15.7886 16.7228 15.5969L20.7006 11.6197C20.8923 11.4278 21 11.1677 21 10.8964C21 10.6252 20.8923 10.3651 20.7006 10.1732L16.7232 6.19563C16.5313 6.00392 16.2712 5.89624 16 5.89624C15.7288 5.89624 15.4687 6.00392 15.2768 6.19563L11.2994 10.1732C11.1077 10.3651 11 10.6252 11 10.8964Z" fill="currentColor"/>
</svg>
`;

const RedditBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21199)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FF4500"/>
<path d="M20.0002 12C20.0002 11.0316 19.2143 10.2456 18.2459 10.2456C17.7687 10.2456 17.3476 10.428 17.0388 10.7368C15.8459 9.88068 14.1897 9.31927 12.3652 9.2491L13.1652 5.50173L15.7617 6.0491C15.7897 6.70875 16.3371 7.24208 17.0108 7.24208C17.6985 7.24208 18.2599 6.68068 18.2599 5.99296C18.2599 5.30524 17.6985 4.74384 17.0108 4.74384C16.5195 4.74384 16.0985 5.02454 15.902 5.44559L12.9967 4.82805C12.9125 4.81401 12.8283 4.82805 12.7581 4.87015C12.688 4.91226 12.6459 4.98243 12.6178 5.06664L11.7336 9.2491C9.86692 9.30524 8.19674 9.85261 6.98972 10.7368C6.68095 10.4421 6.24586 10.2456 5.78271 10.2456C4.81429 10.2456 4.02832 11.0316 4.02832 12C4.02832 12.7158 4.44937 13.3193 5.06692 13.6C5.03885 13.7684 5.02481 13.9509 5.02481 14.1333C5.02481 16.828 8.15464 19.0035 12.0283 19.0035C15.902 19.0035 19.0318 16.828 19.0318 14.1333C19.0318 13.9509 19.0178 13.7824 18.9897 13.614C19.5652 13.3333 20.0002 12.7158 20.0002 12ZM8.00025 13.2491C8.00025 12.5614 8.56165 12 9.24937 12C9.93709 12 10.4985 12.5614 10.4985 13.2491C10.4985 13.9368 9.93709 14.4982 9.24937 14.4982C8.56165 14.4982 8.00025 13.9368 8.00025 13.2491ZM14.9757 16.5473C14.1195 17.4035 12.4915 17.4596 12.0143 17.4596C11.5371 17.4596 9.89499 17.3895 9.05288 16.5473C8.92657 16.421 8.92657 16.2105 9.05288 16.0842C9.1792 15.9579 9.38972 15.9579 9.51604 16.0842C10.0494 16.6175 11.2003 16.814 12.0283 16.814C12.8564 16.814 13.9932 16.6175 14.5406 16.0842C14.6669 15.9579 14.8774 15.9579 15.0038 16.0842C15.102 16.2245 15.102 16.421 14.9757 16.5473ZM14.7511 14.4982C14.0634 14.4982 13.502 13.9368 13.502 13.2491C13.502 12.5614 14.0634 12 14.7511 12C15.4388 12 16.0002 12.5614 16.0002 13.2491C16.0002 13.9368 15.4388 14.4982 14.7511 14.4982Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_106_21199">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Reddit = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM18.2459 10.2456C19.2143 10.2456 20.0002 11.0316 20.0002 12C20.0002 12.7158 19.5652 13.3333 18.9897 13.614C19.0178 13.7824 19.0318 13.9509 19.0318 14.1333C19.0318 16.828 15.902 19.0035 12.0283 19.0035C8.15464 19.0035 5.02481 16.828 5.02481 14.1333C5.02481 13.9509 5.03885 13.7684 5.06692 13.6C4.44937 13.3193 4.02832 12.7158 4.02832 12C4.02832 11.0316 4.81429 10.2456 5.78271 10.2456C6.24586 10.2456 6.68095 10.4421 6.98972 10.7368C8.19674 9.85261 9.86692 9.30524 11.7336 9.2491L12.6178 5.06664C12.6459 4.98243 12.688 4.91226 12.7581 4.87015C12.8283 4.82805 12.9125 4.81401 12.9967 4.82805L15.902 5.44559C16.0985 5.02454 16.5196 4.74384 17.0108 4.74384C17.6985 4.74384 18.2599 5.30524 18.2599 5.99296C18.2599 6.68068 17.6985 7.24208 17.0108 7.24208C16.3371 7.24208 15.7897 6.70875 15.7617 6.0491L13.1652 5.50173L12.3652 9.2491C14.1897 9.31927 15.8459 9.88068 17.0388 10.7368C17.3476 10.428 17.7687 10.2456 18.2459 10.2456ZM9.24937 12C8.56165 12 8.00025 12.5614 8.00025 13.2491C8.00025 13.9368 8.56165 14.4982 9.24937 14.4982C9.93709 14.4982 10.4985 13.9368 10.4985 13.2491C10.4985 12.5614 9.93709 12 9.24937 12ZM12.0143 17.4596C12.4915 17.4596 14.1195 17.4035 14.9757 16.5473C15.102 16.421 15.102 16.2245 15.0038 16.0842C14.8774 15.9579 14.6669 15.9579 14.5406 16.0842C13.9932 16.6175 12.8564 16.814 12.0283 16.814C11.2003 16.814 10.0494 16.6175 9.51604 16.0842C9.38972 15.9579 9.1792 15.9579 9.05288 16.0842C8.92657 16.2105 8.92657 16.421 9.05288 16.5473C9.89499 17.3895 11.5371 17.4596 12.0143 17.4596ZM13.502 13.2491C13.502 13.9368 14.0634 14.4982 14.7511 14.4982C15.4388 14.4982 16.0002 13.9368 16.0002 13.2491C16.0002 12.5614 15.4388 12 14.7511 12C14.0634 12 13.502 12.5614 13.502 13.2491Z" />
</svg>
`;

const Refresh = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
<path d="M20.453 12.893C20.1752 15.5029 18.6964 17.9487 16.2494 19.3614C12.1839 21.7086 6.98539 20.3157 4.63818 16.2502L4.38818 15.8172M3.54613 11.107C3.82393 8.49711 5.30272 6.05138 7.74971 4.63862C11.8152 2.29141 17.0137 3.68434 19.3609 7.74983L19.6109 8.18285M3.49316 18.0661L4.22521 15.334L6.95727 16.0661M17.0424 7.93401L19.7744 8.66606L20.5065 5.93401" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

const Samsung = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="Platform=Samsung, Style=Black, State=Default">
<path id="path20" d="M19.842 15.2067C19.9315 15.681 20.1311 16.9406 19.8718 18.8773C19.3327 22.6177 16.0515 24 12.0511 24C7.89027 24 4 22.497 4 17.4857V15.7715H9.94602V17.9288C9.94602 19.1488 10.7743 19.9664 12.1602 19.9664C13.6367 19.9664 14.1357 19.2102 14.325 18.454C14.4248 18.0296 14.4948 17.3442 14.2756 16.8002C13.1377 13.9055 5.26761 12.5752 4.3097 7.99653C4.08025 6.86695 4.0998 5.97972 4.26957 4.98223C4.84781 1.32097 8.06004 0 12.0007 0C15.1234 0 19.4623 0.776979 19.4623 5.64688V7.22059H13.9464V5.8393C13.9464 4.61923 13.1881 3.80168 11.8906 3.80168C10.4944 3.80168 10.016 4.59842 9.86576 5.31507C9.80609 5.56679 9.77625 6.04109 9.88634 6.49458C10.514 9.11572 18.9139 10.5074 19.842 15.2067Z"/>
</g>
</svg>
`;

const Search = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Send = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M10.4995 13.5001L20.9995 3.00005M10.6271 13.8281L13.2552 20.5861C13.4867 21.1815 13.6025 21.4791 13.7693 21.566C13.9139 21.6414 14.0862 21.6415 14.2308 21.5663C14.3977 21.4796 14.5139 21.1821 14.7461 20.587L21.3364 3.69925C21.5461 3.16207 21.6509 2.89348 21.5935 2.72185C21.5437 2.5728 21.4268 2.45583 21.2777 2.40604C21.1061 2.34871 20.8375 2.45352 20.3003 2.66315L3.41258 9.25349C2.8175 9.48572 2.51997 9.60183 2.43326 9.76873C2.35809 9.91342 2.35819 10.0857 2.43353 10.2303C2.52043 10.3971 2.81811 10.5128 3.41345 10.7444L10.1715 13.3725C10.2923 13.4195 10.3527 13.443 10.4036 13.4793C10.4487 13.5114 10.4881 13.5509 10.5203 13.596C10.5566 13.6468 10.5801 13.7073 10.6271 13.8281Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Settings = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.39516 19.3711L9.97961 20.6856C10.1533 21.0768 10.4369 21.4093 10.7958 21.6426C11.1548 21.8759 11.5737 22.0001 12.0018 22C12.4299 22.0001 12.8489 21.8759 13.2078 21.6426C13.5668 21.4093 13.8503 21.0768 14.0241 20.6856L14.6085 19.3711C14.8165 18.9047 15.1665 18.5159 15.6085 18.26C16.0533 18.0034 16.5678 17.8941 17.0785 17.9478L18.5085 18.1C18.9342 18.145 19.3638 18.0656 19.7452 17.8713C20.1266 17.6771 20.4435 17.3763 20.6574 17.0056C20.8716 16.635 20.9736 16.2103 20.9511 15.7829C20.9286 15.3555 20.7826 14.9438 20.5307 14.5978L19.6841 13.4344C19.3826 13.0171 19.2215 12.5148 19.2241 12C19.224 11.4866 19.3866 10.9864 19.6885 10.5711L20.5352 9.40778C20.787 9.06175 20.9331 8.65007 20.9556 8.22267C20.978 7.79528 20.876 7.37054 20.6618 7C20.4479 6.62923 20.1311 6.32849 19.7496 6.13423C19.3682 5.93997 18.9386 5.86053 18.5129 5.90556L17.0829 6.05778C16.5723 6.11141 16.0577 6.00212 15.6129 5.74556C15.1701 5.48825 14.82 5.09736 14.6129 4.62889L14.0241 3.31444C13.8503 2.92317 13.5668 2.59072 13.2078 2.3574C12.8489 2.12408 12.4299 1.99993 12.0018 2C11.5737 1.99993 11.1548 2.12408 10.7958 2.3574C10.4369 2.59072 10.1533 2.92317 9.97961 3.31444L9.39516 4.62889C9.18809 5.09736 8.83804 5.48825 8.39516 5.74556C7.95038 6.00212 7.43583 6.11141 6.92516 6.05778L5.49072 5.90556C5.06505 5.86053 4.63546 5.93997 4.25403 6.13423C3.87261 6.32849 3.55574 6.62923 3.34183 7C3.12765 7.37054 3.02561 7.79528 3.0481 8.22267C3.07058 8.65007 3.21662 9.06175 3.4685 9.40778L4.31516 10.5711C4.61711 10.9864 4.7797 11.4866 4.77961 12C4.7797 12.5134 4.61711 13.0137 4.31516 13.4289L3.4685 14.5922C3.21662 14.9382 3.07058 15.3499 3.0481 15.7773C3.02561 16.2047 3.12765 16.6295 3.34183 17C3.55595 17.3706 3.87286 17.6712 4.25423 17.8654C4.6356 18.0596 5.06508 18.1392 5.49072 18.0944L6.92072 17.9422C7.43139 17.8886 7.94594 17.9979 8.39072 18.2544C8.83525 18.511 9.18693 18.902 9.39516 19.3711Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3432 9 9.00004 10.3431 9.00004 12C9.00004 13.6569 10.3432 15 12 15Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Share = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const Shield = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M11.302 21.6149C11.5234 21.744 11.6341 21.8086 11.7903 21.8421C11.9116 21.8681 12.0884 21.8681 12.2097 21.8421C12.3659 21.8086 12.4766 21.744 12.698 21.6149C14.646 20.4784 20 16.9084 20 12V7.21759C20 6.41808 20 6.01833 19.8692 5.6747C19.7537 5.37113 19.566 5.10027 19.3223 4.88552C19.0465 4.64243 18.6722 4.50207 17.9236 4.22134L12.5618 2.21067C12.3539 2.13271 12.25 2.09373 12.143 2.07827C12.0482 2.06457 11.9518 2.06457 11.857 2.07827C11.75 2.09373 11.6461 2.13271 11.4382 2.21067L6.0764 4.22134C5.3278 4.50207 4.9535 4.64243 4.67766 4.88552C4.43398 5.10027 4.24627 5.37113 4.13076 5.6747C4 6.01833 4 6.41808 4 7.21759V12C4 16.9084 9.35396 20.4784 11.302 21.6149Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const SignalBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.11911 0.350322L9.38845 1.44131C8.32691 1.70367 7.31091 2.12432 6.3746 2.68912L5.79842 1.72428C6.82904 1.10015 7.94881 0.63684 9.11911 0.350322ZM14.8809 0.350322L14.6115 1.44131C15.6731 1.70367 16.6891 2.12432 17.6254 2.68912L18.2084 1.72428C17.1751 1.1007 16.0531 0.637446 14.8809 0.350322ZM1.72427 5.79503C1.10072 6.82716 0.637457 7.94795 0.350307 9.11913L1.44129 9.38846C1.70365 8.32693 2.1243 7.31093 2.68911 6.37461L1.72427 5.79503ZM1.12423 12C1.12414 11.4545 1.16517 10.9097 1.24696 10.3704L0.135519 10.1999C-0.0451731 11.392 -0.0451731 12.6046 0.135519 13.7967L1.24696 13.6297C1.1653 13.0903 1.12427 12.5455 1.12423 12ZM18.2016 22.2723L17.6254 21.3109C16.6906 21.8762 15.6756 22.2969 14.615 22.5587L14.8843 23.6497C16.0532 23.3604 17.1716 22.8961 18.2016 22.2723ZM22.8758 12C22.8757 12.5455 22.8347 13.0903 22.753 13.6297L23.8645 13.7967C24.0452 12.6046 24.0452 11.392 23.8645 10.1999L22.753 10.3704C22.8348 10.9097 22.8759 11.4545 22.8758 12ZM23.6497 14.8775L22.5587 14.6082C22.297 15.671 21.8763 16.6882 21.3109 17.6254L22.2757 18.205C22.8999 17.172 23.3632 16.0499 23.6497 14.8775ZM13.6297 22.7531C12.5494 22.9167 11.4506 22.9167 10.3703 22.7531L10.2033 23.8645C11.3943 24.0452 12.6057 24.0452 13.7967 23.8645L13.6297 22.7531ZM20.7552 18.4505C20.1072 19.3292 19.3302 20.1051 18.4505 20.7518L19.1187 21.6587C20.0876 20.9454 20.9449 20.0916 21.6621 19.1255L20.7552 18.4505ZM18.4505 3.24485C19.3302 3.89279 20.1072 4.66977 20.7552 5.54955L21.6621 4.87451C20.9474 3.90756 20.0925 3.05263 19.1255 2.33796L18.4505 3.24485ZM3.24483 5.54955C3.89278 4.66977 4.66976 3.89279 5.54954 3.24485L4.87449 2.33796C3.90754 3.05263 3.05262 3.90756 2.33795 4.87451L3.24483 5.54955ZM22.2757 5.79503L21.3109 6.37461C21.8762 7.30945 22.2969 8.3244 22.5587 9.38506L23.6497 9.11572C23.3625 7.94563 22.8992 6.82595 22.2757 5.79503ZM10.3703 1.24698C11.4506 1.08331 12.5494 1.08331 13.6297 1.24698L13.7967 0.135534C12.6057 -0.0451779 11.3943 -0.0451779 10.2033 0.135534L10.3703 1.24698ZM3.82101 21.9587L1.49925 22.4974L2.04134 20.1756L0.946941 19.9199L0.404856 22.2417C0.370939 22.3856 0.365734 22.5348 0.389539 22.6808C0.413344 22.8267 0.465692 22.9666 0.543588 23.0923C0.621485 23.218 0.723402 23.3271 0.843508 23.4134C0.963615 23.4997 1.09956 23.5615 1.24355 23.5952C1.41196 23.6327 1.58655 23.6327 1.75495 23.5952L4.07671 23.0599L3.82101 21.9587ZM1.17878 18.9176L2.27658 19.1698L2.65161 17.5606C2.10394 16.642 1.69604 15.6469 1.44129 14.6082L0.350307 14.8775C0.595705 15.8718 0.966907 16.8307 1.45493 17.7311L1.17878 18.9176ZM6.42915 21.3518L4.81994 21.7268L5.07564 22.8246L6.25868 22.5485C7.15838 23.038 8.11751 23.4093 9.11229 23.6531L9.38163 22.5621C8.34612 22.3041 7.35459 21.8939 6.43938 21.345L6.42915 21.3518ZM12 2.24932C6.61325 2.25273 2.25272 6.62009 2.25272 12.0034C2.25568 13.837 2.77433 15.6328 3.74941 17.1856L2.81185 21.1882L6.81099 20.2506C11.3693 23.1178 17.3902 21.7507 20.2574 17.1958C23.1247 12.641 21.7609 6.62009 17.2061 3.74943C15.6467 2.76884 13.842 2.24882 12 2.24932Z" fill="#3A76F0"/>
</svg>
`;

const Signal = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M9.11911 0.350322L9.38845 1.44131C8.32691 1.70367 7.31091 2.12432 6.3746 2.68912L5.79842 1.72428C6.82904 1.10015 7.94881 0.63684 9.11911 0.350322ZM14.8809 0.350322L14.6115 1.44131C15.6731 1.70367 16.6891 2.12432 17.6254 2.68912L18.2084 1.72428C17.1751 1.1007 16.0531 0.637446 14.8809 0.350322ZM1.72427 5.79503C1.10072 6.82716 0.637457 7.94795 0.350307 9.11913L1.44129 9.38846C1.70365 8.32693 2.1243 7.31093 2.68911 6.37461L1.72427 5.79503ZM1.12423 12C1.12414 11.4545 1.16517 10.9097 1.24696 10.3704L0.135519 10.1999C-0.0451731 11.392 -0.0451731 12.6046 0.135519 13.7967L1.24696 13.6297C1.1653 13.0903 1.12427 12.5455 1.12423 12ZM18.2016 22.2723L17.6254 21.3109C16.6906 21.8762 15.6756 22.2969 14.615 22.5587L14.8843 23.6497C16.0532 23.3604 17.1716 22.8961 18.2016 22.2723ZM22.8758 12C22.8757 12.5455 22.8347 13.0903 22.753 13.6297L23.8645 13.7967C24.0452 12.6046 24.0452 11.392 23.8645 10.1999L22.753 10.3704C22.8348 10.9097 22.8759 11.4545 22.8758 12ZM23.6497 14.8775L22.5587 14.6082C22.297 15.671 21.8763 16.6882 21.3109 17.6254L22.2757 18.205C22.8999 17.172 23.3632 16.0499 23.6497 14.8775ZM13.6297 22.7531C12.5494 22.9167 11.4506 22.9167 10.3703 22.7531L10.2033 23.8645C11.3943 24.0452 12.6057 24.0452 13.7967 23.8645L13.6297 22.7531ZM20.7552 18.4505C20.1072 19.3292 19.3302 20.1051 18.4505 20.7518L19.1187 21.6587C20.0876 20.9454 20.9449 20.0916 21.6621 19.1255L20.7552 18.4505ZM18.4505 3.24485C19.3302 3.89279 20.1072 4.66977 20.7552 5.54955L21.6621 4.87451C20.9474 3.90756 20.0925 3.05263 19.1255 2.33796L18.4505 3.24485ZM3.24483 5.54955C3.89278 4.66977 4.66976 3.89279 5.54954 3.24485L4.87449 2.33796C3.90754 3.05263 3.05262 3.90756 2.33795 4.87451L3.24483 5.54955ZM22.2757 5.79503L21.3109 6.37461C21.8762 7.30945 22.2969 8.3244 22.5587 9.38506L23.6497 9.11572C23.3625 7.94563 22.8992 6.82595 22.2757 5.79503ZM10.3703 1.24698C11.4506 1.08331 12.5494 1.08331 13.6297 1.24698L13.7967 0.135534C12.6057 -0.0451779 11.3943 -0.0451779 10.2033 0.135534L10.3703 1.24698ZM3.82101 21.9587L1.49925 22.4974L2.04134 20.1756L0.946941 19.9199L0.404856 22.2417C0.370939 22.3856 0.365734 22.5348 0.389539 22.6808C0.413344 22.8267 0.465692 22.9666 0.543588 23.0923C0.621485 23.218 0.723402 23.3271 0.843508 23.4134C0.963615 23.4997 1.09956 23.5615 1.24355 23.5952C1.41196 23.6327 1.58655 23.6327 1.75495 23.5952L4.07671 23.0599L3.82101 21.9587ZM1.17878 18.9176L2.27658 19.1698L2.65161 17.5606C2.10394 16.642 1.69604 15.6469 1.44129 14.6082L0.350307 14.8775C0.595705 15.8718 0.966907 16.8307 1.45493 17.7311L1.17878 18.9176ZM6.42915 21.3518L4.81994 21.7268L5.07564 22.8246L6.25868 22.5485C7.15838 23.038 8.11751 23.4093 9.11229 23.6531L9.38163 22.5621C8.34612 22.3041 7.35459 21.8939 6.43938 21.345L6.42915 21.3518ZM12 2.24932C6.61325 2.25273 2.25272 6.62009 2.25272 12.0034C2.25568 13.837 2.77433 15.6328 3.74941 17.1856L2.81185 21.1882L6.81099 20.2506C11.3693 23.1178 17.3902 21.7507 20.2574 17.1958C23.1247 12.641 21.7609 6.62009 17.2061 3.74943C15.6467 2.76884 13.842 2.24882 12 2.24932Z" />
</svg>
`;

const Sliders = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.0337 6H3.66667C2.74619 6 2 5.25381 2 4.33333C2 3.41286 2.74619 2.66667 3.66667 2.66667H10.0337M5.96633 13.3333H12.3333C13.2538 13.3333 14 12.5871 14 11.6667C14 10.7462 13.2538 10 12.3333 10H5.96633M2 11.6667C2 12.9553 3.04467 14 4.33333 14C5.622 14 6.66667 12.9553 6.66667 11.6667C6.66667 10.378 5.622 9.33333 4.33333 9.33333C3.04467 9.33333 2 10.378 2 11.6667ZM14 4.33333C14 5.622 12.9553 6.66667 11.6667 6.66667C10.378 6.66667 9.33333 5.622 9.33333 4.33333C9.33333 3.04467 10.378 2 11.6667 2C12.9553 2 14 3.04467 14 4.33333Z" stroke="#141414" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const SnapchatBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22.2974 17.6797C18.5809 15.8801 17.9885 13.1015 17.9622 12.8954C17.9303 12.6457 17.8941 12.4495 18.1694 12.1955C18.4349 11.9502 19.6129 11.2209 19.9397 10.9927C20.4799 10.6149 20.7179 10.2376 20.5425 9.77392C20.4198 9.45312 20.1212 9.33229 19.8067 9.33229C19.7074 9.33259 19.6085 9.3437 19.5117 9.36541C18.9181 9.49422 18.3417 9.79171 18.0082 9.87206C17.9681 9.8824 17.9269 9.88796 17.8855 9.88862C17.7077 9.88862 17.6403 9.80949 17.6574 9.59543C17.6991 8.94648 17.7874 7.67986 17.685 6.49666C17.5446 4.86876 17.0197 4.06217 16.3973 3.34881C16.0962 3.00287 14.6982 1.51666 12.0001 1.51666C9.30207 1.51666 7.90583 3.00287 7.60659 3.34452C6.98236 4.05788 6.45808 4.86446 6.31889 6.49236C6.21649 7.67556 6.30846 8.94157 6.34648 9.59113C6.35875 9.79477 6.2962 9.88433 6.11837 9.88433C6.07699 9.88362 6.03583 9.87806 5.99574 9.86777C5.66277 9.78741 5.08637 9.48993 4.4928 9.36112C4.39598 9.33941 4.29708 9.3283 4.19786 9.328C3.88206 9.328 3.58467 9.45067 3.46203 9.76962C3.28665 10.2333 3.52335 10.6106 4.06541 10.9884C4.39224 11.2166 5.57018 11.9453 5.83569 12.1912C6.1104 12.4452 6.07484 12.6414 6.04295 12.8911C6.01658 13.1003 5.42363 15.8788 1.70768 17.6754C1.49 17.7809 1.11963 18.0042 1.77268 18.3649C2.79794 18.9316 3.48042 18.8709 4.01083 19.2125C4.46092 19.5027 4.19479 20.1283 4.52224 20.354C4.92449 20.6319 6.11347 20.3344 7.64951 20.8417C8.93722 21.2661 9.71965 22.4653 12.0032 22.4653C14.2867 22.4653 15.0918 21.2606 16.3568 20.8417C17.8898 20.3344 19.0813 20.6319 19.4841 20.354C19.8109 20.1283 19.5454 19.5027 19.9955 19.2125C20.5259 18.8709 21.2078 18.9316 22.2337 18.3649C22.8855 18.0085 22.5151 17.7852 22.2974 17.6797Z" fill="white"/>
<path d="M23.9141 17.4679C23.7473 17.014 23.4297 16.7711 23.0679 16.57C22.9998 16.5301 22.9373 16.4982 22.8839 16.4737C22.776 16.4178 22.6656 16.3639 22.5559 16.3068C21.4282 15.7088 20.5477 14.9543 19.9369 14.06C19.7635 13.8083 19.6131 13.5414 19.4875 13.2626C19.4354 13.1136 19.4378 13.0289 19.4752 12.9517C19.5123 12.8921 19.5614 12.8409 19.6193 12.8014C19.8131 12.6732 20.013 12.5431 20.1485 12.4554C20.3901 12.299 20.5814 12.1751 20.7047 12.0874C21.1676 11.7636 21.4914 11.4194 21.6937 11.0349C21.8349 10.7692 21.9173 10.4761 21.9351 10.1758C21.953 9.8754 21.906 9.57469 21.7974 9.2941C21.4908 8.4869 20.7286 7.98577 19.8051 7.98577C19.6103 7.98559 19.4161 8.00615 19.2256 8.04711C19.1747 8.05815 19.1239 8.0698 19.0742 8.08268C19.0828 7.53065 19.0705 6.94794 19.0215 6.37443C18.8473 4.35827 18.1415 3.30143 17.4057 2.45865C16.9345 1.93053 16.3795 1.48372 15.7629 1.13621C14.6463 0.498301 13.3801 0.174438 11.9998 0.174438C10.6195 0.174438 9.35938 0.498301 8.24154 1.13621C7.62351 1.48383 7.06737 1.93153 6.59573 2.4611C5.8599 3.30388 5.15411 4.36257 4.97997 6.37689C4.93091 6.9504 4.91865 7.53617 4.92662 8.08514C4.87695 8.07226 4.82667 8.0606 4.77577 8.04956C4.58534 8.0086 4.39109 7.98804 4.19631 7.98823C3.27223 7.98823 2.5088 8.48935 2.20343 9.29656C2.09428 9.57726 2.04682 9.87819 2.06428 10.1789C2.08174 10.4796 2.16371 10.773 2.30461 11.0392C2.50758 11.4237 2.83134 11.7678 3.2943 12.0917C3.41694 12.1776 3.60887 12.3015 3.85047 12.4597C3.98108 12.5444 4.17178 12.6683 4.3588 12.7922C4.42424 12.8345 4.47985 12.8903 4.52191 12.956C4.56116 13.0363 4.56238 13.1228 4.50413 13.2823C4.38023 13.5552 4.23227 13.8165 4.06202 14.0631C3.46477 14.9372 2.60998 15.6781 1.5185 16.2712C0.940259 16.5779 0.339331 16.7828 0.0854691 17.4728C-0.105847 17.9936 0.0192443 18.5861 0.505505 19.0854C0.683967 19.2718 0.890957 19.4285 1.1187 19.5497C1.59257 19.8102 2.09645 20.0119 2.61918 20.1502C2.72705 20.1781 2.82946 20.2239 2.92209 20.2858C3.09931 20.441 3.07417 20.6747 3.31025 21.0169C3.42875 21.1938 3.57933 21.3469 3.7542 21.4684C4.24966 21.8106 4.80643 21.8321 5.39632 21.8548C5.92919 21.875 6.53318 21.8983 7.22302 22.1259C7.50877 22.2204 7.80556 22.4032 8.14956 22.6166C8.97553 23.1245 10.1063 23.8194 11.9986 23.8194C13.8909 23.8194 15.0296 23.1208 15.8617 22.6111C16.2032 22.4013 16.4982 22.2204 16.7759 22.1284C17.4658 21.9002 18.0698 21.8775 18.6026 21.8573C19.1925 21.8346 19.7493 21.8131 20.2448 21.4708C20.4519 21.3264 20.6244 21.1379 20.75 20.9188C20.9199 20.6299 20.9156 20.4281 21.075 20.287C21.1619 20.2281 21.2581 20.1841 21.3596 20.157C21.8894 20.0182 22.4002 19.8147 22.8803 19.551C23.1222 19.4211 23.34 19.2506 23.5241 19.0468L23.5303 19.0394C23.9865 18.5512 24.1011 17.9758 23.9141 17.4679ZM22.2321 18.3721C21.2063 18.9388 20.5244 18.8781 19.994 19.2197C19.5433 19.5099 19.81 20.1355 19.4826 20.3612C19.0803 20.6391 17.8913 20.3416 16.3553 20.8489C15.0884 21.2678 14.2802 22.4725 12.0016 22.4725C9.72301 22.4725 8.93383 21.2703 7.64613 20.8458C6.11315 20.3385 4.92171 20.636 4.51885 20.3582C4.19202 20.1324 4.45753 19.5068 4.00744 19.2167C3.47642 18.875 2.79455 18.9357 1.76929 18.3721C1.11624 18.0114 1.48661 17.7881 1.7043 17.6826C5.42024 15.883 6.0132 13.1044 6.03956 12.8983C6.07145 12.6487 6.10701 12.4524 5.8323 12.1984C5.56679 11.9531 4.38885 11.2238 4.06202 10.9956C3.52118 10.6178 3.28326 10.2405 3.45864 9.77683C3.58128 9.45603 3.88051 9.3352 4.19447 9.3352C4.29369 9.3355 4.39259 9.34661 4.48941 9.36832C5.08298 9.49713 5.65938 9.79462 5.99235 9.87497C6.03244 9.88526 6.0736 9.89082 6.11499 9.89153C6.29281 9.89153 6.35536 9.80198 6.34309 9.59834C6.30508 8.94877 6.2131 7.68277 6.3155 6.49956C6.45592 4.87167 6.9802 4.06508 7.6032 3.35172C7.90244 3.00885 9.30849 1.52264 11.9973 1.52264C14.6862 1.52264 16.0959 3.00271 16.3951 3.34436C17.0188 4.05772 17.5437 4.86431 17.6828 6.4922C17.7853 7.6754 17.697 8.94202 17.6553 9.59097C17.6412 9.80504 17.7055 9.88417 17.8834 9.88417C17.9248 9.8835 17.9659 9.87794 18.006 9.86761C18.3396 9.78726 18.916 9.48977 19.5096 9.36096C19.6064 9.33925 19.7053 9.32814 19.8045 9.32784C20.1203 9.32784 20.4177 9.45051 20.5403 9.76947C20.7157 10.2332 20.479 10.6104 19.9376 10.9882C19.6107 11.2164 18.4328 11.9451 18.1673 12.1911C17.8919 12.445 17.9281 12.6413 17.96 12.8909C17.9864 13.1001 18.5787 15.8787 22.2953 17.6753C22.5148 17.7851 22.8852 18.0083 22.2321 18.3721Z" fill="black"/>
</svg>
`;

const Snapchat = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9131 17.4571C23.7477 17.0035 23.429 16.7584 23.0674 16.5623C23 16.5255 22.9387 16.4887 22.8835 16.4642C22.7732 16.4091 22.6629 16.3539 22.5526 16.2988C21.4249 15.6982 20.5424 14.9505 19.9357 14.0557C19.7641 13.8044 19.6109 13.5348 19.4883 13.259C19.4331 13.1119 19.4393 13.0261 19.476 12.9464C19.5128 12.8851 19.5618 12.8361 19.6231 12.7932C19.8192 12.6645 20.0154 12.5358 20.1502 12.45C20.3892 12.2907 20.5853 12.1681 20.7079 12.0823C21.1675 11.7575 21.4923 11.4143 21.6946 11.0282C21.9826 10.4889 22.0194 9.85761 21.7988 9.28765C21.4923 8.47868 20.7324 7.98226 19.807 7.98226C19.6109 7.98226 19.4209 8.00065 19.2248 8.04355C19.1757 8.0558 19.1206 8.06806 19.0716 8.08032C19.0777 7.52874 19.0654 6.94653 19.0164 6.37044C18.8448 4.35413 18.1339 3.30002 17.3985 2.4604C16.9266 1.93334 16.375 1.48596 15.756 1.13663C14.6406 0.499254 13.372 0.174438 11.993 0.174438C10.6141 0.174438 9.35162 0.499254 8.23621 1.13663C7.61723 1.48596 7.06565 1.93334 6.59375 2.4604C5.85832 3.30002 5.15353 4.36026 4.9758 6.37044C4.92678 6.94653 4.91452 7.52874 4.92065 8.08032C4.87162 8.06806 4.82259 8.0558 4.76743 8.04355C4.57745 8.00065 4.38133 7.98226 4.19134 7.98226C3.26593 7.98226 2.50598 8.4848 2.19955 9.28765C1.97892 9.85761 2.0157 10.4889 2.30374 11.0282C2.50598 11.4143 2.8308 11.7575 3.29044 12.0823C3.41301 12.1681 3.603 12.2907 3.84814 12.45C3.97684 12.5358 4.16683 12.6584 4.35682 12.7809C4.42423 12.8238 4.47939 12.879 4.52229 12.9464C4.55906 13.0261 4.56519 13.1119 4.5039 13.2712C4.38133 13.5409 4.23424 13.8044 4.06264 14.0496C3.46817 14.9198 2.61017 15.6614 1.51928 16.2559C0.943193 16.5623 0.342591 16.7645 0.0851904 17.4571C-0.104796 17.978 0.017776 18.5663 0.501934 19.0689C0.679664 19.2527 0.888036 19.4121 1.11479 19.5347C1.58669 19.7921 2.08924 19.9943 2.6163 20.1353C2.72661 20.1659 2.82467 20.2088 2.9166 20.2701C3.09433 20.4233 3.06981 20.6562 3.3027 20.9994C3.41914 21.1771 3.57236 21.3303 3.74396 21.4529C4.24037 21.7961 4.79807 21.8145 5.38642 21.839C5.91961 21.8574 6.52021 21.8819 7.21274 22.1087C7.50078 22.2006 7.79495 22.3844 8.13815 22.5989C8.96551 23.1076 10.0932 23.8001 11.9869 23.8001C13.8806 23.8001 15.0144 23.1015 15.8479 22.5928C16.1911 22.3844 16.4853 22.2006 16.7611 22.1087C17.4475 21.8819 18.0542 21.8574 18.5874 21.839C19.1757 21.8145 19.7334 21.7961 20.2299 21.4529C20.4382 21.3058 20.6098 21.122 20.7324 20.9013C20.904 20.6133 20.8979 20.411 21.0572 20.2701C21.143 20.2088 21.2411 20.1659 21.3391 20.1414C21.8662 20.0004 22.381 19.7982 22.859 19.5347C23.098 19.406 23.3187 19.2344 23.5025 19.0321L23.5087 19.026C23.9867 18.5357 24.1031 17.9596 23.9131 17.4571ZM22.2339 18.358C21.2104 18.9218 20.524 18.8605 19.997 19.2037C19.5435 19.4917 19.8131 20.1169 19.4883 20.3436C19.0838 20.6194 17.8949 20.3252 16.3627 20.8339C15.0941 21.2507 14.2913 22.458 12.0114 22.458C9.73159 22.458 8.94713 21.2568 7.66013 20.8339C6.12798 20.3252 4.93903 20.6255 4.53455 20.3436C4.20973 20.1169 4.47326 19.4917 4.02587 19.2037C3.49269 18.8605 2.81241 18.9218 1.78894 18.358C1.13318 17.9964 1.50702 17.7757 1.72152 17.6716C5.43545 15.8759 6.02992 13.0996 6.05444 12.8913C6.08508 12.64 6.12185 12.4439 5.84606 12.1926C5.58253 11.9475 4.40585 11.2182 4.0749 10.9914C3.53559 10.6114 3.29657 10.2376 3.4743 9.77181C3.59687 9.45312 3.89717 9.33055 4.20973 9.33055C4.30779 9.33055 4.40585 9.34281 4.5039 9.36119C5.09838 9.48989 5.67446 9.78407 6.00541 9.86987C6.04831 9.88212 6.08508 9.88825 6.12798 9.88825C6.30571 9.88825 6.36699 9.79632 6.35474 9.59408C6.31797 8.94445 6.22604 7.68196 6.33022 6.49914C6.47118 4.87507 6.99211 4.06609 7.61723 3.35518C7.91753 3.01197 9.32097 1.52886 12.0114 1.52886C14.7019 1.52886 16.1053 3.00585 16.4056 3.34905C17.0307 4.05996 17.5517 4.86894 17.6926 6.49301C17.7968 7.67583 17.7049 8.93832 17.662 9.58795C17.6497 9.80245 17.711 9.88212 17.8887 9.88212C17.9316 9.88212 17.9684 9.87599 18.0113 9.86374C18.3423 9.78406 18.9183 9.48376 19.5128 9.35506C19.6109 9.33055 19.7089 9.32442 19.807 9.32442C20.1195 9.32442 20.4198 9.44699 20.5424 9.76568C20.7201 10.2315 20.4811 10.6053 19.9418 10.9853C19.617 11.212 18.4403 11.9413 18.1707 12.1865C17.8949 12.4377 17.9316 12.6339 17.9623 12.8851C17.9868 13.0935 18.5813 15.8698 22.2952 17.6654C22.5158 17.7696 22.8835 17.9964 22.2339 18.358Z" />
</svg>
`;

const Solana = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M3.25027 14.1702C3.37266 14.0467 3.53858 13.9773 3.71157 13.9773H19.6731C19.9638 13.9773 20.1094 14.3325 19.9037 14.5401L16.7497 17.7238C16.6274 17.8473 16.4614 17.9167 16.2884 17.9167H0.326949C0.0362038 17.9167 -0.109361 17.5615 0.0962996 17.3539L3.25027 14.1702Z" fill="url(#paint0_linear_963_3782)"/>
  <path d="M3.25027 2.27631C3.37264 2.15276 3.53857 2.08337 3.71157 2.08337H19.6731C19.9638 2.08337 20.1094 2.43858 19.9037 2.64622L16.7497 5.82987C16.6274 5.95338 16.4614 6.02276 16.2884 6.02276H0.326949C0.0362038 6.02276 -0.109361 5.66756 0.0962996 5.45996L3.25027 2.27631Z" fill="url(#paint1_linear_963_3782)"/>
  <path d="M16.7497 8.18537C16.6274 8.06186 16.4614 7.99248 16.2884 7.99248H0.326949C0.0362038 7.99248 -0.109361 8.34768 0.0962996 8.55529L3.25027 11.7389C3.37264 11.8625 3.53857 11.9319 3.71157 11.9319H19.6731C19.9638 11.9319 20.1094 11.5767 19.9037 11.369L16.7497 8.18537Z" fill="url(#paint2_linear_963_3782)"/>
  <defs>
    <linearGradient id="paint0_linear_963_3782" x1="13.5212" y1="-2.25977" x2="2.29692" y2="19.0217" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00FFA3"/>
      <stop offset="1" stop-color="#DC1FFF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_963_3782" x1="13.5212" y1="-2.25977" x2="2.29692" y2="19.0217" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00FFA3"/>
      <stop offset="1" stop-color="#DC1FFF"/>
    </linearGradient>
    <linearGradient id="paint2_linear_963_3782" x1="13.5212" y1="-2.25977" x2="2.29692" y2="19.0217" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00FFA3"/>
      <stop offset="1" stop-color="#DC1FFF"/>
    </linearGradient>
  </defs>
</svg>
`;

const SpacingHeight = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 3C2 2.44772 2.44772 2 3 2H21C21.5523 2 22 2.44772 22 3C22 3.55228 21.5523 4 21 4H3C2.44772 4 2 3.55228 2 3Z" fill="currentColor"/>
<path d="M2 21C2 20.4477 2.44772 20 3 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21Z" fill="currentColor"/>
<path d="M14.4453 8.83205L13 7.86853L13 16.1316L14.4453 15.1681C14.9048 14.8617 15.5257 14.9859 15.832 15.4454C16.1384 15.9049 16.0142 16.5258 15.5547 16.8322L12.5547 18.8322C12.2188 19.0561 11.7812 19.0561 11.4453 18.8322L8.44528 16.8322C7.98576 16.5258 7.86158 15.9049 8.16793 15.4454C8.47429 14.9859 9.09516 14.8617 9.55468 15.1681L11 16.1316L11 7.86851L9.55468 8.83205C9.09516 9.1384 8.47429 9.01423 8.16793 8.5547C7.86158 8.09517 7.98576 7.4743 8.44528 7.16795L11.4453 5.16795C11.7812 4.94402 12.2188 4.94402 12.5547 5.16795L15.5547 7.16795C16.0142 7.4743 16.1384 8.09517 15.832 8.5547C15.5257 9.01423 14.9048 9.1384 14.4453 8.83205Z" fill="currentColor"/>
</svg>
`;

const Star04Filled = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke="none" fill="currentColor">
  <path d="M12.9333 1.64102C12.7848 1.25483 12.4138 1 12 1C11.5862 1 11.2152 1.25483 11.0667 1.64102L9.0547 6.87211C8.7543 7.65315 8.6599 7.87822 8.53078 8.05981C8.40122 8.24202 8.24202 8.40122 8.05981 8.53078C7.87822 8.6599 7.65315 8.7543 6.8721 9.0547L1.64102 11.0667C1.25483 11.2152 1 11.5862 1 12C1 12.4138 1.25483 12.7848 1.64102 12.9333L6.87211 14.9453C7.65315 15.2457 7.87822 15.3401 8.05981 15.4692C8.24202 15.5988 8.40122 15.758 8.53078 15.9402C8.6599 16.1218 8.7543 16.3469 9.0547 17.1279L11.0667 22.359C11.2152 22.7452 11.5862 23 12 23C12.4138 23 12.7848 22.7452 12.9333 22.359L14.9453 17.1279C15.2457 16.3469 15.3401 16.1218 15.4692 15.9402C15.5988 15.758 15.758 15.5988 15.9402 15.4692C16.1218 15.3401 16.3469 15.2457 17.1279 14.9453L22.359 12.9333C22.7452 12.7848 23 12.4138 23 12C23 11.5862 22.7452 11.2152 22.359 11.0667L17.1279 9.0547C16.3469 8.7543 16.1218 8.6599 15.9402 8.53078C15.758 8.40122 15.5988 8.24202 15.4692 8.05981C15.3401 7.87822 15.2457 7.65315 14.9453 6.87211L12.9333 1.64102Z" />
</svg>`;

const Stars01Filled = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
<g id="stars-01">
<g id="Solid">
<path d="M15.9333 1.64102C15.7848 1.25483 15.4138 1 15 1C14.5862 1 14.2152 1.25483 14.0667 1.64102L12.888 4.70544C12.5876 5.48648 12.4932 5.71155 12.3641 5.89315C12.2345 6.07535 12.0754 6.23455 11.8931 6.36411C11.7116 6.49323 11.4865 6.58763 10.7054 6.88803L7.64102 8.06665C7.25483 8.21519 7 8.58623 7 9C7 9.41377 7.25483 9.78481 7.64102 9.93335L10.7054 11.112C11.4865 11.4124 11.7116 11.5068 11.8931 11.6359C12.0754 11.7655 12.2345 11.9246 12.3641 12.1069C12.4932 12.2884 12.5876 12.5135 12.888 13.2946L14.0667 16.359C14.2152 16.7452 14.5862 17 15 17C15.4138 17 15.7848 16.7452 15.9333 16.359L17.112 13.2946C17.4124 12.5135 17.5068 12.2884 17.6359 12.1069C17.7655 11.9246 17.9246 11.7655 18.1069 11.6359C18.2884 11.5068 18.5135 11.4124 19.2946 11.112L22.359 9.93335C22.7452 9.78481 23 9.41377 23 9C23 8.58623 22.7452 8.21519 22.359 8.06665L19.2946 6.88803C18.5135 6.58763 18.2884 6.49323 18.1069 6.36411C17.9246 6.23455 17.7654 6.07536 17.6359 5.89315C17.5068 5.71155 17.4124 5.48648 17.112 4.70544L15.9333 1.64102Z"/>
<path d="M7.39443 12.5528C7.22503 12.214 6.87877 12 6.5 12C6.12123 12 5.77496 12.214 5.60557 12.5528L4.82111 14.1217C4.53863 14.6867 4.45255 14.8493 4.34796 14.9849C4.24305 15.121 4.12104 15.243 3.98494 15.348C3.84925 15.4525 3.68667 15.5386 3.1217 15.8211L1.55279 16.6056C1.214 16.775 1 17.1212 1 17.5C1 17.8788 1.214 18.225 1.55279 18.3944L3.1217 19.1789C3.68667 19.4614 3.84925 19.5475 3.98494 19.652C4.12104 19.757 4.24305 19.879 4.34796 20.0151C4.45255 20.1507 4.53863 20.3133 4.82111 20.8783L5.60557 22.4472C5.77497 22.786 6.12123 23 6.5 23C6.87877 23 7.22504 22.786 7.39443 22.4472L8.17889 20.8783C8.46137 20.3133 8.54745 20.1507 8.65204 20.0151C8.75695 19.879 8.87896 19.757 9.01506 19.652C9.15075 19.5475 9.31333 19.4614 9.8783 19.1789L11.4472 18.3944C11.786 18.225 12 17.8788 12 17.5C12 17.1212 11.786 16.775 11.4472 16.6056L9.8783 15.8211C9.31333 15.5386 9.15075 15.4525 9.01506 15.348C8.87896 15.243 8.75695 15.121 8.65204 14.9849C8.54745 14.8493 8.46137 14.6867 8.17889 14.1217L7.39443 12.5528Z"/>
</g>
</g>
</svg>
`;

const Stars = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const StopSquare = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 9.6C8 9.03995 8 8.75992 8.10899 8.54601C8.20487 8.35785 8.35785 8.20487 8.54601 8.10899C8.75992 8 9.03995 8 9.6 8H14.4C14.9601 8 15.2401 8 15.454 8.10899C15.6422 8.20487 15.7951 8.35785 15.891 8.54601C16 8.75992 16 9.03995 16 9.6V14.4C16 14.9601 16 15.2401 15.891 15.454C15.7951 15.6422 15.6422 15.7951 15.454 15.891C15.2401 16 14.9601 16 14.4 16H9.6C9.03995 16 8.75992 16 8.54601 15.891C8.35785 15.7951 8.20487 15.6422 8.10899 15.454C8 15.2401 8 14.9601 8 14.4V9.6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const StripeBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.2695 7.13648C10.2695 6.109 11.1386 5.7115 12.5428 5.7115C14.8668 5.7609 17.1473 6.34144 19.204 7.40723V1.20481C17.0833 0.384858 14.8213 -0.02389 12.5428 0.0010786C7.13022 0.0010786 3.5 2.79029 3.5 7.44773C3.5 14.7346 13.671 13.5511 13.671 16.6921C13.671 17.9206 12.6038 18.3016 11.102 18.3016C8.8874 18.3016 6.02713 17.4001 3.78359 16.2001V22.4835C6.09346 23.4723 8.58371 23.9883 11.1027 24C16.6655 24 20.5 21.2963 20.5 16.5579C20.5 8.69346 10.2695 10.0982 10.2695 7.13798V7.13648Z" fill="#6772E5"/>
</svg>
`;

const TelegramBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21213)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="url(#paint0_linear_106_21213)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.43189 11.8733C8.93014 10.3492 11.2628 9.3444 12.43 8.85893C15.7626 7.47282 16.455 7.23203 16.9064 7.22408C17.0056 7.22234 17.2276 7.24694 17.3714 7.3636C17.4928 7.46211 17.5262 7.59518 17.5422 7.68857C17.5581 7.78197 17.578 7.99473 17.5622 8.16097C17.3816 10.0585 16.6002 14.6631 16.2027 16.7884C16.0345 17.6876 15.7032 17.9891 15.3826 18.0186C14.6857 18.0828 14.1566 17.5581 13.4816 17.1157C12.4255 16.4233 11.8288 15.9924 10.8036 15.3168C9.61884 14.536 10.3869 14.1069 11.0621 13.4056C11.2388 13.2221 14.3092 10.4294 14.3686 10.176C14.376 10.1443 14.3829 10.0262 14.3128 9.96385C14.2426 9.90148 14.139 9.92281 14.0643 9.93977C13.9584 9.96381 12.2712 11.079 9.00264 13.2853C8.52373 13.6142 8.08994 13.7744 7.70129 13.766C7.27283 13.7568 6.44864 13.5238 5.83594 13.3246C5.08444 13.0803 4.48716 12.9512 4.53917 12.5363C4.56626 12.3202 4.86383 12.0992 5.43189 11.8733Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_106_21213" x1="12" y1="0" x2="12" y2="23.822" gradientUnits="userSpaceOnUse">
<stop stop-color="#2AABEE"/>
<stop offset="1" stop-color="#229ED9"/>
</linearGradient>
<clipPath id="clip0_106_21213">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Telegram = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21415)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.43 8.85893C11.2628 9.3444 8.93014 10.3492 5.43189 11.8733C4.86383 12.0992 4.56626 12.3202 4.53917 12.5363C4.49339 12.9015 4.95071 13.0453 5.57348 13.2411C5.65819 13.2678 5.74596 13.2954 5.83594 13.3246C6.44864 13.5238 7.27283 13.7568 7.70129 13.766C8.08994 13.7744 8.52373 13.6142 9.00264 13.2853C12.2712 11.079 13.9584 9.96381 14.0643 9.93977C14.139 9.92281 14.2426 9.90148 14.3128 9.96385C14.3829 10.0262 14.376 10.1443 14.3686 10.176C14.3233 10.3691 12.5281 12.0381 11.5991 12.9018C11.3095 13.171 11.1041 13.362 11.0621 13.4056C10.968 13.5033 10.8721 13.5958 10.78 13.6846C10.2108 14.2333 9.78391 14.6448 10.8036 15.3168C11.2936 15.6397 11.6857 15.9067 12.0769 16.1731C12.5042 16.4641 12.9303 16.7543 13.4816 17.1157C13.6221 17.2077 13.7562 17.3034 13.8869 17.3965C14.3841 17.751 14.8307 18.0694 15.3826 18.0186C15.7032 17.9891 16.0345 17.6876 16.2027 16.7884C16.6002 14.6631 17.3816 10.0585 17.5622 8.16097C17.578 7.99473 17.5581 7.78197 17.5422 7.68857C17.5262 7.59518 17.4928 7.46211 17.3714 7.3636C17.2276 7.24694 17.0056 7.22234 16.9064 7.22408C16.455 7.23203 15.7626 7.47282 12.43 8.85893Z" />
</g>
<defs>
<clipPath id="clip0_106_21415">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TetherBrand = `<?xml version="1.0" encoding="utf-8"?>
<svg width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
<g fill="none" fill-rule="evenodd">
<circle cx="16" cy="16" r="16" fill="#26A17B"/>
<path fill="#FFF" d="M17.922 17.383v-.002c-.11.008-.677.042-1.942.042-1.01 0-1.721-.03-1.971-.042v.003c-3.888-.171-6.79-.848-6.79-1.658 0-.809 2.902-1.486 6.79-1.66v2.644c.254.018.982.061 1.988.061 1.207 0 1.812-.05 1.925-.06v-2.643c3.88.173 6.775.85 6.775 1.658 0 .81-2.895 1.485-6.775 1.657m0-3.59v-2.366h5.414V7.819H8.595v3.608h5.414v2.365c-4.4.202-7.709 1.074-7.709 2.118 0 1.044 3.309 1.915 7.709 2.118v7.582h3.913v-7.584c4.393-.202 7.694-1.073 7.694-2.116 0-1.043-3.301-1.914-7.694-2.117"/>
</g>
</svg>
`;

const TikTokBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.1762 8.66347C18.7196 9.77064 20.6102 10.4221 22.6523 10.4221V6.47861C22.2658 6.47869 21.8803 6.43825 21.5023 6.35786V9.46193C19.4604 9.46193 17.57 8.81049 16.0262 7.7034V15.7509C16.0262 19.7766 12.7743 23.0399 8.76309 23.0399C7.26641 23.0399 5.87531 22.5858 4.71973 21.807C6.03864 23.1604 7.87796 24 9.91285 24C13.9243 24 17.1764 20.7367 17.1764 16.7108V8.66347H17.1762ZM18.5949 4.68499C17.8061 3.82023 17.2883 2.70267 17.1762 1.46717V0.959961H16.0864C16.3607 2.53028 17.2964 3.87187 18.5949 4.68499ZM7.25681 18.7178C6.81614 18.1379 6.578 17.4286 6.57907 16.6992C6.57907 14.858 8.06647 13.3651 9.90153 13.3651C10.2435 13.365 10.5835 13.4176 10.9094 13.5214V9.48977C10.5285 9.43739 10.1441 9.41515 9.75986 9.4233V12.5613C9.4337 12.4575 9.0936 12.4048 8.75152 12.4051C6.91646 12.4051 5.42914 13.8979 5.42914 15.7393C5.42914 17.0414 6.1726 18.1687 7.25681 18.7178Z" fill="#FF004F"/>
<path d="M16.0265 7.70332C17.5702 8.81041 19.4607 9.46185 21.5025 9.46185V6.35778C20.3628 6.11414 19.3538 5.5164 18.5951 4.68499C17.2966 3.87179 16.361 2.5302 16.0867 0.959961H13.2241V16.7106C13.2176 18.5468 11.7327 20.0336 9.90162 20.0336C8.82257 20.0336 7.86394 19.5174 7.25682 18.7178C6.17269 18.1687 5.42923 17.0413 5.42923 15.7394C5.42923 13.8981 6.91655 12.4052 8.75161 12.4052C9.1032 12.4052 9.44208 12.4602 9.75995 12.5614V9.42338C5.81921 9.50509 2.6499 12.7365 2.6499 16.7107C2.6499 18.6946 3.43913 20.4931 4.72006 21.8071C5.87565 22.5858 7.26675 23.04 8.76342 23.04C12.7747 23.04 16.0265 19.7765 16.0265 15.7509V7.70332H16.0265Z" fill="black"/>
<path d="M21.5025 6.3578V5.51848C20.4748 5.52005 19.4672 5.23119 18.5952 4.68493C19.3671 5.53306 20.3835 6.11787 21.5025 6.3578ZM16.0867 0.959983C16.0605 0.809911 16.0404 0.658851 16.0265 0.507214V0H12.074V15.7508C12.0677 17.5868 10.5829 19.0736 8.75164 19.0736C8.214 19.0736 7.70638 18.9455 7.25685 18.7179C7.86397 19.5174 8.82259 20.0336 9.90164 20.0336C11.7326 20.0336 13.2177 18.5469 13.2241 16.7107V0.959983H16.0867ZM9.76014 9.42341V8.52989C9.42988 8.48459 9.09691 8.46186 8.76353 8.46202C4.75192 8.46194 1.5 11.7254 1.5 15.7508C1.5 18.2745 2.77806 20.4987 4.72017 21.807C3.43924 20.493 2.65001 18.6944 2.65001 16.7106C2.65001 12.7365 5.81924 9.50511 9.76014 9.42341Z" fill="#00F2EA"/>
</svg>
`;

const TikTok = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z" />
</svg>
`;

const Trash = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="#616161" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const TumblrBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21210)">
<path d="M14.6 24C11 24 8.3 22.15 8.3 17.7V10.6H5V6.75C8.6 5.8 10.1 2.7 10.3 0H14.05V6.1H18.4V10.6H14.05V16.8C14.05 18.65 15 19.3 16.5 19.3H18.6V24H14.6Z" fill="#001935"/>
</g>
<defs>
<clipPath id="clip0_106_21210">
<rect width="13.6" height="24" fill="white" transform="translate(5)"/>
</clipPath>
</defs>
</svg>
`;

const Tumblr = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21409)">
<path d="M14.6 24C11 24 8.3 22.15 8.3 17.7V10.6H5V6.75C8.6 5.8 10.1 2.7 10.3 0H14.05V6.1H18.4V10.6H14.05V16.8C14.05 18.65 15 19.3 16.5 19.3H18.6V24H14.6Z" />
</g>
<defs>
<clipPath id="clip0_106_21409">
<rect width="13.6" height="24" fill="white" transform="translate(5)"/>
</clipPath>
</defs>
</svg>
`;

const TwitterBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9455 23L10.396 15.0901L3.44886 23H0.509766L9.09209 13.2311L0.509766 1H8.05571L13.286 8.45502L19.8393 1H22.7784L14.5943 10.3165L23.4914 23H15.9455ZM19.2185 20.77H17.2398L4.71811 3.23H6.6971L11.7121 10.2532L12.5793 11.4719L19.2185 20.77Z" fill="#242E36"/>
</svg>
`;

const Twitter = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9455 23L10.396 15.0901L3.44886 23H0.509766L9.09209 13.2311L0.509766 1H8.05571L13.286 8.45502L19.8393 1H22.7784L14.5943 10.3165L23.4914 23H15.9455ZM19.2185 20.77H17.2398L4.71811 3.23H6.6971L11.7121 10.2532L12.5793 11.4719L19.2185 20.77Z" />
</svg>
`;

const UsdcBrand = `<svg data-name="86977684-12db-4850-8f30-233a7c267d11" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000">
  <path d="M1000 2000c554.17 0 1000-445.83 1000-1000S1554.17 0 1000 0 0 445.83 0 1000s445.83 1000 1000 1000z" fill="#2775ca"/>
  <path d="M1275 1158.33c0-145.83-87.5-195.83-262.5-216.66-125-16.67-150-50-150-108.34s41.67-95.83 125-95.83c75 0 116.67 25 137.5 87.5 4.17 12.5 16.67 20.83 29.17 20.83h66.66c16.67 0 29.17-12.5 29.17-29.16v-4.17c-16.67-91.67-91.67-162.5-187.5-170.83v-100c0-16.67-12.5-29.17-33.33-33.34h-62.5c-16.67 0-29.17 12.5-33.34 33.34v95.83c-125 16.67-204.16 100-204.16 204.17 0 137.5 83.33 191.66 258.33 212.5 116.67 20.83 154.17 45.83 154.17 112.5s-58.34 112.5-137.5 112.5c-108.34 0-145.84-45.84-158.34-108.34-4.16-16.66-16.66-25-29.16-25h-70.84c-16.66 0-29.16 12.5-29.16 29.17v4.17c16.66 104.16 83.33 179.16 220.83 200v100c0 16.66 12.5 29.16 33.33 33.33h62.5c16.67 0 29.17-12.5 33.34-33.33v-100c125-20.84 208.33-108.34 208.33-220.84z" fill="#fff"/>
  <path d="M787.5 1595.83c-325-116.66-491.67-479.16-370.83-800 62.5-175 200-308.33 370.83-370.83 16.67-8.33 25-20.83 25-41.67V325c0-16.67-8.33-29.17-25-33.33-4.17 0-12.5 0-16.67 4.16-395.83 125-612.5 545.84-487.5 941.67 75 233.33 254.17 412.5 487.5 487.5 16.67 8.33 33.34 0 37.5-16.67 4.17-4.16 4.17-8.33 4.17-16.66v-58.34c0-12.5-12.5-29.16-25-37.5zM1229.17 295.83c-16.67-8.33-33.34 0-37.5 16.67-4.17 4.17-4.17 8.33-4.17 16.67v58.33c0 16.67 12.5 33.33 25 41.67 325 116.66 491.67 479.16 370.83 800-62.5 175-200 308.33-370.83 370.83-16.67 8.33-25 20.83-25 41.67V1700c0 16.67 8.33 29.17 25 33.33 4.17 0 12.5 0 16.67-4.16 395.83-125 612.5-545.84 487.5-941.67-75-237.5-258.34-416.67-487.5-491.67z" fill="#fff"/>
</svg>
`;

const UserCircle = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="user-circle">
<path id="Icon" d="M5.3163 19.4384C5.92462 18.0052 7.34492 17 9 17H15C16.6551 17 18.0754 18.0052 18.6837 19.4384M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const User = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="user-03">
<path id="Icon" d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const Wallet = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<g id="wallet-04">
<path id="Icon" d="M20 9.5V7.2C20 6.0799 20 5.51984 19.782 5.09202C19.5903 4.7157 19.2843 4.40974 18.908 4.21799C18.4802 4 17.9201 4 16.8 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.7157 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V16.8C2 17.9201 2 18.4802 2.21799 18.908C2.40973 19.2843 2.71569 19.5903 3.09202 19.782C3.51984 20 4.07989 20 5.2 20L16.8 20C17.9201 20 18.4802 20 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C20 18.4802 20 17.9201 20 16.8V14.5M15 12C15 11.5353 15 11.303 15.0384 11.1098C15.1962 10.3164 15.8164 9.69624 16.6098 9.53843C16.803 9.5 17.0353 9.5 17.5 9.5H19.5C19.9647 9.5 20.197 9.5 20.3902 9.53843C21.1836 9.69624 21.8038 10.3164 21.9616 11.1098C22 11.303 22 11.5353 22 12C22 12.4647 22 12.697 21.9616 12.8902C21.8038 13.6836 21.1836 14.3038 20.3902 14.4616C20.197 14.5 19.9647 14.5 19.5 14.5H17.5C17.0353 14.5 16.803 14.5 16.6098 14.4616C15.8164 14.3038 15.1962 13.6836 15.0384 12.8902C15 12.697 15 12.4647 15 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
`;

const X = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L7 17M7 7L17 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const YoutubeBrand = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_106_21177)">
<path d="M23.522 6.18547C23.3863 5.67489 23.1189 5.20889 22.7465 4.83413C22.3741 4.45936 21.9099 4.18897 21.4002 4.05002C19.5238 3.54547 12.0238 3.54547 12.0238 3.54547C12.0238 3.54547 4.5238 3.54547 2.64744 4.05002C2.13773 4.18897 1.67346 4.45936 1.30109 4.83413C0.92872 5.20889 0.661309 5.67489 0.525622 6.18547C0.0238038 8.07002 0.0238037 12 0.0238037 12C0.0238037 12 0.0238038 15.93 0.525622 17.8146C0.661309 18.3251 0.92872 18.7911 1.30109 19.1659C1.67346 19.5407 2.13773 19.8111 2.64744 19.95C4.5238 20.4546 12.0238 20.4546 12.0238 20.4546C12.0238 20.4546 19.5238 20.4546 21.4002 19.95C21.9099 19.8111 22.3741 19.5407 22.7465 19.1659C23.1189 18.7911 23.3863 18.3251 23.522 17.8146C24.0238 15.93 24.0238 12 24.0238 12C24.0238 12 24.0238 8.07002 23.522 6.18547Z" fill="#FF0302"/>
<path d="M9.56934 15.5687V8.4314L15.8421 12L9.56934 15.5687Z" fill="#FEFEFE"/>
</g>
<defs>
<clipPath id="clip0_106_21177">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Youtube = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M23.7609 7.20005C23.7609 7.20005 23.5266 5.54536 22.8047 4.8188C21.8906 3.86255 20.8688 3.85786 20.4 3.80161C17.0438 3.55786 12.0047 3.55786 12.0047 3.55786H11.9953C11.9953 3.55786 6.95625 3.55786 3.6 3.80161C3.13125 3.85786 2.10938 3.86255 1.19531 4.8188C0.473438 5.54536 0.24375 7.20005 0.24375 7.20005C0.24375 7.20005 0 9.14536 0 11.086V12.9047C0 14.8454 0.239062 16.7907 0.239062 16.7907C0.239062 16.7907 0.473437 18.4454 1.19062 19.1719C2.10469 20.1282 3.30469 20.0954 3.83906 20.1985C5.76094 20.3813 12 20.4375 12 20.4375C12 20.4375 17.0438 20.4282 20.4 20.1891C20.8688 20.1329 21.8906 20.1282 22.8047 19.1719C23.5266 18.4454 23.7609 16.7907 23.7609 16.7907C23.7609 16.7907 24 14.85 24 12.9047V11.086C24 9.14536 23.7609 7.20005 23.7609 7.20005ZM9.52031 15.1125V8.36724L16.0031 11.7516L9.52031 15.1125Z" />
</svg>
`;

const AD = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4012)">
<path d="M6.78286 22.8093C8.36049 23.5721 10.1303 24 12.0002 24C13.8701 24 15.64 23.5721 17.2176 22.8093L18.2611 12L17.2176 1.19072C15.64 0.427875 13.8701 0 12.0002 0C10.1303 0 8.36049 0.427875 6.78286 1.19072L5.73938 12L6.78286 22.8093Z" fill="#FFDA44"/>
<path d="M17.2169 22.809C21.2309 20.8681 23.9995 16.7577 23.9995 12.0002C23.9995 7.24269 21.2309 3.13222 17.2169 1.19131V22.809Z" fill="#D80027"/>
<path d="M6.78238 22.809V1.19131C2.76843 3.13222 -0.000244141 7.24264 -0.000244141 12.0002C-0.000244141 16.7577 2.76843 20.8681 6.78238 22.809Z" fill="#0052B4"/>
<path d="M11.9999 16.1734C11.9999 14.2585 11.9999 11.9995 11.9999 11.9995H15.1303V13.5647C15.1303 13.8366 14.6086 14.833 13.3208 15.6517C12.8331 15.9618 12.3282 16.0615 11.9999 16.1734Z" fill="#D80027"/>
<path d="M11.9997 8.86884H8.86926V11.9993H11.9997V8.86884Z" fill="#D80027"/>
<path d="M13.5654 7.8262C13.5654 7.24987 13.0982 6.78271 12.5219 6.78271C12.3316 6.78271 12.1537 6.83446 12.0002 6.92343C11.8466 6.83446 11.6688 6.78271 11.4785 6.78271C10.9022 6.78271 10.435 7.24987 10.435 7.8262H7.82629V13.0435C7.82629 14.9858 9.36876 16.1091 10.5784 16.6914C10.4879 16.846 10.435 17.0254 10.435 17.2175C10.435 17.7938 10.9022 18.261 11.4785 18.261C11.6688 18.261 11.8466 18.2093 12.0002 18.1203C12.1538 18.2093 12.3316 18.261 12.5219 18.261C13.0982 18.261 13.5654 17.7938 13.5654 17.2175C13.5654 17.0254 13.5125 16.846 13.4219 16.6914C14.6316 16.1091 16.1741 14.9859 16.1741 13.0435V7.8262H13.5654ZM14.6089 13.0435C14.6089 13.3155 14.6089 14.1428 13.3211 14.9616C12.8333 15.2717 12.3285 15.4728 12.0002 15.5846C11.6719 15.4728 11.167 15.2717 10.6792 14.9616C9.3915 14.1428 9.3915 13.3155 9.3915 13.0435V9.3914H14.6089V13.0435Z" fill="#FF9811"/>
</g>
<defs>
<clipPath id="clip0_2087_4012">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5787)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M6.78259 16.1729L7.82608 23.2527C9.12601 23.7351 10.5321 23.999 12 23.999C17.1595 23.999 21.5581 20.7425 23.2535 16.1729H6.78259Z" fill="black"/>
<path d="M6.78259 7.8266L7.82608 0.746785C9.12601 0.264394 10.5321 0.000488281 12 0.000488281C17.1595 0.000488281 21.5581 3.25699 23.2535 7.8266H6.78259Z" fill="#6DA544"/>
<path d="M0.000366211 12C0.000366211 17.1596 3.25691 21.5581 7.82648 23.2536V0.746399C3.25691 2.44191 0.000366211 6.84043 0.000366211 12Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_5787">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AF = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_3980)">
<path d="M17.2173 1.19072C15.6396 0.427875 13.8697 0 11.9999 0C10.13 0 8.36012 0.427875 6.7825 1.19072L5.73901 12L6.7825 22.8093C8.36012 23.5721 10.13 24 11.9999 24C13.8697 24 15.6396 23.5721 17.2173 22.8093L18.2607 12L17.2173 1.19072Z" fill="#D80027"/>
<path d="M6.78275 1.19131C2.76884 3.13227 0.00012207 7.24269 0.00012207 12.0002C0.00012207 16.7577 2.76884 20.8681 6.78275 22.809V1.19131Z" fill="black"/>
<path d="M17.2175 1.19131V22.809C21.2314 20.8681 24.0002 16.7577 24.0002 12.0002C24.0002 7.24269 21.2314 3.13227 17.2175 1.19131Z" fill="#496E2D"/>
<path d="M11.9997 7.82675C9.69448 7.82675 7.82581 9.69547 7.82581 12.0006C7.82581 14.3058 9.69452 16.1745 11.9997 16.1745C14.3049 16.1745 16.1736 14.3058 16.1736 12.0006C16.1736 9.69547 14.3049 7.82675 11.9997 7.82675ZM11.9997 14.6093C10.5589 14.6093 9.39101 13.4413 9.39101 12.0006C9.39101 10.5599 10.559 9.39196 11.9997 9.39196C13.4404 9.39196 14.6084 10.5599 14.6084 12.0006C14.6084 13.4413 13.4404 14.6093 11.9997 14.6093Z" fill="#FFDA44"/>
<path d="M12 10.4363C11.4237 10.4363 10.9565 10.9034 10.9565 11.4798V13.045H13.0435V11.4798C13.0435 10.9034 12.5764 10.4363 12 10.4363Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_3980">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4042)">
<path d="M0 11.9993C0 12.8212 0.082875 13.6238 0.240328 14.3993L12 15.1297L23.7597 14.3993C23.9172 13.6238 24 12.8212 24 11.9993C24 11.1773 23.9171 10.3747 23.7597 9.59929L12 8.86884L0.240328 9.59929C0.082875 10.3747 0 11.1773 0 11.9993Z" fill="#0052B4"/>
<path d="M23.7595 14.3992H0.240112C1.35194 19.8765 6.19436 23.9992 11.9998 23.9992C17.8052 23.9992 22.6476 19.8765 23.7595 14.3992Z" fill="#F0F0F0"/>
<path d="M0.240112 9.6H23.7596C22.6476 4.12266 17.8053 0 11.9998 0C6.19427 0 1.35194 4.12266 0.240112 9.6Z" fill="black"/>
<path d="M17.2176 9.59937H6.78284L8.91471 8.59653L7.77945 6.53192L10.0944 6.97466L10.3878 4.63611L12.0002 6.35614L13.6127 4.63611L13.906 6.97466L16.221 6.53192L15.0858 8.59662L17.2176 9.59937Z" fill="#FFDA44"/>
<path d="M0 12.0008C0 18.6282 5.37262 24.0008 12 24.0008L2.39981 4.80035C0.893062 6.80609 0 9.29904 0 12.0008Z" fill="#A2001D"/>
<path d="M11.9996 23.9998C18.627 23.9998 23.9996 18.6272 23.9996 11.9998C23.9996 9.2981 23.1066 6.80514 21.5998 4.79941L11.9996 23.9998Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4042">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4027)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9674 12.0005H11.9996C11.9996 11.9897 11.9996 11.9792 11.9996 11.9684C11.9889 11.9791 11.9782 11.9898 11.9674 12.0005Z" fill="#F0F0F0"/>
<path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"/>
<path d="M6.07075 1.56508C4.19393 2.63378 2.6336 4.19407 1.56494 6.07089V11.9999H4.6954V4.69563V4.69553H11.9997C11.9997 3.70821 11.9997 2.76761 11.9997 1.56508H6.07075Z" fill="#D80027"/>
<path d="M11.9995 10.5248L7.736 6.2614H6.26038V6.26149L11.9994 12.0005H11.9995C11.9995 12.0005 11.9995 10.983 11.9995 10.5248Z" fill="#D80027"/>
<path d="M20.2941 13.7573C20.6392 13.2826 20.8696 12.7028 20.8696 12.0007V6.78335C20.4336 7.11091 19.8917 7.30506 19.3044 7.30506C18.451 7.30506 17.6934 6.89524 17.2175 6.26167C16.7415 6.89524 15.9839 7.30506 15.1305 7.30506C14.5432 7.30506 14.0013 7.11086 13.5653 6.78344V12.0007C13.5653 12.7028 13.7958 13.2826 14.1408 13.7573H20.2941Z" fill="#F3F3F3"/>
<path d="M19.2085 11.0321C19.3746 10.6269 19.5038 10.0345 19.5038 9.7397C19.5038 9.26603 18.8863 8.88208 18.8863 8.88208C18.8863 8.88208 18.2687 9.26603 18.2687 9.7397C18.2687 10.0345 18.398 10.6269 18.564 11.0321L18.2075 11.837C18.4171 11.9222 18.6461 11.9696 18.8863 11.9696C19.1265 11.9696 19.3555 11.9222 19.5651 11.837L19.2085 11.0321Z" fill="#FF9811"/>
<path d="M16.7953 8.4267C16.3614 8.48548 15.7838 8.66994 15.5285 8.81731C15.1183 9.05417 15.0945 9.78087 15.0945 9.78087C15.0945 9.78087 15.7358 10.1237 16.146 9.88686C16.4014 9.73944 16.8497 9.33144 17.1175 8.98494L17.9929 8.89119C17.9619 8.66722 17.8882 8.44517 17.7683 8.23719C17.6481 8.0292 17.4927 7.85445 17.3141 7.71556L16.7953 8.4267Z" fill="#FF9811"/>
<path d="M15.7447 11.8206C16.0125 12.1669 16.4609 12.5748 16.7163 12.7223C17.1265 12.9591 17.7678 12.6164 17.7678 12.6164C17.7678 12.6164 17.7439 11.8896 17.3338 11.6528C17.0783 11.5053 16.5008 11.3211 16.0668 11.2624L15.5481 10.5511C15.3695 10.69 15.2141 10.8648 15.0939 11.0726C14.9739 11.2807 14.9004 11.5027 14.8693 11.7268L15.7447 11.8206Z" fill="#FF9811"/>
<path d="M14.0114 13.5656C14.9858 15.1291 17.2171 15.6525 17.2171 15.6525C17.2171 15.6525 19.4483 15.1291 20.4228 13.5656H14.0114Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_4027">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_3995)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M18.7825 8.90743H14.436C14.7043 8.62646 14.8694 8.24607 14.8694 7.82687C14.8694 6.96245 14.1686 6.26167 13.3042 6.26167C12.7596 6.26167 12.2802 6.53992 11.9999 6.96184C11.7195 6.53992 11.2401 6.26167 10.6955 6.26167C9.8311 6.26167 9.13032 6.96245 9.13032 7.82687C9.13032 8.24607 9.29546 8.62651 9.56377 8.90743H5.21729C5.21729 10.06 6.22121 10.9944 7.37372 10.9944H7.30416C7.30416 12.147 8.23852 13.0814 9.39118 13.0814C9.39118 13.4547 9.48957 13.8047 9.66132 14.1077L7.93022 15.8388L9.25838 17.1669L11.1424 15.2829C11.2162 15.3099 11.2925 15.3317 11.3714 15.3464L10.2329 17.9168L11.9999 19.8269L13.7668 17.9167L12.6284 15.3463C12.7073 15.3316 12.7836 15.3099 12.8573 15.2828L14.7413 17.1668L16.0695 15.8387L14.3384 14.1075C14.5102 13.8046 14.6086 13.4545 14.6086 13.0812C15.7612 13.0812 16.6955 12.1469 16.6955 10.9942H16.626C17.7785 10.9943 18.7825 10.06 18.7825 8.90743Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_3995">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4056)">
<path d="M24.0001 12C24.0001 10.5322 23.7361 9.12608 23.2537 7.82615L12.0001 7.30438L0.746513 7.8261C0.264169 9.12608 0.00012207 10.5322 0.00012207 12C0.00012207 13.4679 0.264169 14.874 0.746513 16.1739L12.0001 16.6957L23.2537 16.174C23.7361 14.874 24.0001 13.4679 24.0001 12Z" fill="#0052B4"/>
<path d="M12.0001 23.9995C17.1596 23.9995 21.5582 20.743 23.2537 16.1734H0.74646C2.44198 20.743 6.84049 23.9995 12.0001 23.9995Z" fill="#FF9811"/>
<path d="M0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4056">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4020)">
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#D80027"/>
<path d="M23.9999 12.0004C23.9999 18.6277 18.6273 24.0003 11.9999 24.0003C5.3725 24.0003 -0.00012207 18.6277 -0.00012207 12.0004" fill="black"/>
<path d="M10.354 9.54358L11.3713 10.2819L10.9836 11.4775L12.0002 10.738L13.0175 11.4763L12.6284 10.281L13.6448 9.54161L12.3879 9.54236L11.9987 8.34709L11.611 9.54278L10.354 9.54358Z" fill="#FFDA44"/>
<path d="M14.9998 6.8033C14.0542 6.25735 13.0202 5.99968 11.9998 6.00146V7.56633C12.754 7.56497 13.5182 7.75529 14.2172 8.15888C16.3349 9.38157 17.0631 12.0992 15.8403 14.2169C14.6177 16.3346 11.9001 17.0628 9.78236 15.8401C9.16539 15.4839 8.66734 15.0003 8.30022 14.4421L6.99353 15.3048C7.49026 16.0599 8.16508 16.7137 8.99978 17.1956C11.865 18.8498 15.5417 17.8646 17.1959 14.9994C18.8501 12.1343 17.865 8.45752 14.9998 6.8033Z" fill="#FFDA44"/>
<path d="M8.53959 10.956C8.12475 11.7144 8.40328 12.6655 9.16162 13.0804L14.2452 15.8582C13.8995 16.4901 14.0831 17.2593 14.715 17.605L16.0882 18.3562C16.7201 18.7019 17.5128 18.4698 17.8585 17.8378L18.6097 16.4647L8.53959 10.956Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4020">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4050)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0002 -0.000915527C7.24267 -0.000915527 3.13192 2.76776 1.19092 6.78171H22.8094C20.8685 2.76776 16.7577 -0.000915527 12.0002 -0.000915527Z" fill="#338AF3"/>
<path d="M12.0004 23.9988C16.7579 23.9988 20.8687 21.2301 22.8097 17.2161H1.19116C3.13216 21.2301 7.24291 23.9988 12.0004 23.9988Z" fill="#338AF3"/>
<path d="M15.5865 12.0001L14.1209 12.6894L14.9014 14.1088L13.31 13.8043L13.1083 15.4119L11.9998 14.2296L10.8913 15.4119L10.6897 13.8043L9.09833 14.1087L9.87871 12.6894L8.41321 12.0001L9.87875 11.3107L9.09833 9.89138L10.6897 10.1958L10.8914 8.58817L11.9998 9.77054L13.1083 8.58817L13.31 10.1958L14.9014 9.89138L14.121 11.3107L15.5865 12.0001Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4050">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4004)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M17.8217 1.50525C16.0974 0.54675 14.1127 0 12 0C5.37309 0 0.00084375 5.37178 0 11.9986L8.34783 7.82611L17.8217 1.50525Z" fill="#0052B4"/>
<path d="M-0.000366211 12.0019C0.000477539 18.6287 5.37273 24.0005 11.9996 24.0005C14.1123 24.0005 16.0971 23.4538 17.8213 22.4952L8.34746 16.1744L-0.000366211 12.0019Z" fill="#0052B4"/>
<path d="M18.8214 2.12703C18.499 1.90395 18.1651 1.69648 17.8209 1.50519L-0.000366211 11.9983C-0.000366211 11.9988 -0.000366211 11.9993 -0.000366211 11.9998C-0.000366211 12.0002 -0.000366211 12.0007 -0.000366211 12.0012L17.8209 22.4943C18.1651 22.3029 18.499 22.0955 18.8214 21.8724L2.05379 11.9998L18.8214 2.12703Z" fill="#D80027"/>
<path d="M20.8692 11.5526H19.4398C19.8115 11.1064 19.7885 10.4425 19.3698 10.0238C19.8133 9.58035 19.8133 8.86124 19.3698 8.41766L19.3431 8.44447C19.7866 8.00099 19.8133 7.25507 19.3698 6.81158L12.9453 13.2361C13.3888 13.6797 14.0953 13.6744 14.5388 13.2308L14.6625 13.1178L17.7388 12.8382V14.1613H18.7823V12.7433L20.3475 12.601L20.8692 11.5526Z" fill="#A2001D"/>
<path d="M13.0439 14.6089L12 14.0872L13.0439 13.5654H19.8264V14.6089H13.0439Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4004">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4084)">
<path d="M23.2541 16.1731C23.7365 14.8731 24.0005 13.467 24.0005 11.9992C24.0005 10.5313 23.7365 9.12531 23.2541 7.82528L12.0005 6.7818L0.746879 7.82528C0.264535 9.12531 0.000488281 10.5313 0.000488281 11.9992C0.000488281 13.467 0.264535 14.8731 0.746879 16.1731L12.0005 17.2165L23.2541 16.1731Z" fill="#F0F0F0"/>
<path d="M12.0006 23.9995C17.1601 23.9995 21.5587 20.743 23.2542 16.1734H0.746948C2.44251 20.743 6.84098 23.9995 12.0006 23.9995Z" fill="#D80027"/>
<path d="M12.0002 0C6.84061 0 2.44214 3.2565 0.746582 7.82611H23.2538C21.5583 3.2565 17.1598 0 12.0002 0Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4084">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4068)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9678 12.0004H11.9999C11.9999 11.9895 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z" fill="#F0F0F0"/>
<path d="M11.9997 6.26165C11.9997 4.15017 11.9997 2.76656 11.9997 0.000793457H11.9977C5.37125 0.00187158 -0.000244141 5.37398 -0.000244141 12.0007H6.26061V8.47518L9.78617 12.0007H11.9677C11.9784 11.9901 11.9891 11.9794 11.9998 11.9686C11.9998 11.1602 11.9998 10.4388 11.9998 9.78726L8.47419 6.26165H11.9997Z" fill="#F0F0F0"/>
<path d="M6.07112 1.56573C4.19429 2.63444 2.63401 4.19472 1.56531 6.07155V12.0005H4.69576V4.69624V4.69619H12.0001C12.0001 3.70886 12.0001 2.76827 12.0001 1.56573H6.07112Z" fill="#D80027"/>
<path d="M12.0004 10.5249L7.73702 6.26156H6.26135C6.26135 6.26151 6.26135 6.26156 6.26135 6.26156L12.0004 12.0006H12.0004C12.0004 12.0006 12.0004 10.9832 12.0004 10.5249Z" fill="#D80027"/>
<path d="M7.23753 14.0864L7.89613 15.4635L9.38333 15.1198L8.71733 16.4933L9.9133 17.4417L8.42422 17.7774L8.42839 19.3038L7.23753 18.3488L6.04672 19.3038L6.05089 17.7774L4.56177 17.4417L5.75778 16.4933L5.09169 15.1198L6.57899 15.4635L7.23753 14.0864Z" fill="#F0F0F0"/>
<path d="M17.9671 16.6953L18.2964 17.3839L19.04 17.212L18.707 17.8987L19.305 18.373L18.5605 18.5408L18.5625 19.304L17.9671 18.8265L17.3717 19.304L17.3738 18.5408L16.6293 18.373L17.2273 17.8987L16.8943 17.212L17.6378 17.3839L17.9671 16.6953Z" fill="#F0F0F0"/>
<path d="M14.9035 9.39136L15.2327 10.08L15.9763 9.90801L15.6433 10.5948L16.2413 11.069L15.4968 11.2368L15.4988 12L14.9035 11.5225L14.308 12L14.3101 11.2368L13.5656 11.069L14.1635 10.5948L13.8305 9.90801L14.5742 10.08L14.9035 9.39136Z" fill="#F0F0F0"/>
<path d="M17.9671 5.21759L18.2964 5.90618L19.04 5.73429L18.707 6.42106L19.305 6.89525L18.5605 7.06311L18.5625 7.82633L17.9671 7.34881L17.3717 7.82633L17.3738 7.06311L16.6293 6.89525L17.2272 6.42106L16.8943 5.73429L17.6378 5.90618L17.9671 5.21759Z" fill="#F0F0F0"/>
<path d="M20.6422 8.34772L20.9715 9.03631L21.7151 8.86437L21.3821 9.55114L21.9801 10.0254L21.2355 10.1932L21.2376 10.9564L20.6422 10.4789L20.0468 10.9564L20.0488 10.1932L19.3043 10.0254L19.9023 9.55114L19.5693 8.86437L20.3129 9.03631L20.6422 8.34772Z" fill="#F0F0F0"/>
<path d="M18.7292 12.0003L18.9881 12.7975H19.8264L19.1482 13.2902L19.4073 14.0873L18.7292 13.5946L18.0511 14.0873L18.3101 13.2902L17.632 12.7975H18.4701L18.7292 12.0003Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4068">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4060)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M12.0001 24.0002C15.6371 24.0002 18.896 22.3819 21.0967 19.8264H2.90344C5.10408 22.3819 8.36297 24.0002 12.0001 24.0002Z" fill="#338AF3"/>
<path d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z" fill="#338AF3"/>
<path d="M0.953613 16.6962C1.18494 17.2398 1.45536 17.7625 1.76104 18.2614H22.2385C22.5441 17.7625 22.8146 17.2397 23.046 16.6962H0.953613Z" fill="#338AF3"/>
<path d="M5.49892 7.56907L3.15442 6.53435L5.49892 5.49964L6.53359 3.15518L7.56826 5.49964L9.91272 6.53435L7.56826 7.56907L6.53359 9.91353L5.49892 7.56907Z" fill="#F0F0F0"/>
<path d="M6.53375 4.44733L7.1727 5.89525L8.62067 6.5343L7.1727 7.1733L6.53375 8.62122L5.8947 7.1733L4.44678 6.5343L5.8947 5.89525L6.53375 4.44733Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4060">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AX = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_3987)">
<path d="M23.5864 15.1299C23.8554 14.1317 23.9998 13.0826 23.9998 11.9994C23.9998 10.9163 23.8554 9.86714 23.5864 8.86898L10.9563 0.0450897C8.61154 0.247121 6.45983 1.12321 4.69541 2.47889L0.413146 8.86898C0.144131 9.86714 -0.000244141 10.9163 -0.000244141 11.9994C-0.000244141 13.0762 0.142396 14.1196 0.408412 15.1125L4.69536 21.52C6.45979 22.8757 8.61149 23.7518 10.9562 23.9538L23.5864 15.1299Z" fill="#FFDA44"/>
<path d="M0.412964 15.1305C1.10728 17.7067 2.63751 19.9396 4.69523 21.5206V15.1305H0.412964Z" fill="#0052B4"/>
<path d="M10.9559 23.9544C11.2999 23.984 11.6478 24.0001 11.9994 24.0001C17.5437 24.0001 22.209 20.2397 23.586 15.1305H10.9559V23.9544Z" fill="#0052B4"/>
<path d="M23.586 8.86955C22.209 3.76036 17.5437 0 11.9994 0C11.6478 0 11.2999 0.0160312 10.9559 0.0456562V8.86955H23.586Z" fill="#0052B4"/>
<path d="M4.69523 2.47977C2.63751 4.06087 1.10728 6.29366 0.412964 8.86987H4.69523V2.47977Z" fill="#0052B4"/>
<path d="M23.8987 10.4343H9.3916H9.39156V0.284721C8.28259 0.530628 7.23123 0.929206 6.2611 1.45857V10.4342H0.101822C0.0350254 10.9466 0.000244141 11.469 0.000244141 11.9995C0.000244141 12.53 0.0350254 13.0523 0.101822 13.5647H6.26106H6.2611V22.5404C7.23123 23.0697 8.28259 23.4683 9.39156 23.7142V13.5648V13.5647H23.8987C23.9654 13.0523 24.0002 12.53 24.0002 11.9995C24.0002 11.469 23.9654 10.9466 23.8987 10.4343Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_3987">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const AZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4089)">
<path d="M23.9996 12C23.9996 10.5322 23.7356 9.12608 23.2532 7.82615L11.9996 7.30438L0.746024 7.8261C0.263681 9.12608 -0.000366211 10.5322 -0.000366211 12C-0.000366211 13.4679 0.263681 14.874 0.746024 16.1739L11.9996 16.6957L23.2532 16.174C23.7356 14.874 23.9996 13.4679 23.9996 12Z" fill="#D80027"/>
<path d="M12.0003 23.9995C17.1599 23.9995 21.5584 20.743 23.2539 16.1734H0.746704C2.44222 20.743 6.84074 23.9995 12.0003 23.9995Z" fill="#6DA544"/>
<path d="M0.746704 7.82519H23.254C21.5584 3.25558 17.1599 -0.000915527 12.0003 -0.000915527C6.84074 -0.000915527 2.44222 3.25558 0.746704 7.82519Z" fill="#338AF3"/>
<path d="M12.2606 15.3911C10.3876 15.3911 8.86927 13.8727 8.86927 11.9997C8.86927 10.1268 10.3876 8.60843 12.2606 8.60843C12.8445 8.60843 13.3941 8.75609 13.8738 9.01606C13.1212 8.28007 12.092 7.82581 10.9562 7.82581C8.65102 7.82581 6.78235 9.69452 6.78235 11.9997C6.78235 14.3049 8.65107 16.1736 10.9562 16.1736C12.092 16.1736 13.1212 15.7193 13.8738 14.9833C13.3941 15.2434 12.8445 15.3911 12.2606 15.3911Z" fill="#F0F0F0"/>
<path d="M14.8696 9.65082L15.3188 10.9141L16.5297 10.3384L15.9541 11.5494L17.2174 11.9986L15.9541 12.4479L16.5297 13.6589L15.3188 13.0831L14.8696 14.3465L14.4204 13.0831L13.2094 13.6589L13.7851 12.4479L12.5217 11.9986L13.7851 11.5494L13.2094 10.3384L14.4204 10.9141L14.8696 9.65082Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4089">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4264)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9995 -0.000701904C7.74468 -0.000701904 4.00734 2.21381 1.87659 5.553L18.1497 22.3047C21.6532 20.2093 23.9995 16.3785 23.9995 11.9993C23.9995 5.37192 18.6269 -0.000701904 11.9995 -0.000701904Z" fill="#FFDA44"/>
<path d="M24.0001 11.9991C24.0001 8.88559 22.8142 6.04928 20.8696 3.91656V20.0817C22.8142 17.949 24.0001 15.1127 24.0001 11.9991Z" fill="#0052B4"/>
<path d="M14.9905 22.5869L16.2474 22.5861L16.6352 21.3904L17.0243 22.5857L17.6548 22.5853C18.0414 22.3783 18.4153 22.1509 18.7751 21.9042L2.09516 5.22433C1.82029 5.62539 1.5696 6.04417 1.34418 6.47824L1.4924 6.93349L2.74935 6.93269L1.73291 7.67214L2.12207 8.86741L1.10469 8.12922L0.497897 8.5706C0.174413 9.65697 0.000366211 10.8077 0.000366211 11.9991C0.000366211 18.6265 5.37299 23.9991 12.0004 23.9991C13.4016 23.9991 14.7464 23.7586 15.9965 23.317L14.9905 22.5869ZM2.67688 11.4774L3.06454 10.2817L2.04726 9.54344L3.30421 9.54264L3.69191 8.34691L4.08107 9.54218L5.33802 9.54138L4.32154 10.2808L4.71069 11.4761L3.69332 10.7379L2.67688 11.4774ZM5.26555 14.0861L5.65321 12.8904L4.63593 12.1521L5.89288 12.1513L6.28058 10.9556L6.66974 12.1509L7.92669 12.1501L6.91026 12.8895L7.29941 14.0848L6.28204 13.3466L5.26555 14.0861ZM7.85418 16.6948L8.24183 15.4991L7.22455 14.7608L8.48151 14.76L8.86921 13.5643L9.25837 14.7596L10.5153 14.7588L9.49888 15.4982L9.88804 16.6935L8.87066 15.9552L7.85418 16.6948ZM11.4593 18.564L10.4428 19.3035L10.8305 18.1078L9.81318 17.3695L11.0701 17.3687L11.4579 16.173L11.847 17.3682L13.104 17.3674L12.0876 18.1069L12.4767 19.3022L11.4593 18.564ZM13.0315 21.9122L13.4191 20.7165L12.4018 19.9782L13.6588 19.9774L14.0465 18.7817L14.4357 19.9769L15.6926 19.9761L14.6762 20.7156L15.0653 21.9108L14.048 21.1726L13.0315 21.9122Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4264">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BB = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4108)">
<path d="M17.2173 1.1909C15.6396 0.428058 13.8697 0.000183105 11.9999 0.000183105C10.13 0.000183105 8.36012 0.428058 6.7825 1.1909L5.73901 12.0002L6.7825 22.8095C8.36012 23.5723 10.13 24.0002 11.9999 24.0002C13.8697 24.0002 15.6396 23.5723 17.2173 22.8095L18.2607 12.0002L17.2173 1.1909Z" fill="#FFDA44"/>
<path d="M6.78275 1.19128C2.76884 3.13219 0.00012207 7.24261 0.00012207 12.0001C0.00012207 16.7577 2.76884 20.8681 6.78275 22.809V1.19128Z" fill="#0052B4"/>
<path d="M17.2177 1.19171V22.8094C21.2316 20.8685 24.0003 16.7581 24.0003 12.0006C24.0003 7.24309 21.2316 3.13262 17.2177 1.19171Z" fill="#0052B4"/>
<path d="M15.6522 7.30337L16.3521 7.65334L15.6522 7.30337L14.9521 6.9534C14.9099 7.03783 13.9959 8.8975 13.8466 11.7382H12.7826V7.30337L12 6.25989L11.2174 7.30337V11.7382H10.1533C10.004 8.8975 9.09003 7.03783 9.0478 6.9534L7.64783 7.65339C7.65748 7.67261 8.60872 9.60878 8.60872 12.5208V13.3034H11.2174V17.7382H12.7826V13.3034H15.3913V12.5207C15.3913 11.0152 15.6518 9.77378 15.8704 8.99744C16.1086 8.15087 16.3506 7.65648 16.353 7.65156L15.6522 7.30337Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4108">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BD = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4105)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"/>
<path d="M9.39133 17.2174C12.2728 17.2174 14.6087 14.8815 14.6087 12C14.6087 9.11855 12.2728 6.78265 9.39133 6.78265C6.50985 6.78265 4.17395 9.11855 4.17395 12C4.17395 14.8815 6.50985 17.2174 9.39133 17.2174Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4105">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4125)">
<path d="M16.1736 0.746574C14.8736 0.26423 13.4676 0.000183105 11.9997 0.000183105C10.5319 0.000183105 9.12582 0.26423 7.82583 0.746574L6.78235 12.0002L7.82583 23.2538C9.12582 23.7362 10.5319 24.0002 11.9997 24.0002C13.4676 24.0002 14.8736 23.7362 16.1736 23.2538L17.2171 12.0002L16.1736 0.746574Z" fill="#FFDA44"/>
<path d="M23.9999 11.9993C23.9999 6.83976 20.7434 2.4412 16.1738 0.745728V23.253C20.7434 21.5574 23.9999 17.1589 23.9999 11.9993Z" fill="#D80027"/>
<path d="M-0.000366211 12C-0.000366211 17.1596 3.25613 21.5581 7.82574 23.2536V0.746399C3.25613 2.44187 -0.000366211 6.84043 -0.000366211 12Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4125">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BF = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4351)">
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#D80027"/>
<path d="M24 12.0007C24 18.6281 18.6274 24.0007 12 24.0007C5.37262 24.0007 0 18.6281 0 12.0007" fill="#6DA544"/>
<path d="M11.9999 7.82538L12.9064 10.6153H15.8401L13.4667 12.3396L14.3732 15.1297L11.9999 13.4054L9.6266 15.1297L10.5332 12.3396L8.15979 10.6153H11.0934L11.9999 7.82538Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4351">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4347)">
<path d="M24 12.0006C24 10.5328 23.736 9.12669 23.2536 7.82676L12 7.30499L0.746391 7.82671C0.264047 9.12669 0 10.5328 0 12.0006C0 13.4685 0.264047 14.8746 0.746391 16.1745L12 16.6963L23.2536 16.1746C23.736 14.8746 24 13.4685 24 12.0006Z" fill="#496E2D"/>
<path d="M11.9999 23.9999C17.1595 23.9999 21.558 20.7434 23.2536 16.1738H0.746338C2.44185 20.7434 6.84037 23.9999 11.9999 23.9999Z" fill="#D80027"/>
<path d="M0.746338 7.82541H23.2536C21.558 3.2558 17.1595 -0.000701904 11.9999 -0.000701904C6.84037 -0.000701904 2.44185 3.2558 0.746338 7.82541Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4347">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4102)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0001 -0.000915527C9.59189 -0.000915527 7.34977 0.709006 5.47046 1.93024L8.55666 3.99879L4.6958 5.99876L8.55666 7.99872L4.6958 9.99869L8.55666 11.9984L4.6958 13.9984L8.55666 15.9983L4.6958 17.9984L8.55666 19.9984L5.47008 22.0676C7.34949 23.2891 9.59175 23.9991 12.0001 23.9991C18.6275 23.9991 24.0001 18.6265 24.0001 11.9991C24.0001 5.37171 18.6275 -0.000915527 12.0001 -0.000915527Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4102">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4355)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M19.307 2.48002C15.0108 -0.825891 8.98979 -0.825891 4.6936 2.47997L12.0003 9.78666L19.307 2.48002Z" fill="#D80027"/>
<path d="M12.0004 14.2139L4.69385 21.5205C8.99004 24.8264 15.011 24.8264 19.3072 21.5205L12.0005 14.2138L12.0004 14.2139Z" fill="#D80027"/>
<path d="M9.7868 12.0003L2.48016 4.6936C-0.825744 8.98979 -0.825744 15.0108 2.48016 19.307L9.7868 12.0003Z" fill="#6DA544"/>
<path d="M14.2142 12.0003L21.5208 19.307C24.8267 15.0108 24.8267 8.98979 21.5208 4.6936L14.2142 12.0003Z" fill="#6DA544"/>
<path d="M12.0003 17.2179C14.8818 17.2179 17.2177 14.882 17.2177 12.0005C17.2177 9.11901 14.8818 6.78311 12.0003 6.78311C9.11886 6.78311 6.78296 9.11901 6.78296 12.0005C6.78296 14.882 9.11886 17.2179 12.0003 17.2179Z" fill="#F0F0F0"/>
<path d="M11.9999 8.34824L12.4517 9.13086H13.3554L12.9035 9.91344L13.3554 10.6961H12.4517L11.9999 11.4787L11.5481 10.6961H10.6444L11.0962 9.91344L10.6444 9.13086H11.5481L11.9999 8.34824Z" fill="#D80027"/>
<path d="M9.70355 12.001L10.1554 12.7836H11.059L10.6072 13.5662L11.059 14.3488H10.1554L9.70355 15.1314L9.25168 14.3488H8.34802L8.79985 13.5662L8.34802 12.7836H9.25168L9.70355 12.001Z" fill="#D80027"/>
<path d="M14.2971 12.001L14.7489 12.7836H15.6525L15.2007 13.5662L15.6525 14.3488H14.7489L14.2971 15.1314L13.8452 14.3488H12.9415L13.3934 13.5662L12.9415 12.7836H13.8452L14.2971 12.001Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4355">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BJ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4139)">
<path d="M7.82629 10.9569L8.86978 23.587C9.86789 23.856 10.917 24.0004 12.0002 24.0004C18.6276 24.0004 24.0002 18.6278 24.0002 12.0004L7.82629 10.9569Z" fill="#D80027"/>
<path d="M7.82629 12.0001L8.86973 0.413513C9.86789 0.144497 10.917 0.00012207 12.0002 0.00012207C18.6276 0.00012207 24.0002 5.37275 24.0002 12.0001H7.82629Z" fill="#FFDA44"/>
<path d="M-0.000488281 11.9997C-0.000488281 17.544 3.75987 22.2093 8.86906 23.5863V0.413086C3.75987 1.79009 -0.000488281 6.45537 -0.000488281 11.9997Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4139">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5578)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M21.4265 9.65236H17.4787C17.4787 8.932 16.8947 8.34802 16.1744 8.34802L15.1309 10.435C15.1309 10.435 16.2439 13.5654 16.2091 13.5654H17.5135C18.2339 13.5654 18.8178 12.9815 18.8178 12.2611C19.5382 12.2611 20.1221 11.6771 20.1221 10.9567H20.0787C20.799 10.9567 21.4265 10.3728 21.4265 9.65236Z" fill="#ACABB1"/>
<path d="M2.57422 9.65224H6.52204C6.52204 8.93188 7.10601 8.3479 7.82637 8.3479L8.86987 10.4348C8.86987 10.4348 7.7568 13.5653 7.79161 13.5653H6.48727C5.76687 13.5653 5.18294 12.9814 5.18294 12.261C4.46253 12.261 3.8786 11.677 3.8786 10.9566H3.92204C3.20164 10.9566 2.57422 10.3726 2.57422 9.65224Z" fill="#ACABB1"/>
<path d="M16.1737 16.6957V17.2174H7.82584V16.6957H5.73889V18.7826H7.82584V19.3043H16.1737V18.7826H18.2606V16.6957H16.1737Z" fill="#FFDA44"/>
<path d="M7.82593 8.34851V13.5659C7.82593 16.7608 11.9998 17.7398 11.9998 17.7398C11.9998 17.7398 16.1737 16.7608 16.1737 13.5659V8.34851L11.9998 7.82678L7.82593 8.34851Z" fill="#0052B4"/>
<path d="M16.1737 10.4342H7.82593V13.5646H16.1737V10.4342Z" fill="#D80027"/>
<path d="M14.0868 5.73875V6.52136L13.565 6.78225L13.0433 6.26047V4.69525H10.9564V6.26047L10.4346 6.78225L9.91287 6.52136V5.73875H7.82593V8.34742H16.1738V5.73875H14.0868Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5578">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4143)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027"/>
<path d="M11.9998 5.73889V9.78622L7.82593 5.73889H11.9998Z" fill="#0052B4"/>
<path d="M6.26073 11.9996H9.78625L6.26073 7.30396L5.73901 10.9561L6.26073 11.9996Z" fill="#0052B4"/>
<path d="M11.9683 12.0012H12.0004C12.0004 11.9904 12.0004 11.9798 12.0004 11.969C11.9897 11.9797 11.979 11.9905 11.9683 12.0012Z" fill="#F0F0F0"/>
<path d="M11.999 6.26135C11.999 4.14986 11.999 2.76635 11.999 0.000488281H11.997C5.37048 0.00161328 -0.000976562 5.37372 -0.000976562 12.0005H6.25988V8.47497L9.7854 12.0005H11.967C11.9776 11.9898 11.9883 11.9791 11.9991 11.9684C11.9991 11.1599 11.9991 10.4386 11.9991 9.78696L8.47346 6.26135H11.999Z" fill="#F0F0F0"/>
<path d="M6.07063 1.56519C4.1938 2.63389 2.63348 4.19417 1.56482 6.071V12.5217H4.69527V4.69573V4.69564H12.5213C12.5213 3.70831 12.5213 2.76772 12.5213 1.56519H6.07063Z" fill="#D80027"/>
<path d="M12.4763 11.0002L7.73576 6.25977H6.26013V6.25986L12.4762 12.4759H12.4763C12.4763 12.476 12.4763 11.4584 12.4763 11.0002Z" fill="#D80027"/>
<path d="M13.5652 6.25989V11.999C13.5652 14.7946 20.8695 14.7946 20.8695 11.999V6.25989H13.5652Z" fill="#F3F3F3"/>
<path d="M13.5652 12.0005V12.0005C13.5652 14.7961 17.2174 15.6527 17.2174 15.6527C17.2174 15.6527 20.8695 14.7961 20.8695 12.0005V12.0005H13.5652Z" fill="#6DA544"/>
<path d="M17.2175 9.70447L15.5219 10.4349V12.0001L17.2175 13.0436L18.9132 12.0001V10.4349L17.2175 9.70447Z" fill="#A2001D"/>
<path d="M18.9132 8.86865H15.5219V10.4339H18.9132V8.86865Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_4143">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4334)">
<path d="M12.0004 23.9977C18.6269 23.9977 23.9987 18.6259 23.9987 11.9994C23.9987 5.373 18.6269 0.00120544 12.0004 0.00120544C5.37399 0.00120544 0.00219727 5.373 0.00219727 11.9994C0.00219727 18.6259 5.37399 23.9977 12.0004 23.9977Z" fill="#F0F0F0"/>
<path d="M1.60952 6.00125C1.06796 6.93915 0.668487 7.9197 0.402466 8.91849L20.4681 20.5035C21.2001 19.7737 21.8496 18.9373 22.391 17.9995L1.60952 6.00125Z" fill="black"/>
<path d="M17.9987 1.60925C13.1979 -1.16248 7.2784 -0.238696 3.53174 3.49695L23.5974 15.0818C24.9593 9.96945 22.7995 4.38103 17.9987 1.60925Z" fill="#FFDA44"/>
<path d="M6.00067 22.3899C10.8014 25.1617 16.7211 24.2379 20.4676 20.5023L0.40194 8.91725C-0.959855 14.0298 1.19982 19.6182 6.00067 22.3899Z" fill="#FFDA44"/>
<path d="M15.3909 10.6963C15.3909 12.569 13.8728 14.0872 12.0001 14.0872C10.1274 14.0872 8.60928 12.569 8.60928 10.6963C8.60928 10.1125 8.7569 9.56303 9.01687 9.08334C8.28106 9.83584 7.82678 10.8649 7.82678 12.0005C7.82678 14.3053 9.69521 16.1738 12.0001 16.1738C14.305 16.1738 16.1734 14.3054 16.1734 12.0005C16.1734 10.8649 15.7192 9.83584 14.9833 9.08334C15.2433 9.56312 15.3909 10.1125 15.3909 10.6963Z" fill="#D80027"/>
<path d="M12.7828 6.78357H11.2178V14.6085H12.7828V6.78357Z" fill="#D80027"/>
<path d="M14.6081 8.34828H9.39148C9.39148 8.70843 9.70522 9.00037 10.0653 9.00037H10.0436C10.0436 9.36052 10.3356 9.65246 10.6957 9.65246C10.6957 10.0126 10.9877 10.3046 11.3478 10.3046H12.6519C13.012 10.3046 13.304 10.0126 13.304 9.65246C13.6641 9.65246 13.9561 9.36052 13.9561 9.00037H13.9344C14.2944 9.00033 14.6081 8.70848 14.6081 8.34828Z" fill="#D80027"/>
<path d="M15.6522 15.13H8.34888V16.695H15.6522V15.13Z" fill="#D80027"/>
<path d="M16.6948 15.651H13.5648V17.216H16.6948V15.651Z" fill="#D80027"/>
<path d="M10.435 15.651H7.30505V17.216H10.435V15.651Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4334">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4254)">
<path d="M24 12.0007C24 10.5328 23.736 9.12671 23.2536 7.82677L12 7.30501L0.746391 7.82673C0.264 9.12671 0 10.5328 0 12.0007C0 13.4685 0.264 14.8746 0.746391 16.1745L12 16.6963L23.2536 16.1746C23.736 14.8746 24 13.4685 24 12.0007Z" fill="#FFDA44"/>
<path d="M11.9999 23.9999C17.1595 23.9999 21.558 20.7434 23.2536 16.1738H0.746338C2.44185 20.7434 6.84037 23.9999 11.9999 23.9999Z" fill="#6DA544"/>
<path d="M0.746216 7.8264H23.2535C21.5579 3.25679 17.1594 0.000289917 11.9998 0.000289917C6.84025 0.000289917 2.44173 3.25679 0.746216 7.8264Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4254">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BQ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4258)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M3.51497 3.51431C0.943172 6.0861 -0.216844 9.53489 0.0340778 12.898L12.8986 0.0334636C9.5355 -0.217505 6.08677 0.942511 3.51497 3.51431Z" fill="#FFDA44"/>
<path d="M4.28491 21.1899C8.99965 25.1565 16.0477 24.9219 20.4854 20.4843C24.923 16.0467 25.1576 8.99858 21.1909 4.2839L4.28491 21.1899Z" fill="#0052B4"/>
<path d="M11.9569 11.5167L12.991 10.9566L11.9569 10.3964C11.7155 8.82794 10.4762 7.58861 8.90771 7.34721L8.34751 6.31305L7.78735 7.34716C6.21892 7.58857 4.97963 8.82789 4.73813 10.3964L3.70398 10.9566L4.73809 11.5167C4.97954 13.0852 6.21882 14.3246 7.7873 14.566L8.34751 15.6001L8.90766 14.566C10.4762 14.3246 11.7155 13.0852 11.9569 11.5167ZM8.34755 13.0436C7.19495 13.0436 6.26059 12.1092 6.26059 10.9566C6.26059 9.80393 7.1949 8.86961 8.34755 8.86961C9.50021 8.86961 10.4345 9.80393 10.4345 10.9566C10.4345 12.1092 9.50016 13.0436 8.34755 13.0436Z" fill="black"/>
<path d="M8.34767 9.39093L8.7995 10.1735H9.7032L9.25133 10.9561L9.7032 11.7388H8.7995L8.34767 12.5213L7.89584 11.7388H6.99219L7.44402 10.9561L6.99219 10.1735H7.89584L8.34767 9.39093Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4258">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BQ2 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5479)">
<path d="M5.23694 21.9128C7.16284 23.2293 9.49145 23.9997 12.0004 23.9997C14.5093 23.9997 16.838 23.2293 18.7638 21.9128L12.0004 20.8693L5.23694 21.9128Z" fill="#D80027"/>
<path d="M18.7638 2.08709C16.838 0.770606 14.5093 0.00012207 12.0004 0.00012207C9.49145 0.00012207 7.16275 0.770606 5.23694 2.08709L12.0004 3.13057L18.7638 2.08709Z" fill="#D80027"/>
<path d="M5.23694 21.9128C7.16284 23.2293 9.49145 23.9997 12.0004 23.9997C14.5093 23.9997 16.838 23.2293 18.7638 21.9128L12.0004 20.8693L5.23694 21.9128Z" fill="#D80027"/>
<path d="M18.7638 2.08709C16.838 0.770606 14.5093 0.00012207 12.0004 0.00012207C9.49145 0.00012207 7.16275 0.770606 5.23694 2.08709L12.0004 3.13057L18.7638 2.08709Z" fill="#D80027"/>
<path d="M23.9703 11.2165C23.686 7.51289 21.4357 3.91214 18.7644 2.08603H5.23745C2.27795 4.1092 0.270436 7.42271 0.026123 11.2165L12.0009 11.9991L23.9703 11.2165Z" fill="#0052B4"/>
<path d="M0.0251465 12.7822C0.269459 16.576 2.27693 19.8895 5.23643 21.9126H18.7633C21.723 19.8895 23.7304 16.576 23.9747 12.7822L11.9999 11.9996L0.0251465 12.7822Z" fill="#0052B4"/>
<path d="M23.9694 11.2173H12.7826V1.56519H11.2174V11.2173H0.0252656C0.008625 11.4761 0 11.737 0 12C0 12.2629 0.00857813 12.5238 0.0252187 12.7826H11.2174V22.4348H12.7826V12.7826H23.9748C23.9914 12.5238 24 12.2629 24 12C24 11.7389 23.9895 11.4779 23.9694 11.2173Z" fill="#D80027"/>
<path d="M4.6958 11.9993L12.0001 7.40823L19.3045 11.9993L12.0001 16.5903L4.6958 11.9993Z" fill="#F0F0F0"/>
<path d="M7.82593 14.0873H17.2172L15.1303 10.9568L14.0868 12.0003L13.0433 11.4786L11.9998 13.0438H9.91285L8.86937 12.0003L7.82593 14.0873Z" fill="#6DA544"/>
<path d="M12.0003 8.86896L12.2593 9.66607H13.0974L12.4194 10.1588L12.6784 10.9559L12.0003 10.4633L11.3222 10.9559L11.5812 10.1588L10.9032 9.66607H11.7413L12.0003 8.86896Z" fill="#FFDA44"/>
<path d="M12.0003 6.09656L2.60901 11.9993L12.0003 17.9021L21.3916 11.9993L12.0003 6.09656ZM5.55032 11.9993L12.0003 7.94526L18.4503 11.9993L12.0003 16.0534L5.55032 11.9993Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5479">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BQ3 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5384)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9999 0.000981008C11.9887 -0.00745649 -0.00330894 11.9978 -0.000121435 12.001C-0.000121435 5.37361 5.3725 0.000981008 11.9999 0.000981008Z" fill="#D80027"/>
<path d="M11.9999 4.44543e-06C12.0111 -0.00843305 24.0031 11.9968 23.9999 12C23.9999 5.37263 18.6273 4.44543e-06 11.9999 4.44543e-06Z" fill="#D80027"/>
<path d="M11.9995 23.9994C11.9883 24.0078 -0.00367515 12.0026 -0.000487646 11.9994C-0.000487646 18.6268 5.37214 23.9994 11.9995 23.9994Z" fill="#0052B4"/>
<path d="M11.9995 23.9989C12.0107 24.0073 24.0027 12.0021 23.9995 11.9989C23.9995 18.6263 18.6269 23.9989 11.9995 23.9989Z" fill="#0052B4"/>
<path d="M12 6.26074L13.2951 10.2465H17.4859L14.0954 12.7098L15.3905 16.6956L12 14.2322L8.60956 16.6956L9.90463 12.7098L6.51416 10.2465H10.705L12 6.26074Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5384">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4276)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544"/>
<path d="M12.0004 4.69609L21.9135 12.0004L12.0004 19.3048L2.0874 12.0004L12.0004 4.69609Z" fill="#FFDA44"/>
<path d="M12.0001 16.1738C14.3052 16.1738 16.174 14.3051 16.174 11.9999C16.174 9.69476 14.3052 7.82605 12.0001 7.82605C9.69489 7.82605 7.82617 9.69476 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12.0001 16.1738Z" fill="#F0F0F0"/>
<path d="M9.91324 11.7395C9.18743 11.7395 8.48698 11.8499 7.82764 12.0548C7.85684 14.3348 9.71328 16.1743 12.0002 16.1743C13.4143 16.1743 14.6633 15.4704 15.4183 14.3946C14.1266 12.7775 12.139 11.7395 9.91324 11.7395Z" fill="#0052B4"/>
<path d="M16.0966 12.7998C16.1469 12.5409 16.174 12.2737 16.174 12.0001C16.174 9.69491 14.3053 7.82624 12.0001 7.82624C10.2801 7.82624 8.80355 8.86691 8.16455 10.3528C8.72939 10.2357 9.31421 10.1741 9.91322 10.1741C12.3375 10.174 14.5305 11.1817 16.0966 12.7998Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4276">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4096)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M7.30559 7.82519H23.2548C21.5593 3.25558 17.1608 -0.000915527 12.0012 -0.000915527C8.68747 -0.000915527 5.68779 1.34247 3.51636 3.51419L7.30559 7.82519Z" fill="#338AF3"/>
<path d="M7.30462 16.1725H23.2538C21.5584 20.7421 17.1598 23.9986 12.0003 23.9986C8.68649 23.9986 5.68682 22.6552 3.51538 20.4835L7.30462 16.1725Z" fill="#338AF3"/>
<path d="M3.51447 3.51428C-1.17181 8.20056 -1.17181 15.7986 3.51447 20.4849C5.45101 18.5484 7.3135 16.6859 11.9998 11.9996L3.51447 3.51428Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4096">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4159)">
<path d="M3.51422 20.4854C-1.17206 15.7991 -1.17206 8.20118 3.51422 3.51485C8.2005 -1.17148 15.7985 -1.17143 20.4848 3.51485C20.4848 3.51649 23.6708 14.2988 18.9845 18.9851C14.2983 23.6715 3.5175 20.4887 3.51422 20.4854Z" fill="#FFDA44"/>
<path d="M3.51465 20.4846C8.20093 25.1709 15.7989 25.1709 20.4853 20.4846C25.1716 15.7983 25.1716 8.20036 20.4853 3.51404L3.51465 20.4846Z" fill="#FF9811"/>
<path d="M18.7885 6.78192V4.69495H14.7884L14.4828 5.00052C13.3958 6.08751 13.5787 7.35557 13.7122 8.28145C13.8359 9.14034 13.8508 9.46935 13.5314 9.78881C13.212 10.1082 12.8829 10.0934 12.0241 9.96946C11.0982 9.83601 9.8302 9.65315 8.74321 10.7401C7.65628 11.827 7.83923 13.095 7.97282 14.0208C8.09671 14.8796 8.11162 15.2086 7.79231 15.5279C7.47295 15.8472 7.14384 15.8323 6.28523 15.7084C5.95045 15.6601 5.60428 15.6102 5.23471 15.6061L5.21179 17.693C5.44307 17.6955 5.7074 17.7336 5.98725 17.774C6.31856 17.8219 6.69356 17.876 7.08853 17.876C7.49784 17.876 7.92843 17.8176 8.35368 17.634V19.3037H11.4841V17.7385H9.91893V16.695H10.9624V15.1298H10.1284C10.168 14.6235 10.0984 14.1386 10.0384 13.7229C9.91453 12.8641 9.89962 12.5351 10.2189 12.2159C10.5383 11.8965 10.8673 11.9113 11.7262 12.0351C12.4009 12.1324 13.2572 12.2553 14.0929 11.8946V13.5646H17.2233V11.9994H15.6581V10.9559H16.7016V9.3907H15.8677C15.9073 8.88431 15.8377 8.39948 15.7777 7.98365C15.6913 7.3836 15.6579 7.04217 15.7546 6.78196H18.7885V6.78192Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4159">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4270)">
<path d="M0.567113 8.34776C0.19952 9.49944 0.000441415 10.7263 0.00048829 11.9999C0.000441415 13.2735 0.19952 14.5004 0.56716 15.6521L12.0005 16.1739L23.4338 15.6521C23.8013 14.5004 24.0004 13.2734 24.0004 12C24.0004 10.7264 23.8014 9.49944 23.4338 8.34776L12.0004 7.82605L0.567113 8.34776Z" fill="#F0F0F0"/>
<path d="M24.0004 12.0005C24.0004 11.2887 23.938 10.5913 23.8191 9.91353H0.181679C0.06271 10.5913 0.000366211 11.2886 0.000366211 12.0005C0.000366211 12.7124 0.0627568 13.4097 0.181679 14.0875H23.8191C23.938 13.4096 24.0004 12.7124 24.0004 12.0005Z" fill="black"/>
<path d="M11.9999 23.9997C17.3537 23.9997 21.888 20.4933 23.4331 15.6518H0.566528C2.11176 20.4932 6.64603 23.9996 11.9999 23.9997Z" fill="#338AF3"/>
<path d="M12.0004 -0.000623701C6.64656 -0.000623701 2.11234 3.50577 0.567017 8.34711L23.4336 8.34716C21.8884 3.50577 17.3542 -0.000717451 12.0004 -0.000623701Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_4270">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4114)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC"/>
<path d="M4.95669 11.1289L3.65234 8.76256L4.95669 6.43329L6.26103 8.76256L4.95669 11.1289Z" fill="#A2001D"/>
<path d="M2.3478 11.1289L1.04346 8.76256L2.3478 6.43329L3.65214 8.76256L2.3478 11.1289Z" fill="#A2001D"/>
<path d="M4.95669 17.5644L3.65234 15.198L4.95669 12.8688L6.26103 15.198L4.95669 17.5644Z" fill="#A2001D"/>
<path d="M2.3478 17.5644L1.04346 15.198L2.3478 12.8688L3.65214 15.198L2.3478 17.5644Z" fill="#A2001D"/>
<path d="M6.26053 2.32881L5.89125 1.66937C5.2289 2.06181 4.60767 2.51617 4.03528 3.02448L4.95619 4.69516L6.26053 2.32881Z" fill="#A2001D"/>
<path d="M4.95617 19.3043L4.02551 20.9663C4.59739 21.4752 5.2182 21.9303 5.88026 22.3235L6.26056 21.6336L4.95617 19.3043Z" fill="#A2001D"/>
<path d="M7.3042 15.1307V23.0461C8.7465 23.6601 10.3334 24.0002 11.9999 24.0002C17.1594 24.0002 21.5579 20.7437 23.2535 16.1741L7.3042 15.1307Z" fill="#6DA544"/>
<path d="M23.2535 16.1741C23.7359 14.8741 23.9999 13.468 23.9999 12.0002C23.9999 5.37281 18.6272 0.000183105 11.9999 0.000183105C10.3335 0.000183105 8.7465 0.340167 7.3042 0.953996V16.1741H23.2535V16.1741Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4114">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const BZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4129)">
<path d="M23.9996 12C23.9996 7.88156 21.9245 4.24814 18.7631 2.08701L11.9996 1.56525L5.23618 2.08697C2.07479 4.24814 -0.000366211 7.88161 -0.000366211 12C-0.000366211 16.1186 2.07479 19.752 5.23618 21.9131L11.9996 22.4348L18.7631 21.9131C21.9245 19.752 23.9996 16.1186 23.9996 12Z" fill="#0052B4"/>
<path d="M18.764 2.08715C16.8381 0.770621 14.5095 0.000183105 12.0005 0.000183105C9.49162 0.000183105 7.16292 0.770621 5.23706 2.08715H18.764Z" fill="#A2001D"/>
<path d="M5.23633 21.9133C7.16214 23.2299 9.49089 24.0003 11.9998 24.0003C14.5087 24.0003 16.8374 23.2299 18.7632 21.9133H5.23633Z" fill="#A2001D"/>
<path d="M12.0004 17.7382C15.17 17.7382 17.7395 15.1687 17.7395 11.999C17.7395 8.82939 15.17 6.25989 12.0004 6.25989C8.83073 6.25989 6.26123 8.82939 6.26123 11.999C6.26123 15.1687 8.83073 17.7382 12.0004 17.7382Z" fill="#F0F0F0"/>
<path d="M11.9999 16.6954C14.5932 16.6954 16.6955 14.5931 16.6955 11.9997C16.6955 9.4064 14.5932 7.30408 11.9999 7.30408C9.40652 7.30408 7.3042 9.4064 7.3042 11.9997C7.3042 14.5931 9.40652 16.6954 11.9999 16.6954Z" fill="#6DA544"/>
<path d="M11.9996 15.1296C13.7285 15.1296 15.13 13.728 15.13 11.9991C15.13 10.2702 13.7285 8.86865 11.9996 8.86865C10.2707 8.86865 8.86914 10.2702 8.86914 11.9991C8.86914 13.728 10.2707 15.1296 11.9996 15.1296Z" fill="#F0F0F0"/>
<path d="M11.9995 11.217L10.3038 11.9997V13.304L11.9995 14.3475L13.6951 13.304V11.9997L11.9995 11.217Z" fill="#0052B4"/>
<path d="M13.6951 10.4358H10.3038V12.001H13.6951V10.4358Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4129">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4379)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M24.0009 12.0011C24.0009 7.24352 21.2322 3.13277 17.2183 1.19177V22.8103C21.2322 20.8693 24.0009 16.7586 24.0009 12.0011Z" fill="#D80027"/>
<path d="M0.000488281 12.0004C0.000488281 16.7579 2.76916 20.8687 6.78311 22.8097V1.1911C2.76916 3.1321 0.000488281 7.24285 0.000488281 12.0004Z" fill="#D80027"/>
<path d="M14.0875 13.5662L16.1744 12.5227L15.131 12.001V10.9575L13.044 12.001L14.0875 9.91402H13.044L12.0006 8.34882L10.9571 9.91402H9.91358L10.9571 12.001L8.8701 10.9575V12.001L7.82666 12.5227L9.91358 13.5662L9.39186 14.6097H11.4788V16.1749H12.5223V14.6097H14.6092L14.0875 13.5662Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4379">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4448)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544"/>
<path d="M18.4212 17.2178L18.7505 17.9063L19.4941 17.7345L19.1612 18.4212L19.7591 18.8954L19.0146 19.0632L19.0167 19.8265L18.4212 19.349L17.8258 19.8265L17.8279 19.0632L17.0834 18.8954L17.6814 18.4212L17.3484 17.7345L18.0919 17.9063L18.4212 17.2178Z" fill="#FFDA44"/>
<path d="M15.3579 9.91229L15.6872 10.6008L16.4308 10.4289L16.0978 11.1158L16.6958 11.5899L15.9513 11.7578L15.9533 12.521L15.3579 12.0435L14.7625 12.521L14.7645 11.7578L14.02 11.5899L14.618 11.1158L14.285 10.4289L15.0286 10.6008L15.3579 9.91229Z" fill="#FFDA44"/>
<path d="M18.4213 5.73828L18.7506 6.42683L19.4942 6.25489L19.1613 6.9417L19.7592 7.41594L19.0146 7.5837L19.0167 8.34697L18.4213 7.86945L17.8259 8.34697L17.828 7.5837L17.0835 7.41594L17.6814 6.9417L17.3484 6.25489L18.092 6.42683L18.4213 5.73828Z" fill="#FFDA44"/>
<path d="M21.0971 8.87018L21.4264 9.55872L22.1701 9.38683L21.8371 10.0736L22.4351 10.5478L21.6905 10.7156L21.6926 11.4789L21.0971 11.0014L20.5017 11.4789L20.5037 10.7156L19.7593 10.5478L20.3573 10.0736L20.0242 9.38683L20.7678 9.55872L21.0971 8.87018Z" fill="#FFDA44"/>
<path d="M19.1841 12.5212L19.4432 13.3184H20.2813L19.6032 13.811L19.8623 14.6081L19.1841 14.1155L18.506 14.6081L18.765 13.811L18.0869 13.3184H18.9251L19.1841 12.5212Z" fill="#FFDA44"/>
<path d="M13.3045 15.3914C11.4315 15.3914 9.9131 13.873 9.9131 12.0001C9.9131 10.1272 11.4314 8.6088 13.3045 8.6088C13.8884 8.6088 14.4379 8.7565 14.9177 9.01642C14.1651 8.28039 13.1359 7.82617 12 7.82617C9.69489 7.82617 7.82617 9.69489 7.82617 12.0001C7.82617 14.3052 9.69489 16.174 12 16.174C13.1359 16.174 14.1651 15.7197 14.9176 14.9837C14.4379 15.2437 13.8884 15.3914 13.3045 15.3914Z" fill="#FFDA44"/>
<path d="M7.5469 4.69552C7.18596 4.0719 6.51213 3.65204 5.73982 3.65204C4.96751 3.65204 4.29368 4.0719 3.93274 4.69552H7.5469Z" fill="#FFDA44"/>
<path d="M7.55316 4.70746L5.73914 6.52147L3.92513 4.70746C3.75174 5.01172 3.65222 5.36361 3.65222 5.73889C3.65222 6.8915 4.58658 7.82586 5.73919 7.82586C6.8918 7.82586 7.82616 6.89155 7.82616 5.73889C7.82611 5.36361 7.72655 5.01172 7.55316 4.70746Z" fill="#FFDA44"/>
<path d="M5.21729 6.00049V7.76083C5.38402 7.80372 5.55886 7.82655 5.73901 7.82655C5.91915 7.82655 6.09399 7.80367 6.26073 7.76083V6.00049H5.21729Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4448">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CD = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5367)">
<path d="M6.50505 22.6698L15.3206 15.3195L22.6709 6.50393C21.5281 4.28919 19.716 2.47611 17.5022 1.33185L8.67967 8.6786L1.33301 17.501C2.47718 19.715 4.29025 21.527 6.50505 22.6698Z" fill="#FFDA44"/>
<path d="M20.4853 20.4851C24.2712 16.6992 24.998 11.0134 22.6671 6.49719L6.49731 22.667C11.0135 24.9978 16.6994 24.271 20.4853 20.4851Z" fill="#D80027"/>
<path d="M3.51436 3.51375C-0.271537 7.29965 -0.998285 12.9855 1.33248 17.5017L17.5023 1.33191C12.9861 -0.998946 7.30026 -0.272103 3.51436 3.51375Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5367">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CD2 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4550)">
<path d="M22.6672 6.4984C22.1128 5.42407 21.386 4.4157 20.4854 3.51513C19.5848 2.61452 18.5764 1.88773 17.5021 1.33329L9.04823 9.0492L1.33228 17.5031C1.88676 18.5774 2.61356 19.5858 3.51412 20.4864C4.41468 21.3869 5.4231 22.1137 6.49738 22.6682L14.9512 14.9523L22.6672 6.4984Z" fill="#FFDA44"/>
<path d="M3.51468 20.4854C4.01807 20.9888 4.55521 21.4378 5.1186 21.8331L21.8335 5.11813C21.4383 4.55474 20.9893 4.0176 20.4859 3.51421C19.9825 3.01082 19.4454 2.5619 18.882 2.16665L2.16711 18.8815C2.56232 19.4448 3.01124 19.9821 3.51468 20.4854Z" fill="#D80027"/>
<path d="M3.51429 3.51439C-0.271664 7.30034 -0.99846 12.9862 1.33245 17.5024L17.5023 1.33259C12.986 -0.998271 7.3002 -0.27138 3.51429 3.51439Z" fill="#338AF3"/>
<path d="M20.4855 20.4851C24.2714 16.6992 24.9981 11.0133 22.6674 6.49716L6.49756 22.6669C11.0137 24.9978 16.6996 24.2711 20.4855 20.4851Z" fill="#338AF3"/>
<path d="M6.39522 3.65115L7.04276 5.64414H9.13826L7.44297 6.87583L8.09051 8.86876L6.39522 7.63703L4.69985 8.86876L5.34747 6.87583L3.6521 5.64414H5.7476L6.39522 3.65115Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4550">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CF = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4404)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M22.5405 6.2603C20.9898 3.41831 18.3234 1.27289 15.13 0.41217L14.6083 6.2603H22.5405Z" fill="#0052B4"/>
<path d="M1.45898 6.26048H9.39117L8.86945 0.412354C5.676 1.27307 3.00966 3.41854 1.45898 6.26048Z" fill="#0052B4"/>
<path d="M14.6083 12.0016V17.7408H22.5405C23.4707 16.0359 23.9996 14.0806 23.9996 12.0016H14.6083Z" fill="#6DA544"/>
<path d="M9.39119 12.0007H-0.00012207C-0.00012207 14.0796 0.528769 16.035 1.45896 17.7399H9.39114V12.0007H9.39119Z" fill="#6DA544"/>
<path d="M1.45911 17.7396C3.00978 20.5816 5.67612 22.727 8.86957 23.5878L9.39129 18.4733L1.45911 17.7396Z" fill="#FFDA44"/>
<path d="M15.1301 23.5884C18.3236 22.7276 20.99 20.5822 22.5406 17.7402L14.6084 18.4738L15.1301 23.5884Z" fill="#FFDA44"/>
<path d="M14.6084 18.4738L22.5406 17.7402H14.6084V18.4738Z" fill="#FFDA44"/>
<path d="M9.39134 17.7396H1.45911L9.39134 18.4732V17.7396Z" fill="#FFDA44"/>
<path d="M12.0001 0.000366211C10.9169 0.000366211 9.86779 0.144741 8.86963 0.413757V23.587C9.86779 23.856 10.9169 24.0004 12.0001 24.0004C13.0832 24.0004 14.1324 23.856 15.1305 23.587V0.413757C14.1324 0.144741 13.0832 0.000366211 12.0001 0.000366211Z" fill="#D80027"/>
<path d="M6.45426 2.60913L6.77798 3.60555H7.82577L6.97818 4.2214L7.30195 5.21782L6.45426 4.60202L5.60662 5.21782L5.93048 4.2214L5.08289 3.60555H6.13059L6.45426 2.60913Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4404">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5634)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M18.2604 9.91309H14.0865V5.73915H9.91254V9.91309H5.73865V14.087H9.91254V18.2609H14.0865V14.087H18.2604V9.91309Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5634">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4476)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9679 12.001H12.0001C12.0001 11.9902 12.0001 11.9797 12.0001 11.9689C11.9894 11.9796 11.9786 11.9903 11.9679 12.001Z" fill="#F0F0F0"/>
<path d="M11.9997 6.26184C11.9997 4.15035 11.9997 2.76684 11.9997 0.000976562H11.9977C5.37121 0.00210156 -0.000244141 5.37421 -0.000244141 12.001H6.26061V8.47546L9.78613 12.001H11.9677C11.9784 11.9903 11.9891 11.9796 11.9998 11.9689C11.9998 11.1604 11.9998 10.4391 11.9998 9.78745L8.47419 6.26184H11.9997Z" fill="#F0F0F0"/>
<path d="M6.07136 1.56458C4.19454 2.63328 2.63421 4.19356 1.56555 6.07039V11.9994H4.69601V4.69512V4.69503H12.0003C12.0003 3.7077 12.0003 2.76711 12.0003 1.56458H6.07136Z" fill="#D80027"/>
<path d="M12.0001 10.5236L7.73661 6.26013H6.26099V6.26023L12 11.9992H12.0001C12.0001 11.9992 12.0001 10.9817 12.0001 10.5236Z" fill="#D80027"/>
<path d="M16.1738 12L16.3958 12.6833H17.1142L16.533 13.1055L16.755 13.7888L16.1738 13.3665L15.5926 13.7888L15.8146 13.1055L15.2334 12.6833H15.9518L16.1738 12Z" fill="#F0F0F0"/>
<path d="M13.2225 13.223L13.8626 13.5491L14.3706 13.0411L14.2582 13.7507L14.8984 14.0769L14.1888 14.1892L14.0764 14.8989L13.7502 14.2587L13.0406 14.3711L13.5487 13.8631L13.2225 13.223Z" fill="#F0F0F0"/>
<path d="M11.9995 16.1731L12.6828 15.9511L12.6829 15.2328L13.105 15.8139L13.7883 15.5918L13.366 16.1731L13.7883 16.7544L13.105 16.5324L12.6829 17.1135V16.3952L11.9995 16.1731Z" fill="#F0F0F0"/>
<path d="M13.2225 19.1254L13.5486 18.4853L13.0406 17.9774L13.7502 18.0897L14.0764 17.4496L14.1888 18.1592L14.8984 18.2715L14.2582 18.5977L14.3706 19.3073L13.8626 18.7992L13.2225 19.1254Z" fill="#F0F0F0"/>
<path d="M16.1738 20.3481L15.9518 19.6648H15.2334L15.8146 19.2426L15.5926 18.5593L16.1738 18.9816L16.7551 18.5593L16.5331 19.2426L17.1143 19.6648H16.3959L16.1738 20.3481Z" fill="#F0F0F0"/>
<path d="M19.1248 19.1254L18.4847 18.7994L17.9767 19.3073L18.0891 18.5977L17.449 18.2716L18.1586 18.1592L18.271 17.4496L18.5971 18.0897L19.3067 17.9774L18.7986 18.4853L19.1248 19.1254Z" fill="#F0F0F0"/>
<path d="M20.3478 16.1731L19.6645 16.3952V17.1135L19.2422 16.5323L18.559 16.7544L18.9813 16.1731L18.559 15.5918L19.2422 15.8139L19.6645 15.2328V15.9511L20.3478 16.1731Z" fill="#F0F0F0"/>
<path d="M19.1248 13.223L18.7987 13.8631L19.3067 14.3711L18.5971 14.2587L18.271 14.8988L18.1586 14.1892L17.449 14.0768L18.0891 13.7507L17.9767 13.0411L18.4847 13.5491L19.1248 13.223Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4476">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4423)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M24.0001 12.0002C24.0001 18.6276 18.6275 24.0002 12.0001 24.0002C5.37275 24.0002 0.00012207 18.6276 0.00012207 12.0002C0.00012207 5.37287 12.0001 12.0002 12.0001 12.0002C12.0001 12.0002 21.0827 12.0002 24.0001 12.0002Z" fill="#D80027"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C12 4.56352 12 12 12 12C12 12 4.17389 12 0 12Z" fill="#0052B4"/>
<path d="M7.14288 4.17346L7.91993 6.56493H10.4344L8.40016 8.0429L9.17716 10.4344L7.14288 8.95635L5.1086 10.4344L5.8856 8.0429L3.85132 6.56493H6.36583L7.14288 4.17346Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4423">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4374)">
<path d="M17.2174 1.19108C15.6397 0.428241 13.8698 0.000366211 12 0.000366211C10.1301 0.000366211 8.36024 0.428241 6.78262 1.19108L5.73914 12.0004L6.78262 22.8096C8.36024 23.5725 10.1301 24.0004 12 24.0004C13.8698 24.0004 15.6397 23.5725 17.2174 22.8096L18.2608 12.0004L17.2174 1.19108Z" fill="#D80027"/>
<path d="M12.0002 7.82538L13.0361 11.0138H16.389L13.6766 12.9846L14.7126 16.1732L12.0002 14.2025L9.28778 16.1732L10.3239 12.9846L7.61157 11.0138H10.9642L12.0002 7.82538Z" fill="#FFDA44"/>
<path d="M6.78299 1.19171C2.76908 3.13262 0.000366211 7.24304 0.000366211 12.0006C0.000366211 16.7581 2.76908 20.8685 6.78299 22.8094V1.19171Z" fill="#496E2D"/>
<path d="M17.2178 1.19171V22.8094C21.2317 20.8685 24.0004 16.7581 24.0004 12.0006C24.0004 7.24309 21.2317 3.13262 17.2178 1.19171Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4374">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4428)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M6.56731 7.30145L7.60325 10.489H10.9548L8.24543 12.4624L9.28137 15.6499L6.56731 13.6811L3.85325 15.6499L4.89387 12.4624L2.17981 10.489H5.53137L6.56731 7.30145Z" fill="#FFDA44"/>
<path d="M14.2262 18.5846L13.434 17.6096L12.2622 18.0643L12.9418 17.0096L12.1497 16.03L13.3637 16.3534L14.0481 15.2987L14.1137 16.555L15.3325 16.8784L14.1559 17.3284L14.2262 18.5846Z" fill="#FFDA44"/>
<path d="M15.8017 15.7253L16.1767 14.5253L15.1501 13.7987L16.4064 13.78L16.7767 12.58L17.1845 13.7706L18.4408 13.7565L17.433 14.5065L17.8361 15.6971L16.8095 14.9706L15.8017 15.7253Z" fill="#FFDA44"/>
<path d="M17.9253 8.80662L17.3722 9.9363L18.2722 10.8129L17.03 10.6347L16.4769 11.7597L16.2613 10.5222L15.0144 10.3441L16.13 9.75818L15.9144 8.51599L16.8144 9.39255L17.9253 8.80662Z" fill="#FFDA44"/>
<path d="M14.2592 5.38507L14.1654 6.63664L15.3326 7.11007L14.1092 7.41007L14.0201 8.66632L13.3592 7.59757L12.1357 7.89757L12.9467 6.93664L12.2811 5.87257L13.4482 6.34601L14.2592 5.38507Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4428">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4460)">
<path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z" fill="#FFDA44"/>
<path d="M1.60583 18.0005C3.68076 21.5872 7.55844 24.0005 12.0001 24.0005C16.4417 24.0005 20.3194 21.5872 22.3943 18.0005L12.0001 17.2179L1.60583 18.0005Z" fill="#D80027"/>
<path d="M22.3938 17.9998C23.4148 16.2347 23.9995 14.1856 23.9995 11.9998H-0.000488281C-0.000488281 14.1856 0.584231 16.2347 1.60526 17.9998H22.3938Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4460">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4494)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.2536 7.82617H0.746391C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617Z" fill="#D80027"/>
<path d="M12.0012 -0.000488281C8.36407 -0.000488281 5.10518 1.61782 2.90454 4.1734H21.0977C18.8971 1.61782 15.6382 -0.000488281 12.0012 -0.000488281Z" fill="#0052B4"/>
<path d="M21.0963 19.826H2.90308C5.10372 22.3816 8.36261 23.9999 11.9997 23.9999C15.6368 23.9999 18.8957 22.3816 21.0963 19.826Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4494">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4525)">
<path d="M12 24.0001C18.6273 24.0001 23.9999 18.6275 23.9999 12.0002C23.9999 5.37277 18.6273 0.000205994 12 0.000205994C5.37256 0.000205994 0 5.37277 0 12.0002C0 18.6275 5.37256 24.0001 12 24.0001Z" fill="#F0F0F0"/>
<path d="M11.9996 0.000244141C8.07369 0.000244141 4.58834 1.8857 2.39905 4.80024H21.6C19.4108 1.88565 15.9254 0.000244141 11.9996 0.000244141Z" fill="#0052B4"/>
<path d="M11.9996 24.0002C15.9254 24.0002 19.4108 22.1147 21.6001 19.2002H2.39905C4.5883 22.1148 8.07369 24.0002 11.9996 24.0002Z" fill="#0052B4"/>
<path d="M0 12.0002C0 12.8222 0.0828749 13.6248 0.240328 14.4002H23.7597C23.9172 13.6248 24 12.8222 24 12.0002C24 11.1783 23.9171 10.3757 23.7597 9.60021H0.240328C0.0828749 10.3757 0 11.1783 0 12.0002Z" fill="#0052B4"/>
<path d="M3.5148 3.5146C-1.17144 8.20084 -1.17144 15.7989 3.5148 20.4852C5.45134 18.5486 7.31378 16.6862 12.0001 11.9999L3.5148 3.5146Z" fill="#D80027"/>
<path d="M4.85658 8.86958L5.63349 11.2609H8.14814L6.11391 12.739L6.89081 15.1303L4.85658 13.6524L2.82225 15.1303L3.59934 12.739L1.56506 11.2609H4.07953L4.85658 8.86958Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4525">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4534)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M11.9999 24.0007C15.9374 24.0007 19.4319 22.1042 21.62 19.1749H2.37976C4.56789 22.1042 8.06237 24.0007 11.9999 24.0007Z" fill="#0052B4"/>
<path d="M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.419 0.246984 14.7803 0.699188 16.0439H23.3008C23.753 14.7803 24 13.419 24 12Z" fill="#0052B4"/>
<path d="M8.21371 7.69602L8.8612 9.68877H10.9567L9.26146 10.9206L9.90895 12.9134L8.21371 11.6817L6.51848 12.9134L7.16606 10.9206L5.47083 9.68877H7.56623L8.21371 7.69602Z" fill="#F0F0F0"/>
<path d="M4.61493 5.6095L5.00343 6.80519H6.26075L5.24361 7.54423L5.63211 8.73996L4.61493 8.00093L3.59779 8.73996L3.98633 7.54423L2.96924 6.80519H4.22652L4.61493 5.6095Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4534">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CX = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4436)">
<path d="M20.4857 20.4857C15.7994 25.172 8.20141 25.172 3.51509 20.4857C-1.17123 15.7995 -1.17118 8.20146 3.51509 3.51514C3.88399 3.884 13.1072 10.8936 13.1072 10.8936L20.4857 20.4857Z" fill="#0052B4"/>
<path d="M3.51501 3.51422C8.20129 -1.17206 15.7993 -1.17206 20.4856 3.51422C25.1719 8.20049 25.1719 15.7985 20.4856 20.4848" fill="#6DA544"/>
<path d="M12.0003 15.131C13.7292 15.131 15.1308 13.7295 15.1308 12.0006C15.1308 10.2717 13.7292 8.87012 12.0003 8.87012C10.2714 8.87012 8.86987 10.2717 8.86987 12.0006C8.86987 13.7295 10.2714 15.131 12.0003 15.131Z" fill="#FFDA44"/>
<path d="M4.4684 17.2175L4.79769 17.9061L5.54127 17.7342L5.20827 18.4209L5.8063 18.8952L5.06174 19.0629L5.0638 19.8262L4.4684 19.3487L3.87299 19.8262L3.87505 19.0629L3.13049 18.8952L3.72852 18.4209L3.39548 17.7342L4.1391 17.9061L4.4684 17.2175Z" fill="#F0F0F0"/>
<path d="M2.31442 11.4769L2.64372 12.1654L3.38729 11.9935L3.05434 12.6803L3.65228 13.1545L2.90776 13.3223L2.90982 14.0856L2.31442 13.6081L1.71906 14.0856L1.72108 13.3223L0.976562 13.1545L1.57455 12.6803L1.24155 11.9935L1.98512 12.1654L2.31442 11.4769Z" fill="#F0F0F0"/>
<path d="M4.46835 6.78186L4.79765 7.47041L5.54122 7.29847L5.20827 7.98528L5.80625 8.45951L5.06169 8.62728L5.06376 9.39054L4.46835 8.91307L3.87295 9.39054L3.87501 8.62728L3.13049 8.45951L3.72843 7.98528L3.39543 7.29847L4.13905 7.47041L4.46835 6.78186Z" fill="#F0F0F0"/>
<path d="M7.14425 10.4346L7.47355 11.1232L8.21717 10.9512L7.88413 11.6381L8.48211 12.1123L7.7376 12.2801L7.73961 13.0433L7.14425 12.5658L6.54885 13.0433L6.55091 12.2801L5.8064 12.1123L6.40433 11.6381L6.07138 10.9512L6.81496 11.1232L7.14425 10.4346Z" fill="#F0F0F0"/>
<path d="M5.23131 13.5646L5.49034 14.3617H6.32847L5.65037 14.8544L5.9094 15.6515L5.23131 15.1589L4.55322 15.6515L4.81225 14.8544L4.13416 14.3617H4.97228L5.23131 13.5646Z" fill="#F0F0F0"/>
<path d="M12 14.0872H13.0434C13.0434 14.0872 13.4956 13.2872 13.0434 12.522L14.0869 11.4785L13.5652 10.435H13.0435C13.0435 10.435 12.7826 11.2176 11.7391 11.2176C10.6957 11.2176 10.4348 10.435 10.4348 10.435H9.91309L10.4348 11.4785L9.91309 12.522L10.4348 13.0437C10.4348 13.0437 10.9565 12.0002 12 12.522C12 12.522 12.4434 13.1741 12 14.0872Z" fill="#6DA544"/>
<path d="M19.7888 6.57258C19.8134 6.44437 19.8265 6.31214 19.8265 6.17677C19.8265 5.24864 19.2205 4.4625 18.3828 4.19128C18.6387 4.7116 18.783 5.29678 18.783 5.91591C18.783 6.12469 18.7662 6.32953 18.7347 6.52945C18.6086 6.32634 18.4466 6.14077 18.2488 5.98331C17.5034 5.39025 16.4849 5.37455 15.7318 5.874C16.3132 6.00094 16.8754 6.25898 17.3726 6.65456C17.7618 6.96431 18.0763 7.38328 18.3172 7.78772L15.1309 8.78545C18.2613 9.30717 20.87 7.22025 20.87 7.22025C20.5809 6.64219 20.132 6.54469 19.7888 6.57258Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4436">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4542)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC"/>
<path d="M18.7826 10.4345C18.4174 10.4345 17.9652 10.4345 17.2174 10.4345C17.2174 13.316 14.8814 15.6518 12 15.6518C9.11844 15.6518 6.78261 13.316 6.78261 10.4345C6.27824 10.4345 5.72169 10.4345 5.21741 10.4345C5.21741 13.5383 7.30222 16.1552 10.148 16.9611C9.836 17.5538 9.88353 18.3 10.3292 18.8562C10.9146 18.387 11.5206 17.9013 12.0348 17.4894C12.5489 17.9014 13.155 18.387 13.7403 18.8562C14.1904 18.2945 14.2347 17.5388 13.9123 16.9432C16.727 16.1175 18.7826 13.5162 18.7826 10.4345Z" fill="#6DA544"/>
<path d="M7.82617 9.91283C7.82617 9.91283 7.82617 12.5215 10.4349 12.5215L10.9566 13.0432H12.0001C12.0001 13.0432 12.5218 11.478 13.5653 11.478C13.5653 11.478 13.5653 10.4346 14.6088 10.4346C15.6522 10.4346 16.174 10.4346 16.174 10.4346C16.174 10.4346 15.6522 8.34758 18.2609 6.78238L17.2174 6.26066C17.2174 6.26066 13.5653 8.86935 10.9566 8.34763V9.39111H9.91309L9.39138 8.8694L7.82617 9.91283Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4542">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const CZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4546)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M10.957 11.9993C10.957 11.9993 3.52217 20.4863 3.51514 20.4846C5.68667 22.6562 8.68671 23.9993 12.0004 23.9993C18.6278 23.9993 24.0004 18.6267 24.0004 11.9993H10.957Z" fill="#D80027"/>
<path d="M3.5152 3.5146C-1.17108 8.20088 -1.17108 15.7989 3.5152 20.4852C5.45175 18.5487 7.31423 16.6862 12.0005 11.9999L3.5152 3.5146Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4546">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4720)">
<path d="M0.746338 16.1749C2.44185 20.7445 6.84037 24.001 11.9999 24.001C17.1595 24.001 21.558 20.7445 23.2536 16.1749L11.9999 15.1315L0.746338 16.1749Z" fill="#FFDA44"/>
<path d="M11.9999 0.000774384C6.84037 0.000774384 2.44185 3.25727 0.746338 7.82688L11.9999 8.87032L23.2536 7.82684C21.558 3.25727 17.1595 0.000774384 11.9999 0.000774384Z" fill="black"/>
<path d="M0.746391 7.82577C0.264047 9.12575 0 10.5318 0 11.9997C0 13.4675 0.264047 14.8736 0.746391 16.1735H23.2537C23.736 14.8736 24 13.4675 24 11.9997C24 10.5318 23.736 9.12575 23.2536 7.82577H0.746391Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4720">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DJ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4564)">
<path d="M10.9562 13.044C10.9562 13.044 3.52144 3.5136 3.5144 3.51528C5.68594 1.34371 8.68598 0.000549316 11.9997 0.000549316C18.6271 0.000549316 23.9997 5.37318 23.9997 12.0006L10.9562 13.044Z" fill="#338AF3"/>
<path d="M10.9562 11.9993C10.9562 11.9993 3.52144 20.4863 3.5144 20.4846C5.68594 22.6562 8.68598 23.9993 11.9997 23.9993C18.6271 23.9993 23.9997 18.6267 23.9997 11.9993H10.9562Z" fill="#6DA544"/>
<path d="M3.51447 3.5146C-1.17181 8.20088 -1.17181 15.7989 3.51447 20.4852C5.45101 18.5487 7.3135 16.6862 11.9998 11.9999L3.51447 3.5146Z" fill="#F0F0F0"/>
<path d="M4.85633 8.86938L5.63329 11.2608H8.14794L6.11366 12.7388L6.89057 15.1303L4.85633 13.6523L2.82201 15.1303L3.5991 12.7388L1.56482 11.2608H4.07929L4.85633 8.86938Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4564">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4557)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M9.39189 10.4349H23.899C23.1319 4.54709 18.0974 0.00012207 12.0005 0.00012207C11.1045 0.00012207 10.2318 0.099169 9.39185 0.285356V10.4349H9.39189Z" fill="#D80027"/>
<path d="M6.26146 10.4357V1.46001C2.96647 3.25785 0.607626 6.55555 0.102173 10.4357H6.26146V10.4357Z" fill="#D80027"/>
<path d="M6.26092 13.5656H0.101685C0.607138 17.4457 2.96598 20.7434 6.26097 22.5412L6.26092 13.5656Z" fill="#D80027"/>
<path d="M9.39185 13.5656V23.7151C10.2318 23.9013 11.1045 24.0003 12.0005 24.0003C18.0974 24.0003 23.1319 19.4534 23.899 13.5656H9.39185V13.5656Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4557">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4569)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M14.348 23.7694C19.0919 22.8283 22.8288 19.0913 23.7699 14.3475H14.348V23.7694Z" fill="#496E2D"/>
<path d="M0.230103 14.3475C1.17112 19.0913 4.90809 22.8283 9.65198 23.7694V14.3475H0.230103Z" fill="#496E2D"/>
<path d="M23.7699 9.65228C22.8288 4.90844 19.0919 1.17147 14.348 0.230408V9.65228H23.7699Z" fill="#496E2D"/>
<path d="M9.65234 0.230469C4.90845 1.17153 1.17148 4.9085 0.230469 9.65234H9.65234V0.230469Z" fill="#496E2D"/>
<path d="M11.2171 14.3481H9.65186V23.77C10.1627 23.8713 10.6852 23.9399 11.2171 23.9742V14.3481Z" fill="#FFDA44"/>
<path d="M11.2175 9.65277V0.0267029C10.6857 0.0609216 10.1631 0.129594 9.65234 0.23089V9.65277H11.2175Z" fill="#FFDA44"/>
<path d="M12.7823 0.0266587C12.5234 0.00992432 12.2627 0.000549316 11.9997 0.000549316C11.7366 0.000549316 11.4759 0.00992432 11.217 0.0266587V9.65277H12.7822V0.0266587H12.7823Z" fill="black"/>
<path d="M11.217 23.9739C11.4759 23.9906 11.7366 24 11.9997 24C12.2627 24 12.5234 23.9906 12.7823 23.9739V14.3478H11.2171V23.9739H11.217Z" fill="black"/>
<path d="M9.65206 11.2178V9.65259H0.230188C0.128845 10.1634 0.0602197 10.6859 0.026001 11.2178H9.65206Z" fill="#FFDA44"/>
<path d="M14.3478 11.2183H23.9739C23.9397 10.6864 23.871 10.1639 23.7697 9.65311H14.3478V11.2183H14.3478Z" fill="#FFDA44"/>
<path d="M14.348 12.7831H23.9741C23.9908 12.5243 24.0002 12.2635 24.0002 12.0005C24.0002 11.7375 23.9908 11.4767 23.9741 11.2179H14.348V12.7831Z" fill="black"/>
<path d="M0.0259873 11.2179C0.0092998 11.4767 -0.00012207 11.7375 -0.00012207 12.0005C-0.00012207 12.2635 0.0092998 12.5243 0.0259873 12.7831H9.6521V11.2179H0.0259873V11.2179Z" fill="black"/>
<path d="M11.9999 17.7389C15.1695 17.7389 17.739 15.1694 17.739 11.9998C17.739 8.83015 15.1695 6.26065 11.9999 6.26065C8.83024 6.26065 6.26074 8.83015 6.26074 11.9998C6.26074 15.1694 8.83024 17.7389 11.9999 17.7389Z" fill="#D80027"/>
<path d="M13.3069 12.6408C12.88 11.7871 12.3252 10.9218 12.3252 10.9218C12.3252 10.9218 12.3389 10.5278 12.3389 10.2931C12.3389 9.93943 12.0522 9.65274 11.6986 9.65274C11.3636 9.65274 11.0891 9.91013 11.0611 10.2378C10.7977 10.255 10.5892 10.4736 10.5892 10.7413C10.5892 10.936 10.6995 11.1047 10.861 11.189C10.9412 11.0013 11.0983 10.8548 11.2927 10.788C11.3244 10.8139 11.3584 10.8371 11.3947 10.8567L11.4768 10.896C11.4768 10.896 11.1726 11.7534 11.1726 12.214C11.1726 13.5089 12.0264 13.9082 12.0264 13.9082V13.9216L11.5995 14.3484H12.4532V13.4946L12.8801 13.9215C12.8839 13.9135 13.6887 13.4045 13.3069 12.6408Z" fill="#496E2D"/>
<path d="M11.9996 7.30444L12.1938 7.90229H12.8224L12.3139 8.2718L12.5082 8.86964L11.9996 8.50018L11.491 8.86964L11.6853 8.2718L11.1768 7.90229H11.8054L11.9996 7.30444Z" fill="#496E2D"/>
<path d="M9.23988 8.20183L9.74838 8.57135L10.257 8.20178L10.0627 8.79972L10.5713 9.16914L9.94268 9.16919L9.74843 9.76704L9.55413 9.16919L8.92554 9.16914L9.43408 8.79963L9.23988 8.20183Z" fill="#496E2D"/>
<path d="M7.53406 10.5493H8.1626L8.3569 9.95142L8.55115 10.5493L9.17979 10.5492L8.67124 10.9188L8.86554 11.5166L8.3569 11.1471L7.84835 11.5166L8.04256 10.9187L7.53406 10.5493Z" fill="#496E2D"/>
<path d="M7.53406 13.4514L8.04256 13.0819L7.84831 12.484L8.3569 12.8536L8.86549 12.484L8.67124 13.0819L9.17984 13.4514L8.55115 13.4514L8.3569 14.0492L8.1626 13.4514H7.53406Z" fill="#496E2D"/>
<path d="M9.23993 15.799L9.43413 15.2013L8.92554 14.8318H9.55418L9.74847 14.2339L9.94272 14.8317H10.5714L10.0628 15.2013L10.257 15.7991L9.74843 15.4296L9.23993 15.799Z" fill="#496E2D"/>
<path d="M11.9996 16.6964L11.8054 16.0986H11.1768L11.6853 15.7291L11.491 15.1312L11.9996 15.5007L12.5081 15.1312L12.3139 15.7291L12.8224 16.0986L12.1938 16.0986L11.9996 16.6964Z" fill="#496E2D"/>
<path d="M14.7603 15.799L14.2518 15.4295L13.7432 15.7991L13.9374 15.2013L13.4288 14.8317L14.0575 14.8317L14.2517 14.2339L14.446 14.8317H15.0746L14.5661 15.2013L14.7603 15.799Z" fill="#496E2D"/>
<path d="M16.466 13.4515H15.8374L15.6431 14.0494L15.4489 13.4516H14.8202L15.3288 13.082L15.1345 12.4842L15.6431 12.8537L16.1516 12.4842L15.9575 13.0821L16.466 13.4515Z" fill="#496E2D"/>
<path d="M16.466 10.5492L15.9575 10.9187L16.1517 11.5165L15.6431 11.1471L15.1345 11.5166L15.3288 10.9187L14.8202 10.5493L15.4489 10.5492L15.6431 9.95142L15.8374 10.5492H16.466Z" fill="#496E2D"/>
<path d="M14.7603 8.20178L14.5661 8.79958L15.0746 9.1691H14.446L14.2518 9.76699L14.0575 9.16915L13.4288 9.16919L13.9374 8.79958L13.7432 8.20183L14.2518 8.57125L14.7603 8.20178Z" fill="#496E2D"/>
</g>
<defs>
<clipPath id="clip0_2087_4569">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4599)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0.413818 15.131C1.52185 19.2421 4.7589 22.4792 8.87002 23.5872V15.131H0.413818Z" fill="#D80027"/>
<path d="M8.86949 0.413391C4.75841 1.52138 1.52131 4.75847 0.41333 8.86955H8.86953V0.413391H8.86949Z" fill="#0052B4"/>
<path d="M23.5867 8.86967C22.4787 4.75859 19.2416 1.5215 15.1305 0.413513V8.86972H23.5867V8.86967Z" fill="#D80027"/>
<path d="M15.1305 23.5871C19.2416 22.479 22.4787 19.242 23.5867 15.1309H15.1305V23.5871Z" fill="#0052B4"/>
<path d="M15.1305 11.9998C15.1305 13.7288 13.729 15.1303 12.0001 15.1303C10.2712 15.1303 8.86963 13.7288 8.86963 11.9998C8.86963 10.2709 12.0001 8.86938 12.0001 8.86938C12.0001 8.86938 15.1305 10.2709 15.1305 11.9998Z" fill="#496E2D"/>
<path d="M8.86963 11.9998C8.86963 10.2709 10.2712 8.86938 12.0001 8.86938C13.729 8.86938 15.1305 10.2709 15.1305 11.9998" fill="#0052B4"/>
<path d="M10.2393 10.4344V12.391C10.2393 13.3635 11.0276 14.1518 12.0001 14.1518C12.9726 14.1518 13.761 13.3635 13.761 12.391V10.4344H10.2393Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4599">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5600)">
<path d="M1.19121 6.78262C0.428363 8.36025 0.000488281 10.1301 0.000488281 12C0.000488281 13.8699 0.428363 15.6398 1.19121 17.2174L12.0005 18.2609L22.8098 17.2174C23.5726 15.6398 24.0005 13.8699 24.0005 12C24.0005 10.1301 23.5726 8.36025 22.8098 6.78262L12.0005 5.73914L1.19121 6.78262Z" fill="#F0F0F0"/>
<path d="M1.19104 17.2167C3.13195 21.2306 7.24237 23.9993 11.9999 23.9993C16.7574 23.9993 20.8679 21.2306 22.8088 17.2167H1.19104Z" fill="black"/>
<path d="M1.19104 6.78287H22.8088C20.8679 2.76892 16.7574 0.000244141 11.9999 0.000244141C7.24237 0.000244141 3.13195 2.76892 1.19104 6.78287Z" fill="#D80027"/>
<path d="M3.5152 3.51392C-1.17108 8.2002 -1.17108 15.7982 3.5152 20.4845C5.45175 18.548 7.31423 16.6855 12.0005 11.9992L3.5152 3.51392Z" fill="#496E2D"/>
</g>
<defs>
<clipPath id="clip0_2087_5600">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const DZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_3998)">
<path d="M12.0004 0C18.6278 0 24.0004 5.37262 24.0004 12C24.0004 18.6274 18.6278 24 12.0004 24C12.0004 23.4783 10.4352 12 10.4352 12L12.0004 0Z" fill="#F0F0F0"/>
<path d="M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0" fill="#496E2D"/>
<path d="M14.578 9.6987L13.5934 11.0555L11.9989 10.5384L12.9851 11.894L12.0006 13.2508L13.5945 12.7318L14.5807 14.0874L14.5797 12.4111L16.1736 11.8921L14.5791 11.3751L14.578 9.6987Z" fill="#D80027"/>
<path d="M12.9952 15.392C11.1223 15.392 9.60389 13.8736 9.60389 12.0007C9.60389 10.1277 11.1223 8.60937 12.9952 8.60937C13.5792 8.60937 14.1287 8.75703 14.6084 9.017C13.8558 8.28101 12.8266 7.82675 11.6909 7.82675C9.38564 7.82675 7.51697 9.69547 7.51697 12.0006C7.51697 14.3058 9.38569 16.1745 11.6909 16.1745C12.8266 16.1745 13.8558 15.7203 14.6084 14.9843C14.1287 15.2443 13.5792 15.392 12.9952 15.392Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_3998">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const EC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4613)">
<path d="M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z" fill="#FFDA44"/>
<path d="M1.60559 18.0009C3.68051 21.5876 7.5582 24.0009 11.9998 24.0009C16.4415 24.0009 20.3192 21.5876 22.3941 18.0009L11.9998 17.2183L1.60559 18.0009Z" fill="#D80027"/>
<path d="M22.3944 18.0002C23.4154 16.2352 24.0001 14.186 24.0001 12.0002H0.00012207C0.00012207 14.186 0.584841 16.2352 1.60587 18.0002H22.3944Z" fill="#0052B4"/>
<path d="M11.9997 16.1744C14.3049 16.1744 16.1736 14.3057 16.1736 12.0005C16.1736 9.69534 14.3049 7.82663 11.9997 7.82663C9.69452 7.82663 7.82581 9.69534 7.82581 12.0005C7.82581 14.3057 9.69452 16.1744 11.9997 16.1744Z" fill="#FFDA44"/>
<path d="M12.0003 14.6092C10.5618 14.6092 9.3916 13.4389 9.3916 12.0005V10.4353C9.3916 8.99686 10.5619 7.82663 12.0003 7.82663C13.4387 7.82663 14.609 8.99691 14.609 10.4353V12.0005C14.609 13.439 13.4387 14.6092 12.0003 14.6092Z" fill="#338AF3"/>
<path d="M16.1737 5.73996H13.0432C13.0432 5.16368 12.576 4.69647 11.9997 4.69647C11.4235 4.69647 10.9563 5.16368 10.9563 5.73996H7.82581C7.82581 6.31629 8.32779 6.78344 8.90403 6.78344H8.86929C8.86929 7.35977 9.33645 7.82693 9.91278 7.82693C9.91278 8.40326 10.3799 8.87041 10.9563 8.87041H13.0432C13.6196 8.87041 14.0867 8.40326 14.0867 7.82693C14.663 7.82693 15.1302 7.35977 15.1302 6.78344H15.0955C15.6718 6.78344 16.1737 6.31624 16.1737 5.73996Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4613">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const EE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4641)">
<path d="M-0.000244141 11.9995C-0.000244141 13.4673 0.263803 14.8734 0.746147 16.1734L11.9998 16.6951L23.2534 16.1734C23.7358 14.8734 23.9998 13.4673 23.9998 11.9995C23.9998 10.5316 23.7358 9.12558 23.2534 7.8256L11.9998 7.30383L0.746147 7.82555C0.263803 9.12558 -0.000244141 10.5316 -0.000244141 11.9995Z" fill="black"/>
<path d="M11.9997 -0.000305176C6.84013 -0.000305176 2.44161 3.25619 0.746094 7.8258H23.2534C21.5578 3.25619 17.1593 -0.000305176 11.9997 -0.000305176Z" fill="#0052B4"/>
<path d="M23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4641">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const EG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4620)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0002 -0.000305176C6.84061 -0.000305176 2.4421 3.25619 0.746582 7.8258H23.2538C21.5583 3.25619 17.1598 -0.000305176 12.0002 -0.000305176Z" fill="#D80027"/>
<path d="M12.0002 24.0003C17.1598 24.0003 21.5583 20.7438 23.2538 16.1742H0.746582C2.4421 20.7438 6.84061 24.0003 12.0002 24.0003Z" fill="black"/>
<path d="M16.1739 10.6956H13.0435C13.0435 10.1193 12.5763 9.6521 12 9.6521C11.4237 9.6521 10.9565 10.1193 10.9565 10.6956H7.82605C7.82605 11.2719 8.32803 11.7391 8.90431 11.7391H8.86953C8.86953 12.3154 9.33669 12.7826 9.91302 12.7826C9.91302 13.3589 10.3802 13.826 10.9565 13.826H13.0435C13.6198 13.826 14.087 13.3589 14.087 12.7826C14.6633 12.7826 15.1304 12.3154 15.1304 11.7391H15.0957C15.672 11.7391 16.1739 11.2719 16.1739 10.6956Z" fill="#FF9811"/>
</g>
<defs>
<clipPath id="clip0_2087_4620">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const EH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4218)">
<path d="M1.19072 6.78189C0.427875 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427875 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166C23.5721 15.639 24 13.8692 24 11.9993C24 10.1294 23.5721 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189Z" fill="#F0F0F0"/>
<path d="M1.19128 17.2178C3.13219 21.2317 7.24266 24.0004 12.0001 24.0004C16.7576 24.0004 20.8681 21.2317 22.809 17.2178H1.19128Z" fill="#496E2D"/>
<path d="M1.19128 6.78226H22.809C20.8681 2.76831 16.7577 -0.000366211 12.0001 -0.000366211C7.24261 -0.000366211 3.13219 2.76831 1.19128 6.78226Z" fill="black"/>
<path d="M3.51471 3.51501C-1.17157 8.2013 -1.17157 15.7993 3.51471 20.4856C5.45126 18.5491 7.31375 16.6866 12 12.0003L3.51471 3.51501Z" fill="#D80027"/>
<path d="M15.1306 12C15.1306 10.2516 16.3593 8.79103 18.0001 8.43272C17.7479 8.37764 17.4863 8.34778 17.2175 8.34778C15.2004 8.34778 13.5653 9.98287 13.5653 12C13.5653 14.017 15.2004 15.6521 17.2175 15.6521C17.4862 15.6521 17.7479 15.6223 18.0001 15.5672C16.3593 15.2089 15.1306 13.7483 15.1306 12Z" fill="#D80027"/>
<path d="M18.1533 9.6521L18.6714 11.2465H20.3477L18.9915 12.2317L19.5096 13.826L18.1533 12.8407L16.7972 13.826L17.3153 12.2317L15.959 11.2465H17.6353L18.1533 9.6521Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4218">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ER = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4636)">
<path d="M10.9568 10.9566C10.9568 10.9566 3.52205 20.4871 3.51501 20.4854C5.68655 22.6569 8.68659 24.0001 12.0003 24.0001C18.6277 24.0001 24.0003 18.6275 24.0003 12.0001L10.9568 10.9566Z" fill="#338AF3"/>
<path d="M10.9568 11.9997C10.9568 11.9997 3.52205 3.51274 3.51501 3.51443C5.68655 1.34285 8.68659 -0.000305176 12.0003 -0.000305176C18.6277 -0.000305176 24.0003 5.37232 24.0003 11.9997H10.9568Z" fill="#6DA544"/>
<path d="M3.51422 3.5155C-1.17206 8.20178 -1.17206 15.7998 3.51422 20.4861C3.51389 20.4881 23.9995 12.0008 23.9995 12.0008L3.51422 3.5155Z" fill="#D80027"/>
<path d="M6.26044 7.04321C3.95892 7.04321 2.08655 8.91563 2.08655 11.2171V12.7823C2.08655 15.0838 3.95897 16.9562 6.26044 16.9562C8.56191 16.9562 10.4343 15.0838 10.4343 12.7823V11.2171C10.4344 8.91563 8.56195 7.04321 6.26044 7.04321ZM8.86913 12.7824C8.86913 13.9482 8.10028 14.9377 7.04302 15.2709V13.565L8.15039 12.4576L7.04363 11.3508L7.04302 10.9569V10.4346H5.47786V11.9997L4.37124 13.1063L5.47786 14.2129V15.271C4.4206 14.9378 3.65175 13.9483 3.65175 12.7824V11.2172C3.65175 9.77874 4.82203 8.60851 6.26044 8.60851C7.69885 8.60851 8.86913 9.77879 8.86913 11.2172V12.7824Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4636">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ES = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5566)">
<path d="M0 11.9993C0 13.4671 0.264047 14.8732 0.746391 16.1732L12 17.2167L23.2536 16.1732C23.736 14.8732 24 13.4671 24 11.9993C24 10.5315 23.736 9.12539 23.2536 7.82541L12 6.78192L0.746391 7.82541C0.264047 9.12539 0 10.5315 0 11.9993Z" fill="#FFDA44"/>
<path d="M23.2551 7.82574C21.5596 3.25618 17.1611 -0.000366211 12.0015 -0.000366211C6.84196 -0.000366211 2.44344 3.25618 0.747925 7.82574H23.2551Z" fill="#D80027"/>
<path d="M0.746948 16.174C2.44246 20.7435 6.84098 24.0001 12.0006 24.0001C17.1601 24.0001 21.5586 20.7435 23.2542 16.174H0.746948Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5566">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ET = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4645)">
<path d="M-0.00012207 12C-0.00012207 13.4679 0.263925 14.874 0.746315 16.174L11.9999 17.2173L23.2534 16.1739C23.7359 14.874 23.9999 13.4679 23.9999 12C23.9999 10.5522 23.7434 9.1644 23.2736 7.87942L11.9999 6.78259L0.726159 7.87947C0.256331 9.1644 -0.00012207 10.5522 -0.00012207 12Z" fill="#FFDA44"/>
<path d="M11.9998 24.0003C17.1594 24.0003 21.5579 20.7438 23.2534 16.1742H0.746216C2.44173 20.7438 6.84025 24.0003 11.9998 24.0003Z" fill="#D80027"/>
<path d="M11.9999 -0.000305176C6.84037 -0.000305176 2.44185 3.25619 0.746338 7.8258H23.2536C21.558 3.25619 17.1595 -0.000305176 11.9999 -0.000305176Z" fill="#6DA544"/>
<path d="M11.9998 17.7398C15.1694 17.7398 17.7389 15.1703 17.7389 12.0007C17.7389 8.83103 15.1694 6.26154 11.9998 6.26154C8.83012 6.26154 6.26062 8.83103 6.26062 12.0007C6.26062 15.1703 8.83012 17.7398 11.9998 17.7398Z" fill="#0052B4"/>
<path d="M11.9986 7.55646L13.0347 10.745H16.3927L13.6749 12.7157L14.7191 15.9137L11.9986 13.9336L9.28232 15.91L10.3223 12.7157L7.60706 10.745H10.9626L11.9986 7.55646Z" fill="#FFDA44"/>
<path d="M16.1308 12.7939L12.8441 11.7259L14.8753 8.9303L14.0312 8.31689L11.9999 11.1127L9.96872 8.31694L9.1245 8.93025L11.1557 11.7261L7.86914 12.7939L8.19155 13.7864L11.4782 12.7185V16.1742H12.5217V12.7185L15.8082 13.7864L16.1308 12.7939Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4645">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4685)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.8985 10.4347H9.39148H9.39143V0.285156C8.28247 0.531062 7.23111 0.929641 6.26098 1.459V10.4346V10.4347H0.1017C0.0349033 10.9471 0.00012207 11.4694 0.00012207 11.9999C0.00012207 12.5304 0.0349033 13.0528 0.1017 13.5651H6.26093H6.26098V22.5408C7.23111 23.0701 8.28247 23.4688 9.39143 23.7146V13.5653V13.5652H23.8985C23.9652 13.0528 24.0001 12.5304 24.0001 11.9999C24.0001 11.4694 23.9652 10.9471 23.8985 10.4347Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4685">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FJ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4671)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#338AF3"/>
<path d="M11.9993 5.7403V9.78762L7.82544 5.7403H11.9993Z" fill="#0052B4"/>
<path d="M6.26049 12.0019H9.78605L6.26049 7.30621L5.73877 10.9584L6.26049 12.0019Z" fill="#0052B4"/>
<path d="M11.9673 12.0001H11.9995C11.9995 11.9893 11.9995 11.9788 11.9995 11.968C11.9887 11.9787 11.978 11.9894 11.9673 12.0001Z" fill="#F0F0F0"/>
<path d="M11.9997 6.26153C11.9997 4.15005 11.9997 2.76653 11.9997 0.000671387H11.9977C5.37125 0.00179639 -0.000244141 5.37391 -0.000244141 12.0007H6.26061V8.47516L9.78617 12.0007H11.9677C11.9784 11.99 11.9891 11.9793 11.9998 11.9686C11.9998 11.1601 11.9998 10.4387 11.9998 9.78714L8.47419 6.26153H11.9997Z" fill="#F0F0F0"/>
<path d="M6.07075 1.56586C4.19393 2.63456 2.63364 4.19484 1.56494 6.07167V12.0007H4.6954V4.69641V4.69631H11.9997C11.9997 3.70898 11.9997 2.76839 11.9997 1.56586H6.07075Z" fill="#D80027"/>
<path d="M11.9998 10.525L7.73641 6.2616H6.26074V6.26169L11.9997 12.0007H11.9998C11.9998 12.0007 11.9998 10.9832 11.9998 10.525Z" fill="#D80027"/>
<path d="M13.5656 7.82718V12.001C13.5656 14.7966 17.2177 15.6532 17.2177 15.6532C17.2177 15.6532 20.8699 14.7966 20.8699 12.001V7.82718L17.2177 6.78369L13.5656 7.82718Z" fill="#F3F3F3"/>
<path d="M20.8699 7.82625V6.26105H13.5656V7.82625H16.6959V10.9567H13.5656V12.0001C13.5656 12.0002 13.5656 12.0002 13.5656 12.0002L16.6959 12.0003V15.4923C17.0108 15.6037 17.2177 15.6524 17.2177 15.6524C17.2177 15.6524 17.4245 15.6038 17.7394 15.4923V12.0002H20.8699V12.0001V10.9567H17.7394V7.8262H20.8699V7.82625Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4671">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4653)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9672 12.0003H11.9993C11.9993 11.9895 11.9993 11.979 11.9993 11.9681C11.9886 11.9789 11.9779 11.9896 11.9672 12.0003Z" fill="#F0F0F0"/>
<path d="M11.9996 6.26074C11.9996 4.14925 11.9996 2.76574 11.9996 -0.00012207H11.9976C5.37113 0.00100293 -0.000366211 5.37311 -0.000366211 11.9999H6.26049V8.47436L9.78605 11.9999H11.9676C11.9783 11.9892 11.9889 11.9785 11.9997 11.9678C11.9997 11.1593 11.9997 10.438 11.9997 9.78635L8.47407 6.26074H11.9996Z" fill="#F0F0F0"/>
<path d="M6.07063 1.56494C4.1938 2.63364 2.63352 4.19393 1.56482 6.07075V11.9997H4.69527V4.69549V4.69539H11.9996C11.9996 3.70807 11.9996 2.76747 11.9996 1.56494H6.07063Z" fill="#D80027"/>
<path d="M11.9997 10.5243L7.73629 6.26093H6.26062V6.26102L11.9996 12H11.9997C11.9997 12 11.9997 10.9825 11.9997 10.5243Z" fill="#D80027"/>
<path d="M19.3046 14.0864V14.6081H15.1307V14.0864H13.5654V16.1733H14.6089V16.6951H19.8263V16.1733H20.8698V14.0864H19.3046Z" fill="#FFDA44"/>
<path d="M13.5654 6.26154V12.0007C13.5654 14.7963 17.2176 15.6528 17.2176 15.6528C17.2176 15.6528 20.8698 14.7963 20.8698 12.0007V6.26154H13.5654Z" fill="#338AF3"/>
<path d="M17.218 10.5428C16.305 10.5428 16.305 11.3776 15.392 11.3776C14.479 11.3776 14.479 10.5428 13.566 10.5428V12.0037C14.479 12.0037 14.479 12.8385 15.392 12.8385C16.305 12.8385 16.305 12.0037 17.218 12.0037C18.1311 12.0037 18.1311 12.8385 19.0442 12.8385C19.9573 12.8385 19.9573 12.0037 20.8704 12.0037V10.5428C19.9573 10.5428 19.9573 11.3776 19.0442 11.3776C18.1311 11.3776 18.1311 10.5428 17.218 10.5428Z" fill="#F3F3F3"/>
<path d="M17.2176 7.6181C16.3046 7.6181 16.3046 8.4529 15.3916 8.4529C14.4787 8.4529 14.4787 7.6181 13.5657 7.6181V9.07896C14.4787 9.07896 14.4787 9.91376 15.3916 9.91376C16.3046 9.91376 16.3046 9.07896 17.2176 9.07896C18.1307 9.07896 18.1307 9.91376 19.0438 9.91376C19.9569 9.91376 19.9569 9.07896 20.87 9.07896V7.6181C19.9569 7.6181 19.9569 8.4529 19.0438 8.4529C18.1307 8.4529 18.1307 7.6181 17.2176 7.6181Z" fill="#F3F3F3"/>
</g>
<defs>
<clipPath id="clip0_2087_4653">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5089)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"/>
<path d="M12.0003 5.21744L12.5182 6.81175H14.1947L12.8385 7.79711L13.3565 9.39138L12.0003 8.40606L10.644 9.39138L11.1621 7.79711L9.80591 6.81175H11.4823L12.0003 5.21744Z" fill="#F0F0F0"/>
<path d="M5.21741 11.9997L6.81172 11.4816V9.80518L7.79708 11.1615L9.39135 10.6434L8.40603 11.9997L9.39135 13.3558L7.79708 12.8377L6.81172 14.1939V12.5176L5.21741 11.9997Z" fill="#F0F0F0"/>
<path d="M12.0004 18.783L11.4823 17.1887H9.80591L11.1622 16.2033L10.6442 14.6091L12.0004 15.5944L13.3565 14.6091L12.8384 16.2033L14.1947 17.1887H12.5183L12.0004 18.783Z" fill="#F0F0F0"/>
<path d="M18.7829 11.9995L17.1886 12.5176V14.1939L16.2033 12.8377L14.609 13.3557L15.5943 11.9995L14.609 10.6434L16.2033 11.1615L17.1886 9.80518V11.4816L18.7829 11.9995Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5089">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4667)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.4782 12L23.8982 10.4348C23.8284 9.90131 23.7238 9.37875 23.5866 8.86959H10.9564V0.0456543C10.4239 0.0914981 9.90151 0.172545 9.39123 0.285701L7.30426 1.5652L6.26078 1.45987C5.71164 1.7595 5.18847 2.10075 4.69558 2.47945V8.86954H0.41331C0.276106 9.3787 0.171481 9.90126 0.101731 10.4347L0.521638 12L0.101685 13.5652C0.171435 14.0987 0.27606 14.6213 0.413263 15.1304H4.69553V21.5205C5.18842 21.8993 5.71164 22.2405 6.26073 22.5401L7.82593 22.4347L9.39114 23.7142C9.90146 23.8274 10.4239 23.9084 10.9563 23.9543V15.1305H23.5864C23.7236 14.6213 23.8283 14.0987 23.898 13.5652L23.4782 12Z" fill="#0052B4"/>
<path d="M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 11.9999C0 12.5304 0.034875 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4667">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const FR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4688)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z" fill="#D80027"/>
<path d="M0.000488281 12.0008C0.000488281 17.1604 3.25704 21.5589 7.8266 23.2544V0.747192C3.25704 2.44271 0.000488281 6.84122 0.000488281 12.0008Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4688">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4703)">
<path d="M23.2532 16.175C23.7356 14.875 23.9996 13.4689 23.9996 12.0011C23.9996 10.5332 23.7356 9.12721 23.2532 7.82718L11.9996 6.78369L0.746024 7.82718C0.263681 9.12721 -0.000366211 10.5332 -0.000366211 12.0011C-0.000366211 13.4689 0.263681 14.875 0.746024 16.175L11.9996 17.2184L23.2532 16.175Z" fill="#FFDA44"/>
<path d="M12.0004 23.9997C17.1599 23.9997 21.5585 20.7432 23.2539 16.1736H0.746704C2.44227 20.7432 6.84074 23.9997 12.0004 23.9997Z" fill="#0052B4"/>
<path d="M12.0004 0.000732422C6.84074 0.000732422 2.44227 3.25723 0.746704 7.82684H23.254C21.5585 3.25723 17.1599 0.000732422 12.0004 0.000732422Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4703">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GB2 = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4625)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4694 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4625">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GB = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5792)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M2.48069 4.69299C1.53808 5.91938 0.827311 7.3329 0.413452 8.86848H6.65617L2.48069 4.69299Z" fill="#0052B4"/>
<path d="M23.587 8.86861C23.1731 7.33308 22.4623 5.91957 21.5198 4.69318L17.3444 8.86861H23.587Z" fill="#0052B4"/>
<path d="M0.413452 15.1302C0.827359 16.6658 1.53812 18.0793 2.48069 19.3056L6.65603 15.1302H0.413452Z" fill="#0052B4"/>
<path d="M19.3056 2.47976C18.0792 1.53715 16.6657 0.826382 15.1301 0.412476V6.65515L19.3056 2.47976Z" fill="#0052B4"/>
<path d="M4.69397 21.5176C5.92036 22.4602 7.33388 23.171 8.86941 23.5849V17.3423L4.69397 21.5176Z" fill="#0052B4"/>
<path d="M8.86936 0.412476C7.33383 0.826382 5.92031 1.53715 4.69397 2.47971L8.86936 6.6551V0.412476Z" fill="#0052B4"/>
<path d="M15.1301 23.5849C16.6657 23.171 18.0792 22.4602 19.3055 21.5177L15.1301 17.3423V23.5849Z" fill="#0052B4"/>
<path d="M17.3444 15.1302L21.5198 19.3057C22.4623 18.0793 23.1731 16.6658 23.587 15.1302H17.3444Z" fill="#0052B4"/>
<path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"/>
<path d="M15.1304 15.1313L20.4852 20.4861C20.7315 20.2399 20.9664 19.9825 21.1906 19.7157L16.6061 15.1312H15.1304V15.1313Z" fill="#D80027"/>
<path d="M8.86951 15.1312H8.86941L3.51465 20.486C3.76084 20.7323 4.01823 20.9672 4.28504 21.1914L8.86951 16.6068V15.1312Z" fill="#D80027"/>
<path d="M8.86939 8.86911V8.86902L3.51458 3.51416C3.2683 3.76035 3.03336 4.01774 2.8092 4.28455L7.39372 8.86907H8.86939V8.86911Z" fill="#D80027"/>
<path d="M15.1304 8.87017L20.4852 3.51526C20.239 3.26898 19.9817 3.03405 19.7148 2.80994L15.1304 7.39445V8.87017Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5792">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GD = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4748)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M5.23633 2.08688C7.16219 0.770346 9.49084 -9.15527e-05 11.9998 -9.15527e-05C14.5087 -9.15527e-05 16.8374 0.770346 18.7632 2.08688L11.9998 2.6086L5.23633 2.08688Z" fill="#A2001D"/>
<path d="M12.0003 11.9995L11.2345 11.2336L11.0311 11.5979L12.0003 11.9995Z" fill="#0052B4"/>
<path d="M3.5152 3.51514C-1.17108 8.20142 -1.17108 15.7994 3.5152 20.4858C5.45175 18.5492 7.31423 16.6867 12.0005 12.0004L3.5152 3.51514Z" fill="#496E2D"/>
<path d="M20.4858 3.51591C25.1721 8.2022 25.1721 15.8002 20.4858 20.4865C18.5493 18.55 16.6868 16.6875 12.0005 12.0012L20.4858 3.51591Z" fill="#496E2D"/>
<path d="M12.0001 16.174C14.3052 16.174 16.174 14.3053 16.174 12.0002C16.174 9.69498 14.3052 7.82626 12.0001 7.82626C9.69489 7.82626 7.82617 9.69498 7.82617 12.0002C7.82617 14.3053 9.69489 16.174 12.0001 16.174Z" fill="#A2001D"/>
<path d="M11.9996 7.82639L12.9352 10.7059H15.9633L13.5137 12.4859L14.4492 15.3655L11.9996 13.5858L9.54996 15.3655L10.4857 12.4859L8.03613 10.7059H11.064L11.9996 7.82639Z" fill="#FFDA44"/>
<path d="M12.0043 -9.15527e-05H11.9963C8.68444 0.000986572 5.68627 1.34363 3.51562 3.51403H20.485C18.3143 1.34363 15.3161 0.000986572 12.0043 -9.15527e-05Z" fill="#A2001D"/>
<path d="M3.51611 20.4857C5.68764 22.6569 8.68736 23.9998 12.0007 23.9998C15.3141 23.9998 18.3138 22.6569 20.4853 20.4857H3.51611Z" fill="#A2001D"/>
<path d="M12.0004 1.30418L12.1947 1.90203H12.8233L12.3147 2.27154L12.509 2.86939L12.0004 2.49992L11.4918 2.86939L11.6861 2.27154L11.1775 1.90203H11.8061L12.0004 1.30418Z" fill="#FFDA44"/>
<path d="M9.09084 1.30418L9.28513 1.90203H9.91373L9.40518 2.27154L9.59948 2.86939L9.09084 2.49992L8.58234 2.86939L8.77658 2.27154L8.26794 1.90203H8.89654L9.09084 1.30418Z" fill="#FFDA44"/>
<path d="M14.91 1.30418L15.1043 1.90203H15.7329L15.2244 2.27154L15.4187 2.86939L14.91 2.49992L14.4015 2.86939L14.5958 2.27154L14.0872 1.90203H14.7158L14.91 1.30418Z" fill="#FFDA44"/>
<path d="M12.0004 21.1297L12.1947 21.7276H12.8233L12.3147 22.0971L12.509 22.6949L12.0004 22.3254L11.4918 22.6949L11.6861 22.0971L11.1775 21.7276H11.8061L12.0004 21.1297Z" fill="#FFDA44"/>
<path d="M9.09084 21.1297L9.28513 21.7276H9.91373L9.40518 22.0971L9.59948 22.6949L9.09084 22.3254L8.58234 22.6949L8.77658 22.0971L8.26794 21.7276H8.89654L9.09084 21.1297Z" fill="#FFDA44"/>
<path d="M14.91 21.1297L15.1043 21.7276H15.7329L15.2244 22.0971L15.4187 22.6949L14.91 22.3254L14.4015 22.6949L14.5958 22.0971L14.0872 21.7276H14.7158L14.91 21.1297Z" fill="#FFDA44"/>
<path d="M3.65676 11.802C3.96496 12.2889 3.82012 12.9335 3.33313 13.2418C2.8462 13.55 2.20157 13.4052 1.89332 12.9182C1.33527 12.0366 1.65885 10.5967 1.65885 10.5967C1.65885 10.5967 3.09866 10.9203 3.65676 11.802Z" fill="#FFDA44"/>
<path d="M3.05358 13.3225C3.34172 13.3225 3.5753 13.0889 3.5753 12.8007C3.5753 12.5126 3.34172 12.279 3.05358 12.279C2.76544 12.279 2.53186 12.5126 2.53186 12.8007C2.53186 13.0889 2.76544 13.3225 3.05358 13.3225Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4748">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4712)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"/>
<path d="M7.30428 5.73982V4.17457H5.73908V5.73982H4.17383V7.30502H5.73908V8.87022H7.30428V7.30502H8.86948V5.73982H7.30428Z" fill="#D80027"/>
<path d="M18.2608 5.73982V4.17457H16.6956V5.73982H15.1304V7.30502H16.6956V8.87022H18.2608V7.30502H19.826V5.73982H18.2608Z" fill="#D80027"/>
<path d="M7.30428 16.6967V15.1315H5.73908V16.6967H4.17383V18.2619H5.73908V19.8271H7.30428V18.2619H8.86948V16.6967H7.30428Z" fill="#D80027"/>
<path d="M18.2608 16.6967V15.1315H16.6956V16.6967H15.1304V18.2619H16.6956V19.8271H18.2608V18.2619H19.826V16.6967H18.2608Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4712">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4789)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z" fill="#D80027"/>
<path d="M15.3916 12.5219L16.1742 13.0436V10.9567L15.3916 11.4784H12.522V8.60884L13.0438 7.82626H10.9568L11.4786 8.60884V11.4784H8.60899L7.82642 10.9567V13.0436L8.60899 12.5219H11.4786V15.3915L10.9568 16.174H13.0438L12.522 15.3915V12.5219H15.3916Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4789">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4724)">
<path d="M0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 16.6948L23.2536 16.1731C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12522 23.2536 7.82523L12 7.30347L0.746391 7.82519C0.264047 9.12522 0 10.5313 0 11.9991Z" fill="#FFDA44"/>
<path d="M11.9998 -0.000948906C6.84025 -0.000948906 2.44173 3.25555 0.746216 7.82516H23.2535C21.5579 3.25555 17.1594 -0.000948906 11.9998 -0.000948906Z" fill="#D80027"/>
<path d="M23.2536 16.1741H0.746338C2.44185 20.7436 6.84037 24.0002 11.9999 24.0002C17.1595 24.0002 21.558 20.7436 23.2536 16.1741Z" fill="#496E2D"/>
<path d="M11.9998 7.82627L13.0358 11.0147H16.3886L13.6763 12.9855L14.7123 16.174L11.9998 14.2034L9.28741 16.174L10.3235 12.9855L7.61121 11.0147H10.9639L11.9998 7.82627Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4724">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4729)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F9F9F9"/>
<path d="M11.9999 24.0007C17.1594 24.0007 21.558 20.7442 23.2534 16.1746H0.746216C2.44178 20.7442 6.84025 24.0007 11.9999 24.0007Z" fill="#D80027"/>
<path d="M16.6955 9.91357V8.34837H17.2173V7.30488H16.1738V7.82665H15.1303V7.30488H14.0869V8.34837H14.6086V9.91357H13.5651V6.26149H14.0869V5.21806H13.0434V5.73968H12.5216V5.21806H11.4782V5.73968H10.9564V5.21806H9.91292V6.26149H10.4347V9.91357H9.3912V8.34837H9.91292V7.30488H8.86943V7.82665H7.82599V7.30488H6.78251V8.34837H7.30423V9.91357H6.26074V14.0875H17.739V9.91357H16.6955Z" fill="#D80027"/>
<path d="M11.9998 13.5651C11.1353 13.5651 10.4346 14.2659 10.4346 15.1303C10.4346 15.8117 10.8702 16.3913 11.478 16.6062V18.7826H9.91284V20.8695H12.5215V16.6062C13.1294 16.3913 13.565 15.8118 13.565 15.1304C13.565 14.266 12.8642 13.5651 11.9998 13.5651ZM11.9998 15.6521C11.7116 15.6521 11.478 15.4185 11.478 15.1304C11.478 14.8423 11.7116 14.6087 11.9998 14.6087C12.2879 14.6087 12.5215 14.8423 12.5215 15.1304C12.5215 15.4185 12.2879 15.6521 11.9998 15.6521Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4729">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4743)">
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z" fill="#F0F0F0"/>
<path d="M24.0004 12.0005C24.0004 18.6278 18.6277 24.0005 12.0004 24.0005C5.37299 24.0005 0.000366211 18.6278 0.000366211 12.0005" fill="#D80027"/>
<path d="M8.34754 17.7397C11.5172 17.7397 14.0867 15.1702 14.0867 12.0005C14.0867 8.83088 11.5172 6.26138 8.34754 6.26138C5.1779 6.26138 2.6084 8.83088 2.6084 12.0005C2.6084 15.1702 5.1779 17.7397 8.34754 17.7397Z" fill="#F0F0F0"/>
<path d="M2.6084 12.0005C2.6084 8.83098 5.1779 6.26138 8.34754 6.26138C11.5172 6.26138 14.0867 8.83093 14.0867 12.0005" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4743">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4707)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0004 0.000778198C7.0394 0.000778198 2.78183 3.01137 0.954224 7.30512H23.0466C21.219 3.01137 16.9614 0.000778198 12.0004 0.000778198Z" fill="#A2001D"/>
<path d="M12.0004 24.0007C16.9614 24.0007 21.219 20.9901 23.0466 16.6964H0.954224C2.78183 20.9901 7.0394 24.0007 12.0004 24.0007Z" fill="#496E2D"/>
<path d="M23.5865 8.8696H0.413269C0.144253 9.86771 -0.00012207 10.9169 -0.00012207 12.0001C-0.00012207 13.0832 0.144253 14.1324 0.413269 15.1305H23.5865C23.8555 14.1324 23.9999 13.0832 23.9999 12.0001C23.9999 10.9169 23.8555 9.86771 23.5865 8.8696Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4707">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4800)">
<path d="M16.1744 0.746376C14.8744 0.263986 13.4683 -6.10352e-05 12.0004 -6.10352e-05C10.5326 -6.10352e-05 9.12651 0.263986 7.82657 0.746283L7.30481 11.9999L7.82653 23.2536C9.12651 23.7359 10.5326 23.9999 12.0004 23.9999C13.4683 23.9999 14.8744 23.7359 16.1744 23.2535L16.6961 11.9999L16.1744 0.746376Z" fill="#FFDA44"/>
<path d="M0 12.0003C0 17.1598 3.2565 21.5584 7.82611 23.2539V0.746643C3.2565 2.44221 0 6.84067 0 12.0003Z" fill="#D80027"/>
<path d="M23.9996 12.0003C23.9996 6.84067 20.7431 2.44221 16.1735 0.746643V23.2539C20.7431 21.5584 23.9996 17.1598 23.9996 12.0003Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4800">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GQ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4628)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M7.30462 7.8258H23.2538C21.5584 3.25619 17.1598 -0.000305176 12.0003 -0.000305176C8.68649 -0.000305176 5.68682 1.34309 3.51538 3.5148L7.30462 7.8258Z" fill="#6DA544"/>
<path d="M7.30462 16.1742H23.2538C21.5584 20.7438 17.1598 24.0003 12.0003 24.0003C8.68649 24.0003 5.68682 22.6569 3.51538 20.4852L7.30462 16.1742Z" fill="#D80027"/>
<path d="M3.5152 3.5155C-1.17108 8.20178 -1.17108 15.7998 3.5152 20.4861C5.45175 18.5496 7.31423 16.6871 12.0005 12.0008L3.5152 3.5155Z" fill="#0052B4"/>
<path d="M14.087 9.91272V12.5214C14.087 14.1189 16.174 14.6084 16.174 14.6084C16.174 14.6084 18.261 14.1189 18.261 12.5214V9.91272H14.087Z" fill="#DEDDE0"/>
<path d="M16.6953 12.0523H15.6519V13.5653H16.6953V12.0523Z" fill="#786145"/>
<path d="M17.2176 11.4789C17.2176 10.9025 16.7504 10.4354 16.1741 10.4354C15.5978 10.4354 15.1306 10.9025 15.1306 11.4789C14.8425 11.4789 14.6089 11.7124 14.6089 12.0006C14.6089 12.2887 14.8425 12.5223 15.1306 12.5223C15.3017 12.5223 17.0465 12.5223 17.2176 12.5223C17.5057 12.5223 17.7393 12.2887 17.7393 12.0006C17.7393 11.7124 17.5058 11.4789 17.2176 11.4789Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4628">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4735)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9996 8.87002H23.5862C23.2854 7.75373 22.828 6.70181 22.2384 5.73956H11.9996V8.87002Z" fill="#338AF3"/>
<path d="M4.53058 21.3914H19.4702C20.5654 20.5192 21.5046 19.4597 22.2391 18.261H1.76172C2.4963 19.4596 3.43548 20.5192 4.53058 21.3914Z" fill="#338AF3"/>
<path d="M4.17433 2.90377C3.23092 3.71616 2.41534 4.67283 1.76172 5.73952H4.17433V2.90377Z" fill="#338AF3"/>
<path d="M12.0001 12C12.0001 10.7777 12.0001 9.75471 12.0001 8.86952H7.30447V12H4.17401V8.86952H0.413513C0.144497 9.86768 0.00012207 10.9168 0.00012207 12C0.00012207 13.0831 0.144497 14.1323 0.413513 15.1304H23.5868C23.8557 14.1323 24.0001 13.0831 24.0001 12H12.0001Z" fill="#338AF3"/>
<path d="M12.0005 0.000686646C10.3341 0.000686646 8.74715 0.340671 7.30481 0.954499V5.73983H12.0005C12.0005 4.64708 12.0005 3.71769 12.0005 2.60937H19.4703C17.4204 0.976812 14.8246 0.000686646 12.0005 0.000686646Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_4735">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4782)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9992 12.0003C23.9992 7.24276 21.2305 3.13201 17.2166 1.19101V22.8095C21.2305 20.8686 23.9992 16.7578 23.9992 12.0003Z" fill="#338AF3"/>
<path d="M-0.000366211 12.0001C-0.000366211 16.7576 2.76831 20.8684 6.78226 22.8094V1.19083C2.76831 3.13183 -0.000366211 7.24258 -0.000366211 12.0001Z" fill="#338AF3"/>
<path d="M15.1355 14.0284L13.1065 11.9994L15.0379 10.0679L14.9503 9.04781L14.3974 8.49478L11.9997 10.8925L9.60191 8.49478L9.04897 9.04781L8.96146 10.0679L10.8928 11.9994L8.86377 14.0284L9.97058 15.1351L11.9997 13.1062L14.0287 15.1351L15.1355 14.0284Z" fill="#ACABB1"/>
<path d="M14.9516 9.04898L13.8448 10.1557C14.3169 10.6278 14.6089 11.28 14.6089 12.0004C14.6089 13.4411 13.4409 14.6091 12.0002 14.6091C10.5595 14.6091 9.3915 13.4411 9.3915 12.0004C9.3915 11.28 9.68353 10.6278 10.1556 10.1557L9.04884 9.04898C8.29345 9.80423 7.82629 10.8477 7.82629 12.0004C7.82629 14.3056 9.69501 16.1743 12.0002 16.1743C14.3054 16.1743 16.1741 14.3055 16.1741 12.0004C16.1741 10.8478 15.7069 9.80428 14.9516 9.04898Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4782">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4771)">
<path d="M5.23633 21.9123C7.16214 23.2288 9.49089 23.9993 11.9998 23.9993C14.5087 23.9993 16.8374 23.2288 18.7632 21.9123L11.9998 20.8688L5.23633 21.9123Z" fill="#D80027"/>
<path d="M18.7641 2.08688C16.8382 0.770392 14.5095 -9.15527e-05 12.0006 -9.15527e-05C9.49174 -9.15527e-05 7.16299 0.770392 5.23718 2.08688L12.0006 3.13036L18.7641 2.08688Z" fill="#D80027"/>
<path d="M23.9996 12.0004C23.9996 8.02965 21.6223 4.042 18.7631 2.0874H5.23618C2.07479 4.24853 -0.000366211 7.882 -0.000366211 12.0004C-0.000366211 16.119 2.07479 19.7523 5.23618 21.9135H18.7631C21.9245 19.7523 23.9996 16.119 23.9996 12.0004Z" fill="#0052B4"/>
<path d="M11.3208 19.5749C11.1568 19.4342 7.3042 16.0851 7.3042 12C7.3042 7.91489 11.1568 4.56572 11.3208 4.42514L11.9999 3.84305L12.6789 4.42509C12.8429 4.56572 16.6955 7.91484 16.6955 12C16.6955 16.0852 12.843 19.4343 12.6789 19.5749L11.9999 20.157L11.3208 19.5749Z" fill="#D80027"/>
<path d="M15.6524 12C15.6524 8.3478 12.0002 5.21735 12.0002 5.21735C12.0002 5.21735 8.34802 8.34789 8.34802 12C8.34802 13.1172 8.69007 14.1855 9.16454 15.1304H14.8359C15.3103 14.1855 15.6524 13.1172 15.6524 12Z" fill="#338AF3"/>
<path d="M15.6524 12.0005C15.6524 13.1177 15.3103 14.186 14.8359 15.1309L12.0002 15.6526L9.16454 15.1309C8.69007 14.186 8.34802 13.1177 8.34802 12.0005H15.6524Z" fill="#0052B4"/>
<path d="M12.0001 18.7824C12.0001 18.7824 13.7592 17.2741 14.8357 15.1302H9.16443C10.241 17.2741 12.0001 18.7824 12.0001 18.7824Z" fill="#FFDA44"/>
<path d="M9.65161 9.91257H14.3473L11.9994 12.2604L9.65161 9.91257Z" fill="#6DA544"/>
<path d="M12.7827 11.4773H11.2175V16.1729H12.7827V11.4773Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4771">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4793)">
<path d="M11.9996 -9.15527e-05C10.9165 -9.15527e-05 9.86723 0.144283 8.86912 0.413299L7.82568 11.9999L8.86917 23.5865C9.86723 23.8555 10.9165 23.9999 11.9996 23.9999C18.6269 23.9999 23.9996 18.6273 23.9996 11.9999C23.9996 5.37253 18.6269 -9.15527e-05 11.9996 -9.15527e-05Z" fill="#FFDA44"/>
<path d="M7.82568 12.0005L8.86917 23.5871C9.86723 23.8561 10.9165 24.0005 11.9996 24.0005C18.6269 24.0005 23.9996 18.6278 23.9996 12.0005H7.82568Z" fill="#6DA544"/>
<path d="M0 11.9995C0 16.5481 2.53078 20.5052 6.26086 22.5405V1.45862C2.53078 3.49384 0 7.45102 0 11.9995Z" fill="#D80027"/>
<path d="M0.00012207 11.9995C0.00012207 17.5438 3.76048 22.2091 8.86967 23.5861V0.412903C3.76048 1.7899 0.00012207 6.45518 0.00012207 11.9995Z" fill="#D80027"/>
<path d="M4.53456 8.86835L5.31151 11.2597H7.82617L5.79189 12.7378L6.56879 15.1293L4.53456 13.6512L2.50023 15.1293L3.27732 12.7378L1.24304 11.2597H3.75756L4.53456 8.86835Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4793">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const GY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4804)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12 -0.000976562C9.87837 -0.000976562 7.88581 0.550367 6.15649 1.51646V22.4816C7.88585 23.4477 9.87837 23.999 12 23.999C18.6274 23.999 24 18.6264 24 11.999C24 5.37165 18.6274 -0.000976562 12 -0.000976562Z" fill="#6DA544"/>
<path d="M6.1919 1.49817C5.43698 1.91653 4.73208 2.41378 4.08806 2.97909C4.15317 2.922 4.21893 2.86556 4.28522 2.80987L13.4758 12.0005L4.28517 21.1911C4.21884 21.1354 4.15312 21.0789 4.08801 21.0218C4.73203 21.5872 5.43698 22.0844 6.19186 22.5028L24.0001 12.0005L6.1919 1.49817Z" fill="#F0F0F0"/>
<path d="M5.17825 2.12689C4.81229 2.3803 4.46082 2.65297 4.1259 2.94439L12 11.9996L4.12585 21.0548C4.46078 21.3463 4.81225 21.619 5.1782 21.8723L21.9458 11.9996L5.17825 2.12689Z" fill="#FFDA44"/>
<path d="M4.28492 2.80988C4.01815 3.03403 3.76071 3.26902 3.51453 3.51516L10.9564 12.0005L3.51453 20.4858C3.76071 20.732 4.0181 20.967 4.28492 21.1911L13.4755 12.0005L4.28492 2.80988Z" fill="black"/>
<path d="M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31375 16.6859 12 11.9996L3.51471 3.51428Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4804">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const HK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4830)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M13.2391 9.07758C12.9664 10.2119 12.4818 9.99558 12.244 10.9848C10.8433 10.648 9.98058 9.23944 10.3174 7.83858C10.654 6.43781 12.0628 5.57512 13.4636 5.91192C12.9879 7.89037 13.4831 8.06306 13.2391 9.07758Z" fill="#F0F0F0"/>
<path d="M9.6042 9.91761C10.5987 10.5275 10.2432 10.9215 11.1105 11.4534C10.3573 12.6816 8.75117 13.0667 7.52295 12.3135C6.29478 11.5604 5.9096 9.95412 6.66279 8.72595C8.39745 9.78964 8.71456 9.37212 9.6042 9.91761Z" fill="#F0F0F0"/>
<path d="M9.27995 13.635C10.1673 12.8776 10.4321 13.3374 11.206 12.6769C12.1414 13.7727 12.0113 15.4194 10.9155 16.3548C9.81967 17.2901 8.17304 17.1599 7.23779 16.0642C8.78532 14.7431 8.48621 14.3124 9.27995 13.635Z" fill="#F0F0F0"/>
<path d="M12.7151 15.0916C12.2689 14.0136 12.7881 13.9037 12.399 12.9637C13.7303 12.4128 15.2561 13.0453 15.8071 14.3765C16.358 15.7077 15.7254 17.2336 14.3942 17.7845C13.6162 15.9044 13.1142 16.0558 12.7151 15.0916Z" fill="#F0F0F0"/>
<path d="M15.162 12.274C13.9989 12.3653 14.0547 11.8375 13.0406 11.917C12.9279 10.4808 14.0011 9.22501 15.4374 9.11228C16.8736 8.99982 18.1294 10.0729 18.242 11.5092C16.2134 11.6683 16.2022 12.1925 15.162 12.274Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4830">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const HN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4820)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0002 23.9987C16.7577 23.9987 20.8685 21.23 22.8095 17.2161H1.19092C3.13192 21.23 7.24267 23.9987 12.0002 23.9987Z" fill="#338AF3"/>
<path d="M12.0009 -0.000976562C7.2434 -0.000976562 3.13265 2.7677 1.19165 6.78165H22.8102C20.8692 2.7677 16.7584 -0.000976562 12.0009 -0.000976562Z" fill="#338AF3"/>
<path d="M7.38553 7.8244L7.77403 9.02014H9.03126L8.01417 9.75907L8.40272 10.9548L7.38553 10.2158L6.36834 10.9548L6.75689 9.75907L5.73975 9.02014H6.99698L7.38553 7.8244Z" fill="#338AF3"/>
<path d="M7.38553 13.0425L7.77403 14.2383H9.03126L8.01417 14.9772L8.40272 16.1729L7.38553 15.4339L6.36834 16.1729L6.75689 14.9772L5.73975 14.2383H6.99698L7.38553 13.0425Z" fill="#338AF3"/>
<path d="M16.6151 7.8244L17.0037 9.02014H18.2609L17.2438 9.75907L17.6323 10.9548L16.6151 10.2158L15.598 10.9548L15.9865 9.75907L14.9694 9.02014H16.2266L16.6151 7.8244Z" fill="#338AF3"/>
<path d="M16.6151 13.0425L17.0037 14.2383H18.2609L17.2438 14.9772L17.6323 16.1729L16.6151 15.4339L15.598 16.1729L15.9865 14.9772L14.9694 14.2383H16.2266L16.6151 13.0425Z" fill="#338AF3"/>
<path d="M12 10.4333L12.3886 11.6291H13.6458L12.6287 12.3681L13.0172 13.5638L12 12.8248L10.9828 13.5638L11.3714 12.3681L10.3542 11.6291H11.6115L12 10.4333Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_4820">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const HR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4500)">
<path d="M24 12C24 10.5321 23.736 9.12601 23.2536 7.82607L12 7.30431L0.746391 7.82602C0.264047 9.12601 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1738L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z" fill="#F0F0F0"/>
<path d="M11.9999 23.9994C17.1595 23.9994 21.558 20.7429 23.2536 16.1733H0.746338C2.44185 20.7429 6.84037 23.9994 11.9999 23.9994Z" fill="#0052B4"/>
<path d="M0.746216 7.82669H23.2535C21.5579 3.25708 17.1594 0.000579834 11.9998 0.000579834C6.84025 0.000579834 2.44173 3.25708 0.746216 7.82669Z" fill="#D80027"/>
<path d="M15.1302 8.34753H13.0432L13.3911 5.7388L14.7823 4.69531L16.1736 5.7388V7.82576L15.1302 8.34753Z" fill="#338AF3"/>
<path d="M8.86924 8.34803H10.9562L10.6083 5.7393L9.21705 4.69582L7.82581 5.7393V7.82627L8.86924 8.34803Z" fill="#338AF3"/>
<path d="M13.3908 8.34781H10.6082V5.73907L11.9995 4.69559L13.3908 5.73907V8.34781Z" fill="#0052B4"/>
<path d="M7.82581 7.82573V13.5648C7.82581 14.9314 8.4859 16.1466 9.50403 16.9085L10.2345 16.7257L11.1562 17.653C11.4288 17.7092 11.7109 17.7388 11.9997 17.7388C12.2871 17.7388 12.5677 17.7096 12.8389 17.654L13.8911 16.7779L14.4954 16.9068C15.5131 16.145 16.1736 14.931 16.1736 13.5648V7.82573H7.82581Z" fill="#F0F0F0"/>
<path d="M9.4956 7.82591H7.82605V9.49546H9.4956V7.82591Z" fill="#D80027"/>
<path d="M12.8348 7.82591H11.1653V9.49546H12.8348V7.82591Z" fill="#D80027"/>
<path d="M16.1742 7.82591H14.5046V9.49546H16.1742V7.82591Z" fill="#D80027"/>
<path d="M11.1648 9.49496H9.49524V11.1645H11.1648V9.49496Z" fill="#D80027"/>
<path d="M14.504 9.49496H12.8345V11.1645H14.504V9.49496Z" fill="#D80027"/>
<path d="M9.4956 11.1638H7.82605V12.8334H9.4956V11.1638Z" fill="#D80027"/>
<path d="M11.1648 12.8346H9.49524V14.5042H11.1648V12.8346Z" fill="#D80027"/>
<path d="M12.8348 11.1638H11.1653V12.8334H12.8348V11.1638Z" fill="#D80027"/>
<path d="M16.1742 11.1638H14.5046V12.8334H16.1742V11.1638Z" fill="#D80027"/>
<path d="M14.504 12.8346H12.8345V14.5042H14.504V12.8346Z" fill="#D80027"/>
<path d="M12.8348 14.5039H11.1653V16.1734H12.8348V14.5039Z" fill="#D80027"/>
<path d="M9.49542 14.5039H7.93359C8.07684 15.1245 8.35847 15.6924 8.74462 16.1734H9.49542V14.5039Z" fill="#D80027"/>
<path d="M14.5046 16.1736H15.2554C15.6416 15.6926 15.9232 15.1246 16.0664 14.5041H14.5046V16.1736Z" fill="#D80027"/>
<path d="M9.49524 16.1731V16.9016C9.98082 17.267 10.5483 17.529 11.1648 17.6547V16.1731H9.49524Z" fill="#D80027"/>
<path d="M12.8345 16.1731V17.6547C13.451 17.5291 14.0184 17.267 14.504 16.9016V16.1731H12.8345Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4500">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const HT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4811)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 5.37262 12 0 12 0C12 0 24 5.37262 24 12Z" fill="#A2001D"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#0052B4"/>
<path d="M16.1736 15.1305L11.9997 14.6088L7.82581 15.1305V8.86963H16.1736V15.1305Z" fill="#F0F0F0"/>
<path d="M11.9998 14.6083C13.1524 14.6083 14.0868 13.6739 14.0868 12.5213C14.0868 11.3687 13.1524 10.4343 11.9998 10.4343C10.8472 10.4343 9.91284 11.3687 9.91284 12.5213C9.91284 13.6739 10.8472 14.6083 11.9998 14.6083Z" fill="#0052B4"/>
<path d="M12.0003 13.5651C12.5766 13.5651 13.0438 13.0979 13.0438 12.5216C13.0438 11.9453 12.5766 11.4781 12.0003 11.4781C11.424 11.4781 10.9568 11.9453 10.9568 12.5216C10.9568 13.0979 11.424 13.5651 12.0003 13.5651Z" fill="#A2001D"/>
<path d="M10.4348 9.91327H13.5652L12 11.4785L10.4348 9.91327Z" fill="#6DA544"/>
<path d="M12.5221 10.9556H11.4786V14.086H12.5221V10.9556Z" fill="#FFDA44"/>
<path d="M13.6692 13.7745H10.3301L7.82581 15.1311H16.1736L13.6692 13.7745Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4811">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const HU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4838)">
<path d="M0.746024 7.82522C0.263681 9.12525 -0.000366211 10.5313 -0.000366211 11.9991C-0.000366211 13.467 0.263681 14.8731 0.746024 16.173L11.9996 17.2165L23.2532 16.173C23.7356 14.8731 23.9996 13.467 23.9996 11.9991C23.9996 10.5313 23.7356 9.12525 23.2532 7.82522L11.9996 6.78174L0.746024 7.82522Z" fill="#F0F0F0"/>
<path d="M12.0004 -0.000976562C6.84086 -0.000976562 2.44229 3.25552 0.746826 7.82513H23.2541C21.5585 3.25552 17.16 -0.000976562 12.0004 -0.000976562Z" fill="#D80027"/>
<path d="M12.0004 23.9993C17.16 23.9993 21.5585 20.7428 23.254 16.1732H0.746826C2.44229 20.7428 6.84086 23.9993 12.0004 23.9993Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4838">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ID = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4857)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4857">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4873)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9996 11.999C23.9996 6.83951 20.7431 2.44095 16.1735 0.745483V23.2527C20.7431 21.5571 23.9996 17.1587 23.9996 11.999Z" fill="#FF9811"/>
<path d="M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44156 0 6.84013 0 11.9997Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4873">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4880)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M16.5181 9.39207H13.5057L11.9996 6.78339L10.4936 9.39207H7.4812L8.98748 12.0008L7.4812 14.6094H10.4936L11.9996 17.2181L13.5057 14.6094H16.5181L15.0118 12.0008L16.5181 9.39207ZM13.85 12.0008L12.9249 13.6033H11.0745L10.1492 12.0008L11.0745 10.3982H12.9248L13.85 12.0008ZM11.9996 8.79559L12.344 9.39203H11.6554L11.9996 8.79559ZM9.22397 10.3982H9.91266L9.56831 10.9946L9.22397 10.3982ZM9.22397 13.6033L9.56836 13.0069L9.9127 13.6033H9.22397ZM11.9996 15.2059L11.6553 14.6094H12.344L11.9996 15.2059ZM14.7753 13.6033H14.0866L14.431 13.0069L14.7753 13.6033ZM14.0866 10.3982H14.7753L14.4309 10.9946L14.0866 10.3982Z" fill="#0052B4"/>
<path d="M19.4697 2.60905H4.52997C3.43483 3.4813 2.49564 4.54077 1.76111 5.73951H22.2385C21.504 4.54082 20.5648 3.4813 19.4697 2.60905Z" fill="#0052B4"/>
<path d="M4.52997 21.3914H19.4696C20.5648 20.5191 21.504 19.4597 22.2385 18.2609H1.76111C2.49569 19.4596 3.43487 20.5191 4.52997 21.3914Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4880">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4877)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M16.4434 8.04392L15.5953 11.0707L13.0504 10.6008L11.4123 7.22412L6.98702 8.79448L6.63804 7.81104L5.48022 7.6684L6.35262 10.1269L9.39804 9.34812L10.2635 11.787L8.15824 14.8939L11.7309 17.9411L11.0538 18.735L11.5091 19.8091L13.2021 17.8242L11.0049 15.5763L12.6843 13.6074L16.4276 13.8771L17.2803 9.25943L18.3064 9.44895L19.009 8.51754L16.4434 8.04392Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4877">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4850)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0001 -0.000976562C7.24255 -0.000976562 3.1318 2.7677 1.1908 6.78165H22.8093C20.8684 2.7677 16.7576 -0.000976562 12.0001 -0.000976562Z" fill="#FF9811"/>
<path d="M12.0001 23.9997C16.7576 23.9997 20.8684 21.231 22.8094 17.217H1.1908C3.1318 21.231 7.24254 23.9997 12.0001 23.9997Z" fill="#6DA544"/>
<path d="M12.0003 16.1732C14.3055 16.1732 16.1742 14.3044 16.1742 11.9993C16.1742 9.69409 14.3055 7.82538 12.0003 7.82538C9.69513 7.82538 7.82642 9.69409 7.82642 11.9993C7.82642 14.3044 9.69513 16.1732 12.0003 16.1732Z" fill="#0052B4"/>
<path d="M12.0002 14.6081C13.4409 14.6081 14.6088 13.4401 14.6088 11.9994C14.6088 10.5586 13.4409 9.39069 12.0002 9.39069C10.5594 9.39069 9.39148 10.5586 9.39148 11.9994C9.39148 13.4401 10.5594 14.6081 12.0002 14.6081Z" fill="#F0F0F0"/>
<path d="M12.0003 8.78088L12.8051 10.6061L14.7881 10.3904L13.6099 12L14.7881 13.6095L12.8051 13.3939L12.0003 15.2191L11.1955 13.3939L9.21252 13.6095L10.3908 12L9.21252 10.3904L11.1955 10.6061L12.0003 8.78088Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4850">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4283)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M21.9999 13.4358C20.9999 13.4358 20.9999 12.5214 19.9998 12.5214C18.9999 12.5214 18.9999 13.4358 17.9999 13.4358C17 13.4358 16.9999 12.5214 16 12.5214C15 12.5214 15 13.4358 14 13.4358C13 13.4358 12.9999 12.5214 11.9998 12.5214C10.9998 12.5214 10.9998 13.4358 9.99991 13.4358C9.00006 13.4358 9.00006 12.5214 8.00008 12.5214C7 12.5214 7 13.4358 5.99992 13.4358C4.99984 13.4358 4.99984 12.5214 3.99977 12.5214C2.99992 12.5214 2.99992 13.4358 1.99994 13.4358C1.00534 13.4358 0.999578 12.5315 0.015625 12.5218C0.0433281 13.0707 0.108859 13.6096 0.207953 14.1366C1.00502 14.2537 1.07481 15.0357 2.00003 15.0357C3.00002 15.0357 3.00002 14.1215 3.99986 14.1215C4.99994 14.1215 4.99994 15.0357 6.00002 15.0357C7.00009 15.0357 7.00009 14.1215 8.00017 14.1215C9.00016 14.1215 9.00016 15.0357 10 15.0357C11 15.0357 11 14.1215 11.9999 14.1215C13 14.1215 13 15.0357 14.0001 15.0357C15.0002 15.0357 15.0002 14.1215 16.0001 14.1215C17.0001 14.1215 17.0001 15.0357 18 15.0357C19 15.0357 19 14.1215 19.9999 14.1215C21 14.1215 21 15.0357 22 15.0357C22.9252 15.0357 22.995 14.2537 23.7921 14.1366C23.8913 13.6096 23.9567 13.0708 23.9845 12.5218C23.0004 12.5315 22.9945 13.4358 21.9999 13.4358Z" fill="#0052B4"/>
<path d="M19.9999 15.6514C18.9999 15.6514 18.9999 16.5657 18 16.5657C17 16.5657 17 15.6514 16.0001 15.6514C15.0001 15.6514 15.0001 16.5657 14 16.5657C13 16.5657 13 15.6514 11.9999 15.6514C10.9999 15.6514 10.9999 16.5657 9.99997 16.5657C9.00012 16.5657 9.00013 15.6514 8.00014 15.6514C7.00006 15.6514 7.00006 16.5657 5.99998 16.5657C4.99991 16.5657 4.99991 15.6514 3.99983 15.6514C2.99999 15.6514 2.99999 16.5657 2 16.5657C1.26336 16.5657 1.06888 16.0699 0.617798 15.8087C0.890985 16.6252 1.24981 17.4024 1.68317 18.13C1.77702 18.1527 1.88136 18.1657 1.99995 18.1657C2.99994 18.1657 2.99994 17.2515 3.99978 17.2515C4.99986 17.2515 4.99986 18.1657 5.99994 18.1657C7.00002 18.1657 7.00002 17.2515 8.00009 17.2515C9.00008 17.2515 9.00008 18.1657 9.99992 18.1657C10.9999 18.1657 10.9999 17.2515 11.9998 17.2515C12.9999 17.2515 12.9999 18.1657 14 18.1657C15.0001 18.1657 15.0001 17.2515 16 17.2515C17 17.2515 17 18.1657 17.9999 18.1657C18.9999 18.1657 18.9999 17.2515 19.9999 17.2515C20.9999 17.2515 20.9999 18.1657 21.9999 18.1657C22.1186 18.1657 22.223 18.1527 22.3169 18.13C22.7503 17.4024 23.1091 16.6252 23.3822 15.8087C22.9311 16.0699 22.7366 16.5658 21.9999 16.5658C21 16.5657 21 15.6514 19.9999 15.6514Z" fill="#0052B4"/>
<path d="M23.7209 9.41946C22.9899 9.57119 22.8967 10.306 21.9999 10.306C20.9999 10.306 20.9999 9.39166 19.9999 9.39166C18.9999 9.39166 18.9999 10.306 18 10.306C17.0001 10.306 17 9.39166 16.0001 9.39166C15.0001 9.39166 15.0001 10.306 14.0001 10.306C13 10.306 13 9.39166 11.9999 9.39166C11.4596 9.39166 11.2111 9.65857 10.9392 9.904V11.504C11.2111 11.2586 11.4595 10.9917 11.9999 10.9917C13 10.9917 13 11.906 14.0001 11.906C15.0001 11.906 15.0001 10.9917 16.0001 10.9917C17.0001 10.9917 17.0001 11.906 18 11.906C18.9999 11.906 19 10.9917 19.9999 10.9917C21 10.9917 21 11.906 21.9999 11.906C22.9252 11.906 22.995 11.124 23.7921 11.0069C23.8432 11.0069 23.9003 11.0064 23.9587 11.0057C23.9144 10.466 23.8343 9.93654 23.7209 9.41946Z" fill="#0052B4"/>
<path d="M22.8443 6.85724C22.6371 7.03129 22.3975 7.17585 21.9999 7.17585C20.9999 7.17585 20.9999 6.26151 19.9999 6.26151C18.9999 6.26151 18.9999 7.17585 18 7.17585C17.0001 7.17585 17 6.26151 16.0001 6.26151C15.0001 6.26151 15.0001 7.17585 14.0001 7.17585C13 7.17585 13 6.26151 11.9999 6.26151C11.4596 6.26151 11.2111 6.52841 10.9392 6.77385V8.37383C11.2111 8.12844 11.4595 7.86158 11.9999 7.86158C13 7.86158 13 8.77583 14.0001 8.77583C15 8.77583 15 7.86158 16 7.86158C17 7.86158 17 8.77583 17.9999 8.77583C18.9999 8.77583 18.9999 7.86158 19.9999 7.86158C20.9999 7.86158 20.9999 8.77583 21.9999 8.77583C22.7094 8.77583 22.9161 8.31622 23.3333 8.04894C23.1911 7.64127 23.0279 7.24354 22.8443 6.85724Z" fill="#0052B4"/>
<path d="M20.0854 3.13263C20.0576 3.13113 20.0294 3.13019 20 3.13019C19 3.13019 19 4.04453 18 4.04453C17.0001 4.04453 17.0001 3.13019 16.0001 3.13019C15.0001 3.13019 15.0001 4.04453 14.0001 4.04453C13 4.04453 13 3.13019 11.9999 3.13019C11.4596 3.13019 11.2111 3.39709 10.9392 3.64253V5.24252C11.2111 4.99713 11.4595 4.73027 11.9999 4.73027C13 4.73027 13 5.64452 14.0001 5.64452C15.0001 5.64452 15.0001 4.73027 16.0001 4.73027C17.0001 4.73027 17.0001 5.64452 18 5.64452C18.9999 5.64452 19 4.73027 19.9999 4.73027C21 4.73027 21 5.64452 21.9999 5.64452C22.0615 5.64452 22.119 5.64086 22.1735 5.63435C21.5927 4.70791 20.8894 3.86617 20.0854 3.13263Z" fill="#0052B4"/>
<path d="M15.0671 0.396226C14.7926 0.643163 14.5445 0.914382 13.9999 0.914382C12.9998 0.914382 12.9998 0.000131897 11.9998 3.8147e-05H11.9996C11.4825 8.5022e-05 11.2328 0.244632 10.9739 0.480835V2.08087C11.2328 1.84466 11.4825 1.60007 11.9998 1.60007C12.9999 1.60007 12.9999 2.51432 13.9999 2.51432C15 2.51432 15 1.60007 16 1.60007C16.9999 1.60007 16.9999 2.51432 17.9999 2.51432C18.4194 2.51432 18.6628 2.35326 18.8781 2.16641C17.7373 1.36696 16.4512 0.761054 15.0671 0.396226Z" fill="#0052B4"/>
<path d="M14.0004 22.8273C13.0003 22.8273 13.0003 21.9129 12.0003 21.9129C11.0003 21.9129 11.0003 22.8273 10.0003 22.8273C9.00049 22.8273 9.00049 21.9129 8.00051 21.9129C7.23452 21.9129 7.05485 22.4489 6.5636 22.7C7.91829 23.3898 9.42143 23.8294 11.0124 23.9591C11.2584 23.7343 11.5084 23.5129 12.0003 23.5129C12.4923 23.5129 12.7422 23.7343 12.9883 23.9592C14.5793 23.8295 16.0826 23.3898 17.4373 22.7001C16.9459 22.449 16.7663 21.9129 16.0004 21.9129C15.0005 21.9129 15.0005 22.8273 14.0004 22.8273Z" fill="#0052B4"/>
<path d="M18.0001 19.6976C17.0002 19.6976 17.0002 18.7833 16.0002 18.7833C15.0002 18.7833 15.0002 19.6976 14.0002 19.6976C13.0001 19.6976 13.0001 18.7833 12.0001 18.7833C11.0001 18.7833 11.0001 19.6976 10.0001 19.6976C9.00028 19.6976 9.00028 18.7833 8.0003 18.7833C7.00022 18.7833 7.00022 19.6976 6.00014 19.6976C5.00007 19.6976 5.00007 18.7833 3.99999 18.7833C3.28088 18.7833 3.07894 19.2563 2.65027 19.5218C2.91896 19.8555 3.20461 20.1749 3.50691 20.4777C3.64233 20.4198 3.80124 20.3833 3.99994 20.3833C5.00002 20.3833 5.00002 21.2976 6.0001 21.2976C7.00017 21.2976 7.00018 20.3833 8.00025 20.3833C9.00024 20.3833 9.00024 21.2976 10.0001 21.2976C11.0001 21.2976 11.0001 20.3833 12 20.3833C13.0001 20.3833 13.0001 21.2976 14.0002 21.2976C15.0002 21.2976 15.0002 20.3833 16.0002 20.3833C17.0001 20.3833 17.0002 21.2976 18.0001 21.2976C19 21.2976 19.0001 20.3833 20 20.3833C20.199 20.3833 20.3579 20.4198 20.4934 20.4778C20.7957 20.1749 21.0814 19.8555 21.3501 19.5219C20.9213 19.2564 20.7194 18.7833 20.0001 18.7833C19.0001 18.7833 19.0001 19.6976 18.0001 19.6976Z" fill="#0052B4"/>
<path d="M11.9675 11.9991H11.9997C11.9997 11.9883 11.9997 11.9778 11.9997 11.9669C11.989 11.9777 11.9783 11.9884 11.9675 11.9991Z" fill="#F0F0F0"/>
<path d="M11.9996 6.26153V9.78714L7.82568 5.73981L11.9996 6.26153Z" fill="#0052B4"/>
<path d="M6.26053 12.0005H9.786L6.26049 7.30489L5.73877 10.9571L6.26053 12.0005Z" fill="#0052B4"/>
<path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.2609V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"/>
<path d="M6.07124 1.56418C4.19441 2.63288 2.63413 4.19316 1.56543 6.06999V11.999H4.69588V4.69473V4.69463H12.0002C12.0002 3.7073 12.0002 2.76671 12.0002 1.56418H6.07124Z" fill="#D80027"/>
<path d="M11.9999 10.5234L7.73637 6.25999H6.26074V6.26009L11.9998 11.9991H11.9999C11.9999 11.9991 11.9999 10.9816 11.9999 10.5234Z" fill="#D80027"/>
<path d="M15.652 6.26097H20.3476L17.9998 8.6088L15.652 6.26097Z" fill="#6DA544"/>
<path d="M18.5223 8.08647H17.4788V10.956H18.5223V8.08647Z" fill="#A2001D"/>
<path d="M18.5213 15.6519H17.4778V18.5215H18.5213V15.6519Z" fill="#A2001D"/>
<path d="M21.1305 14.0873C21.1305 13.2229 20.4297 12.5221 19.5653 12.5221C19.1643 12.5221 18.7988 12.6731 18.5218 12.921V12.0004H19.0435V10.9569H18.5218V10.4352H17.4783V10.9569H16.9566V12.0004H17.4783V12.921C17.2013 12.6731 16.8358 12.5221 16.4348 12.5221C15.5704 12.5221 14.8696 13.2229 14.8696 14.0873C14.8696 14.5508 15.0712 14.967 15.3913 15.2537V16.1743H20.6087V15.2537C20.9289 14.967 21.1305 14.5508 21.1305 14.0873Z" fill="#FFDA44"/>
<path d="M19.5647 13.5649C19.4001 13.5649 19.2849 13.6372 19.2172 13.6978L18.5212 14.3208H17.4778L16.7818 13.6978C16.7141 13.6372 16.5989 13.5649 16.4343 13.5649C16.1466 13.5649 15.9126 13.799 15.9126 14.0866C15.9126 14.2893 16.0219 14.4173 16.087 14.4756L16.4344 14.7867V15.1301H19.5648V14.7867L19.9122 14.4756C19.9773 14.4173 20.0866 14.2893 20.0866 14.0866C20.0865 13.799 19.8524 13.5649 19.5647 13.5649Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4283">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IQ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4865)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9998 -0.000610352C6.84025 -0.000610352 2.44173 3.25589 0.746216 7.8255H23.2535C21.5579 3.25589 17.1594 -0.000610352 11.9998 -0.000610352Z" fill="#A2001D"/>
<path d="M11.9999 24.0006C17.1595 24.0006 21.558 20.7441 23.2536 16.1744H0.746338C2.44185 20.7441 6.84037 24.0006 11.9999 24.0006Z" fill="black"/>
<path d="M9.13051 11.2186C9.12395 11.2186 9.11753 11.219 9.11096 11.2191V11.2186H6.81704C6.93334 10.7692 7.34106 10.4359 7.82617 10.4359V8.87073C6.38772 8.87073 5.21748 10.041 5.21748 11.4794V12.7577V12.7838H9.11096C9.11978 12.7838 9.12671 12.7838 9.13051 12.7838C9.27437 12.7838 9.39137 12.9009 9.39137 13.0447V13.5664H4.17395V15.1316H10.9566V13.0446C10.9566 12.0377 10.1374 11.2186 9.13051 11.2186Z" fill="#496E2D"/>
<path d="M13.0438 13.5657V8.87H11.4786V15.1309H14.0873V13.5657H13.0438Z" fill="#496E2D"/>
<path d="M18.2607 13.5657V8.87H16.6955V13.5657H16.1737V12.0005H14.6085V15.1309H19.3042V13.5657H18.2607Z" fill="#496E2D"/>
</g>
<defs>
<clipPath id="clip0_2087_4865">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4860)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M15.8978 8.86968H14.3278C14.3408 9.04222 14.3481 9.21632 14.3481 9.39139C14.3481 10.5522 14.058 11.6774 13.5521 12.4783C13.3961 12.7253 13.1339 13.0741 12.7829 13.3094V8.86963H11.2177V13.3094C10.8667 13.0741 10.6044 12.7253 10.4484 12.4783C9.94252 11.6774 9.65241 10.5522 9.65241 9.39139C9.65241 9.21632 9.65981 9.04218 9.67275 8.86968H8.10272C8.09264 9.04138 8.08716 9.21529 8.08716 9.39139C8.08716 12.6096 9.80597 15.1305 12.0002 15.1305C14.1944 15.1305 15.9132 12.6096 15.9132 9.39139C15.9133 9.21529 15.9078 9.04138 15.8978 8.86968Z" fill="#D80027"/>
<path d="M4.95684 5.73816H6.52204V6.78165H8.08724V5.73816H9.65245V6.78165H11.2176V5.73816H12.7829V6.78165H14.3481V5.73816H15.9133V6.78165H17.4785V5.73816H19.0437V6.78165H22.8095C20.8686 2.7677 16.7578 -0.000976562 12.0003 -0.000976562C7.24284 -0.000976562 3.13204 2.7677 1.19104 6.78165H4.95684V5.73816Z" fill="#6DA544"/>
<path d="M19.0438 17.217V18.2605H17.4786V17.217H15.9134V18.2605H14.3482V17.217H12.783V18.2605H11.2178V17.217H9.65259V18.2605H8.08738V17.217H6.52204V18.2605H4.95684V17.217H1.19104C3.13204 21.231 7.24279 23.9997 12.0003 23.9997C16.7579 23.9997 20.8686 21.231 22.8096 17.217H19.0438Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4860">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4842)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0.41333 15.1301C1.10764 17.7063 2.63788 19.9391 4.6956 21.5202V15.1301H0.41333Z" fill="#0052B4"/>
<path d="M10.9563 23.954C11.3003 23.9836 11.6481 23.9996 11.9998 23.9996C17.5441 23.9996 22.2094 20.2393 23.5864 15.1301H10.9563V23.954Z" fill="#0052B4"/>
<path d="M23.5864 8.86912C22.2094 3.75993 17.5441 -0.000427246 11.9998 -0.000427246C11.6481 -0.000427246 11.3003 0.015604 10.9563 0.045229V8.86912H23.5864Z" fill="#0052B4"/>
<path d="M4.6956 2.47937C2.63788 4.06046 1.10764 6.29326 0.41333 8.86946H4.6956V2.47937Z" fill="#0052B4"/>
<path d="M23.8982 10.4351H9.39112H9.39107V0.285583C8.2821 0.53149 7.23074 0.930068 6.26062 1.45943V10.4351H0.101334C0.0345371 10.9475 -0.000244141 11.4699 -0.000244141 12.0003C-0.000244141 12.5308 0.0345371 13.0532 0.101334 13.5656H6.26057H6.26062V22.5412C7.23074 23.0705 8.2821 23.4692 9.39107 23.7151V13.5657V13.5656H23.8982C23.9649 13.0532 23.9998 12.5308 23.9998 12.0003C23.9998 11.4699 23.9649 10.9475 23.8982 10.4351Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4842">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const IT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4886)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9999 11.9991C23.9999 6.83955 20.7434 2.44103 16.1738 0.745514V23.2528C20.7434 21.5572 23.9999 17.1587 23.9999 11.9991Z" fill="#D80027"/>
<path d="M-0.00012207 11.9997C-0.00012207 17.1593 3.25638 21.5578 7.82599 23.2533V0.746071C3.25638 2.44159 -0.00012207 6.8401 -0.00012207 11.9997Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4886">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const JE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4899)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M21.5204 19.3072L14.2138 12.0006H14.2137L21.5204 4.69384C21.2053 4.28434 20.8606 3.89036 20.4855 3.51521C20.1104 3.14012 19.7164 2.79536 19.3069 2.48031L12.0002 9.78695L12.0002 9.787L4.69356 2.48031C4.28411 2.7954 3.89007 3.14007 3.51493 3.51521C3.13979 3.89036 2.79507 4.28434 2.48003 4.69384L9.78667 12.0004L9.78672 12.0005L2.47998 19.3072C2.79512 19.7167 3.13984 20.1107 3.51489 20.4858C3.89003 20.8609 4.28396 21.2057 4.69351 21.5207L12.0002 14.2141L12.0002 14.2141L19.3069 21.5207C19.7163 21.2056 20.1104 20.8609 20.4855 20.4858C20.8607 20.1107 21.2053 19.7167 21.5204 19.3072Z" fill="#D80027"/>
<path d="M9.9126 3.65286L11.9996 4.17458L14.0865 3.65286V1.87897L13.2517 2.29635L11.9996 1.04417L10.7474 2.29635L9.9126 1.87897V3.65286Z" fill="#FFDA44"/>
<path d="M9.9126 3.65289V4.95733C9.9126 6.55483 11.9996 7.0443 11.9996 7.0443C11.9996 7.0443 14.0865 6.55478 14.0865 4.95733V3.65289H9.9126Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4899">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const JM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4890)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M19.3056 2.48076C17.2822 0.925403 14.7493 0.000137329 11.9999 0.000137329C9.25048 0.000137329 6.71754 0.92545 4.69409 2.48076L11.9999 9.78651L19.3056 2.48076Z" fill="#6DA544"/>
<path d="M2.48033 4.69361C0.925068 6.71706 -0.000244141 9.24996 -0.000244141 11.9994C-0.000244141 14.7488 0.925068 17.2817 2.48038 19.3052L9.78618 11.9994L2.48033 4.69361Z" fill="black"/>
<path d="M4.69409 21.5188C6.71759 23.0741 9.25048 23.9994 11.9999 23.9994C14.7493 23.9994 17.2822 23.0741 19.3057 21.5188L11.9999 14.213L4.69409 21.5188Z" fill="#6DA544"/>
<path d="M21.5192 19.3051C23.0746 17.2817 23.9999 14.7488 23.9999 11.9994C23.9999 9.24996 23.0746 6.71706 21.5192 4.69361L14.2135 11.9994L21.5192 19.3051Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4890">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const JO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4904)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M7.30437 7.82625H23.2536C21.5581 3.25664 17.1596 0.000137329 12 0.000137329C8.68625 0.000137329 5.68657 1.34353 3.51514 3.51525L7.30437 7.82625Z" fill="black"/>
<path d="M7.30437 16.1745H23.2536C21.5581 20.7441 17.1596 24.0006 12 24.0006C8.68625 24.0006 5.68657 22.6572 3.51514 20.4855L7.30437 16.1745Z" fill="#6DA544"/>
<path d="M3.51471 3.51381C-1.17157 8.20009 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51381Z" fill="#D80027"/>
<path d="M4.7628 9.39177L5.42135 10.7689L6.90865 10.4252L6.24255 11.7987L7.43857 12.7471L5.94949 13.0827L5.95361 14.6091L4.7628 13.6542L3.57194 14.6091L3.57611 13.0827L2.08704 12.7471L3.28301 11.7987L2.617 10.4252L4.10421 10.7689L4.7628 9.39177Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4904">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const JP = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4896)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12 17.2178C14.8815 17.2178 17.2174 14.8819 17.2174 12.0004C17.2174 9.11894 14.8815 6.78304 12 6.78304C9.11849 6.78304 6.78259 9.11894 6.78259 12.0004C6.78259 14.8819 9.11849 17.2178 12 17.2178Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4896">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4915)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0003 -0.000732422C7.24279 -0.000732422 3.13204 2.76794 1.19104 6.78189H22.8096C20.8686 2.76794 16.7578 -0.000732422 12.0003 -0.000732422Z" fill="black"/>
<path d="M12.0003 24.0001C7.24279 24.0001 3.13204 21.2314 1.19104 17.2175H22.8096C20.8686 21.2314 16.7578 24.0001 12.0003 24.0001Z" fill="#496E2D"/>
<path d="M23.4335 8.34706H0.566794C0.1992 9.49873 0.00012207 10.7257 0.00012207 11.9992C0.00012207 13.2728 0.1992 14.4997 0.566794 15.6514H23.4334C23.801 14.4997 24.0001 13.2728 24.0001 11.9992C24.0001 10.7257 23.801 9.49873 23.4335 8.34706Z" fill="#A2001D"/>
<path d="M15.7368 5.54511L14.3157 4.88919L12.0002 10.1322L9.68466 4.88919L8.26355 5.54511L11.1383 11.9998L8.26355 18.4544L9.68466 19.1103L12.0002 13.8673L14.3157 19.1103L15.7368 18.4544L12.8621 11.9998L15.7368 5.54511Z" fill="#F0F0F0"/>
<path d="M12.9653 6.16323C12.4152 5.56243 12.0001 5.21706 12.0001 5.21706C12.0001 5.21706 11.585 5.56238 11.0349 6.16323V17.836C11.585 18.4369 12.0001 18.7823 12.0001 18.7823C12.0001 18.7823 12.4152 18.437 12.9653 17.8361V6.16323Z" fill="#F0F0F0"/>
<path d="M9.3916 8.40226V15.5981C9.97294 16.6282 10.6845 17.4725 11.2177 18.0323V5.96814C10.6845 6.52787 9.9729 7.37223 9.3916 8.40226Z" fill="#A2001D"/>
<path d="M14.6087 8.40283C14.0273 7.37275 13.3158 6.52844 12.7826 5.9687V18.0329C13.3158 17.4731 14.0273 16.6288 14.6087 15.5987V8.40283Z" fill="#A2001D"/>
<path d="M14.6086 8.40091V15.5968C15.1972 14.5539 15.6521 13.3206 15.6521 11.9989C15.6521 10.6772 15.1972 9.44388 14.6086 8.40091Z" fill="black"/>
<path d="M9.39126 8.40091V15.5968C8.80275 14.5539 8.34778 13.3206 8.34778 11.9989C8.34778 10.6772 8.80275 9.44388 9.39126 8.40091Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4915">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4944)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M17.8682 12L15.4703 13.1279L16.7472 15.4504L14.1432 14.9522L13.8134 17.5826L11.9995 15.6481L10.1859 17.5826L9.8559 14.9522L7.25209 15.4503L8.52897 13.1278L6.13098 12L8.52897 10.8722L7.25209 8.54959L9.85581 9.04787L10.186 6.41739L11.9995 8.35197L13.8135 6.41739L14.1432 9.04787L16.7473 8.54959L15.4704 10.8723L17.8682 12Z" fill="#FFDA44"/>
<path d="M12.0002 15.6514C14.0172 15.6514 15.6524 14.0163 15.6524 11.9992C15.6524 9.98221 14.0172 8.34708 12.0002 8.34708C9.98316 8.34708 8.34802 9.98221 8.34802 11.9992C8.34802 14.0163 9.98316 15.6514 12.0002 15.6514Z" fill="#D80027"/>
<path d="M10.1742 12.0005C10.0862 12.0005 9.99931 12.005 9.91357 12.0135C9.91671 12.5193 10.0997 12.9823 10.402 13.342C10.5632 12.908 10.804 12.5124 11.1076 12.1738C10.8176 12.0622 10.503 12.0005 10.1742 12.0005Z" fill="#FFDA44"/>
<path d="M11.2985 13.9671C11.5178 14.0455 11.754 14.0884 12.0004 14.0884C12.2468 14.0884 12.483 14.0455 12.7024 13.9671C12.5828 13.4978 12.3359 13.0788 12.0004 12.7495C11.6649 13.0787 11.418 13.4978 11.2985 13.9671Z" fill="#FFDA44"/>
<path d="M13.8078 10.9573C13.4469 10.3336 12.773 9.91351 12.0005 9.91351C11.228 9.91351 10.5541 10.3336 10.1932 10.9573C10.8511 10.9607 11.468 11.1395 12.0005 11.4484C12.5331 11.1395 13.1498 10.9607 13.8078 10.9573Z" fill="#FFDA44"/>
<path d="M12.8927 12.1739C13.1963 12.5125 13.4371 12.9082 13.5983 13.3422C13.9006 12.9825 14.0836 12.5195 14.0867 12.0137C14.0009 12.0051 13.9141 12.0006 13.8261 12.0006C13.4973 12.0006 13.1828 12.0624 12.8927 12.1739Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4944">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4368)">
<path d="M0.000244141 12.0009C0.000244141 14.0798 0.529135 16.0351 1.45932 17.74L12.0002 18.7835L22.5412 17.74C23.4714 16.0351 24.0002 14.0798 24.0002 12.0009C24.0002 9.92195 23.4714 7.96661 22.5412 6.26172L12.0002 5.21823L1.45932 6.26172C0.529135 7.96661 0.000244141 9.92195 0.000244141 12.0009Z" fill="#D80027"/>
<path d="M1.45911 6.26126H22.5409C20.5057 2.53113 16.5485 0.000396729 12 0.000396729C7.45151 0.000396729 3.49437 2.53113 1.45911 6.26126Z" fill="#0052B4"/>
<path d="M12 24.0008C16.5485 24.0008 20.5057 21.4701 22.5409 17.74H1.45911C3.49437 21.4701 7.45151 24.0008 12 24.0008Z" fill="#0052B4"/>
<path d="M16.1744 14.3474V12.7822H15.1309V10.6952L14.0874 9.65173L13.0439 10.6952V8.60824L12.0005 7.56476L10.957 8.60824V10.6952L9.91349 9.65173L8.87 10.6952V12.7822H7.82657V14.3474H6.78308V15.9126H17.2178V14.3474H16.1744Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4368">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4928)">
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027"/>
<path d="M16.1735 11.16L14.4679 11.9622L15.3762 13.614L13.5242 13.2597L13.2895 15.1306L11.9996 13.7546L10.7096 15.1306L10.475 13.2597L8.62298 13.6139L9.53118 11.9622L7.82568 11.16L9.53118 10.3577L8.62298 8.70608L10.4749 9.06027L10.7096 7.18948L11.9996 8.56541L13.2896 7.18948L13.5242 9.06027L15.3762 8.70608L14.4681 10.3579L16.1735 11.16Z" fill="#FFDA44"/>
<path d="M15.1305 3.91303H12.7827C12.7827 3.48089 12.4323 3.1304 12.0001 3.1304C11.5679 3.1304 11.2175 3.48084 11.2175 3.91303H8.86963C8.86963 4.34521 9.24613 4.69565 9.67832 4.69565H9.65221C9.65221 5.12784 10.0026 5.47828 10.4348 5.47828C10.4348 5.91046 10.7852 6.2609 11.2175 6.2609H12.7827C13.2148 6.2609 13.5653 5.91051 13.5653 5.47828C13.9974 5.47828 14.3479 5.12788 14.3479 4.69565H14.3218C14.754 4.69565 15.1305 4.34526 15.1305 3.91303Z" fill="#FFDA44"/>
<path d="M24.0002 11.9996C24.0002 18.627 18.6276 23.9996 12.0002 23.9996C5.37287 23.9996 0.000244141 18.627 0.000244141 11.9996C0.521963 11.9996 24.0002 11.9996 24.0002 11.9996Z" fill="#F0F0F0"/>
<path d="M12.0006 24.0005C15.7516 24.0005 19.1001 22.279 21.3006 19.5835C20.9048 19.3137 20.6911 18.8775 20.0004 18.8775C19.0004 18.8775 19.0004 19.7918 18.0005 19.7918C17.0005 19.7918 17.0005 18.8775 16.0005 18.8775C15.0006 18.8775 15.0006 19.7918 14.0005 19.7918C13.0005 19.7918 13.0004 18.8775 12.0004 18.8775C11.0004 18.8775 11.0004 19.7918 10.0004 19.7918C9.0006 19.7918 9.0006 18.8775 8.00061 18.8775C7.00054 18.8775 7.00054 19.7918 6.00046 19.7918C5.00038 19.7918 5.00038 18.8775 4.0003 18.8775C3.30965 18.8775 3.09594 19.3136 2.70032 19.5835C4.90082 22.279 8.24947 24.0005 12.0006 24.0005Z" fill="#0052B4"/>
<path d="M22 13.5312C21 13.5312 21 12.6169 20 12.6169C19 12.6169 19 13.5312 18 13.5312C17.0001 13.5312 17.0001 12.6169 16.0001 12.6169C15.0001 12.6169 15.0001 13.5312 14.0001 13.5312C13.0001 13.5312 13 12.6169 11.9999 12.6169C11 12.6169 11 13.5312 10 13.5312C9.00018 13.5312 9.00018 12.6169 8.0002 12.6169C7.00012 12.6169 7.00012 13.5312 6.00004 13.5312C4.99997 13.5312 4.99997 12.6169 3.99989 12.6169C3.00004 12.6169 3.00004 13.5312 2.00006 13.5312C1.00547 13.5312 0.9997 12.6269 0.0157471 12.6173C0.0434502 13.1662 0.108981 13.7051 0.208075 14.232C1.00514 14.3492 1.07493 15.1312 2.00011 15.1312C3.00009 15.1312 3.00009 14.2169 3.99993 14.2169C5.00001 14.2169 5.00001 15.1312 6.00009 15.1312C7.00017 15.1312 7.00017 14.2169 8.00025 14.2169C9.00023 14.2169 9.00023 15.1312 10.0001 15.1312C11.0001 15.1312 11.0001 14.2169 12 14.2169C13.0001 14.2169 13.0001 15.1312 14.0002 15.1312C15.0002 15.1312 15.0002 14.2169 16.0002 14.2169C17.0002 14.2169 17.0002 15.1312 18.0001 15.1312C19 15.1312 19.0001 14.2169 20 14.2169C21.0001 14.2169 21.0001 15.1312 22 15.1312C22.9253 15.1312 22.9951 14.3492 23.7922 14.2321C23.8913 13.7051 23.9568 13.1662 23.9846 12.6173C23.0005 12.627 22.9946 13.5312 22 13.5312Z" fill="#0052B4"/>
<path d="M20.0001 15.7477C19.0001 15.7477 19.0001 16.6621 18.0002 16.6621C17.0003 16.6621 17.0002 15.7477 16.0003 15.7477C15.0003 15.7477 15.0003 16.6621 14.0003 16.6621C13.0002 16.6621 13.0002 15.7477 12.0001 15.7477C11.0001 15.7477 11.0001 16.6621 10.0002 16.6621C9.00035 16.6621 9.00035 15.7477 8.00037 15.7477C7.00029 15.7477 7.00029 16.6621 6.00021 16.6621C5.00013 16.6621 5.00013 15.7477 4.00005 15.7477C3.00021 15.7477 3.00021 16.6621 2.00023 16.6621C1.28571 16.6621 1.08162 16.1954 0.658569 15.9287C0.940194 16.7424 1.30657 17.5165 1.7478 18.24C1.82454 18.2542 1.90807 18.262 2.00023 18.262C3.00021 18.262 3.00021 17.3478 4.00005 17.3478C5.00013 17.3478 5.00013 18.262 6.00021 18.262C7.00029 18.262 7.00029 17.3478 8.00037 17.3478C9.00035 17.3478 9.00035 18.262 10.0002 18.262C11.0002 18.262 11.0002 17.3478 12.0001 17.3478C13.0002 17.3478 13.0002 18.262 14.0003 18.262C15.0003 18.262 15.0004 17.3478 16.0003 17.3478C17.0003 17.3478 17.0003 18.262 18.0002 18.262C19.0001 18.262 19.0002 17.3478 20.0001 17.3478C21.0002 17.3478 21.0002 18.262 22.0001 18.262C22.0924 18.262 22.1759 18.2542 22.2527 18.24C22.6939 17.5165 23.0602 16.7424 23.342 15.9288C22.9189 16.1953 22.7148 16.6621 22.0001 16.6621C21.0002 16.6621 21.0002 15.7477 20.0001 15.7477Z" fill="#0052B4"/>
<path d="M23.963 11.051C23.0007 11.0738 22.9874 11.9644 22.0001 11.9644C21.0001 11.9644 21.0001 11.05 20.0001 11.05C19.0001 11.05 19.0001 11.9644 18.0001 11.9644C17.0002 11.9644 17.0002 11.05 16.0002 11.05C15.0002 11.05 15.0002 11.9644 14.0002 11.9644C13.0002 11.9644 13.0001 11.05 12.0001 11.05C11.0001 11.05 11.0001 11.9644 10.0001 11.9644C9.00029 11.9644 9.00029 11.05 8.00031 11.05C7.00023 11.05 7.00023 11.9644 6.00015 11.9644C5.00007 11.9644 5.00007 11.05 3.99999 11.05C3.00015 11.05 3.00015 11.9644 2.00017 11.9644C1.01303 11.9644 0.999666 11.0739 0.037416 11.051C0.0129941 11.3639 0.000244141 11.68 0.000244141 11.9991C0.000244141 12.2177 0.00643164 12.4348 0.0181035 12.6505C0.999807 12.6615 1.00632 13.5643 2.00021 13.5643C3.0002 13.5643 3.0002 12.6501 4.00004 12.6501C5.00012 12.6501 5.00012 13.5643 6.0002 13.5643C7.00028 13.5643 7.00028 12.6501 8.00035 12.6501C9.00034 12.6501 9.00034 13.5643 10.0002 13.5643C11.0002 13.5643 11.0002 12.6501 12.0001 12.6501C13.0002 12.6501 13.0002 13.5643 14.0003 13.5643C15.0003 13.5643 15.0003 12.6501 16.0003 12.6501C17.0003 12.6501 17.0003 13.5643 18.0002 13.5643C19.0001 13.5643 19.0002 12.6501 20.0001 12.6501C21.0002 12.6501 21.0002 13.5643 22.0001 13.5643C22.9941 13.5643 23.0006 12.6615 23.9825 12.6505C23.9941 12.4348 24.0002 12.2177 24.0002 11.9991C24.0002 11.68 23.9875 11.3639 23.963 11.051Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4928">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4464)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9994 11.9653H10.9911C8.40842 14.548 6.84664 16.542 5.25195 18.1367L12.0346 18.7479L22.5596 17.7044C23.4781 16.0078 23.9998 14.0649 23.9998 12.0001C23.9998 11.9884 23.9994 11.977 23.9994 11.9653Z" fill="#D80027"/>
<path d="M5.2526 6.22564H22.5219C20.4811 2.51464 16.5347 -0.000488281 12.0004 -0.000488281C8.69547 -0.000488281 5.70316 1.33597 3.53308 3.49751L5.2526 6.22564Z" fill="#FFDA44"/>
<path d="M5.7734 17.704C4.69461 18.7828 4.27771 19.6866 3.49719 20.4671C5.67008 22.649 8.67688 23.9996 11.9995 23.9996C16.5621 23.9996 20.5298 21.4531 22.5593 17.704H5.7734Z" fill="#0052B4"/>
<path d="M3.51422 3.48035C-1.17206 8.16663 -1.17206 15.7646 3.51422 20.451C5.45077 18.5144 7.31325 16.6519 11.9995 11.9657L3.51422 3.48035Z" fill="#6DA544"/>
<path d="M3.16535 11.9647C3.16535 10.2163 4.39408 8.75575 6.03489 8.39744C5.78271 8.34236 5.52105 8.3125 5.25227 8.3125C3.23519 8.3125 1.6001 9.9476 1.6001 11.9647C1.6001 13.9818 3.23519 15.6169 5.25227 15.6169C5.521 15.6169 5.78266 15.587 6.03489 15.5319C4.39408 15.1736 3.16535 13.713 3.16535 11.9647Z" fill="#F0F0F0"/>
<path d="M5.99477 8.83472L6.18906 9.43256H6.81766L6.30906 9.80208L6.50336 10.3999L5.99477 10.0305L5.48617 10.3999L5.68047 9.80208L5.17188 9.43256H5.80047L5.99477 8.83472Z" fill="#F0F0F0"/>
<path d="M5.99477 10.3998L6.18906 10.9977H6.81766L6.30906 11.3671L6.50336 11.965L5.99477 11.5955L5.48617 11.965L5.68047 11.3671L5.17188 10.9977H5.80047L5.99477 10.3998Z" fill="#F0F0F0"/>
<path d="M5.99477 11.9646L6.18906 12.5624H6.81766L6.30906 12.932L6.50336 13.5298L5.99477 13.1603L5.48617 13.5298L5.68047 12.932L5.17188 12.5624H5.80047L5.99477 11.9646Z" fill="#F0F0F0"/>
<path d="M5.99477 13.5297L6.18906 14.1275H6.81766L6.30906 14.497L6.50336 15.0949L5.99477 14.7254L5.48617 15.0949L5.68047 14.497L5.17188 14.1275H5.80047L5.99477 13.5297Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4464">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5393)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z" fill="#FFDA44"/>
<path d="M3.51503 20.4852C4.01842 20.9885 4.55556 21.4375 5.11895 21.8327L21.8331 5.11856C21.4379 4.55512 20.989 4.01802 20.4855 3.51463C19.9822 3.01124 19.4451 2.56241 18.8817 2.16711L2.1676 18.8813C2.56276 19.4447 3.01164 19.9818 3.51503 20.4852Z" fill="black"/>
<path d="M3.51439 3.51475C-0.271387 7.30053 -0.998186 12.9861 1.33263 17.5021L17.5017 1.33309C12.9857 -0.997679 7.30002 -0.27088 3.51439 3.51475Z" fill="#6DA544"/>
<path d="M20.4852 20.4847C24.271 16.699 24.9977 11.0134 22.667 6.49731L6.4978 22.6665C11.0138 24.9972 16.6995 24.2705 20.4852 20.4847Z" fill="#D80027"/>
<path d="M7.62983 14.1578L8.75005 14.7286L9.63909 13.8396L9.4424 15.0813L10.5626 15.6521L9.3208 15.8488L9.12412 17.0905L8.55337 15.9703L7.31165 16.167L8.20063 15.278L7.62983 14.1578Z" fill="#F0F0F0"/>
<path d="M14.1561 7.63057L15.2763 8.20136L16.1653 7.31238L15.9686 8.55405L17.0888 9.1249L15.8471 9.32158L15.6504 10.5633L15.0796 9.44313L13.8379 9.63977L14.7269 8.75079L14.1561 7.63057Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5393">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KP = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5239)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9999 -0.000267029C8.36285 -0.000267029 5.10396 1.61805 2.90332 4.17362H21.0965C18.8959 1.61805 15.637 -0.000267029 11.9999 -0.000267029Z" fill="#0052B4"/>
<path d="M21.0962 19.827H2.90295C5.1036 22.3825 8.36249 24.0008 11.9996 24.0008C15.6366 24.0008 18.8955 22.3825 21.0962 19.827Z" fill="#0052B4"/>
<path d="M22.2387 5.7386H1.76128C0.644297 7.56134 0 9.70507 0 11.9995C0 14.2939 0.644297 16.4376 1.76128 18.2603H22.2387C23.3557 16.4376 24 14.2939 24 11.9995C24 9.70507 23.3557 7.56134 22.2387 5.7386Z" fill="#D80027"/>
<path d="M7.38263 16.6182C9.93273 16.6182 12 14.551 12 12.0008C12 9.45074 9.93273 7.38347 7.38263 7.38347C4.83253 7.38347 2.76526 9.45074 2.76526 12.0008C2.76526 14.551 4.83253 16.6182 7.38263 16.6182Z" fill="#F0F0F0"/>
<path d="M7.38242 7.38347L8.41841 10.572H11.7764L9.05877 12.5427L10.1029 15.7407L7.38242 13.7606L4.66611 15.737L5.70608 12.5427L2.99084 10.572H6.34639L7.38242 7.38347Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5239">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5537)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M16.1741 11.9996C16.1741 13.0431 14.3054 15.6518 12.0002 15.6518C9.69501 15.6518 7.82629 13.0431 7.82629 11.9996C7.82629 9.69442 9.69501 7.82574 12.0002 7.82574C14.3054 7.82574 16.1741 9.69442 16.1741 11.9996Z" fill="#D80027"/>
<path d="M16.1741 11.9995C16.1741 14.3047 14.3054 16.1734 12.0002 16.1734C9.69501 16.1734 7.82629 14.3047 7.82629 11.9995" fill="#0052B4"/>
<path d="M17.5335 14.5826L16.4268 15.6893L17.1646 16.4272L18.2714 15.3204L17.5335 14.5826Z" fill="black"/>
<path d="M15.6884 16.4268L14.5817 17.5336L15.3195 18.2714L16.4263 17.1647L15.6884 16.4268Z" fill="black"/>
<path d="M19.747 16.7947L18.6403 17.9015L19.3781 18.6393L20.4849 17.5326L19.747 16.7947Z" fill="black"/>
<path d="M17.903 18.6409L16.7963 19.7477L17.5341 20.4855L18.6409 19.3788L17.903 18.6409Z" fill="black"/>
<path d="M18.6406 15.6896L17.5338 16.7964L18.2717 17.5342L19.3784 16.4275L18.6406 15.6896Z" fill="black"/>
<path d="M16.796 17.5339L15.6892 18.6406L16.4271 19.3785L17.5338 18.2717L16.796 17.5339Z" fill="black"/>
<path d="M15.6894 5.35815L18.6407 8.30951L19.3786 7.57166L16.4272 4.62031L15.6894 5.35815Z" fill="black"/>
<path d="M14.5828 6.46618L15.6896 7.57294L16.4274 6.83512L15.3206 5.72837L14.5828 6.46618Z" fill="black"/>
<path d="M16.4274 8.31L17.5342 9.41675L18.272 8.67893L17.1652 7.57218L16.4274 8.31Z" fill="black"/>
<path d="M16.7951 4.25225L17.9019 5.35901L18.6397 4.62116L17.5329 3.5144L16.7951 4.25225Z" fill="black"/>
<path d="M18.6409 6.09765L19.7477 7.20441L20.4855 6.46656L19.3788 5.3598L18.6409 6.09765Z" fill="black"/>
<path d="M7.20343 19.7479L4.25208 16.7966L3.51423 17.5344L6.46558 20.4858L7.20343 19.7479Z" fill="black"/>
<path d="M8.31061 18.64L7.20386 17.5332L6.46604 18.271L7.5728 19.3778L8.31061 18.64Z" fill="black"/>
<path d="M6.46589 16.7959L5.35913 15.6891L4.62128 16.427L5.72804 17.5337L6.46589 16.7959Z" fill="black"/>
<path d="M9.41755 17.5337L6.46619 14.5823L5.72834 15.3202L8.6797 18.2715L9.41755 17.5337Z" fill="black"/>
<path d="M4.25262 7.20471L7.20398 4.25336L6.46613 3.51551L3.51477 6.46687L4.25262 7.20471Z" fill="black"/>
<path d="M5.35858 8.30982L8.30994 5.35846L7.57209 4.62061L4.62073 7.57197L5.35858 8.30982Z" fill="black"/>
<path d="M6.46637 9.41706L9.41772 6.4657L8.67991 5.72788L5.72855 8.67924L6.46637 9.41706Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_5537">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4939)">
<path d="M23.2541 16.1731C23.7364 14.8731 24.0005 13.467 24.0005 11.9992C24.0005 10.5313 23.7364 9.12527 23.2541 7.82528L12.0005 6.7818L0.746879 7.82528C0.264535 9.12527 0.000488281 10.5313 0.000488281 11.9992C0.000488281 13.467 0.264535 14.8731 0.746879 16.1731L12.0005 17.2166L23.2541 16.1731Z" fill="#F0F0F0"/>
<path d="M12.0002 23.9995C17.1598 23.9995 21.5583 20.743 23.2538 16.1734H0.746582C2.44214 20.743 6.84061 23.9995 12.0002 23.9995Z" fill="#D80027"/>
<path d="M12.0002 -0.000518799C6.84061 -0.000518799 2.44214 3.25598 0.746582 7.82559H23.2538C21.5583 3.25598 17.1598 -0.000518799 12.0002 -0.000518799Z" fill="#6DA544"/>
<path d="M3.5152 3.5145C-1.17108 8.20078 -1.17108 15.7988 3.5152 20.4851C4.7384 19.2619 5.93231 18.068 7.82657 16.1737V7.82592L3.5152 3.5145Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4939">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4385)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9686 12.0004H12.0008C12.0008 11.9896 12.0008 11.9791 12.0008 11.9683C11.9901 11.979 11.9794 11.9897 11.9686 12.0004Z" fill="#F0F0F0"/>
<path d="M12.0002 6.26037C12.0002 4.14889 12.0002 2.76537 12.0002 -0.000488281H11.9982C5.3717 0.000636719 0.000244141 5.37275 0.000244141 11.9995H6.2611V8.474L9.78662 11.9995H11.9682C11.9789 11.9888 11.9896 11.9781 12.0003 11.9674C12.0003 11.1589 12.0003 10.4376 12.0003 9.78598L8.47468 6.26037H12.0002Z" fill="#F0F0F0"/>
<path d="M17.2173 8.86919C18.3699 8.86919 19.3043 7.93482 19.3043 6.78222C19.3043 5.62962 18.3699 4.69525 17.2173 4.69525C16.0647 4.69525 15.1304 5.62962 15.1304 6.78222C15.1304 7.93482 16.0647 8.86919 17.2173 8.86919Z" fill="#6DA544"/>
<path d="M6.07063 1.56525C4.1938 2.63395 2.63348 4.19423 1.56482 6.07106V12H4.69527V4.69579V4.6957H11.9996C11.9996 3.70837 11.9996 2.76778 11.9996 1.56525H6.07063Z" fill="#D80027"/>
<path d="M11.9993 10.5238L7.73576 6.26038H6.26013V6.26047L11.9992 11.9995H11.9993C11.9993 11.9995 11.9993 10.9819 11.9993 10.5238Z" fill="#D80027"/>
<path d="M20.8692 6.26038H13.5648V9.39083H20.8692V6.26038Z" fill="#D80027"/>
<path d="M13.5652 14.0869V16.1738H14.6632C15.3215 16.819 16.2227 17.2173 17.2174 17.2173C18.212 17.2173 19.1132 16.819 19.7715 16.1738H19.826H20.8695V14.0869H13.5652Z" fill="#FFDA44"/>
<path d="M13.5652 8.86902V11.9995C13.5652 14.7951 17.2174 15.6516 17.2174 15.6516C17.2174 15.6516 20.8695 14.7951 20.8695 11.9995V8.86902H13.5652Z" fill="#338AF3"/>
<path d="M17.2172 10.5403C16.3043 10.5403 16.3043 11.3751 15.3913 11.3751C14.4783 11.3751 14.4783 10.5403 13.5653 10.5403V12.0012C14.4783 12.0012 14.4783 12.836 15.3913 12.836C16.3043 12.836 16.3043 12.0012 17.2172 12.0012C18.1303 12.0012 18.1303 12.836 19.0434 12.836C19.9566 12.836 19.9565 12.0012 20.8696 12.0012V10.5403C19.9566 10.5403 19.9566 11.3751 19.0434 11.3751C18.1303 11.3751 18.1303 10.5403 17.2172 10.5403Z" fill="#F3F3F3"/>
<path d="M17.2171 7.61664C16.3041 7.61664 16.3041 8.45144 15.3912 8.45144C14.4782 8.45144 14.4782 7.61664 13.5652 7.61664V9.0775C14.4782 9.0775 14.4782 9.91229 15.3912 9.91229C16.3041 9.91229 16.3041 9.0775 17.2171 9.0775C18.1302 9.0775 18.1302 9.91229 19.0433 9.91229C19.9565 9.91229 19.9564 9.0775 20.8695 9.0775V7.61664C19.9565 7.61664 19.9565 8.45144 19.0433 8.45144C18.1302 8.45144 18.1302 7.61664 17.2171 7.61664Z" fill="#F3F3F3"/>
</g>
<defs>
<clipPath id="clip0_2087_4385">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const KZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4910)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"/>
<path d="M18.783 12.1301H5.21777C5.21777 13.0666 6.03345 13.8258 6.96987 13.8258H6.91343C6.91343 14.7623 7.67257 15.5214 8.60909 15.5214C8.60909 16.458 9.36823 17.2171 10.3047 17.2171H13.6961C14.6326 17.2171 15.3917 16.458 15.3917 15.5214C16.3282 15.5214 17.0874 14.7623 17.0874 13.8258H17.0309C17.9673 13.8258 18.783 13.0666 18.783 12.1301Z" fill="#FFDA44"/>
<path d="M16.696 9.91351C16.696 12.5068 14.5937 14.6092 12.0003 14.6092C9.40698 14.6092 7.30469 12.5068 7.30469 9.91351" fill="#338AF3"/>
<path d="M15.5865 9.9124L14.1209 10.6018L14.9014 12.0212L13.31 11.7167L13.1083 13.3243L11.9998 12.1419L10.8913 13.3243L10.6897 11.7167L9.09833 12.0211L9.87871 10.6017L8.41321 9.9124L9.87875 9.22305L9.09833 7.80372L10.6897 8.10813L10.8914 6.5005L11.9998 7.68293L13.1083 6.5005L13.31 8.10813L14.9014 7.80372L14.121 9.2231L15.5865 9.9124Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4910">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4953)">
<path d="M22.8094 6.78189C20.8684 2.76794 16.7576 -0.000732422 12.0001 -0.000732422C7.24254 -0.000732422 3.1318 2.76794 1.1908 6.78189L12.0001 7.82538L22.8094 6.78189Z" fill="#D80027"/>
<path d="M1.19055 17.2162C3.13155 21.2301 7.2423 23.9988 11.9998 23.9988C16.7574 23.9988 20.8681 21.2301 22.8091 17.2162L11.9998 16.1727L1.19055 17.2162Z" fill="#D80027"/>
<path d="M22.809 6.7818H1.19047C0.427631 8.35938 -0.000244141 10.1293 -0.000244141 11.9992C-0.000244141 13.8691 0.427631 15.639 1.19047 17.2166H22.809C23.5719 15.639 23.9998 13.8691 23.9998 11.9992C23.9998 10.1293 23.5719 8.35938 22.809 6.7818Z" fill="#0052B4"/>
<path d="M12.0002 16.1736C14.3054 16.1736 16.1741 14.3049 16.1741 11.9997C16.1741 9.69455 14.3054 7.82584 12.0002 7.82584C9.69501 7.82584 7.82629 9.69455 7.82629 11.9997C7.82629 14.3049 9.69501 16.1736 12.0002 16.1736Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4953">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LB = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4964)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0001 -0.000732422C7.24255 -0.000732422 3.1318 2.76794 1.1908 6.78189H22.8093C20.8684 2.76794 16.7576 -0.000732422 12.0001 -0.000732422Z" fill="#D80027"/>
<path d="M12.0003 23.9994C16.7578 23.9994 20.8686 21.2307 22.8096 17.2167H1.19104C3.13204 21.2307 7.24279 23.9994 12.0003 23.9994Z" fill="#D80027"/>
<path d="M15.1305 14.0862L12.0001 8.34705L8.86963 14.0862H11.2175V15.6514H12.7827V14.0862H15.1305Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_4964">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5587)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"/>
<path d="M7.56531 16.1739H16.4349L12.0001 5.73914L7.56531 16.1739Z" fill="#F3F3F3"/>
<path d="M9.10657 15.1303L12.0001 8.54858L14.8937 15.1303H9.10657Z" fill="#333333"/>
<path d="M7.56531 16.1745H16.4349L12.0001 12.0006L7.56531 16.1745Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5587">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4999)">
<path d="M24.0002 11.9995C24.0002 18.6269 18.6276 23.9995 12.0002 23.9995C5.37287 23.9995 0.000244141 18.6269 0.000244141 11.9995C0.521963 11.9995 12.0002 10.4343 12.0002 10.4343L24.0002 11.9995Z" fill="#D80027"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#0052B4"/>
<path d="M8.86986 8.34736C8.86986 7.48294 8.16908 6.78216 7.30466 6.78216C6.90365 6.78216 6.53816 6.9331 6.26118 7.18102V6.26039H6.7829V5.21691H6.26118V4.69519H5.21769V5.21691H4.69598V6.26039H5.21769V7.18102C4.94071 6.9331 4.57523 6.78216 4.17421 6.78216C3.30979 6.78216 2.60901 7.48294 2.60901 8.34736C2.60901 8.81082 2.81062 9.22707 3.13073 9.51371V10.4343H8.3481V9.51371C8.6683 9.22707 8.86986 8.81082 8.86986 8.34736Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4999">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5571)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z" fill="#FFDA44"/>
<path d="M9.391 2.08618H5.23623C5.05211 2.21204 4.87192 2.34306 4.69534 2.47867L3.65186 11.9992L4.69534 21.5197C4.87192 21.6554 5.05211 21.7864 5.23623 21.9122H9.391V2.08618Z" fill="#FF9811"/>
<path d="M0 12.0006C0 15.8793 1.84069 19.3275 4.69567 21.5211V2.48004C1.84069 4.6737 0 8.12193 0 12.0006Z" fill="#6DA544"/>
<path d="M19.3043 7.31537V7.61588L19.3155 7.61757L19.3043 7.31537Z" fill="#FFDA44"/>
<path d="M23.0435 15.1296H20.7826L19.8261 16.1731V18.2601H17.7391V17.2166H18.7826V15.1296H14.087V16.434H13.0435V13.9482C12.7233 13.6616 12.5217 13.2453 12.5217 12.7818V5.99922C12.5217 5.1348 13.2225 4.43401 14.087 4.43401V14.0862H16.1739L16.89 13.4894C16.7649 13.1915 16.6956 12.8644 16.6956 12.521V10.9558H15.1304V7.82538H18.2608C18.2608 7.30366 19.0435 6.78189 19.0435 6.78189C19.0435 6.78189 19.8261 7.30361 19.8261 7.82538V8.60801V10.9558C20.4066 10.9627 21.3288 10.9477 22.3251 10.9558C22.0634 10.4983 21.913 9.95548 21.913 9.39063C21.913 8.46996 22.3105 7.64224 22.9432 7.06943C22.0312 5.04841 20.576 3.32518 18.7634 2.08618H10.9565V21.9123H18.7635C20.9675 20.4057 22.6432 18.1833 23.4562 15.5799L23.0435 15.1296Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_5571">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4975)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M2.74292 4.36307H21.257C20.5732 3.53502 19.7801 2.80073 18.9003 2.18127H5.09965C4.21986 2.80063 3.42678 3.53498 2.74292 4.36307Z" fill="#F0F0F0"/>
<path d="M0 12.0005C0 12.3684 0.0174844 12.732 0.049875 13.0915H23.9501C23.9825 12.732 24 12.3684 24 12.0005C24 11.6327 23.9825 11.2691 23.9501 10.9097H0.049875C0.0174844 11.2691 0 11.6327 0 12.0005Z" fill="#F0F0F0"/>
<path d="M1.30884 17.4546H22.6917C23.0451 16.7634 23.3332 16.0335 23.5484 15.2729H0.452148C0.667258 16.0335 0.955539 16.7635 1.30884 17.4546Z" fill="#F0F0F0"/>
<path d="M5.09965 21.8181H18.9003C19.7801 21.1986 20.5732 20.4643 21.257 19.6363H2.74292C3.42678 20.4642 4.21986 21.1986 5.09965 21.8181Z" fill="#F0F0F0"/>
<path d="M0.452026 8.72788H23.5484C23.3332 7.96719 23.045 7.23725 22.6916 6.54608H1.30876C0.955464 7.23725 0.667183 7.96719 0.452026 8.72788Z" fill="#F0F0F0"/>
<path d="M5.73853 2.18186H18.8997C16.9478 0.807577 14.568 6.10352e-05 11.9994 6.10352e-05C10.4342 6.10352e-05 7.6904 0.807577 5.73853 2.18186Z" fill="#D80027"/>
<path d="M11.4783 6.54526H22.6914C22.2924 5.76465 21.8104 5.03345 21.257 4.36346H11.4783V6.54526Z" fill="#D80027"/>
<path d="M11.4783 10.9085H23.9501C23.8826 10.1593 23.747 9.42976 23.5482 8.72668H11.4783V10.9085Z" fill="#D80027"/>
<path d="M0.451439 15.2736H23.5477C23.7465 14.5706 23.8822 13.841 23.9497 13.0919H0.0494385C0.116938 13.841 0.252595 14.5706 0.451439 15.2736Z" fill="#D80027"/>
<path d="M2.7426 19.6369H21.2567C21.8101 18.9668 22.2921 18.2356 22.6911 17.4551H1.30823C1.70727 18.2357 2.18924 18.9669 2.7426 19.6369Z" fill="#D80027"/>
<path d="M11.9992 24.0005C14.5678 24.0005 16.9477 23.193 18.8995 21.8187H5.09888C7.05075 23.193 9.4306 24.0005 11.9992 24.0005Z" fill="#D80027"/>
<path d="M0.45188 8.72685C0.253036 9.42998 0.117427 10.1595 0.0499268 10.9087H12V-0.000427246C6.50724 -0.000427246 1.8765 3.69014 0.45188 8.72685Z" fill="#0052B4"/>
<path d="M7.14369 3.13049L7.92064 5.52182H10.4353L8.40102 6.99989L9.17792 9.39136L7.14369 7.91339L5.10936 9.39136L5.88645 6.99989L3.85217 5.52182H6.36669L7.14369 3.13049Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4975">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4970)">
<path d="M0 11.9999C0 13.8697 0.427828 15.6396 1.19072 17.2173L12 17.739L22.8093 17.2173C23.5722 15.6396 24 13.8697 24 11.9999C24 10.13 23.5722 8.36013 22.8093 6.78251L12 6.26074L1.19072 6.78246C0.427828 8.36013 0 10.13 0 11.9999Z" fill="#F0F0F0"/>
<path d="M12.0003 24.0001C16.7578 24.0001 20.8686 21.2314 22.8096 17.2175H1.19104C3.13204 21.2314 7.24279 24.0001 12.0003 24.0001Z" fill="#6DA544"/>
<path d="M12.0003 -0.000732422C7.24279 -0.000732422 3.13204 2.76794 1.19104 6.78189H22.8096C20.8686 2.76794 16.7578 -0.000732422 12.0003 -0.000732422Z" fill="#0052B4"/>
<path d="M12.7831 11.7392V8.86969H11.2179V11.7392L9.32739 13.6298C9.87719 14.5298 10.8686 15.1306 12.0005 15.1306C13.1323 15.1306 14.1237 14.5298 14.6736 13.6298L12.7831 11.7392Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_4970">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5003)">
<path d="M23.254 16.1743C23.7364 14.8744 24.0004 13.4683 24.0004 12.0005C24.0004 10.5326 23.7364 9.1265 23.254 7.82656L12.0004 6.78308L0.746757 7.82656C0.264366 9.1265 0.000366211 10.5326 0.000366211 12.0005C0.000366211 13.4683 0.264366 14.8744 0.746757 16.1743L12.0004 17.2178L23.254 16.1743Z" fill="#6DA544"/>
<path d="M23.2538 7.82568C21.5583 3.25607 17.1598 -0.000427246 12.0002 -0.000427246C6.84061 -0.000427246 2.4421 3.25607 0.746582 7.82568H23.2538Z" fill="#FFDA44"/>
<path d="M12.0003 24.0008C17.1599 24.0008 21.5584 20.7443 23.2539 16.1747H0.746704C2.44222 20.7443 6.84073 24.0008 12.0003 24.0008Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5003">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5007)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0002 -0.000366211C6.84061 -0.000366211 2.4421 3.25613 0.746582 7.82574H23.2538C21.5583 3.25613 17.1598 -0.000366211 12.0002 -0.000366211Z" fill="#D80027"/>
<path d="M12.0002 24.0008C17.1598 24.0008 21.5583 20.7443 23.2538 16.1747H0.746582C2.4421 20.7443 6.84061 24.0008 12.0002 24.0008Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_5007">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LV = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4959)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0005 -0.000732422C6.45622 -0.000732422 1.79094 3.75963 0.41394 8.86881H23.5872C22.2102 3.75963 17.5449 -0.000732422 12.0005 -0.000732422Z" fill="#A2001D"/>
<path d="M12.0003 23.9986C17.5446 23.9986 22.2099 20.2382 23.5869 15.129H0.413696C1.7907 20.2382 6.45598 23.9986 12.0003 23.9986Z" fill="#A2001D"/>
</g>
<defs>
<clipPath id="clip0_2087_4959">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const LY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4992)">
<path d="M1.19084 6.78274C0.427997 8.36037 0.00012207 10.1302 0.00012207 12.0001C0.00012207 13.87 0.427997 15.6399 1.19084 17.2175L12.0001 18.261L22.8094 17.2175C23.5722 15.6399 24.0001 13.87 24.0001 12.0001C24.0001 10.1302 23.5722 8.36037 22.8094 6.78274L12.0001 5.73926L1.19084 6.78274Z" fill="black"/>
<path d="M1.19141 17.2168C3.13231 21.2307 7.24273 23.9994 12.0003 23.9994C16.7577 23.9994 20.8682 21.2307 22.8091 17.2168H1.19141Z" fill="#496E2D"/>
<path d="M1.19141 6.78299H22.8091C20.8682 2.76904 16.7577 0.000366211 12.0003 0.000366211C7.24273 0.000366211 3.13231 2.76904 1.19141 6.78299Z" fill="#D80027"/>
<path d="M14.7933 9.80475L15.7779 11.1615L17.3724 10.6445L16.3863 12.0001L17.3707 13.3569L15.7768 12.8379L14.7906 14.1935L14.7917 12.5172L13.1976 11.9982L14.7922 11.4812L14.7933 9.80475Z" fill="#F0F0F0"/>
<path d="M12.1064 15.3904C10.2335 15.3904 8.7151 13.872 8.7151 11.9991C8.7151 10.1261 10.2335 8.60776 12.1064 8.60776C12.6904 8.60776 13.2399 8.75542 13.7196 9.01539C12.967 8.2794 11.9378 7.82513 10.8021 7.82513C8.49685 7.82513 6.62817 9.69385 6.62817 11.999C6.62817 14.3042 8.49689 16.1729 10.8021 16.1729C11.9378 16.1729 12.967 15.7187 13.7196 14.9827C13.2398 15.2427 12.6904 15.3904 12.1064 15.3904Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4992">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5139)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#E70015"/>
<path d="M19.0919 9.84775H13.6744L12.0003 4.69543L10.3262 9.84775H4.90869L9.29155 13.0321L7.61741 18.1845L12.0003 15.0002L16.3832 18.1846L14.7091 13.0321L19.0919 9.84775ZM10.5182 12.6335L11.0843 10.8912H12.9163L13.4824 12.6335V12.6335L12.0003 13.7103L10.5183 12.6335L10.5182 12.6335ZM12.5773 9.84775H11.4234L12.0003 8.07212L12.5773 9.84775ZM14.37 11.9886L14.0134 10.8912H15.8804L14.37 11.9886ZM9.98718 10.8912L9.6306 11.9886L8.12015 10.8912H9.98718ZM9.60224 15.4526L10.1792 13.6771L11.1127 14.3552L9.60224 15.4526ZM12.8879 14.3553L13.8215 13.6771L14.3984 15.4527L12.8879 14.3553Z" fill="#008300"/>
</g>
<defs>
<clipPath id="clip0_2087_5139">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5103)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5103">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MD = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5096)">
<path d="M17.2171 1.1913C15.6395 0.428455 13.8696 0.000579834 11.9998 0.000579834C10.1299 0.000579834 8.36 0.428455 6.78238 1.1913L5.73889 12.0006L6.78238 22.8099C8.36 23.5727 10.1299 24.0006 11.9998 24.0006C13.8696 24.0006 15.6395 23.5727 17.2171 22.8099L18.2606 12.0006L17.2171 1.1913Z" fill="#FFDA44"/>
<path d="M6.78262 1.19211C2.76872 3.13306 0 7.24348 0 12.001C0 16.7585 2.76872 20.8689 6.78262 22.8098V1.19211Z" fill="#0052B4"/>
<path d="M17.2174 1.19211V22.8098C21.2313 20.8689 24 16.7585 24 12.001C24 7.24348 21.2313 3.13306 17.2174 1.19211Z" fill="#D80027"/>
<path d="M16.1736 9.44225H13.304C13.304 8.72188 12.7201 8.13791 11.9997 8.13791C11.2793 8.13791 10.6954 8.72188 10.6954 9.44225H7.82581C7.82581 10.1515 8.44366 10.7264 9.15284 10.7264H9.11009C9.11009 11.4358 9.68506 12.0108 10.3944 12.0108C10.3944 12.6388 10.8454 13.1606 11.4411 13.2721L10.4291 15.5569C10.914 15.754 11.4439 15.8636 11.9997 15.8636C12.5554 15.8636 13.0854 15.754 13.5703 15.5569L12.5583 13.2721C13.154 13.1606 13.605 12.6388 13.605 12.0108C14.3143 12.0108 14.8893 11.4358 14.8893 10.7264H14.8465C15.5558 10.7264 16.1736 10.1515 16.1736 9.44225Z" fill="#FF9811"/>
<path d="M12 11.2177L10.3043 12.0003V13.5655L12 14.609L13.6956 13.5655V12.0003L12 11.2177Z" fill="#0052B4"/>
<path d="M13.6956 10.4341H10.3043V11.9993H13.6956V10.4341Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5096">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ME = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5119)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M24.0004 11.9997C24.0004 7.88125 21.9253 4.24778 18.7638 2.0867H5.23691C2.07552 4.24778 0.000366211 7.88125 0.000366211 11.9997C0.000366211 16.1183 2.07552 19.7517 5.23691 21.9128H18.7638C21.9253 19.7517 24.0004 16.1183 24.0004 11.9997Z" fill="#A2001D"/>
<path d="M9.39185 8.87012H14.6092V6.7832L13.5657 7.30492L12.0005 5.73972L10.4353 7.30492L9.39185 6.7832V8.87012Z" fill="#FFDA44"/>
<path d="M16.6962 12.0002H14.0885C14.1908 11.8233 14.2502 11.6186 14.2502 11.3996C14.2502 10.7346 13.7111 10.1956 13.0462 10.1956C12.5868 10.1956 12.1878 10.453 11.9848 10.8313C11.7817 10.453 11.3827 10.1956 10.9233 10.1956C10.2584 10.1956 9.71929 10.7346 9.71929 11.3996C9.71929 11.6187 9.77883 11.8234 9.88101 12.0002H7.30481C7.30481 12.7982 7.99983 13.445 8.79773 13.445H8.74964C8.74964 14.0995 9.18497 14.6522 9.78183 14.8297L8.60915 16.0025L9.71592 17.1092L11.2859 15.5392C11.3474 15.5618 11.411 15.5798 11.4768 15.5922L10.5281 17.7341C10.9827 17.919 11.4795 18.0216 12.0006 18.0216C12.5215 18.0216 13.0184 17.919 13.473 17.7341L12.5243 15.5922C12.5901 15.5798 12.6537 15.5618 12.7151 15.5392L14.2851 17.1092L15.3918 16.0025L14.2191 14.8297C14.8159 14.6521 15.2513 14.0996 15.2513 13.4451H15.2032C16.0012 13.445 16.6962 12.7982 16.6962 12.0002Z" fill="#FFDA44"/>
<path d="M12.0005 12.7828L10.3048 13.5654V15.1306L12.0005 16.1741L13.6961 15.1306V13.5654L12.0005 12.7828Z" fill="#6DA544"/>
<path d="M13.6961 11.9992H10.3048V14.0861H13.6961V11.9992Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5119">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5023)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M7.82629 11.9995V23.2531C9.12623 23.7355 10.5323 23.9995 12.0002 23.9995C18.6276 23.9995 24.0002 18.6268 24.0002 11.9995C24.0002 5.37208 7.82629 11.9995 7.82629 11.9995Z" fill="#6DA544"/>
<path d="M12.0002 0.000366211C10.5323 0.000366211 9.12623 0.264413 7.82629 0.746757V12.0004C7.82629 12.0004 18.4698 12.0004 24.0002 12.0004C24.0002 5.37299 18.6276 0.000366211 12.0002 0.000366211Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5023">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5055)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 9.98611 23.5031 8.08847 22.6265 6.42188L11.9859 12.0141L17.5781 1.37353C15.9115 0.496875 14.0139 0 12 0C5.37262 0 0 5.37262 0 12C0 15.3137 1.34316 18.3137 3.51469 20.4853C5.68627 22.6569 8.68627 24 12 24Z" fill="#0052B4"/>
<path d="M22.6141 6.43437C22.0648 5.38887 21.3507 4.40726 20.4716 3.52817C19.5925 2.64907 18.611 1.93493 17.5654 1.3857L3.50098 20.4987L22.6141 6.43437Z" fill="#F0F0F0"/>
<path d="M3.50098 20.4994L22.6141 6.43498C22.0648 5.38948 21.3507 4.40787 20.4716 3.52878L3.50098 20.4994Z" fill="#FF9811"/>
<path d="M10.4205 7.03688L8.95497 7.72623L9.73539 9.1456L8.14399 8.84115L7.94233 10.4488L6.83383 9.26635L5.72533 10.4488L5.52377 8.84115L3.93236 9.14551L4.71269 7.72618L3.24719 7.03688L4.71274 6.34749L3.93236 4.92821L5.52368 5.23257L5.72538 3.62495L6.83383 4.80737L7.94233 3.62495L8.14399 5.23257L9.73544 4.92821L8.95502 6.34754L10.4205 7.03688Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5055">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5351)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M13.8251 23.8624C15.7767 23.5646 17.5733 22.796 19.0964 21.6771L12.0001 12.0003L13.8251 23.8624Z" fill="#D80027"/>
<path d="M10.1754 0.137695C8.22371 0.435445 6.42718 1.20401 4.90393 2.32287L12.0003 11.9997L10.1754 0.137695Z" fill="#D80027"/>
<path d="M4.90393 21.6771C6.42709 22.796 8.22362 23.5646 10.1753 23.8624L12.0003 12.0003L4.90393 21.6771Z" fill="#D80027"/>
<path d="M2.32348 4.90234C1.20457 6.42559 0.436103 8.22208 0.138306 10.1738L12.0004 11.9988L2.32348 4.90234Z" fill="#D80027"/>
<path d="M0.138306 13.8252C0.436056 15.7769 1.20462 17.5735 2.32352 19.0966L12.0004 12.0003L0.138306 13.8252Z" fill="#D80027"/>
<path d="M23.8622 10.174C23.5644 8.22233 22.7959 6.42579 21.6769 4.90259L12.0001 11.999L23.8622 10.174Z" fill="#D80027"/>
<path d="M19.0964 2.32282C17.5732 1.20396 15.7767 0.435445 13.8251 0.137695L12.0001 11.9997L19.0964 2.32282Z" fill="#D80027"/>
<path d="M21.677 19.0967C22.7959 17.5735 23.5644 15.7769 23.8623 13.8253L12.0001 12.0003L21.677 19.0967Z" fill="#D80027"/>
<path d="M12.0003 16.1743C14.3055 16.1743 16.1742 14.3056 16.1742 12.0004C16.1742 9.69525 14.3055 7.82654 12.0003 7.82654C9.69513 7.82654 7.82642 9.69525 7.82642 12.0004C7.82642 14.3056 9.69513 16.1743 12.0003 16.1743Z" fill="#D80027"/>
<path d="M12.0001 15.1297C13.729 15.1297 15.1305 13.7281 15.1305 11.9992C15.1305 10.2703 13.729 8.86877 12.0001 8.86877C10.2712 8.86877 8.86963 10.2703 8.86963 11.9992C8.86963 13.7281 10.2712 15.1297 12.0001 15.1297Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5351">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5047)">
<path d="M16.1742 0.745887C14.8742 0.263543 13.4682 -0.00050354 12.0003 -0.00050354C10.5325 -0.00050354 9.12643 0.263543 7.82644 0.745887L6.78296 11.9995L7.82644 23.2531C9.12643 23.7355 10.5325 23.9995 12.0003 23.9995C13.4682 23.9995 14.8742 23.7355 16.1742 23.2531L17.2177 11.9995L16.1742 0.745887Z" fill="#FFDA44"/>
<path d="M23.9996 12.0002C23.9996 6.84066 20.7431 2.4421 16.1735 0.746628V23.2539C20.7431 21.5583 23.9996 17.1598 23.9996 12.0002Z" fill="#D80027"/>
<path d="M0.00012207 11.9994C0.00012207 17.159 3.25662 21.5575 7.82623 23.2531V0.74585C3.25662 2.44132 0.00012207 6.83988 0.00012207 11.9994Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5047">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5151)">
<path d="M23.2535 16.1744C23.7359 14.8744 23.9999 13.4683 23.9999 12.0005C23.9999 10.5326 23.7359 9.1265 23.2535 7.82657L11.9999 6.78308L0.746269 7.82657C0.263925 9.1265 -0.00012207 10.5326 -0.00012207 12.0005C-0.00012207 13.4683 0.263925 14.8744 0.746269 16.1744L11.9999 17.2178L23.2535 16.1744Z" fill="#6DA544"/>
<path d="M23.2536 7.82605C21.558 3.25644 17.1595 -6.10352e-05 11.9999 -6.10352e-05C6.84037 -6.10352e-05 2.44185 3.25644 0.746338 7.82605H23.2536Z" fill="#FFDA44"/>
<path d="M11.9998 23.9991C17.1594 23.9991 21.5579 20.7426 23.2534 16.173H0.746216C2.44173 20.7426 6.84025 23.9991 11.9998 23.9991Z" fill="#D80027"/>
<path d="M20.2292 10.153H13.9429L12.0003 4.17438L10.0577 10.153H3.77148L8.85719 13.8479L6.91459 19.8266L12.0003 16.1744L17.0861 19.8265L15.1435 13.8479L20.2292 10.153Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5151">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5106)">
<path d="M11.9996 24.0006C13.4675 24.0006 14.8736 23.7366 16.1735 23.2542L16.6953 12.0006L16.1735 0.74697C14.8736 0.264627 13.4675 0.000579834 11.9996 0.000579834C10.5318 0.000579834 9.12566 0.264627 7.82572 0.74697L7.30396 12.0006L7.82567 23.2542C9.12566 23.7366 10.5318 24.0006 11.9996 24.0006Z" fill="#0052B4"/>
<path d="M-0.000244141 12C-0.000244141 17.1596 3.25626 21.5581 7.82587 23.2536V0.746429C3.25626 2.44195 -0.000244141 6.84046 -0.000244141 12Z" fill="#A2001D"/>
<path d="M16.1736 0.745972V23.2532C20.7432 21.5577 23.9997 17.1592 23.9997 11.9996C23.9997 6.84 20.7432 2.44149 16.1736 0.745972Z" fill="#A2001D"/>
<path d="M6.78262 11.9989H5.73914V16.1728H6.78262V11.9989Z" fill="#FFDA44"/>
<path d="M2.60867 11.9989H1.56519V16.1728H2.60867V11.9989Z" fill="#FFDA44"/>
<path d="M4.17361 14.6085C4.74991 14.6085 5.2171 14.1413 5.2171 13.565C5.2171 12.9887 4.74991 12.5215 4.17361 12.5215C3.59731 12.5215 3.13013 12.9887 3.13013 13.565C3.13013 14.1413 3.59731 14.6085 4.17361 14.6085Z" fill="#FFDA44"/>
<path d="M4.17382 10.4336C4.46196 10.4336 4.69554 10.2001 4.69554 9.91192C4.69554 9.62378 4.46196 9.3902 4.17382 9.3902C3.88568 9.3902 3.6521 9.62378 3.6521 9.91192C3.6521 10.2001 3.88568 10.4336 4.17382 10.4336Z" fill="#FFDA44"/>
<path d="M5.21722 15.1289H3.13025V16.1724H5.21722V15.1289Z" fill="#FFDA44"/>
<path d="M5.21722 10.9551H3.13025V11.9986H5.21722V10.9551Z" fill="#FFDA44"/>
<path d="M4.17433 6.26004L4.5439 7.39723H5.73958L4.77232 8.10007L5.1416 9.23726L4.17433 8.53442L3.20711 9.23726L3.5764 8.10007L2.60913 7.39723H3.80482L4.17433 6.26004Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5106">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5011)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"/>
<path d="M14.0869 11.5003C13.7923 11.5003 13.5126 11.559 13.2529 11.6525C13.3952 11.3354 13.4906 10.9826 13.4906 10.6059C13.4906 9.11521 11.9999 7.99719 11.9999 7.99719C11.9999 7.99719 10.5093 9.11521 10.5093 10.6059C10.5093 10.9826 10.6046 11.3354 10.7469 11.6525C10.4872 11.5591 10.2075 11.5003 9.91301 11.5003C8.42234 11.5003 7.30432 12.9909 7.30432 12.9909C7.30432 12.9909 8.42234 14.4816 9.91301 14.4816C10.787 14.4816 11.5324 13.9694 12 13.5454C12.4676 13.9693 13.213 14.4816 14.0869 14.4816C15.5776 14.4816 16.6956 12.9909 16.6956 12.9909C16.6956 12.9909 15.5775 11.5003 14.0869 11.5003Z" fill="#F0F0F0"/>
<path d="M12.0005 4.69458L12.3084 5.64221H13.3048L12.4988 6.22796L12.8065 7.17558L12.0005 6.58983L11.1945 7.17558L11.5022 6.22796L10.6962 5.64221H11.6926L12.0005 4.69458Z" fill="#FFDA44"/>
<path d="M8.2111 6.35156L8.80351 6.88491L9.49384 6.48637L9.16965 7.21458L9.76201 7.74802L8.96926 7.66467L8.64507 8.39288L8.47923 7.6132L7.68652 7.52986L8.3768 7.13123L8.2111 6.35156Z" fill="#FFDA44"/>
<path d="M5.43762 9.12594L6.21734 9.29164L6.61592 8.60132L6.69926 9.39402L7.47889 9.55986L6.75073 9.8841L6.83408 10.6768L6.30059 10.0845L5.57243 10.4087L5.97101 9.7183L5.43762 9.12594Z" fill="#FFDA44"/>
<path d="M15.7896 6.35156L15.1973 6.88491L14.5069 6.48637L14.8311 7.21458L14.2388 7.74802L15.0315 7.66467L15.3557 8.39288L15.5216 7.6132L16.3143 7.52986L15.624 7.13123L15.7896 6.35156Z" fill="#FFDA44"/>
<path d="M18.5631 9.12594L17.7834 9.29164L17.3849 8.60132L17.3015 9.39402L16.5219 9.55986L17.25 9.8841L17.1667 10.6768L17.7001 10.0845L18.4283 10.4087L18.0297 9.7183L18.5631 9.12594Z" fill="#FFDA44"/>
<path d="M11.9997 18.6554C13.1838 18.6554 14.2752 18.2604 15.1507 17.5956H8.84863C9.72416 18.2603 10.8156 18.6554 11.9997 18.6554Z" fill="#F0F0F0"/>
<path d="M7.21716 15.5244C7.38277 15.9034 7.59277 16.2584 7.83943 16.5842H16.1606C16.4072 16.2584 16.6172 15.9034 16.7829 15.5244H7.21716Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5011">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MP = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5247)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"/>
<path d="M11.6213 19.5561C11.2978 19.5405 11.0302 19.3302 10.9253 19.0448C10.7401 19.2864 10.4218 19.4079 10.1083 19.3271C9.79418 19.2462 9.57457 18.9864 9.52915 18.6848C9.29852 18.8841 8.96252 18.9383 8.67195 18.7959C8.38081 18.653 8.21806 18.354 8.23474 18.0498C7.9692 18.199 7.62902 18.1844 7.37285 17.9861C7.1172 17.7879 7.01754 17.4628 7.09474 17.168C6.80463 17.2609 6.47492 17.1785 6.2636 16.9327C6.05229 16.6875 6.0199 16.3489 6.15457 16.076C5.85195 16.1083 5.5452 15.9612 5.3876 15.6785C5.22949 15.3957 5.26606 15.0571 5.45332 14.8165C5.15018 14.7873 4.87887 14.5812 4.78184 14.2723C4.68429 13.9635 4.78863 13.639 5.02081 13.4412C4.72967 13.3514 4.50635 13.0947 4.47349 12.7728C4.44063 12.451 4.6076 12.1551 4.87418 12.008C4.60756 11.8619 4.43956 11.5661 4.47138 11.2447C4.47138 11.2447 4.47138 11.2447 4.4719 11.2447C4.50373 10.9222 4.72704 10.6651 5.01762 10.5742C4.78545 10.377 4.68007 10.053 4.77659 9.74411C4.8731 9.43473 5.14385 9.22811 5.44704 9.19782C5.25973 8.95782 5.22218 8.61915 5.37921 8.33593C5.53624 8.05314 5.84304 7.90548 6.14618 7.93731C6.01052 7.66445 6.04235 7.32583 6.25315 7.07959C6.46343 6.83387 6.79315 6.7509 7.08377 6.84273C7.00549 6.54845 7.10463 6.2229 7.36029 6.02415C7.61543 5.82531 7.9556 5.81017 8.22115 5.95834C8.20395 5.65422 8.36618 5.3552 8.65681 5.21172C8.94692 5.06875 9.28343 5.122 9.51452 5.32126C9.55887 5.01976 9.77852 4.7589 10.0921 4.67743C10.4051 4.59606 10.7234 4.71657 10.9091 4.95761C11.014 4.67223 11.2811 4.46143 11.6046 4.44526C11.9276 4.42862 12.2145 4.61012 12.3481 4.88308C12.5077 4.62428 12.8114 4.4709 13.1312 4.51942C13.4516 4.56742 13.6973 4.8032 13.7735 5.09804C13.9822 4.87572 14.3109 4.78759 14.6145 4.8992C14.9187 5.01137 15.1117 5.29206 15.1264 5.59675C15.3752 5.42148 15.7154 5.40109 15.9904 5.57223C16.2653 5.74286 16.3973 6.0564 16.3504 6.35743C16.6295 6.23589 16.9665 6.2844 17.2013 6.50664C17.4361 6.72943 17.5029 7.06281 17.3965 7.34818C17.6944 7.28504 18.0147 7.39984 18.2005 7.66539C18.3862 7.93042 18.3846 8.27059 18.2234 8.52887C18.5276 8.52676 18.8182 8.70418 18.9471 9.00104C19.0754 9.29842 19.005 9.63184 18.7947 9.85253C19.0937 9.91201 19.3426 10.1442 19.4083 10.4614C19.4735 10.7786 19.3373 11.0901 19.0874 11.2638C19.3671 11.3823 19.5643 11.6593 19.5648 11.9828C19.5648 11.9864 19.5648 11.9896 19.5648 11.9933C19.5648 11.9954 19.5648 11.998 19.5648 12.0001C19.5648 12.3235 19.3686 12.6011 19.089 12.7206C19.3394 12.8933 19.4766 13.2047 19.4114 13.5219C19.3467 13.8392 19.0984 14.0719 18.7994 14.1324C19.0102 14.3526 19.0817 14.6854 18.9539 14.9834C18.8261 15.2807 18.5354 15.4587 18.2307 15.4571C18.3925 15.7154 18.3951 16.0555 18.2099 16.3211C18.0247 16.5867 17.7049 16.7025 17.4069 16.6399C17.5139 16.9247 17.4476 17.2587 17.2134 17.482C16.9786 17.7048 16.6421 17.7538 16.3629 17.6333C16.4104 17.9338 16.2789 18.2479 16.0045 18.4196C15.73 18.5912 15.3898 18.5714 15.1405 18.3966C15.1264 18.7013 14.9344 18.9826 14.6307 19.0952C14.6307 19.0952 14.6307 19.0952 14.6302 19.0952C14.3266 19.2074 13.9979 19.1198 13.7887 18.8981C13.7135 19.1934 13.4683 19.4297 13.148 19.4788C12.8282 19.5273 12.524 19.3749 12.3638 19.1162C12.2365 19.3786 11.9673 19.557 11.6605 19.557C11.6474 19.5572 11.6344 19.5567 11.6213 19.5561Z" fill="#F3F3F3"/>
<path d="M12.0003 17.2183C14.8818 17.2183 17.2177 14.8824 17.2177 12.0009C17.2177 9.11943 14.8818 6.78354 12.0003 6.78354C9.11886 6.78354 6.78296 9.11943 6.78296 12.0009C6.78296 14.8824 9.11886 17.2183 12.0003 17.2183Z" fill="#338AF3"/>
<path d="M13.1418 10.2289C13.3981 10.0388 13.565 9.73489 13.565 9.3912V8.86948C13.565 8.29316 13.0978 7.826 12.5215 7.826H11.478C10.9017 7.826 10.4346 8.29316 10.4346 8.86948V9.3912C10.4346 9.73489 10.6014 10.0388 10.8577 10.2289L9.91284 19.826C9.91284 19.826 10.4346 20.3478 11.9998 20.3478C13.5651 20.3478 14.0868 19.826 14.0868 19.826L13.1418 10.2289Z" fill="#BDBCC1"/>
<path d="M12.0001 7.826L12.9066 10.6159H15.8403L13.467 12.3403L14.3734 15.1303L12.0001 13.406L9.62675 15.1303L10.5334 12.3403L8.16003 10.6159H11.0936L12.0001 7.826Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5247">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MQ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5060)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.8969 10.4354C23.5659 7.90477 22.4291 5.45948 20.485 3.51534C18.5409 1.5712 16.0955 0.434437 13.5649 0.103406L13.565 10.4354H23.8969Z" fill="#0052B4"/>
<path d="M10.4346 0.10405C7.90402 0.435081 5.45869 1.5718 3.51455 3.51594C1.57046 5.46013 0.433692 7.90546 0.102661 10.4361L10.4347 10.436L10.4346 0.10405Z" fill="#0052B4"/>
<path d="M0.103027 13.5664C0.434059 16.097 1.57082 18.5424 3.51492 20.4865C5.45906 22.4306 7.90434 23.5673 10.435 23.8984L10.435 13.5665L0.103027 13.5664Z" fill="#0052B4"/>
<path d="M13.5649 23.8983C16.0955 23.5673 18.5408 22.4306 20.485 20.4864C22.4291 18.5423 23.5658 16.097 23.8968 13.5664H13.5649V23.8983Z" fill="#0052B4"/>
<path d="M16.0963 7.61472C16.0963 7.45515 16.226 7.32545 16.3856 7.32545H17.0055C17.9854 7.32545 18.7826 6.52829 18.7826 5.54847C18.7826 4.56864 17.9854 3.77143 17.0055 3.77143H16.4168C16.2247 3.6271 15.9669 3.53809 15.6826 3.53809C15.0895 3.53809 14.6087 3.9227 14.6087 4.39717C14.6087 4.86704 15.0803 5.24823 15.6655 5.25564L15.6652 5.25906H17.0055C17.1651 5.25906 17.2948 5.38881 17.2948 5.54837C17.2948 5.70793 17.1651 5.83764 17.0055 5.83764H16.3856C15.4058 5.83764 14.6086 6.63479 14.6086 7.61462C14.6086 8.59445 15.4057 9.39165 16.3856 9.39165H18.7825V7.90394H16.3856C16.226 7.90398 16.0963 7.77428 16.0963 7.61472Z" fill="#F0F0F0"/>
<path d="M6.70491 7.61484C6.70491 7.45528 6.83461 7.32557 6.99422 7.32557H7.6141C8.59397 7.32557 9.39118 6.52842 9.39118 5.54859C9.39118 4.56876 8.59402 3.77156 7.6141 3.77156H7.02544C6.8333 3.62723 6.57554 3.53821 6.29119 3.53821C5.69808 3.53821 5.21729 3.92282 5.21729 4.39729C5.21729 4.86717 5.68889 5.24835 6.27408 5.25576L6.2738 5.25918H7.61414C7.77375 5.25918 7.90346 5.38893 7.90346 5.54849C7.90346 5.70806 7.77375 5.83776 7.61414 5.83776H6.99427C6.01439 5.83776 5.21729 6.63492 5.21729 7.61475C5.21729 8.59457 6.01435 9.39178 6.99427 9.39178H9.39113V7.90406H6.99422C6.83461 7.90411 6.70491 7.7744 6.70491 7.61484Z" fill="#F0F0F0"/>
<path d="M16.0964 18.6859C16.0964 18.5264 16.2261 18.3967 16.3857 18.3967H17.0056C17.9854 18.3967 18.7826 17.5995 18.7826 16.6197C18.7826 15.6398 17.9855 14.8426 17.0056 14.8426H16.4169C16.2248 14.6983 15.967 14.6093 15.6826 14.6093C15.0895 14.6093 14.6087 14.994 14.6087 15.4684C14.6087 15.9383 15.0803 16.3194 15.6655 16.3268L15.6652 16.3303H17.0055C17.1651 16.3303 17.2948 16.46 17.2948 16.6196C17.2948 16.7791 17.1651 16.9088 17.0055 16.9088H16.3856C15.4058 16.9088 14.6086 17.706 14.6086 18.6858C14.6086 19.6657 15.4057 20.4629 16.3856 20.4629H18.7826V18.9752H16.3857C16.2261 18.9752 16.0964 18.8454 16.0964 18.6859Z" fill="#F0F0F0"/>
<path d="M6.70483 18.6859C6.70483 18.5264 6.83454 18.3967 6.99415 18.3967H7.61402C8.59389 18.3967 9.3911 17.5995 9.3911 16.6197C9.3911 15.6398 8.59394 14.8426 7.61402 14.8426H7.02536C6.83322 14.6983 6.57546 14.6093 6.29112 14.6093C5.69796 14.6093 5.21716 14.994 5.21716 15.4684C5.21716 15.9383 5.68877 16.3194 6.27396 16.3268L6.27368 16.3303H7.61402C7.77363 16.3303 7.90333 16.46 7.90333 16.6196C7.90333 16.7791 7.77363 16.9088 7.61402 16.9088H6.99415C6.01427 16.9088 5.21716 17.706 5.21716 18.6858C5.21716 19.6657 6.01423 20.4629 6.99415 20.4629H9.39105V18.9752H6.99415C6.83454 18.9752 6.70483 18.8454 6.70483 18.6859Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5060">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5072)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"/>
<path d="M11.9997 13.8637C10.0016 13.8637 8.33238 12.4594 7.92284 10.5842C7.85993 10.8725 7.82581 11.1714 7.82581 11.4786C7.82581 13.7839 9.69448 15.6525 11.9997 15.6525C14.3049 15.6525 16.1736 13.7838 16.1736 11.4786C16.1736 11.1714 16.1395 10.8725 16.0766 10.5841C15.667 12.4595 13.9978 13.8637 11.9997 13.8637Z" fill="#FFDA44"/>
<path d="M11.9999 8.3478L12.3884 9.54354H13.6457L12.6285 10.2825L13.017 11.4783L11.9999 10.7392L10.9827 11.4783L11.3713 10.2825L10.3541 9.54354H11.6114L11.9999 8.3478Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5072">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5127)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9684 11.9998H12.0005C12.0005 11.989 12.0005 11.9784 12.0005 11.9676C11.9898 11.9783 11.9791 11.9891 11.9684 11.9998Z" fill="#F0F0F0"/>
<path d="M12.0005 6.26129C12.0005 4.1498 12.0005 2.76629 12.0005 0.000427246H11.9985C5.37194 0.00155225 0.000488281 5.37366 0.000488281 12.0004H6.26134V8.47491L9.78686 12.0004H11.9684C11.9791 11.9897 11.9898 11.9791 12.0005 11.9683C12.0005 11.1599 12.0005 10.4385 12.0005 9.7869L8.47492 6.26129H12.0005Z" fill="#F0F0F0"/>
<path d="M6.07124 1.56549C4.19441 2.63419 2.63409 4.19448 1.56543 6.0713V12.0003H4.69588V4.69604V4.69594H12.0002C12.0002 3.70862 12.0002 2.76802 12.0002 1.56549H6.07124Z" fill="#D80027"/>
<path d="M12.0005 10.5243L7.73698 6.26086H6.26135V6.26096L12.0004 12H12.0005C12.0005 12 12.0005 10.9824 12.0005 10.5243Z" fill="#D80027"/>
<path d="M13.5649 6.2605V11.9996C13.5649 14.7952 17.2171 15.6518 17.2171 15.6518C17.2171 15.6518 20.8693 14.7952 20.8693 11.9996V6.2605H13.5649Z" fill="#338AF3"/>
<path d="M13.5649 11.9992C13.5649 14.7948 17.2171 15.6514 17.2171 15.6514C17.2171 15.6514 20.8693 14.7948 20.8693 11.9992H13.5649Z" fill="#A2001D"/>
<path d="M18.7823 8.86909H17.7388V7.82556H16.6953V8.86909H15.6519V9.91253H16.6953V13.0429H17.7388V9.91253H18.7823V8.86909Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_5127">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5051)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9998 -0.000495911C18.6271 -0.000495911 23.9998 5.37213 23.9998 11.9995C23.9998 18.6269 18.6271 23.9995 11.9998 23.9995" fill="#D80027"/>
<path d="M8.34749 4.69622V3.13102H6.78229V4.69622H5.21704V6.26142H6.78229V7.82667H8.34749V6.26142H9.9127V4.69622H8.34749Z" fill="#ACABB1"/>
</g>
<defs>
<clipPath id="clip0_2087_5051">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5077)">
<path d="M1.45862 6.26036L11.9995 7.30385L22.5405 6.26036C20.5052 2.53024 16.5481 -0.000495911 11.9995 -0.000495911C7.45102 -0.000495911 3.49388 2.53024 1.45862 6.26036Z" fill="#D80027"/>
<path d="M1.45883 17.7384L11.9998 18.7819L22.5407 17.7384C23.4709 16.0335 23.9998 14.0782 23.9998 11.9993L11.9998 10.9558L-0.000244141 11.9993C-0.000244141 14.0782 0.528647 16.0335 1.45883 17.7384Z" fill="#FFDA44"/>
<path d="M1.45883 6.26097C0.528647 7.96586 -0.000244141 9.92121 -0.000244141 12.0001H23.9998C23.9998 9.92121 23.4709 7.96586 22.5407 6.26097H11.9998H1.45883Z" fill="#0052B4"/>
<path d="M11.9995 23.9996C16.5481 23.9996 20.5052 21.4688 22.5405 17.7387H1.45862C3.49388 21.4688 7.45102 23.9996 11.9995 23.9996Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5077">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MV = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5043)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M19.826 6.26099H4.17383V17.7393H19.826V6.26099Z" fill="#6DA544"/>
<path d="M13.9322 15.3913C12.0593 15.3913 10.5409 13.8729 10.5409 12C10.5409 10.127 12.0593 8.60867 13.9322 8.60867C14.5162 8.60867 15.0657 8.75633 15.5454 9.0163C14.7928 8.28032 13.7637 7.82605 12.6279 7.82605C10.3227 7.82605 8.45398 9.69477 8.45398 11.9999C8.45398 14.3051 10.3227 16.1738 12.6279 16.1738C13.7637 16.1738 14.7929 15.7196 15.5454 14.9836C15.0657 15.2436 14.5162 15.3913 13.9322 15.3913Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5043">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5027)">
<path d="M-0.00012207 11.9997C-0.00012207 13.4676 0.263925 14.8736 0.746269 16.1736L11.9999 16.6954L23.2535 16.1737C23.7359 14.8736 23.9999 13.4676 23.9999 11.9997C23.9999 10.5319 23.7359 9.12583 23.2535 7.82584L11.9999 7.30408L0.746269 7.8258C0.263925 9.12583 -0.00012207 10.5319 -0.00012207 11.9997Z" fill="#D80027"/>
<path d="M11.9998 -0.000366211C6.84025 -0.000366211 2.44173 3.25613 0.746216 7.82574H23.2535C21.5579 3.25613 17.1594 -0.000366211 11.9998 -0.000366211Z" fill="black"/>
<path d="M23.2534 16.1747H0.746216C2.44173 20.7442 6.84025 24.0008 11.9998 24.0008C17.1594 24.0008 21.5579 20.7442 23.2534 16.1747Z" fill="#496E2D"/>
<path d="M15.5865 5.73994L14.121 5.0506L14.9014 3.63127L13.31 3.93572L13.1083 2.328L11.9998 3.51042L10.8914 2.328L10.6897 3.93572L9.09833 3.63127L9.87875 5.0506L8.41321 5.73994H15.5865Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5027">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MX = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5082)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9999 11.9997C23.9999 7.24218 21.2312 3.13143 17.2173 1.19043V22.8089C21.2312 20.868 23.9999 16.7572 23.9999 11.9997Z" fill="#D80027"/>
<path d="M-0.00012207 11.9997C-0.00012207 16.7572 2.76855 20.868 6.7825 22.809V1.19043C2.76855 3.13143 -0.00012207 7.24218 -0.00012207 11.9997Z" fill="#6DA544"/>
<path d="M8.86951 11.9993C8.86951 13.7282 10.2711 15.1297 12 15.1297C13.7289 15.1297 15.1304 13.7282 15.1304 11.9993V10.9558H8.86951V11.9993Z" fill="#6DA544"/>
<path d="M16.1734 9.91339H13.043C13.043 9.33711 12.5758 8.8699 11.9995 8.8699C11.4232 8.8699 10.956 9.33711 10.956 9.91339H7.82556C7.82556 10.4897 8.32755 10.9569 8.90378 10.9569H8.86905C8.86905 11.5332 9.3362 12.0004 9.91253 12.0004C9.91253 12.5767 10.3797 13.0438 10.956 13.0438H13.043C13.6193 13.0438 14.0865 12.5767 14.0865 12.0004C14.6628 12.0004 15.13 11.5332 15.13 10.9569H15.0952C15.6715 10.9569 16.1734 10.4897 16.1734 9.91339Z" fill="#FF9811"/>
</g>
<defs>
<clipPath id="clip0_2087_5082">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5032)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.4784 12.0002H24.0001C24.0001 10.9171 23.8557 9.86791 23.5867 8.86975H11.4784V12.0002Z" fill="#D80027"/>
<path d="M11.4784 5.73873H22.2388C21.5043 4.54004 20.5651 3.48053 19.47 2.60828H11.4784V5.73873Z" fill="#D80027"/>
<path d="M12.0001 24.0002C14.8243 24.0002 17.4201 23.024 19.47 21.3915H4.53027C6.58016 23.024 9.17596 24.0002 12.0001 24.0002Z" fill="#D80027"/>
<path d="M1.76146 18.2601H22.2389C22.8286 17.2978 23.2859 16.2459 23.5868 15.1296H0.413574C0.714371 16.2459 1.17173 17.2978 1.76146 18.2601Z" fill="#D80027"/>
<path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4"/>
<path d="M7.98001 10.2709C6.34117 10.2709 5.01263 8.94229 5.01263 7.30349C5.01263 5.6647 6.34121 4.33612 7.98001 4.33612C8.491 4.33612 8.97179 4.46535 9.39156 4.69279C8.73306 4.04887 7.8325 3.65137 6.8387 3.65137C4.82171 3.65137 3.18652 5.28651 3.18652 7.30354C3.18652 9.32057 4.82171 10.9557 6.8387 10.9557C7.8325 10.9557 8.73306 10.5582 9.39156 9.91429C8.97179 10.1416 8.49104 10.2709 7.98001 10.2709Z" fill="#FFDA44"/>
<path d="M8.81659 5.21729L9.34342 6.31894L10.5332 6.04407L10.0004 7.14277L10.9572 7.90153L9.7659 8.17008L9.76923 9.39122L8.81659 8.62725L7.8639 9.39122L7.86718 8.17008L6.6759 7.90153L7.63272 7.14277L7.09989 6.04407L8.28972 6.31894L8.81659 5.21729Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5032">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const MZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5142)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M6.48568 16.696L3.51465 20.4852C5.68609 22.6569 8.68576 24.0003 11.9995 24.0003C16.9603 24.0003 21.2172 20.9896 23.0447 16.696H6.48568Z" fill="#FFDA44"/>
<path d="M23.0634 7.34841C21.2461 3.03164 16.9771 0.000610352 11.9995 0.000610352C8.68576 0.000610352 5.68609 1.344 3.51465 3.51572L6.51981 7.34841H23.0634Z" fill="#496E2D"/>
<path d="M2.60864 8.82593V15.1302H23.5866C23.8558 14.1322 23.9999 13.083 23.9999 11.9998C23.9999 10.901 23.8519 9.83693 23.5752 8.82593H2.60864Z" fill="black"/>
<path d="M3.51434 3.51428C-1.17194 8.20056 -1.17194 15.7986 3.51434 20.4849C5.45089 18.5484 7.31337 16.6859 11.9997 11.9996L3.51434 3.51428Z" fill="#A2001D"/>
<path d="M4.85694 8.86945L5.6339 11.2608H8.14855L6.11427 12.7389L6.89118 15.1304L4.85694 13.6523L2.82262 15.1304L3.59971 12.7389L1.56543 11.2608H4.0799L4.85694 8.86945Z" fill="#FFDA44"/>
<path d="M7.13101 11.9992H2.58301V14.0862H7.13101V11.9992Z" fill="#F0F0F0"/>
<path d="M7.99216 9.60735L7.2543 8.86945L4.85674 11.267L2.45917 8.86945L1.72131 9.60735L4.12099 12.0028L1.72131 14.4025L2.45917 15.1304L4.85674 12.7371L7.2543 15.1304L7.99216 14.4025L5.59249 12.0028L7.99216 9.60735Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_5142">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5156)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M3.51451 20.4849C4.0179 20.9883 4.55499 21.4372 5.11838 21.8325L21.8326 5.11826C21.4374 4.55487 20.9884 4.01778 20.485 3.51439C19.9816 3.011 19.4445 2.56212 18.8811 2.16687L2.16699 18.8811C2.5622 19.4444 3.01112 19.9815 3.51451 20.4849Z" fill="#A2001D"/>
<path d="M3.51501 3.51478C-0.270799 7.30059 -0.99755 12.9862 1.33322 17.5022L17.5024 1.33307C12.9863 -0.997692 7.30073 -0.270848 3.51501 3.51478Z" fill="#0052B4"/>
<path d="M20.4858 20.4847C24.2715 16.699 24.9982 11.0134 22.6676 6.49731L6.49841 22.6665C11.0144 24.9972 16.7 24.2705 20.4858 20.4847Z" fill="#496E2D"/>
<path d="M9.9132 6.78182L8.56854 7.41431L9.2846 8.71659L7.82449 8.43731L7.63943 9.91223L6.62243 8.8274L5.60538 9.91223L5.42042 8.43731L3.96026 8.71654L4.67627 7.41426L3.33167 6.78182L4.67632 6.14929L3.96026 4.8471L5.42037 5.12638L5.60543 3.65137L6.62243 4.73624L7.63948 3.65137L7.82449 5.12638L9.2846 4.8471L8.56863 6.14934L9.9132 6.78182Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5156">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5205)">
<path d="M1.19035 6.78213C0.427509 8.35976 -0.000366211 10.1296 -0.000366211 11.9995C-0.000366211 13.8694 0.427509 15.6393 1.19035 17.2169L11.9996 18.2604L22.8089 17.2169C23.5718 15.6393 23.9996 13.8694 23.9996 11.9995C23.9996 10.1296 23.5718 8.35976 22.8089 6.78213L11.9996 5.73865L1.19035 6.78213Z" fill="#F0F0F0"/>
<path d="M1.19092 17.2183C3.13182 21.2322 7.24225 24.0009 11.9998 24.0009C16.7573 24.0009 20.8677 21.2322 22.8086 17.2183H1.19092Z" fill="#6DA544"/>
<path d="M1.19092 6.78238H22.8086C20.8677 2.76843 16.7573 -0.000244141 11.9998 -0.000244141C7.24229 -0.000244141 3.13182 2.76843 1.19092 6.78238Z" fill="#FF9811"/>
<path d="M11.9999 16.1742C14.3051 16.1742 16.1738 14.3055 16.1738 12.0003C16.1738 9.69513 14.3051 7.82642 11.9999 7.82642C9.69476 7.82642 7.82605 9.69513 7.82605 12.0003C7.82605 14.3055 9.69476 16.1742 11.9999 16.1742Z" fill="#FF9811"/>
</g>
<defs>
<clipPath id="clip0_2087_5205">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NF = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5233)">
<path d="M17.2169 1.19044C15.6392 0.4276 13.8694 -0.000274658 11.9995 -0.000274658C10.1296 -0.000274658 8.35976 0.4276 6.78213 1.19044L5.73865 11.9997L6.78213 22.809C8.35976 23.5718 10.1296 23.9997 11.9995 23.9997C13.8694 23.9997 15.6392 23.5718 17.2169 22.809L18.2604 11.9997L17.2169 1.19044Z" fill="#F0F0F0"/>
<path d="M6.7825 1.19124C2.76855 3.13214 -0.00012207 7.24257 -0.00012207 12.0001C-0.00012207 16.7576 2.76855 20.8681 6.7825 22.809V1.19124Z" fill="#6DA544"/>
<path d="M17.2172 1.19122V22.8089C21.2311 20.868 23.9998 16.7576 23.9998 12.0001C23.9998 7.2426 21.2311 3.13213 17.2172 1.19122Z" fill="#6DA544"/>
<path d="M15.1304 15.6516L12 5.73859L8.86951 15.6516H11.2173V18.2603H12.7826V15.6516H15.1304Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5233">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5211)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M-0.000366211 12.0003C-0.000366211 17.1599 3.25613 21.5584 7.82574 23.2539V0.746704C3.25613 2.44217 -0.000366211 6.84074 -0.000366211 12.0003Z" fill="#6DA544"/>
<path d="M23.9999 12.0003C23.9999 6.84074 20.7434 2.44217 16.1738 0.746704V23.254C20.7434 21.5584 23.9999 17.1599 23.9999 12.0003Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5211">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5196)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0003 -0.000183105C7.24279 -0.000183105 3.13204 2.76849 1.19104 6.78244H22.8096C20.8686 2.76849 16.7578 -0.000183105 12.0003 -0.000183105Z" fill="#338AF3"/>
<path d="M12.0003 24.001C16.7578 24.001 20.8686 21.2323 22.8096 17.2184H1.19104C3.13204 21.2323 7.24279 24.001 12.0003 24.001Z" fill="#338AF3"/>
<path d="M12.0003 8.34766C9.98328 8.34766 8.34814 9.9828 8.34814 11.9998C8.34814 14.0169 9.98328 15.652 12.0003 15.652C14.0173 15.652 15.6525 14.0169 15.6525 11.9998C15.6525 9.9828 14.0173 8.34766 12.0003 8.34766ZM12.0003 14.0868C10.8478 14.0868 9.91335 13.1525 9.91335 11.9998C9.91335 10.8472 10.8477 9.91286 12.0003 9.91286C13.1529 9.91286 14.0873 10.8472 14.0873 11.9998C14.0873 13.1525 13.1529 14.0868 12.0003 14.0868Z" fill="#FFDA44"/>
<path d="M13.807 12.5222L11.9996 12.0005L10.1922 12.5222L9.58972 13.5657H14.4094L13.807 12.5222Z" fill="#0052B4"/>
<path d="M11.9997 9.39136L10.7948 11.4783L11.9997 12L13.2046 11.4783L11.9997 9.39136Z" fill="#338AF3"/>
<path d="M10.1923 12.5211H13.8071L13.2046 11.4777H10.7947L10.1923 12.5211Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5196">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5179)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0002 -0.000549316C6.84061 -0.000549316 2.4421 3.25595 0.746582 7.82556H23.2538C21.5583 3.25595 17.1598 -0.000549316 12.0002 -0.000549316Z" fill="#A2001D"/>
<path d="M12.0002 24.0004C17.1598 24.0004 21.5583 20.7439 23.2538 16.1743H0.746582C2.4421 20.7439 6.84061 24.0004 12.0002 24.0004Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5179">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5253)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0.41333 15.131C1.10764 17.7072 2.63788 19.9401 4.6956 21.5211V15.131H0.41333Z" fill="#D80027"/>
<path d="M10.9563 23.9549C11.3003 23.9845 11.6481 24.0006 11.9998 24.0006C17.5441 24.0006 22.2094 20.2402 23.5864 15.131H10.9563V23.9549Z" fill="#D80027"/>
<path d="M23.5864 8.87005C22.2094 3.76086 17.5441 0.000505447 11.9998 0.000505447C11.6481 0.000505447 11.3003 0.0165367 10.9563 0.0461617V8.87005H23.5864Z" fill="#D80027"/>
<path d="M4.6956 2.48028C2.63788 4.06137 1.10764 6.29417 0.41333 8.87037H4.6956V2.48028Z" fill="#D80027"/>
<path d="M23.8984 10.4343H9.39136H9.39131V0.28474C8.28234 0.530647 7.23098 0.929225 6.26086 1.45858V10.4342V10.4343H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5649V13.5648H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5253">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NP = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5169)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.9299 13.3046L23.9296 13.3042L23.9296 13.3046H23.9299Z" fill="#0052B4"/>
<path d="M23.9292 13.3041C23.9292 13.3041 23.9293 13.304 23.9293 13.3038L10.7693 0.0621948C10.1757 0.12271 9.59475 0.226492 9.02986 0.370351C3.83897 1.69199 0 11.9998 0 11.9998C0 11.9998 16.7999 23.2421 18.7165 21.945C19.1 21.6855 19.4677 21.4044 19.8177 21.1034L12.0185 13.3041H23.9292Z" fill="#0052B4"/>
<path d="M20.8697 11.9995L9.19911 0.328979C3.923 1.59071 0.00012207 6.33662 0.00012207 11.9995C0.00012207 18.6269 5.37275 23.9995 12.0001 23.9995C14.514 23.9995 16.8469 23.226 18.7749 21.9047L8.86967 11.9995H20.8697Z" fill="#D80027"/>
<path d="M11.4126 17.7175L9.94704 17.0281L10.7275 15.6088L9.13605 15.9133L8.9344 14.3055L7.82595 15.488L6.71749 14.3055L6.51579 15.9133L4.92443 15.6088L5.70485 17.0281L4.23926 17.7175L5.70485 18.4068L4.92443 19.8262L6.51588 19.5217L6.71745 21.1294L7.82595 19.9469L8.9344 21.1294L9.13605 19.5217L10.7274 19.8262L9.94699 18.4069L11.4126 17.7175Z" fill="#F0F0F0"/>
<path d="M10.4343 6.65496L9.3684 6.15363L9.93601 5.12131L8.77853 5.34274L8.63186 4.1734L7.82565 5.03342L7.01945 4.1734L6.87273 5.34274L5.71525 5.12131L6.2829 6.15363L5.21692 6.65496L7.82565 7.17677L10.4343 6.65496Z" fill="#F0F0F0"/>
<path d="M10.9567 6.65533C10.9567 8.38422 9.55514 9.78578 7.82625 9.78578C6.09736 9.78578 4.6958 8.38422 4.6958 6.65533" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5169">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5162)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#0052B4"/>
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M12.001 -0.000549316C5.72524 -0.000549316 0.575644 4.81731 0.0467529 10.956H23.9554C23.4265 4.81731 18.2769 -0.000549316 12.001 -0.000549316Z" fill="#0052B4"/>
<path d="M11.9998 24.0001C18.2756 24.0001 23.4252 19.1822 23.9542 13.0436H0.0455322C0.574423 19.1822 5.72402 24.0001 11.9998 24.0001Z" fill="#0052B4"/>
<path d="M9.91324 16.1745L8.56859 16.8071L9.2846 18.1093L7.82449 17.83L7.63948 19.305L6.62243 18.2202L5.60543 19.305L5.42042 17.83L3.96026 18.1093L4.67632 16.807L3.33167 16.1745L4.67637 15.5421L3.96026 14.2399L5.42037 14.5191L5.60548 13.0441L6.62243 14.129L7.63953 13.0441L7.82449 14.5191L9.28465 14.2399L8.56863 15.5421L9.91324 16.1745Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5162">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5216)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#FFDA44"/>
<path d="M12.0003 5.7395V9.78683L7.82642 5.7395H12.0003Z" fill="#0052B4"/>
<path d="M6.26122 12.0002H9.78674L6.26122 7.30457L5.7395 10.9567L6.26122 12.0002Z" fill="#0052B4"/>
<path d="M11.9684 12.0007H12.0006C12.0006 11.9899 12.0006 11.9794 12.0006 11.9685C11.9898 11.9793 11.9791 11.99 11.9684 12.0007Z" fill="#F0F0F0"/>
<path d="M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z" fill="#F0F0F0"/>
<path d="M11.9993 10.5247L7.73576 6.26123H6.26013V6.26132L11.9992 12.0003H11.9993C11.9993 12.0003 11.9993 10.9828 11.9993 10.5247Z" fill="#D80027"/>
<path d="M6.07063 1.56494C5.60802 1.82838 5.16482 2.12196 4.74332 2.44244H5.2357L3.93435 3.3881L4.43132 4.91796L3.12998 3.97249L2.99151 4.07313C2.45118 4.68672 1.97212 5.35554 1.56482 6.07075V11.9997H4.69527V4.69549V4.69539H11.9996C11.9996 3.70807 11.9996 2.76747 11.9996 1.56494H6.07063Z" fill="#D80027"/>
<path d="M5.12589 2.16431C4.99647 2.25492 4.86887 2.34806 4.7432 2.44363L3.93437 3.38929L3.13 3.97363L2.99035 4.07507C2.6957 4.40976 2.41937 4.76095 2.16296 5.12718C2.45523 5.26903 2.78331 5.34876 3.13 5.34876C4.35465 5.34876 5.34737 4.35604 5.34737 3.13138C5.34747 2.7846 5.26778 2.45662 5.12589 2.16431Z" fill="#0052B4"/>
<path d="M2.99011 4.07382L3.12975 3.97238L4.4311 4.9179L3.93408 3.38804L5.23533 2.44238H4.74286C4.10564 2.92702 3.51844 3.47377 2.99011 4.07382Z" fill="#FFDA44"/>
<path d="M8.29415 2.0874L8.55318 2.88451H9.3913L8.71326 3.37721L8.97215 4.17432L8.29415 3.68167L7.6161 4.17432L7.87494 3.37721L7.1969 2.88451H8.03507L8.29415 2.0874Z" fill="#FFDA44"/>
<path d="M3.13004 7.30518L3.38907 8.10228H4.2272L3.5492 8.59504L3.80809 9.39215L3.13004 8.89944L2.45195 9.39215L2.71084 8.59504L2.03284 8.10228H2.87096L3.13004 7.30518Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5216">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const NZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5183)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9684 12.0006H12.0006C12.0006 11.9897 12.0006 11.9792 12.0006 11.9684C11.9898 11.9791 11.9791 11.9898 11.9684 12.0006Z" fill="#F0F0F0"/>
<path d="M12.0004 6.26092C12.0004 4.14944 12.0004 2.76592 12.0004 6.10352e-05H11.9983C5.37186 0.00118604 0.000366211 5.3733 0.000366211 12.0001H6.26122V8.47455L9.78678 12.0001H11.9683C11.979 11.9894 11.9897 11.9787 12.0004 11.968C12.0004 11.1595 12.0004 10.4381 12.0004 9.78653L8.4748 6.26092H12.0004Z" fill="#F0F0F0"/>
<path d="M6.07112 1.565C4.19429 2.63371 2.63401 4.19399 1.56531 6.07082V11.9998H4.69576V4.69555V4.69546H12.0001C12.0001 3.70813 12.0001 2.76753 12.0001 1.565H6.07112Z" fill="#D80027"/>
<path d="M12.0004 10.5247L7.73702 6.26123C7.73702 6.26123 6.26135 6.26132 6.26135 6.26123V6.26132L12.0004 12.0003H12.0004C12.0004 12.0003 12.0004 10.9828 12.0004 10.5247Z" fill="#D80027"/>
<path d="M20.7811 8.90472L21.0401 9.70188H21.8783L21.2002 10.1945L21.4592 10.9916L20.7811 10.499L20.1029 10.9916L20.362 10.1945L19.6838 9.70188H20.522L20.7811 8.90472Z" fill="#D80027"/>
<path d="M17.7849 14.6436L18.1735 15.8393H19.4307L18.4135 16.5783L18.8021 17.774L17.7849 17.035L16.7678 17.774L17.1563 16.5783L16.1392 15.8393H17.3964L17.7849 14.6436Z" fill="#D80027"/>
<path d="M17.8985 5.25195L18.2223 6.24847H19.27L18.4224 6.86417L18.7462 7.86064L17.8985 7.24475L17.0509 7.86064L17.3747 6.86417L16.5271 6.24847H17.5748L17.8985 5.25195Z" fill="#D80027"/>
<path d="M15.0152 8.87L15.4037 10.0658H16.6609L15.6438 10.8047L16.0324 12.0005L15.0152 11.2615L13.998 12.0005L14.3866 10.8047L13.3694 10.0658H14.6266L15.0152 8.87Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5183">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const OM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5261)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0.00012207 12.0005C0.00012207 16.549 2.5309 20.5062 6.26098 22.5414V1.45957C2.5309 3.49479 0.00012207 7.45198 0.00012207 12.0005Z" fill="#D80027"/>
<path d="M23.2538 16.1751C23.7361 14.8752 24.0001 13.4691 24.0001 12.0013C24.0001 10.5334 23.7361 9.1273 23.2538 7.82736H0.74656C0.264169 9.1273 0.00012207 10.5334 0.00012207 12.0013C0.00012207 13.4691 0.264169 14.8752 0.74656 16.1751L12.0001 17.2186L23.2538 16.1751Z" fill="#D80027"/>
<path d="M12.0003 23.9997C17.1599 23.9997 21.5584 20.7432 23.2539 16.1736H0.746704C2.44217 20.7432 6.84073 23.9997 12.0003 23.9997Z" fill="#6DA544"/>
<path d="M0.000244141 11.9996C0.000244141 17.5439 3.7606 22.2092 8.86979 23.5862V0.413002C3.7606 1.79 0.000244141 6.45528 0.000244141 11.9996Z" fill="#D80027"/>
<path d="M7.34159 5.28158L6.23483 4.17481L5.49701 4.91272L4.7592 4.17481L3.65244 5.28158L4.3903 6.01944L3.65234 6.75734L4.75911 7.86411L5.49697 7.1262L6.23483 7.86411L7.34159 6.75734L6.60373 6.01944L7.34159 5.28158Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5261">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5285)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0 11.9998C0 18.6272 5.37262 23.9998 12 23.9998C12 19.4363 12 11.9998 12 11.9998C12 11.9998 4.17389 11.9998 0 11.9998Z" fill="#0052B4"/>
<path d="M11.9996 0.000823975C18.627 0.000823975 23.9996 5.37345 23.9996 12.0008C19.4361 12.0008 11.9996 12.0008 11.9996 12.0008C11.9996 12.0008 11.9996 4.17471 11.9996 0.000823975Z" fill="#D80027"/>
<path d="M7.14361 4.1748L7.92066 6.56627H10.4352L8.40089 8.04424L9.17789 10.4357L7.14361 8.9577L5.10933 10.4357L5.88633 8.04424L3.85205 6.56627H6.36657L7.14361 4.1748Z" fill="#0052B4"/>
<path d="M16.857 13.5647L17.634 15.9562H20.1486L18.1142 17.4341L18.8913 19.8256L16.857 18.3476L14.8227 19.8256L15.5997 17.4341L13.5654 15.9562H16.0799L16.857 13.5647Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5285">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5307)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M24.0001 12.0015C24.0001 6.84199 20.7436 2.44342 16.174 0.747955V23.2552C20.7436 21.5596 24.0001 17.1611 24.0001 12.0015Z" fill="#D80027"/>
<path d="M0.000244141 12.0007C0.000244141 17.1603 3.25674 21.5588 7.82635 23.2543V0.747101C3.25674 2.44257 0.000244141 6.84113 0.000244141 12.0007Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5307">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PF = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4692)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M1.45911 6.26159H22.5409C20.5057 2.53147 16.5485 0.000732422 12 0.000732422C7.45151 0.000732422 3.49437 2.53147 1.45911 6.26159Z" fill="#D80027"/>
<path d="M11.9997 23.9999C16.5482 23.9999 20.5053 21.4691 22.5406 17.739H1.45874C3.49401 21.4691 7.45115 23.9999 11.9997 23.9999Z" fill="#D80027"/>
<path d="M16.174 11.9997C16.174 14.3049 14.3052 15.6519 12.0001 15.6519C9.69489 15.6519 7.82617 14.3049 7.82617 11.9997C7.82617 9.69448 9.69489 7.82581 12.0001 7.82581C14.3052 7.82581 16.174 9.69448 16.174 11.9997Z" fill="#FFDA44"/>
<path d="M16.174 11.9998C16.174 14.305 14.3052 16.1737 12.0001 16.1737C9.69489 16.1737 7.82617 14.305 7.82617 11.9998" fill="#0052B4"/>
<path d="M10.4351 10.9559H9.3916V13.0429H10.4351V10.9559Z" fill="#D80027"/>
<path d="M14.6089 10.9559H13.5654V13.0429H14.6089V10.9559Z" fill="#D80027"/>
<path d="M12.522 9.39087H11.4785V13.043H12.522V9.39087Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4692">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5291)">
<path d="M20.4853 20.4857C15.799 25.172 8.20108 25.172 3.51471 20.4857C-1.17158 15.7994 -1.17158 8.20139 3.51475 3.51506C8.20103 -1.17121 15.0611 -0.433356 19.7474 4.25297C24.4337 8.93925 25.1716 15.7994 20.4853 20.4857Z" fill="black"/>
<path d="M3.51465 3.51464C8.20093 -1.17164 15.7989 -1.17155 20.4852 3.51469C25.1715 8.20097 25.1715 15.7989 20.4852 20.4853" fill="#A2001D"/>
<path d="M9.17152 16.1739L9.36577 16.7717H9.99441L9.48582 17.1412L9.68012 17.7391L9.17152 17.3696L8.66293 17.7391L8.85718 17.1412L8.34863 16.7717H8.97723L9.17152 16.1739Z" fill="#F0F0F0"/>
<path d="M7.56507 10.435L7.88893 11.4315H8.93659L8.08895 12.0473L8.41272 13.0437L7.56507 12.4278L6.71748 13.0437L7.04129 12.0473L6.1936 11.4315H7.24136L7.56507 10.435Z" fill="#F0F0F0"/>
<path d="M7.56507 17.7387L7.88884 18.7352H8.93659L8.08886 19.351L8.41272 20.3474L7.56507 19.7315L6.71748 20.3474L7.0412 19.351L6.1936 18.7352H7.24121L7.56507 17.7387Z" fill="#F0F0F0"/>
<path d="M10.629 13.0439L10.9529 14.0404H12.0005L11.1529 14.6561L11.4766 15.6526L10.629 15.0367L9.7814 15.6526L10.1052 14.6561L9.25757 14.0404H10.3053L10.629 13.0439Z" fill="#F0F0F0"/>
<path d="M4.50221 13.0439L4.82607 14.0404H5.87368L5.02608 14.6561L5.3498 15.6526L4.50221 15.0367L3.65457 15.6526L3.97843 14.6561L3.13074 14.0404H4.17844L4.50221 13.0439Z" fill="#F0F0F0"/>
<path d="M20.0881 8.8863C19.5518 8.35 18.855 8.03317 18.1062 7.97875L20.3477 6.23533C19.455 5.3426 18.2585 4.93942 17.0909 5.02469C16.9511 4.52238 16.6846 4.04791 16.2896 3.65289L15.4042 5.42374C15.3461 5.31789 15.2726 5.21828 15.1828 5.12861C14.6734 4.61922 13.8476 4.61922 13.3382 5.12861C12.8289 5.638 12.8288 6.46385 13.3382 6.97324C13.4279 7.06291 13.5275 7.13646 13.6334 7.19458L11.8625 8.08C12.2577 8.47516 12.7325 8.74183 13.235 8.88152C13.1495 10.0491 13.5523 11.2454 14.445 12.1382L16.4035 9.62017C16.5508 9.4751 16.7454 9.39499 16.9524 9.39499C17.1614 9.39499 17.3579 9.47636 17.5057 9.62425C17.6536 9.77205 17.735 9.9686 17.735 10.1776C17.735 10.3867 17.6536 10.5832 17.5057 10.731L18.2436 11.4689C18.5885 11.124 18.7785 10.6654 18.7785 10.1777C18.7785 9.77857 18.6512 9.39916 18.4161 9.08547C18.7586 9.17692 19.0823 9.35608 19.3504 9.62425C20.1642 10.438 20.1642 11.762 19.3504 12.5756L20.0883 13.3135C20.6795 12.7223 21.0052 11.9362 21.0052 11.1C21.005 10.2637 20.6794 9.47758 20.0881 8.8863Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5291">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5312)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0004 -6.10352e-05V11.9999L3.51514 20.4853C5.68671 22.6568 8.68671 23.9999 12.0004 23.9999C18.6278 23.9999 24.0004 18.6273 24.0004 11.9999C24.0004 5.37256 12.0004 -6.10352e-05 12.0004 -6.10352e-05Z" fill="#D80027"/>
<path d="M12.0004 -6.10352e-05C8.68671 -6.10352e-05 5.68671 1.3431 3.51514 3.51463C6.45936 6.45885 7.50453 7.50406 12.0004 11.9999H24.0004C24.0004 5.37256 18.6278 -6.10352e-05 12.0004 -6.10352e-05Z" fill="#0052B4"/>
<path d="M8.21723 11.9998L6.75173 11.3105L7.53215 9.89117L5.94074 10.1956L5.73909 8.58795L4.63059 9.77033L3.52213 8.58795L3.32043 10.1956L1.72907 9.89113L2.50949 11.3105L1.04395 11.9998L2.50949 12.6892L1.72907 14.1085L3.32057 13.8041L3.52209 15.4117L4.63059 14.2294L5.73909 15.4117L5.94074 13.8041L7.53205 14.1086L6.75168 12.6892L8.21723 11.9998Z" fill="#FFDA44"/>
<path d="M3.20082 4.69525L3.68851 5.37695L4.48749 5.12388L3.98977 5.79831L4.47746 6.48002L3.68218 6.21513L3.18451 6.88952L3.19074 6.05139L2.39551 5.78645L3.19463 5.53338L3.20082 4.69525Z" fill="#FFDA44"/>
<path d="M3.20082 17.1096L3.68851 17.7913L4.48749 17.5381L3.98977 18.2126L4.47746 18.8943L3.68218 18.6294L3.18451 19.3038L3.19074 18.4657L2.39551 18.2008L3.19463 17.9477L3.20082 17.1096Z" fill="#FFDA44"/>
<path d="M10.1563 10.9033L9.66866 11.585L8.86963 11.3318L9.36735 12.0063L8.87966 12.688L9.67494 12.4231L10.1727 13.0975L10.1664 12.2594L10.9616 11.9945L10.1625 11.7414L10.1563 10.9033Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5312">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5269)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0.000244141 12.0002C0.000244141 16.5487 2.53098 20.5058 6.26111 22.5411V1.45927C2.53098 3.49453 0.000244141 7.45167 0.000244141 12.0002Z" fill="#F0F0F0"/>
<path d="M11.9996 0.000816345C9.92073 0.000816345 7.96539 0.529707 6.2605 1.45989V22.5417C7.96539 23.4719 9.92073 24.0008 11.9996 24.0008C18.627 24.0008 23.9996 18.6282 23.9996 12.0008C23.9996 5.37344 18.627 0.000816345 11.9996 0.000816345Z" fill="#496E2D"/>
<path d="M17.1308 13.9861C15.6127 15.083 13.4927 14.7415 12.3958 13.2234C11.2989 11.7053 11.6403 9.58533 13.1585 8.48846C13.6318 8.14646 14.1637 7.94428 14.7048 7.87402C13.6638 7.71835 12.5634 7.95291 11.6429 8.61802C9.77449 9.96811 9.35416 12.5772 10.7042 14.4458C12.0543 16.3142 14.6634 16.7345 16.5319 15.3843C17.4525 14.7192 18.0207 13.7483 18.1997 12.711C17.9631 13.2025 17.6042 13.644 17.1308 13.9861Z" fill="#F0F0F0"/>
<path d="M17.0661 7.82724L17.9213 8.74885L19.0621 8.22047L18.4498 9.31847L19.3049 10.2402L18.0713 9.99713L17.4591 11.0952L17.309 9.84694L16.0754 9.60389L17.2162 9.07552L17.0661 7.82724Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5269">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5364)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M24 11.9996C24 18.627 18.6274 23.9996 12 23.9996C5.37262 23.9996 0 18.627 0 11.9996" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5364">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5321)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9684 12.0007H12.0006C12.0006 11.9899 12.0006 11.9794 12.0006 11.9685C11.9898 11.9793 11.9791 11.99 11.9684 12.0007Z" fill="#F0F0F0"/>
<path d="M12.0005 6.26104C12.0005 4.14956 12.0005 2.76604 12.0005 0.000183105H11.9985C5.37194 0.00130811 0.000488281 5.37342 0.000488281 12.0002H6.26134V8.47467L9.78686 12.0002H11.9684C11.9791 11.9895 11.9898 11.9788 12.0005 11.9681C12.0005 11.1596 12.0005 10.4383 12.0005 9.78665L8.47492 6.26104H12.0005Z" fill="#F0F0F0"/>
<path d="M6.07124 1.565C4.19441 2.63371 2.63409 4.19399 1.56543 6.07082V11.9998H4.69588V4.69555V4.69546H12.0002C12.0002 3.70813 12.0002 2.76753 12.0002 1.565H6.07124Z" fill="#D80027"/>
<path d="M12.0005 10.5247L7.73698 6.26129H6.26135V6.26139L12.0004 12.0004H12.0005C12.0005 12.0004 12.0005 10.9829 12.0005 10.5247Z" fill="#D80027"/>
<path d="M18.7832 7.30388L17.2179 7.82564L15.6527 7.30388L15.131 5.99953L15.6527 4.69519H18.7832L18.2614 5.99953L18.7832 7.30388Z" fill="#ACABB1"/>
<path d="M13.5649 7.30389V13.043C13.5649 15.8386 17.2171 16.6952 17.2171 16.6952C17.2171 16.6952 20.8693 15.8386 20.8693 13.043V7.30389H13.5649Z" fill="#338AF3"/>
<path d="M13.8948 14.4023C14.7925 16.1258 17.2177 16.6948 17.2177 16.6948C17.2177 16.6948 19.643 16.1258 20.5407 14.4023L17.2177 8.86877L13.8948 14.4023Z" fill="#6DA544"/>
<path d="M20.8693 12.985L17.2171 7.30389L13.5649 12.985V13.043C13.5649 13.5604 13.6903 14.0112 13.8941 14.4026L17.2171 9.2335L20.5401 14.4026C20.7439 14.0111 20.8693 13.5603 20.8693 13.0429V12.985Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5321">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5340)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.999 -0.000549316C8.07308 -0.000549316 4.58769 1.8849 2.39844 4.79945H21.5995C19.4102 1.8849 15.9248 -0.000549316 11.999 -0.000549316Z" fill="#D80027"/>
<path d="M11.999 23.9994C15.9248 23.9994 19.4102 22.1139 21.5995 19.1994H2.39844C4.58769 22.1139 8.07308 23.9994 11.999 23.9994Z" fill="#D80027"/>
<path d="M-0.000610352 11.9994C-0.000610352 12.8214 0.0822646 13.624 0.239718 14.3994H23.7592C23.9166 13.624 23.9994 12.8214 23.9994 11.9994C23.9994 11.1775 23.9165 10.3749 23.7591 9.59943H0.239718C0.0822646 10.3749 -0.000610352 11.1775 -0.000610352 11.9994Z" fill="#D80027"/>
<path d="M3.51434 3.51538C-1.17194 8.20166 -1.17194 15.7997 3.51434 20.486C5.45089 18.5495 7.31337 16.687 11.9997 12.0007L3.51434 3.51538Z" fill="#0052B4"/>
<path d="M4.85694 8.86877L5.6339 11.2601H8.14855L6.11427 12.7382L6.89118 15.1297L4.85694 13.6517L2.82262 15.1297L3.59971 12.7382L1.56543 11.2601H4.0799L4.85694 8.86877Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5340">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5280)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M7.30425 7.82693H23.2535C21.558 3.25732 17.1594 0.000823975 11.9999 0.000823975C8.68612 0.000823975 5.68645 1.34421 3.51501 3.51593L7.30425 7.82693Z" fill="black"/>
<path d="M7.30425 16.1736H23.2535C21.558 20.7432 17.1594 23.9997 11.9999 23.9997C8.68612 23.9997 5.68645 22.6563 3.51501 20.4846L7.30425 16.1736Z" fill="#6DA544"/>
<path d="M3.51459 3.51488C-1.17169 8.20116 -1.17169 15.7992 3.51459 20.4855C5.45114 18.549 7.31362 16.6865 11.9999 12.0002L3.51459 3.51488Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5280">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5334)">
<path d="M-0.000366211 12.0007C-0.000366211 17.1602 3.25613 21.5587 7.82565 23.2542L8.86918 12.0006L7.82565 0.74707C3.25613 2.44263 -0.000366211 6.8411 -0.000366211 12.0007Z" fill="#6DA544"/>
<path d="M24.0002 11.9999C24.0002 5.37256 18.6275 -6.10352e-05 12.0002 -6.10352e-05C10.5323 -6.10352e-05 9.1262 0.263986 7.82617 0.74633V23.2535C9.1262 23.7359 10.5323 23.9999 12.0002 23.9999C18.6275 23.9999 24.0002 18.6273 24.0002 11.9999Z" fill="#D80027"/>
<path d="M7.82623 16.1745C10.1314 16.1745 12.0001 14.3058 12.0001 12.0006C12.0001 9.69544 10.1314 7.82672 7.82623 7.82672C5.52106 7.82672 3.65234 9.69544 3.65234 12.0006C3.65234 14.3058 5.52106 16.1745 7.82623 16.1745Z" fill="#FFDA44"/>
<path d="M5.47778 9.9126V12.5213C5.47778 13.8179 6.52891 14.8691 7.82561 14.8691C9.12232 14.8691 10.1734 13.818 10.1734 12.5213V9.9126H5.47778Z" fill="#D80027"/>
<path d="M7.8262 13.3038C7.39467 13.3038 7.04358 12.9527 7.04358 12.5212V11.4777H8.60878V12.5212C8.60878 12.9527 8.25769 13.3038 7.8262 13.3038Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5334">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5277)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"/>
<path d="M9.39108 17.2183C12.2726 17.2183 14.6085 14.8824 14.6085 12.0009C14.6085 9.11944 12.2726 6.78354 9.39108 6.78354C6.50961 6.78354 4.17371 9.11944 4.17371 12.0009C4.17371 14.8824 6.50961 17.2183 9.39108 17.2183Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5277">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const PY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5301)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0003 -3.05176e-05C7.24279 -3.05176e-05 3.13204 2.76864 1.19104 6.78259H22.8096C20.8686 2.76864 16.7578 -3.05176e-05 12.0003 -3.05176e-05Z" fill="#D80027"/>
<path d="M12.0003 24.0008C16.7578 24.0008 20.8686 21.2321 22.8096 17.2181H1.19104C3.13204 21.2321 7.24279 24.0008 12.0003 24.0008Z" fill="#0052B4"/>
<path d="M14.9512 8.52664L13.8444 9.63341C14.3165 10.1055 14.6085 10.7577 14.6085 11.478C14.6085 12.9188 13.4405 14.0867 11.9998 14.0867C10.5591 14.0867 9.39113 12.9187 9.39113 11.478C9.39113 10.7577 9.68316 10.1055 10.1552 9.63341L9.04848 8.52664C8.29308 9.28189 7.82593 10.3254 7.82593 11.478C7.82593 13.7833 9.69465 15.6519 11.9998 15.6519C14.305 15.6519 16.1737 13.7832 16.1737 11.478C16.1737 10.3254 15.7065 9.28189 14.9512 8.52664Z" fill="#6DA544"/>
<path d="M11.9999 9.91263L12.3885 11.1084H13.6457L12.6285 11.8473L13.0171 13.0431L11.9999 12.3041L10.9827 13.0431L11.3713 11.8473L10.3541 11.1084H11.6114L11.9999 9.91263Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5301">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const QA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5348)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M24 11.9999C24 5.37256 18.6274 -6.10352e-05 12 -6.10352e-05C9.65252 -6.10352e-05 7.4628 0.674705 5.61321 1.83983L8.24351 2.95738L4.69568 4.46478L8.24351 5.97214L4.69568 7.47945L8.24351 8.98672L4.69568 10.4938L8.24351 12.0008L4.69568 13.5081L8.24351 15.0153L4.69568 16.5224L8.24351 18.0296L4.69568 19.5369L8.24351 21.044L5.61438 22.1609C7.46374 23.3255 9.65299 23.9999 12 23.9999C18.6274 23.9999 24 18.6273 24 11.9999Z" fill="#751A46"/>
</g>
<defs>
<clipPath id="clip0_2087_5348">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const RO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5371)">
<path d="M16.1741 0.745367C14.8741 0.26307 13.4681 -0.000976556 12.0002 -0.000976556C10.5324 -0.00102343 9.1263 0.26307 7.82632 0.745367L6.78284 11.999L7.82632 23.2526C9.12626 23.735 10.5323 23.999 12.0002 23.999C13.468 23.999 14.8741 23.735 16.1741 23.2526L17.2175 11.999L16.1741 0.745367Z" fill="#FFDA44"/>
<path d="M23.9997 11.9996C23.9997 6.84005 20.7432 2.44144 16.1736 0.745972V23.2533C20.7432 21.5576 23.9996 17.1592 23.9997 11.9996Z" fill="#D80027"/>
<path d="M0.00012207 11.9995C0.00012207 17.1592 3.25662 21.5576 7.82614 23.2532L7.82619 0.745972C3.25662 2.44144 0.00012207 6.83991 0.00012207 11.9995Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5371">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const RS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5449)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z" fill="#0052B4"/>
<path d="M12.0003 0.00012207C6.84074 0.00012207 2.44222 3.25662 0.746704 7.82623H23.254C21.5584 3.25662 17.1599 0.00012207 12.0003 0.00012207Z" fill="#D80027"/>
<path d="M3.10339 6.78314V12.7694C3.10339 16.1746 7.55188 17.2179 7.55188 17.2179C7.55188 17.2179 12.0003 16.1746 12.0003 12.7694V6.78314H3.10339Z" fill="#D80027"/>
<path d="M4.94226 7.82638H10.1597V5.73941L9.1162 6.26113L7.551 4.69592L5.98575 6.26113L4.94226 5.73941V7.82638Z" fill="#FFDA44"/>
<path d="M10.9561 13.6026L7.56477 10.2112L4.17346 13.6026L5.28023 14.7093L7.56477 12.4248L9.84932 14.7093L10.9561 13.6026Z" fill="#FFDA44"/>
<path d="M10.956 10.4341H9.37365C9.46262 10.2805 9.51437 10.1026 9.51437 9.91243C9.51437 9.33605 9.04717 8.86894 8.47089 8.86894C8.07268 8.86894 7.72689 9.09197 7.55096 9.41986C7.37504 9.09202 7.02925 8.86894 6.63104 8.86894C6.05476 8.86894 5.58756 9.33605 5.58756 9.91243C5.58756 10.1026 5.63931 10.2805 5.72828 10.4341H4.17334C4.17334 11.0104 4.67532 11.4775 5.25156 11.4775H5.21682C5.21682 12.0539 5.68398 12.521 6.26031 12.521C6.26031 13.0313 6.62678 13.4552 7.11076 13.546L6.28857 15.4023C6.68261 15.5625 7.1132 15.6515 7.5647 15.6515C8.0162 15.6515 8.44679 15.5625 8.84082 15.4023L8.01864 13.546C8.50262 13.4553 8.86909 13.0313 8.86909 12.521C9.44542 12.521 9.91257 12.0539 9.91257 11.4775H9.87784C10.454 11.4775 10.956 11.0103 10.956 10.4341Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5449">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const RU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5375)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.2539 16.1733C23.7362 14.8734 24.0002 13.4673 24.0002 11.9995C24.0002 10.5316 23.7362 9.12555 23.2539 7.82556H0.746635C0.264291 9.12555 0.000244141 10.5316 0.000244141 11.9995C0.000244141 13.4673 0.264291 14.8734 0.746635 16.1733L12.0002 17.2168L23.2539 16.1733Z" fill="#0052B4"/>
<path d="M12.0003 23.9995C17.1599 23.9995 21.5584 20.743 23.2539 16.1733H0.746704C2.44222 20.743 6.84073 23.9995 12.0003 23.9995Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5375">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const RW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5379)">
<path d="M0.000366211 11.9991C0.000366211 14.078 0.529257 16.0333 1.45944 17.7382L12.0004 18.7817L22.5413 17.7382C23.4715 16.0333 24.0004 14.078 24.0004 11.9991L12.0004 10.9556L0.000366211 11.9991Z" fill="#FFDA44"/>
<path d="M22.5409 6.26086C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H24C24 9.92109 23.4711 7.96575 22.5409 6.26086Z" fill="#338AF3"/>
<path d="M12.0004 23.9991C16.5489 23.9991 20.5061 21.4684 22.5413 17.7383H1.45947C3.49474 21.4684 7.45188 23.9991 12.0004 23.9991Z" fill="#496E2D"/>
<path d="M13.5651 7.02244L15.0307 7.71183L14.2502 9.1312L15.8416 8.8268L16.0433 10.4344L17.1517 9.252L18.2602 10.4344L18.4618 8.8268L20.0532 9.13111L19.2728 7.71178L20.7383 7.02244L19.2728 6.33314L20.0532 4.91377L18.4619 5.21817L18.2602 3.6106L17.1517 4.79297L16.0432 3.6106L15.8416 5.21817L14.2502 4.91377L15.0306 6.33319L13.5651 7.02244Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5379">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5434)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#6DA544"/>
<path d="M6.78296 14.3476C6.78296 15.2121 7.48374 15.9128 8.34816 15.9128H13.0438C13.0438 16.6332 13.6278 17.2172 14.3482 17.2172H15.9134C16.6337 17.2172 17.2177 16.6332 17.2177 15.9128V14.3476H6.78296Z" fill="#F0F0F0"/>
<path d="M17.3474 6.78308V10.4352C17.3474 11.0106 16.8793 11.4787 16.304 11.4787V13.0439C17.7424 13.0439 18.9126 11.8737 18.9126 10.4352V6.78308H17.3474Z" fill="#F0F0F0"/>
<path d="M6.1304 10.435C6.1304 11.0104 5.6623 11.4785 5.08691 11.4785V13.0437C6.52537 13.0437 7.6956 11.8734 7.6956 10.435V6.78283H6.1304V10.435Z" fill="#F0F0F0"/>
<path d="M16.5654 6.78308H15.0002V10.4353H16.5654V6.78308Z" fill="#F0F0F0"/>
<path d="M12.6522 8.87005C12.6522 9.01391 12.5351 9.13091 12.3913 9.13091C12.2475 9.13091 12.1304 9.01386 12.1304 8.87005V6.78308H10.5652V8.87005C10.5652 9.01391 10.4482 9.13091 10.3044 9.13091C10.1606 9.13091 10.0435 9.01386 10.0435 8.87005V6.78308H8.47827V8.87005C8.47827 9.87697 9.29746 10.6962 10.3044 10.6962C10.6922 10.6962 11.0518 10.5743 11.3479 10.3673C11.6439 10.5742 12.0036 10.6962 12.3914 10.6962C12.4695 10.6962 12.5462 10.6907 12.6217 10.6811C12.5108 11.138 12.0993 11.4787 11.6087 11.4787V13.0439C13.0472 13.0439 14.2174 11.8737 14.2174 10.4353V8.87005V6.78308H12.6522V8.87005H12.6522Z" fill="#F0F0F0"/>
<path d="M10.8261 11.4781H8.47827V13.0433H10.8261V11.4781Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5434">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SB = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5517)">
<path d="M20.4861 20.4851C24.9866 15.9845 25.1643 8.79933 21.0211 4.08563L12.0005 11.9994L4.08667 21.02C8.80036 25.1633 15.9855 24.9856 20.4861 20.4851Z" fill="#496E2D"/>
<path d="M3.51487 3.5144C8.01537 -0.986107 15.2006 -1.16381 19.9143 2.97942L12.0004 12.0001L2.97993 19.9138C-1.16334 15.2001 -0.985595 8.01491 3.51487 3.5144Z" fill="#0052B4"/>
<path d="M19.9139 2.98016L2.97949 19.9146C3.15068 20.1093 3.32843 20.3004 3.51448 20.4864C3.70048 20.6723 3.89158 20.8501 4.0864 21.0214L21.0207 4.08697C20.8495 3.89216 20.6717 3.7011 20.4856 3.51505C20.2997 3.32915 20.1086 3.15135 19.9139 2.98016Z" fill="#FFDA44"/>
<path d="M5.05667 4.17438L5.31575 4.97158H6.15392L5.47583 5.46419L5.73481 6.26139L5.05667 5.76869L4.37853 6.26139L4.63761 5.46419L3.95947 4.97158H4.79769L5.05667 4.17438Z" fill="#F0F0F0"/>
<path d="M9.33744 4.17358L9.59652 4.97079H10.4346L9.75655 5.46339L10.0156 6.2606L9.33744 5.76789L8.6593 6.2606L8.91837 5.46339L8.24023 4.97079H9.07841L9.33744 4.17358Z" fill="#F0F0F0"/>
<path d="M5.05631 8.34778L5.31539 9.14498H6.15356L5.47546 9.63763L5.73445 10.4348L5.05631 9.94213L4.37817 10.4348L4.63725 9.63763L3.95911 9.14498H4.79732L5.05631 8.34778Z" fill="#F0F0F0"/>
<path d="M9.33744 8.34778L9.59652 9.14498H10.4346L9.75655 9.63763L10.0156 10.4348L9.33744 9.94213L8.6593 10.4348L8.91837 9.63763L8.24023 9.14498H9.07841L9.33744 8.34778Z" fill="#F0F0F0"/>
<path d="M7.19698 6.26166L7.45606 7.05886H8.29418L7.61609 7.55151L7.87512 8.34871L7.19698 7.85601L6.51884 8.34871L6.77787 7.55151L6.09973 7.05886H6.93795L7.19698 6.26166Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5517">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5459)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M20.1002 3.14639C17.9655 1.19208 15.122 -0.000656128 11.9998 -0.000656128C11.4887 -0.000656128 10.985 0.031547 10.4906 0.0935626L4.69544 6.78197L0.379517 15.0055C0.658329 16.0865 1.08461 17.1081 1.63459 18.0485L11.9998 11.9993L20.1002 3.14639Z" fill="#FFDA44"/>
<path d="M21.9904 18.648L5.20129 21.888C7.1339 23.2193 9.47569 23.9993 11.9999 23.9993C16.1681 23.9993 19.8393 21.8739 21.9904 18.648Z" fill="#6DA544"/>
<path d="M20.1023 3.14821L1.64185 18.0603C2.12471 18.8838 2.70281 19.6446 3.36127 20.3276L24.0002 11.9996C24.0002 8.49524 22.4978 5.34205 20.1023 3.14821Z" fill="#D80027"/>
<path d="M-0.000488281 12C-0.000488281 13.0381 0.131418 14.0454 0.379246 15.0061L10.4904 0.0941925C4.57536 0.836411 -0.000488281 5.88372 -0.000488281 12Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5459">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5627)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M9.39079 10.435H23.8979C23.1308 4.54719 18.0963 0.000217438 11.9994 0.000217438C11.1035 0.000217438 10.2307 0.0992643 9.39075 0.285452V10.435H9.39079Z" fill="#0052B4"/>
<path d="M6.26073 10.4348V1.45918C2.96569 3.25702 0.606894 6.55472 0.10144 10.4349H6.26073V10.4348Z" fill="#0052B4"/>
<path d="M6.26068 13.5656H0.10144C0.606894 17.4458 2.96569 20.7435 6.26073 22.5413L6.26068 13.5656Z" fill="#0052B4"/>
<path d="M9.39075 13.5657V23.7152C10.2307 23.9014 11.1035 24.0004 11.9994 24.0004C18.0963 24.0004 23.1308 19.4535 23.8979 13.5656H9.39075V13.5657Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5627">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5469)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#D80027"/>
<path d="M7.3039 6.26095C7.3039 4.51261 8.53263 3.05208 10.1734 2.69372C9.92125 2.63869 9.65965 2.60883 9.39082 2.60883C7.37374 2.60883 5.73865 4.24392 5.73865 6.261C5.73865 8.27808 7.37374 9.91317 9.39082 9.91317C9.65955 9.91317 9.92121 9.88331 10.1734 9.82823C8.53263 9.46987 7.3039 8.00934 7.3039 6.26095Z" fill="#F0F0F0"/>
<path d="M11.9996 2.86996L12.2587 3.66707H13.0968L12.4187 4.15978L12.6777 4.95689L11.9996 4.46428L11.3215 4.95689L11.5806 4.15978L10.9025 3.66707H11.7406L11.9996 2.86996Z" fill="#F0F0F0"/>
<path d="M9.96639 4.43463L10.2254 5.23179H11.0635L10.3855 5.72444L10.6445 6.52155L9.96639 6.02894L9.2882 6.52155L9.54728 5.72444L8.86914 5.23179H9.70731L9.96639 4.43463Z" fill="#F0F0F0"/>
<path d="M14.033 4.43463L14.292 5.23179H15.1302L14.452 5.72444L14.7111 6.52155L14.033 6.02894L13.3549 6.52155L13.6139 5.72444L12.9358 5.23179H13.7739L14.033 4.43463Z" fill="#F0F0F0"/>
<path d="M13.2505 6.78333L13.5095 7.58048H14.3476L13.6695 8.07314L13.9286 8.87025L13.2505 8.37764L12.5724 8.87025L12.8314 8.07314L12.1533 7.58048H12.9914L13.2505 6.78333Z" fill="#F0F0F0"/>
<path d="M10.7488 6.78333L11.0078 7.58048H11.846L11.1679 8.07314L11.427 8.87025L10.7488 8.37764L10.0707 8.87025L10.3297 8.07314L9.65161 7.58048H10.4898L10.7488 6.78333Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5469">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5512)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.2539 7.82644H10.435V4.69598H4.17413V7.82644H0.746635C0.264291 9.12637 0.000244141 10.5325 0.000244141 12.0003C0.000244141 13.4682 0.264291 14.8742 0.746635 16.1742L12.0002 17.2177L23.2539 16.1742C23.7362 14.8742 24.0002 13.4682 24.0002 12.0003C24.0002 10.5325 23.7362 9.12637 23.2539 7.82644Z" fill="#0052B4"/>
<path d="M12.0002 23.9996C17.1598 23.9996 21.5583 20.7431 23.2538 16.1735H0.746582C2.4421 20.7431 6.84061 23.9996 12.0002 23.9996Z" fill="#D80027"/>
<path d="M4.17407 7.82641V8.86984C4.17407 11.2661 7.30453 12.0003 7.30453 12.0003C7.30453 12.0003 10.435 11.2661 10.435 8.86984V7.82641L9.39149 8.86989L7.30453 7.30469L5.21756 8.86989L4.17407 7.82641Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5512">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5504)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12.0001 23.9996C18.6275 23.9996 24.0001 18.627 24.0001 11.9996C24.0001 10.5318 23.7361 9.12568 23.2537 7.82574H0.746513C0.264169 9.12568 0.00012207 10.5318 0.00012207 11.9996C0.00012207 18.627 5.37275 23.9996 12.0001 23.9996Z" fill="#0052B4"/>
<path d="M12.0001 23.9996C17.1596 23.9996 21.5582 20.7431 23.2537 16.1735H0.74646C2.44198 20.7431 6.84049 23.9996 12.0001 23.9996Z" fill="#D80027"/>
<path d="M3.10266 6.78192V12.7681C3.10266 16.1733 7.55115 17.2167 7.55115 17.2167C7.55115 17.2167 11.9996 16.1733 11.9996 12.7681V6.78192H3.10266Z" fill="#F0F0F0"/>
<path d="M4.14648 6.78192V12.7681C4.14648 13.1679 4.23527 13.5454 4.41114 13.8994C6.15648 13.8994 8.76517 13.8994 10.6918 13.8994C10.8677 13.5455 10.9564 13.1679 10.9564 12.7681V6.78192H4.14648Z" fill="#D80027"/>
<path d="M9.63862 10.9562H8.07346V9.91267H9.11694V8.86918H8.07346V7.82574H7.02997V8.86918H5.98653V9.91267H7.02997V10.9562H5.46472V11.9996H7.02997V13.0431H8.07346V11.9996H9.63862V10.9562Z" fill="#F0F0F0"/>
<path d="M5.83428 15.3573C6.5067 15.7799 7.19754 16.0252 7.55121 16.1343C7.90489 16.0253 8.59573 15.7799 9.26815 15.3573C9.94625 14.9311 10.4216 14.4437 10.6915 13.9007C10.3938 13.69 10.0306 13.5658 9.63818 13.5658C9.49531 13.5658 9.35651 13.5827 9.22306 13.6138C8.94026 12.9713 8.29831 12.5223 7.55126 12.5223C6.80421 12.5223 6.16221 12.9713 5.87946 13.6138C5.74601 13.5827 5.60717 13.5658 5.46434 13.5658C5.07195 13.5658 4.70871 13.69 4.41101 13.9007C4.68078 14.4437 5.15614 14.9311 5.83428 15.3573Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5504">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5465)">
<path d="M23.2535 16.1743C23.7359 14.8743 23.9999 13.4682 23.9999 12.0004C23.9999 10.5325 23.7359 9.12649 23.2535 7.8265L11.9999 6.78302L0.746269 7.8265C0.263878 9.12649 -0.00012207 10.5325 -0.00012207 12.0004C-0.00012207 13.4682 0.263878 14.8743 0.746269 16.1743L11.9999 17.2178L23.2535 16.1743Z" fill="#F0F0F0"/>
<path d="M11.9999 24.0006C17.1594 24.0006 21.558 20.7441 23.2534 16.1745H0.746216C2.44178 20.7441 6.84025 24.0006 11.9999 24.0006Z" fill="#338AF3"/>
<path d="M11.9999 0.00012207C6.84025 0.00012207 2.44178 3.25662 0.746216 7.82623H23.2535C21.558 3.25662 17.1594 0.00012207 11.9999 0.00012207Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5465">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5418)">
<path d="M24 11.9997C24 18.6271 18.6274 23.9997 12 23.9997C5.37262 23.9997 0 18.6271 0 11.9997C0.521719 11.9997 12 10.4345 12 10.4345L24 11.9997Z" fill="#338AF3"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#F0F0F0"/>
<path d="M16.7632 8.28088L12 13.0442L7.23671 8.28088C6.62072 9.19527 6.26086 10.2959 6.26086 11.4789V13.0441C6.26086 15.5574 7.88485 17.6983 10.1385 18.4732C9.83766 19.0627 9.88838 19.7984 10.3291 20.3485C10.9145 19.8793 11.5206 19.3936 12.0347 18.9817C12.5488 19.3937 13.1549 19.8794 13.7402 20.3485C14.1862 19.792 14.2332 19.0453 13.9206 18.4523C16.1434 17.6606 17.739 15.5354 17.739 13.0441V11.479C17.7391 10.2959 17.3792 9.19532 16.7632 8.28088Z" fill="#6DA544"/>
<path d="M11.9997 17.2175C9.69818 17.2175 7.82581 15.3451 7.82581 13.0436V11.4784C7.82581 9.17691 9.69823 7.30453 11.9997 7.30453C14.3012 7.30453 16.1736 9.17696 16.1736 11.4784V13.0436C16.1736 15.3451 14.3012 17.2175 11.9997 17.2175Z" fill="#FFDA44"/>
<path d="M14.6088 13.0433V11.4781C14.6088 10.0396 13.4386 8.86942 12.0002 8.86942C10.5618 8.86942 9.39148 10.0397 9.39148 11.4781V13.0433L12.0002 13.565L14.6088 13.0433Z" fill="#338AF3"/>
<path d="M9.39148 13.0432C9.39148 14.4817 10.5618 15.6519 12.0002 15.6519C13.4386 15.6519 14.6088 14.4816 14.6088 13.0432H9.39148Z" fill="#6DA544"/>
<path d="M15.1305 7.30396C15.1305 6.43953 14.4297 5.73875 13.5653 5.73875C13.1643 5.73875 12.7988 5.88969 12.5218 6.13761V5.21699H13.0435V4.1735H12.5218V3.65178H11.4783V4.1735H10.9566V5.21699H11.4783V6.13761C11.2013 5.88969 10.8358 5.73875 10.4348 5.73875C9.57041 5.73875 8.86963 6.43953 8.86963 7.30396C8.86963 7.76741 9.07124 8.18366 9.39135 8.4703V9.39093H14.6087V8.4703C14.9289 8.18366 15.1305 7.76741 15.1305 7.30396Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5418">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5443)">
<path d="M17.2174 1.19083C15.6397 0.427989 13.8698 0.000114441 12 0.000114441C10.1301 0.000114441 8.36024 0.427989 6.78262 1.19083L5.73914 12.0001L6.78262 22.8094C8.36024 23.5722 10.1301 24.0001 12 24.0001C13.8698 24.0001 15.6397 23.5722 17.2174 22.8094L18.2608 12.0001L17.2174 1.19083Z" fill="#FFDA44"/>
<path d="M12.0002 7.826L13.0361 11.0144H16.389L13.6766 12.9852L14.7126 16.1738L12.0002 14.2032L9.28778 16.1738L10.3239 12.9852L7.61157 11.0144H10.9642L12.0002 7.826Z" fill="#496E2D"/>
<path d="M6.78299 1.19077C2.76908 3.13173 0.000366211 7.24215 0.000366211 11.9996C0.000366211 16.7571 2.76908 20.8675 6.78299 22.8085V1.19077Z" fill="#496E2D"/>
<path d="M17.2178 1.19143V22.8091C21.2317 20.8682 24.0004 16.7578 24.0004 12.0003C24.0004 7.24281 21.2317 3.13238 17.2178 1.19143Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5443">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5527)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#338AF3"/>
<path d="M12.0001 6.26068L13.2951 10.2464H17.486L14.0955 12.7097L15.3905 16.6955L12.0001 14.2321L8.60961 16.6955L9.90467 12.7097L6.51416 10.2464H10.705L12.0001 6.26068Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5527">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5605)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.2532 7.82683H0.745978C0.263681 9.12686 -0.000366211 10.5329 -0.000366211 12.0007C-0.000366211 13.4686 0.263681 14.8747 0.745978 16.1746H23.2532C23.7356 14.8747 23.9996 13.4686 23.9996 12.0007C23.9996 10.5329 23.7356 9.12686 23.2532 7.82683Z" fill="#A2001D"/>
<path d="M12.0347 24.0012C16.1447 24.0012 19.7717 21.9344 21.9345 18.7838H2.13489C4.29761 21.9344 7.92451 24.0012 12.0347 24.0012Z" fill="#6DA544"/>
<path d="M12.0343 0.000274658C16.1444 0.000274658 19.7714 2.06709 21.9341 5.21765H2.13452C4.29724 2.06709 7.92415 0.000274658 12.0343 0.000274658Z" fill="#6DA544"/>
<path d="M11.9996 7.82683L13.0355 11.0153H16.3883L13.6759 12.9861L14.712 16.1746L11.9996 14.204L9.28714 16.1746L10.3233 12.9861L7.61084 11.0153H10.9636L11.9996 7.82683Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5605">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5559)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.0638 7.347C21.2465 3.03024 16.9775 -0.000793457 11.9999 -0.000793457C8.68612 -0.000793457 5.68645 1.3426 3.51501 3.51432L6.52017 7.347H23.0638Z" fill="black"/>
<path d="M6.55425 16.6075L3.51501 20.4837C5.68645 22.6554 8.68612 23.9988 11.9999 23.9988C16.9943 23.9988 21.2754 20.9475 23.0823 16.6075H6.55425Z" fill="#496E2D"/>
<path d="M2.60889 8.82605V15.1304H23.5868C23.856 14.1323 24.0002 13.0831 24.0002 12C24.0002 10.9011 23.8522 9.83705 23.5754 8.82605H2.60889Z" fill="#A2001D"/>
<path d="M3.51459 3.51459C-1.17169 8.20087 -1.17169 15.7989 3.51459 20.4852C5.45114 18.5487 7.31362 16.6862 11.9999 11.9999L3.51459 3.51459Z" fill="#0052B4"/>
<path d="M3.90853 9.01648L5.37314 11.0603L7.76976 10.2988L6.27862 12.3235L7.74323 14.3674L5.35692 13.5748L3.86573 15.5995L3.88214 13.085L1.49573 12.2923L3.89217 11.5309L3.90853 9.01648Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5559">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ST = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5426)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M7.30498 7.82623H23.2542C21.5587 3.25662 17.1602 0.000116348 12.0006 0.000116348C8.68686 0.000116348 5.68718 1.34351 3.51575 3.51523L7.30498 7.82623Z" fill="#6DA544"/>
<path d="M7.30413 16.1746H23.2533C21.5579 20.7442 17.1593 24.0007 11.9998 24.0007C8.686 24.0007 5.68633 22.6573 3.51489 20.4856L7.30413 16.1746Z" fill="#6DA544"/>
<path d="M3.51471 3.51378C-1.17157 8.20007 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51378Z" fill="#D80027"/>
<path d="M15.2378 9.91279L15.7558 11.5071H17.4322L16.076 12.4924L16.594 14.0867L15.2378 13.1014L13.8816 14.0867L14.3996 12.4924L13.0435 11.5071H14.7198L15.2378 9.91279Z" fill="black"/>
<path d="M20.4558 9.91279L20.9737 11.5071H22.6501L21.2939 12.4924L21.8119 14.0867L20.4558 13.1014L19.0995 14.0867L19.6175 12.4924L18.2614 11.5071H19.9377L20.4558 9.91279Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_5426">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SV = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5401)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M12 -0.000976562C7.24242 -0.000976562 3.13167 2.7677 1.19067 6.78165H22.8092C20.8682 2.7677 16.7574 -0.000976562 12 -0.000976562Z" fill="#0052B4"/>
<path d="M12 23.9989C16.7574 23.9989 20.8682 21.2302 22.8092 17.2162H1.19067C3.13167 21.2302 7.24242 23.9989 12 23.9989Z" fill="#0052B4"/>
<path d="M9.58997 12.5225L11.9998 8.34857L14.4097 12.5225H9.58997Z" fill="#FFDA44"/>
<path d="M15.1303 13.8996L11.9998 15.4649L8.86938 13.8996V11.8127H15.1303V13.8996Z" fill="#6DA544"/>
<path d="M14.9517 8.52725L13.8449 9.63402C14.317 10.1061 14.609 10.7583 14.609 11.4786C14.609 12.9194 13.441 14.0873 12.0003 14.0873C10.5596 14.0873 9.39162 12.9194 9.39162 11.4786C9.39162 10.7583 9.68365 10.1061 10.1557 9.63402L9.04896 8.52725C8.29357 9.2825 7.82642 10.326 7.82642 11.4786C7.82642 13.7839 9.69514 15.6525 12.0003 15.6525C14.3055 15.6525 16.1742 13.7838 16.1742 11.4786C16.1742 10.326 15.707 9.2825 14.9517 8.52725Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5401">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SX = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5494)">
<path d="M10.9564 13.0427C10.9564 13.0427 3.52156 3.51222 3.51453 3.51391C5.68606 1.34233 8.6861 -0.000823975 11.9998 -0.000823975C18.6272 -0.000823975 23.9998 5.3718 23.9998 11.9992L10.9564 13.0427Z" fill="#D80027"/>
<path d="M10.9564 11.9995C10.9564 11.9995 3.52156 20.4865 3.51453 20.4848C5.68606 22.6564 8.6861 23.9995 11.9998 23.9995C18.6272 23.9995 23.9998 18.6269 23.9998 11.9995H10.9564Z" fill="#0052B4"/>
<path d="M3.51471 3.51462C-1.17157 8.2009 -1.17157 15.7989 3.51471 20.4852C5.45126 18.5487 7.31375 16.6862 12 11.9999L3.51471 3.51462Z" fill="#F0F0F0"/>
<path d="M1.31583 11.9996C1.30926 12.0857 1.30481 12.1725 1.30481 12.2604C1.30481 14.1333 2.82318 15.6517 4.69612 15.6517C6.56906 15.6517 8.08743 14.1333 8.08743 12.2604C8.08743 12.1725 8.08298 12.0857 8.07642 11.9996H1.31583Z" fill="#FFDA44"/>
<path d="M4.69583 10.4338C5.27213 10.4338 5.73931 9.96662 5.73931 9.39032C5.73931 8.81402 5.27213 8.34683 4.69583 8.34683C4.11953 8.34683 3.65234 8.81402 3.65234 9.39032C3.65234 9.96662 4.11953 10.4338 4.69583 10.4338Z" fill="#FFDA44"/>
<path d="M2.34753 9.13019V12.5215C2.34753 14.3187 4.69536 14.8693 4.69536 14.8693C4.69536 14.8693 7.04319 14.3187 7.04319 12.5215V9.13019H2.34753Z" fill="#D80027"/>
<path d="M4.69687 13.7776C4.26131 13.6209 3.39136 13.2203 3.39136 12.5219V10.174H6.00009V12.5219C6.00009 13.2226 5.13023 13.6222 4.69687 13.7776Z" fill="#338AF3"/>
<path d="M5.21768 11.4777V10.9559L4.69596 10.6951L4.17419 10.9559V11.4777L3.91333 11.7386V12.782H5.47858V11.7386L5.21768 11.4777Z" fill="#F3F3F3"/>
</g>
<defs>
<clipPath id="clip0_2087_5494">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5637)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9997 -0.000724792C6.84013 -0.000724792 2.44161 3.25578 0.746094 7.82538H23.2534C21.5578 3.25578 17.1593 -0.000724792 11.9997 -0.000724792Z" fill="#D80027"/>
<path d="M11.9999 24.0005C17.1595 24.0005 21.558 20.744 23.2536 16.1744H0.746338C2.44185 20.744 6.84037 24.0005 11.9999 24.0005Z" fill="black"/>
<path d="M7.17018 9.13013L7.81767 11.1229H9.91312L8.21788 12.3547L8.86542 14.3475L7.17018 13.1159L5.47495 14.3475L6.12248 12.3547L4.42725 11.1229H6.5227L7.17018 9.13013Z" fill="#6DA544"/>
<path d="M16.8301 9.13013L17.4776 11.1229H19.5731L17.8778 12.3547L18.5253 14.3475L16.8301 13.1159L15.1349 14.3475L15.7824 12.3547L14.0872 11.1229H16.1826L16.8301 9.13013Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5637">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const SZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5612)">
<path d="M22.809 17.2165C23.5719 15.6389 23.9998 13.869 23.9998 11.9991C23.9998 10.1293 23.5719 8.35934 22.809 6.78176L11.9998 6.25999L1.19047 6.78171C0.427631 8.35934 -0.000244141 10.1293 -0.000244141 11.9991C-0.000244141 13.869 0.427631 15.6389 1.19047 17.2165L11.9998 17.7383L22.809 17.2165Z" fill="#FFDA44"/>
<path d="M12 0.000274658C7.24242 0.000274658 3.13167 2.76895 1.19067 6.7829H22.8092C20.8682 2.76895 16.7574 0.000274658 12 0.000274658Z" fill="black"/>
<path d="M12 23.9993C7.24242 23.9993 3.13167 21.2307 1.19067 17.2167H22.8092C20.8682 21.2307 16.7574 23.9993 12 23.9993Z" fill="#0052B4"/>
<path d="M23.4331 8.34787H0.566428C0.198834 9.49954 -0.000244141 10.7265 -0.000244141 12C-0.000244141 13.2736 0.198834 14.5005 0.566428 15.6522H23.433C23.8007 14.5005 23.9998 13.2736 23.9998 12C23.9998 10.7265 23.8007 9.49954 23.4331 8.34787Z" fill="#A2001D"/>
<path d="M19.826 11.4791H4.17383V12.5226H19.826V11.4791Z" fill="#FFDA44"/>
<path d="M17.739 9.39119H6.26074V10.4347H17.739V9.39119Z" fill="#FFDA44"/>
<path d="M17.8134 11.9996C17.8134 11.9996 15.1301 15.13 11.9997 15.13C8.86931 15.13 8.86926 11.9996 8.86926 11.9996C8.86926 11.9996 8.86926 8.8691 11.9997 8.8691C15.1302 8.8691 17.8134 11.9996 17.8134 11.9996Z" fill="#F0F0F0"/>
<path d="M11.9996 15.13C8.86913 15.13 6.18591 11.9996 6.18591 11.9996C6.18591 11.9996 8.86913 8.8691 11.9996 8.8691" fill="black"/>
<path d="M10.9567 10.957H9.91321V13.044H10.9567V10.957Z" fill="#F0F0F0"/>
<path d="M14.0867 10.957H13.0432V13.044H14.0867V10.957Z" fill="black"/>
<path d="M4.17398 13.0445C4.75028 13.0445 5.21746 12.5773 5.21746 12.001C5.21746 11.4247 4.75028 10.9575 4.17398 10.9575C3.59768 10.9575 3.13049 11.4247 3.13049 12.001C3.13049 12.5773 3.59768 13.0445 4.17398 13.0445Z" fill="#0052B4"/>
<path d="M19.8267 13.0441C20.403 13.0441 20.8702 12.5769 20.8702 12.0006C20.8702 11.4243 20.403 10.9571 19.8267 10.9571C19.2504 10.9571 18.7832 11.4243 18.7832 12.0006C18.7832 12.5769 19.2504 13.0441 19.8267 13.0441Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5612">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5740)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9683 11.9996H12.0004C12.0004 11.9888 12.0004 11.9783 12.0004 11.9674C11.9897 11.9782 11.979 11.9889 11.9683 11.9996Z" fill="#F0F0F0"/>
<path d="M12.0005 6.26116C12.0005 4.14968 12.0005 2.76616 12.0005 0.000305176H11.9985C5.37194 0.00143018 0.000488281 5.37354 0.000488281 12.0003H6.26135V8.47479L9.78686 12.0003H11.9684C11.9791 11.9896 11.9898 11.9789 12.0005 11.9682C12.0005 11.1597 12.0005 10.4384 12.0005 9.78677L8.47493 6.26116H12.0005Z" fill="#F0F0F0"/>
<path d="M6.07112 1.56537C4.19429 2.63407 2.63396 4.19435 1.56531 6.07118V12.0002H4.69576V4.69592V4.69582H12.0001C12.0001 3.70849 12.0001 2.7679 12.0001 1.56537H6.07112Z" fill="#D80027"/>
<path d="M12.0005 10.524L7.73698 6.26062H6.26135V6.26071L12.0004 11.9997H12.0005C12.0005 11.9997 12.0005 10.9822 12.0005 10.524Z" fill="#D80027"/>
<path d="M13.5649 6.26044V11.9995C13.5649 14.7952 17.2171 15.6517 17.2171 15.6517C17.2171 15.6517 20.8693 14.7952 20.8693 11.9995V6.26044H13.5649Z" fill="#FFDA44"/>
<path d="M16.6957 8.34775C16.6957 8.92407 16.2286 10.4347 15.6522 10.4347C15.0759 10.4347 14.6088 8.92407 14.6088 8.34775C14.6088 7.77142 15.6522 7.30426 15.6522 7.30426C15.6522 7.30426 16.6957 7.77142 16.6957 8.34775Z" fill="#FF9811"/>
<path d="M19.4642 9.48423C19.6326 9.07337 19.7636 8.47281 19.7636 8.17384C19.7636 7.69356 19.1374 7.30426 19.1374 7.30426C19.1374 7.30426 18.5113 7.6936 18.5113 8.17384C18.5113 8.47281 18.6423 9.07337 18.8107 9.48423L18.4492 10.3003C18.6617 10.3867 18.8939 10.4347 19.1374 10.4347C19.3809 10.4347 19.6131 10.3867 19.8256 10.3003L19.4642 9.48423Z" fill="#A2001D"/>
<path d="M16.435 12C16.435 12 15.9133 13.0435 15.9133 14.087C15.9133 14.087 17.4785 14.087 18.522 14.087C18.522 13.0435 18.0003 12 18.0003 12L17.2176 11.4783L16.435 12Z" fill="#6DA544"/>
<path d="M18.0006 12.0005V11.7397C18.0006 11.3075 17.6502 10.957 17.2179 10.957C16.7857 10.957 16.4353 11.3074 16.4353 11.7397V12.0005H18.0006Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5740">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TD = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4419)">
<path d="M12.0003 -0.000549316C10.5325 -0.000549316 9.12639 0.263498 7.82645 0.745841L7.30469 11.9995L7.82641 23.2531C9.12639 23.7355 10.5325 23.9995 12.0003 23.9995C13.4682 23.9995 14.8743 23.7355 16.1742 23.2531L16.696 11.9995L16.1743 0.745841C14.8743 0.263498 13.4682 -0.000549316 12.0003 -0.000549316Z" fill="#FFDA44"/>
<path d="M24.0004 12.0004C24.0004 6.8408 20.7439 2.44228 16.1743 0.746765V23.254C20.7439 21.5585 24.0004 17.16 24.0004 12.0004Z" fill="#D80027"/>
<path d="M7.82611 23.254V0.746765C3.2565 2.44228 0 6.8408 0 12.0004C0 17.16 3.2565 21.5585 7.82611 23.254Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4419">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5674)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M12 0.000396729C11.9913 0.000490479 11.4783 4.8004 11.4783 4.8004H21.6005C19.4113 1.88585 15.9259 0.000396729 12 0.000396729Z" fill="#496E2D"/>
<path d="M12.0002 24.0003C15.926 24.0003 19.4114 22.1149 21.6007 19.2003H2.39966C4.58891 22.1149 8.0743 24.0003 12.0002 24.0003Z" fill="#496E2D"/>
<path d="M23.7597 9.60037H11.4783L12 14.4004H23.7597C23.9172 13.6249 24 12.8223 24 12.0004C24 11.1784 23.9171 10.3758 23.7597 9.60037Z" fill="#496E2D"/>
<path d="M12 14.4C12 11.8957 12 2.81737 12 0C5.37262 0 0 5.37262 0 12C0 12.822 0.082875 13.6245 0.240281 14.4H12Z" fill="#D80027"/>
<path d="M6.62106 5.73828L7.39806 8.12961H9.91267L7.87843 9.60772L8.65534 11.9991L6.62106 10.5212L4.58678 11.9991L5.36382 9.60772L3.32959 8.12961H5.84411L6.62106 5.73828Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5674">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TH = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5668)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M23.254 7.82596H0.746757C0.264366 9.12594 0.000366211 10.532 0.000366211 11.9998C0.000366211 13.4677 0.264366 14.8738 0.746757 16.1737H23.254C23.7364 14.8738 24.0004 13.4677 24.0004 11.9998C24.0004 10.532 23.7364 9.12594 23.254 7.82596Z" fill="#0052B4"/>
<path d="M12.0014 -0.000579834C8.36432 -0.000579834 5.10543 1.61773 2.90479 4.17331H21.098C18.8974 1.61773 15.6385 -0.000579834 12.0014 -0.000579834Z" fill="#D80027"/>
<path d="M21.097 19.8261H2.90381C5.10445 22.3817 8.36334 24 12.0004 24C15.6375 24 18.8964 22.3817 21.097 19.8261Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5668">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TJ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5650)">
<path d="M1.19084 6.78177C0.427997 8.35939 0.00012207 10.1293 0.00012207 11.9991C0.00012207 13.869 0.427997 15.6389 1.19084 17.2165L12.0001 18.26L22.8094 17.2165C23.5722 15.6389 24.0001 13.869 24.0001 11.9991C24.0001 10.1293 23.5722 8.35939 22.8094 6.78177L12.0001 5.73828L1.19084 6.78177Z" fill="#F0F0F0"/>
<path d="M1.19141 17.2176C3.13236 21.2315 7.24278 24.0002 12.0003 24.0002C16.7577 24.0002 20.8682 21.2315 22.8091 17.2176H1.19141Z" fill="#6DA544"/>
<path d="M1.19141 6.78204H22.8091C20.8682 2.76814 16.7577 -0.000579834 12.0003 -0.000579834C7.24278 -0.000579834 3.13236 2.76814 1.19141 6.78204Z" fill="#D80027"/>
<path d="M9.91333 15.1315H14.0873V13.3575L13.2525 13.7749L12.0003 12.5228L10.7481 13.7749L9.91333 13.3575V15.1315Z" fill="#FFDA44"/>
<path d="M7.52492 13.0438L7.71921 13.6416H8.34781L7.83921 14.0112L8.03351 14.609L7.52492 14.2395L7.01632 14.609L7.21062 14.0112L6.70203 13.6416H7.33062L7.52492 13.0438Z" fill="#FFDA44"/>
<path d="M8.12733 10.9577L8.32163 11.5555H8.95022L8.44163 11.925L8.63588 12.5229L8.12733 12.1534L7.61874 12.5229L7.81304 11.925L7.30444 11.5555H7.93304L8.12733 10.9577Z" fill="#FFDA44"/>
<path d="M9.84877 9.39279L10.0431 9.99064H10.6716L10.1631 10.3602L10.3573 10.958L9.84877 10.5885L9.34022 10.958L9.53447 10.3602L9.02588 9.99064H9.65452L9.84877 9.39279Z" fill="#FFDA44"/>
<path d="M16.475 13.0438L16.2807 13.6416H15.6521L16.1607 14.0112L15.9664 14.609L16.475 14.2395L16.9835 14.609L16.7893 14.0112L17.2979 13.6416H16.6693L16.475 13.0438Z" fill="#FFDA44"/>
<path d="M15.8727 10.9577L15.6784 11.5555H15.0498L15.5584 11.925L15.3641 12.5229L15.8727 12.1534L16.3813 12.5229L16.187 11.925L16.6956 11.5555H16.067L15.8727 10.9577Z" fill="#FFDA44"/>
<path d="M14.1512 9.39279L13.9569 9.99064H13.3284L13.8369 10.3602L13.6426 10.958L14.1512 10.5885L14.6598 10.958L14.4655 10.3602L14.9741 9.99064H14.3455L14.1512 9.39279Z" fill="#FFDA44"/>
<path d="M12.0004 8.60938L12.1947 9.20722H12.8233L12.3147 9.57673L12.509 10.1746L12.0004 9.80511L11.4918 10.1746L11.6861 9.57673L11.1775 9.20722H11.8061L12.0004 8.60938Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5650">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TK = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5682)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M19.3043 5.73914C19.1967 6.25641 19.1478 6.80733 19.1478 7.35652C19.1478 10.5222 21.035 13.2621 23.7394 14.4955C23.9097 13.6904 24 12.8558 24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 18.6274 5.37262 24 12 24C16.1101 24 19.7371 21.9332 21.8998 18.7826H6.78263V17.2174H22.8093C22.9733 16.8782 23.1215 16.53 23.2537 16.1739H6.78263L19.3043 5.73914Z" fill="#0052B4"/>
<path d="M8.81571 6.26117L9.07474 7.05833H9.91287L9.23482 7.55103L9.49385 8.34814L8.81571 7.85553L8.13766 8.34814L8.39665 7.55103L7.71851 7.05833H8.55668L8.81571 6.26117Z" fill="#F0F0F0"/>
<path d="M5.41134 12.0001L5.73516 12.9966H6.78281L5.93517 13.6123L6.25898 14.6088L5.41134 13.9929L4.56375 14.6088L4.88751 13.6123L4.03992 12.9966H5.08758L5.41134 12.0001Z" fill="#F0F0F0"/>
<path d="M5.41134 3.65247L5.73516 4.64898H6.78281L5.93517 5.26468L6.25898 6.26115L5.41134 5.64531L4.56375 6.26115L4.88751 5.26468L4.03992 4.64898H5.08758L5.41134 3.65247Z" fill="#F0F0F0"/>
<path d="M2.80245 8.3475L3.12626 9.34402H4.17387L3.32628 9.95972L3.65009 10.9562L2.80245 10.3403L1.95486 10.9562L2.27862 9.95972L1.43103 9.34402H2.47864L2.80245 8.3475Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5682">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TL = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4608)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M11.9997 -0.000305176C9.06173 -0.000305176 6.37082 1.05612 4.28479 2.8091L17.2171 11.9997L4.28479 21.1903C6.37082 22.9433 9.06173 23.9997 11.9997 23.9997C18.6271 23.9997 23.9997 18.6271 23.9997 11.9997C23.9997 5.37232 18.6271 -0.000305176 11.9997 -0.000305176Z" fill="#D80027"/>
<path d="M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z" fill="black"/>
<path d="M3.32696 9.25146L5.15321 10.9798L7.3614 9.77684L6.2821 12.0479L8.1084 13.7763L5.61493 13.4516L4.53549 15.7226L4.07391 13.2508L1.58044 12.926L3.78854 11.7231L3.32696 9.25146Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_4608">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5712)">
<path d="M11.9997 -0.000610352C11.1038 -0.000610352 10.231 0.0984365 9.3911 0.284624L8.86938 11.9993L9.3911 23.7141C10.2311 23.9003 11.1038 23.9994 11.9997 23.9994C18.6272 23.9994 23.9997 18.6268 23.9997 11.9993C23.9997 5.37197 18.6272 -0.000610352 11.9997 -0.000610352Z" fill="#496E2D"/>
<path d="M3.13016 3.91705C1.1856 6.04968 -0.000244141 8.88608 -0.000244141 11.9996C-0.000244141 15.1131 1.18565 17.9496 3.13021 20.0823L3.65193 11.9996L3.13016 3.91705Z" fill="#496E2D"/>
<path d="M17.5514 9.05162C18.1418 7.40602 17.4785 5.61629 16.0551 4.72491C16.3111 4.75824 16.5674 4.81852 16.8204 4.90923C18.7189 5.59041 19.7058 7.6816 19.0247 9.58013C18.3435 11.4788 16.2523 12.4656 14.3537 11.7844C14.1007 11.6937 13.8645 11.5772 13.6458 11.4402C15.3112 11.6571 16.961 10.6972 17.5514 9.05162Z" fill="#F0F0F0"/>
<path d="M14.277 4.27429L13.7639 4.9372L12.9751 4.65412L13.4469 5.34684L12.934 6.00965L13.7386 5.77499L14.2105 6.46762L14.2358 5.62987L15.0405 5.39517L14.2516 5.11218L14.277 4.27429Z" fill="#F0F0F0"/>
<path d="M15.6623 6.4353L15.1492 7.09816L14.3603 6.81508L14.8322 7.5078L14.3192 8.17062L15.1238 7.93587L15.5958 8.62863L15.6212 7.79083L16.4258 7.55608L15.6369 7.27305L15.6623 6.4353Z" fill="#F0F0F0"/>
<path d="M11.8341 5.06036L11.3211 5.72318L10.5322 5.44019L11.0041 6.13286L10.4911 6.79572L11.2957 6.56102L11.7676 7.25369L11.793 6.41594L12.5976 6.18124L11.8087 5.89816L11.8341 5.06036Z" fill="#F0F0F0"/>
<path d="M11.778 7.53455L11.265 8.19741L10.4761 7.91437L10.948 8.60709L10.4349 9.26991L11.2396 9.03525L11.7115 9.72787L11.7369 8.89012L12.5415 8.65542L11.7526 8.37234L11.778 7.53455Z" fill="#F0F0F0"/>
<path d="M14.132 8.38L13.619 9.04282L12.8301 8.75979L13.302 9.4525L12.7889 10.1153L13.5936 9.88061L14.0655 10.5733L14.0909 9.73549L14.8956 9.50083L14.1066 9.2178L14.132 8.38Z" fill="#F0F0F0"/>
<path d="M3.13013 3.9175V20.0827C4.76513 21.8758 6.93684 23.1707 9.39098 23.7148V0.285339C6.9368 0.829371 4.76517 2.12429 3.13013 3.9175Z" fill="#D80027"/>
<path d="M5.51949 6.31755L4.47131 5.5367V4.43247L5.51949 3.65167H7.00191L8.05008 4.43247V5.5367L7.00191 6.31755H5.51949Z" fill="#F0F0F0"/>
<path d="M6.26072 3.65167H5.51948L4.47131 4.43247V4.97233H6.26072V3.65167Z" fill="#FF9811"/>
<path d="M6.26074 6.31668H7.00193L8.0501 5.53583V4.97253H6.26074V6.31668Z" fill="#FF9811"/>
<path d="M5.51949 20.3484L4.47131 19.5676V18.4634L5.51949 17.6826H7.00191L8.05008 18.4634V19.5676L7.00191 20.3484H5.51949Z" fill="#F0F0F0"/>
<path d="M6.26072 17.6826H5.51948L4.47131 18.4634V19.0033H6.26072V17.6826Z" fill="#FF9811"/>
<path d="M6.26074 20.3493H7.00193L8.0501 19.5684V19.0052H6.26074V20.3493Z" fill="#FF9811"/>
<path d="M5.51936 13.3323L4.47119 12.5515V11.4473L5.51936 10.6664H7.00178L8.04995 11.4473V12.5515L7.00178 13.3323H5.51936Z" fill="#496E2D"/>
<path d="M8.0867 15.0514H7.63014V14.5949H6.82787L6.26059 14.0276L5.69335 14.5949H4.89109V15.0514H4.43457V15.9644H4.89109V16.4209H5.69331L6.26063 16.9883L6.82787 16.4209H7.63014V15.9644H8.0867V15.0514Z" fill="#496E2D"/>
<path d="M8.08694 8.03605H7.63038V7.57949H6.82811L6.26083 7.01221L5.6936 7.57949H4.89133V8.03605H4.43481V8.94908H4.89133V9.4056H5.69355L6.26088 9.97297L6.82811 9.4056H7.63038V8.94908H8.08694V8.03605Z" fill="#496E2D"/>
<path d="M6.78225 11.4792H5.73877V12.5227H6.78225V11.4792Z" fill="#D80027"/>
<path d="M6.26061 9.01487C6.54874 9.01487 6.78232 8.78129 6.78232 8.49315C6.78232 8.20502 6.54874 7.97144 6.26061 7.97144C5.97247 7.97144 5.73889 8.20502 5.73889 8.49315C5.73889 8.78129 5.97247 9.01487 6.26061 9.01487Z" fill="#D80027"/>
<path d="M6.26049 16.0308C6.54862 16.0308 6.7822 15.7972 6.7822 15.5091C6.7822 15.2209 6.54862 14.9874 6.26049 14.9874C5.97235 14.9874 5.73877 15.2209 5.73877 15.5091C5.73877 15.7972 5.97235 16.0308 6.26049 16.0308Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5712">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5701)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M11.9999 17.7387C15.1695 17.7387 17.739 15.1692 17.739 11.9996C17.739 8.82994 15.1695 6.26044 11.9999 6.26044C8.83025 6.26044 6.26074 8.82994 6.26074 11.9996C6.26074 15.1692 8.83025 17.7387 11.9999 17.7387Z" fill="#F0F0F0"/>
<path d="M12.7065 9.80505L13.691 11.1619L15.2856 10.6448L14.2995 12.0004L15.2839 13.3572L13.6899 12.8382L12.7038 14.1938L12.7048 12.5175L11.1108 11.9985L12.7054 11.4815L12.7065 9.80505Z" fill="#D80027"/>
<path d="M13.304 15.3906C11.4311 15.3906 9.91273 13.8722 9.91273 11.9993C9.91273 10.1263 11.4311 8.60794 13.304 8.60794C13.888 8.60794 14.4375 8.7556 14.9172 9.01557C14.1647 8.27958 13.1355 7.82532 11.9997 7.82532C9.69457 7.82532 7.82581 9.69404 7.82581 11.9992C7.82581 14.3044 9.69457 16.1731 11.9997 16.1731C13.1355 16.1731 14.1647 15.7188 14.9172 14.9828C14.4375 15.2429 13.888 15.3906 13.304 15.3906Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5701">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TO = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5690)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M7.82613 6.2614V4.6962H6.26088V6.2614H4.69568V7.82665H6.26088V9.39186H7.82613V7.82665H9.39134V6.2614H7.82613Z" fill="#D80027"/>
<path d="M12 0V12C5.37262 12 2.73867 12 0 12C0 18.6274 5.37262 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5690">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TR = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5707)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M11.5088 9.80505L12.4934 11.1619L14.088 10.6448L13.1018 12.0004L14.0863 13.3572L12.4923 12.8382L11.5062 14.1938L11.5072 12.5175L9.91321 11.9985L11.5078 11.4815L11.5088 9.80505Z" fill="#F0F0F0"/>
<path d="M8.82186 15.3906C6.94893 15.3906 5.43055 13.8722 5.43055 11.9993C5.43055 10.1263 6.94893 8.60794 8.82186 8.60794C9.40583 8.60794 9.9553 8.75565 10.435 9.01557C9.68244 8.27954 8.65321 7.82532 7.51752 7.82532C5.2123 7.82532 3.34363 9.69404 3.34363 11.9992C3.34363 14.3044 5.21235 16.1731 7.51752 16.1731C8.6533 16.1731 9.68249 15.7188 10.435 14.9828C9.9553 15.2429 9.40583 15.3906 8.82186 15.3906Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5707">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TT = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5695)">
<path d="M6.49775 1.33197C5.42347 1.88645 4.41505 2.61325 3.51449 3.51381C2.61388 4.41442 1.88708 5.42284 1.33264 6.49713L9.04859 14.951L17.5025 22.6669C18.5768 22.1125 19.5852 21.3857 20.4858 20.4851C21.3864 19.5845 22.1131 18.5761 22.6676 17.5018L14.9517 9.04792L6.49775 1.33197Z" fill="#F0F0F0"/>
<path d="M20.4855 20.4859C20.9889 19.9826 21.4378 19.4454 21.8331 18.882L5.11816 2.16705C4.55477 2.56226 4.01763 3.01123 3.51424 3.51462C3.01084 4.01801 2.56188 4.55515 2.16663 5.11858L18.8815 21.8335C19.4449 21.4383 19.9821 20.9893 20.4855 20.4859Z" fill="black"/>
<path d="M3.51407 20.4865C7.30002 24.2725 12.9858 24.9992 17.502 22.6683L1.33227 6.49854C-0.998592 11.0148 -0.271701 16.7006 3.51407 20.4865Z" fill="#D80027"/>
<path d="M20.485 3.51461C16.6991 -0.271293 11.0133 -0.998043 6.49707 1.33272L22.6668 17.5026C24.9977 12.9864 24.271 7.30052 20.485 3.51461Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5695">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TV = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5754)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#338AF3"/>
<path d="M5.73938 12.0012H9.78666L6.2611 7.82727L5.73938 9.39247V12.0012Z" fill="#0052B4"/>
<path d="M12.0002 9.78671L7.82629 5.73938H12.0002L12.0002 9.78671Z" fill="#0052B4"/>
<path d="M11.9683 11.9996H12.0004C12.0004 11.9888 12.0004 11.9783 12.0004 11.9674C11.9897 11.9782 11.979 11.9889 11.9683 11.9996Z" fill="#F0F0F0"/>
<path d="M12.0004 6.26116C12.0004 4.14968 12.0004 2.76612 12.0004 0.000305176H11.9984C5.37187 0.00143018 0.000366211 5.37354 0.000366211 12.0003H6.26127V8.47479L9.78679 12.0003H11.9683C11.979 11.9896 11.9897 11.9789 12.0005 11.9682C12.0005 11.1597 12.0005 10.4384 12.0005 9.78677L8.4748 6.26116H12.0004Z" fill="#F0F0F0"/>
<path d="M6.07124 1.56537C4.19441 2.63407 2.63413 4.19435 1.56543 6.07118V12.0002H4.69588V4.69592V4.69582H12.0002C12.0002 3.70849 12.0002 2.7679 12.0002 1.56537H6.07124Z" fill="#D80027"/>
<path d="M12.0005 10.524L7.73698 6.26062H6.26135V6.26071L12.0004 11.9997H12.0005C12.0005 11.9997 12.0005 10.9822 12.0005 10.524Z" fill="#D80027"/>
<path d="M13.0973 19.8252L13.3563 20.6224H14.1945L13.5164 21.115L13.7755 21.9121L13.0973 21.4195L12.4192 21.9121L12.6783 21.115L12.0001 20.6224H12.8382L13.0973 19.8252Z" fill="#FFDA44"/>
<path d="M19.7727 14.6093L20.0317 15.4064H20.8699L20.1918 15.8991L20.4509 16.6962L19.7727 16.2036L19.0947 16.6962L19.3537 15.8991L18.6755 15.4064H19.5137L19.7727 14.6093Z" fill="#FFDA44"/>
<path d="M21.4451 6.78253L21.7041 7.57969H22.5423L21.8642 8.07234L22.1232 8.86945L21.4451 8.37684L20.767 8.86945L21.026 8.07234L20.3479 7.57969H21.1861L21.4451 6.78253Z" fill="#FFDA44"/>
<path d="M21.8597 12.5214L22.1186 13.3186H22.9568L22.2788 13.8113L22.5378 14.6084L21.8597 14.1158L21.1816 14.6084L21.4406 13.8113L20.7625 13.3186H21.6006L21.8597 12.5214Z" fill="#FFDA44"/>
<path d="M14.2991 17.9513L15.0461 18.3319L15.6387 17.7393L15.5076 18.567L16.2544 18.9475L15.4265 19.0787L15.2954 19.9066L14.9149 19.1597L14.087 19.2909L14.6797 18.6983L14.2991 17.9513Z" fill="#FFDA44"/>
<path d="M14.2991 14.8214L15.0461 15.2019L15.6387 14.6093L15.5076 15.4371L16.2544 15.8175L15.4265 15.9487L15.2954 16.7766L14.9149 16.0297L14.087 16.1609L14.6797 15.5683L14.2991 14.8214Z" fill="#FFDA44"/>
<path d="M16.908 16.8271L17.6549 17.2077L18.2476 16.6151L18.1165 17.4428L18.8633 17.8234L18.0354 17.9545L17.9043 18.7824L17.5238 18.0355L16.6959 18.1667L17.2886 17.5741L16.908 16.8271Z" fill="#FFDA44"/>
<path d="M16.908 10.1248L17.6549 10.5053L18.2476 9.91266L18.1165 10.7405L18.8633 11.121L18.0354 11.2521L17.9043 12.08L17.5238 11.3332L16.6959 11.4643L17.2886 10.8717L16.908 10.1248Z" fill="#FFDA44"/>
<path d="M19.4365 10.0444L20.1835 10.425L20.7761 9.83234L20.645 10.6601L21.3918 11.0406L20.5639 11.1718L20.4328 11.9996L20.0524 11.2528L19.2245 11.384L19.8171 10.7914L19.4365 10.0444Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5754">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5644)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027"/>
<path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4"/>
<path d="M10.435 7.02305L8.96945 7.71249L9.74983 9.13181L8.15847 8.82731L7.95677 10.435L6.84836 9.25261L5.73986 10.435L5.53825 8.82731L3.94684 9.13172L4.72722 7.71239L3.26172 7.02305L4.72727 6.33375L3.94684 4.91438L5.5382 5.21883L5.73991 3.61121L6.84836 4.79358L7.95681 3.61121L8.15847 5.21883L9.74987 4.91438L8.96945 6.3338L10.435 7.02305Z" fill="#F0F0F0"/>
<path d="M6.8486 9.25672C8.08226 9.25672 9.08233 8.25664 9.08233 7.02299C9.08233 5.78933 8.08226 4.78925 6.8486 4.78925C5.61494 4.78925 4.61487 5.78933 4.61487 7.02299C4.61487 8.25664 5.61494 9.25672 6.8486 9.25672Z" fill="#0052B4"/>
<path d="M6.84792 8.21398C6.19162 8.21398 5.65771 7.68002 5.65771 7.02373C5.65771 6.36743 6.19167 5.83348 6.84792 5.83348C7.50422 5.83348 8.03817 6.36743 8.03817 7.02373C8.03812 7.68002 7.50412 8.21398 6.84792 8.21398Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5644">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const TZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5663)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M3.51471 20.4856C4.0181 20.989 4.55519 21.4379 5.11858 21.8331L21.8328 5.11886C21.4376 4.55547 20.9887 4.01837 20.4853 3.51498C19.9818 3.01159 19.4448 2.56272 18.8814 2.16747L2.16724 18.8817C2.56239 19.445 3.01136 19.9821 3.51471 20.4856Z" fill="black"/>
<path d="M3.51459 3.5138C-0.271129 7.29961 -0.997926 12.9851 1.33284 17.5012L17.502 1.3321C12.9859 -0.998668 7.30036 -0.271825 3.51459 3.5138Z" fill="#6DA544"/>
<path d="M20.485 20.4851C24.2708 16.6994 24.9975 11.0138 22.6668 6.49771L6.49768 22.6669C11.0137 24.9976 16.6993 24.2708 20.485 20.4851Z" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_5663">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const UA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5784)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FFDA44"/>
<path d="M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12" fill="#338AF3"/>
</g>
<defs>
<clipPath id="clip0_2087_5784">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const UG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5776)">
<path d="M20.9431 20.0002C22.8435 17.8771 23.9996 15.0739 23.9996 12.0002C23.9996 8.92654 22.8435 6.12327 20.943 4.00021L11.9996 3.13068L3.05626 4.00021C1.15581 6.12327 -0.000366211 8.92654 -0.000366211 12.0002C-0.000366211 15.0739 1.15576 17.8771 3.05621 20.0002L11.9996 20.8698L20.9431 20.0002Z" fill="#FFDA44"/>
<path d="M3.05664 4.00047H20.9434C18.7462 1.54577 15.5537 0.000488281 12 0.000488281C8.44628 0.000488281 5.25386 1.54577 3.05664 4.00047Z" fill="black"/>
<path d="M-0.000366211 12.0007L11.9996 13.0442L23.9996 12.0007C23.9996 10.598 23.7582 9.25186 23.3158 8.00067H0.683446C0.241087 9.25186 -0.000366211 10.598 -0.000366211 12.0007Z" fill="#D80027"/>
<path d="M0.683446 15.9993H23.3159C23.7582 14.7481 23.9996 13.402 23.9996 11.9993H-0.000366211C-0.000366211 13.402 0.241087 14.7481 0.683446 15.9993Z" fill="black"/>
<path d="M20.9435 19.9995H3.05664C5.25386 22.4542 8.44628 23.9995 12.0001 23.9995C15.5538 23.9995 18.7463 22.4542 20.9435 19.9995Z" fill="#D80027"/>
<path d="M16.0042 12.0007C16.0042 14.2125 14.2115 16.0051 11.9998 16.0051C9.78813 16.0051 7.99548 14.2125 7.99548 12.0007C7.99548 9.78904 9.78813 7.9964 11.9998 7.9964C14.2115 7.9964 16.0042 9.78904 16.0042 12.0007Z" fill="#F0F0F0"/>
<path d="M13.4665 12.2036L11.9995 11.568C11.9995 11.568 12.3428 10.4288 12.361 10.3508C12.3744 10.2939 12.3815 10.2345 12.3815 10.1734C12.3815 9.9573 12.2939 9.76164 12.1523 9.62008L12.5212 9.25117C12.2852 9.01516 11.959 8.86914 11.5989 8.86914C11.2387 8.86914 10.9126 9.01511 10.6765 9.25117L11.0454 9.62008C10.9038 9.76169 10.8162 9.95734 10.8162 10.1734C10.8162 10.2525 10.8282 10.3286 10.85 10.4006L10.2946 10.956H11.3041C11.3041 10.956 10.8867 11.5829 10.6588 12.0977C10.431 12.6125 10.662 13.2409 11.1886 13.475L11.4931 13.6104L11.9995 14.0864V14.6081L11.4778 15.1299H12.5213V14.0864L12.9974 13.6103H13.9822C13.9869 13.6005 13.9919 13.5909 13.9964 13.5809C14.2303 13.0543 13.9931 12.4376 13.4665 12.2036Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_2087_5776">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const US = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5809)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.478 12H23.9997C23.9997 10.9169 23.8554 9.86761 23.5863 8.86951H11.478V12Z" fill="#D80027"/>
<path d="M11.478 5.73848H22.2385C21.5039 4.5398 20.5647 3.48028 19.4696 2.60803H11.478V5.73848Z" fill="#D80027"/>
<path d="M11.9997 23.9999C14.8239 23.9999 17.4197 23.0238 19.4695 21.3912H4.52991C6.57975 23.0238 9.17555 23.9999 11.9997 23.9999Z" fill="#D80027"/>
<path d="M1.7611 18.2598H22.2385C22.8283 17.2975 23.2856 16.2457 23.5864 15.1294H0.413208C0.714005 16.2457 1.17136 17.2975 1.7611 18.2598Z" fill="#D80027"/>
<path d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_5809">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const UY = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5817)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9996 8.86873H23.5862C23.2854 7.75245 22.828 6.70053 22.2384 5.73828H11.9996V8.86873Z" fill="#338AF3"/>
<path d="M4.53009 21.3898H19.4698C20.5649 20.5176 21.5041 19.4581 22.2386 18.2594H1.76123C2.49581 19.4581 3.435 20.5176 4.53009 21.3898Z" fill="#338AF3"/>
<path d="M12.0001 -0.000854492C12.0001 1.04263 12.0001 2.60783 12.0001 2.60783H19.47C17.4201 0.975271 14.8243 -0.000854492 12.0001 -0.000854492Z" fill="#338AF3"/>
<path d="M11.9996 8.86873H23.5862C23.2854 7.75245 22.828 6.70053 22.2384 5.73828H11.9996V8.86873Z" fill="#338AF3"/>
<path d="M0.00012207 12.0001C0.00012207 13.0833 0.144497 14.1324 0.413513 15.1306H23.5868C23.8557 14.1324 24.0001 13.0833 24.0001 12.0001H0.00012207Z" fill="#338AF3"/>
<path d="M10.4352 7.02317L8.96965 7.71256L9.75007 9.13194L8.15867 8.82753L7.95701 10.4351L6.8486 9.25273L5.7401 10.4351L5.53849 8.82753L3.94709 9.13184L4.72746 7.71251L3.26196 7.02317L4.72751 6.33387L3.94709 4.9145L5.53845 5.21891L5.74015 3.61133L6.8486 4.7937L7.95706 3.61133L8.15867 5.21891L9.75012 4.9145L8.9697 6.33392L10.4352 7.02317Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_5817">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const UZ = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5827)">
<path d="M0.566869 8.34794C0.199275 9.49956 0.000197274 10.7264 0.000244149 12C0.000197274 13.2736 0.199322 14.5005 0.566916 15.6521L12.0002 16.174L23.4336 15.6522C23.8011 14.5006 24.0003 13.2736 24.0003 12.0001C24.0003 10.7265 23.8012 9.49956 23.4336 8.34789L12.0002 7.82617L0.566869 8.34794Z" fill="#F0F0F0"/>
<path d="M23.4332 8.34789L11.9999 7.82617L0.5665 8.34789C0.457563 8.68933 0.363766 9.03747 0.285156 9.39137H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z" fill="#D80027"/>
<path d="M0.285034 14.609C0.36355 14.9629 0.457347 15.311 0.566284 15.6524L0.567409 15.6525L11.9996 16.1742L23.4329 15.6525C23.5418 15.3111 23.6356 14.9629 23.7142 14.609H0.285034Z" fill="#D80027"/>
<path d="M12.0004 24.0007C17.3543 24.0007 21.8885 20.4943 23.4338 15.6528H0.567139C2.11237 20.4942 6.64669 24.0007 12.0004 24.0007Z" fill="#6DA544"/>
<path d="M12.0001 -0.000854492C6.64632 -0.000807617 2.1121 3.50558 0.566772 8.34697L23.4334 8.34702C21.8882 3.50554 17.354 -0.000901367 12.0001 -0.000854492Z" fill="#338AF3"/>
<path d="M5.48351 4.95618C5.48351 3.83226 6.2734 2.89335 7.32823 2.66301C7.16614 2.62757 6.9979 2.6084 6.82512 2.6084C5.52847 2.6084 4.47729 3.65952 4.47729 4.95623C4.47729 6.25293 5.52837 7.30406 6.82512 7.30406C6.9979 7.30406 7.16609 7.28484 7.32823 7.24945C6.27345 7.01901 5.48351 6.0801 5.48351 4.95618Z" fill="#F0F0F0"/>
<path d="M8.71543 6.02246L8.87434 6.5116H9.38865L8.97259 6.81395L9.13149 7.30309L8.71543 7.00079L8.29927 7.30309L8.45823 6.81395L8.04211 6.5116H8.55643L8.71543 6.02246Z" fill="#F0F0F0"/>
<path d="M10.3577 6.02246L10.5166 6.5116H11.0309L10.6148 6.81395L10.7738 7.30309L10.3577 7.00079L9.94156 7.30309L10.1005 6.81395L9.68445 6.5116H10.1987L10.3577 6.02246Z" fill="#F0F0F0"/>
<path d="M11.9988 6.02246L12.1577 6.5116H12.672L12.2559 6.81395L12.4148 7.30309L11.9988 7.00079L11.5826 7.30309L11.7416 6.81395L11.3254 6.5116H11.8398L11.9988 6.02246Z" fill="#F0F0F0"/>
<path d="M13.641 6.02246L13.7999 6.5116H14.3142L13.8981 6.81395L14.0571 7.30309L13.641 7.00079L13.2248 7.30309L13.3838 6.81395L12.9677 6.5116H13.482L13.641 6.02246Z" fill="#F0F0F0"/>
<path d="M15.2822 6.02246L15.4412 6.5116H15.9555L15.5394 6.81395L15.6984 7.30309L15.2822 7.00079L14.8661 7.30309L15.0251 6.81395L14.609 6.5116H15.1233L15.2822 6.02246Z" fill="#F0F0F0"/>
<path d="M10.3577 4.31506L10.5166 4.80416H11.0309L10.6148 5.10655L10.7738 5.59564L10.3577 5.29335L9.94156 5.59564L10.1005 5.10655L9.68445 4.80416H10.1987L10.3577 4.31506Z" fill="#F0F0F0"/>
<path d="M11.9988 4.31506L12.1577 4.80416H12.672L12.2559 5.10655L12.4148 5.59564L11.9988 5.29335L11.5826 5.59564L11.7416 5.10655L11.3254 4.80416H11.8398L11.9988 4.31506Z" fill="#F0F0F0"/>
<path d="M13.641 4.31506L13.7999 4.80416H14.3142L13.8981 5.10655L14.0571 5.59564L13.641 5.29335L13.2248 5.59564L13.3838 5.10655L12.9677 4.80416H13.482L13.641 4.31506Z" fill="#F0F0F0"/>
<path d="M15.2822 4.31506L15.4412 4.80416H15.9555L15.5394 5.10655L15.6984 5.59564L15.2822 5.29335L14.8661 5.59564L15.0251 5.10655L14.609 4.80416H15.1233L15.2822 4.31506Z" fill="#F0F0F0"/>
<path d="M11.9988 2.60803L12.1577 3.09722H12.672L12.2559 3.39952L12.4148 3.8887L11.9988 3.58641L11.5826 3.8887L11.7416 3.39952L11.3254 3.09722H11.8398L11.9988 2.60803Z" fill="#F0F0F0"/>
<path d="M13.641 2.60803L13.7999 3.09722H14.3142L13.8981 3.39952L14.0571 3.8887L13.641 3.58641L13.2248 3.8887L13.3838 3.39952L12.9677 3.09722H13.482L13.641 2.60803Z" fill="#F0F0F0"/>
<path d="M15.2822 2.60803L15.4412 3.09722H15.9555L15.5394 3.39952L15.6984 3.8887L15.2822 3.58641L14.8661 3.8887L15.0251 3.39952L14.609 3.09722H15.1233L15.2822 2.60803Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5827">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const VC = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5592)">
<path d="M17.739 1.45932C16.0342 0.529135 14.0788 0.000244141 11.9999 0.000244141C9.921 0.000244141 7.96566 0.529135 6.26077 1.45932L5.21729 12.0002L6.26077 22.5412C7.96566 23.4714 9.921 24.0002 11.9999 24.0002C14.0788 24.0002 16.0342 23.4714 17.739 22.5412L18.7825 12.0002L17.739 1.45932Z" fill="#FFDA44"/>
<path d="M6.26123 22.5408V1.45898C2.5311 3.4943 0.000366211 7.45144 0.000366211 12C0.000366211 16.5485 2.5311 20.5056 6.26123 22.5408Z" fill="#338AF3"/>
<path d="M24.0005 12.0002C24.0005 7.45168 21.4697 3.49454 17.7396 1.45923V22.541C21.4697 20.5059 24.0005 16.5487 24.0005 12.0002Z" fill="#6DA544"/>
<path d="M9.39195 15.1298L7.30493 11.9993L9.3919 8.8689L11.479 11.9993L9.39195 15.1298Z" fill="#6DA544"/>
<path d="M14.6098 15.1298L12.5228 11.9993L14.6098 8.8689L16.6968 11.9993L14.6098 15.1298Z" fill="#6DA544"/>
<path d="M12.0008 19.3037L9.91382 16.1733L12.0008 13.0428L14.0878 16.1733L12.0008 19.3037Z" fill="#6DA544"/>
</g>
<defs>
<clipPath id="clip0_2087_5592">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const VE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4189)">
<path d="M22.8088 17.2166C23.5717 15.639 23.9995 13.8692 23.9995 11.9993C23.9995 10.1294 23.5717 8.35951 22.8088 6.78189L11.9995 5.7384L1.19023 6.78189C0.42734 8.35951 -0.000488281 10.1294 -0.000488281 11.9993C-0.000488281 13.8692 0.42734 15.639 1.19023 17.2166L11.9995 18.2601L22.8088 17.2166Z" fill="#0052B4"/>
<path d="M11.9997 24.0004C16.7572 24.0004 20.868 21.2317 22.809 17.2178H1.19043C3.13143 21.2317 7.24218 24.0004 11.9997 24.0004Z" fill="#D80027"/>
<path d="M20.7819 14.3561L20.1481 14.8514L20.4232 15.607L19.7563 15.1574L19.1224 15.6525L19.344 14.8793L18.6772 14.4295L19.4811 14.4015L19.7029 13.6283L19.9781 14.3841L20.7819 14.3561Z" fill="#F0F0F0"/>
<path d="M19.159 11.5444L18.7329 12.2266L19.25 12.8426L18.4694 12.6483L18.0432 13.3303L17.987 12.5279L17.2065 12.3333L17.9524 12.0319L17.8964 11.2295L18.4133 11.8458L19.159 11.5444Z" fill="#F0F0F0"/>
<path d="M16.6725 9.45837L16.5054 10.2452L17.2019 10.6474L16.402 10.7317L16.2347 11.5183L15.9076 10.7835L15.1075 10.8675L15.7054 10.3293L15.3782 9.59455L16.0748 9.99664L16.6725 9.45837Z" fill="#F0F0F0"/>
<path d="M13.6222 8.34802L13.7343 9.14457L14.5264 9.28416L13.8035 9.63695L13.9154 10.4334L13.3567 9.85482L12.6336 10.2074L13.0113 9.49712L12.4525 8.91859L13.2447 9.05823L13.6222 8.34802Z" fill="#F0F0F0"/>
<path d="M10.3766 8.34802L10.7543 9.05822L11.5463 8.91849L10.9877 9.49726L11.3652 10.2075L10.6423 9.85482L10.0834 10.4333L10.1955 9.63694L9.47253 9.28435L10.2647 9.14457L10.3766 8.34802Z" fill="#F0F0F0"/>
<path d="M7.32626 9.45837L7.92411 9.99664L8.62053 9.59455L8.29348 10.3295L8.89119 10.8677L8.09126 10.7835L7.76398 11.5183L7.59697 10.7315L6.797 10.6475L7.49356 10.2453L7.32626 9.45837Z" fill="#F0F0F0"/>
<path d="M4.83973 11.5444L5.58565 11.8457L6.10249 11.2296L6.04657 12.0322L6.79225 12.3335L6.01183 12.528L5.95563 13.3303L5.52954 12.6483L4.74902 12.8428L5.26605 12.2266L4.83973 11.5444Z" fill="#F0F0F0"/>
<path d="M3.2168 14.3561L4.0208 14.3841L4.29577 13.6284L4.51772 14.4017L5.32148 14.4297L4.65464 14.8796L4.87627 15.6527L4.24252 15.1575L3.57562 15.6072L3.85073 14.8514L3.2168 14.3561Z" fill="#F0F0F0"/>
<path d="M22.809 6.78226C20.868 2.76831 16.7572 -0.000366211 11.9997 -0.000366211C7.24218 -0.000366211 3.13143 2.76831 1.19043 6.78226H22.809Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4189">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const VG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4312)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z" fill="#0052B4"/>
<path d="M11.9683 12.0007H12.0004C12.0004 11.9899 12.0004 11.9794 12.0004 11.9685C11.9897 11.9793 11.979 11.99 11.9683 12.0007Z" fill="#F0F0F0"/>
<path d="M11.9999 6.26171C11.9999 4.15023 11.9999 2.76671 11.9999 0.000854492H11.9979C5.37133 0.00197949 -0.00012207 5.37409 -0.00012207 12.0009H6.26073V8.47534L9.78625 12.0009H11.9678C11.9785 11.9902 11.9892 11.9795 11.9999 11.9687C11.9999 11.1603 11.9999 10.4389 11.9999 9.78732L8.47431 6.26171H11.9999Z" fill="#F0F0F0"/>
<path d="M6.07063 1.56418C4.1938 2.63288 2.63348 4.19316 1.56482 6.06999V11.999H4.69527V4.69473V4.69463H11.9996C11.9996 3.7073 11.9996 2.76671 11.9996 1.56418H6.07063Z" fill="#D80027"/>
<path d="M17.2179 11.9996L13.9745 15.2431C14.5824 16.4155 15.8062 17.217 17.2179 17.217C18.6296 17.217 19.8535 16.4155 20.4613 15.2431L17.2179 11.9996Z" fill="#FFDA44"/>
<path d="M11.9998 10.5244L7.73624 6.26097H6.26062V6.26106L11.9997 12.0001H11.9998C11.9998 12.0001 11.9998 10.9826 11.9998 10.5244Z" fill="#D80027"/>
<path d="M13.5652 6.26097V12.0001V12.0001C13.5652 14.7957 17.2174 15.6523 17.2174 15.6523C17.2174 15.6523 20.8695 14.7957 20.8695 12.0001V12.0001V6.26097H13.5652Z" fill="#6DA544"/>
<path d="M18 8.86989H16.4348V13.0438H18V8.86989Z" fill="#F0F0F0"/>
<path d="M17.2173 9.65173C17.6495 9.65173 17.9999 9.30133 17.9999 8.8691C17.9999 8.43687 17.6495 8.08647 17.2173 8.08647C16.7851 8.08647 16.4347 8.43687 16.4347 8.8691C16.4347 9.30133 16.7851 9.65173 17.2173 9.65173Z" fill="#A2001D"/>
<path d="M15.6529 7.30481H14.6094V8.34829H15.6529V7.30481Z" fill="#FFDA44"/>
<path d="M15.6522 9.65199H14.6088V10.6955H15.6522V9.65199Z" fill="#FFDA44"/>
<path d="M15.6522 12.0005H14.6088V13.044H15.6522V12.0005Z" fill="#FFDA44"/>
<path d="M19.8262 7.30545H18.7827V8.34893H19.8262V7.30545Z" fill="#FFDA44"/>
<path d="M19.8262 9.65199H18.7827V10.6955H19.8262V9.65199Z" fill="#FFDA44"/>
<path d="M19.8262 12.0005H18.7827V13.044H19.8262V12.0005Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4312">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const VI = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4205)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FCFCFC"/>
<path d="M14.0378 8.38349C14.0378 7.25793 13.1254 6.34546 11.9997 6.34546C10.8741 6.34546 9.96167 7.25793 9.96167 8.38349H5.47803C5.47803 9.49166 6.44337 10.3901 7.55154 10.3901H7.48479C7.48479 11.4984 8.38311 12.3969 9.49147 12.3969C9.49147 13.3781 10.1962 14.1934 11.1269 14.3677L11.1217 14.3794H12.8779L12.8727 14.3677C13.8034 14.1934 14.5081 13.3781 14.5081 12.3969C15.6164 12.3969 16.5148 11.4984 16.5148 10.3901H16.4479C17.5561 10.3901 18.5215 9.49166 18.5215 8.38349H14.0378Z" fill="#FFDA44"/>
<path d="M11.1042 14.1724L9.84058 17.0253C10.5073 17.2964 11.2361 17.447 12.0002 17.447C12.7643 17.447 13.4931 17.2964 14.1598 17.0253L12.8962 14.1724H11.1042Z" fill="#FFDA44"/>
<path d="M9.39124 9.3855V12.896C9.39124 14.8928 11.9999 15.5047 11.9999 15.5047C11.9999 15.5047 14.6086 14.8928 14.6086 12.896V9.3855H9.39124Z" fill="#F0F0F0"/>
<path d="M2.90988 12.0846L4.32077 16.0307L5.71699 12.0846H6.78255L4.74695 17.302H3.89453L1.84436 12.0846H2.90988Z" fill="#338AF3"/>
<path d="M19.3041 17.302V12.0846H20.3181V17.302H19.3041Z" fill="#338AF3"/>
<path d="M10.4343 10.5195V14.7736C10.793 15.0376 11.1788 15.2191 11.4778 15.3354V10.5195H10.4343Z" fill="#D80027"/>
<path d="M13.5642 10.5195V14.7736C13.2056 15.0376 12.8197 15.2191 12.5208 15.3354V10.5195H13.5642Z" fill="#D80027"/>
<path d="M14.6086 9.3855H9.39124V11.0409H14.6086V9.3855Z" fill="#0052B4"/>
</g>
<defs>
<clipPath id="clip0_2087_4205">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const VN = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4202)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#D80027"/>
<path d="M12.0002 6.26123L13.2952 10.247H17.4861L14.0956 12.7103L15.3906 16.696L12.0002 14.2327L8.60969 16.696L9.90475 12.7103L6.51428 10.247H10.7051L12.0002 6.26123Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4202">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const VU = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4163)">
<path d="M24.0003 12.0003C24.0003 11.4698 23.9655 10.9475 23.8988 10.4351H10.435C7.98342 7.98365 3.51488 3.51539 3.51507 3.51501C-1.1712 8.20129 -1.1712 15.7992 3.51507 20.4856L10.4352 13.5656H23.8988C23.9655 13.0532 24.0003 12.5308 24.0003 12.0003Z" fill="black"/>
<path d="M23.9967 12.2726C23.9962 12.2958 23.9957 12.319 23.995 12.3422C23.9956 12.3189 23.9961 12.2958 23.9967 12.2726Z" fill="#F0F0F0"/>
<path d="M23.9851 12.6002C23.984 12.6232 23.9824 12.646 23.9812 12.6689C23.9824 12.6461 23.9839 12.6232 23.9851 12.6002Z" fill="#F0F0F0"/>
<path d="M23.968 12.8632C23.9656 12.8969 23.9633 12.9307 23.9606 12.9643C23.9633 12.9307 23.9656 12.8969 23.968 12.8632Z" fill="#F0F0F0"/>
<path d="M23.9285 10.6921C23.9329 10.7323 23.9373 10.7724 23.9413 10.8127C23.9373 10.7724 23.9328 10.7323 23.9285 10.6921Z" fill="#F0F0F0"/>
<path d="M23.9805 11.3298C23.9817 11.3527 23.9833 11.3756 23.9844 11.3985C23.9832 11.3756 23.9817 11.3527 23.9805 11.3298Z" fill="#F0F0F0"/>
<path d="M23.9945 11.6567C23.9952 11.6799 23.9956 11.7032 23.9962 11.7264C23.9957 11.7031 23.9951 11.6799 23.9945 11.6567Z" fill="#F0F0F0"/>
<path d="M23.9609 11.0355C23.9637 11.0692 23.966 11.1029 23.9684 11.1367C23.966 11.1029 23.9637 11.0692 23.9609 11.0355Z" fill="#F0F0F0"/>
<path d="M23.8987 10.4344C23.9041 10.4755 23.9089 10.5168 23.9138 10.558C23.2016 4.61044 18.1397 -0.000366211 12.0003 -0.000366211C8.68651 -0.000366211 5.68647 1.34283 3.51489 3.5145L10.4348 10.4344H23.8987V10.4344Z" fill="#D80027"/>
<path d="M23.8987 13.5652H10.4348L3.51489 20.4851C5.68647 22.6567 8.68651 24 12.0003 24C18.1397 24 23.2016 19.3892 23.9138 13.4415C23.9089 13.4827 23.904 13.5241 23.8987 13.5652Z" fill="#6DA544"/>
<path d="M23.9413 13.1877C23.9373 13.228 23.9329 13.2681 23.9285 13.3083C23.9329 13.2681 23.9373 13.2281 23.9413 13.1877Z" fill="#F0F0F0"/>
<path d="M23.9685 11.137C23.9731 11.2012 23.9772 11.2655 23.9807 11.33C23.9771 11.2655 23.9731 11.2012 23.9685 11.137Z" fill="black"/>
<path d="M23.9132 10.5583C23.9186 10.6029 23.9237 10.6475 23.9285 10.6922C23.9236 10.6475 23.9185 10.6029 23.9132 10.5583Z" fill="black"/>
<path d="M23.9412 10.8124C23.9485 10.8869 23.9551 10.9616 23.9611 11.0367C23.9551 10.9616 23.9485 10.8869 23.9412 10.8124Z" fill="black"/>
<path d="M24.0005 12C24.0005 12.0913 23.9991 12.1823 23.9971 12.2731C23.9991 12.1823 24.0005 12.0913 24.0005 12Z" fill="black"/>
<path d="M23.9808 12.6688C23.9773 12.7333 23.9731 12.7977 23.9686 12.8619C23.9731 12.7977 23.9772 12.7333 23.9808 12.6688Z" fill="black"/>
<path d="M23.9611 12.964C23.9551 13.0389 23.9485 13.1137 23.9412 13.1882C23.9485 13.1137 23.9551 13.0389 23.9611 12.964Z" fill="black"/>
<path d="M23.9285 13.3081C23.9237 13.3528 23.9186 13.3974 23.9132 13.4419C23.9185 13.3974 23.9236 13.3528 23.9285 13.3081Z" fill="black"/>
<path d="M23.9971 11.7274C23.9991 11.8183 24.0005 11.9093 24.0005 12.0005C24.0005 11.9093 23.9991 11.8183 23.9971 11.7274Z" fill="black"/>
<path d="M23.9856 11.3982C23.9898 11.4841 23.993 11.5704 23.9954 11.6569C23.993 11.5704 23.9899 11.4841 23.9856 11.3982Z" fill="black"/>
<path d="M23.9953 12.3419C23.9929 12.4283 23.9897 12.5146 23.9855 12.6006C23.9898 12.5146 23.9929 12.4283 23.9953 12.3419Z" fill="black"/>
<path d="M23.989 11.4733H9.99426L2.80566 4.28577C2.5733 4.53083 2.32144 4.87302 2.16568 5.11672L9.04031 11.995L2.15991 18.8755C2.29613 19.1178 2.5929 19.4765 2.80125 19.7099L9.9944 12.5168H23.9907C23.9981 12.3437 24.0005 12.1699 24.0005 11.995C24.0004 11.7608 23.994 11.588 23.989 11.4733Z" fill="#FFDA44"/>
<path d="M2.91539 14.5574V13.5523C3.91842 13.5523 4.73437 12.7362 4.73437 11.7333C4.73437 11.0237 4.15701 10.4464 3.44742 10.4464C2.964 10.4464 2.57067 10.8396 2.57067 11.3232C2.57067 11.6323 2.82216 11.8838 3.13134 11.8838C3.30609 11.8838 3.44826 11.7416 3.44826 11.5668H4.45336C4.45336 12.2959 3.86029 12.8889 3.13139 12.8889C2.268 12.889 1.56567 12.1865 1.56567 11.3232C1.56567 10.2856 2.40989 9.44141 3.44747 9.44141C4.71131 9.44141 5.73956 10.4697 5.73956 11.7335C5.73951 13.2905 4.47262 14.5574 2.91539 14.5574Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4163">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const WS = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5409)">
<path d="M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z" fill="#D80027"/>
<path d="M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z" fill="#0052B4"/>
<path d="M9.61146 7.82622L9.80576 8.42411H10.4344L9.92576 8.79353L10.1201 9.39142L9.61146 9.0219L9.10287 9.39142L9.29717 8.79353L8.78857 8.42411H9.41717L9.61146 7.82622Z" fill="#F0F0F0"/>
<path d="M6.45448 3.13118L6.77824 4.1277H7.826L6.97831 4.7434L7.30217 5.73987L6.45448 5.12398L5.60684 5.73987L5.93065 4.7434L5.08301 4.1277H6.13067L6.45448 3.13118Z" fill="#F0F0F0"/>
<path d="M9.58546 4.17502L9.90923 5.17158H10.9569L10.1093 5.78729L10.4331 6.78375L9.58546 6.16786L8.73782 6.78375L9.06163 5.78729L8.21399 5.17158H9.26165L9.58546 4.17502Z" fill="#F0F0F0"/>
<path d="M7.1106 8.34901L7.43442 9.34553H8.48207L7.63443 9.96123L7.95824 10.9577L7.1106 10.3419L6.26296 10.9577L6.58678 9.96123L5.73914 9.34553H6.78684L7.1106 8.34901Z" fill="#F0F0F0"/>
<path d="M4.36764 5.73991L4.69145 6.73642H5.73916L4.89147 7.35212L5.21528 8.34859L4.36764 7.73275L3.52004 8.34859L3.84381 7.35212L2.99622 6.73642H4.04387L4.36764 5.73991Z" fill="#F0F0F0"/>
</g>
<defs>
<clipPath id="clip0_2087_5409">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const YE = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4226)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M11.9999 23.9992C17.1595 23.9992 21.558 20.7427 23.2536 16.1731H0.746338C2.44185 20.7427 6.84037 23.9992 11.9999 23.9992Z" fill="black"/>
<path d="M11.9999 0.000610352C6.84037 0.000610352 2.44185 3.25711 0.746338 7.82672H23.2536C21.558 3.25711 17.1595 0.000610352 11.9999 0.000610352Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_4226">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ZA = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_5530)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M3.51422 20.4852C-1.17206 15.7989 -1.17206 8.20092 3.51422 3.51459C3.51389 3.5151 10.4343 11.9999 10.4343 11.9999L3.51422 20.4852Z" fill="black"/>
<path d="M10.435 12.0002L1.59175 6.02423C1.31757 6.50081 1.07579 6.99825 0.868042 7.51312L5.34503 12.0002L0.868183 16.4876C1.07575 17.0021 1.31729 17.4992 1.59128 17.9754L10.435 12.0002Z" fill="#FFDA44"/>
<path d="M23.8985 10.4348H10.4346L3.5147 3.51483C2.76901 4.26052 2.12116 5.10385 1.59166 6.02405L7.55598 12L1.59119 17.9751C2.12069 18.8955 2.76883 19.7392 3.5147 20.485L10.4346 13.5652H23.8985C23.9652 13.0528 24.0001 12.5304 24.0001 12C24.0001 11.4695 23.9652 10.9471 23.8985 10.4348Z" fill="#6DA544"/>
<path d="M4.69373 21.5181C6.71727 23.0735 9.25026 23.9988 11.9998 23.9988C17.5441 23.9988 22.2094 20.2385 23.5864 15.1293H11.0826L4.69373 21.5181Z" fill="#0052B4"/>
<path d="M23.5864 8.86875C22.2094 3.75957 17.5441 -0.000793457 11.9998 -0.000793457C9.25026 -0.000793457 6.71727 0.924566 4.69373 2.47997L11.0825 8.86875H23.5864Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_2087_5530">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ZM = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4230)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#496E2D"/>
<path d="M16.6953 11.9993H11.9996V23.9993C13.4023 23.9993 14.7484 23.7578 15.9996 23.3156L16.6953 11.9993Z" fill="#D80027"/>
<path d="M20.0002 20.9427C22.4549 18.7455 24.0002 15.553 24.0002 11.9993H19.3046L20.0002 20.9427Z" fill="#FF9811"/>
<path d="M15.9999 11.9993V23.3155C17.4904 22.7886 18.8457 21.9759 19.9999 20.9427V11.9993H15.9999Z" fill="black"/>
<path d="M22.1738 7.82669H19.0434C19.0434 7.25041 18.5761 6.7832 17.9999 6.7832C17.4236 6.7832 16.9564 7.25041 16.9564 7.82669H13.8259C13.8259 8.40302 14.3279 8.87017 14.9041 8.87017H14.8694C14.8694 9.4465 15.3365 9.91366 15.9129 9.91366C15.9129 10.49 16.38 10.9571 16.9564 10.9571H19.0434C19.6196 10.9571 20.0868 10.49 20.0868 9.91366C20.6631 9.91366 21.1303 9.4465 21.1303 8.87017H21.0956C21.6719 8.87013 22.1738 8.40297 22.1738 7.82669Z" fill="#FF9811"/>
</g>
<defs>
<clipPath id="clip0_2087_4230">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const ZW = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2087_4236)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0"/>
<path d="M22.8522 6.87246C22.2426 5.58461 21.4105 4.42291 20.4055 3.43643L12.0008 2.60913L3.5961 3.43647C3.56929 3.46277 3.54313 3.48968 3.5166 3.51625L6.87285 6.8725L12.0008 7.02911L22.8522 6.87246Z" fill="#FFDA44"/>
<path d="M3.51599 20.4853C3.56015 20.5295 3.60421 20.5737 3.64902 20.6172L12.0003 21.3923L20.3515 20.6172C21.3669 19.6328 22.2091 18.471 22.8274 17.1812L7.30462 16.6967C5.96901 18.0323 4.42851 19.5727 3.51599 20.4853Z" fill="#FFDA44"/>
<path d="M23.8805 10.3081L9.91284 9.91309L11.9998 12.0001C11.3817 12.6182 10.4589 13.541 9.91284 14.087L23.8732 13.7442C23.9561 13.1747 23.9998 12.5925 23.9998 12.0001C23.9998 11.4256 23.9586 10.861 23.8805 10.3081Z" fill="black"/>
<path d="M12 0.000610352C8.72684 0.000610352 5.76031 1.3117 3.59534 3.43664H20.4047C18.2397 1.3117 15.2732 0.000610352 12 0.000610352Z" fill="#6DA544"/>
<path d="M10.3076 10.3086H23.8802C23.709 9.09551 23.3567 7.94079 22.851 6.87256H6.87158L10.3076 10.3086Z" fill="#D80027"/>
<path d="M6.81946 17.1815H22.8267C23.3383 16.1141 23.6962 14.9592 23.873 13.7455H10.2555C8.92485 15.0761 7.79713 16.2038 6.81946 17.1815Z" fill="#D80027"/>
<path d="M12 24.0006C15.2463 24.0006 18.191 22.7109 20.3512 20.6167H3.6488C5.80899 22.7109 8.75368 24.0006 12 24.0006Z" fill="#6DA544"/>
<path d="M4.28516 2.80994C4.0184 3.03409 3.76101 3.26908 3.51477 3.51522L12.0001 12.0005L3.51477 20.4858C3.76096 20.732 4.0184 20.967 4.28516 21.1911L13.4758 12.0005L4.28516 2.80994Z" fill="black"/>
<path d="M4.82455 8.86914L5.6015 11.2605H8.11611L6.08183 12.7386L6.85883 15.13L4.82455 13.652L2.79022 15.13L3.56732 12.7386L1.53308 11.2605H4.04755L4.82455 8.86914Z" fill="#D80027"/>
<path d="M6.96209 12.1947L4.93718 11.4773C4.93718 11.4773 4.78756 10.0738 4.77851 10.0262C4.70979 9.66418 4.39165 9.39038 4.00962 9.39038C3.57743 9.39038 3.22699 9.74077 3.22699 10.173C3.22699 10.2447 3.23745 10.3137 3.25549 10.3797L2.68774 10.9513C2.68774 10.9513 3.36209 10.9513 3.69724 10.9513C3.69724 11.9991 2.91537 11.9991 2.91537 13.0425L3.3491 14.086H5.95779L6.3926 13.0425H6.39242C6.43596 12.9424 6.4624 12.8392 6.47332 12.736C6.84813 12.5844 6.96209 12.1947 6.96209 12.1947Z" fill="#FFDA44"/>
</g>
<defs>
<clipPath id="clip0_2087_4236">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
`;

const Icons = {
    alertCircle: AlertCircle,
    alertTriangle: AlertTriangle,
    alignVerticalCenter: AlignVerticalCenter,
    angelListBrand: AngelListBrand,
    angelList: AngelList,
    appleBrand: AppleBrand,
    apple: Apple,
    arbitrumBrand: ArbitrumBrand,
    arrowCircleBrokenDownLeft: ArrowCircleBrokenDownLeft,
    arrowCircleDownFilled: ArrowCircleDownFilled,
    arrowNarrow: ArrowNarrow,
    arrow: Arrow,
    asterisk: Asterisk,
    backupKit: BackupKit,
    bank: Bank,
    baseBrand: BaseBrand,
    brush: Brush,
    celoBrand: CeloBrand,
    checkCircleFilled: CheckCircleFilled,
    checkCircle: CheckCircle,
    checkSquare: CheckSquare,
    check: Check,
    chevronDown: ChevronDown,
    chevronRight: ChevronRight,
    chevronSelectorVertical: ChevronSelectorVertical,
    chevronUp: ChevronUp,
    clock: Clock,
    close: Close,
    clubhouseBrand: ClubhouseBrand,
    clubhouse: Clubhouse,
    code: Code,
    copy07: Copy07,
    copy: Copy,
    cosmos: Cosmos,
    creditCard02: CreditCard02,
    creditCard: CreditCard,
    cube03: Cube03,
    cubeOutline: CubeOutline,
    cube: Cube,
    currencyDollar: CurrencyDollar,
    decentBrand: DecentBrand,
    decent: Decent,
    dell: Dell,
    discordBrand: DiscordBrand,
    discord: Discord,
    dot: Dot,
    dots: Dots,
    downloadCloud: DownloadCloud,
    download: Download,
    dribbbleBrand: DribbbleBrand,
    dribbble: Dribbble,
    earth: Earth,
    edit02: Edit02,
    emptyCircle: EmptyCircle,
    ethereum: Ethereum,
    eyeOff: EyeOff,
    eye: Eye,
    facebookBrand: FacebookBrand,
    facebook: Facebook,
    farcasterBrand: FarcasterBrand,
    farcaster: Farcaster,
    figmaBrand: FigmaBrand,
    figma: Figma,
    file: File,
    folder: Folder,
    githubBrand: GithubBrand,
    github: Github,
    globe: Globe,
    googleBrand: GoogleBrand,
    google: Google,
    gridDots: GridDots,
    helpCircle: HelpCircle,
    heroAlertCircle: HeroAlertCircle,
    heroCheckmarkCapsule: HeroCheckmarkCapsule,
    heroCheckmark: HeroCheckmark,
    heroEmail: HeroEmail,
    heroExternalConnection: HeroExternalConnection,
    heroLock: HeroLock,
    heroPasskey: HeroPasskey,
    heroPhone: HeroPhone,
    heroPlusCircleCapsule: HeroPlusCircleCapsule,
    heroPlusCircle: HeroPlusCircle,
    heroWallet: HeroWallet,
    home: Home,
    hp: Hp,
    image: Image$1,
    infoCircle: InfoCircle,
    instagramBrand: InstagramBrand,
    instagram: Instagram,
    key: Key,
    laptop: Laptop,
    lenovo: Lenovo,
    lg: Lg,
    lightning01: Lightning01,
    lightning: Lightning,
    linkExternal: LinkExternal,
    linkedinBrand: LinkedinBrand,
    linkedin: Linkedin,
    lockKeyholeCircle: LockKeyholeCircle,
    logOut: LogOut,
    mail: Mail,
    menu: Menu,
    monitor: Monitor,
    moonpayBrand: MoonpayBrand,
    moreLoginOptions: MoreLoginOptions,
    motorola: Motorola,
    nobleBrand: NobleBrand,
    optimismBrand: OptimismBrand,
    paraBlackBg: ParaBlackBg,
    paraBrand: ParaBrand,
    paraIconBrand: ParaIconBrand,
    paraIconQr: ParaIconQr,
    paraIcon: ParaIcon,
    paraLogo: ParaLogo,
    paraRingsDark: ParaRingsDark,
    paraRings: ParaRings,
    para: Para,
    passcode: Passcode,
    phone: Phone,
    pintrestBrand: PintrestBrand,
    pintrest: Pintrest,
    plusCircle: PlusCircle,
    plus: Plus,
    polygonBrand: PolygonBrand,
    polygon: Polygon,
    puzzlePiece: PuzzlePiece,
    qrCode02: QrCode02,
    qrCode: QrCode,
    rampNetworkBrand: RampNetworkBrand,
    rampNetwork: RampNetwork,
    redditBrand: RedditBrand,
    reddit: Reddit,
    refresh: Refresh,
    samsung: Samsung,
    search: Search,
    send: Send,
    settings: Settings,
    share: Share,
    shield: Shield,
    signalBrand: SignalBrand,
    signal: Signal,
    sliders: Sliders,
    snapchatBrand: SnapchatBrand,
    snapchat: Snapchat,
    solana: Solana,
    spacingHeight: SpacingHeight,
    star04Filled: Star04Filled,
    stars01Filled: Stars01Filled,
    stars: Stars,
    stopSquare: StopSquare,
    stripeBrand: StripeBrand,
    telegramBrand: TelegramBrand,
    telegram: Telegram,
    tetherBrand: TetherBrand,
    tikTokBrand: TikTokBrand,
    tikTok: TikTok,
    trash: Trash,
    tumblrBrand: TumblrBrand,
    tumblr: Tumblr,
    twitterBrand: TwitterBrand,
    twitter: Twitter,
    usdcBrand: UsdcBrand,
    userCircle: UserCircle,
    user: User,
    wallet: Wallet,
    x: X,
    youtubeBrand: YoutubeBrand,
    youtube: Youtube,
    AD: AD,
    AE: AE,
    AF: AF,
    AG: AG,
    AI: AI,
    AL: AL,
    AM: AM,
    AO: AO,
    AR: AR,
    AS: AS,
    AT: AT,
    AU: AU,
    AW: AW,
    AX: AX,
    AZ: AZ,
    BA: BA,
    BB: BB,
    BD: BD,
    BE: BE,
    BF: BF,
    BG: BG,
    BH: BH,
    BI: BI,
    BJ: BJ,
    BL: BL,
    BM: BM,
    BN: BN,
    BO: BO,
    BQ: BQ,
    BQ2: BQ2,
    BQ3: BQ3,
    BR: BR,
    BS: BS,
    BT: BT,
    BW: BW,
    BY: BY,
    BZ: BZ,
    CA: CA,
    CC: CC,
    CD: CD,
    CD2: CD2,
    CF: CF,
    CH: CH,
    CK: CK,
    CL: CL,
    CM: CM,
    CN: CN,
    CO: CO,
    CR: CR,
    CU: CU,
    CW: CW,
    CX: CX,
    CY: CY,
    CZ: CZ,
    DE: DE,
    DJ: DJ,
    DK: DK,
    DM: DM,
    DO: DO,
    DS: DS,
    DZ: DZ,
    EC: EC,
    EE: EE,
    EG: EG,
    EH: EH,
    ER: ER,
    ES: ES,
    ET: ET,
    FI: FI,
    FJ: FJ,
    FK: FK,
    FM: FM,
    FO: FO,
    FR: FR,
    GA: GA,
    GB2: GB2,
    GB: GB,
    GD: GD,
    GE: GE,
    GG: GG,
    GH: GH,
    GI: GI,
    GL: GL,
    GM: GM,
    GN: GN,
    GQ: GQ,
    GR: GR,
    GT: GT,
    GU: GU,
    GW: GW,
    GY: GY,
    HK: HK,
    HN: HN,
    HR: HR,
    HT: HT,
    HU: HU,
    ID: ID,
    IE: IE,
    IL: IL,
    IM: IM,
    IN: IN,
    IO: IO,
    IQ: IQ,
    IR: IR,
    IS: IS,
    IT: IT,
    JE: JE,
    JM: JM,
    JO: JO,
    JP: JP,
    KE: KE,
    KG: KG,
    KH: KH,
    KI: KI,
    KM: KM,
    KN: KN,
    KP: KP,
    KR: KR,
    KW: KW,
    KY: KY,
    KZ: KZ,
    LA: LA,
    LB: LB,
    LC: LC,
    LI: LI,
    LK: LK,
    LR: LR,
    LS: LS,
    LT: LT,
    LU: LU,
    LV: LV,
    LY: LY,
    MA: MA,
    MC: MC,
    MD: MD,
    ME: ME,
    MG: MG,
    MH: MH,
    MK: MK,
    ML: ML,
    MM: MM,
    MN: MN,
    MO: MO,
    MP: MP,
    MQ: MQ,
    MR: MR,
    MS: MS,
    MT: MT,
    MU: MU,
    MV: MV,
    MW: MW,
    MX: MX,
    MY: MY,
    MZ: MZ,
    NA: NA,
    NE: NE,
    NF: NF,
    NG: NG,
    NI: NI,
    NL: NL,
    NO: NO,
    NP: NP,
    NR: NR,
    NU: NU,
    NZ: NZ,
    OM: OM,
    PA: PA,
    PE: PE,
    PF: PF,
    PG: PG,
    PH: PH,
    PK: PK,
    PL: PL,
    PN: PN,
    PR: PR,
    PS: PS,
    PT: PT,
    PW: PW,
    PY: PY,
    QA: QA,
    RO: RO,
    RS: RS,
    RU: RU,
    RW: RW,
    SA: SA,
    SB: SB,
    SC: SC,
    SE: SE,
    SG: SG,
    SI: SI,
    SK: SK,
    SL: SL,
    SM: SM,
    SN: SN,
    SO: SO,
    SR: SR,
    SS: SS,
    ST: ST,
    SV: SV,
    SX: SX,
    SY: SY,
    SZ: SZ,
    TC: TC,
    TD: TD,
    TG: TG,
    TH: TH,
    TJ: TJ,
    TK: TK,
    TL: TL,
    TM: TM,
    TN: TN,
    TO: TO,
    TR: TR,
    TT: TT,
    TV: TV,
    TW: TW,
    TZ: TZ,
    UA: UA,
    UG: UG,
    US: US,
    UY: UY,
    UZ: UZ,
    VC: VC,
    VE: VE,
    VG: VG,
    VI: VI,
    VN: VN,
    VU: VU,
    WS: WS,
    YE: YE,
    ZA: ZA,
    ZM: ZM,
    ZW: ZW,
};

const cpslDropdownCss = ":host{display:block;position:relative;font-family:Arial, sans-serif;--input-color:var(--cpsl-color-text-primary);--container-background-color:var(--cpsl-color-input-surface-default);--container-border-color:var(--cpsl-color-input-border-active);--scrollbar-color:var(--cpsl-color-text-subtle);--divider-color:var(--cpsl-color-divider);--input-placeholder-color:var(--cpsl-color-text-secondary);--input-font-size:var(--cpsl-font-size-body-m);--button-hover-color:var(--cpsl-color-tile-button-surface-hover);font-family:var(--cpsl-font-family, inherit)}.input-container{position:relative;width:100%}::slotted(cpsl-dropdown){position:absolute;width:100%;top:100%;left:0;z-index:2}.dropdown-button{display:flex;width:100%;padding:0 4px;background:none;border:none;align-items:center;justify-content:space-between;cursor:pointer;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--input-color)}.dropdown-button span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex-grow:1}.dropdown-button div{margin-left:8px;display:flex;align-items:center}.dropdown-options{display:none;position:fixed;list-style:none;padding:0;margin-top:4px;border:1px solid var(--container-border-color);border-radius:8px;z-index:999999999999;overflow-y:auto;max-height:300px;box-sizing:border-box;background-color:var(--container-background-color);}.dropdown-options.open{display:block}.dropdown-options li{padding:8px;cursor:pointer;display:flex;align-items:center;border-bottom:1px solid var(--cpsl-color-divider);color:var(--input-color);background:var(--container-background-color);font-size:var(--input-font-size)}.dropdown-options li:hover{background-color:var(--button-hover-color)}.dropdown-options li svg{width:24px;height:24px;margin-right:8px;padding:0 8px;vertical-align:middle;}.dropdown-options::-webkit-scrollbar{width:8px;height:8px;background-color:transparent;}.dropdown-options::-webkit-scrollbar-thumb{background-color:var(--scrollbar-color);border-radius:10px;border:2px solid transparent;background-clip:content-box;height:8px}.dropdown-options::-webkit-scrollbar-track{background:transparent;}.dropdown-value{margin-left:8px;color:var(--cpsl-color-text-secondary)}.dropdown-button .chevron{transition:transform 0.3s ease}.dropdown-button .chevron.closed{transform:rotate(180deg)}.search-bar{padding:0;border-bottom:1px solid var(--cpsl-color-divider);position:sticky;top:0;background:var(--container-background-color);z-index:1;}.search-bar input{width:100%;padding:8px;border:none;box-sizing:border-box;font-size:var(--input-font-size);color:var(--input-color);background-color:var(--container-background-color);border-radius:0;}.search-bar input::placeholder{color:var(--input-placeholder-color)}.search-bar input:focus{outline:none;border-color:transparent;}";
const CpslDropdownStyle0 = cpslDropdownCss;

const CpslDropdown = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.selectedItemChange = createEvent(this, "selectedItemChange", 7);
        this.toggleDropdown = () => {
            this.isOpen = !this.isOpen;
        };
        this.selectItem = (item, emitEvent = true) => {
            this.selectedItem = item;
            this.isOpen = false;
            if (emitEvent) {
                this.selectedItemChange.emit(this.selectedItem);
            }
        };
        this.handleItemSelect = (item) => () => {
            this.selectItem(item);
        };
        this.handleSearchQueryChange = (event) => {
            const target = event.target;
            this.searchQuery = target.value;
            this.filteredItems = this.items.filter(item => item.label.toLowerCase().includes(this.searchQuery.toLowerCase()));
        };
        this.handleClickOutside = (event) => {
            if (this.isOpen && !this.el.contains(event.target)) {
                this.isOpen = false;
            }
        };
        this.width = '100%';
        this.hasCpslSearch = false;
        this.isOpen = false;
        this.searchQuery = '';
        this.filteredItems = [];
        this.items = [];
        this.selectedItem = null;
    }
    handleSelectedItemChange(newValue) {
        if (newValue !== null) {
            this.selectItem(newValue, false);
        }
    }
    handleOpenChange() {
        if (this.isOpen) {
            this.adjustPosition();
            this.addClickOutsideListener();
        }
        else {
            this.removeClickOutsideListener();
        }
    }
    handleResize() {
        if (this.isOpen) {
            this.adjustPosition();
        }
    }
    adjustPosition() {
        var _a;
        if (typeof window !== 'undefined') {
            const dropdownOptions = this.el.shadowRoot.querySelector('.dropdown-options');
            const parentRect = (_a = this.el.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const searchBar = this.el.shadowRoot.querySelector('.search-bar');
            const viewportHeight = window.innerHeight;
            if (parentRect) {
                this.width = `${parentRect.width}px`;
                dropdownOptions.style.left = `${parentRect.x}px`;
                if (window.innerWidth <= 480) {
                    searchBar.style.maxHeight = `30px`;
                    dropdownOptions.style.top = `425px`;
                    dropdownOptions.style.maxHeight = '110px';
                    return;
                }
                dropdownOptions.style.top = `${parentRect.y + parentRect.height}px`;
                const availableHeight = viewportHeight - parentRect.bottom;
                dropdownOptions.style.maxHeight = `${availableHeight - 8}px`;
            }
        }
    }
    addClickOutsideListener() {
        typeof window !== 'undefined' && window.addEventListener('click', this.handleClickOutside);
    }
    removeClickOutsideListener() {
        typeof window !== 'undefined' && window.removeEventListener('click', this.handleClickOutside);
    }
    componentWillLoad() {
        if (this.items.length > 0) {
            this.filteredItems = [...this.items];
            if (this.selectedItem !== null) {
                this.selectItem(this.selectedItem, false);
            }
            else {
                this.selectedItem = this.items[0];
            }
        }
    }
    disconnectedCallback() {
        this.removeClickOutsideListener();
    }
    render() {
        var _a, _b, _c;
        return (h(Host, { key: '918eabdb23ab1f6c136c2ade37b572b60966ce75' }, h("button", { key: '53cde2c1780c6ceb1c08667fac003910810472b2', class: "dropdown-button", onClick: this.toggleDropdown }, `${((_a = this.selectedItem) === null || _a === void 0 ? void 0 : _a.selectedLabel) || ((_b = this.selectedItem) === null || _b === void 0 ? void 0 : _b.label)} ${(_c = this.selectedItem) === null || _c === void 0 ? void 0 : _c.value}`, h("div", { key: '9dded62f6bcd83665f2af693f2ac6cff20de4d52', class: `chevron ${this.isOpen ? '' : 'closed'}`, innerHTML: Icons['chevronUp'] })), h("ul", { key: '10a3cfc29eb61e9a2c64b0075c0b9b2985d08c70', class: { 'dropdown-options': true, 'open': this.isOpen }, style: { width: this.width } }, this.hasCpslSearch && (h("li", { key: '702a1282cb816da185a0ce435146443daddb1d6c', class: "search-bar" }, h("input", { key: 'da05fa6019d2c0bd1dab4336378cd449172a3cae', type: "text", placeholder: "Search...", value: this.searchQuery, onInput: this.handleSearchQueryChange }))), this.filteredItems.map(item => (h("li", { onClick: this.handleItemSelect(item) }, h("span", { innerHTML: Icons[item.icon] }), item.label, " ", h("span", { class: "dropdown-value" }, item.value)))))));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "selectedItem": ["handleSelectedItemChange"],
        "isOpen": ["handleOpenChange"]
    }; }
};
CpslDropdown.style = CpslDropdownStyle0;

const cpslFileUploadCss = ":host{--container-box-shadow:none;--container-box-shadow-color:var(--cpsl-color-file-border-placeholder);--container-border-color:var(--cpsl-color-file-border-placeholder);--container-border-color-error:var(--cpsl-color-file-border-error);--container-background-color:var(--cpsl-color-file-surface-default);--container-background-color-disabled:var(--cpsl-color-file-surface-disabled);--container-background-color-drag:var(--cpsl-color-file-surface-drag);--container-border-width:1px;--container-border-radius:var(--cpsl-border-radius-file);--container-padding-top:12px;--container-padding-bottom:12px;--container-padding-end:12px;--container-padding-start:12px;--container-height:48px;--container-gap:8px;--optional-label-color:var(--cpsl-color-text-secondary);--label-color:var(--cpsl-color-text-primary);--label-font-size:var(--cpsl-font-size-body-s);--label-margin-bottom:0px;--helper-text-color:var(--cpsl-color-text-secondary);--helper-text-error-color:var(--cpsl-color-text-error);--helper-text-icon-color:var(--cpsl-color-text-secondary);--helper-text-icon-error-color:var(--cpsl-color-text-error);--helper-text-icon-size:16px;--helper-text-font-size:var(--cpsl-font-size-body-xs);--helper-text-margin-top:0px;--sample-img-height:40px;--sample-img-width:40px;--sample-img-border-radius:8px;display:flex;flex-direction:column;gap:4px;font-family:var(--cpsl-font-family, inherit)}.container{-webkit-padding-start:var(--container-padding-start);padding-inline-start:var(--container-padding-start);-webkit-padding-end:var(--container-padding-end);padding-inline-end:var(--container-padding-end);padding-top:var(--container-padding-top);padding-bottom:var(--container-padding-bottom);display:flex;align-items:center;box-sizing:border-box;flex-wrap:wrap;width:100%;gap:var(--container-gap);cursor:pointer;position:relative;border-style:solid;border-width:var(--container-border-width);border-color:var(--container-border-color);border-radius:var(--container-border-radius);background:var(--container-background-color);box-shadow:var(--container-box-shadow)}.container.drag,.container:active{background:var(--container-background-color-drag)}.container.drag-error{cursor:no-drop}.container.error{border-color:var(--container-border-color-error)}input{position:absolute;width:100%;height:100%;top:0;left:0;margin:0px;opacity:0;cursor:pointer}.sample-img{height:var(--sample-img-height);width:var(--sample-img-width);border-radius:var(--sample-img-border-radius);object-fit:contain}.sample-image-name-container{display:flex;gap:4px;align-items:center;text-align:center}.sample-image-name-container cpsl-icon{z-index:10000;--height:16px;--width:16px}.inline-text{display:inline-block}.sample-image-name{display:inline-block;color:var(--cpsl-color-text-tertiary)}.label-container{flex:1}.file-container{display:flex;flex-direction:column;flex:0;min-width:33%;gap:8px;justify-content:center;align-items:center}.label{display:inline-block;color:var(--label-color);font-size:var(--label-font-size);font-weight:500;margin-bottom:var(--label-margin-bottom)}.optional-label{display:inline-block;color:var(--optional-label-color);font-size:var(--label-font-size);font-weight:500}.helper-text-container{display:flex;align-items:center;gap:4px;color:var(--helper-text-color);font-size:var(--helper-text-font-size);font-weight:500;margin-top:var(--helper-text-margin-top)}.helper-text-container cpsl-icon{--height:var(--helper-text-icon-size);--width:var(--helper-text-icon-size);--icon-color:var(--helper-text-icon-color)}.error-text{color:var(--helper-text-error-color)}.error-text cpsl-icon{--icon-color:var(--helper-text-icon-error-color)}";
const CpslFileUploadStyle0 = cpslFileUploadCss;

var __awaiter$2 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const CpslFileUpload = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslOnDrop = createEvent(this, "cpslOnDrop", 7);
        this.cpslOnDragEnter = createEvent(this, "cpslOnDragEnter", 7);
        this.cpslOnDragLeave = createEvent(this, "cpslOnDragLeave", 7);
        this.cpslFileChange = createEvent(this, "cpslFileChange", 7);
        this.cpslFileRemoved = createEvent(this, "cpslFileRemoved", 7);
        this.inputId = `cpsl-file-upload-${inputIds$2++}`;
        this.handleDrop = (ev) => __awaiter$2(this, void 0, void 0, function* () {
            var _a;
            ev.preventDefault();
            const item = (_a = Array.from(ev.dataTransfer.items)) === null || _a === void 0 ? void 0 : _a[0];
            if (item && this.isValidFile(item.type)) {
                const file = item.getAsFile();
                yield this.addFile(file);
            }
            this.dragOver = false;
            this.dragError = false;
            this.cpslOnDrop.emit(ev);
        });
        this.handleDragEnter = (ev) => {
            var _a;
            ev.preventDefault();
            this.dragOver = true;
            const item = (_a = Array.from(ev.dataTransfer.items)) === null || _a === void 0 ? void 0 : _a[0];
            if (item && this.isValidFile(item.type)) {
                this.dragError = true;
            }
            this.cpslOnDragEnter.emit(ev);
        };
        this.handleDragLeave = (ev) => {
            ev.preventDefault();
            this.dragOver = false;
            this.dragError = false;
            this.cpslOnDragLeave.emit(ev);
        };
        this.handleInputChange = (ev) => __awaiter$2(this, void 0, void 0, function* () {
            ev.preventDefault();
            const input = this.inputEl;
            if (input.files.length) {
                const file = input.files[0];
                if (this.isValidFile(file.type)) {
                    yield this.addFile(file);
                }
            }
        });
        this.isValidFile = (type) => {
            var _a;
            if (((_a = this.fileTypes) === null || _a === void 0 ? void 0 : _a.length) ? !this.fileTypes.includes(type) : false) {
                return false;
            }
            return true;
        };
        this.addFile = (file) => __awaiter$2(this, void 0, void 0, function* () {
            this.file = file;
            this.cpslFileChange.emit(file);
            this.uploadError = false;
            this.isUploading = true;
            const uploadSuccess = this.uploadFile ? yield this.uploadFile(file) : true;
            if (!uploadSuccess) {
                this.uploadError = true;
                const input = this.inputEl;
                input.value = '';
            }
            this.isUploading = false;
        });
        this.removeFile = (e) => {
            e.preventDefault();
            this.file = undefined;
            const input = this.inputEl;
            input.value = '';
            this.cpslFileRemoved.emit();
        };
        this.file = undefined;
        this.dragOver = undefined;
        this.dragError = undefined;
        this.isUploading = undefined;
        this.uploadError = undefined;
        this.disabled = false;
        this.errorText = undefined;
        this.externalFilename = undefined;
        this.externalSrc = undefined;
        this.fileTypes = undefined;
        this.helperText = undefined;
        this.label = undefined;
        this.required = false;
        this.showOptionalLabel = false;
        this.uploadFile = undefined;
    }
    get inputEl() {
        return this.el.shadowRoot.getElementById(this.inputId);
    }
    get FileContent() {
        var _a;
        const hasFile = Boolean(this.file) || Boolean(this.externalSrc);
        const isUploading = this.isUploading;
        const error = this.uploadError;
        const text = !hasFile ? (h(Fragment, null, 'Drag file here or ', h("cpsl-text", { class: "inline-text", variant: "bodyXS" }, "upload file"))) : isUploading ? (`${this.file.name} is uploading`) : error ? ('Upload Failed') : (((_a = this.file) === null || _a === void 0 ? void 0 : _a.name) || this.externalFilename || '');
        const TopElement = !hasFile ? (h("cpsl-icon", { icon: "image" })) : isUploading ? (h("cpsl-spinner", null)) : error ? (h("cpsl-icon", { icon: "close" })) : (h("img", { class: "sample-img", src: this.file ? URL.createObjectURL(this.file) : this.externalSrc, alt: "Sample Image" }));
        return (h(Fragment, null, TopElement, h("span", { class: "sample-image-name-container" }, h("cpsl-text", { class: "sample-image-name", variant: "bodyXS" }, text), hasFile && !error && !isUploading && h("cpsl-icon", { icon: "close", onClick: this.removeFile }))));
    }
    render() {
        var _a, _b, _c;
        return (h(Host, { key: '521ca35901a009b303650d7446e1f148930d7fe3' }, this.label && (h("label", { key: '94c58691decea8455a254698ec8fd27baba260ca', class: "label", htmlFor: this.inputId }, this.label, this.required ? '*' : ' ', !this.required && this.showOptionalLabel ? h("span", { class: "optional-label" }, "(optional)") : '')), h("slot", { key: 'cf7e80e4c4a1e48b4f4efddfe4e8eb0f4a31ed4b', name: "label" }), h("div", { key: '35f1707b3c8d1f1c939d9312b541f32edfc424d1', class: { 'container': true, 'error': Boolean(this.errorText), 'drag': this.dragOver, 'drag-error': this.dragError } }, h("div", { key: '327f71aaaa7d4920a62118ea956c4c128907fae6', class: { 'label-container': true } }, h("slot", { key: '0c4891ffb0c9d49e2b5b09c3bdbc8d5b2ed3ff2d', name: "left-content" })), h("div", { key: '47dc7cc569d860dc07478c2782c62a0d25b3df07', class: { 'file-container': true } }, this.FileContent), h("input", { key: '809568bfed82463cda7851d3717187112cff708b', id: this.inputId, type: "file", accept: (_b = (_a = this.fileTypes) === null || _a === void 0 ? void 0 : _a.join(', ')) !== null && _b !== void 0 ? _b : '*', files: this.file ? [this.file] : undefined, onDrop: this.handleDrop, onDragEnter: this.handleDragEnter, onDragLeave: this.handleDragLeave, onChange: this.handleInputChange, disabled: this.disabled })), (this.errorText || this.helperText) && (h("div", { key: '6f06cba54f65d903b3d22e015e694a154b189df7', class: { 'helper-text-container': true, 'error-text': Boolean(this.errorText) } }, h("span", { key: '2103ca2366b9a7827c42302cea3fa8d8c71bc50b' }, (_c = this.errorText) !== null && _c !== void 0 ? _c : this.helperText)))));
    }
    get el() { return getElement(this); }
};
let inputIds$2 = 0;
CpslFileUpload.style = CpslFileUploadStyle0;

const cpslIconCss = ":host{display:block;--filter:auto;--height:24px;--width:24px;--svg-height:calc(var(--height) - (2 * var(--inset)));--svg-width:calc(var(--width) - (2 * var(--inset)));--icon-color:currentColor;--icon-fill-color:currentColor;--icon-stroke-color:currentColor;width:var(--width);height:var(--height)}:host .foreground-0{fill:var(--cpsl-color-foreground-0);stop-color:var(--cpsl-color-foreground-0)}:host .accent-0{fill:var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0));stop-color:var(--cpsl-color-accent-0, var(--cpsl-color-foreground-0))}:host div{display:flex;justify-content:center;align-items:center;width:100%;height:100%;color:var(--icon-color)}:host svg{width:var(--svg-width, \"100%\");height:var(--svg-height, \"100%\");filter:var(--filter)}:host svg .background-16{fill:var(--cpsl-color-background-16)}:host svg .foreground-0{fill:var(--cpsl-color-foreground-0)}:host svg .fill{fill:var(--icon-fill-color)}:host svg .stroke{stroke:var(--icon-stroke-color)}:host img{width:100%;height:100%;object-fit:contain}";
const CpslIconStyle0 = cpslIconCss;

const CpslIcon = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.src = undefined;
        this.size = undefined;
        this.invert = undefined;
        this.inset = '0px';
        this.icon = undefined;
    }
    render() {
        return (h(Host, { key: '42f171468ddb966ecdf81dc4e6bac3004f5f0761', part: "icon", role: "img", style: Object.assign(Object.assign({ ['--inset']: this.inset }, (this.size ? { ['--height']: this.size, ['--width']: this.size } : {})), (this.invert ? { ['--filter']: 'invert(100%)' } : {})) }, !this.icon ? h("img", { src: this.src }) : h("div", { innerHTML: Icons[this.icon] })));
    }
};
CpslIcon.style = CpslIconStyle0;

const cpslIconGroupCss = ":host{--container-padding-top:4px;--container-padding-end:4px;--container-padding-bottom:4px;--container-padding-start:4px;--container-border-width:2px;--container-border-color:var(--cpsl-color-iconGroup-border);--container-background:var(--cpsl-color-iconGroup-surface);--icon-height:15px;--icon-width:15px;--icon-item-color:var(--cpsl-color-iconGroup-icon-default);display:flex;width:auto;padding-right:calc(var(--container-border-width) * 3)}.icon-container{-webkit-padding-start:var(--container-padding-start);padding-inline-start:var(--container-padding-start);-webkit-padding-end:var(--container-padding-end);padding-inline-end:var(--container-padding-end);padding-top:var(--container-padding-top);padding-bottom:var(--container-padding-bottom);margin-right:calc(var(--container-border-width) * -3);border-style:solid;border-width:var(--container-border-width);border-color:var(--container-border-color);border-radius:1000px;background:var(--container-background);transition:margin 250ms}.icon-container cpsl-icon{--height:var(--icon-height);--width:var(--icon-width);--icon-color:var(--icon-item-color)}.icon-container.expanded{margin-right:calc(var(--container-border-width) * -1)}.icon-container.disabled cpsl-icon{--icon-color:var(--cpsl-color-iconGroup-icon-disabled)}";
const CpslIconGroupStyle0 = cpslIconGroupCss;

function isOfTypeIconType(key) {
    return Object.keys(Icons).includes(key);
}
const CpslIconGroup = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.isHovered = undefined;
        this.expandFrom = 'right';
        this.disabled = false;
        this.icons = undefined;
    }
    componentDidLoad() {
        this.el.addEventListener('mouseover', () => {
            this.isHovered = true;
        });
        this.el.addEventListener('mouseout', () => {
            this.isHovered = false;
        });
    }
    disconnectedCallback() {
        this.el.removeEventListener('mouseover', () => {
            this.isHovered = true;
        });
        this.el.removeEventListener('mouseout', () => {
            this.isHovered = false;
        });
    }
    render() {
        // If disabled remove all brand icons to ensure the disabled color is shown correctly
        const icons = this.disabled ? this.icons.map(icon => icon.replace('Brand', '')) : this.icons;
        return (h(Host, { key: 'f471279b940c2b3b3872c1d37477fd85073127c8' }, icons.map((icon, index) => {
            const isIcon = isOfTypeIconType(icon);
            return (h("span", { part: "icon-container", class: {
                    'icon-container': true,
                    'expanded': !this.disabled && this.isHovered && (this.expandFrom === 'right' ? index !== this.icons.length - 1 : index === 0),
                    'disabled': this.disabled,
                }, style: { zIndex: `${this.icons.length - index}` } }, h("cpsl-icon", { key: icon, icon: isIcon ? icon : undefined, src: !isIcon ? icon : undefined })));
        })));
    }
    get el() { return getElement(this); }
};
CpslIconGroup.style = CpslIconGroupStyle0;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var inputmask = {exports: {}};

/*!
 * dist/inputmask
 * https://github.com/RobinHerbots/Inputmask
 * Copyright (c) 2010 - 2024 Robin Herbots
 * Licensed under the MIT license
 * Version: 5.0.9
 */

(function (module, exports) {
!function(e, t) {
    module.exports = t();
}("undefined" != typeof self ? self : commonjsGlobal, (function() {
    return function() {
        var e = {
            3976: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                t.default = {
                    _maxTestPos: 500,
                    placeholder: "_",
                    optionalmarker: [ "[", "]" ],
                    quantifiermarker: [ "{", "}" ],
                    groupmarker: [ "(", ")" ],
                    alternatormarker: "|",
                    escapeChar: "\\",
                    mask: null,
                    regex: null,
                    oncomplete: function() {},
                    onincomplete: function() {},
                    oncleared: function() {},
                    repeat: 0,
                    greedy: !1,
                    autoUnmask: !1,
                    removeMaskOnSubmit: !1,
                    clearMaskOnLostFocus: !0,
                    insertMode: !0,
                    insertModeVisual: !0,
                    clearIncomplete: !1,
                    alias: null,
                    onKeyDown: function() {},
                    onBeforeMask: null,
                    onBeforePaste: function(e, t) {
                        return "function" == typeof t.onBeforeMask ? t.onBeforeMask.call(this, e, t) : e;
                    },
                    onBeforeWrite: null,
                    onUnMask: null,
                    showMaskOnFocus: !0,
                    showMaskOnHover: !0,
                    onKeyValidation: function() {},
                    skipOptionalPartCharacter: " ",
                    numericInput: !1,
                    rightAlign: !1,
                    undoOnEscape: !0,
                    radixPoint: "",
                    _radixDance: !1,
                    groupSeparator: "",
                    keepStatic: null,
                    positionCaretOnTab: !0,
                    tabThrough: !1,
                    supportsInputType: [ "text", "tel", "url", "password", "search" ],
                    isComplete: null,
                    preValidation: null,
                    postValidation: null,
                    staticDefinitionSymbol: void 0,
                    jitMasking: !1,
                    nullable: !0,
                    inputEventOnly: !1,
                    noValuePatching: !1,
                    positionCaretOnClick: "lvp",
                    casing: null,
                    inputmode: "text",
                    importDataAttributes: !0,
                    shiftPositions: !0,
                    usePrototypeDefinitions: !0,
                    validationEventTimeOut: 3e3,
                    substitutes: {}
                };
            },
            7392: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                t.default = {
                    9: {
                        validator: "[0-9\uff10-\uff19]",
                        definitionSymbol: "*"
                    },
                    a: {
                        validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
                        definitionSymbol: "*"
                    },
                    "*": {
                        validator: "[0-9\uff10-\uff19A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]"
                    }
                };
            },
            253: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e, t, n) {
                    if (void 0 === n) return e.__data ? e.__data[t] : null;
                    e.__data = e.__data || {}, e.__data[t] = n;
                };
            },
            3776: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Event = void 0, t.off = function(e, t) {
                    var n, i;
                    u(this[0]) && e && (n = this[0].eventRegistry, i = this[0], e.split(" ").forEach((function(e) {
                        var a = o(e.split("."), 2);
                        (function(e, i) {
                            var a, r, o = [];
                            if (e.length > 0) if (void 0 === t) for (a = 0, r = n[e][i].length; a < r; a++) o.push({
                                ev: e,
                                namespace: i && i.length > 0 ? i : "global",
                                handler: n[e][i][a]
                            }); else o.push({
                                ev: e,
                                namespace: i && i.length > 0 ? i : "global",
                                handler: t
                            }); else if (i.length > 0) for (var l in n) for (var s in n[l]) if (s === i) if (void 0 === t) for (a = 0, 
                            r = n[l][s].length; a < r; a++) o.push({
                                ev: l,
                                namespace: s,
                                handler: n[l][s][a]
                            }); else o.push({
                                ev: l,
                                namespace: s,
                                handler: t
                            });
                            return o;
                        })(a[0], a[1]).forEach((function(e) {
                            var t = e.ev, a = e.handler;
                            !function(e, t, a) {
                                if (e in n == 1) if (i.removeEventListener ? i.removeEventListener(e, a, !1) : i.detachEvent && i.detachEvent("on".concat(e), a), 
                                "global" === t) for (var r in n[e]) n[e][r].splice(n[e][r].indexOf(a), 1); else n[e][t].splice(n[e][t].indexOf(a), 1);
                            }(t, e.namespace, a);
                        }));
                    })));
                    return this;
                }, t.on = function(e, t) {
                    if (u(this[0])) {
                        var n = this[0].eventRegistry, i = this[0];
                        e.split(" ").forEach((function(e) {
                            var a = o(e.split("."), 2), r = a[0], l = a[1];
                            !function(e, a) {
                                i.addEventListener ? i.addEventListener(e, t, !1) : i.attachEvent && i.attachEvent("on".concat(e), t), 
                                n[e] = n[e] || {}, n[e][a] = n[e][a] || [], n[e][a].push(t);
                            }(r, void 0 === l ? "global" : l);
                        }));
                    }
                    return this;
                }, t.trigger = function(e) {
                    var t = arguments;
                    if (u(this[0])) for (var n = this[0].eventRegistry, i = this[0], o = "string" == typeof e ? e.split(" ") : [ e.type ], l = 0; l < o.length; l++) {
                        var s = o[l].split("."), f = s[0], p = s[1] || "global";
                        if (void 0 !== c && "global" === p) {
                            var d, h = {
                                bubbles: !0,
                                cancelable: !0,
                                composed: !0,
                                detail: arguments[1]
                            };
                            if (c.createEvent) {
                                try {
                                    if ("input" === f) h.inputType = "insertText", d = new InputEvent(f, h); else d = new CustomEvent(f, h);
                                } catch (e) {
                                    (d = c.createEvent("CustomEvent")).initCustomEvent(f, h.bubbles, h.cancelable, h.detail);
                                }
                                e.type && (0, a.default)(d, e), i.dispatchEvent(d);
                            } else (d = c.createEventObject()).eventType = f, d.detail = arguments[1], e.type && (0, a.default)(d, e), i.fireEvent("on" + d.eventType, d);
                        } else if (void 0 !== n[f]) {
                            arguments[0] = arguments[0].type ? arguments[0] : r.default.Event(arguments[0]), 
                            arguments[0].detail = arguments.slice(1);
                            var v = n[f];
                            ("global" === p ? Object.values(v).flat() : v[p]).forEach((function(e) {
                                return e.apply(i, t);
                            }));
                        }
                    }
                    return this;
                };
                var i = s(n(9380)), a = s(n(600)), r = s(n(4963));
                function o(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var i, a, r, o, l = [], s = !0, c = !1;
                            try {
                                if (r = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for (;!(s = (i = r.call(n)).done) && (l.push(i.value), l.length !== t); s = !0) ;
                            } catch (e) {
                                c = !0, a = e;
                            } finally {
                                try {
                                    if (!s && null != n.return && (o = n.return(), Object(o) !== o)) return;
                                } finally {
                                    if (c) throw a;
                                }
                            }
                            return l;
                        }
                    }(e, t) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return l(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === n && e.constructor && (n = e.constructor.name);
                        if ("Map" === n || "Set" === n) return Array.from(e);
                        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l(e, t);
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function l(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var c = i.default.document;
                function u(e) {
                    return e instanceof Element;
                }
                var f = t.Event = void 0;
                "function" == typeof i.default.CustomEvent ? t.Event = f = i.default.CustomEvent : i.default.Event && c && c.createEvent ? (t.Event = f = function(e, t) {
                    t = t || {
                        bubbles: !1,
                        cancelable: !1,
                        composed: !0,
                        detail: void 0
                    };
                    var n = c.createEvent("CustomEvent");
                    return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
                }, f.prototype = i.default.Event.prototype) : "undefined" != typeof Event && (t.Event = f = Event);
            },
            600: function(e, t) {
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function e() {
                    var t, i, a, r, o, l, s = arguments[0] || {}, c = 1, u = arguments.length, f = !1;
                    "boolean" == typeof s && (f = s, s = arguments[c] || {}, c++);
                    "object" !== n(s) && "function" != typeof s && (s = {});
                    for (;c < u; c++) if (null != (t = arguments[c])) for (i in t) a = s[i], s !== (r = t[i]) && (f && r && ("[object Object]" === Object.prototype.toString.call(r) || (o = Array.isArray(r))) ? (o ? (o = !1, 
                    l = a && Array.isArray(a) ? a : []) : l = a && "[object Object]" === Object.prototype.toString.call(a) ? a : {}, 
                    s[i] = e(f, l, r)) : void 0 !== r && (s[i] = r));
                    return s;
                };
            },
            4963: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = l(n(9380)), a = l(n(253)), r = n(3776), o = l(n(600));
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var s = i.default.document;
                function c(e) {
                    return e instanceof c ? e : this instanceof c ? void (null != e && e !== i.default && (this[0] = e.nodeName ? e : void 0 !== e[0] && e[0].nodeName ? e[0] : s.querySelector(e), 
                    void 0 !== this[0] && null !== this[0] && (this[0].eventRegistry = this[0].eventRegistry || {}))) : new c(e);
                }
                c.prototype = {
                    on: r.on,
                    off: r.off,
                    trigger: r.trigger
                }, c.extend = o.default, c.data = a.default, c.Event = r.Event;
                t.default = c;
            },
            9845: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mobile = t.iphone = t.ie = void 0;
                var i, a = (i = n(9380)) && i.__esModule ? i : {
                    default: i
                };
                var r = a.default.navigator && a.default.navigator.userAgent || "";
                t.ie = r.indexOf("MSIE ") > 0 || r.indexOf("Trident/") > 0, t.mobile = a.default.navigator && a.default.navigator.userAgentData && a.default.navigator.userAgentData.mobile || a.default.navigator && a.default.navigator.maxTouchPoints || "ontouchstart" in a.default, 
                t.iphone = /iphone/i.test(r);
            },
            7184: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e) {
                    return e.replace(n, "\\$1");
                };
                var n = new RegExp("(\\" + [ "/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^" ].join("|\\") + ")", "gim");
            },
            6030: function(e, t, n) {
                function i(e) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, i(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventHandlers = void 0;
                var a, r = n(9845), o = (a = n(9380)) && a.__esModule ? a : {
                    default: a
                }, l = n(7760), s = n(2839), c = n(8711), u = n(7215), f = n(4713);
                function p() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ p = function() {
                        return t;
                    };
                    var e, t = {}, n = Object.prototype, a = n.hasOwnProperty, r = Object.defineProperty || function(e, t, n) {
                        e[t] = n.value;
                    }, o = "function" == typeof Symbol ? Symbol : {}, l = o.iterator || "@@iterator", s = o.asyncIterator || "@@asyncIterator", c = o.toStringTag || "@@toStringTag";
                    function u(e, t, n) {
                        return Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        u({}, "");
                    } catch (e) {
                        u = function(e, t, n) {
                            return e[t] = n;
                        };
                    }
                    function f(e, t, n, i) {
                        var a = t && t.prototype instanceof k ? t : k, o = Object.create(a.prototype), l = new D(i || []);
                        return r(o, "_invoke", {
                            value: E(e, n, l)
                        }), o;
                    }
                    function d(e, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, n)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    t.wrap = f;
                    var h = "suspendedStart", v = "suspendedYield", m = "executing", g = "completed", y = {};
                    function k() {}
                    function b() {}
                    function x() {}
                    var w = {};
                    u(w, l, (function() {
                        return this;
                    }));
                    var P = Object.getPrototypeOf, S = P && P(P(L([])));
                    S && S !== n && a.call(S, l) && (w = S);
                    var O = x.prototype = k.prototype = Object.create(w);
                    function _(e) {
                        [ "next", "throw", "return" ].forEach((function(t) {
                            u(e, t, (function(e) {
                                return this._invoke(t, e);
                            }));
                        }));
                    }
                    function M(e, t) {
                        function n(r, o, l, s) {
                            var c = d(e[r], e, o);
                            if ("throw" !== c.type) {
                                var u = c.arg, f = u.value;
                                return f && "object" == i(f) && a.call(f, "__await") ? t.resolve(f.__await).then((function(e) {
                                    n("next", e, l, s);
                                }), (function(e) {
                                    n("throw", e, l, s);
                                })) : t.resolve(f).then((function(e) {
                                    u.value = e, l(u);
                                }), (function(e) {
                                    return n("throw", e, l, s);
                                }));
                            }
                            s(c.arg);
                        }
                        var o;
                        r(this, "_invoke", {
                            value: function(e, i) {
                                function a() {
                                    return new t((function(t, a) {
                                        n(e, i, t, a);
                                    }));
                                }
                                return o = o ? o.then(a, a) : a();
                            }
                        });
                    }
                    function E(t, n, i) {
                        var a = h;
                        return function(r, o) {
                            if (a === m) throw new Error("Generator is already running");
                            if (a === g) {
                                if ("throw" === r) throw o;
                                return {
                                    value: e,
                                    done: !0
                                };
                            }
                            for (i.method = r, i.arg = o; ;) {
                                var l = i.delegate;
                                if (l) {
                                    var s = j(l, i);
                                    if (s) {
                                        if (s === y) continue;
                                        return s;
                                    }
                                }
                                if ("next" === i.method) i.sent = i._sent = i.arg; else if ("throw" === i.method) {
                                    if (a === h) throw a = g, i.arg;
                                    i.dispatchException(i.arg);
                                } else "return" === i.method && i.abrupt("return", i.arg);
                                a = m;
                                var c = d(t, n, i);
                                if ("normal" === c.type) {
                                    if (a = i.done ? g : v, c.arg === y) continue;
                                    return {
                                        value: c.arg,
                                        done: i.done
                                    };
                                }
                                "throw" === c.type && (a = g, i.method = "throw", i.arg = c.arg);
                            }
                        };
                    }
                    function j(t, n) {
                        var i = n.method, a = t.iterator[i];
                        if (a === e) return n.delegate = null, "throw" === i && t.iterator.return && (n.method = "return", 
                        n.arg = e, j(t, n), "throw" === n.method) || "return" !== i && (n.method = "throw", 
                        n.arg = new TypeError("The iterator does not provide a '" + i + "' method")), y;
                        var r = d(a, t.iterator, n.arg);
                        if ("throw" === r.type) return n.method = "throw", n.arg = r.arg, n.delegate = null, 
                        y;
                        var o = r.arg;
                        return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", 
                        n.arg = e), n.delegate = null, y) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), 
                        n.delegate = null, y);
                    }
                    function T(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), 
                        this.tryEntries.push(t);
                    }
                    function A(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function D(e) {
                        this.tryEntries = [ {
                            tryLoc: "root"
                        } ], e.forEach(T, this), this.reset(!0);
                    }
                    function L(t) {
                        if (t || "" === t) {
                            var n = t[l];
                            if (n) return n.call(t);
                            if ("function" == typeof t.next) return t;
                            if (!isNaN(t.length)) {
                                var r = -1, o = function n() {
                                    for (;++r < t.length; ) if (a.call(t, r)) return n.value = t[r], n.done = !1, n;
                                    return n.value = e, n.done = !0, n;
                                };
                                return o.next = o;
                            }
                        }
                        throw new TypeError(i(t) + " is not iterable");
                    }
                    return b.prototype = x, r(O, "constructor", {
                        value: x,
                        configurable: !0
                    }), r(x, "constructor", {
                        value: b,
                        configurable: !0
                    }), b.displayName = u(x, c, "GeneratorFunction"), t.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === b || "GeneratorFunction" === (t.displayName || t.name));
                    }, t.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, x) : (e.__proto__ = x, u(e, c, "GeneratorFunction")), 
                        e.prototype = Object.create(O), e;
                    }, t.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, _(M.prototype), u(M.prototype, s, (function() {
                        return this;
                    })), t.AsyncIterator = M, t.async = function(e, n, i, a, r) {
                        void 0 === r && (r = Promise);
                        var o = new M(f(e, n, i, a), r);
                        return t.isGeneratorFunction(n) ? o : o.next().then((function(e) {
                            return e.done ? e.value : o.next();
                        }));
                    }, _(O), u(O, c, "Generator"), u(O, l, (function() {
                        return this;
                    })), u(O, "toString", (function() {
                        return "[object Generator]";
                    })), t.keys = function(e) {
                        var t = Object(e), n = [];
                        for (var i in t) n.push(i);
                        return n.reverse(), function e() {
                            for (;n.length; ) {
                                var i = n.pop();
                                if (i in t) return e.value = i, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, t.values = L, D.prototype = {
                        constructor: D,
                        reset: function(t) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, 
                            this.method = "next", this.arg = e, this.tryEntries.forEach(A), !t) for (var n in this) "t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(t) {
                            if (this.done) throw t;
                            var n = this;
                            function i(i, a) {
                                return l.type = "throw", l.arg = t, n.next = i, a && (n.method = "next", n.arg = e), 
                                !!a;
                            }
                            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                                var o = this.tryEntries[r], l = o.completion;
                                if ("root" === o.tryLoc) return i("end");
                                if (o.tryLoc <= this.prev) {
                                    var s = a.call(o, "catchLoc"), c = a.call(o, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
                                        if (this.prev < o.finallyLoc) return i(o.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < o.catchLoc) return i(o.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < o.finallyLoc) return i(o.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && a.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var r = i;
                                    break;
                                }
                            }
                            r && ("break" === e || "continue" === e) && r.tryLoc <= t && t <= r.finallyLoc && (r = null);
                            var o = r ? r.completion : {};
                            return o.type = e, o.arg = t, r ? (this.method = "next", this.next = r.finallyLoc, 
                            y) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, 
                            this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), 
                            y;
                        },
                        finish: function(e) {
                            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), A(n), y;
                            }
                        },
                        catch: function(e) {
                            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e) {
                                    var i = n.completion;
                                    if ("throw" === i.type) {
                                        var a = i.arg;
                                        A(n);
                                    }
                                    return a;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(t, n, i) {
                            return this.delegate = {
                                iterator: L(t),
                                resultName: n,
                                nextLoc: i
                            }, "next" === this.method && (this.arg = e), y;
                        }
                    }, t;
                }
                function d(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = function(e, t) {
                            if (!e) return;
                            if ("string" == typeof e) return h(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            "Object" === n && e.constructor && (n = e.constructor.name);
                            if ("Map" === n || "Set" === n) return Array.from(e);
                            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return h(e, t);
                        }(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var i = 0, a = function() {};
                            return {
                                s: a,
                                n: function() {
                                    return i >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[i++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: a
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var r, o = !0, l = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return o = e.done, e;
                        },
                        e: function(e) {
                            l = !0, r = e;
                        },
                        f: function() {
                            try {
                                o || null == n.return || n.return();
                            } finally {
                                if (l) throw r;
                            }
                        }
                    };
                }
                function h(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                function v(e, t, n, i, a, r, o) {
                    try {
                        var l = e[r](o), s = l.value;
                    } catch (e) {
                        return void n(e);
                    }
                    l.done ? t(s) : Promise.resolve(s).then(i, a);
                }
                var m, g, y = t.EventHandlers = {
                    keyEvent: function(e, t, n, i, a) {
                        var o = this.inputmask, p = o.opts, d = o.dependencyLib, h = o.maskset, v = this, m = d(v), g = e.key, k = c.caret.call(o, v), b = p.onKeyDown.call(this, e, c.getBuffer.call(o), k, p);
                        if (void 0 !== b) return b;
                        if (g === s.keys.Backspace || g === s.keys.Delete || r.iphone && g === s.keys.BACKSPACE_SAFARI || e.ctrlKey && g === s.keys.x && !("oncut" in v)) e.preventDefault(), 
                        u.handleRemove.call(o, v, g, k), (0, l.writeBuffer)(v, c.getBuffer.call(o, !0), h.p, e, v.inputmask._valueGet() !== c.getBuffer.call(o).join("")); else if (g === s.keys.End || g === s.keys.PageDown) {
                            e.preventDefault();
                            var x = c.seekNext.call(o, c.getLastValidPosition.call(o));
                            c.caret.call(o, v, e.shiftKey ? k.begin : x, x, !0);
                        } else g === s.keys.Home && !e.shiftKey || g === s.keys.PageUp ? (e.preventDefault(), 
                        c.caret.call(o, v, 0, e.shiftKey ? k.begin : 0, !0)) : p.undoOnEscape && g === s.keys.Escape && !0 !== e.altKey ? ((0, l.checkVal)(v, !0, !1, o.undoValue.split("")), m.trigger("click")) : g !== s.keys.Insert || e.shiftKey || e.ctrlKey || void 0 !== o.userOptions.insertMode ? !0 === p.tabThrough && g === s.keys.Tab ? !0 === e.shiftKey ? (k.end = c.seekPrevious.call(o, k.end, !0), 
                        !0 === f.getTest.call(o, k.end - 1).match.static && k.end--, k.begin = c.seekPrevious.call(o, k.end, !0), 
                        k.begin >= 0 && k.end > 0 && (e.preventDefault(), c.caret.call(o, v, k.begin, k.end))) : (k.begin = c.seekNext.call(o, k.begin, !0), 
                        k.end = c.seekNext.call(o, k.begin, !0), k.end < h.maskLength && k.end--, k.begin <= h.maskLength && (e.preventDefault(), 
                        c.caret.call(o, v, k.begin, k.end))) : e.shiftKey || (p.insertModeVisual && !1 === p.insertMode ? g === s.keys.ArrowRight ? setTimeout((function() {
                            var e = c.caret.call(o, v);
                            c.caret.call(o, v, e.begin);
                        }), 0) : g === s.keys.ArrowLeft && setTimeout((function() {
                            var e = c.translatePosition.call(o, v.inputmask.caretPos.begin);
                            c.translatePosition.call(o, v.inputmask.caretPos.end);
                            o.isRTL ? c.caret.call(o, v, e + (e === h.maskLength ? 0 : 1)) : c.caret.call(o, v, e - (0 === e ? 0 : 1));
                        }), 0) : void 0 === o.keyEventHook || o.keyEventHook(e)) : u.isSelection.call(o, k) ? p.insertMode = !p.insertMode : (p.insertMode = !p.insertMode, 
                        c.caret.call(o, v, k.begin, k.begin));
                        return o.isComposing = g == s.keys.Process || g == s.keys.Unidentified, o.ignorable = g.length > 1 && !("textarea" === v.tagName.toLowerCase() && g == s.keys.Enter), 
                        y.keypressEvent.call(this, e, t, n, i, a);
                    },
                    keypressEvent: function(e, t, n, i, a) {
                        var r = this.inputmask || this, o = r.opts, f = r.dependencyLib, p = r.maskset, d = r.el, h = f(d), v = e.key;
                        if (!0 === t || e.ctrlKey && e.altKey && !r.ignorable || !(e.ctrlKey || e.metaKey || r.ignorable)) {
                            if (v) {
                                var m, g = t ? {
                                    begin: a,
                                    end: a
                                } : c.caret.call(r, d);
                                t || (v = o.substitutes[v] || v), p.writeOutBuffer = !0;
                                var y = u.isValid.call(r, g, v, i, void 0, void 0, void 0, t);
                                if (!1 !== y && (c.resetMaskSet.call(r, !0), m = void 0 !== y.caret ? y.caret : c.seekNext.call(r, y.pos.begin ? y.pos.begin : y.pos), 
                                p.p = m), m = o.numericInput && void 0 === y.caret ? c.seekPrevious.call(r, m) : m, 
                                !1 !== n && (setTimeout((function() {
                                    o.onKeyValidation.call(d, v, y);
                                }), 0), p.writeOutBuffer && !1 !== y)) {
                                    var k = c.getBuffer.call(r);
                                    (0, l.writeBuffer)(d, k, m, e, !0 !== t);
                                }
                                if (e.preventDefault(), t) return !1 !== y && (y.forwardPosition = m), y;
                            }
                        } else v === s.keys.Enter && r.undoValue !== r._valueGet(!0) && (r.undoValue = r._valueGet(!0), 
                        setTimeout((function() {
                            h.trigger("change");
                        }), 0));
                    },
                    pasteEvent: (m = p().mark((function e(t) {
                        var n, i, a, r, s, u;
                        return p().wrap((function(e) {
                            for (;;) switch (e.prev = e.next) {
                              case 0:
                                n = function(e, n, i, a, o) {
                                    var s = c.caret.call(e, n, void 0, void 0, !0), u = i.substr(0, s.begin), f = i.substr(s.end, i.length);
                                    if (u == (e.isRTL ? c.getBufferTemplate.call(e).slice().reverse() : c.getBufferTemplate.call(e)).slice(0, s.begin).join("") && (u = ""), 
                                    f == (e.isRTL ? c.getBufferTemplate.call(e).slice().reverse() : c.getBufferTemplate.call(e)).slice(s.end).join("") && (f = ""), 
                                    a = u + a + f, e.isRTL && !0 !== r.numericInput) {
                                        a = a.split("");
                                        var p, h = d(c.getBufferTemplate.call(e));
                                        try {
                                            for (h.s(); !(p = h.n()).done; ) {
                                                var v = p.value;
                                                a[0] === v && a.shift();
                                            }
                                        } catch (e) {
                                            h.e(e);
                                        } finally {
                                            h.f();
                                        }
                                        a = a.reverse().join("");
                                    }
                                    var m = a;
                                    if ("function" == typeof o) {
                                        if (!1 === (m = o.call(e, m, r))) return !1;
                                        m || (m = i);
                                    }
                                    (0, l.checkVal)(n, !0, !1, m.toString().split(""), t);
                                }, i = this, a = this.inputmask, r = a.opts, s = a._valueGet(!0), a.skipInputEvent = !0, 
                                t.clipboardData && t.clipboardData.getData ? u = t.clipboardData.getData("text/plain") : o.default.clipboardData && o.default.clipboardData.getData && (u = o.default.clipboardData.getData("Text")), 
                                n(a, i, s, u, r.onBeforePaste), t.preventDefault();

                              case 7:
                              case "end":
                                return e.stop();
                            }
                        }), e, this);
                    })), g = function() {
                        var e = this, t = arguments;
                        return new Promise((function(n, i) {
                            var a = m.apply(e, t);
                            function r(e) {
                                v(a, n, i, r, o, "next", e);
                            }
                            function o(e) {
                                v(a, n, i, r, o, "throw", e);
                            }
                            r(void 0);
                        }));
                    }, function(e) {
                        return g.apply(this, arguments);
                    }),
                    inputFallBackEvent: function(e) {
                        var t = this.inputmask, n = t.opts, i = t.dependencyLib;
                        var a, o = this, u = o.inputmask._valueGet(!0), p = (t.isRTL ? c.getBuffer.call(t).slice().reverse() : c.getBuffer.call(t)).join(""), d = c.caret.call(t, o, void 0, void 0, !0);
                        if (p !== u) {
                            if (a = function(e, i, a) {
                                for (var r, o, l, s = e.substr(0, a.begin).split(""), u = e.substr(a.begin).split(""), p = i.substr(0, a.begin).split(""), d = i.substr(a.begin).split(""), h = s.length >= p.length ? s.length : p.length, v = u.length >= d.length ? u.length : d.length, m = "", g = [], y = "~"; s.length < h; ) s.push(y);
                                for (;p.length < h; ) p.push(y);
                                for (;u.length < v; ) u.unshift(y);
                                for (;d.length < v; ) d.unshift(y);
                                var k = s.concat(u), b = p.concat(d);
                                for (o = 0, r = k.length; o < r; o++) switch (l = f.getPlaceholder.call(t, c.translatePosition.call(t, o)), 
                                m) {
                                  case "insertText":
                                    b[o - 1] === k[o] && a.begin == k.length - 1 && g.push(k[o]), o = r;
                                    break;

                                  case "insertReplacementText":
                                  case "deleteContentBackward":
                                    k[o] === y ? a.end++ : o = r;
                                    break;

                                  default:
                                    k[o] !== b[o] && (k[o + 1] !== y && k[o + 1] !== l && void 0 !== k[o + 1] || (b[o] !== l || b[o + 1] !== y) && b[o] !== y ? b[o + 1] === y && b[o] === k[o + 1] ? (m = "insertText", 
                                    g.push(k[o]), a.begin--, a.end--) : k[o] !== l && k[o] !== y && (k[o + 1] === y || b[o] !== k[o] && b[o + 1] === k[o + 1]) ? (m = "insertReplacementText", 
                                    g.push(k[o]), a.begin--) : k[o] === y ? (m = "deleteContentBackward", (c.isMask.call(t, c.translatePosition.call(t, o), !0) || b[o] === n.radixPoint) && a.end++) : o = r : (m = "insertText", 
                                    g.push(k[o]), a.begin--, a.end--));
                                }
                                return {
                                    action: m,
                                    data: g,
                                    caret: a
                                };
                            }(u, p, d), (o.inputmask.shadowRoot || o.ownerDocument).activeElement !== o && o.focus(), 
                            (0, l.writeBuffer)(o, c.getBuffer.call(t)), c.caret.call(t, o, d.begin, d.end, !0), 
                            !r.mobile && t.skipNextInsert && "insertText" === e.inputType && "insertText" === a.action && t.isComposing) return !1;
                            switch ("insertCompositionText" === e.inputType && "insertText" === a.action && t.isComposing ? t.skipNextInsert = !0 : t.skipNextInsert = !1, 
                            a.action) {
                              case "insertText":
                              case "insertReplacementText":
                                a.data.forEach((function(e, n) {
                                    var a = new i.Event("keypress");
                                    a.key = e, t.ignorable = !1, y.keypressEvent.call(o, a);
                                })), setTimeout((function() {
                                    t.$el.trigger("keyup");
                                }), 0);
                                break;

                              case "deleteContentBackward":
                                var h = new i.Event("keydown");
                                h.key = s.keys.Backspace, y.keyEvent.call(o, h);
                                break;

                              default:
                                (0, l.applyInputValue)(o, u), c.caret.call(t, o, d.begin, d.end, !0);
                            }
                            e.preventDefault();
                        }
                    },
                    setValueEvent: function(e) {
                        var t = this.inputmask, n = t.dependencyLib, i = this, a = e && e.detail ? e.detail[0] : arguments[1];
                        void 0 === a && (a = i.inputmask._valueGet(!0)), (0, l.applyInputValue)(i, a, new n.Event("input")), 
                        (e.detail && void 0 !== e.detail[1] || void 0 !== arguments[2]) && c.caret.call(t, i, e.detail ? e.detail[1] : arguments[2]);
                    },
                    focusEvent: function(e) {
                        var t = this.inputmask, n = t.opts, i = t && t._valueGet();
                        n.showMaskOnFocus && i !== c.getBuffer.call(t).join("") && (0, l.writeBuffer)(this, c.getBuffer.call(t), c.seekNext.call(t, c.getLastValidPosition.call(t))), 
                        !0 !== n.positionCaretOnTab || !1 !== t.mouseEnter || u.isComplete.call(t, c.getBuffer.call(t)) && -1 !== c.getLastValidPosition.call(t) || y.clickEvent.apply(this, [ e, !0 ]), 
                        t.undoValue = t && t._valueGet(!0);
                    },
                    invalidEvent: function(e) {
                        this.inputmask.validationEvent = !0;
                    },
                    mouseleaveEvent: function() {
                        var e = this.inputmask, t = e.opts, n = this;
                        e.mouseEnter = !1, t.clearMaskOnLostFocus && (n.inputmask.shadowRoot || n.ownerDocument).activeElement !== n && (0, l.HandleNativePlaceholder)(n, e.originalPlaceholder);
                    },
                    clickEvent: function(e, t) {
                        var n = this.inputmask;
                        n.clicked++;
                        var i = this;
                        if ((i.inputmask.shadowRoot || i.ownerDocument).activeElement === i) {
                            var a = c.determineNewCaretPosition.call(n, c.caret.call(n, i), t);
                            void 0 !== a && c.caret.call(n, i, a);
                        }
                    },
                    cutEvent: function(e) {
                        var t = this.inputmask, n = t.maskset, i = this, a = c.caret.call(t, i), r = t.isRTL ? c.getBuffer.call(t).slice(a.end, a.begin) : c.getBuffer.call(t).slice(a.begin, a.end), f = t.isRTL ? r.reverse().join("") : r.join("");
                        o.default.navigator && o.default.navigator.clipboard ? o.default.navigator.clipboard.writeText(f) : o.default.clipboardData && o.default.clipboardData.getData && o.default.clipboardData.setData("Text", f), 
                        u.handleRemove.call(t, i, s.keys.Delete, a), (0, l.writeBuffer)(i, c.getBuffer.call(t), n.p, e, t.undoValue !== t._valueGet(!0));
                    },
                    blurEvent: function(e) {
                        var t = this.inputmask, n = t.opts, i = t.dependencyLib;
                        t.clicked = 0;
                        var a = i(this), r = this;
                        if (r.inputmask) {
                            (0, l.HandleNativePlaceholder)(r, t.originalPlaceholder);
                            var o = r.inputmask._valueGet(), s = c.getBuffer.call(t).slice();
                            "" !== o && (n.clearMaskOnLostFocus && (-1 === c.getLastValidPosition.call(t) && o === c.getBufferTemplate.call(t).join("") ? s = [] : l.clearOptionalTail.call(t, s)), 
                            !1 === u.isComplete.call(t, s) && (setTimeout((function() {
                                a.trigger("incomplete");
                            }), 0), n.clearIncomplete && (c.resetMaskSet.call(t, !1), s = n.clearMaskOnLostFocus ? [] : c.getBufferTemplate.call(t).slice())), 
                            (0, l.writeBuffer)(r, s, void 0, e)), o = t._valueGet(!0), t.undoValue !== o && ("" != o || t.undoValue != c.getBufferTemplate.call(t).join("") || t.undoValue == c.getBufferTemplate.call(t).join("") && t.maskset.validPositions.length > 0) && (t.undoValue = o, 
                            a.trigger("change"));
                        }
                    },
                    mouseenterEvent: function() {
                        var e = this.inputmask, t = e.opts.showMaskOnHover, n = this;
                        if (e.mouseEnter = !0, (n.inputmask.shadowRoot || n.ownerDocument).activeElement !== n) {
                            var i = (e.isRTL ? c.getBufferTemplate.call(e).slice().reverse() : c.getBufferTemplate.call(e)).join("");
                            t && (0, l.HandleNativePlaceholder)(n, i);
                        }
                    },
                    submitEvent: function() {
                        var e = this.inputmask, t = e.opts;
                        e.undoValue !== e._valueGet(!0) && e.$el.trigger("change"), -1 === c.getLastValidPosition.call(e) && e._valueGet && e._valueGet() === c.getBufferTemplate.call(e).join("") && e._valueSet(""), 
                        t.clearIncomplete && !1 === u.isComplete.call(e, c.getBuffer.call(e)) && e._valueSet(""), 
                        t.removeMaskOnSubmit && (e._valueSet(e.unmaskedvalue(), !0), setTimeout((function() {
                            (0, l.writeBuffer)(e.el, c.getBuffer.call(e));
                        }), 0));
                    },
                    resetEvent: function() {
                        var e = this.inputmask;
                        e.refreshValue = !0, setTimeout((function() {
                            (0, l.applyInputValue)(e.el, e._valueGet(!0));
                        }), 0);
                    }
                };
            },
            9716: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventRuler = void 0;
                var i, a = n(7760), r = (i = n(2394)) && i.__esModule ? i : {
                    default: i
                }, o = n(2839), l = n(8711);
                t.EventRuler = {
                    on: function(e, t, n) {
                        var i = e.inputmask.dependencyLib, s = function(t) {
                            t.originalEvent && (t = t.originalEvent || t, arguments[0] = t);
                            var s, c = this, u = c.inputmask, f = u ? u.opts : void 0;
                            if (void 0 === u && "FORM" !== this.nodeName) {
                                var p = i.data(c, "_inputmask_opts");
                                i(c).off(), p && new r.default(p).mask(c);
                            } else {
                                if ([ "submit", "reset", "setvalue" ].includes(t.type) || "FORM" === this.nodeName || !(c.disabled || c.readOnly && !("keydown" === t.type && t.ctrlKey && t.key === o.keys.c || !1 === f.tabThrough && t.key === o.keys.Tab))) {
                                    switch (t.type) {
                                      case "input":
                                        if (!0 === u.skipInputEvent) return u.skipInputEvent = !1, t.preventDefault();
                                        break;

                                      case "click":
                                      case "focus":
                                        return u.validationEvent ? (u.validationEvent = !1, e.blur(), (0, a.HandleNativePlaceholder)(e, (u.isRTL ? l.getBufferTemplate.call(u).slice().reverse() : l.getBufferTemplate.call(u)).join("")), 
                                        setTimeout((function() {
                                            e.focus();
                                        }), f.validationEventTimeOut), !1) : (s = arguments, void setTimeout((function() {
                                            e.inputmask && n.apply(c, s);
                                        }), 0));
                                    }
                                    var d = n.apply(c, arguments);
                                    return !1 === d && (t.preventDefault(), t.stopPropagation()), d;
                                }
                                t.preventDefault();
                            }
                        };
                        [ "submit", "reset" ].includes(t) ? (s = s.bind(e), null !== e.form && i(e.form).on(t, s)) : i(e).on(t, s), 
                        e.inputmask.events[t] = e.inputmask.events[t] || [], e.inputmask.events[t].push(s);
                    },
                    off: function(e, t) {
                        if (e.inputmask && e.inputmask.events) {
                            var n = e.inputmask.dependencyLib, i = e.inputmask.events;
                            for (var a in t && ((i = [])[t] = e.inputmask.events[t]), i) {
                                for (var r = i[a]; r.length > 0; ) {
                                    var o = r.pop();
                                    [ "submit", "reset" ].includes(a) ? null !== e.form && n(e.form).off(a, o) : n(e).off(a, o);
                                }
                                delete e.inputmask.events[a];
                            }
                        }
                    }
                };
            },
            219: function(e, t, n) {
                var i = p(n(7184)), a = p(n(2394)), r = n(2839), o = n(8711), l = n(4713);
                function s(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var i, a, r, o, l = [], s = !0, c = !1;
                            try {
                                if (r = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for (;!(s = (i = r.call(n)).done) && (l.push(i.value), l.length !== t); s = !0) ;
                            } catch (e) {
                                c = !0, a = e;
                            } finally {
                                try {
                                    if (!s && null != n.return && (o = n.return(), Object(o) !== o)) return;
                                } finally {
                                    if (c) throw a;
                                }
                            }
                            return l;
                        }
                    }(e, t) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return c(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === n && e.constructor && (n = e.constructor.name);
                        if ("Map" === n || "Set" === n) return Array.from(e);
                        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function c(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                function u(e) {
                    return u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, u(e);
                }
                function f(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
                        Object.defineProperty(e, (a = i.key, r = void 0, r = function(e, t) {
                            if ("object" !== u(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var i = n.call(e, t || "default");
                                if ("object" !== u(i)) return i;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(a, "string"), "symbol" === u(r) ? r : String(r)), i);
                    }
                    var a, r;
                }
                function p(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                n(1313);
                var d = a.default.dependencyLib, h = function() {
                    function e(t, n, i, a) {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.mask = t, this.format = n, this.opts = i, this.inputmask = a, this._date = new Date(1, 0, 1), 
                        this.initDateObject(t, this.opts, this.inputmask);
                    }
                    var t, n;
                    return t = e, (n = [ {
                        key: "date",
                        get: function() {
                            return void 0 === this._date && (this._date = new Date(1, 0, 1), this.initDateObject(void 0, this.opts, this.inputmask)), 
                            this._date;
                        }
                    }, {
                        key: "initDateObject",
                        value: function(e, t, n) {
                            var i;
                            for (P(t).lastIndex = 0; i = P(t).exec(this.format); ) {
                                var a = /\d+$/.exec(i[0]), r = a ? i[0][0] + "x" : i[0], o = void 0;
                                if (void 0 !== e) {
                                    if (a) {
                                        var s = P(t).lastIndex, c = j.call(n, i.index, t, n && n.maskset);
                                        P(t).lastIndex = s, o = e.slice(0, e.indexOf(c.nextMatch[0]));
                                    } else {
                                        for (var u = i[0][0], f = i.index; n && (t.placeholder[l.getTest.call(n, f).match.placeholder] || l.getTest.call(n, f).match.placeholder) === u; ) f++;
                                        var p = f - i.index;
                                        o = e.slice(0, p || y[r] && y[r][4] || r.length);
                                    }
                                    e = e.slice(o.length);
                                }
                                Object.prototype.hasOwnProperty.call(y, r) && this.setValue(this, o, r, y[r][2], y[r][1]);
                            }
                        }
                    }, {
                        key: "setValue",
                        value: function(e, t, n, i, a) {
                            if (void 0 !== t) switch (i) {
                              case "ampm":
                                e[i] = t, e["raw" + i] = t.replace(/\s/g, "_");
                                break;

                              case "month":
                                if ("mmm" === n || "mmmm" === n) {
                                    e[i] = _("mmm" === n ? m.monthNames.slice(0, 12).findIndex((function(e) {
                                        return t.toLowerCase() === e.toLowerCase();
                                    })) + 1 : m.monthNames.slice(12, 24).findIndex((function(e) {
                                        return t.toLowerCase() === e.toLowerCase();
                                    })) + 1, 2), e[i] = "00" === e[i] ? "" : e[i].toString(), e["raw" + i] = e[i];
                                    break;
                                }

                              default:
                                e[i] = t.replace(/[^0-9]/g, "0"), e["raw" + i] = t.replace(/\s/g, "_");
                            }
                            if (void 0 !== a) {
                                var r = e[i];
                                ("day" === i && 29 === parseInt(r) || "month" === i && 2 === parseInt(r)) && (29 !== parseInt(e.day) || 2 !== parseInt(e.month) || "" !== e.year && void 0 !== e.year || e._date.setFullYear(2012, 1, 29)), 
                                "day" === i && (g = !0, 0 === parseInt(r) && (r = 1)), "month" === i && (g = !0), 
                                "year" === i && (g = !0, r.length < y[n][4] && (r = _(r, y[n][4], !0))), ("" !== r && !isNaN(r) || "ampm" === i) && a.call(e._date, r);
                            }
                        }
                    }, {
                        key: "reset",
                        value: function() {
                            this._date = new Date(1, 0, 1);
                        }
                    }, {
                        key: "reInit",
                        value: function() {
                            this._date = void 0;
                        }
                    } ]) && f(t.prototype, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }(), v = (new Date).getFullYear(), m = a.default.prototype.i18n, g = !1, y = {
                    d: [ "[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", Date.prototype.getDate ],
                    dd: [ "0[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", function() {
                        return _(Date.prototype.getDate.call(this), 2);
                    } ],
                    ddd: [ "" ],
                    dddd: [ "" ],
                    m: [ "[1-9]|1[012]", function(e) {
                        var t = e ? parseInt(e) : 0;
                        return t > 0 && t--, Date.prototype.setMonth.call(this, t);
                    }, "month", function() {
                        return Date.prototype.getMonth.call(this) + 1;
                    } ],
                    mm: [ "0[1-9]|1[012]", function(e) {
                        var t = e ? parseInt(e) : 0;
                        return t > 0 && t--, Date.prototype.setMonth.call(this, t);
                    }, "month", function() {
                        return _(Date.prototype.getMonth.call(this) + 1, 2);
                    } ],
                    mmm: [ m.monthNames.slice(0, 12).join("|"), function(e) {
                        var t = m.monthNames.slice(0, 12).findIndex((function(t) {
                            return e.toLowerCase() === t.toLowerCase();
                        }));
                        return -1 !== t && Date.prototype.setMonth.call(this, t);
                    }, "month", function() {
                        return m.monthNames.slice(0, 12)[Date.prototype.getMonth.call(this)];
                    } ],
                    mmmm: [ m.monthNames.slice(12, 24).join("|"), function(e) {
                        var t = m.monthNames.slice(12, 24).findIndex((function(t) {
                            return e.toLowerCase() === t.toLowerCase();
                        }));
                        return -1 !== t && Date.prototype.setMonth.call(this, t);
                    }, "month", function() {
                        return m.monthNames.slice(12, 24)[Date.prototype.getMonth.call(this)];
                    } ],
                    yy: [ "[0-9]{2}", function(e) {
                        var t = (new Date).getFullYear().toString().slice(0, 2);
                        Date.prototype.setFullYear.call(this, "".concat(t).concat(e));
                    }, "year", function() {
                        return _(Date.prototype.getFullYear.call(this), 2);
                    }, 2 ],
                    yyyy: [ "[0-9]{4}", Date.prototype.setFullYear, "year", function() {
                        return _(Date.prototype.getFullYear.call(this), 4);
                    }, 4 ],
                    h: [ "[1-9]|1[0-2]", Date.prototype.setHours, "hours", Date.prototype.getHours ],
                    hh: [ "0[1-9]|1[0-2]", Date.prototype.setHours, "hours", function() {
                        return _(Date.prototype.getHours.call(this), 2);
                    } ],
                    hx: [ function(e) {
                        return "[0-9]{".concat(e, "}");
                    }, Date.prototype.setHours, "hours", function(e) {
                        return Date.prototype.getHours;
                    } ],
                    H: [ "1?[0-9]|2[0-3]", Date.prototype.setHours, "hours", Date.prototype.getHours ],
                    HH: [ "0[0-9]|1[0-9]|2[0-3]", Date.prototype.setHours, "hours", function() {
                        return _(Date.prototype.getHours.call(this), 2);
                    } ],
                    Hx: [ function(e) {
                        return "[0-9]{".concat(e, "}");
                    }, Date.prototype.setHours, "hours", function(e) {
                        return function() {
                            return _(Date.prototype.getHours.call(this), e);
                        };
                    } ],
                    M: [ "[1-5]?[0-9]", Date.prototype.setMinutes, "minutes", Date.prototype.getMinutes ],
                    MM: [ "0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setMinutes, "minutes", function() {
                        return _(Date.prototype.getMinutes.call(this), 2);
                    } ],
                    s: [ "[1-5]?[0-9]", Date.prototype.setSeconds, "seconds", Date.prototype.getSeconds ],
                    ss: [ "0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setSeconds, "seconds", function() {
                        return _(Date.prototype.getSeconds.call(this), 2);
                    } ],
                    l: [ "[0-9]{3}", Date.prototype.setMilliseconds, "milliseconds", function() {
                        return _(Date.prototype.getMilliseconds.call(this), 3);
                    }, 3 ],
                    L: [ "[0-9]{2}", Date.prototype.setMilliseconds, "milliseconds", function() {
                        return _(Date.prototype.getMilliseconds.call(this), 2);
                    }, 2 ],
                    t: [ "[ap]", b, "ampm", x, 1 ],
                    tt: [ "[ap]m", b, "ampm", x, 2 ],
                    T: [ "[AP]", b, "ampm", x, 1 ],
                    TT: [ "[AP]M", b, "ampm", x, 2 ],
                    Z: [ ".*", void 0, "Z", function() {
                        var e = this.toString().match(/\((.+)\)/)[1];
                        e.includes(" ") && (e = (e = e.replace("-", " ").toUpperCase()).split(" ").map((function(e) {
                            return s(e, 1)[0];
                        })).join(""));
                        return e;
                    } ],
                    o: [ "" ],
                    S: [ "" ]
                }, k = {
                    isoDate: "yyyy-mm-dd",
                    isoTime: "HH:MM:ss",
                    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
                    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
                };
                function b(e) {
                    var t = this.getHours();
                    e.toLowerCase().includes("p") ? this.setHours(t + 12) : e.toLowerCase().includes("a") && t >= 12 && this.setHours(t - 12);
                }
                function x() {
                    var e = this.getHours();
                    return (e = e || 12) >= 12 ? "PM" : "AM";
                }
                function w(e) {
                    var t = /\d+$/.exec(e[0]);
                    if (t && void 0 !== t[0]) {
                        var n = y[e[0][0] + "x"].slice("");
                        return n[0] = n[0](t[0]), n[3] = n[3](t[0]), n;
                    }
                    if (y[e[0]]) return y[e[0]];
                }
                function P(e) {
                    if (!e.tokenizer) {
                        var t = [], n = [];
                        for (var i in y) if (/\.*x$/.test(i)) {
                            var a = i[0] + "\\d+";
                            -1 === n.indexOf(a) && n.push(a);
                        } else -1 === t.indexOf(i[0]) && t.push(i[0]);
                        e.tokenizer = "(" + (n.length > 0 ? n.join("|") + "|" : "") + t.join("+|") + ")+?|.", 
                        e.tokenizer = new RegExp(e.tokenizer, "g");
                    }
                    return e.tokenizer;
                }
                function S(e, t, n) {
                    if (!g) return !0;
                    if (void 0 === e.rawday || !isFinite(e.rawday) && new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0).getDate() >= e.day || "29" == e.day && (!isFinite(e.rawyear) || void 0 === e.rawyear || "" === e.rawyear) || new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0).getDate() >= e.day) return t;
                    if ("29" == e.day) {
                        var i = j.call(this, t.pos, n, this.maskset);
                        if (i.targetMatch && "yyyy" === i.targetMatch[0] && t.pos - i.targetMatchIndex == 2) return t.remove = t.pos + 1, 
                        t;
                    } else if (2 == e.date.getMonth() && "30" == e.day && void 0 !== t.c) return e.day = "03", 
                    e.date.setDate(3), e.date.setMonth(1), t.insert = [ {
                        pos: t.pos,
                        c: "0"
                    }, {
                        pos: t.pos + 1,
                        c: t.c
                    } ], t.caret = o.seekNext.call(this, t.pos + 1), t;
                    return !1;
                }
                function O(e, t, n, a) {
                    var r, o, l = "", s = 0, c = {};
                    for (P(n).lastIndex = 0; r = P(n).exec(e); ) {
                        if (void 0 === t) if (o = w(r)) l += "(" + o[0] + ")", n.placeholder && "" !== n.placeholder ? (c[s] = n.placeholder[r.index % n.placeholder.length], 
                        c[n.placeholder[r.index % n.placeholder.length]] = r[0].charAt(0)) : c[s] = r[0].charAt(0); else switch (r[0]) {
                          case "[":
                            l += "(";
                            break;

                          case "]":
                            l += ")?";
                            break;

                          default:
                            l += (0, i.default)(r[0]), c[s] = r[0].charAt(0);
                        } else if (o = w(r)) if (!0 !== a && o[3]) l += o[3].call(t.date); else o[2] ? l += t["raw" + o[2]] : l += r[0]; else l += r[0];
                        s++;
                    }
                    return void 0 === t && (n.placeholder = c), l;
                }
                function _(e, t, n) {
                    for (e = String(e), t = t || 2; e.length < t; ) e = n ? e + "0" : "0" + e;
                    return e;
                }
                function M(e, t, n) {
                    return "string" == typeof e ? new h(e, t, n, this) : e && "object" === u(e) && Object.prototype.hasOwnProperty.call(e, "date") ? e : void 0;
                }
                function E(e, t) {
                    return O(t.inputFormat, {
                        date: e
                    }, t);
                }
                function j(e, t, n) {
                    var i, a, r = this, o = n && n.tests[e] ? t.placeholder[n.tests[e][0].match.placeholder] || n.tests[e][0].match.placeholder : "", s = 0, c = 0;
                    for (P(t).lastIndex = 0; a = P(t).exec(t.inputFormat); ) {
                        var u = /\d+$/.exec(a[0]);
                        if (u) c = parseInt(u[0]); else {
                            for (var f = a[0][0], p = s; r && (t.placeholder[l.getTest.call(r, p).match.placeholder] || l.getTest.call(r, p).match.placeholder) === f; ) p++;
                            0 === (c = p - s) && (c = a[0].length);
                        }
                        if (s += c, -1 != a[0].indexOf(o) || s >= e + 1) {
                            i = a, a = P(t).exec(t.inputFormat);
                            break;
                        }
                    }
                    return {
                        targetMatchIndex: s - c,
                        nextMatch: a,
                        targetMatch: i
                    };
                }
                a.default.extendAliases({
                    datetime: {
                        mask: function(e) {
                            return e.numericInput = !1, y.S = m.ordinalSuffix.join("|"), e.inputFormat = k[e.inputFormat] || e.inputFormat, 
                            e.displayFormat = k[e.displayFormat] || e.displayFormat || e.inputFormat, e.outputFormat = k[e.outputFormat] || e.outputFormat || e.inputFormat, 
                            e.regex = O(e.inputFormat, void 0, e), e.min = M(e.min, e.inputFormat, e), e.max = M(e.max, e.inputFormat, e), 
                            null;
                        },
                        placeholder: "",
                        inputFormat: "isoDateTime",
                        displayFormat: null,
                        outputFormat: null,
                        min: null,
                        max: null,
                        skipOptionalPartCharacter: "",
                        preValidation: function(e, t, n, i, a, r, o, l) {
                            if (l) return !0;
                            if (isNaN(n) && e[t] !== n) {
                                var s = j.call(this, t, a, r);
                                if (s.nextMatch && s.nextMatch[0] === n && s.targetMatch[0].length > 1) {
                                    var c = w(s.targetMatch)[0];
                                    if (new RegExp(c).test("0" + e[t - 1])) return e[t] = e[t - 1], e[t - 1] = "0", 
                                    {
                                        fuzzy: !0,
                                        buffer: e,
                                        refreshFromBuffer: {
                                            start: t - 1,
                                            end: t + 1
                                        },
                                        pos: t + 1
                                    };
                                }
                            }
                            return !0;
                        },
                        postValidation: function(e, t, n, i, a, r, o, s) {
                            var c, u, f = this;
                            if (o) return !0;
                            if (!1 === i && (((c = j.call(f, t + 1, a, r)).targetMatch && c.targetMatchIndex === t && c.targetMatch[0].length > 1 && void 0 !== y[c.targetMatch[0]] || (c = j.call(f, t + 2, a, r)).targetMatch && c.targetMatchIndex === t + 1 && c.targetMatch[0].length > 1 && void 0 !== y[c.targetMatch[0]]) && (u = w(c.targetMatch)[0]), 
                            void 0 !== u && (void 0 !== r.validPositions[t + 1] && new RegExp(u).test(n + "0") ? (e[t] = n, 
                            e[t + 1] = "0", i = {
                                pos: t + 2,
                                caret: t
                            }) : new RegExp(u).test("0" + n) && (e[t] = "0", e[t + 1] = n, i = {
                                pos: t + 2
                            })), !1 === i)) return i;
                            if (i.fuzzy && (e = i.buffer, t = i.pos), (c = j.call(f, t, a, r)).targetMatch && c.targetMatch[0] && void 0 !== y[c.targetMatch[0]]) {
                                var p = w(c.targetMatch);
                                u = p[0];
                                var d = e.slice(c.targetMatchIndex, c.targetMatchIndex + c.targetMatch[0].length);
                                if (!1 === new RegExp(u).test(d.join("")) && 2 === c.targetMatch[0].length && r.validPositions[c.targetMatchIndex] && r.validPositions[c.targetMatchIndex + 1] && (r.validPositions[c.targetMatchIndex + 1].input = "0"), 
                                "year" == p[2]) for (var h = l.getMaskTemplate.call(f, !1, 1, void 0, !0), m = t + 1; m < e.length; m++) e[m] = h[m], 
                                r.validPositions.splice(t + 1, 1);
                            }
                            var g = i, k = M.call(f, e.join(""), a.inputFormat, a);
                            return g && !isNaN(k.date.getTime()) && (a.prefillYear && (g = function(e, t, n) {
                                if (e.year !== e.rawyear) {
                                    var i = v.toString(), a = e.rawyear.replace(/[^0-9]/g, ""), r = i.slice(0, a.length), o = i.slice(a.length);
                                    if (2 === a.length && a === r) {
                                        var l = new Date(v, e.month - 1, e.day);
                                        e.day == l.getDate() && (!n.max || n.max.date.getTime() >= l.getTime()) && (e.date.setFullYear(v), 
                                        e.year = i, t.insert = [ {
                                            pos: t.pos + 1,
                                            c: o[0]
                                        }, {
                                            pos: t.pos + 2,
                                            c: o[1]
                                        } ]);
                                    }
                                }
                                return t;
                            }(k, g, a)), g = function(e, t, n, i, a) {
                                if (!t) return t;
                                if (t && n.min && !isNaN(n.min.date.getTime())) {
                                    var r;
                                    for (e.reset(), P(n).lastIndex = 0; r = P(n).exec(n.inputFormat); ) {
                                        var o;
                                        if ((o = w(r)) && o[3]) {
                                            for (var l = o[1], s = e[o[2]], c = n.min[o[2]], u = n.max ? n.max[o[2]] : c + 1, f = [], p = !1, d = 0; d < c.length; d++) void 0 !== i.validPositions[d + r.index] || p ? (f[d] = s[d], 
                                            p = p || s[d] > c[d]) : (d + r.index == 0 && s[d] < c[d] ? (f[d] = s[d], p = !0) : f[d] = c[d], 
                                            "year" === o[2] && s.length - 1 == d && c != u && (f = (parseInt(f.join("")) + 1).toString().split("")), 
                                            "ampm" === o[2] && c != u && n.min.date.getTime() > e.date.getTime() && (f[d] = u[d]));
                                            l.call(e._date, f.join(""));
                                        }
                                    }
                                    t = n.min.date.getTime() <= e.date.getTime(), e.reInit();
                                }
                                return t && n.max && (isNaN(n.max.date.getTime()) || (t = n.max.date.getTime() >= e.date.getTime())), 
                                t;
                            }(k, g = S.call(f, k, g, a), a, r)), void 0 !== t && g && i.pos !== t ? {
                                buffer: O(a.inputFormat, k, a).split(""),
                                refreshFromBuffer: {
                                    start: t,
                                    end: i.pos
                                },
                                pos: i.caret || i.pos
                            } : g;
                        },
                        onKeyDown: function(e, t, n, i) {
                            e.ctrlKey && e.key === r.keys.ArrowRight && (this.inputmask._valueSet(E(new Date, i)), 
                            d(this).trigger("setvalue"));
                        },
                        onUnMask: function(e, t, n) {
                            return t ? O(n.outputFormat, M.call(this, e, n.inputFormat, n), n, !0) : t;
                        },
                        casing: function(e, t, n, i) {
                            if (0 == t.nativeDef.indexOf("[ap]")) return e.toLowerCase();
                            if (0 == t.nativeDef.indexOf("[AP]")) return e.toUpperCase();
                            var a = l.getTest.call(this, [ n - 1 ]);
                            return 0 == a.match.def.indexOf("[AP]") || 0 === n || a && a.input === String.fromCharCode(r.keyCode.Space) || a && a.match.def === String.fromCharCode(r.keyCode.Space) ? e.toUpperCase() : e.toLowerCase();
                        },
                        onBeforeMask: function(e, t) {
                            return "[object Date]" === Object.prototype.toString.call(e) && (e = E(e, t)), e;
                        },
                        insertMode: !1,
                        insertModeVisual: !1,
                        shiftPositions: !1,
                        keepStatic: !1,
                        inputmode: "numeric",
                        prefillYear: !0
                    }
                });
            },
            1313: function(e, t, n) {
                var i, a = (i = n(2394)) && i.__esModule ? i : {
                    default: i
                };
                a.default.dependencyLib.extend(!0, a.default.prototype.i18n, {
                    dayNames: [ "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday" ],
                    monthNames: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
                    ordinalSuffix: [ "st", "nd", "rd", "th" ]
                });
            },
            3851: function(e, t, n) {
                var i, a = (i = n(2394)) && i.__esModule ? i : {
                    default: i
                }, r = n(8711), o = n(4713);
                function l(e) {
                    return function(e) {
                        if (Array.isArray(e)) return s(e);
                    }(e) || function(e) {
                        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                    }(e) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return s(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === n && e.constructor && (n = e.constructor.name);
                        if ("Map" === n || "Set" === n) return Array.from(e);
                        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s(e, t);
                    }(e) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function s(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                a.default.extendDefinitions({
                    A: {
                        validator: "[A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
                        casing: "upper"
                    },
                    "&": {
                        validator: "[0-9A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5]",
                        casing: "upper"
                    },
                    "#": {
                        validator: "[0-9A-Fa-f]",
                        casing: "upper"
                    }
                });
                var c = /25[0-5]|2[0-4][0-9]|[01][0-9][0-9]/;
                function u(e, t, n, i, a) {
                    if (n - 1 > -1 && "." !== t.buffer[n - 1] ? (e = t.buffer[n - 1] + e, e = n - 2 > -1 && "." !== t.buffer[n - 2] ? t.buffer[n - 2] + e : "0" + e) : e = "00" + e, 
                    a.greedy && parseInt(e) > 255 && c.test("00" + e.charAt(2))) {
                        var r = [].concat(l(t.buffer.slice(0, n)), [ ".", e.charAt(2) ]);
                        if (r.join("").match(/\./g).length < 4) return {
                            refreshFromBuffer: !0,
                            buffer: r,
                            caret: n + 2
                        };
                    }
                    return c.test(e);
                }
                a.default.extendAliases({
                    cssunit: {
                        regex: "[+-]?[0-9]+\\.?([0-9]+)?(px|em|rem|ex|%|in|cm|mm|pt|pc)"
                    },
                    url: {
                        regex: "(https?|ftp)://.*",
                        autoUnmask: !1,
                        keepStatic: !1,
                        tabThrough: !0
                    },
                    ip: {
                        mask: "i{1,3}.j{1,3}.k{1,3}.l{1,3}",
                        definitions: {
                            i: {
                                validator: u
                            },
                            j: {
                                validator: u
                            },
                            k: {
                                validator: u
                            },
                            l: {
                                validator: u
                            }
                        },
                        onUnMask: function(e, t, n) {
                            return e;
                        },
                        inputmode: "decimal",
                        substitutes: {
                            ",": "."
                        }
                    },
                    email: {
                        mask: function(e) {
                            var t = e.separator, n = e.quantifier, i = "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]", a = i;
                            if (t) for (var r = 0; r < n; r++) a += "[".concat(t).concat(i, "]");
                            return a;
                        },
                        greedy: !1,
                        casing: "lower",
                        separator: null,
                        quantifier: 5,
                        skipOptionalPartCharacter: "",
                        onBeforePaste: function(e, t) {
                            return (e = e.toLowerCase()).replace("mailto:", "");
                        },
                        definitions: {
                            "*": {
                                validator: "[0-9\uff11-\uff19A-Za-z\u0410-\u044f\u0401\u0451\xc0-\xff\xb5!#$%&'*+/=?^_`{|}~-]"
                            },
                            "-": {
                                validator: "[0-9A-Za-z-]"
                            }
                        },
                        onUnMask: function(e, t, n) {
                            return e;
                        },
                        inputmode: "email"
                    },
                    mac: {
                        mask: "##:##:##:##:##:##"
                    },
                    vin: {
                        mask: "V{13}9{4}",
                        definitions: {
                            V: {
                                validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
                                casing: "upper"
                            }
                        },
                        clearIncomplete: !0,
                        autoUnmask: !0
                    },
                    ssn: {
                        mask: "999-99-9999",
                        postValidation: function(e, t, n, i, a, l, s) {
                            var c = o.getMaskTemplate.call(this, !0, r.getLastValidPosition.call(this), !0, !0);
                            return /^(?!219-09-9999|078-05-1120)(?!666|000|9.{2}).{3}-(?!00).{2}-(?!0{4}).{4}$/.test(c.join(""));
                        }
                    }
                });
            },
            207: function(e, t, n) {
                var i = l(n(7184)), a = l(n(2394)), r = n(2839), o = n(8711);
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var s = a.default.dependencyLib;
                function c(e, t) {
                    for (var n = "", i = 0; i < e.length; i++) a.default.prototype.definitions[e.charAt(i)] || t.definitions[e.charAt(i)] || t.optionalmarker[0] === e.charAt(i) || t.optionalmarker[1] === e.charAt(i) || t.quantifiermarker[0] === e.charAt(i) || t.quantifiermarker[1] === e.charAt(i) || t.groupmarker[0] === e.charAt(i) || t.groupmarker[1] === e.charAt(i) || t.alternatormarker === e.charAt(i) ? n += "\\" + e.charAt(i) : n += e.charAt(i);
                    return n;
                }
                function u(e, t, n, i) {
                    if (e.length > 0 && t > 0 && (!n.digitsOptional || i)) {
                        var a = e.indexOf(n.radixPoint), r = !1;
                        n.negationSymbol.back === e[e.length - 1] && (r = !0, e.length--), -1 === a && (e.push(n.radixPoint), 
                        a = e.length - 1);
                        for (var o = 1; o <= t; o++) isFinite(e[a + o]) || (e[a + o] = "0");
                    }
                    return r && e.push(n.negationSymbol.back), e;
                }
                function f(e, t) {
                    var n = 0;
                    for (var i in "+" === e && (n = o.seekNext.call(this, t.validPositions.length - 1)), 
                    t.tests) if ((i = parseInt(i)) >= n) for (var a = 0, r = t.tests[i].length; a < r; a++) if ((void 0 === t.validPositions[i] || "-" === e) && t.tests[i][a].match.def === e) return i + (void 0 !== t.validPositions[i] && "-" !== e ? 1 : 0);
                    return n;
                }
                function p(e, t) {
                    for (var n = -1, i = 0, a = t.validPositions.length; i < a; i++) {
                        var r = t.validPositions[i];
                        if (r && r.match.def === e) {
                            n = i;
                            break;
                        }
                    }
                    return n;
                }
                function d(e, t, n, i, a) {
                    var r = t.buffer ? t.buffer.indexOf(a.radixPoint) : -1, o = (-1 !== r || i && a.jitMasking) && new RegExp(a.definitions[9].validator).test(e);
                    return !i && a._radixDance && -1 !== r && o && null == t.validPositions[r] ? {
                        insert: {
                            pos: r === n ? r + 1 : r,
                            c: a.radixPoint
                        },
                        pos: n
                    } : o;
                }
                a.default.extendAliases({
                    numeric: {
                        mask: function(e) {
                            e.repeat = 0, e.groupSeparator === e.radixPoint && e.digits && "0" !== e.digits && ("." === e.radixPoint ? e.groupSeparator = "," : "," === e.radixPoint ? e.groupSeparator = "." : e.groupSeparator = ""), 
                            " " === e.groupSeparator && (e.skipOptionalPartCharacter = void 0), e.placeholder.length > 1 && (e.placeholder = e.placeholder.charAt(0)), 
                            "radixFocus" === e.positionCaretOnClick && "" === e.placeholder && (e.positionCaretOnClick = "lvp");
                            var t = "0", n = e.radixPoint;
                            !0 === e.numericInput && void 0 === e.__financeInput ? (t = "1", e.positionCaretOnClick = "radixFocus" === e.positionCaretOnClick ? "lvp" : e.positionCaretOnClick, 
                            e.digitsOptional = !1, isNaN(e.digits) && (e.digits = 2), e._radixDance = !1, n = "," === e.radixPoint ? "?" : "!", 
                            "" !== e.radixPoint && void 0 === e.definitions[n] && (e.definitions[n] = {}, e.definitions[n].validator = "[" + e.radixPoint + "]", 
                            e.definitions[n].placeholder = e.radixPoint, e.definitions[n].static = !0, e.definitions[n].generated = !0)) : (e.__financeInput = !1, 
                            e.numericInput = !0);
                            var a, r = "[+]";
                            if (r += c(e.prefix, e), "" !== e.groupSeparator ? (void 0 === e.definitions[e.groupSeparator] && (e.definitions[e.groupSeparator] = {}, 
                            e.definitions[e.groupSeparator].validator = "[" + e.groupSeparator + "]", e.definitions[e.groupSeparator].placeholder = e.groupSeparator, 
                            e.definitions[e.groupSeparator].static = !0, e.definitions[e.groupSeparator].generated = !0), 
                            r += e._mask(e)) : r += "9{+}", void 0 !== e.digits && 0 !== e.digits) {
                                var o = e.digits.toString().split(",");
                                isFinite(o[0]) && o[1] && isFinite(o[1]) ? r += n + t + "{" + e.digits + "}" : (isNaN(e.digits) || parseInt(e.digits) > 0) && (e.digitsOptional || e.jitMasking ? (a = r + n + t + "{0," + e.digits + "}", 
                                e.keepStatic = !0) : r += n + t + "{" + e.digits + "}");
                            } else e.inputmode = "numeric";
                            return r += c(e.suffix, e), r += "[-]", a && (r = [ a + c(e.suffix, e) + "[-]", r ]), 
                            e.greedy = !1, function(e) {
                                void 0 === e.parseMinMaxOptions && (null !== e.min && (e.min = e.min.toString().replace(new RegExp((0, i.default)(e.groupSeparator), "g"), ""), "," === e.radixPoint && (e.min = e.min.replace(e.radixPoint, ".")), 
                                e.min = isFinite(e.min) ? parseFloat(e.min) : NaN, isNaN(e.min) && (e.min = Number.MIN_VALUE)), 
                                null !== e.max && (e.max = e.max.toString().replace(new RegExp((0, i.default)(e.groupSeparator), "g"), ""), 
                                "," === e.radixPoint && (e.max = e.max.replace(e.radixPoint, ".")), e.max = isFinite(e.max) ? parseFloat(e.max) : NaN, 
                                isNaN(e.max) && (e.max = Number.MAX_VALUE)), e.parseMinMaxOptions = "done");
                            }(e), "" !== e.radixPoint && e.substituteRadixPoint && (e.substitutes["." == e.radixPoint ? "," : "."] = e.radixPoint), 
                            r;
                        },
                        _mask: function(e) {
                            return "(" + e.groupSeparator + "999){+|1}";
                        },
                        digits: "*",
                        digitsOptional: !0,
                        enforceDigitsOnBlur: !1,
                        radixPoint: ".",
                        positionCaretOnClick: "radixFocus",
                        _radixDance: !0,
                        groupSeparator: "",
                        allowMinus: !0,
                        negationSymbol: {
                            front: "-",
                            back: ""
                        },
                        prefix: "",
                        suffix: "",
                        min: null,
                        max: null,
                        SetMaxOnOverflow: !1,
                        step: 1,
                        inputType: "text",
                        unmaskAsNumber: !1,
                        roundingFN: Math.round,
                        inputmode: "decimal",
                        shortcuts: {
                            k: "1000",
                            m: "1000000"
                        },
                        placeholder: "0",
                        greedy: !1,
                        rightAlign: !0,
                        insertMode: !0,
                        autoUnmask: !1,
                        skipOptionalPartCharacter: "",
                        usePrototypeDefinitions: !1,
                        stripLeadingZeroes: !0,
                        substituteRadixPoint: !0,
                        definitions: {
                            0: {
                                validator: d
                            },
                            1: {
                                validator: d,
                                definitionSymbol: "9"
                            },
                            9: {
                                validator: "[0-9\uff10-\uff19\u0660-\u0669\u06f0-\u06f9]",
                                definitionSymbol: "*"
                            },
                            "+": {
                                validator: function(e, t, n, i, a) {
                                    return a.allowMinus && ("-" === e || e === a.negationSymbol.front);
                                }
                            },
                            "-": {
                                validator: function(e, t, n, i, a) {
                                    return a.allowMinus && e === a.negationSymbol.back;
                                }
                            }
                        },
                        preValidation: function(e, t, n, i, a, r, o, l) {
                            var s = this;
                            if (!1 !== a.__financeInput && n === a.radixPoint) return !1;
                            var c = e.indexOf(a.radixPoint), u = t;
                            if (t = function(e, t, n, i, a) {
                                return a._radixDance && a.numericInput && t !== a.negationSymbol.back && e <= n && (n > 0 || t == a.radixPoint) && (void 0 === i.validPositions[e - 1] || i.validPositions[e - 1].input !== a.negationSymbol.back) && (e -= 1), 
                                e;
                            }(t, n, c, r, a), "-" === n || n === a.negationSymbol.front) {
                                if (!0 !== a.allowMinus) return !1;
                                var d = !1, h = p("+", r), v = p("-", r);
                                return -1 !== h && (d = [ h ], -1 !== v && d.push(v)), !1 !== d ? {
                                    remove: d,
                                    caret: u - a.negationSymbol.back.length
                                } : {
                                    insert: [ {
                                        pos: f.call(s, "+", r),
                                        c: a.negationSymbol.front,
                                        fromIsValid: !0
                                    }, {
                                        pos: f.call(s, "-", r),
                                        c: a.negationSymbol.back,
                                        fromIsValid: void 0
                                    } ],
                                    caret: u + a.negationSymbol.back.length
                                };
                            }
                            if (n === a.groupSeparator) return {
                                caret: u
                            };
                            if (l) return !0;
                            if (-1 !== c && !0 === a._radixDance && !1 === i && n === a.radixPoint && void 0 !== a.digits && (isNaN(a.digits) || parseInt(a.digits) > 0) && c !== t) {
                                var m = f.call(s, a.radixPoint, r);
                                return r.validPositions[m] && (r.validPositions[m].generatedInput = r.validPositions[m].generated || !1), 
                                {
                                    caret: a._radixDance && t === c - 1 ? c + 1 : c
                                };
                            }
                            if (!1 === a.__financeInput) if (i) {
                                if (a.digitsOptional) return {
                                    rewritePosition: o.end
                                };
                                if (!a.digitsOptional) {
                                    if (o.begin > c && o.end <= c) return n === a.radixPoint ? {
                                        insert: {
                                            pos: c + 1,
                                            c: "0",
                                            fromIsValid: !0
                                        },
                                        rewritePosition: c
                                    } : {
                                        rewritePosition: c + 1
                                    };
                                    if (o.begin < c) return {
                                        rewritePosition: o.begin - 1
                                    };
                                }
                            } else if (!a.showMaskOnHover && !a.showMaskOnFocus && !a.digitsOptional && a.digits > 0 && "" === this.__valueGet.call(this.el)) return {
                                rewritePosition: c
                            };
                            return {
                                rewritePosition: t
                            };
                        },
                        postValidation: function(e, t, n, i, a, r, o) {
                            if (!1 === i) return i;
                            if (o) return !0;
                            if (null !== a.min || null !== a.max) {
                                var l = a.onUnMask(e.slice().reverse().join(""), void 0, s.extend({}, a, {
                                    unmaskAsNumber: !0
                                }));
                                if (null !== a.min && l < a.min && (l.toString().length > a.min.toString().length || l < 0)) return !1;
                                if (null !== a.max && l > a.max) return !!a.SetMaxOnOverflow && {
                                    refreshFromBuffer: !0,
                                    buffer: u(a.max.toString().replace(".", a.radixPoint).split(""), a.digits, a).reverse()
                                };
                            }
                            return i;
                        },
                        onUnMask: function(e, t, n) {
                            if ("" === t && !0 === n.nullable) return t;
                            var a = e.replace(n.prefix, "");
                            return a = (a = a.replace(n.suffix, "")).replace(new RegExp((0, i.default)(n.groupSeparator), "g"), ""), 
                            "" !== n.placeholder.charAt(0) && (a = a.replace(new RegExp(n.placeholder.charAt(0), "g"), "0")), 
                            n.unmaskAsNumber ? ("" !== n.radixPoint && -1 !== a.indexOf(n.radixPoint) && (a = a.replace(i.default.call(this, n.radixPoint), ".")), 
                            a = (a = a.replace(new RegExp("^" + (0, i.default)(n.negationSymbol.front)), "-")).replace(new RegExp((0, i.default)(n.negationSymbol.back) + "$"), ""), Number(a)) : a;
                        },
                        isComplete: function(e, t) {
                            var n = (t.numericInput ? e.slice().reverse() : e).join("");
                            return n = (n = (n = (n = (n = n.replace(new RegExp("^" + (0, i.default)(t.negationSymbol.front)), "-")).replace(new RegExp((0, i.default)(t.negationSymbol.back) + "$"), "")).replace(t.prefix, "")).replace(t.suffix, "")).replace(new RegExp((0, i.default)(t.groupSeparator) + "([0-9]{3})", "g"), "$1"), "," === t.radixPoint && (n = n.replace((0, i.default)(t.radixPoint), ".")), isFinite(n);
                        },
                        onBeforeMask: function(e, t) {
                            var n;
                            e = null !== (n = e) && void 0 !== n ? n : "";
                            var a = t.radixPoint || ",";
                            isFinite(t.digits) && (t.digits = parseInt(t.digits)), "number" != typeof e && "number" !== t.inputType || "" === a || (e = e.toString().replace(".", a));
                            var r = "-" === e.charAt(0) || e.charAt(0) === t.negationSymbol.front, o = e.split(a), l = o[0].replace(/[^\-0-9]/g, ""), s = o.length > 1 ? o[1].replace(/[^0-9]/g, "") : "", c = o.length > 1;
                            e = l + ("" !== s ? a + s : s);
                            var f = 0;
                            if ("" !== a && (f = t.digitsOptional ? t.digits < s.length ? t.digits : s.length : t.digits, 
                            "" !== s || !t.digitsOptional)) {
                                var p = Math.pow(10, f || 1);
                                e = e.replace((0, i.default)(a), "."), isNaN(parseFloat(e)) || (e = (t.roundingFN(parseFloat(e) * p) / p).toFixed(f)), 
                                e = e.toString().replace(".", a);
                            }
                            if (0 === t.digits && -1 !== e.indexOf(a) && (e = e.substring(0, e.indexOf(a))), 
                            null !== t.min || null !== t.max) {
                                var d = e.toString().replace(a, ".");
                                null !== t.min && d < t.min ? e = t.min.toString().replace(".", a) : null !== t.max && d > t.max && (e = t.max.toString().replace(".", a));
                            }
                            return r && "-" !== e.charAt(0) && (e = "-" + e), u(e.toString().split(""), f, t, c).join("");
                        },
                        onBeforeWrite: function(e, t, n, a) {
                            function r(e, t) {
                                if (!1 !== a.__financeInput || t) {
                                    var n = e.indexOf(a.radixPoint);
                                    -1 !== n && e.splice(n, 1);
                                }
                                if ("" !== a.groupSeparator) for (;-1 !== (n = e.indexOf(a.groupSeparator)); ) e.splice(n, 1);
                                return e;
                            }
                            var o, l;
                            if (a.stripLeadingZeroes && (l = function(e, t) {
                                var n = new RegExp("(^" + ("" !== t.negationSymbol.front ? (0, i.default)(t.negationSymbol.front) + "?" : "") + (0, i.default)(t.prefix) + ")(.*)(" + (0, i.default)(t.suffix) + ("" != t.negationSymbol.back ? (0, i.default)(t.negationSymbol.back) + "?" : "") + "$)").exec(e.slice().reverse().join("")), a = n ? n[2] : "", r = !1;
                                return a && (a = a.split(t.radixPoint.charAt(0))[0], r = new RegExp("^[0" + t.groupSeparator + "]*").exec(a)), 
                                !(!r || !(r[0].length > 1 || r[0].length > 0 && r[0].length < a.length)) && r;
                            }(t, a))) for (var c = t.join("").lastIndexOf(l[0].split("").reverse().join("")) - (l[0] == l.input ? 0 : 1), f = l[0] == l.input ? 1 : 0, p = l[0].length - f; p > 0; p--) this.maskset.validPositions.splice(c + p, 1), 
                            delete t[c + p];
                            if (e) switch (e.type) {
                              case "blur":
                              case "checkval":
                                if (null !== a.min) {
                                    var d = a.onUnMask(t.slice().reverse().join(""), void 0, s.extend({}, a, {
                                        unmaskAsNumber: !0
                                    }));
                                    if (null !== a.min && d < a.min) return {
                                        refreshFromBuffer: !0,
                                        buffer: u(a.min.toString().replace(".", a.radixPoint).split(""), a.digits, a).reverse()
                                    };
                                }
                                if (t[t.length - 1] === a.negationSymbol.front) {
                                    var h = new RegExp("(^" + ("" != a.negationSymbol.front ? (0, i.default)(a.negationSymbol.front) + "?" : "") + (0, i.default)(a.prefix) + ")(.*)(" + (0, i.default)(a.suffix) + ("" != a.negationSymbol.back ? (0, i.default)(a.negationSymbol.back) + "?" : "") + "$)").exec(r(t.slice(), !0).reverse().join(""));
                                    0 == (h ? h[2] : "") && (o = {
                                        refreshFromBuffer: !0,
                                        buffer: [ 0 ]
                                    });
                                } else if ("" !== a.radixPoint) {
                                    t.indexOf(a.radixPoint) === a.suffix.length && (o && o.buffer ? o.buffer.splice(0, 1 + a.suffix.length) : (t.splice(0, 1 + a.suffix.length), 
                                    o = {
                                        refreshFromBuffer: !0,
                                        buffer: r(t)
                                    }));
                                }
                                if (a.enforceDigitsOnBlur) {
                                    var v = (o = o || {}) && o.buffer || t.slice().reverse();
                                    o.refreshFromBuffer = !0, o.buffer = u(v, a.digits, a, !0).reverse();
                                }
                            }
                            return o;
                        },
                        onKeyDown: function(e, t, n, i) {
                            var a, o = s(this);
                            if (3 != e.location) {
                                var l, c = e.key;
                                if ((l = i.shortcuts && i.shortcuts[c]) && l.length > 1) return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) * parseInt(l)), 
                                o.trigger("setvalue"), !1;
                            }
                            if (e.ctrlKey) switch (e.key) {
                              case r.keys.ArrowUp:
                                return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) + parseInt(i.step)), 
                                o.trigger("setvalue"), !1;

                              case r.keys.ArrowDown:
                                return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) - parseInt(i.step)), 
                                o.trigger("setvalue"), !1;
                            }
                            if (!e.shiftKey && (e.key === r.keys.Delete || e.key === r.keys.Backspace || e.key === r.keys.BACKSPACE_SAFARI) && n.begin !== t.length) {
                                if (t[e.key === r.keys.Delete ? n.begin - 1 : n.end] === i.negationSymbol.front) return a = t.slice().reverse(), 
                                "" !== i.negationSymbol.front && a.shift(), "" !== i.negationSymbol.back && a.pop(), 
                                o.trigger("setvalue", [ a.join(""), n.begin ]), !1;
                                if (!0 === i._radixDance) {
                                    var f, p = t.indexOf(i.radixPoint);
                                    if (i.digitsOptional) {
                                        if (0 === p) return (a = t.slice().reverse()).pop(), o.trigger("setvalue", [ a.join(""), n.begin >= a.length ? a.length : n.begin ]), 
                                        !1;
                                    } else if (-1 !== p && (n.begin < p || n.end < p || e.key === r.keys.Delete && (n.begin === p || n.begin - 1 === p))) return n.begin === n.end && (e.key === r.keys.Backspace || e.key === r.keys.BACKSPACE_SAFARI ? n.begin++ : e.key === r.keys.Delete && n.begin - 1 === p && (f = s.extend({}, n), 
                                    n.begin--, n.end--)), (a = t.slice().reverse()).splice(a.length - n.begin, n.begin - n.end + 1), 
                                    a = u(a, i.digits, i).join(""), f && (n = f), o.trigger("setvalue", [ a, n.begin >= a.length ? p + 1 : n.begin ]), 
                                    !1;
                                }
                            }
                        }
                    },
                    currency: {
                        prefix: "",
                        groupSeparator: ",",
                        alias: "numeric",
                        digits: 2,
                        digitsOptional: !1
                    },
                    decimal: {
                        alias: "numeric"
                    },
                    integer: {
                        alias: "numeric",
                        inputmode: "numeric",
                        digits: 0
                    },
                    percentage: {
                        alias: "numeric",
                        min: 0,
                        max: 100,
                        suffix: " %",
                        digits: 0,
                        allowMinus: !1
                    },
                    indianns: {
                        alias: "numeric",
                        _mask: function(e) {
                            return "(" + e.groupSeparator + "99){*|1}(" + e.groupSeparator + "999){1|1}";
                        },
                        groupSeparator: ",",
                        radixPoint: ".",
                        placeholder: "0",
                        digits: 2,
                        digitsOptional: !1
                    }
                });
            },
            9380: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = !("undefined" == typeof window || !window.document || !window.document.createElement);
                t.default = n ? window : {};
            },
            7760: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HandleNativePlaceholder = function(e, t) {
                    var n = e ? e.inputmask : this;
                    if (i.ie) {
                        if (e.inputmask._valueGet() !== t && (e.placeholder !== t || "" === e.placeholder)) {
                            var a = o.getBuffer.call(n).slice(), r = e.inputmask._valueGet();
                            if (r !== t) {
                                var l = o.getLastValidPosition.call(n);
                                -1 === l && r === o.getBufferTemplate.call(n).join("") ? a = [] : -1 !== l && u.call(n, a), 
                                p(e, a);
                            }
                        }
                    } else e.placeholder !== t && (e.placeholder = t, "" === e.placeholder && e.removeAttribute("placeholder"));
                }, t.applyInputValue = c, t.checkVal = f, t.clearOptionalTail = u, t.unmaskedvalue = function(e) {
                    var t = e ? e.inputmask : this, n = t.opts, i = t.maskset;
                    if (e) {
                        if (void 0 === e.inputmask) return e.value;
                        e.inputmask && e.inputmask.refreshValue && c(e, e.inputmask._valueGet(!0));
                    }
                    for (var a = [], r = i.validPositions, l = 0, s = r.length; l < s; l++) r[l] && r[l].match && (1 != r[l].match.static || Array.isArray(i.metadata) && !0 !== r[l].generatedInput) && a.push(r[l].input);
                    var u = 0 === a.length ? "" : (t.isRTL ? a.reverse() : a).join("");
                    if ("function" == typeof n.onUnMask) {
                        var f = (t.isRTL ? o.getBuffer.call(t).slice().reverse() : o.getBuffer.call(t)).join("");
                        u = n.onUnMask.call(t, f, u, n);
                    }
                    return u;
                }, t.writeBuffer = p;
                var i = n(9845), a = n(6030), r = n(2839), o = n(8711), l = n(7215), s = n(4713);
                function c(e, t, n) {
                    var i = e ? e.inputmask : this, a = i.opts;
                    e.inputmask.refreshValue = !1, "function" == typeof a.onBeforeMask && (t = a.onBeforeMask.call(i, t, a) || t), 
                    f(e, !0, !1, t = (t || "").toString().split(""), n), i.undoValue = i._valueGet(!0), 
                    (a.clearMaskOnLostFocus || a.clearIncomplete) && e.inputmask._valueGet() === o.getBufferTemplate.call(i).join("") && -1 === o.getLastValidPosition.call(i) && e.inputmask._valueSet("");
                }
                function u(e) {
                    e.length = 0;
                    for (var t, n = s.getMaskTemplate.call(this, !0, 0, !0, void 0, !0); void 0 !== (t = n.shift()); ) e.push(t);
                    return e;
                }
                function f(e, t, n, i, r) {
                    var c, u = e ? e.inputmask : this, f = u.maskset, d = u.opts, h = u.dependencyLib, v = i.slice(), m = "", g = -1, y = d.skipOptionalPartCharacter;
                    d.skipOptionalPartCharacter = "", o.resetMaskSet.call(u, !1), u.clicked = 0, g = d.radixPoint ? o.determineNewCaretPosition.call(u, {
                        begin: 0,
                        end: 0
                    }, !1, !1 === d.__financeInput ? "radixFocus" : void 0).begin : 0, f.p = g, u.caretPos = {
                        begin: g
                    };
                    var k = [], b = u.caretPos;
                    if (v.forEach((function(e, t) {
                        if (void 0 !== e) {
                            var i = new h.Event("_checkval");
                            i.key = e, m += e;
                            var r = o.getLastValidPosition.call(u, void 0, !0);
                            !function(e, t) {
                                for (var n = s.getMaskTemplate.call(u, !0, 0).slice(e, o.seekNext.call(u, e, !1, !1)).join("").replace(/'/g, ""), i = n.indexOf(t); i > 0 && " " === n[i - 1]; ) i--;
                                var a = 0 === i && !o.isMask.call(u, e) && (s.getTest.call(u, e).match.nativeDef === t.charAt(0) || !0 === s.getTest.call(u, e).match.static && s.getTest.call(u, e).match.nativeDef === "'" + t.charAt(0) || " " === s.getTest.call(u, e).match.nativeDef && (s.getTest.call(u, e + 1).match.nativeDef === t.charAt(0) || !0 === s.getTest.call(u, e + 1).match.static && s.getTest.call(u, e + 1).match.nativeDef === "'" + t.charAt(0)));
                                if (!a && i > 0 && !o.isMask.call(u, e, !1, !0)) {
                                    var r = o.seekNext.call(u, e);
                                    u.caretPos.begin < r && (u.caretPos = {
                                        begin: r
                                    });
                                }
                                return a;
                            }(g, m) ? (c = a.EventHandlers.keypressEvent.call(u, i, !0, !1, n, u.caretPos.begin)) && (g = u.caretPos.begin + 1, 
                            m = "") : c = a.EventHandlers.keypressEvent.call(u, i, !0, !1, n, r + 1), c ? (void 0 !== c.pos && f.validPositions[c.pos] && !0 === f.validPositions[c.pos].match.static && void 0 === f.validPositions[c.pos].alternation && (k.push(c.pos), 
                            u.isRTL || (c.forwardPosition = c.pos + 1)), p.call(u, void 0, o.getBuffer.call(u), c.forwardPosition, i, !1), 
                            u.caretPos = {
                                begin: c.forwardPosition,
                                end: c.forwardPosition
                            }, b = u.caretPos) : void 0 === f.validPositions[t] && v[t] === s.getPlaceholder.call(u, t) && o.isMask.call(u, t, !0) ? u.caretPos.begin++ : u.caretPos = b;
                        }
                    })), k.length > 0) {
                        var x, w, P = o.seekNext.call(u, -1, void 0, !1);
                        if (!l.isComplete.call(u, o.getBuffer.call(u)) && k.length <= P || l.isComplete.call(u, o.getBuffer.call(u)) && k.length > 0 && k.length !== P && 0 === k[0]) for (var S = P; void 0 !== (x = k.shift()); ) if (x < S) {
                            var O = new h.Event("_checkval");
                            if ((w = f.validPositions[x]).generatedInput = !0, O.key = w.input, (c = a.EventHandlers.keypressEvent.call(u, O, !0, !1, n, S)) && void 0 !== c.pos && c.pos !== x && f.validPositions[c.pos] && !0 === f.validPositions[c.pos].match.static) k.push(c.pos); else if (!c) break;
                            S++;
                        }
                    }
                    t && p.call(u, e, o.getBuffer.call(u), c ? c.forwardPosition : u.caretPos.begin, r || new h.Event("checkval"), r && ("input" === r.type && u.undoValue !== o.getBuffer.call(u).join("") || "paste" === r.type)), 
                    d.skipOptionalPartCharacter = y;
                }
                function p(e, t, n, i, a) {
                    var s = e ? e.inputmask : this, c = s.opts, u = s.dependencyLib;
                    if (i && "function" == typeof c.onBeforeWrite) {
                        var f = c.onBeforeWrite.call(s, i, t, n, c);
                        if (f) {
                            if (f.refreshFromBuffer) {
                                var p = f.refreshFromBuffer;
                                l.refreshFromBuffer.call(s, !0 === p ? p : p.start, p.end, f.buffer || t), t = o.getBuffer.call(s, !0);
                            }
                            void 0 !== n && (n = void 0 !== f.caret ? f.caret : n);
                        }
                    }
                    if (void 0 !== e && (e.inputmask._valueSet(t.join("")), void 0 === n || void 0 !== i && "blur" === i.type || o.caret.call(s, e, n, void 0, void 0, void 0 !== i && "keydown" === i.type && (i.key === r.keys.Delete || i.key === r.keys.Backspace)), 
                    void 0 === e.inputmask.writeBufferHook || e.inputmask.writeBufferHook(n), !0 === a)) {
                        var d = u(e), h = e.inputmask._valueGet();
                        e.inputmask.skipInputEvent = !0, d.trigger("input"), setTimeout((function() {
                            h === o.getBufferTemplate.call(s).join("") ? d.trigger("cleared") : !0 === l.isComplete.call(s, t) && d.trigger("complete");
                        }), 0);
                    }
                }
            },
            2394: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = v(n(3976)), a = v(n(7392)), r = v(n(4963)), o = n(9716), l = v(n(9380)), s = n(7760), c = n(157), u = n(2391), f = n(8711), p = n(7215), d = n(4713);
                function h(e) {
                    return h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, h(e);
                }
                function v(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var m = l.default.document, g = "_inputmask_opts";
                function y(e, t, n) {
                    if (!(this instanceof y)) return new y(e, t, n);
                    this.dependencyLib = r.default, this.el = void 0, this.events = {}, this.maskset = void 0, 
                    !0 !== n && ("[object Object]" === Object.prototype.toString.call(e) ? t = e : (t = t || {}, 
                    e && (t.alias = e)), this.opts = r.default.extend(!0, {}, this.defaults, t), this.noMasksCache = t && void 0 !== t.definitions, 
                    this.userOptions = t || {}, k(this.opts.alias, t, this.opts)), this.refreshValue = !1, 
                    this.undoValue = void 0, this.$el = void 0, this.skipInputEvent = !1, this.validationEvent = !1, 
                    this.ignorable = !1, this.mouseEnter = !1, this.clicked = 0, this.originalPlaceholder = void 0, 
                    this.isComposing = !1, this.hasAlternator = !1;
                }
                function k(e, t, n) {
                    var i = y.prototype.aliases[e];
                    return i ? (i.alias && k(i.alias, void 0, n), r.default.extend(!0, n, i), r.default.extend(!0, n, t), 
                    !0) : (null === n.mask && (n.mask = e), !1);
                }
                y.prototype = {
                    dataAttribute: "data-inputmask",
                    defaults: i.default,
                    definitions: a.default,
                    aliases: {},
                    masksCache: {},
                    i18n: {},
                    get isRTL() {
                        return this.opts.isRTL || this.opts.numericInput;
                    },
                    mask: function(e) {
                        var t = this;
                        return "string" == typeof e && (e = m.getElementById(e) || m.querySelectorAll(e)), 
                        (e = e.nodeName ? [ e ] : Array.isArray(e) ? e : [].slice.call(e)).forEach((function(e, n) {
                            var i = r.default.extend(!0, {}, t.opts);
                            if (function(e, t, n, i) {
                                function a(t, a) {
                                    var r = "" === i ? t : i + "-" + t;
                                    null !== (a = void 0 !== a ? a : e.getAttribute(r)) && ("string" == typeof a && (0 === t.indexOf("on") ? a = l.default[a] : "false" === a ? a = !1 : "true" === a && (a = !0)), 
                                    n[t] = a);
                                }
                                if (!0 === t.importDataAttributes) {
                                    var o, s, c, u, f = e.getAttribute(i);
                                    if (f && "" !== f && (f = f.replace(/'/g, '"'), s = JSON.parse("{" + f + "}")), 
                                    s) for (u in c = void 0, s) if ("alias" === u.toLowerCase()) {
                                        c = s[u];
                                        break;
                                    }
                                    for (o in a("alias", c), n.alias && k(n.alias, n, t), t) {
                                        if (s) for (u in c = void 0, s) if (u.toLowerCase() === o.toLowerCase()) {
                                            c = s[u];
                                            break;
                                        }
                                        a(o, c);
                                    }
                                }
                                r.default.extend(!0, t, n), ("rtl" === e.dir || t.rightAlign) && (e.style.textAlign = "right");
                                ("rtl" === e.dir || t.numericInput) && (e.dir = "ltr", e.removeAttribute("dir"), 
                                t.isRTL = !0);
                                return Object.keys(n).length;
                            }(e, i, r.default.extend(!0, {}, t.userOptions), t.dataAttribute)) {
                                var a = (0, u.generateMaskSet)(i, t.noMasksCache);
                                void 0 !== a && (void 0 !== e.inputmask && (e.inputmask.opts.autoUnmask = !0, e.inputmask.remove()), 
                                e.inputmask = new y(void 0, void 0, !0), e.inputmask.opts = i, e.inputmask.noMasksCache = t.noMasksCache, 
                                e.inputmask.userOptions = r.default.extend(!0, {}, t.userOptions), e.inputmask.el = e, 
                                e.inputmask.$el = (0, r.default)(e), e.inputmask.maskset = a, r.default.data(e, g, t.userOptions), 
                                c.mask.call(e.inputmask));
                            }
                        })), e && e[0] && e[0].inputmask || this;
                    },
                    option: function(e, t) {
                        return "string" == typeof e ? this.opts[e] : "object" === h(e) ? (r.default.extend(this.userOptions, e), 
                        this.el && !0 !== t && this.mask(this.el), this) : void 0;
                    },
                    unmaskedvalue: function(e) {
                        if (this.maskset = this.maskset || (0, u.generateMaskSet)(this.opts, this.noMasksCache), 
                        void 0 === this.el || void 0 !== e) {
                            var t = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                            s.checkVal.call(this, void 0, !1, !1, t), "function" == typeof this.opts.onBeforeWrite && this.opts.onBeforeWrite.call(this, void 0, f.getBuffer.call(this), 0, this.opts);
                        }
                        return s.unmaskedvalue.call(this, this.el);
                    },
                    remove: function() {
                        if (this.el) {
                            r.default.data(this.el, g, null);
                            var e = this.opts.autoUnmask ? (0, s.unmaskedvalue)(this.el) : this._valueGet(this.opts.autoUnmask);
                            e !== f.getBufferTemplate.call(this).join("") ? this._valueSet(e, this.opts.autoUnmask) : this._valueSet(""), 
                            o.EventRuler.off(this.el), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this.el), "value") && this.__valueGet && Object.defineProperty(this.el, "value", {
                                get: this.__valueGet,
                                set: this.__valueSet,
                                configurable: !0
                            }) : m.__lookupGetter__ && this.el.__lookupGetter__("value") && this.__valueGet && (this.el.__defineGetter__("value", this.__valueGet), 
                            this.el.__defineSetter__("value", this.__valueSet)), this.el.inputmask = void 0;
                        }
                        return this.el;
                    },
                    getemptymask: function() {
                        return this.maskset = this.maskset || (0, u.generateMaskSet)(this.opts, this.noMasksCache), 
                        (this.isRTL ? f.getBufferTemplate.call(this).reverse() : f.getBufferTemplate.call(this)).join("");
                    },
                    hasMaskedValue: function() {
                        return !this.opts.autoUnmask;
                    },
                    isComplete: function() {
                        return this.maskset = this.maskset || (0, u.generateMaskSet)(this.opts, this.noMasksCache), 
                        p.isComplete.call(this, f.getBuffer.call(this));
                    },
                    getmetadata: function() {
                        if (this.maskset = this.maskset || (0, u.generateMaskSet)(this.opts, this.noMasksCache), 
                        Array.isArray(this.maskset.metadata)) {
                            var e = d.getMaskTemplate.call(this, !0, 0, !1).join("");
                            return this.maskset.metadata.forEach((function(t) {
                                return t.mask !== e || (e = t, !1);
                            })), e;
                        }
                        return this.maskset.metadata;
                    },
                    isValid: function(e) {
                        if (this.maskset = this.maskset || (0, u.generateMaskSet)(this.opts, this.noMasksCache), 
                        e) {
                            var t = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                            s.checkVal.call(this, void 0, !0, !1, t);
                        } else e = this.isRTL ? f.getBuffer.call(this).slice().reverse().join("") : f.getBuffer.call(this).join("");
                        for (var n = f.getBuffer.call(this), i = f.determineLastRequiredPosition.call(this), a = n.length - 1; a > i && !f.isMask.call(this, a); a--) ;
                        return n.splice(i, a + 1 - i), p.isComplete.call(this, n) && e === (this.isRTL ? f.getBuffer.call(this).slice().reverse().join("") : f.getBuffer.call(this).join(""));
                    },
                    format: function(e, t) {
                        this.maskset = this.maskset || (0, u.generateMaskSet)(this.opts, this.noMasksCache);
                        var n = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                        s.checkVal.call(this, void 0, !0, !1, n);
                        var i = this.isRTL ? f.getBuffer.call(this).slice().reverse().join("") : f.getBuffer.call(this).join("");
                        return t ? {
                            value: i,
                            metadata: this.getmetadata()
                        } : i;
                    },
                    setValue: function(e) {
                        this.el && (0, r.default)(this.el).trigger("setvalue", [ e ]);
                    },
                    analyseMask: u.analyseMask
                }, y.extendDefaults = function(e) {
                    r.default.extend(!0, y.prototype.defaults, e);
                }, y.extendDefinitions = function(e) {
                    r.default.extend(!0, y.prototype.definitions, e);
                }, y.extendAliases = function(e) {
                    r.default.extend(!0, y.prototype.aliases, e);
                }, y.format = function(e, t, n) {
                    return y(t).format(e, n);
                }, y.unmask = function(e, t) {
                    return y(t).unmaskedvalue(e);
                }, y.isValid = function(e, t) {
                    return y(t).isValid(e);
                }, y.remove = function(e) {
                    "string" == typeof e && (e = m.getElementById(e) || m.querySelectorAll(e)), (e = e.nodeName ? [ e ] : e).forEach((function(e) {
                        e.inputmask && e.inputmask.remove();
                    }));
                }, y.setValue = function(e, t) {
                    "string" == typeof e && (e = m.getElementById(e) || m.querySelectorAll(e)), (e = e.nodeName ? [ e ] : e).forEach((function(e) {
                        e.inputmask ? e.inputmask.setValue(t) : (0, r.default)(e).trigger("setvalue", [ t ]);
                    }));
                }, y.dependencyLib = r.default, l.default.Inputmask = y;
                t.default = y;
            },
            5296: function(e, t, n) {
                function i(e) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, i(e);
                }
                var a = d(n(9380)), r = d(n(2394));
                function o(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var a = t[n];
                        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), 
                        Object.defineProperty(e, (r = a.key, o = void 0, o = function(e, t) {
                            if ("object" !== i(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var a = n.call(e, t || "default");
                                if ("object" !== i(a)) return a;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(r, "string"), "symbol" === i(o) ? o : String(o)), a);
                    }
                    var r, o;
                }
                function l(e) {
                    var t = u();
                    return function() {
                        var n, a = p(e);
                        if (t) {
                            var r = p(this).constructor;
                            n = Reflect.construct(a, arguments, r);
                        } else n = a.apply(this, arguments);
                        return function(e, t) {
                            if (t && ("object" === i(t) || "function" == typeof t)) return t;
                            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                            return function(e) {
                                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return e;
                            }(e);
                        }(this, n);
                    };
                }
                function s(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return s = function(e) {
                        if (null === e || !function(e) {
                            try {
                                return -1 !== Function.toString.call(e).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e;
                            }
                        }(e)) return e;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, n);
                        }
                        function n() {
                            return c(e, arguments, p(this).constructor);
                        }
                        return n.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), f(n, e);
                    }, s(e);
                }
                function c(e, t, n) {
                    return c = u() ? Reflect.construct.bind() : function(e, t, n) {
                        var i = [ null ];
                        i.push.apply(i, t);
                        var a = new (Function.bind.apply(e, i));
                        return n && f(a, n.prototype), a;
                    }, c.apply(null, arguments);
                }
                function u() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}))), 
                        !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function f(e, t) {
                    return f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                        return e.__proto__ = t, e;
                    }, f(e, t);
                }
                function p(e) {
                    return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, p(e);
                }
                function d(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var h = a.default.document;
                if (h && h.head && h.head.attachShadow && a.default.customElements && void 0 === a.default.customElements.get("input-mask")) {
                    var v = function(e) {
                        !function(e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), Object.defineProperty(e, "prototype", {
                                writable: !1
                            }), t && f(e, t);
                        }(s, e);
                        var t, n, a = l(s);
                        function s() {
                            var e;
                            !function(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }(this, s);
                            var t = (e = a.call(this)).getAttributeNames(), n = e.attachShadow({
                                mode: "closed"
                            });
                            for (var i in e.input = h.createElement("input"), e.input.type = "text", n.appendChild(e.input), 
                            t) Object.prototype.hasOwnProperty.call(t, i) && e.input.setAttribute(t[i], e.getAttribute(t[i]));
                            var o = new r.default;
                            return o.dataAttribute = "", o.mask(e.input), e.input.inputmask.shadowRoot = n, 
                            e;
                        }
                        return t = s, (n = [ {
                            key: "attributeChangedCallback",
                            value: function(e, t, n) {
                                this.input.setAttribute(e, n);
                            }
                        }, {
                            key: "value",
                            get: function() {
                                return this.input.value;
                            },
                            set: function(e) {
                                this.input.value = e;
                            }
                        } ]) && o(t.prototype, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), s;
                    }(s(HTMLElement));
                    a.default.customElements.define("input-mask", v);
                }
            },
            2839: function(e, t) {
                function n(e) {
                    return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, n(e);
                }
                function i(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null != n) {
                            var i, a, r, o, l = [], s = !0, c = !1;
                            try {
                                if (r = (n = n.call(e)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    s = !1;
                                } else for (;!(s = (i = r.call(n)).done) && (l.push(i.value), l.length !== t); s = !0) ;
                            } catch (e) {
                                c = !0, a = e;
                            } finally {
                                try {
                                    if (!s && null != n.return && (o = n.return(), Object(o) !== o)) return;
                                } finally {
                                    if (c) throw a;
                                }
                            }
                            return l;
                        }
                    }(e, t) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return a(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === n && e.constructor && (n = e.constructor.name);
                        if ("Map" === n || "Set" === n) return Array.from(e);
                        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return a(e, t);
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function a(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                function r(e, t) {
                    var n = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e);
                        t && (i = i.filter((function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        }))), n.push.apply(n, i);
                    }
                    return n;
                }
                function o(e, t, i) {
                    return (t = function(e) {
                        var t = function(e, t) {
                            if ("object" !== n(e) || null === e) return e;
                            var i = e[Symbol.toPrimitive];
                            if (void 0 !== i) {
                                var a = i.call(e, t || "default");
                                if ("object" !== n(a)) return a;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === t ? String : Number)(e);
                        }(e, "string");
                        return "symbol" === n(t) ? t : String(t);
                    }(t)) in e ? Object.defineProperty(e, t, {
                        value: i,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = i, e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keys = t.keyCode = void 0, t.toKey = function(e, t) {
                    return s[e] || (t ? String.fromCharCode(e) : String.fromCharCode(e).toLowerCase());
                }, t.toKeyCode = function(e) {
                    return l[e];
                };
                var l = t.keyCode = function(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? r(Object(n), !0).forEach((function(t) {
                            o(e, t, n[t]);
                        })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        }));
                    }
                    return e;
                }({
                    c: 67,
                    x: 88,
                    z: 90,
                    BACKSPACE_SAFARI: 127,
                    Enter: 13,
                    Meta_LEFT: 91,
                    Meta_RIGHT: 92,
                    Space: 32
                }, {
                    Alt: 18,
                    AltGraph: 18,
                    ArrowDown: 40,
                    ArrowLeft: 37,
                    ArrowRight: 39,
                    ArrowUp: 38,
                    Backspace: 8,
                    CapsLock: 20,
                    Control: 17,
                    ContextMenu: 93,
                    Dead: 221,
                    Delete: 46,
                    End: 35,
                    Escape: 27,
                    F1: 112,
                    F2: 113,
                    F3: 114,
                    F4: 115,
                    F5: 116,
                    F6: 117,
                    F7: 118,
                    F8: 119,
                    F9: 120,
                    F10: 121,
                    F11: 122,
                    F12: 123,
                    Home: 36,
                    Insert: 45,
                    NumLock: 144,
                    PageDown: 34,
                    PageUp: 33,
                    Pause: 19,
                    PrintScreen: 44,
                    Process: 229,
                    Shift: 16,
                    ScrollLock: 145,
                    Tab: 9,
                    Unidentified: 229
                }), s = Object.entries(l).reduce((function(e, t) {
                    var n = i(t, 2), a = n[0], r = n[1];
                    return e[r] = void 0 === e[r] ? a : e[r], e;
                }), {});
                t.keys = Object.entries(l).reduce((function(e, t) {
                    var n = i(t, 2), a = n[0];
                    return e[a] = "Space" === a ? " " : a, e;
                }), {});
            },
            2391: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.analyseMask = function(e, t, n) {
                    var i, a, s, c, u, f, p = /(?:[?*+]|\{[0-9+*]+(?:,[0-9+*]*)?(?:\|[0-9+*]*)?\})|[^.?*+^${[]()|\\]+|./g, d = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g, h = !1, v = new o.default, m = [], g = [], y = !1;
                    function k(e, i, a) {
                        a = void 0 !== a ? a : e.matches.length;
                        var o = e.matches[a - 1];
                        if (t) {
                            if (0 === i.indexOf("[") || h && /\\d|\\s|\\w|\\p/i.test(i) || "." === i) {
                                var s = n.casing ? "i" : "";
                                /\\p\{.*}/i.test(i) && (s += "u"), e.matches.splice(a++, 0, {
                                    fn: new RegExp(i, s),
                                    static: !1,
                                    optionality: !1,
                                    newBlockMarker: void 0 === o ? "master" : o.def !== i,
                                    casing: null,
                                    def: i,
                                    placeholder: "object" === l(n.placeholder) ? n.placeholder[v.matches.length] : void 0,
                                    nativeDef: i
                                });
                            } else h && (i = i[i.length - 1]), i.split("").forEach((function(t, i) {
                                o = e.matches[a - 1], e.matches.splice(a++, 0, {
                                    fn: /[a-z]/i.test(n.staticDefinitionSymbol || t) ? new RegExp("[" + (n.staticDefinitionSymbol || t) + "]", n.casing ? "i" : "") : null,
                                    static: !0,
                                    optionality: !1,
                                    newBlockMarker: void 0 === o ? "master" : o.def !== t && !0 !== o.static,
                                    casing: null,
                                    def: n.staticDefinitionSymbol || t,
                                    placeholder: void 0 !== n.staticDefinitionSymbol ? t : "object" === l(n.placeholder) ? n.placeholder[v.matches.length] : void 0,
                                    nativeDef: (h ? "'" : "") + t
                                });
                            }));
                            h = !1;
                        } else {
                            var c = n.definitions && n.definitions[i] || n.usePrototypeDefinitions && r.default.prototype.definitions[i];
                            c && !h ? e.matches.splice(a++, 0, {
                                fn: c.validator ? "string" == typeof c.validator ? new RegExp(c.validator, n.casing ? "i" : "") : new function() {
                                    this.test = c.validator;
                                } : /./,
                                static: c.static || !1,
                                optionality: c.optional || !1,
                                defOptionality: c.optional || !1,
                                newBlockMarker: void 0 === o || c.optional ? "master" : o.def !== (c.definitionSymbol || i),
                                casing: c.casing,
                                def: c.definitionSymbol || i,
                                placeholder: c.placeholder,
                                nativeDef: i,
                                generated: c.generated
                            }) : (e.matches.splice(a++, 0, {
                                fn: /[a-z]/i.test(n.staticDefinitionSymbol || i) ? new RegExp("[" + (n.staticDefinitionSymbol || i) + "]", n.casing ? "i" : "") : null,
                                static: !0,
                                optionality: !1,
                                newBlockMarker: void 0 === o ? "master" : o.def !== i && !0 !== o.static,
                                casing: null,
                                def: n.staticDefinitionSymbol || i,
                                placeholder: void 0 !== n.staticDefinitionSymbol ? i : void 0,
                                nativeDef: (h ? "'" : "") + i
                            }), h = !1);
                        }
                    }
                    function b() {
                        if (m.length > 0) {
                            if (k(c = m[m.length - 1], a), c.isAlternator) {
                                u = m.pop();
                                for (var e = 0; e < u.matches.length; e++) u.matches[e].isGroup && (u.matches[e].isGroup = !1);
                                m.length > 0 ? (c = m[m.length - 1]).matches.push(u) : v.matches.push(u);
                            }
                        } else k(v, a);
                    }
                    function x(e) {
                        var t = new o.default(!0);
                        return t.openGroup = !1, t.matches = e, t;
                    }
                    function w() {
                        if ((s = m.pop()).openGroup = !1, void 0 !== s) if (m.length > 0) {
                            if ((c = m[m.length - 1]).matches.push(s), c.isAlternator) {
                                u = m.pop();
                                for (var e = 0; e < u.matches.length; e++) u.matches[e].isGroup = !1, u.matches[e].alternatorGroup = !1;
                                m.length > 0 ? (c = m[m.length - 1]).matches.push(u) : v.matches.push(u);
                            }
                        } else v.matches.push(s); else b();
                    }
                    function P(e) {
                        var t = e.pop();
                        return t.isQuantifier && (t = x([ e.pop(), t ])), t;
                    }
                    t && (n.optionalmarker[0] = void 0, n.optionalmarker[1] = void 0);
                    for (;i = t ? d.exec(e) : p.exec(e); ) {
                        if (a = i[0], t) {
                            switch (a.charAt(0)) {
                              case "?":
                                a = "{0,1}";
                                break;

                              case "+":
                              case "*":
                                a = "{" + a + "}";
                                break;

                              case "|":
                                if (0 === m.length) {
                                    var S = x(v.matches);
                                    S.openGroup = !0, m.push(S), v.matches = [], y = !0;
                                }
                            }
                            switch (a) {
                              case "\\d":
                                a = "[0-9]";
                                break;

                              case "\\p":
                                a += d.exec(e)[0], a += d.exec(e)[0];
                            }
                        }
                        if (h) b(); else switch (a.charAt(0)) {
                          case "$":
                          case "^":
                            t || b();
                            break;

                          case n.escapeChar:
                            h = !0, t && b();
                            break;

                          case n.optionalmarker[1]:
                          case n.groupmarker[1]:
                            w();
                            break;

                          case n.optionalmarker[0]:
                            m.push(new o.default(!1, !0));
                            break;

                          case n.groupmarker[0]:
                            m.push(new o.default(!0));
                            break;

                          case n.quantifiermarker[0]:
                            var O = new o.default(!1, !1, !0), _ = (a = a.replace(/[{}?]/g, "")).split("|"), M = _[0].split(","), E = isNaN(M[0]) ? M[0] : parseInt(M[0]), j = 1 === M.length ? E : isNaN(M[1]) ? M[1] : parseInt(M[1]), T = isNaN(_[1]) ? _[1] : parseInt(_[1]);
                            "*" !== E && "+" !== E || (E = "*" === j ? 0 : 1), O.quantifier = {
                                min: E,
                                max: j,
                                jit: T
                            };
                            var A = m.length > 0 ? m[m.length - 1].matches : v.matches;
                            (i = A.pop()).isGroup || (i = x([ i ])), A.push(i), A.push(O);
                            break;

                          case n.alternatormarker:
                            if (m.length > 0) {
                                var D = (c = m[m.length - 1]).matches[c.matches.length - 1];
                                f = c.openGroup && (void 0 === D.matches || !1 === D.isGroup && !1 === D.isAlternator) ? m.pop() : P(c.matches);
                            } else f = P(v.matches);
                            if (f.isAlternator) m.push(f); else if (f.alternatorGroup ? (u = m.pop(), f.alternatorGroup = !1) : u = new o.default(!1, !1, !1, !0), 
                            u.matches.push(f), m.push(u), f.openGroup) {
                                f.openGroup = !1;
                                var L = new o.default(!0);
                                L.alternatorGroup = !0, m.push(L);
                            }
                            break;

                          default:
                            b();
                        }
                    }
                    y && w();
                    for (;m.length > 0; ) s = m.pop(), v.matches.push(s);
                    v.matches.length > 0 && (!function e(i) {
                        i && i.matches && i.matches.forEach((function(a, r) {
                            var o = i.matches[r + 1];
                            (void 0 === o || void 0 === o.matches || !1 === o.isQuantifier) && a && a.isGroup && (a.isGroup = !1, 
                            t || (k(a, n.groupmarker[0], 0), !0 !== a.openGroup && k(a, n.groupmarker[1]))), 
                            e(a);
                        }));
                    }(v), g.push(v));
                    (n.numericInput || n.isRTL) && function e(t) {
                        for (var i in t.matches = t.matches.reverse(), t.matches) if (Object.prototype.hasOwnProperty.call(t.matches, i)) {
                            var a = parseInt(i);
                            if (t.matches[i].isQuantifier && t.matches[a + 1] && t.matches[a + 1].isGroup) {
                                var r = t.matches[i];
                                t.matches.splice(i, 1), t.matches.splice(a + 1, 0, r);
                            }
                            void 0 !== t.matches[i].matches ? t.matches[i] = e(t.matches[i]) : t.matches[i] = ((o = t.matches[i]) === n.optionalmarker[0] ? o = n.optionalmarker[1] : o === n.optionalmarker[1] ? o = n.optionalmarker[0] : o === n.groupmarker[0] ? o = n.groupmarker[1] : o === n.groupmarker[1] && (o = n.groupmarker[0]), 
                            o);
                        }
                        var o;
                        return t;
                    }(g[0]);
                    return g;
                }, t.generateMaskSet = function(e, t) {
                    var n;
                    function o(e, t) {
                        var n = t.repeat, i = t.groupmarker, r = t.quantifiermarker, o = t.keepStatic;
                        if (n > 0 || "*" === n || "+" === n) {
                            var l = "*" === n ? 0 : "+" === n ? 1 : n;
                            if (l != n) e = i[0] + e + i[1] + r[0] + l + "," + n + r[1]; else for (var c = e, u = 1; u < l; u++) e += c;
                        }
                        if (!0 === o) {
                            var f = e.match(new RegExp("(.)\\[([^\\]]*)\\]", "g"));
                            f && f.forEach((function(t, n) {
                                var i = function(e, t) {
                                    return function(e) {
                                        if (Array.isArray(e)) return e;
                                    }(e) || function(e, t) {
                                        var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                                        if (null != n) {
                                            var i, a, r, o, l = [], s = !0, c = !1;
                                            try {
                                                if (r = (n = n.call(e)).next, 0 === t) {
                                                    if (Object(n) !== n) return;
                                                    s = !1;
                                                } else for (;!(s = (i = r.call(n)).done) && (l.push(i.value), l.length !== t); s = !0) ;
                                            } catch (e) {
                                                c = !0, a = e;
                                            } finally {
                                                try {
                                                    if (!s && null != n.return && (o = n.return(), Object(o) !== o)) return;
                                                } finally {
                                                    if (c) throw a;
                                                }
                                            }
                                            return l;
                                        }
                                    }(e, t) || function(e, t) {
                                        if (!e) return;
                                        if ("string" == typeof e) return s(e, t);
                                        var n = Object.prototype.toString.call(e).slice(8, -1);
                                        "Object" === n && e.constructor && (n = e.constructor.name);
                                        if ("Map" === n || "Set" === n) return Array.from(e);
                                        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s(e, t);
                                    }(e, t) || function() {
                                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }();
                                }(t.split("["), 2), r = i[0], o = i[1];
                                o = o.replace("]", ""), e = e.replace(new RegExp("".concat((0, a.default)(r), "\\[").concat((0, a.default)(o), "\\]")), r.charAt(0) === o.charAt(0) ? "(".concat(r, "|").concat(r).concat(o, ")") : "".concat(r, "[").concat(o, "]"));
                            }));
                        }
                        return e;
                    }
                    function c(e, n, a) {
                        var s, c, u = !1;
                        return null !== e && "" !== e || ((u = null !== a.regex) ? e = (e = a.regex).replace(/^(\^)(.*)(\$)$/, "$2") : (u = !0, 
                        e = ".*")), 1 === e.length && !1 === a.greedy && 0 !== a.repeat && (a.placeholder = ""), 
                        e = o(e, a), c = u ? "regex_" + a.regex : a.numericInput ? e.split("").reverse().join("") : e, 
                        null !== a.keepStatic && (c = "ks_" + a.keepStatic + c), "object" === l(a.placeholder) && (c = "ph_" + JSON.stringify(a.placeholder) + c), 
                        void 0 === r.default.prototype.masksCache[c] || !0 === t ? (s = {
                            mask: e,
                            maskToken: r.default.prototype.analyseMask(e, u, a),
                            validPositions: [],
                            _buffer: void 0,
                            buffer: void 0,
                            tests: {},
                            excludes: {},
                            metadata: n,
                            maskLength: void 0,
                            jitOffset: {}
                        }, !0 !== t && (r.default.prototype.masksCache[c] = s, s = i.default.extend(!0, {}, r.default.prototype.masksCache[c]))) : s = i.default.extend(!0, {}, r.default.prototype.masksCache[c]), 
                        s;
                    }
                    "function" == typeof e.mask && (e.mask = e.mask(e));
                    if (Array.isArray(e.mask)) {
                        if (e.mask.length > 1) {
                            null === e.keepStatic && (e.keepStatic = !0);
                            var u = e.groupmarker[0];
                            return (e.isRTL ? e.mask.reverse() : e.mask).forEach((function(t) {
                                u.length > 1 && (u += e.alternatormarker), void 0 !== t.mask && "function" != typeof t.mask ? u += t.mask : u += t;
                            })), c(u += e.groupmarker[1], e.mask, e);
                        }
                        e.mask = e.mask.pop();
                    }
                    n = e.mask && void 0 !== e.mask.mask && "function" != typeof e.mask.mask ? c(e.mask.mask, e.mask, e) : c(e.mask, e.mask, e);
                    null === e.keepStatic && (e.keepStatic = !1);
                    return n;
                };
                var i = c(n(4963)), a = c(n(7184)), r = c(n(2394)), o = c(n(9695));
                function l(e) {
                    return l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, l(e);
                }
                function s(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                    return i;
                }
                function c(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            157: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mask = function() {
                    var e = this, t = this.opts, n = this.el, c = this.dependencyLib;
                    r.EventRuler.off(n);
                    var u = function(t, n) {
                        var i = t.getAttribute("type"), a = "input" === t.tagName.toLowerCase() && n.supportsInputType.includes(i) || t.isContentEditable || "textarea" === t.tagName.toLowerCase();
                        if (!a) if ("input" === t.tagName.toLowerCase()) {
                            var s = document.createElement("input");
                            s.setAttribute("type", i), a = "text" === s.type, s = null;
                        } else a = "partial";
                        return !1 !== a ? function(t) {
                            var i, a;
                            function s() {
                                return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== l.getLastValidPosition.call(e) || !0 !== n.nullable ? (this.inputmask.shadowRoot || this.ownerDocument).activeElement === this && n.clearMaskOnLostFocus ? (e.isRTL ? o.clearOptionalTail.call(e, l.getBuffer.call(e).slice()).reverse() : o.clearOptionalTail.call(e, l.getBuffer.call(e).slice())).join("") : i.call(this) : "" : i.call(this);
                            }
                            function u(e) {
                                a.call(this, e), this.inputmask && (0, o.applyInputValue)(this, e);
                            }
                            if (!t.inputmask.__valueGet) {
                                if (!0 !== n.noValuePatching) {
                                    if (Object.getOwnPropertyDescriptor) {
                                        var f = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(t), "value") : void 0;
                                        f && f.get && f.set ? (i = f.get, a = f.set, Object.defineProperty(t, "value", {
                                            get: s,
                                            set: u,
                                            configurable: !0
                                        })) : "input" !== t.tagName.toLowerCase() && (i = function() {
                                            return this.textContent;
                                        }, a = function(e) {
                                            this.textContent = e;
                                        }, Object.defineProperty(t, "value", {
                                            get: s,
                                            set: u,
                                            configurable: !0
                                        }));
                                    } else document.__lookupGetter__ && t.__lookupGetter__("value") && (i = t.__lookupGetter__("value"), 
                                    a = t.__lookupSetter__("value"), t.__defineGetter__("value", s), t.__defineSetter__("value", u));
                                    t.inputmask.__valueGet = i, t.inputmask.__valueSet = a;
                                }
                                t.inputmask._valueGet = function(t) {
                                    return e.isRTL && !0 !== t ? i.call(this.el).split("").reverse().join("") : i.call(this.el);
                                }, t.inputmask._valueSet = function(t, n) {
                                    a.call(this.el, null == t ? "" : !0 !== n && e.isRTL ? t.split("").reverse().join("") : t);
                                }, void 0 === i && (i = function() {
                                    return this.value;
                                }, a = function(e) {
                                    this.value = e;
                                }, function(t) {
                                    if (c.valHooks && (void 0 === c.valHooks[t] || !0 !== c.valHooks[t].inputmaskpatch)) {
                                        var i = c.valHooks[t] && c.valHooks[t].get ? c.valHooks[t].get : function(e) {
                                            return e.value;
                                        }, a = c.valHooks[t] && c.valHooks[t].set ? c.valHooks[t].set : function(e, t) {
                                            return e.value = t, e;
                                        };
                                        c.valHooks[t] = {
                                            get: function(t) {
                                                if (t.inputmask) {
                                                    if (t.inputmask.opts.autoUnmask) return t.inputmask.unmaskedvalue();
                                                    var a = i(t);
                                                    return -1 !== l.getLastValidPosition.call(e, void 0, void 0, t.inputmask.maskset.validPositions) || !0 !== n.nullable ? a : "";
                                                }
                                                return i(t);
                                            },
                                            set: function(e, t) {
                                                var n = a(e, t);
                                                return e.inputmask && (0, o.applyInputValue)(e, t), n;
                                            },
                                            inputmaskpatch: !0
                                        };
                                    }
                                }(t.type), function(e) {
                                    r.EventRuler.on(e, "mouseenter", (function() {
                                        var e = this, t = e.inputmask._valueGet(!0);
                                        t != (e.inputmask.isRTL ? l.getBuffer.call(e.inputmask).slice().reverse() : l.getBuffer.call(e.inputmask)).join("") && (0, o.applyInputValue)(e, t);
                                    }));
                                }(t));
                            }
                        }(t) : t.inputmask = void 0, a;
                    }(n, t);
                    if (!1 !== u) {
                        e.originalPlaceholder = n.placeholder, e.maxLength = void 0 !== n ? n.maxLength : void 0, 
                        -1 === e.maxLength && (e.maxLength = void 0), "inputMode" in n && null === n.getAttribute("inputmode") && (n.inputMode = t.inputmode, 
                        n.setAttribute("inputmode", t.inputmode)), !0 === u && (t.showMaskOnFocus = t.showMaskOnFocus && -1 === [ "cc-number", "cc-exp" ].indexOf(n.autocomplete), 
                        i.iphone && (t.insertModeVisual = !1, n.setAttribute("autocorrect", "off")), r.EventRuler.on(n, "submit", a.EventHandlers.submitEvent), 
                        r.EventRuler.on(n, "reset", a.EventHandlers.resetEvent), r.EventRuler.on(n, "blur", a.EventHandlers.blurEvent), 
                        r.EventRuler.on(n, "focus", a.EventHandlers.focusEvent), r.EventRuler.on(n, "invalid", a.EventHandlers.invalidEvent), 
                        r.EventRuler.on(n, "click", a.EventHandlers.clickEvent), r.EventRuler.on(n, "mouseleave", a.EventHandlers.mouseleaveEvent), 
                        r.EventRuler.on(n, "mouseenter", a.EventHandlers.mouseenterEvent), r.EventRuler.on(n, "paste", a.EventHandlers.pasteEvent), 
                        r.EventRuler.on(n, "cut", a.EventHandlers.cutEvent), r.EventRuler.on(n, "complete", t.oncomplete), 
                        r.EventRuler.on(n, "incomplete", t.onincomplete), r.EventRuler.on(n, "cleared", t.oncleared), 
                        !0 !== t.inputEventOnly && r.EventRuler.on(n, "keydown", a.EventHandlers.keyEvent), 
                        (i.mobile || t.inputEventOnly) && n.removeAttribute("maxLength"), r.EventRuler.on(n, "input", a.EventHandlers.inputFallBackEvent)), 
                        r.EventRuler.on(n, "setvalue", a.EventHandlers.setValueEvent), void 0 === e.applyMaskHook || e.applyMaskHook(), 
                        l.getBufferTemplate.call(e).join(""), e.undoValue = e._valueGet(!0);
                        var f = (n.inputmask.shadowRoot || n.ownerDocument).activeElement;
                        if ("" !== n.inputmask._valueGet(!0) || !1 === t.clearMaskOnLostFocus || f === n) {
                            (0, o.applyInputValue)(n, n.inputmask._valueGet(!0), t);
                            var p = l.getBuffer.call(e).slice();
                            !1 === s.isComplete.call(e, p) && t.clearIncomplete && l.resetMaskSet.call(e, !1), 
                            t.clearMaskOnLostFocus && f !== n && (-1 === l.getLastValidPosition.call(e) ? p = [] : o.clearOptionalTail.call(e, p)), 
                            (!1 === t.clearMaskOnLostFocus || t.showMaskOnFocus && f === n || "" !== n.inputmask._valueGet(!0)) && (0, o.writeBuffer)(n, p), f === n && l.caret.call(e, n, l.seekNext.call(e, l.getLastValidPosition.call(e)));
                        }
                    }
                };
                var i = n(9845), a = n(6030), r = n(9716), o = n(7760), l = n(8711), s = n(7215);
            },
            9695: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e, t, n, i) {
                    this.matches = [], this.openGroup = e || !1, this.alternatorGroup = !1, this.isGroup = e || !1, 
                    this.isOptional = t || !1, this.isQuantifier = n || !1, this.isAlternator = i || !1, 
                    this.quantifier = {
                        min: 1,
                        max: 1
                    };
                };
            },
            3194: function() {
                Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
                    value: function(e, t) {
                        if (null == this) throw new TypeError('"this" is null or not defined');
                        var n = Object(this), i = n.length >>> 0;
                        if (0 === i) return !1;
                        for (var a = 0 | t, r = Math.max(a >= 0 ? a : i - Math.abs(a), 0); r < i; ) {
                            if (n[r] === e) return !0;
                            r++;
                        }
                        return !1;
                    }
                });
            },
            9302: function() {
                var e = Function.bind.call(Function.call, Array.prototype.reduce), t = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable), n = Function.bind.call(Function.call, Array.prototype.concat), i = Object.keys;
                Object.entries || (Object.entries = function(a) {
                    return e(i(a), (function(e, i) {
                        return n(e, "string" == typeof i && t(a, i) ? [ [ i, a[i] ] ] : []);
                    }), []);
                });
            },
            7149: function() {
                function e(t) {
                    return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, e(t);
                }
                "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" === e("test".__proto__) ? function(e) {
                    return e.__proto__;
                } : function(e) {
                    return e.constructor.prototype;
                });
            },
            4013: function() {
                String.prototype.includes || (String.prototype.includes = function(e, t) {
                    return "number" != typeof t && (t = 0), !(t + e.length > this.length) && -1 !== this.indexOf(e, t);
                });
            },
            8711: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.caret = function(e, t, n, i, r) {
                    var o, l = this, s = this.opts;
                    if (void 0 === t) return "selectionStart" in e && "selectionEnd" in e ? (t = e.selectionStart, 
                    n = e.selectionEnd) : a.default.getSelection ? (o = a.default.getSelection().getRangeAt(0)).commonAncestorContainer.parentNode !== e && o.commonAncestorContainer !== e || (t = o.startOffset, 
                    n = o.endOffset) : document.selection && document.selection.createRange && (n = (t = 0 - (o = document.selection.createRange()).duplicate().moveStart("character", -e.inputmask._valueGet().length)) + o.text.length), 
                    {
                        begin: i ? t : f.call(l, t),
                        end: i ? n : f.call(l, n)
                    };
                    if (Array.isArray(t) && (n = l.isRTL ? t[0] : t[1], t = l.isRTL ? t[1] : t[0]), 
                    void 0 !== t.begin && (n = l.isRTL ? t.begin : t.end, t = l.isRTL ? t.end : t.begin), 
                    "number" == typeof t) {
                        t = i ? t : f.call(l, t), n = "number" == typeof (n = i ? n : f.call(l, n)) ? n : t;
                        var c = parseInt(((e.ownerDocument.defaultView || a.default).getComputedStyle ? (e.ownerDocument.defaultView || a.default).getComputedStyle(e, null) : e.currentStyle).fontSize) * n;
                        if (e.scrollLeft = c > e.scrollWidth ? c : 0, e.inputmask.caretPos = {
                            begin: t,
                            end: n
                        }, s.insertModeVisual && !1 === s.insertMode && t === n && (r || n++), e === (e.inputmask.shadowRoot || e.ownerDocument).activeElement) {
                            if ("setSelectionRange" in e) e.setSelectionRange(t, n); else if (a.default.getSelection) {
                                if (o = document.createRange(), void 0 === e.firstChild || null === e.firstChild) {
                                    var u = document.createTextNode("");
                                    e.appendChild(u);
                                }
                                o.setStart(e.firstChild, t < e.inputmask._valueGet().length ? t : e.inputmask._valueGet().length), 
                                o.setEnd(e.firstChild, n < e.inputmask._valueGet().length ? n : e.inputmask._valueGet().length), 
                                o.collapse(!0);
                                var p = a.default.getSelection();
                                p.removeAllRanges(), p.addRange(o);
                            } else e.createTextRange && ((o = e.createTextRange()).collapse(!0), o.moveEnd("character", n), 
                            o.moveStart("character", t), o.select());
                            void 0 === e.inputmask.caretHook || e.inputmask.caretHook.call(l, {
                                begin: t,
                                end: n
                            });
                        }
                    }
                }, t.determineLastRequiredPosition = function(e) {
                    var t, n, i = this, a = i.maskset, l = i.dependencyLib, c = s.call(i), u = {}, f = a.validPositions[c], p = o.getMaskTemplate.call(i, !0, s.call(i), !0, !0), d = p.length, h = void 0 !== f ? f.locator.slice() : void 0;
                    for (t = c + 1; t < p.length; t++) h = (n = o.getTestTemplate.call(i, t, h, t - 1)).locator.slice(), 
                    u[t] = l.extend(!0, {}, n);
                    var v = f && void 0 !== f.alternation ? f.locator[f.alternation] : void 0;
                    for (t = d - 1; t > c && (((n = u[t]).match.optionality || n.match.optionalQuantifier && n.match.newBlockMarker || v && (v !== u[t].locator[f.alternation] && !0 !== n.match.static || !0 === n.match.static && n.locator[f.alternation] && r.checkAlternationMatch.call(i, n.locator[f.alternation].toString().split(","), v.toString().split(",")) && "" !== o.getTests.call(i, t)[0].def)) && p[t] === o.getPlaceholder.call(i, t, n.match)); t--) d--;
                    return e ? {
                        l: d,
                        def: u[d] ? u[d].match : void 0
                    } : d;
                }, t.determineNewCaretPosition = function(e, t, n) {
                    var i, a, r, f = this, p = f.maskset, d = f.opts;
                    t && (f.isRTL ? e.end = e.begin : e.begin = e.end);
                    if (e.begin === e.end) {
                        switch (n = n || d.positionCaretOnClick) {
                          case "none":
                            break;

                          case "select":
                            e = {
                                begin: 0,
                                end: l.call(f).length
                            };
                            break;

                          case "ignore":
                            e.end = e.begin = u.call(f, s.call(f));
                            break;

                          case "radixFocus":
                            if (f.clicked > 1 && 0 === p.validPositions.length) break;
                            if (function(e) {
                                if ("" !== d.radixPoint && 0 !== d.digits) {
                                    var t = p.validPositions;
                                    if (void 0 === t[e] || void 0 === t[e].input) {
                                        if (e < u.call(f, -1)) return !0;
                                        var n = l.call(f).indexOf(d.radixPoint);
                                        if (-1 !== n) {
                                            for (var i = 0, a = t.length; i < a; i++) if (t[i] && n < i && t[i].input !== o.getPlaceholder.call(f, i)) return !1;
                                            return !0;
                                        }
                                    }
                                }
                                return !1;
                            }(e.begin)) {
                                var h = l.call(f).join("").indexOf(d.radixPoint);
                                e.end = e.begin = d.numericInput ? u.call(f, h) : h;
                                break;
                            }

                          default:
                            if (i = e.begin, a = s.call(f, i, !0), i <= (r = u.call(f, -1 !== a || c.call(f, 0) ? a : -1))) e.end = e.begin = c.call(f, i, !1, !0) ? i : u.call(f, i); else {
                                var v = p.validPositions[a], m = o.getTestTemplate.call(f, r, v ? v.match.locator : void 0, v), g = o.getPlaceholder.call(f, r, m.match);
                                if ("" !== g && l.call(f)[r] !== g && !0 !== m.match.optionalQuantifier && !0 !== m.match.newBlockMarker || !c.call(f, r, d.keepStatic, !0) && m.match.def === g) {
                                    var y = u.call(f, r);
                                    (i >= y || i === r) && (r = y);
                                }
                                e.end = e.begin = r;
                            }
                        }
                        return e;
                    }
                }, t.getBuffer = l, t.getBufferTemplate = function() {
                    var e = this.maskset;
                    void 0 === e._buffer && (e._buffer = o.getMaskTemplate.call(this, !1, 1), void 0 === e.buffer && (e.buffer = e._buffer.slice()));
                    return e._buffer;
                }, t.getLastValidPosition = s, t.isMask = c, t.resetMaskSet = function(e) {
                    var t = this.maskset;
                    t.buffer = void 0, !0 !== e && (t.validPositions = [], t.p = 0);
                    !1 === e && (t.tests = {}, t.jitOffset = {});
                }, t.seekNext = u, t.seekPrevious = function(e, t) {
                    var n = this, i = e - 1;
                    if (e <= 0) return 0;
                    for (;i > 0 && (!0 === t && (!0 !== o.getTest.call(n, i).match.newBlockMarker || !c.call(n, i, void 0, !0)) || !0 !== t && !c.call(n, i, void 0, !0)); ) i--;
                    return i;
                }, t.translatePosition = f;
                var i, a = (i = n(9380)) && i.__esModule ? i : {
                    default: i
                }, r = n(7215), o = n(4713);
                function l(e) {
                    var t = this, n = t.maskset;
                    return void 0 !== n.buffer && !0 !== e || (n.buffer = o.getMaskTemplate.call(t, !0, s.call(t), !0), 
                    void 0 === n._buffer && (n._buffer = n.buffer.slice())), n.buffer;
                }
                function s(e, t, n) {
                    var i = this.maskset, a = -1, r = -1, o = n || i.validPositions;
                    void 0 === e && (e = -1);
                    for (var l = 0, s = o.length; l < s; l++) o[l] && (t || !0 !== o[l].generatedInput) && (l <= e && (a = l), 
                    l >= e && (r = l));
                    return -1 === a || a === e ? r : -1 === r || e - a < r - e ? a : r;
                }
                function c(e, t, n) {
                    var i = this, a = this.maskset, r = o.getTestTemplate.call(i, e).match;
                    if ("" === r.def && (r = o.getTest.call(i, e).match), !0 !== r.static) return r.fn;
                    if (!0 === n && void 0 !== a.validPositions[e] && !0 !== a.validPositions[e].generatedInput) return !0;
                    if (!0 !== t && e > -1) {
                        if (n) {
                            var l = o.getTests.call(i, e);
                            return l.length > 1 + ("" === l[l.length - 1].match.def ? 1 : 0);
                        }
                        var s = o.determineTestTemplate.call(i, e, o.getTests.call(i, e)), c = o.getPlaceholder.call(i, e, s.match);
                        return s.match.def !== c;
                    }
                    return !1;
                }
                function u(e, t, n) {
                    var i = this;
                    void 0 === n && (n = !0);
                    for (var a = e + 1; "" !== o.getTest.call(i, a).match.def && (!0 === t && (!0 !== o.getTest.call(i, a).match.newBlockMarker || !c.call(i, a, void 0, !0)) || !0 !== t && !c.call(i, a, void 0, n)); ) a++;
                    return a;
                }
                function f(e) {
                    var t = this.opts, n = this.el;
                    return !this.isRTL || "number" != typeof e || t.greedy && "" === t.placeholder || !n || (e = this._valueGet().length - e) < 0 && (e = 0), 
                    e;
                }
            },
            4713: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.determineTestTemplate = f, t.getDecisionTaker = s, t.getMaskTemplate = function(e, t, n, i, a) {
                    var r = this, o = this.opts, l = this.maskset, s = o.greedy;
                    a && o.greedy && (o.greedy = !1, r.maskset.tests = {});
                    t = t || 0;
                    var p, d, v, m, g = [], y = 0;
                    do {
                        if (!0 === e && l.validPositions[y]) d = (v = a && l.validPositions[y].match.optionality && void 0 === l.validPositions[y + 1] && (!0 === l.validPositions[y].generatedInput || l.validPositions[y].input == o.skipOptionalPartCharacter && y > 0) ? f.call(r, y, h.call(r, y, p, y - 1)) : l.validPositions[y]).match, 
                        p = v.locator.slice(), g.push(!0 === n ? v.input : !1 === n ? d.nativeDef : c.call(r, y, d)); else {
                            d = (v = u.call(r, y, p, y - 1)).match, p = v.locator.slice();
                            var k = !0 !== i && (!1 !== o.jitMasking ? o.jitMasking : d.jit);
                            (m = (m || l.validPositions[y - 1]) && d.static && d.def !== o.groupSeparator && null === d.fn) || !1 === k || void 0 === k || "number" == typeof k && isFinite(k) && k > y ? g.push(!1 === n ? d.nativeDef : c.call(r, g.length, d)) : m = !1;
                        }
                        y++;
                    } while (!0 !== d.static || "" !== d.def || t > y);
                    "" === g[g.length - 1] && g.pop();
                    !1 === n && void 0 !== l.maskLength || (l.maskLength = y - 1);
                    return o.greedy = s, g;
                }, t.getPlaceholder = c, t.getTest = p, t.getTestTemplate = u, t.getTests = h, t.isSubsetOf = d;
                var i, a = (i = n(2394)) && i.__esModule ? i : {
                    default: i
                }, r = n(8711);
                function o(e) {
                    return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, o(e);
                }
                function l(e, t) {
                    var n = (null != e.alternation ? e.mloc[s(e)] : e.locator).join("");
                    if ("" !== n) for (n = n.split(":")[0]; n.length < t; ) n += "0";
                    return n;
                }
                function s(e) {
                    var t = e.locator[e.alternation];
                    return "string" == typeof t && t.length > 0 && (t = t.split(",")[0]), void 0 !== t ? t.toString() : "";
                }
                function c(e, t, n) {
                    var i = this, a = this.opts, l = this.maskset;
                    if (void 0 !== (t = t || p.call(i, e).match).placeholder || !0 === n) {
                        if ("" !== t.placeholder && !0 === t.static && !0 !== t.generated) {
                            var s = r.getLastValidPosition.call(i, e), c = r.seekNext.call(i, s);
                            return (n ? e <= c : e < c) ? a.staticDefinitionSymbol && t.static ? t.nativeDef : t.def : "function" == typeof t.placeholder ? t.placeholder(a) : t.placeholder;
                        }
                        return "function" == typeof t.placeholder ? t.placeholder(a) : t.placeholder;
                    }
                    if (!0 === t.static) {
                        if (e > -1 && void 0 === l.validPositions[e]) {
                            var u, f = h.call(i, e), d = [];
                            if ("string" == typeof a.placeholder && f.length > 1 + ("" === f[f.length - 1].match.def ? 1 : 0)) for (var v = 0; v < f.length; v++) if ("" !== f[v].match.def && !0 !== f[v].match.optionality && !0 !== f[v].match.optionalQuantifier && (!0 === f[v].match.static || void 0 === u || !1 !== f[v].match.fn.test(u.match.def, l, e, !0, a)) && (d.push(f[v]), 
                            !0 === f[v].match.static && (u = f[v]), d.length > 1 && /[0-9a-bA-Z]/.test(d[0].match.def))) return a.placeholder.charAt(e % a.placeholder.length);
                        }
                        return t.def;
                    }
                    return "object" === o(a.placeholder) ? t.def : a.placeholder.charAt(e % a.placeholder.length);
                }
                function u(e, t, n) {
                    return this.maskset.validPositions[e] || f.call(this, e, h.call(this, e, t ? t.slice() : t, n));
                }
                function f(e, t) {
                    var n = this.opts, i = 0, a = function(e, t) {
                        var n = 0, i = !1;
                        t.forEach((function(e) {
                            e.match.optionality && (0 !== n && n !== e.match.optionality && (i = !0), (0 === n || n > e.match.optionality) && (n = e.match.optionality));
                        })), n && (0 == e || 1 == t.length ? n = 0 : i || (n = 0));
                        return n;
                    }(e, t);
                    e = e > 0 ? e - 1 : 0;
                    var r, o, s, c = l(p.call(this, e));
                    n.greedy && t.length > 1 && "" === t[t.length - 1].match.def && (i = 1);
                    for (var u = 0; u < t.length - i; u++) {
                        var f = t[u];
                        r = l(f, c.length);
                        var d = Math.abs(r - c);
                        (!0 !== f.unMatchedAlternationStopped || t.filter((function(e) {
                            return !0 !== e.unMatchedAlternationStopped;
                        })).length <= 1) && (void 0 === o || "" !== r && d < o || s && !n.greedy && s.match.optionality && s.match.optionality - a > 0 && "master" === s.match.newBlockMarker && (!f.match.optionality || f.match.optionality - a < 1 || !f.match.newBlockMarker) || s && !n.greedy && s.match.optionalQuantifier && !f.match.optionalQuantifier) && (o = d, 
                        s = f);
                    }
                    return s;
                }
                function p(e, t) {
                    var n = this.maskset;
                    return n.validPositions[e] ? n.validPositions[e] : (t || h.call(this, e))[0];
                }
                function d(e, t, n) {
                    function i(e) {
                        for (var t, n = [], i = -1, a = 0, r = e.length; a < r; a++) if ("-" === e.charAt(a)) for (t = e.charCodeAt(a + 1); ++i < t; ) n.push(String.fromCharCode(i)); else i = e.charCodeAt(a), 
                        n.push(e.charAt(a));
                        return n.join("");
                    }
                    return e.match.def === t.match.nativeDef || !(!(n.regex || e.match.fn instanceof RegExp && t.match.fn instanceof RegExp) || !0 === e.match.static || !0 === t.match.static) && ("." === t.match.fn.source || -1 !== i(t.match.fn.source.replace(/[[\]/]/g, "")).indexOf(i(e.match.fn.source.replace(/[[\]/]/g, ""))));
                }
                function h(e, t, n) {
                    var i, r, o = this, l = this.dependencyLib, s = this.maskset, c = this.opts, u = this.el, p = s.maskToken, h = t ? n : 0, v = t ? t.slice() : [ 0 ], m = [], g = !1, y = t ? t.join("") : "", k = !1;
                    function b(t, n, r, l) {
                        function f(r, l, p) {
                            function v(e, t) {
                                var n = 0 === t.matches.indexOf(e);
                                return n || t.matches.every((function(i, a) {
                                    return !0 === i.isQuantifier ? n = v(e, t.matches[a - 1]) : Object.prototype.hasOwnProperty.call(i, "matches") && (n = v(e, i)), 
                                    !n;
                                })), n;
                            }
                            function w(e, t, n) {
                                var i, a;
                                if ((s.tests[e] || s.validPositions[e]) && (s.validPositions[e] ? [ s.validPositions[e] ] : s.tests[e]).every((function(e, r) {
                                    if (e.mloc[t]) return i = e, !1;
                                    var o = void 0 !== n ? n : e.alternation, l = void 0 !== e.locator[o] ? e.locator[o].toString().indexOf(t) : -1;
                                    return (void 0 === a || l < a) && -1 !== l && (i = e, a = l), !0;
                                })), i) {
                                    var r = i.locator[i.alternation], o = i.mloc[t] || i.mloc[r] || i.locator;
                                    if (-1 !== o[o.length - 1].toString().indexOf(":")) o.pop();
                                    return o.slice((void 0 !== n ? n : i.alternation) + 1);
                                }
                                return void 0 !== n ? w(e, t) : void 0;
                            }
                            function P(t, n) {
                                return !0 === t.match.static && !0 !== n.match.static && n.match.fn.test(t.match.def, s, e, !1, c, !1);
                            }
                            function S(e, t) {
                                var n = e.alternation, i = void 0 === t || n <= t.alternation && -1 === e.locator[n].toString().indexOf(t.locator[n]);
                                if (!i && n > t.alternation) for (var a = 0; a < n; a++) if (e.locator[a] !== t.locator[a]) {
                                    n = a, i = !0;
                                    break;
                                }
                                return !!i && function(n) {
                                    e.mloc = e.mloc || {};
                                    var i = e.locator[n];
                                    if (void 0 !== i) {
                                        if ("string" == typeof i && (i = i.split(",")[0]), void 0 === e.mloc[i] && (e.mloc[i] = e.locator.slice(), 
                                        e.mloc[i].push(":".concat(e.alternation))), void 0 !== t) {
                                            for (var a in t.mloc) "string" == typeof a && (a = parseInt(a.split(",")[0])), e.mloc[a + 0] = t.mloc[a];
                                            e.locator[n] = Object.keys(e.mloc).join(",");
                                        }
                                        return e.alternation > n && (e.alternation = n), !0;
                                    }
                                    return e.alternation = void 0, !1;
                                }(n);
                            }
                            function O(e, t) {
                                if (e.locator.length !== t.locator.length) return !1;
                                for (var n = e.alternation + 1; n < e.locator.length; n++) if (e.locator[n] !== t.locator[n]) return !1;
                                return !0;
                            }
                            if (h > e + c._maxTestPos) throw new Error("Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. ".concat(s.mask));
                            if (h === e && void 0 === r.matches) {
                                if (m.push({
                                    match: r,
                                    locator: l.reverse(),
                                    cd: y,
                                    mloc: {}
                                }), !r.optionality || void 0 !== p || !(c.definitions && c.definitions[r.nativeDef] && c.definitions[r.nativeDef].optional || a.default.prototype.definitions[r.nativeDef] && a.default.prototype.definitions[r.nativeDef].optional)) return !0;
                                g = !0, h = e;
                            } else if (void 0 !== r.matches) {
                                if (r.isGroup && p !== r) return function() {
                                    if (r = f(t.matches[t.matches.indexOf(r) + 1], l, p)) return !0;
                                }();
                                if (r.isOptional) return function() {
                                    var t = r, a = m.length;
                                    if (r = b(r, n, l, p), m.length > 0) {
                                        if (m.forEach((function(e, t) {
                                            t >= a && (e.match.optionality = e.match.optionality ? e.match.optionality + 1 : 1);
                                        })), i = m[m.length - 1].match, void 0 !== p || !v(i, t)) return r;
                                        g = !0, h = e;
                                    }
                                }();
                                if (r.isAlternator) return function() {
                                    function i(e) {
                                        for (var t, n = e.matches[0].matches ? e.matches[0].matches.length : 1, i = 0; i < e.matches.length && n === (t = e.matches[i].matches ? e.matches[i].matches.length : 1); i++) ;
                                        return n !== t;
                                    }
                                    o.hasAlternator = !0;
                                    var a, v = r, y = [], b = m.slice(), x = l.length, _ = n.length > 0 ? n.shift() : -1;
                                    if (-1 === _ || "string" == typeof _) {
                                        var M, E = h, j = n.slice(), T = [];
                                        if ("string" == typeof _) T = _.split(","); else for (M = 0; M < v.matches.length; M++) T.push(M.toString());
                                        if (void 0 !== s.excludes[e]) {
                                            for (var A = T.slice(), D = 0, L = s.excludes[e].length; D < L; D++) {
                                                var C = s.excludes[e][D].toString().split(":");
                                                l.length == C[1] && T.splice(T.indexOf(C[0]), 1);
                                            }
                                            0 === T.length && (delete s.excludes[e], T = A);
                                        }
                                        (!0 === c.keepStatic || isFinite(parseInt(c.keepStatic)) && E >= c.keepStatic) && (T = T.slice(0, 1));
                                        for (var B = 0; B < T.length; B++) {
                                            M = parseInt(T[B]), m = [], n = "string" == typeof _ && w(h, M, x) || j.slice();
                                            var I = v.matches[M];
                                            if (I && f(I, [ M ].concat(l), p)) r = !0; else if (0 === B && (k = i(v)), I && I.matches && I.matches.length > v.matches[0].matches.length) break;
                                            a = m.slice(), h = E, m = [];
                                            for (var R = 0; R < a.length; R++) {
                                                var F = a[R], N = !1;
                                                F.alternation = F.alternation || x, S(F);
                                                for (var V = 0; V < y.length; V++) {
                                                    var G = y[V];
                                                    if ("string" != typeof _ || void 0 !== F.alternation && T.includes(F.locator[F.alternation].toString())) {
                                                        if (F.match.nativeDef === G.match.nativeDef) {
                                                            N = !0, S(G, F);
                                                            break;
                                                        }
                                                        if (d(F, G, c)) {
                                                            S(F, G) && (N = !0, y.splice(y.indexOf(G), 0, F));
                                                            break;
                                                        }
                                                        if (d(G, F, c)) {
                                                            S(G, F);
                                                            break;
                                                        }
                                                        if (P(F, G)) {
                                                            O(F, G) || void 0 !== u.inputmask.userOptions.keepStatic ? S(F, G) && (N = !0, y.splice(y.indexOf(G), 0, F)) : c.keepStatic = !0;
                                                            break;
                                                        }
                                                        if (P(G, F)) {
                                                            S(G, F);
                                                            break;
                                                        }
                                                    }
                                                }
                                                N || y.push(F);
                                            }
                                        }
                                        m = b.concat(y), h = e, g = m.length > 0 && k, r = y.length > 0 && !k, k && g && !r && m.forEach((function(e, t) {
                                            e.unMatchedAlternationStopped = !0;
                                        })), n = j.slice();
                                    } else r = f(v.matches[_] || t.matches[_], [ _ ].concat(l), p);
                                    if (r) return !0;
                                }();
                                if (r.isQuantifier && p !== t.matches[t.matches.indexOf(r) - 1]) return function() {
                                    for (var a = r, o = !1, u = n.length > 0 ? n.shift() : 0; u < (isNaN(a.quantifier.max) ? u + 1 : a.quantifier.max) && h <= e; u++) {
                                        var p = t.matches[t.matches.indexOf(a) - 1];
                                        if (r = f(p, [ u ].concat(l), p)) {
                                            if (m.forEach((function(t, n) {
                                                (i = x(p, t.match) ? t.match : m[m.length - 1].match).optionalQuantifier = u >= a.quantifier.min, 
                                                i.jit = (u + 1) * (p.matches.indexOf(i) + 1) > a.quantifier.jit, i.optionalQuantifier && v(i, p) && (g = !0, 
                                                h = e, c.greedy && null == s.validPositions[e - 1] && u > a.quantifier.min && -1 != [ "*", "+" ].indexOf(a.quantifier.max) && (m.pop(), 
                                                y = void 0), o = !0, r = !1), !o && i.jit && (s.jitOffset[e] = p.matches.length - p.matches.indexOf(i));
                                            })), o) break;
                                            return !0;
                                        }
                                    }
                                }();
                                if (r = b(r, n, l, p)) return !0;
                            } else h++;
                        }
                        for (var p = n.length > 0 ? n.shift() : 0; p < t.matches.length; p++) if (!0 !== t.matches[p].isQuantifier) {
                            var v = f(t.matches[p], [ p ].concat(r), l);
                            if (v && h === e) return v;
                            if (h > e) break;
                        }
                    }
                    function x(e, t) {
                        var n = -1 != e.matches.indexOf(t);
                        return n || e.matches.forEach((function(e, i) {
                            void 0 === e.matches || n || (n = x(e, t));
                        })), n;
                    }
                    if (e > -1) {
                        if (void 0 === t) {
                            for (var w, P = e - 1; void 0 === (w = s.validPositions[P] || s.tests[P]) && P > -1; ) P--;
                            void 0 !== w && P > -1 && (v = function(e, t) {
                                var n, i = [];
                                return Array.isArray(t) || (t = [ t ]), t.length > 0 && (void 0 === t[0].alternation || !0 === c.keepStatic ? 0 === (i = f.call(o, e, t.slice()).locator.slice()).length && (i = t[0].locator.slice()) : t.forEach((function(e) {
                                    "" !== e.def && (0 === i.length ? (n = e.alternation, i = e.locator.slice()) : e.locator[n] && -1 === i[n].toString().indexOf(e.locator[n]) && (i[n] += "," + e.locator[n]));
                                }))), i;
                            }(P, w), y = v.join(""), h = P);
                        }
                        if (s.tests[e] && s.tests[e][0].cd === y) return s.tests[e];
                        for (var S = v.shift(); S < p.length; S++) {
                            if (b(p[S], v, [ S ]) && h === e || h > e) break;
                        }
                    }
                    return (0 === m.length || g) && m.push({
                        match: {
                            fn: null,
                            static: !0,
                            optionality: !1,
                            casing: null,
                            def: "",
                            placeholder: ""
                        },
                        locator: k && 0 === m.filter((function(e) {
                            return !0 !== e.unMatchedAlternationStopped;
                        })).length ? [ 0 ] : [],
                        mloc: {},
                        cd: y
                    }), void 0 !== t && s.tests[e] ? r = l.extend(!0, [], m) : (s.tests[e] = l.extend(!0, [], m), 
                    r = s.tests[e]), m.forEach((function(e) {
                        e.match.optionality = e.match.defOptionality || !1;
                    })), r;
                }
            },
            7215: function(e, t, n) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.alternate = l, t.checkAlternationMatch = function(e, t, n) {
                    for (var i, a = this.opts.greedy ? t : t.slice(0, 1), r = !1, o = void 0 !== n ? n.split(",") : [], l = 0; l < o.length; l++) -1 !== (i = e.indexOf(o[l])) && e.splice(i, 1);
                    for (var s = 0; s < e.length; s++) if (a.includes(e[s])) {
                        r = !0;
                        break;
                    }
                    return r;
                }, t.handleRemove = function(e, t, n, i, s) {
                    var c = this, u = this.maskset, f = this.opts;
                    if ((f.numericInput || c.isRTL) && (t === a.keys.Backspace ? t = a.keys.Delete : t === a.keys.Delete && (t = a.keys.Backspace), 
                    c.isRTL)) {
                        var p = n.end;
                        n.end = n.begin, n.begin = p;
                    }
                    var d, h = r.getLastValidPosition.call(c, void 0, !0);
                    n.end >= r.getBuffer.call(c).length && h >= n.end && (n.end = h + 1);
                    t === a.keys.Backspace ? n.end - n.begin < 1 && (n.begin = r.seekPrevious.call(c, n.begin)) : t === a.keys.Delete && n.begin === n.end && (n.end = r.isMask.call(c, n.end, !0, !0) ? n.end + 1 : r.seekNext.call(c, n.end) + 1);
                    !1 !== (d = v.call(c, n)) && ((!0 !== i && !1 !== f.keepStatic || null !== f.regex && -1 !== o.getTest.call(c, n.begin).match.def.indexOf("|")) && l.call(c, !0), 
                    !0 !== i && (u.p = t === a.keys.Delete ? n.begin + d : n.begin, u.p = r.determineNewCaretPosition.call(c, {
                        begin: u.p,
                        end: u.p
                    }, !1, !1 === f.insertMode && t === a.keys.Backspace ? "none" : void 0).begin));
                }, t.isComplete = c, t.isSelection = u, t.isValid = f, t.refreshFromBuffer = d, 
                t.revalidateMask = v;
                var i = n(6030), a = n(2839), r = n(8711), o = n(4713);
                function l(e, t, n, i, a, s) {
                    var c = this, u = this.dependencyLib, p = this.opts, d = c.maskset;
                    if (!c.hasAlternator) return !1;
                    var h, v, m, g, y, k, b, x, w, P, S, O = u.extend(!0, [], d.validPositions), _ = u.extend(!0, {}, d.tests), M = !1, E = !1, j = void 0 !== a ? a : r.getLastValidPosition.call(c);
                    if (s && (P = s.begin, S = s.end, s.begin > s.end && (P = s.end, S = s.begin)), 
                    -1 === j && void 0 === a) h = 0, v = (g = o.getTest.call(c, h)).alternation; else for (;j >= 0; j--) if ((m = d.validPositions[j]) && void 0 !== m.alternation) {
                        if (j <= (e || 0) && g && g.locator[m.alternation] !== m.locator[m.alternation]) break;
                        h = j, v = d.validPositions[h].alternation, g = m;
                    }
                    if (void 0 !== v) {
                        b = parseInt(h), d.excludes[b] = d.excludes[b] || [], !0 !== e && d.excludes[b].push((0, o.getDecisionTaker)(g) + ":" + g.alternation);
                        var T = [], A = -1;
                        for (y = b; b < r.getLastValidPosition.call(c, void 0, !0) + 1; y++) -1 === A && e <= y && void 0 !== t && (T.push(t), 
                        A = T.length - 1), (k = d.validPositions[b]) && !0 !== k.generatedInput && (void 0 === s || y < P || y >= S) && T.push(k.input), 
                        d.validPositions.splice(b, 1);
                        for (-1 === A && void 0 !== t && (T.push(t), A = T.length - 1); void 0 !== d.excludes[b] && d.excludes[b].length < 10; ) {
                            for (d.tests = {}, r.resetMaskSet.call(c, !0), M = !0, y = 0; y < T.length && (x = M.caret || 0 == p.insertMode && null != x ? r.seekNext.call(c, x) : r.getLastValidPosition.call(c, void 0, !0) + 1, 
                            w = T[y], M = f.call(c, x, w, !1, i, !0)); y++) y === A && (E = M), 1 == e && M && (E = {
                                caretPos: y
                            });
                            if (M) break;
                            if (r.resetMaskSet.call(c), g = o.getTest.call(c, b), d.validPositions = u.extend(!0, [], O), 
                            d.tests = u.extend(!0, {}, _), !d.excludes[b]) {
                                E = l.call(c, e, t, n, i, b - 1, s);
                                break;
                            }
                            if (null != g.alternation) {
                                var D = (0, o.getDecisionTaker)(g);
                                if (-1 !== d.excludes[b].indexOf(D + ":" + g.alternation)) {
                                    E = l.call(c, e, t, n, i, b - 1, s);
                                    break;
                                }
                                for (d.excludes[b].push(D + ":" + g.alternation), y = b; y < r.getLastValidPosition.call(c, void 0, !0) + 1; y++) d.validPositions.splice(b);
                            } else delete d.excludes[b];
                        }
                    }
                    return E && !1 === p.keepStatic || delete d.excludes[b], E;
                }
                function s(e, t, n) {
                    var i = this.opts, r = this.maskset;
                    switch (i.casing || t.casing) {
                      case "upper":
                        e = e.toUpperCase();
                        break;

                      case "lower":
                        e = e.toLowerCase();
                        break;

                      case "title":
                        var o = r.validPositions[n - 1];
                        e = 0 === n || o && o.input === String.fromCharCode(a.keyCode.Space) ? e.toUpperCase() : e.toLowerCase();
                        break;

                      default:
                        if ("function" == typeof i.casing) {
                            var l = Array.prototype.slice.call(arguments);
                            l.push(r.validPositions), e = i.casing.apply(this, l);
                        }
                    }
                    return e;
                }
                function c(e) {
                    var t = this, n = this.opts, i = this.maskset;
                    if ("function" == typeof n.isComplete) return n.isComplete(e, n);
                    if ("*" !== n.repeat) {
                        var a = !1, l = r.determineLastRequiredPosition.call(t, !0), s = l.l;
                        if (void 0 === l.def || l.def.newBlockMarker || l.def.optionality || l.def.optionalQuantifier) {
                            a = !0;
                            for (var c = 0; c <= s; c++) {
                                var u = o.getTestTemplate.call(t, c).match;
                                if (!0 !== u.static && void 0 === i.validPositions[c] && (!1 === u.optionality || void 0 === u.optionality || u.optionality && 0 == u.newBlockMarker) && (!1 === u.optionalQuantifier || void 0 === u.optionalQuantifier) || !0 === u.static && "" != u.def && e[c] !== o.getPlaceholder.call(t, c, u)) {
                                    a = !1;
                                    break;
                                }
                            }
                        }
                        return a;
                    }
                }
                function u(e) {
                    var t = this.opts.insertMode ? 0 : 1;
                    return this.isRTL ? e.begin - e.end > t : e.end - e.begin > t;
                }
                function f(e, t, n, i, a, p, m) {
                    var g = this, y = this.dependencyLib, k = this.opts, b = g.maskset;
                    n = !0 === n;
                    var x = e;
                    function w(e) {
                        if (void 0 !== e) {
                            if (void 0 !== e.remove && (Array.isArray(e.remove) || (e.remove = [ e.remove ]), 
                            e.remove.sort((function(e, t) {
                                return g.isRTL ? e.pos - t.pos : t.pos - e.pos;
                            })).forEach((function(e) {
                                v.call(g, {
                                    begin: e,
                                    end: e + 1
                                });
                            })), e.remove = void 0), void 0 !== e.insert && (Array.isArray(e.insert) || (e.insert = [ e.insert ]), 
                            e.insert.sort((function(e, t) {
                                return g.isRTL ? t.pos - e.pos : e.pos - t.pos;
                            })).forEach((function(e) {
                                "" !== e.c && f.call(g, e.pos, e.c, void 0 === e.strict || e.strict, void 0 !== e.fromIsValid ? e.fromIsValid : i);
                            })), e.insert = void 0), e.refreshFromBuffer && e.buffer) {
                                var t = e.refreshFromBuffer;
                                d.call(g, !0 === t ? t : t.start, t.end, e.buffer), e.refreshFromBuffer = void 0;
                            }
                            void 0 !== e.rewritePosition && (x = e.rewritePosition, e = !0);
                        }
                        return e;
                    }
                    function P(t, n, a) {
                        var l = !1;
                        return o.getTests.call(g, t).every((function(c, f) {
                            var p = c.match;
                            if (r.getBuffer.call(g, !0), !1 !== (l = (!p.jit || void 0 !== b.validPositions[r.seekPrevious.call(g, t)]) && (null != p.fn ? p.fn.test(n, b, t, a, k, u.call(g, e)) : (n === p.def || n === k.skipOptionalPartCharacter) && "" !== p.def && {
                                c: o.getPlaceholder.call(g, t, p, !0) || p.def,
                                pos: t
                            }))) {
                                var d = void 0 !== l.c ? l.c : n, h = t;
                                return d = d === k.skipOptionalPartCharacter && !0 === p.static ? o.getPlaceholder.call(g, t, p, !0) || p.def : d, 
                                !0 !== (l = w(l)) && void 0 !== l.pos && l.pos !== t && (h = l.pos), !0 !== l && void 0 === l.pos && void 0 === l.c ? !1 : (!1 === v.call(g, e, y.extend({}, c, {
                                    input: s.call(g, d, p, h)
                                }), i, h) && (l = !1), !1);
                            }
                            return !0;
                        })), l;
                    }
                    void 0 !== e.begin && (x = g.isRTL ? e.end : e.begin);
                    var S = !0, O = y.extend(!0, [], b.validPositions);
                    if (!1 === k.keepStatic && void 0 !== b.excludes[x] && !0 !== a && !0 !== i) for (var _ = x; _ < (g.isRTL ? e.begin : e.end); _++) void 0 !== b.excludes[_] && (b.excludes[_] = void 0, 
                    delete b.tests[_]);
                    if ("function" == typeof k.preValidation && !0 !== i && !0 !== p && (S = w(S = k.preValidation.call(g, r.getBuffer.call(g), x, t, u.call(g, e), k, b, e, n || a))), 
                    !0 === S) {
                        if (S = P(x, t, n), (!n || !0 === i) && !1 === S && !0 !== p) {
                            var M = b.validPositions[x];
                            if (!M || !0 !== M.match.static || M.match.def !== t && t !== k.skipOptionalPartCharacter) {
                                if (k.insertMode || void 0 === b.validPositions[r.seekNext.call(g, x)] || e.end > x) {
                                    var E = !1;
                                    if (b.jitOffset[x] && void 0 === b.validPositions[r.seekNext.call(g, x)] && !1 !== (S = f.call(g, x + b.jitOffset[x], t, !0, !0)) && (!0 !== a && (S.caret = x), 
                                    E = !0), e.end > x && (b.validPositions[x] = void 0), !E && !r.isMask.call(g, x, k.keepStatic && 0 === x)) for (var j = x + 1, T = r.seekNext.call(g, x, !1, 0 !== x); j <= T; j++) if (!1 !== (S = P(j, t, n))) {
                                        S = h.call(g, x, void 0 !== S.pos ? S.pos : j) || S, x = j;
                                        break;
                                    }
                                }
                            } else S = {
                                caret: r.seekNext.call(g, x)
                            };
                        }
                        g.hasAlternator && !0 !== a && !n && (a = !0, !1 === S && k.keepStatic && (c.call(g, r.getBuffer.call(g)) || 0 === x) ? S = l.call(g, x, t, n, i, void 0, e) : (u.call(g, e) && b.tests[x] && b.tests[x].length > 1 && k.keepStatic || 1 == S && !0 !== k.numericInput && b.tests[x] && b.tests[x].length > 1 && r.getLastValidPosition.call(g, void 0, !0) > x) && (S = l.call(g, !0))), 
                        !0 === S && (S = {
                            pos: x
                        });
                    }
                    if ("function" == typeof k.postValidation && !0 !== i && !0 !== p) {
                        var A = k.postValidation.call(g, r.getBuffer.call(g, !0), void 0 !== e.begin ? g.isRTL ? e.end : e.begin : e, t, S, k, b, n, m);
                        void 0 !== A && (S = !0 === A ? S : A);
                    }
                    S && void 0 === S.pos && (S.pos = x), !1 === S || !0 === p ? (r.resetMaskSet.call(g, !0), 
                    b.validPositions = y.extend(!0, [], O)) : h.call(g, void 0, x, !0);
                    var D = w(S);
                    void 0 !== g.maxLength && (r.getBuffer.call(g).length > g.maxLength && !i && (r.resetMaskSet.call(g, !0), 
                    b.validPositions = y.extend(!0, [], O), D = !1));
                    return D;
                }
                function p(e, t, n) {
                    for (var i = this.maskset, a = !1, r = o.getTests.call(this, e), l = 0; l < r.length; l++) {
                        if (r[l].match && (r[l].match.nativeDef === t.match[n.shiftPositions ? "def" : "nativeDef"] && (!n.shiftPositions || !t.match.static) || r[l].match.nativeDef === t.match.nativeDef || n.regex && !r[l].match.static && r[l].match.fn.test(t.input, i, e, !1, n))) {
                            a = !0;
                            break;
                        }
                        if (r[l].match && r[l].match.def === t.match.nativeDef) {
                            a = void 0;
                            break;
                        }
                    }
                    return !1 === a && void 0 !== i.jitOffset[e] && (a = p.call(this, e + i.jitOffset[e], t, n)), 
                    a;
                }
                function d(e, t, n) {
                    var a, o, l = this, s = this.maskset, c = this.opts, u = this.dependencyLib, f = c.skipOptionalPartCharacter, p = l.isRTL ? n.slice().reverse() : n;
                    if (c.skipOptionalPartCharacter = "", !0 === e) r.resetMaskSet.call(l, !1), e = 0, 
                    t = n.length, o = r.determineNewCaretPosition.call(l, {
                        begin: 0,
                        end: 0
                    }, !1).begin; else {
                        for (a = e; a < t; a++) s.validPositions.splice(e, 0);
                        o = e;
                    }
                    var d = new u.Event("keypress");
                    for (a = e; a < t; a++) {
                        d.key = p[a].toString(), l.ignorable = !1;
                        var h = i.EventHandlers.keypressEvent.call(l, d, !0, !1, !1, o);
                        !1 !== h && void 0 !== h && (o = h.forwardPosition);
                    }
                    c.skipOptionalPartCharacter = f;
                }
                function h(e, t, n) {
                    var i = this, a = this.maskset, l = this.dependencyLib;
                    if (void 0 === e) for (e = t - 1; e > 0 && !a.validPositions[e]; e--) ;
                    for (var s = e; s < t; s++) {
                        if (void 0 === a.validPositions[s] && !r.isMask.call(i, s, !1)) if (0 == s ? o.getTest.call(i, s) : a.validPositions[s - 1]) {
                            var c = o.getTests.call(i, s).slice();
                            "" === c[c.length - 1].match.def && c.pop();
                            var u, p = o.determineTestTemplate.call(i, s, c);
                            if (p && (!0 !== p.match.jit || "master" === p.match.newBlockMarker && (u = a.validPositions[s + 1]) && !0 === u.match.optionalQuantifier) && ((p = l.extend({}, p, {
                                input: o.getPlaceholder.call(i, s, p.match, !0) || p.match.def
                            })).generatedInput = !0, v.call(i, s, p, !0), !0 !== n)) {
                                var d = a.validPositions[t].input;
                                return a.validPositions[t] = void 0, f.call(i, t, d, !0, !0);
                            }
                        }
                    }
                }
                function v(e, t, n, i) {
                    var a = this, l = this.maskset, s = this.opts, c = this.dependencyLib;
                    function d(e, t, n) {
                        var i = t[e];
                        if (void 0 !== i && !0 === i.match.static && !0 !== i.match.optionality && (void 0 === t[0] || void 0 === t[0].alternation)) {
                            var a = n.begin <= e - 1 ? t[e - 1] && !0 === t[e - 1].match.static && t[e - 1] : t[e - 1], r = n.end > e + 1 ? t[e + 1] && !0 === t[e + 1].match.static && t[e + 1] : t[e + 1];
                            return a && r;
                        }
                        return !1;
                    }
                    var h = 0, v = void 0 !== e.begin ? e.begin : e, m = void 0 !== e.end ? e.end : e, g = !0;
                    if (e.begin > e.end && (v = e.end, m = e.begin), i = void 0 !== i ? i : v, void 0 === n && (v !== m || s.insertMode && void 0 !== l.validPositions[i] || void 0 === t || t.match.optionalQuantifier || t.match.optionality)) {
                        var y, k = c.extend(!0, [], l.validPositions), b = r.getLastValidPosition.call(a, void 0, !0);
                        l.p = v;
                        var x = u.call(a, e) ? v : i;
                        for (y = b; y >= x; y--) l.validPositions.splice(y, 1), void 0 === t && delete l.tests[y + 1];
                        var w, P, S = i, O = S;
                        for (t && (l.validPositions[i] = c.extend(!0, {}, t), O++, S++), null == k[m] && l.jitOffset[m] && (m += l.jitOffset[m] + 1), 
                        y = t ? m : m - 1; y <= b; y++) {
                            if (void 0 !== (w = k[y]) && !0 !== w.generatedInput && (y >= m || y >= v && d(y, k, {
                                begin: v,
                                end: m
                            }))) {
                                for (;"" !== o.getTest.call(a, O).match.def; ) {
                                    if (!1 !== (P = p.call(a, O, w, s)) || "+" === w.match.def) {
                                        "+" === w.match.def && r.getBuffer.call(a, !0);
                                        var _ = f.call(a, O, w.input, "+" !== w.match.def, !0);
                                        if (g = !1 !== _, S = (_.pos || O) + 1, !g && P) break;
                                    } else g = !1;
                                    if (g) {
                                        void 0 === t && w.match.static && y === e.begin && h++;
                                        break;
                                    }
                                    if (!g && r.getBuffer.call(a), O > l.maskLength) break;
                                    O++;
                                }
                                "" == o.getTest.call(a, O).match.def && (g = !1), O = S;
                            }
                            if (!g) break;
                        }
                        if (!g) return l.validPositions = c.extend(!0, [], k), r.resetMaskSet.call(a, !0), 
                        !1;
                    } else t && o.getTest.call(a, i).match.cd === t.match.cd && (l.validPositions[i] = c.extend(!0, {}, t));
                    return r.resetMaskSet.call(a, !0), h;
                }
            }
        }, t = {};
        function n(i) {
            var a = t[i];
            if (void 0 !== a) return a.exports;
            var r = t[i] = {
                exports: {}
            };
            return e[i](r, r.exports, n), r.exports;
        }
        var i = {};
        return function() {
            var e = i;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.default = void 0, n(7149), n(3194), n(9302), n(4013), n(3851), n(219), n(207), 
            n(5296);
            var t, a = (t = n(2394)) && t.__esModule ? t : {
                default: t
            };
            e.default = a.default;
        }(), i;
    }();
}));
}(inputmask));

const Inputmask = /*@__PURE__*/getDefaultExportFromCjs(inputmask.exports);

const cpslInputCss = ":host{--container-box-shadow:none;--container-box-shadow-color:none;--container-border-color:var(--cpsl-color-input-border-active);--container-border-error-color:var(--cpsl-color-input-border-error);--container-background-color:var(--cpsl-color-input-surface-default);--container-background-color-disabled:var(--cpsl-color-input-surface-disabled);--container-border-width:1px;--container-border-radius:var(--cpsl-border-radius-input);--container-padding-top:0px;--container-padding-bottom:0px;--container-padding-end:12px;--container-padding-start:12px;--container-height:48px;--container-gap:8px;--input-background-color:var(--cpsl-color-input-surface-default);--input-background-color-disabled:var(--cpsl-color-input-surface-disabled);--input-color:var(--cpsl-color-text-primary);--input-placeholder-color:var(--cpsl-color-text-secondary);--input-font-size:var(--cpsl-font-size-body-m);--input-font-weight:400;--optional-label-color:var(--cpsl-color-text-secondary);--label-color:var(--cpsl-color-text-primary);--label-font-size:var(--cpsl-font-size-body-s);--label-margin-bottom:0px;--helper-text-color:var(--cpsl-color-text-secondary);--helper-text-error-color:var(--cpsl-color-text-error);--helper-text-icon-color:var(--cpsl-color-text-secondary);--helper-text-icon-error-color:var(--cpsl-color-text-error);--helper-text-icon-size:16px;--helper-text-font-size:var(--cpsl-font-size-body-xs);--helper-text-margin-top:0px;--button-padding:8px;display:flex;flex-direction:column;gap:4px;font-family:var(--cpsl-font-family, inherit)}:host(.contrast-text){--input-color:var(--cpsl-color-contrast)}:host(:not(.has-value)){--container-border-color:var(--cpsl-color-input-border-placeholder);--input-color:var(--cpsl-color-text-secondary)}:host(.disabled){--container-background-color:var(--container-background-color-disabled);--input-background-color:var(--input-background-color-disabled);--input-color:var(--cpsl-color-text-disabled);--container-border-color:transparent}:host(.focused){--container-box-shadow:0px 0px 0px 2px var(--container-box-shadow-color);--container-border-color:var(--cpsl-color-input-border-active);--container-background-color:var(--cpsl-color-input-surface-default)}.input-container{-webkit-padding-start:var(--container-padding-start);padding-inline-start:var(--container-padding-start);-webkit-padding-end:var(--container-padding-end);padding-inline-end:var(--container-padding-end);padding-top:var(--container-padding-top);padding-bottom:var(--container-padding-bottom);display:flex;align-items:center;box-sizing:border-box;height:var(--container-height);gap:var(--container-gap);border-style:var(--container-border-style, solid);border-width:var(--container-border-width);border-color:var(--container-border-color);border-radius:var(--container-border-radius);background:var(--container-background-color);box-shadow:var(--container-box-shadow)}.input-container.textarea{height:auto;min-height:var(--container-height)}.error-container{border-color:var(--container-border-error-color)}.native-input{flex:1;min-width:0;border:none;height:100%;box-sizing:border-box;font-size:var(--input-font-size);font-weight:var(--input-font-weight);color:var(--input-color);background:var(--input-background-color);width:var(--input-width, auto);text-align:var(--input-text-align, left);resize:none;font-family:var(--cpsl-font-family, inherit)}.native-input:focus,.native-input:focus-visible{outline:none}.native-input::placeholder{color:var(--input-placeholder-color);opacity:1;}.native-input::-moz-selection{color:var(--cpsl-color-text-inverted);background:var(--cpsl-color-background-64)}.native-input::selection{color:var(--cpsl-color-text-inverted);background:var(--cpsl-color-background-64)}.label{display:inline-block;color:var(--label-color);font-size:var(--label-font-size);font-weight:500;margin-bottom:var(--label-margin-bottom)}.optional-label{display:inline-block;color:var(--optional-label-color);font-size:var(--label-font-size);font-weight:500}.helper-text-container{display:flex;align-items:center;gap:4px;color:var(--helper-text-color);font-size:var(--helper-text-font-size);font-weight:500;margin-top:var(--helper-text-margin-top)}.helper-text-container cpsl-icon{--height:var(--helper-text-icon-size);--width:var(--helper-text-icon-size);--icon-color:var(--helper-text-icon-color)}.error-text{color:var(--helper-text-error-color)}.error-text cpsl-icon{--icon-color:var(--helper-text-icon-error-color)}:host ::slotted([slot=start]){flex:0 0 auto}:host ::slotted([slot=end]){flex:0 0 auto}:host ::slotted(cpsl-icon){--icon-color:var(--input-color)}:host ::slotted(cpsl-button){width:calc(var(--container-height) - var(--button-padding) * 2);height:calc(var(--container-height) - var(--button-padding) * 2);--button-border-radius:calc(var(--container-border-radius) - 4px);--button-padding-top:4px;--button-padding-start:4px;--button-padding-end:4px;--button-padding-bottom:4px}:host slot[name=end]::slotted(cpsl-button){margin-right:calc((var(--container-padding-end) - var(--button-padding)) * -1)}:host slot[name=start]::slotted(cpsl-button){margin-left:calc((var(--container-padding-end) - var(--button-padding)) * -1)}";
const CpslInputStyle0 = cpslInputCss;

const CpslInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslInput = createEvent(this, "cpslInput", 7);
        this.cpslChange = createEvent(this, "cpslChange", 7);
        this.cpslBlur = createEvent(this, "cpslBlur", 7);
        this.cpslFocus = createEvent(this, "cpslFocus", 7);
        this.cpslPaste = createEvent(this, "cpslPaste", 7);
        this.inputId = `cpsl-input-${inputIds$1++}`;
        this.onInput = (ev) => {
            const input = ev.target;
            let _value = input.value || '';
            if (input.inputmask)
                _value = input.inputmask.unmaskedvalue();
            if (Boolean(input)) {
                this.value = _value;
                input.value === '' ? this.disableSlots() : this.enableSlots();
            }
            this.emitInputChange(ev);
        };
        this.onChange = (ev) => {
            this.emitValueChange(ev);
        };
        this.onBlur = (ev) => {
            this.hasFocus = false;
            if (this.focusedValue !== this.value) {
                /**
                 * Emits the `cpslChange` event when the input value
                 * is different than the value when the input was focused.
                 */
                this.emitValueChange(ev);
            }
            this.cpslBlur.emit(ev);
        };
        this.onFocus = (ev) => {
            this.hasFocus = true;
            this.focusedValue = this.value;
            this.autoselect && ev.target.select();
            this.cpslFocus.emit(ev);
        };
        this.onPaste = (ev) => {
            var _a;
            ev.stopPropagation();
            ev.preventDefault();
            const input = ev.target;
            const pasteData = ((_a = ev.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text')) || '';
            // Manually set the value & cursor position
            const initialSelectionStart = input.selectionStart;
            const newVal = `${input.value.slice(0, input.selectionStart)}${pasteData}${input.value.slice(input.selectionEnd, input.value.length)}`;
            input.value = newVal;
            // this.value = newVal;
            input.selectionEnd = initialSelectionStart + pasteData.length;
            let _value = input.value || '';
            if (input.inputmask)
                _value = input.inputmask.unmaskedvalue();
            this.value = _value;
            this.value === '' ? this.disableSlots() : this.enableSlots();
            // Emit the cpslPaste event
            this.cpslPaste.emit(ev);
            // Emit the cpslChange event since the value was modified by paste
            this.emitInputChange(ev);
        };
        this.focusInput = () => {
            this.nativeInput.focus();
        };
        this.hasFocus = false;
        this.as = 'input';
        this.autocapitalize = 'off';
        this.autocomplete = 'off';
        this.autocorrect = 'off';
        this.noAutoDisable = undefined;
        this.autofocus = false;
        this.autoselect = false;
        this.disabled = false;
        this.contrastText = false;
        this.enterkeyhint = undefined;
        this.errorText = undefined;
        this.fitContent = false;
        this.mask = undefined;
        this.isPhone = undefined;
        this.helperText = undefined;
        this.inputmode = undefined;
        this.label = undefined;
        this.max = undefined;
        this.maxlength = undefined;
        this.min = undefined;
        this.minlength = undefined;
        this.multiple = undefined;
        this.name = this.inputId;
        this.pattern = undefined;
        this.placeholder = undefined;
        this.readonly = false;
        this.required = false;
        this.rows = 5;
        this.showOptionalLabel = false;
        this.spellcheck = false;
        this.startIconSrc = undefined;
        this.startIcon = undefined;
        this.step = undefined;
        this.type = 'text';
        this.value = undefined;
    }
    handleDisable() {
        if (this.disabled) {
            this.disableSlots();
        }
        else {
            this.enableSlots();
        }
    }
    handleSetupMask() {
        var _a;
        if (this.nativeInput) {
            if (this.mask) {
                const [oldValue, oldCursorPosition] = [this.value, this.nativeInput.selectionEnd];
                Inputmask({ mask: this.mask, showMaskOnHover: false }).mask(this.nativeInput);
                this.nativeInput.inputmask.shadowRoot = this.el.shadowRoot;
                if (oldCursorPosition === oldValue.length && this.isPhone) {
                    const firstUnderscore = this.nativeInput.value.indexOf('_');
                    this.nativeInput.setSelectionRange(firstUnderscore, firstUnderscore);
                }
            }
            else {
                if (this.nativeInput.inputmask) {
                    this.nativeInput.inputmask.remove();
                }
                this.nativeInput.value = (_a = this.value) !== null && _a !== void 0 ? _a : '';
            }
        }
    }
    handleValueChange() {
        var _a;
        if (!this.value) {
            this.nativeInput.value = (_a = this.value) !== null && _a !== void 0 ? _a : '';
        }
    }
    componentDidLoad() {
        this.initButtons();
        if (this.value) {
            this.enableSlots();
        }
        else {
            this.disableSlots();
        }
        this.handleSetupMask();
    }
    disableSlots() {
        var _a, _b;
        if (!this.noAutoDisable) {
            (_a = this.endEl) === null || _a === void 0 ? void 0 : _a.setAttribute('disabled', 'true');
            (_b = this.startEl) === null || _b === void 0 ? void 0 : _b.setAttribute('disabled', 'true');
        }
    }
    enableSlots() {
        var _a, _b;
        (_a = this.endEl) === null || _a === void 0 ? void 0 : _a.setAttribute('disabled', 'false');
        (_b = this.startEl) === null || _b === void 0 ? void 0 : _b.setAttribute('disabled', 'false');
    }
    initButtons() {
        var _a, _b;
        if (((_a = this.endEl) === null || _a === void 0 ? void 0 : _a.tagName) === 'CPSL-BUTTON') {
            this.endEl.setAttribute('full-width', 'true');
            this.endEl.addEventListener('mousedown', e => {
                e.preventDefault();
            });
        }
        if (((_b = this.startEl) === null || _b === void 0 ? void 0 : _b.tagName) === 'CPSL-BUTTON') {
            this.startEl.setAttribute('full-width', 'true');
            this.startEl.addEventListener('mousedown', e => {
                e.preventDefault();
            });
        }
    }
    /**
     * Emits a `cpslInput` event.
     */
    emitInputChange(event) {
        this.cpslInput.emit({ value: this.value || '', event });
    }
    /**
     * Emits a `cpslChange` event.
     *
     * This API should be called for user committed changes.
     * This API should not be used for external value changes.
     */
    emitValueChange(event) {
        const { value } = this;
        // Checks for both null and undefined values
        const newValue = value == null ? value : value.toString();
        // Emitting a value change should update the internal state for tracking the focused value
        this.focusedValue = newValue;
        this.cpslChange.emit({ value: newValue, event });
    }
    get startEl() {
        return this.el.querySelector('[slot="start"]');
    }
    get endEl() {
        return this.el.querySelector('[slot="end"]');
    }
    render() {
        var _a, _b, _c, _d;
        return (h(Host, { key: '9b5abde0435d0acbb4f453e3c7b4c7d1da89a165', class: { 'disabled': this.disabled, 'focused': this.hasFocus, 'has-value': Boolean(this.focusedValue) || Boolean(this.value), 'contrast-text': this.contrastText } }, this.label && (h("label", { key: '1ef8472e4ab2a114a3ac961ed5fbcafe82041631', class: "label", htmlFor: this.inputId }, this.label, this.required ? '*' : ' ', !this.required && this.showOptionalLabel ? h("span", { class: "optional-label" }, "(optional)") : '')), h("div", { key: '8945dd09731255aab8acb91f4e12f5285ec86930', class: { 'input-container': true, 'error-container': Boolean(this.errorText), 'textarea': this.as === 'textarea' } }, h("slot", { key: '2f36a7cb8086269c51a4924dc671245a31eddb4f', name: "start" }), h(this.as, { key: '9e244a91bc8909db5fcf54fd10ccf221df8846c2', part: "native-input", class: { 'native-input': true }, ref: input => (this.nativeInput = input), id: this.inputId, disabled: this.disabled, autoCapitalize: this.autocapitalize, autoComplete: this.autocomplete, autoCorrect: this.autocorrect, autoFocus: this.autofocus, enterKeyHint: this.enterkeyhint, inputMode: this.inputmode, min: this.min, max: this.max, minLength: this.minlength, maxLength: this.maxlength, multiple: this.multiple, name: this.name, pattern: this.pattern, placeholder: this.placeholder || '', readOnly: this.readonly, required: this.required, size: this.fitContent ? ((_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 1) : undefined, spellcheck: this.spellcheck, type: this.type, value: (_c = this.value) !== null && _c !== void 0 ? _c : '', rows: this.rows, onInput: this.onInput, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onClick: this.focusInput, onPaste: this.onPaste }), h("slot", { key: '3f3f289699ca56a6c9d0b5e01e702c6a301697dc', name: "end" })), (this.errorText || this.helperText) && (h("div", { key: 'f413751aca4b5059a6b3e6151182b19b09a85d89', class: { 'helper-text-container': true, 'error-text': Boolean(this.errorText) } }, h("span", { key: '5189ac80ac4356f267412a93564b077888a206cf' }, (_d = this.errorText) !== null && _d !== void 0 ? _d : this.helperText)))));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "disabled": ["handleDisable"],
        "mask": ["handleSetupMask"],
        "value": ["handleValueChange"]
    }; }
};
let inputIds$1 = 0;
CpslInput.style = CpslInputStyle0;

const cpslNavButtonGroupCss = ":host{display:flex;flex-direction:column;gap:8px;padding:0px 16px;box-sizing:border-box;width:100%}";
const CpslNavButtonGroupStyle0 = cpslNavButtonGroupCss;

const CpslNavButtonGroup = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    componentWillRender() {
        var _a;
        if ((_a = this.otherSlots) === null || _a === void 0 ? void 0 : _a.length) {
            console.error('cpsl-button is the only valid child of cpsl-nav-button-group');
            this.otherSlots.forEach(item => item.remove());
        }
    }
    get otherSlots() {
        return this.el.querySelectorAll('&> *:not(cpsl-nav-button)');
    }
    render() {
        return (h(Host, { key: 'd52d419d0bcd96e2759a6a39f048f823c3d2ba69' }, h("slot", { key: '851d194ca0b7b0caef7b09420918eb4cdcbee137' })));
    }
    get el() { return getElement(this); }
};
CpslNavButtonGroup.style = CpslNavButtonGroupStyle0;

const cpslOverlayCss = ":host{position:fixed;width:100%;height:100%;inset:0px;z-index:10001;opacity:0%;display:none;background:linear-gradient(180deg, rgba(0, 0, 0, 0.14) 0%, rgba(0, 0, 0, 0.7) 100%)}:host(.over-modal){z-index:10005}";
const CpslOverlayStyle0 = cpslOverlayCss;

const CpslOverlay = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.enterTransitionDuration = 0.5;
        this.exitTransitionDuration = 0.5;
        this.open = undefined;
        this.zIndexOverride = undefined;
    }
    toggleHeight() {
        this.open
            ? gsapWithCSS.timeline({ defaults: { duration: this.enterTransitionDuration } }).to(this.el, { display: 'block', opacity: 1 })
            : gsapWithCSS.timeline({ defaults: { duration: this.exitTransitionDuration } }).to(this.el, { display: 'none', opacity: 0 });
        if (this.open) {
            document.documentElement.style.overflow = 'hidden';
        }
        else {
            // Setting a timeout here to prevent modal from shifting when the scroll bar appears
            setTimeout(() => {
                document.documentElement.style.overflow = 'auto';
            }, this.exitTransitionDuration * 1000);
        }
    }
    componentDidLoad() {
        if (this.open) {
            gsapWithCSS.timeline({ defaults: { duration: this.enterTransitionDuration } }).to(this.el, { display: 'block', opacity: 1 });
            document.documentElement.style.overflow = 'hidden';
        }
    }
    render() {
        return (h(Host, { key: '62199abc410f605818c392e64e0bcfc1a33ec8a5', style: this.zIndexOverride ? { zIndex: `${this.zIndexOverride}` } : {} }, h("slot", { key: 'df78ed55eac09acb15743c933ad0ee38a3d5b93a' })));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "open": ["toggleHeight"]
    }; }
};
CpslOverlay.style = CpslOverlayStyle0;

const cpslPaginationCss = ":host{display:block}.icon{--height:20px;--width:20px}.start-icon{transform:rotate(180deg)}.arrow-button{--button-secondary-icon-color:var(--cpsl-color-text-tertiary)}";
const CpslPaginationStyle0 = cpslPaginationCss;

const CpslPagination = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslPaginationChanged = createEvent(this, "cpslPaginationChanged", 7);
        this.handlePrevClick = () => {
            if (this.currentPage > 0) {
                this.currentPage--;
            }
        };
        this.handleNextClick = () => {
            if (this.currentPage < this.totalPages - 1) {
                this.currentPage++;
            }
        };
        this.handlePageClick = (value) => () => {
            if (value >= 0 && value <= this.totalPages - 1) {
                this.currentPage = value;
            }
        };
        this.currentPage = 0;
        this.initialPage = undefined;
        this.totalPages = undefined;
        this.visiblePages = 5;
    }
    watchChange() {
        this.cpslPaginationChanged.emit(this.currentPage);
    }
    componentWillLoad() {
        var _a;
        this.currentPage = (_a = this.initialPage) !== null && _a !== void 0 ? _a : 0;
        if (this.visiblePages < 5) {
            this.visiblePages = 5;
        }
    }
    render() {
        const filteredPages = this.totalPages <= this.visiblePages ? [...Array(this.totalPages).keys()] : [];
        if (this.totalPages > this.visiblePages) {
            filteredPages.push(0);
            const isFirstSelected = this.currentPage === 0;
            const isLastSelected = this.currentPage === this.totalPages - 1;
            const isFirstOrLastSelected = isFirstSelected || isLastSelected;
            let remainingVisible = this.visiblePages - (isFirstOrLastSelected ? 2 : 3);
            const halfRemaining = Math.round(remainingVisible / 2);
            const numberBefore = Math.max(this.currentPage - 1, 0);
            const numberAfter = Math.max(this.totalPages - 2 - this.currentPage, 0);
            let beforeHalf = halfRemaining;
            let afterHalf = remainingVisible - halfRemaining;
            if (numberBefore >= beforeHalf) {
                if (numberAfter < afterHalf) {
                    beforeHalf += afterHalf - numberAfter;
                    afterHalf = numberAfter;
                }
            }
            else {
                afterHalf += beforeHalf - numberBefore;
                beforeHalf = numberBefore;
            }
            while (beforeHalf > 0) {
                filteredPages.push(this.currentPage - beforeHalf);
                beforeHalf--;
            }
            if (!isFirstSelected) {
                filteredPages.push(this.currentPage);
            }
            const pagesAfter = [];
            while (afterHalf > 0) {
                pagesAfter.push(this.currentPage + afterHalf);
                afterHalf--;
            }
            filteredPages.push(...pagesAfter.reverse());
            if (!isLastSelected) {
                filteredPages.push(this.totalPages - 1);
            }
        }
        return (h(Host, { key: '030d0a78198c77a243ae9996dd8192437c3c370b' }, h("cpsl-button-group", { key: 'b12f592a5cf2cdab91c82516206e4a831bdad5d6', selectedId: `${this.currentPage}` }, h("cpsl-button", { key: 'a24be555c3be19f63a5011aacac7046dbd8bdecd', class: "arrow-button", onClick: this.handlePrevClick }, h("cpsl-icon", { key: 'e82fe20b2091ede6ac99c16dfb433b47d7490293', class: { 'icon': true, 'start-icon': true }, icon: "arrowNarrow" })), filteredPages.map(page => (h("cpsl-button", { key: page, variant: "secondary", fullWidth: true, id: `${page}`, onClick: this.handlePageClick(page) }, h("cpsl-text", { variant: "bodyS" }, page + 1)))), h("cpsl-button", { key: '3d4c5c6b211a1543818746da22739df63a4afcee', class: "arrow-button", onClick: this.handleNextClick }, h("cpsl-icon", { key: 'f623fb7dc739556480bc90d1ce296baa8f5afcb0', class: "icon", icon: "arrowNarrow" })))));
    }
    static get watchers() { return {
        "currentPage": ["watchChange"]
    }; }
};
CpslPagination.style = CpslPaginationStyle0;

const cpslPillCss = ":host{--pill-text-color:var(--cpsl-pill-text);--pill-text-size:clamp(10px, 0.625rem, 15px);--pill-text-line-height:100%;--pill-container-height:18px;--pill-container-background-color:var(--cpsl-color-pill-container-background);--pill-container-border-color:var(--cpsl-color-pill-container-border);--pill-container-padding-start:8px;--pill-container-padding-end:8px;--pill-container-border-radius:var(--cpsl-border-radius-pill);font-family:var(--cpsl-font-family, inherit);display:inline-block}.pill-container{-webkit-padding-start:var(--pill-container-padding-start);padding-inline-start:var(--pill-container-padding-start);-webkit-padding-end:var(--pill-container-padding-end);padding-inline-end:var(--pill-container-padding-end);padding-top:var(--pill-container-padding-top);padding-bottom:var(--pill-container-padding-bottom);display:flex;justify-content:center;align-items:center;box-sizing:border-box;height:var(--pill-container-height);background:var(--pill-container-background-color);border:1px solid;border-color:var(--pill-container-border-color);border-radius:var(--pill-container-border-radius);color:var(--pill-text-color);font-size:var(--pill-text-size);line-height:var(--pill-text-line-height)}.pill-container span{display:inline-block}";
const CpslPillStyle0 = cpslPillCss;

const CpslPill = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.text = undefined;
    }
    render() {
        return (h(Host, { key: 'a349d2f48d6ebc223437e1a9ca125587061659dc' }, h("div", { key: '1bf3f63a8c41fb7fa662201817f5884e3c3926fd', class: "pill-container" }, h("span", { key: 'd9ba2ff7fd44d242b5ae0ee037ae6b9c85ff4834' }, this.text))));
    }
};
CpslPill.style = CpslPillStyle0;

const cpslPopoverCss = ":host{position:fixed;display:block;z-index:-1;overflow:auto;transform:var(--th, ) var(--tv, )}:host(.open){z-index:10006}.container{visibility:hidden;height:0px}.open{visibility:visible;height:auto;z-index:10006}:host(.transform-h-left){--th:translateX(0)}:host(.transform-h-center){--th:translateX(-50%)}:host(.transform-h-right){--th:translateX(-100%)}:host(.transform-v-top){--tv:translateY(0)}:host(.transform-v-center){--tv:translateY(-50%)}:host(.transform-v-bottom){--tv:translateY(-100%)}";
const CpslPopoverStyle0 = cpslPopoverCss;

var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const CpslPopover = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslOpen = createEvent(this, "cpslOpen", 7);
        this.cpslClose = createEvent(this, "cpslClose", 7);
        this.startedInside = false;
        this.startedWhenMounted = false;
        this.configureTriggerInteraction = () => {
            const { trigger, triggerAction, destroyTriggerInteraction } = this;
            if (destroyTriggerInteraction) {
                destroyTriggerInteraction();
            }
            if (trigger === undefined) {
                return;
            }
            this.triggerEl = document.getElementById(trigger);
            if (!this.triggerEl) {
                console.error(`A trigger element with the ID "${trigger}" was not found in the DOM.`, this.el);
                return;
            }
            let triggerCallbacks = [];
            /**
             * Based upon the kind of trigger interaction
             * the user wants, we setup the correct event
             * listeners.
             */
            switch (triggerAction) {
                case 'hover':
                    triggerCallbacks = [
                        {
                            eventName: 'mouseenter',
                            callback: () => __awaiter$1(this, void 0, void 0, function* () {
                                this.present();
                            }),
                        },
                        {
                            eventName: 'mouseleave',
                            callback: () => {
                                if (!this.containerEl.matches(':hover')) {
                                    this.close();
                                }
                                else {
                                    this.containerEl.addEventListener('mouseleave', () => {
                                        this.close();
                                    });
                                }
                            },
                        },
                        {
                            eventName: 'click',
                            callback: (ev) => ev.stopPropagation(),
                        },
                    ];
                    break;
                case 'click':
                default:
                    triggerCallbacks = [
                        {
                            eventName: 'mousedown',
                            callback: e => {
                                var _a;
                                const targetId = (_a = e.target.id) !== null && _a !== void 0 ? _a : '';
                                if (targetId === 'ignore-click') {
                                    return;
                                }
                                if (this.preventBlur) {
                                    e.preventDefault();
                                }
                                if (!this.open) {
                                    this.present();
                                }
                                else if (e.target === this.triggerEl) {
                                    this.close();
                                }
                            },
                        },
                        {
                            eventName: 'touchstart',
                            callback: e => {
                                var _a;
                                const targetId = (_a = e.target.id) !== null && _a !== void 0 ? _a : '';
                                if (targetId === 'ignore-click') {
                                    return;
                                }
                                if (this.preventBlur) {
                                    e.preventDefault();
                                }
                                this.present();
                            },
                        },
                    ];
                    break;
            }
            triggerCallbacks.forEach(({ eventName, callback }) => this.triggerEl.addEventListener(eventName, callback));
            this.destroyTriggerInteraction = () => {
                triggerCallbacks.forEach(({ eventName, callback }) => this.triggerEl.removeEventListener(eventName, callback));
            };
        };
        this.setPosition = () => {
            var _a;
            const anchorEl = (_a = this.anchorEl) !== null && _a !== void 0 ? _a : this.triggerEl;
            if (anchorEl && typeof window !== 'undefined') {
                const windowWidth = window.innerWidth;
                const windowHeight = window.innerHeight;
                const elWidth = this.el.clientWidth;
                const elHeight = this.el.clientHeight;
                const { top, left, height, width } = anchorEl.getBoundingClientRect();
                switch (this.anchorOriginHorizontal) {
                    case 'left': {
                        this.positionX = left;
                        break;
                    }
                    case 'center': {
                        this.positionX = left + width / 2;
                        break;
                    }
                    case 'right': {
                        this.positionX = left + width;
                        break;
                    }
                }
                switch (this.anchorOriginVertical) {
                    case 'top': {
                        this.positionY = top;
                        break;
                    }
                    case 'center': {
                        this.positionY = top + height / 2;
                        break;
                    }
                    case 'bottom': {
                        this.positionY = top + height;
                        break;
                    }
                }
                if (this.positionY < this.windowPadding) {
                    this.positionY = this.windowPadding;
                }
                if (this.positionY + elHeight > windowHeight - 16) {
                    this.positionY = windowHeight - this.windowPadding - elHeight;
                }
                if (this.positionX < this.windowPadding) {
                    this.positionX = this.windowPadding;
                }
                if (this.positionX + elWidth > windowWidth - 16) {
                    this.positionX = windowWidth - this.windowPadding - elWidth;
                }
            }
        };
        this.validateEventStart = event => {
            this.startedWhenMounted = !!this.triggerEl;
            this.startedInside = this.triggerEl.contains(event.target);
            this.present();
        };
        this.handleClickOutside = (event) => {
            // Do nothing if `mousedown` or `touchstart` started inside ref element
            if (this.startedInside || !this.startedWhenMounted)
                return;
            // Do nothing if clicking ref's element or descendent elements
            if (!this.triggerEl || this.triggerEl.contains(event.target))
                return;
            if (this.open) {
                event.preventDefault();
                this.close();
            }
        };
        this.present = () => {
            if (!this.open && !this.disabled) {
                this.open = true;
                this.cpslOpen.emit();
                // Using a small timeout here to ensure the popover is open before attempting to do position calculations
                setTimeout(() => {
                    this.setPosition();
                    this.hasSetInitialPosition = true;
                }, 20);
            }
        };
        this.close = () => {
            this.open = false;
            this.startedInside = false;
            this.cpslClose.emit();
            this.hasSetInitialPosition = false;
        };
        this.open = false;
        this.hasSetInitialPosition = false;
        this.positionX = undefined;
        this.positionY = undefined;
        this.anchorEl = undefined;
        this.anchorOriginHorizontal = 'left';
        this.anchorOriginVertical = 'bottom';
        this.autoWidth = true;
        this.disabled = undefined;
        this.preventBlur = undefined;
        this.transformOriginHorizontal = 'left';
        this.transformOriginVertical = 'top';
        this.triggerAction = 'click';
        this.trigger = undefined;
        this.windowPadding = 16;
    }
    /**
     * Call to close the popover manually.
     */
    closePopover() {
        return __awaiter$1(this, void 0, void 0, function* () {
            this.close();
        });
    }
    onTriggerChange() {
        this.configureTriggerInteraction();
    }
    onAnchorChange() {
        this.setPosition();
    }
    onOpenChange() {
        if (typeof window !== 'undefined') {
            if (this.open) {
                window.addEventListener('mousedown', this.validateEventStart);
                window.addEventListener('touchstart', this.validateEventStart);
                window.addEventListener('click', this.handleClickOutside);
                window.addEventListener('scroll', () => this.setPosition(), true);
                window.addEventListener('resize', () => this.setPosition(), true);
            }
            else {
                window.removeEventListener('mousedown', this.validateEventStart);
                window.removeEventListener('touchstart', this.validateEventStart);
                window.removeEventListener('click', this.handleClickOutside);
                window.removeEventListener('scroll', () => this.setPosition(), true);
                window.removeEventListener('resize', () => this.setPosition(), true);
            }
        }
    }
    componentDidLoad() {
        this.configureTriggerInteraction();
    }
    get containerEl() {
        var _a, _b;
        return (_b = (_a = this.el) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.getElementById('container');
    }
    render() {
        var _a;
        return (h(Host, { key: '37ea2f5b4c7b73aed811317d813ceb9bce8bc38f', class: {
                'open': this.open,
                'transform-h-left': this.transformOriginHorizontal === 'left',
                'transform-h-center': this.transformOriginHorizontal === 'center',
                'transform-h-right': this.transformOriginHorizontal === 'right',
                'transform-v-top': this.transformOriginVertical === 'top',
                'transform-v-center': this.transformOriginVertical === 'center',
                'transform-v-bottom': this.transformOriginVertical === 'bottom',
            }, style: {
                top: `${this.positionY}px`,
                left: `${this.positionX}px`,
                width: !this.open ? '0px' : this.autoWidth ? 'auto' : `${(_a = this.triggerEl) === null || _a === void 0 ? void 0 : _a.clientWidth}px`,
            } }, h("div", { key: '900e9d9089b5cb97ddfb37c10f1ee6e340ca48f6', id: "container", class: { container: true, open: this.open }, style: {
                visibility: this.hasSetInitialPosition ? 'visible' : 'hidden',
            } }, h("slot", { key: 'd734f622b563b747ee6bc4deadfa4a515e91b0d7' }))));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "trigger": ["onTriggerChange"],
        "triggerAction": ["onTriggerChange"],
        "preventBlur": ["onTriggerChange"],
        "anchorOriginHorizontal": ["onAnchorChange"],
        "anchorOriginVertical": ["onAnchorChange"],
        "open": ["onOpenChange"]
    }; }
};
CpslPopover.style = CpslPopoverStyle0;

const cpslProgressIndicatorCss = ":host{--step-height:3px;--step-active-color:var(--cpsl-color-progressIndicator-active);--step-next-color:var(--cpsl-color-progressIndicator-next);--step-previous-color:var(--cpsl-color-progressIndicator-previous);display:flex;align-items:center;justify-content:center;gap:4px}.step{background:var(--step-next-color);border-radius:var(--step-border-radius, calc(var(--step-height) * 2));height:var(--step-height);flex:1;transition:all 0.5s}.previous{background:var(--step-previous-color)}.active{background:var(--step-active-color);flex:2}";
const CpslProgressIndicatorStyle0 = cpslProgressIndicatorCss;

const CpslProgressIndicator = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.totalSteps = undefined;
        this.step = undefined;
    }
    render() {
        const steps = new Array(this.totalSteps).fill(0).map((_, i) => {
            let resp = { active: false, previous: false };
            if (i === this.step) {
                resp.active = true;
            }
            else if (i < this.step) {
                resp.previous = true;
            }
            return resp;
        });
        return (h(Host, null, steps.map(step => (h("div", { class: { step: true, active: step.active, previous: step.previous } })))));
    }
};
CpslProgressIndicator.style = CpslProgressIndicatorStyle0;

var browser = {};

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

var canPromise$1 = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
};

var qrcode = {};

var utils$1 = {};

let toSJISFunction;
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
];

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
utils$1.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
};

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
utils$1.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
};

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
utils$1.getBCHDigit = function (data) {
  let digit = 0;

  while (data !== 0) {
    digit++;
    data >>>= 1;
  }

  return digit
};

utils$1.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f;
};

utils$1.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
};

utils$1.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
};

var errorCorrectionLevel = {};

(function (exports) {
exports.L = { bit: 1 };
exports.M = { bit: 0 };
exports.Q = { bit: 3 };
exports.H = { bit: 2 };

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase();

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
};

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
};
}(errorCorrectionLevel));

function BitBuffer$1 () {
  this.buffer = [];
  this.length = 0;
}

BitBuffer$1.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8);
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1);
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8));
    }

    this.length++;
  }
};

var bitBuffer = BitBuffer$1;

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */

function BitMatrix$1 (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size;
  this.data = new Uint8Array(size * size);
  this.reservedBit = new Uint8Array(size * size);
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix$1.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col;
  this.data[index] = value;
  if (reserved) this.reservedBit[index] = true;
};

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix$1.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
};

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix$1.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value;
};

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix$1.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
};

var bitMatrix = BitMatrix$1;

var alignmentPattern = {};

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

(function (exports) {
const getSymbolSize = utils$1.getSymbolSize;

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2;
  const size = getSymbolSize(version);
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
  const positions = [size - 7]; // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals;
  }

  positions.push(6); // First coord is always 6

  return positions.reverse()
};

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = [];
  const pos = exports.getRowColCoords(version);
  const posLength = pos.length;

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]]);
    }
  }

  return coords
};
}(alignmentPattern));

var finderPattern = {};

const getSymbolSize = utils$1.getSymbolSize;
const FINDER_PATTERN_SIZE = 7;

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
finderPattern.getPositions = function getPositions (version) {
  const size = getSymbolSize(version);

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
};

var maskPattern = {};

/**
 * Data mask pattern reference
 * @type {Object}
 */

(function (exports) {
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
};

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
};

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
};

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size;
  let points = 0;
  let sameCountCol = 0;
  let sameCountRow = 0;
  let lastCol = null;
  let lastRow = null;

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0;
    lastCol = lastRow = null;

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col);
      if (module === lastCol) {
        sameCountCol++;
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
        lastCol = module;
        sameCountCol = 1;
      }

      module = data.get(col, row);
      if (module === lastRow) {
        sameCountRow++;
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
        lastRow = module;
        sameCountRow = 1;
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
  }

  return points
};

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size;
  let points = 0;

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1);

      if (last === 4 || last === 0) points++;
    }
  }

  return points * PenaltyScores.N2
};

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size;
  let points = 0;
  let bitsCol = 0;
  let bitsRow = 0;

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0;
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col);
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row);
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
    }
  }

  return points * PenaltyScores.N3
};

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0;
  const modulesCount = data.data.length;

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i];

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10);

  return k * PenaltyScores.N4
};

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size;

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col));
    }
  }
};

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length;
  let bestPattern = 0;
  let lowerPenalty = Infinity;

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p);
    exports.applyMask(p, data);

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data);

    // Undo previously applied mask
    exports.applyMask(p, data);

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty;
      bestPattern = p;
    }
  }

  return bestPattern
};
}(maskPattern));

var errorCorrectionCode = {};

const ECLevel$1 = errorCorrectionLevel;

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
];

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
];

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
errorCorrectionCode.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel$1.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel$1.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel$1.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel$1.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
};

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
errorCorrectionCode.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel$1.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel$1.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel$1.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel$1.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
};

var polynomial = {};

var galoisField = {};

const EXP_TABLE = new Uint8Array(512);
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1;
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x;
    LOG_TABLE[x] = i;

    x <<= 1; // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D;
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255];
  }
}());

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
galoisField.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
};

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
galoisField.exp = function exp (n) {
  return EXP_TABLE[n]
};

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
galoisField.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
};

(function (exports) {
const GF = galoisField;

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1);

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j]);
    }
  }

  return coeff
};

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident);

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0];

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff);
    }

    // remove all zeros from buffer head
    let offset = 0;
    while (offset < result.length && result[offset] === 0) offset++;
    result = result.slice(offset);
  }

  return result
};

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1]);
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]));
  }

  return poly
};
}(polynomial));

const Polynomial = polynomial;

function ReedSolomonEncoder$1 (degree) {
  this.genPoly = undefined;
  this.degree = degree;

  if (this.degree) this.initialize(this.degree);
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder$1.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree;
  this.genPoly = Polynomial.generateECPolynomial(this.degree);
};

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder$1.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree);
  paddedData.set(data);

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly);

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length;
  if (start > 0) {
    const buff = new Uint8Array(this.degree);
    buff.set(remainder, start);

    return buff
  }

  return remainder
};

var reedSolomonEncoder = ReedSolomonEncoder$1;

var version$1 = {};

var mode = {};

var versionCheck = {};

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */

versionCheck.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
};

var regex = {};

const numeric = '[0-9]+';
const alphanumeric = '[A-Z $%*+\\-./:]+';
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+';
kanji = kanji.replace(/u/g, '\\u');

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+';

regex.KANJI = new RegExp(kanji, 'g');
regex.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
regex.BYTE = new RegExp(byte, 'g');
regex.NUMERIC = new RegExp(numeric, 'g');
regex.ALPHANUMERIC = new RegExp(alphanumeric, 'g');

const TEST_KANJI = new RegExp('^' + kanji + '$');
const TEST_NUMERIC = new RegExp('^' + numeric + '$');
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');

regex.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
};

regex.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
};

regex.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
};

(function (exports) {
const VersionCheck = versionCheck;
const Regex = regex;

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
};

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
};

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
};

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
};

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
};

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
};

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
};

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
};

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
};

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase();

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
};
}(mode));

(function (exports) {
const Utils = utils$1;
const ECCode = errorCorrectionCode;
const ECLevel = errorCorrectionLevel;
const Mode = mode;
const VersionCheck = versionCheck;

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
const G18_BCH = Utils.getBCHDigit(G18);

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0;

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version);
    totalBits += reservedBits + data.getBitsLength();
  });

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion);
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
};

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE;

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version);

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
};

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg;

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0];
  } else {
    seg = data;
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
};

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12;

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH));
  }

  return (version << 12) | d
};
}(version$1));

var formatInfo = {};

const Utils$3 = utils$1;

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
const G15_BCH = Utils$3.getBCHDigit(G15);

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
formatInfo.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask);
  let d = data << 10;

  while (Utils$3.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils$3.getBCHDigit(d) - G15_BCH));
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
};

var segments = {};

const Mode$4 = mode;

function NumericData (data) {
  this.mode = Mode$4.NUMERIC;
  this.data = data.toString();
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
};

NumericData.prototype.getLength = function getLength () {
  return this.data.length
};

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
};

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value;

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3);
    value = parseInt(group, 10);

    bitBuffer.put(value, 10);
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i;
  if (remainingNum > 0) {
    group = this.data.substr(i);
    value = parseInt(group, 10);

    bitBuffer.put(value, remainingNum * 3 + 1);
  }
};

var numericData = NumericData;

const Mode$3 = mode;

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
];

function AlphanumericData (data) {
  this.mode = Mode$3.ALPHANUMERIC;
  this.data = data;
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
};

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
};

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
};

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i;

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11);
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
  }
};

var alphanumericData = AlphanumericData;

const Mode$2 = mode;

function ByteData (data) {
  this.mode = Mode$2.BYTE;
  if (typeof (data) === 'string') {
    this.data = new TextEncoder().encode(data);
  } else {
    this.data = new Uint8Array(data);
  }
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
};

ByteData.prototype.getLength = function getLength () {
  return this.data.length
};

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
};

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8);
  }
};

var byteData = ByteData;

const Mode$1 = mode;
const Utils$2 = utils$1;

function KanjiData (data) {
  this.mode = Mode$1.KANJI;
  this.data = data;
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
};

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
};

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
};

KanjiData.prototype.write = function (bitBuffer) {
  let i;

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils$2.toSJIS(this.data[i]);

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140;

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140;
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff);

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13);
  }
};

var kanjiData = KanjiData;

var dijkstra = {exports: {}};

(function (module) {

/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    while (u) {
      nodes.push(u);
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
{
  module.exports = dijkstra;
}
}(dijkstra));

(function (exports) {
const Mode = mode;
const NumericData = numericData;
const AlphanumericData = alphanumericData;
const ByteData = byteData;
const KanjiData = kanjiData;
const Regex = regex;
const Utils = utils$1;
const dijkstra$1 = dijkstra.exports;

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = [];
  let result;

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    });
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
  let byteSegs;
  let kanjiSegs;

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
    kanjiSegs = [];
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data;
      return acc
    }

    acc.push(curr);
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = [];
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i];

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ]);
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ]);
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ]);
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ]);
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {};
  const graph = { start: {} };
  let prevNodeIds = ['start'];

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i];
    const currentNodeIds = [];

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j];
      const key = '' + i + j;

      currentNodeIds.push(key);
      table[key] = { node: node, lastCount: 0 };
      graph[key] = {};

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n];

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);

          table[prevNodeId].lastCount += node.length;
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version); // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds;
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0;
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode;
  const bestMode = Mode.getBestModeForData(data);

  mode = Mode.from(modesHint, bestMode);

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE;
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null));
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode));
    }

    return acc
  }, [])
};

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());

  const nodes = buildNodes(segs);
  const graph = buildGraph(nodes, version);
  const path = dijkstra$1.find_path(graph.map, 'start', 'end');

  const optimizedSegs = [];
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node);
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
};

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
};
}(segments));

const Utils$1 = utils$1;
const ECLevel = errorCorrectionLevel;
const BitBuffer = bitBuffer;
const BitMatrix = bitMatrix;
const AlignmentPattern = alignmentPattern;
const FinderPattern = finderPattern;
const MaskPattern = maskPattern;
const ECCode = errorCorrectionCode;
const ReedSolomonEncoder = reedSolomonEncoder;
const Version = version$1;
const FormatInfo = formatInfo;
const Mode = mode;
const Segments = segments;

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size;
  const pos = FinderPattern.getPositions(version);

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0];
    const col = pos[i][1];

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true);
        } else {
          matrix.set(row + r, col + c, false, true);
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size;

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0;
    matrix.set(r, 6, value, true);
    matrix.set(6, r, value, true);
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version);

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0];
    const col = pos[i][1];

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true);
        } else {
          matrix.set(row + r, col + c, false, true);
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size;
  const bits = Version.getEncodedBits(version);
  let row, col, mod;

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3);
    col = i % 3 + size - 8 - 3;
    mod = ((bits >> i) & 1) === 1;

    matrix.set(row, col, mod, true);
    matrix.set(col, row, mod, true);
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size;
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
  let i, mod;

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1;

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true);
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true);
    } else {
      matrix.set(size - 15 + i, 8, mod, true);
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true);
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true);
    } else {
      matrix.set(8, 15 - i - 1, mod, true);
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true);
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size;
  let inc = -1;
  let row = size - 1;
  let bitIndex = 7;
  let byteIndex = 0;

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--;

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false;

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1);
          }

          matrix.set(row, col - c, dark);
          bitIndex--;

          if (bitIndex === -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }

      row += inc;

      if (row < 0 || size <= row) {
        row -= inc;
        inc = -inc;
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer();

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4);

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));

    // add binary data sequence to buffer
    data.write(buffer);
  });

  // Calculate required number of bits
  const totalCodewords = Utils$1.getSymbolTotalCodewords(version);
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4);
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0);
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8);
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils$1.getSymbolTotalCodewords(version);

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords;

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks;
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount);

  let offset = 0;
  const dcData = new Array(ecTotalBlocks);
  const ecData = new Array(ecTotalBlocks);
  let maxDataSize = 0;
  const buffer = new Uint8Array(bitBuffer.buffer);

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize);

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b]);

    offset += dataSize;
    maxDataSize = Math.max(maxDataSize, dataSize);
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords);
  let index = 0;
  let i, r;

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i];
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i];
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments;

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data);
  } else if (typeof data === 'string') {
    let estimatedVersion = version;

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data);

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40);
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion;

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments);

  // Allocate matrix buffer
  const moduleCount = Utils$1.getSymbolSize(version);
  const modules = new BitMatrix(moduleCount);

  // Add function modules
  setupFinderPattern(modules, version);
  setupTimingPattern(modules);
  setupAlignmentPattern(modules, version);

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0);

  if (version >= 7) {
    setupVersionInfo(modules, version);
  }

  // Add data codewords
  setupData(modules, dataBits);

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel));
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules);

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern);

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
qrcode.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M;
  let version;
  let mask;

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
    version = Version.from(options.version);
    mask = MaskPattern.from(options.maskPattern);

    if (options.toSJISFunc) {
      Utils$1.setToSJISFunction(options.toSJISFunc);
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
};

var canvas = {};

var utils = {};

(function (exports) {
function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString();
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('');
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }));
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F');

  const hexValue = parseInt(hexCode.join(''), 16);

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {};
  if (!options.color) options.color = {};

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin;

  const width = options.width && options.width >= 21 ? options.width : undefined;
  const scale = options.scale || 4;

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
};

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
};

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts);
  return Math.floor((qrSize + opts.margin * 2) * scale)
};

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size;
  const data = qr.modules.data;
  const scale = exports.getScale(size, opts);
  const symbolSize = Math.floor((size + opts.margin * 2) * scale);
  const scaledMargin = opts.margin * scale;
  const palette = [opts.color.light, opts.color.dark];

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4;
      let pxColor = opts.color.light;

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale);
        const jSrc = Math.floor((j - scaledMargin) / scale);
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
      }

      imgData[posDst++] = pxColor.r;
      imgData[posDst++] = pxColor.g;
      imgData[posDst++] = pxColor.b;
      imgData[posDst] = pxColor.a;
    }
  }
};
}(utils));

(function (exports) {
const Utils = utils;

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (!canvas.style) canvas.style = {};
  canvas.height = size;
  canvas.width = size;
  canvas.style.height = size + 'px';
  canvas.style.width = size + 'px';
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options;
  let canvasEl = canvas;

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas;
    canvas = undefined;
  }

  if (!canvas) {
    canvasEl = getCanvasElement();
  }

  opts = Utils.getOptions(opts);
  const size = Utils.getImageWidth(qrData.modules.size, opts);

  const ctx = canvasEl.getContext('2d');
  const image = ctx.createImageData(size, size);
  Utils.qrToImageData(image.data, qrData, opts);

  clearCanvas(ctx, canvasEl, size);
  ctx.putImageData(image, 0, 0);

  return canvasEl
};

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options;

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas;
    canvas = undefined;
  }

  if (!opts) opts = {};

  const canvasEl = exports.render(qrData, canvas, opts);

  const type = opts.type || 'image/png';
  const rendererOpts = opts.rendererOpts || {};

  return canvasEl.toDataURL(type, rendererOpts.quality)
};
}(canvas));

var svgTag = {};

const Utils = utils;

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255;
  const str = attrib + '="' + color.hex + '"';

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x;
  if (typeof y !== 'undefined') str += ' ' + y;

  return str
}

function qrToPath (data, size, margin) {
  let path = '';
  let moveBy = 0;
  let newRow = false;
  let lineLength = 0;

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size);
    const row = Math.floor(i / size);

    if (!col && !newRow) newRow = true;

    if (data[i]) {
      lineLength++;

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0);

        moveBy = 0;
        newRow = false;
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength);
        lineLength = 0;
      }
    } else {
      moveBy++;
    }
  }

  return path
}

svgTag.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options);
  const size = qrData.modules.size;
  const data = qrData.modules.data;
  const qrcodesize = size + opts.margin * 2;

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>';

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"';

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';

  if (typeof cb === 'function') {
    cb(null, svgTag);
  }

  return svgTag
};

const canPromise = canPromise$1;

const QRCode = qrcode;
const CanvasRenderer = canvas;
const SvgRenderer = svgTag;

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1);
  const argsNum = args.length;
  const isLastArgCb = typeof args[argsNum - 1] === 'function';

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text;
      text = canvas;
      canvas = opts = undefined;
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts;
        opts = undefined;
      } else {
        cb = opts;
        opts = text;
        text = canvas;
        canvas = undefined;
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas;
      canvas = opts = undefined;
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text;
      text = canvas;
      canvas = undefined;
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts);
        resolve(renderFunc(data, canvas, opts));
      } catch (e) {
        reject(e);
      }
    })
  }

  try {
    const data = QRCode.create(text, opts);
    cb(null, renderFunc(data, canvas, opts));
  } catch (e) {
    cb(e);
  }
}

browser.create = QRCode.create;
browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);

// only svg for now.
browser.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// 對於内容少的qrcode，增大容錯率
// Increase the fault tolerance for QrCode with less content
function getErrorCorrectionLevel(content) {
    if (content.length > 36) {
        return 'M';
    }
    else if (content.length > 16) {
        return 'Q';
    }
    else {
        return 'H';
    }
}
/**
 * load image, resolve image
 * 加載圖片
 * @param logoSrc
 * @param crossOrigin
 * @returns
 */
function loadImage(logoSrc, crossOrigin) {
    var image = new Image();
    image.setAttribute('crossOrigin', crossOrigin || 'anonymous');
    image.src = logoSrc;
    return new Promise(function (resolve, reject) {
        image.onload = function () {
            resolve(image);
        };
        image.onerror = function () {
            reject('logo load fail!');
        };
    });
}
/**
 * draw radius
 * 繪製帶圓角的綫條
 * @param ctx
 * @returns
 */
var canvasRoundRect = function (ctx) {
    return function (x, y, w, h, r) {
        var minSize = Math.min(w, h);
        if (r > minSize / 2) {
            r = minSize / 2;
        }
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
        return ctx;
    };
};
/**
 * 判斷是否是函數
 * Determine if it is a function
 * @param o {function} 函數
 */
function isFunction(o) {
    return typeof o === 'function';
}
/**
 * canvas get base64 url and set image src value, if need download image, auto download image
 * 獲取 canvas base64 並賦值給 image 的 src 屬性
 * @param options
 * @returns
 */
var toImage = function (options) {
    return __awaiter(this, void 0, void 0, function () {
        var canvas, download, image, downloadName, startDownload;
        return __generator(this, function (_a) {
            canvas = options.canvas, download = options.download;
            image = options.image, downloadName = options.downloadName;
            if (canvas.toDataURL()) {
                image.src = canvas.toDataURL();
            }
            else {
                throw new Error('Can not get the canvas DataURL');
            }
            if (download !== true && !isFunction(download)) {
                return [2 /*return*/];
            }
            // download also can be a function
            download =
                download === true ? function (start) { return start(); } : download;
            startDownload = function () {
                return saveImage(image, downloadName);
            };
            if (download) {
                return [2 /*return*/, download(startDownload)];
            }
            return [2 /*return*/, Promise.resolve()];
        });
    });
};
/**
 * save image 保存圖片
 * @param image HTMLImageElement
 * @param name image name
 * @returns
 */
var saveImage = function (image, name) {
    return new Promise(function (resolve, reject) {
        try {
            var dataURL = image.src;
            var link = document.createElement('a');
            link.download = name;
            link.href = dataURL;
            link.dispatchEvent(new MouseEvent('click'));
            resolve(true);
        }
        catch (err) {
            reject(err);
        }
    });
};

var dotTypes = {
    tile: 'tile',
    dot: 'dot',
    dotSmall: 'dot-small',
    rounded: 'rounded',
    square: 'square',
    diamond: 'diamond',
    star: 'star',
    fluid: 'fluid',
    fluidLine: 'fluid-line',
    stripe: 'stripe',
    stripeRow: 'stripe-row',
    stripeColumn: 'stripe-column'
};
var QRDot = /** @class */ (function () {
    function QRDot(options) {
        this._context = options.context;
        this._type = options.type;
        this.dotSize = options.dotSize;
    }
    QRDot.prototype.draw = function (x, y, getNeighbor, qrCanvas, i, j) {
        var context = this._context;
        var type = this._type;
        var drawFunction;
        switch (type) {
            case dotTypes.tile:
                drawFunction = this._drawTile;
                break;
            case dotTypes.dot:
                drawFunction = this._drawDot;
                break;
            case dotTypes.dotSmall:
                drawFunction = this._drawDotSmall;
                break;
            case dotTypes.rounded:
                drawFunction = this._drawRounded;
                break;
            case dotTypes.diamond:
                drawFunction = this._drawDiamond;
                break;
            case dotTypes.star:
                drawFunction = this._drawStar;
                break;
            case dotTypes.fluid:
                drawFunction = this._drawFluid;
                break;
            case dotTypes.fluidLine:
                drawFunction = this._drawFluidLine;
                break;
            case dotTypes.stripe:
                drawFunction = this._drawStripe;
                break;
            case dotTypes.stripeRow:
                drawFunction = this._drawStripeRow;
                break;
            case dotTypes.stripeColumn:
                drawFunction = this._drawStripeColumn;
                break;
            case dotTypes.square:
            default:
                drawFunction = this._drawSquare;
                break;
        }
        drawFunction.call(this, {
            x: x,
            y: y,
            size: this.dotSize,
            context: context,
            getNeighbor: getNeighbor,
            qrCanvas: qrCanvas,
            i: i,
            j: j
        });
    };
    QRDot.prototype._drawSquare = function (_a) {
        var x = _a.x, y = _a.y, size = _a.size, context = _a.context;
        this._basicSquare({ x: x, y: y, size: size, context: context, rotation: 0 });
    };
    QRDot.prototype._basicSquare = function (args) {
        var size = args.size, context = args.context;
        this._rotateFigure(__assign(__assign({}, args), { draw: function () {
                context.rect(-size / 2, -size / 2, size, size);
            } }));
    };
    QRDot.prototype._drawDot = function (args) {
        this._drawBasicDot(args);
    };
    QRDot.prototype._drawDotSmall = function (args) {
        this._drawBasicDot(__assign(__assign({}, args), { dotRate: 0.3 }));
    };
    QRDot.prototype._drawBasicDot = function (args) {
        var x = args.x, y = args.y, size = args.size, context = args.context, _a = args.dotRate, dotRate = _a === void 0 ? 0.4 : _a;
        var cx = x + size / 2;
        var cy = y + size / 2;
        context.beginPath();
        context.arc(cx, cy, size * dotRate, 0, Math.PI * 2);
        context.closePath();
        // 一次性填充会糊掉，一个个填则没有问题
        context.fill();
    };
    QRDot.prototype._drawRounded = function (_a) {
        var x = _a.x, y = _a.y, size = _a.size, context = _a.context;
        size = 0.75 * size;
        x += (1 / 8) * size;
        y += (1 / 8) * size;
        var cx = x + size / 2;
        var cy = y + size / 2;
        var originX = -size / 2;
        context.translate(cx, cy);
        canvasRoundRect(context)(originX, originX, size, size, size / 4);
        context.fill();
        context.translate(-cx, -cy);
    };
    QRDot.prototype._drawTile = function (args) {
        var size = args.size, context = args.context;
        this._rotateFigure(__assign(__assign({}, args), { draw: function () {
                context.rect(-size / 2, -size / 2, size - 1, size - 1);
            } }));
    };
    QRDot.prototype._drawDiamond = function (args) {
        var size = args.size, context = args.context;
        this._rotateFigure(__assign(__assign({}, args), { rotation: Math.PI / 4, draw: function () {
                size = (0.5 * size) / Math.sin(Math.PI / 4);
                context.rect(-size / 2, -size / 2, size, size);
            } }));
    };
    QRDot.prototype._drawStar = function (args) {
        var size = args.size, context = args.context;
        this._rotateFigure(__assign(__assign({}, args), { rotation: Math.PI / 4, draw: function () {
                context.moveTo(-size / 2, -size / 2);
                context.quadraticCurveTo(0, 0, size / 2, -size / 2);
                context.quadraticCurveTo(0, 0, size / 2, size / 2);
                context.quadraticCurveTo(0, 0, -size / 2, size / 2);
                context.quadraticCurveTo(0, 0, -size / 2, -size / 2);
            } }));
    };
    QRDot.prototype._drawFluidLine = function (args) {
        this._drawFluid(args, true);
    };
    QRDot.prototype._drawFluid = function (_a, line) {
        var x = _a.x, y = _a.y, size = _a.size, context = _a.context, getNeighbor = _a.getNeighbor;
        if (line === void 0) { line = false; }
        var roundedCorners = [false, false, false, false]; // top-left, top-right, bottom-right, bottom-left
        if (!getNeighbor(0, -1) && !getNeighbor(-1, 0))
            roundedCorners[0] = true;
        if (!getNeighbor(1, 0) && !getNeighbor(0, -1))
            roundedCorners[1] = true;
        if (!getNeighbor(0, 1) && !getNeighbor(1, 0))
            roundedCorners[2] = true;
        if (!getNeighbor(0, 1) && !getNeighbor(-1, 0))
            roundedCorners[3] = true;
        var cx = x + size / 2;
        var cy = y + size / 2;
        context.translate(cx, cy);
        context.beginPath();
        context.arc(0, 0, size / 2, 0, 2 * Math.PI, false);
        context.closePath();
        context.fill();
        if (!roundedCorners[0])
            context.fillRect(-size / 2, -size / 2, size / 2, size / 2);
        if (!roundedCorners[1])
            context.fillRect(0, -size / 2, size / 2, size / 2);
        if (!roundedCorners[2])
            context.fillRect(0, 0, size / 2, size / 2);
        if (!roundedCorners[3])
            context.fillRect(-size / 2, 0, size / 2, size / 2);
        if (line && !getNeighbor(0, 1)) {
            if (getNeighbor(-1, 1)) {
                context.beginPath();
                context.arc(-size, 0, size / 2, 0, 0.5 * Math.PI, false);
                context.arc(0, size, size / 2, Math.PI, 1.5 * Math.PI, false);
                context.closePath();
                context.stroke();
                context.fill();
            }
            if (getNeighbor(1, 1)) {
                context.beginPath();
                context.arc(size, 0, size / 2, 0.5 * Math.PI, Math.PI, false);
                context.arc(0, size, size / 2, 1.5 * Math.PI, 0, false);
                context.closePath();
                context.stroke();
                context.fill();
            }
        }
        context.translate(-cx, -cy);
    };
    QRDot.prototype._drawStripeColumn = function (args) {
        return this._drawStripe(args, 'column');
    };
    QRDot.prototype._drawStripeRow = function (args) {
        return this._drawStripe(args, 'row');
    };
    QRDot.prototype._drawStripe = function (_a, type) {
        var x = _a.x, y = _a.y, size = _a.size, context = _a.context, qrCanvas = _a.qrCanvas, i = _a.i, j = _a.j;
        if (type === void 0) { type = 'default'; }
        function setRangeDisabled(width, height) {
            for (var i1 = i; i1 < i + width; i1++) {
                for (var j1 = j; j1 < j + height; j1++) {
                    qrCanvas.setDisabled(i1, j1);
                }
            }
        }
        function getRangeTrue(width, height) {
            var isTrue = true;
            for (var i1 = i; i1 < i + width; i1++) {
                for (var j1 = j; j1 < j + height; j1++) {
                    if (!qrCanvas.isDark(i1, j1)) {
                        isTrue = false;
                        break;
                    }
                }
                if (!isTrue) {
                    break;
                }
            }
            return isTrue;
        }
        function drawItem(width, height) {
            var cx = x + size / 2;
            var cy = y + size / 2;
            context.translate(cx, cy);
            context.beginPath();
            if (width === 1 && height === 1) {
                // 画圆点
                context.arc(0, 0, size / 4, 0, 2 * Math.PI, false);
            }
            else if (width > 1) {
                // 画横
                context.arc(0, 0, size / 4, 0.5 * Math.PI, 1.5 * Math.PI, false);
                context.arc(size * (width - 1), 0, size / 4, 1.5 * Math.PI, 0.5 * Math.PI, false);
            }
            else if (height > 1) {
                // 画竖
                context.arc(0, 0, size / 4, Math.PI, 2 * Math.PI, false);
                context.arc(0, size * (height - 1), size / 4, 0, Math.PI, false);
            }
            context.fill();
            context.closePath();
            context.translate(-cx, -cy);
            setRangeDisabled(width, height);
        }
        var array = type === 'row'
            ? [
                [3, 1],
                [2, 1],
                [1, 1]
            ]
            : type === 'column'
                ? [
                    [1, 3],
                    [1, 2],
                    [1, 1]
                ]
                : [
                    [3, 1],
                    [1, 3],
                    [2, 1],
                    [1, 2],
                    [1, 1]
                ];
        array.forEach(function (comb) {
            if (getRangeTrue(comb[0], comb[1])) {
                drawItem(comb[0], comb[1]);
            }
        });
    };
    QRDot.prototype._rotateFigure = function (_a) {
        var x = _a.x, y = _a.y, size = _a.size, context = _a.context, _b = _a.rotation, rotation = _b === void 0 ? 0 : _b, draw = _a.draw;
        var cx = x + size / 2;
        var cy = y + size / 2;
        context.translate(cx, cy);
        rotation && context.rotate(rotation);
        draw();
        context.closePath();
        rotation && context.rotate(-rotation);
        context.translate(-cx, -cy);
    };
    return QRDot;
}());

var cornerTypes = {
    square: 'square',
    rounded: 'rounded',
    circle: 'circle',
    roundedCircle: 'rounded-circle',
    circleRounded: 'circle-rounded',
    circleDiamond: 'circle-diamond',
    circleStar: 'circle-star'
};
var QRCorner = /** @class */ (function () {
    function QRCorner(context, cornerType, color) {
        this.context = context;
        this.cornerType = cornerType;
        this.color = color;
    }
    QRCorner.prototype.draw = function (_a) {
        var radius = _a.radius, x = _a.x, y = _a.y, dotSize = _a.dotSize;
        var drawFunction;
        switch (this.cornerType) {
            case cornerTypes.circle:
                drawFunction = this._drawCircle;
                break;
            case cornerTypes.rounded:
                drawFunction = this._drawRounded;
                break;
            case cornerTypes.roundedCircle:
                drawFunction = this._drawRoundedCircle;
                break;
            case cornerTypes.circleRounded:
                drawFunction = this._drawCircleRounded;
                break;
            case cornerTypes.circleDiamond:
                drawFunction = this._drawCircleDiamond;
                break;
            case cornerTypes.circleStar:
                drawFunction = this._drawCircleStar;
                break;
            case cornerTypes.square:
            default:
                drawFunction = this._drawSquare;
                break;
        }
        drawFunction.call(this, { x: x, y: y, radius: radius, dotSize: dotSize });
    };
    QRCorner.prototype._drawRoundedCircle = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize, radius = _a.radius;
        var _radius = typeof radius === 'number' ? radius : (radius === null || radius === void 0 ? void 0 : radius.outer) || dotSize / 2;
        this.drawRoundedSquare(dotSize, x, y, dotSize * 7, _radius, false, 0);
        this.drawCircle(dotSize, x + 2 * dotSize, y + 2 * dotSize, dotSize * 3, true);
    };
    QRCorner.prototype._drawCircleRounded = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize, radius = _a.radius;
        this.drawCircle(dotSize, x, y, dotSize * 7, false);
        var _radius = typeof radius === 'number' ? radius : (radius === null || radius === void 0 ? void 0 : radius.inner) || dotSize / 4;
        this.drawRoundedSquare(dotSize, x + 2 * dotSize, y + 2 * dotSize, dotSize * 3, _radius, true, 0);
    };
    QRCorner.prototype._drawCircleDiamond = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize;
        this.drawCircle(dotSize, x, y, dotSize * 7, false);
        this.drawRoundedSquare(dotSize, x + 2 * dotSize, y + 2 * dotSize, dotSize * 3, 0, true, (45 * Math.PI) / 180);
    };
    QRCorner.prototype._drawCircleStar = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize;
        this.drawCircle(dotSize, x, y, dotSize * 7, false);
        this.drawInnerStar(x + 2 * dotSize, y + 2 * dotSize, dotSize * 3);
    };
    QRCorner.prototype._drawSquare = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize;
        return this._drawBasicRounded({ x: x, y: y, dotSize: dotSize, radius: 0 });
    };
    QRCorner.prototype._drawRounded = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize, radius = _a.radius;
        var inner = typeof radius === 'number' ? radius : (radius === null || radius === void 0 ? void 0 : radius.inner) || dotSize / 4;
        var outer = typeof radius === 'number' ? radius : (radius === null || radius === void 0 ? void 0 : radius.outer) || dotSize / 2;
        return this._drawBasicRounded({
            x: x,
            y: y,
            dotSize: dotSize,
            radius: {
                inner: inner,
                outer: outer
            }
        });
    };
    QRCorner.prototype._drawCircle = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize;
        this.drawCircle(dotSize, x, y, dotSize * 7, false);
        this.drawCircle(dotSize, x + 2 * dotSize, y + 2 * dotSize, dotSize * 3, true);
    };
    QRCorner.prototype._drawBasicRounded = function (_a) {
        var x = _a.x, y = _a.y, dotSize = _a.dotSize, radius = _a.radius, _b = _a.rotation, rotation = _b === void 0 ? 0 : _b;
        var lineWidth = Math.ceil(dotSize);
        var radiusOuter;
        var radiusInner;
        if (typeof radius !== 'number') {
            radiusOuter = radius.outer || 0;
            radiusInner = radius.inner || 0;
        }
        else {
            radiusOuter = radius;
            radiusInner = radiusOuter;
        }
        var size = dotSize * 7;
        // Outer box
        this.drawRoundedSquare(lineWidth, x, y, size, radiusOuter, false, rotation);
        // Inner box
        size = dotSize * 3;
        y += dotSize * 2;
        x += dotSize * 2;
        this.drawRoundedSquare(lineWidth, x, y, size, radiusInner, true, rotation);
    };
    QRCorner.prototype.drawCircle = function (lineWidth, x, y, size, fill) {
        var ctx = this.context;
        var color = this.color;
        ctx.lineWidth = lineWidth;
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        y += size / 2;
        x += size / 2;
        size -= lineWidth;
        ctx.beginPath();
        ctx.arc(x, y, size / 2, 0, Math.PI * 2);
        ctx.stroke();
        ctx.closePath();
        if (fill) {
            ctx.fill();
        }
    };
    QRCorner.prototype.drawRoundedSquare = function (lineWidth, x, y, size, radius, fill, rotation) {
        var ctx = this.context;
        var color = this.color;
        ctx.lineWidth = lineWidth;
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        // Adjust coordinates so that the outside of the stroke is aligned to the edges
        y += lineWidth / 2;
        x += lineWidth / 2;
        size -= lineWidth;
        if (!Array.isArray(radius)) {
            radius = [radius, radius, radius, radius];
        }
        // Radius should not be greater than half the size or less than zero
        radius = radius.map(function (r) {
            r = Math.min(r, size / 2);
            return r < 0 ? 0 : r;
        });
        var rTopLeft = radius[0] || 0;
        var rTopRight = radius[1] || 0;
        var rBottomRight = radius[2] || 0;
        var rBottomLeft = radius[3] || 0;
        ctx.beginPath();
        var cx = x + size / 2;
        var cy = y + size / 2;
        var originX = -size / 2;
        ctx.translate(cx, cy);
        rotation && ctx.rotate(rotation);
        ctx.moveTo(originX + rTopLeft, originX);
        ctx.lineTo(originX + size - rTopRight, originX);
        if (rTopRight)
            ctx.quadraticCurveTo(originX + size, originX, originX + size, originX + rTopRight);
        ctx.lineTo(originX + size, originX + size - rBottomRight);
        if (rBottomRight)
            ctx.quadraticCurveTo(originX + size, originX + size, originX + size - rBottomRight, originX + size);
        ctx.lineTo(originX + rBottomLeft, originX + size);
        if (rBottomLeft)
            ctx.quadraticCurveTo(originX, originX + size, originX, originX + size - rBottomLeft);
        ctx.lineTo(originX, originX + rTopLeft);
        if (rTopLeft)
            ctx.quadraticCurveTo(originX, originX, originX + rTopLeft, originX);
        ctx.closePath();
        ctx.stroke();
        if (fill) {
            ctx.fill();
        }
        rotation && ctx.rotate(-rotation);
        ctx.translate(-cx, -cy);
    };
    QRCorner.prototype.drawInnerStar = function (x, y, size) {
        var context = this.context;
        var cx = x + size / 2;
        var cy = y + size / 2;
        context.translate(cx, cy);
        context.beginPath();
        context.moveTo(-size / 2, -size / 2);
        context.quadraticCurveTo(0, -size / 4, size / 2, -size / 2);
        context.quadraticCurveTo(size / 4, 0, size / 2, size / 2);
        context.quadraticCurveTo(0, size / 4, -size / 2, size / 2);
        context.quadraticCurveTo(-size / 4, 0, -size / 2, -size / 2);
        context.closePath();
        context.fill();
        context.translate(-cx, -cy);
    };
    return QRCorner;
}());

var defaultOptions = {
    logo: {
        bgColor: '#fff',
        borderWidth: 10,
        crossOrigin: 'anonymous',
        borderRadius: 8,
        logoRadius: 0
    },
    width: 380,
    download: false,
    downloadName: 'qr-code.png',
    nodeQrCodeOptions: {
        margin: 4,
        color: {
            dark: '#000',
            light: '#fff'
        }
    },
    dotsOptions: {
        type: 'square',
        color: '#000'
    },
    cornersOptions: {
        type: 'square',
        color: '#000'
    }
};

var squareMask = [
    [1, 1, 1, 1, 1, 1, 1],
    [1, 0, 0, 0, 0, 0, 1],
    [1, 0, 0, 0, 0, 0, 1],
    [1, 0, 0, 0, 0, 0, 1],
    [1, 0, 0, 0, 0, 0, 1],
    [1, 0, 0, 0, 0, 0, 1],
    [1, 1, 1, 1, 1, 1, 1]
];
var dotMask = [
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 1, 1, 1, 0, 0],
    [0, 0, 1, 1, 1, 0, 0],
    [0, 0, 1, 1, 1, 0, 0],
    [0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0]
];
var ErrorCorrectionPercents = {
    L: 0.07,
    M: 0.15,
    Q: 0.25,
    H: 0.3
};
var QRCanvas = /** @class */ (function () {
    function QRCanvas(options) {
        this.qrcodeArray = [];
        /**dotSize: Integer */
        this.dotSize = 0;
        /**offset: Integer */
        this.offset = 0;
        var canvas = options.canvas, content = options.content, _a = options.width, width = _a === void 0 ? defaultOptions.width : _a, _b = options.nodeQrCodeOptions, nodeQrCodeOptions = _b === void 0 ? {} : _b;
        // 默認對内容少的二維碼采用高容錯率，内容多的二維碼采用低容錯率
        // according to the content length to choose different errorCorrectionLevel
        nodeQrCodeOptions.errorCorrectionLevel =
            nodeQrCodeOptions.errorCorrectionLevel || getErrorCorrectionLevel(content);
        var QRDATA = browser.create(content, nodeQrCodeOptions);
        this.canvas = canvas;
        this.options = options;
        this.canvas.setAttribute('width', width + '');
        this.canvas.setAttribute('height', width + '');
        this.saveQrdata(QRDATA);
    }
    /**
     * clear canvas 清理畫布
     */
    QRCanvas.prototype.clear = function () {
        var canvasContext = this.context;
        if (canvasContext) {
            canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }
    };
    Object.defineProperty(QRCanvas.prototype, "context", {
        get: function () {
            return this.canvas.getContext('2d');
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 保存qrcode原始數據
     * @param QRDATA
     */
    QRCanvas.prototype.saveQrdata = function (QRDATA) {
        var _a;
        this.size = QRDATA.modules.size;
        this.version = QRDATA.version;
        this.qrcodeArray = QRDATA.modules.data;
        var nodeQrCodeOptions = this.options.nodeQrCodeOptions;
        var margin = (nodeQrCodeOptions === null || nodeQrCodeOptions === void 0 ? void 0 : nodeQrCodeOptions.margin) || defaultOptions.nodeQrCodeOptions.margin;
        var count = this.size;
        var width = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.width) || defaultOptions.width;
        /**
         * 二維碼去除 margin 后的實際寬度
         */
        var withoutMarginSize = width - margin * 2;
        /**每个像素点宽度 */
        this.dotSize = Math.floor(withoutMarginSize / count);
        this.offset = Math.floor((width - count * this.dotSize) / 2);
    };
    /**初始化 */
    QRCanvas.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var drawFunction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clear();
                        this.drawBackground();
                        return [4 /*yield*/, this.drawLogo()];
                    case 1:
                        drawFunction = _a.sent();
                        this.drawDots();
                        this.drawCorners();
                        drawFunction && drawFunction.call(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    QRCanvas.prototype.drawLogo = function () {
        var _a;
        var logo = (_a = this.options) === null || _a === void 0 ? void 0 : _a.logo;
        if (logo) {
            if (typeof logo === 'string') {
                logo = { src: logo };
            }
            return this._drawLogo(logo);
        }
        else {
            return Promise.resolve(null);
        }
    };
    QRCanvas.prototype._drawLogo = function (logo) {
        return __awaiter(this, void 0, void 0, function () {
            var context, canvas, coverLevel, maxHiddenDots, src, _a, bgColor, _b, borderWidth, _c, crossOrigin, _d, borderRadius, _e, logoRadius, image, rate, logoWidth, logoHeight, logoInnerWidth, logoInnerHeight, maxHeight, xStart, xEnd, yStart, yEnd;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        context = this.context;
                        canvas = this.canvas;
                        coverLevel = ErrorCorrectionPercents[this.options.nodeQrCodeOptions.errorCorrectionLevel];
                        maxHiddenDots = Math.floor(coverLevel * coverLevel * this.size * this.size);
                        src = logo.src, _a = logo.bgColor, bgColor = _a === void 0 ? defaultOptions.logo.bgColor : _a, _b = logo.borderWidth, borderWidth = _b === void 0 ? defaultOptions.logo.borderWidth : _b, _c = logo.crossOrigin, crossOrigin = _c === void 0 ? defaultOptions.logo.crossOrigin : _c, _d = logo.borderRadius, borderRadius = _d === void 0 ? defaultOptions.logo.borderRadius : _d, _e = logo.logoRadius, logoRadius = _e === void 0 ? defaultOptions.logo.logoRadius : _e;
                        return [4 /*yield*/, loadImage(src, crossOrigin)];
                    case 1:
                        image = _f.sent();
                        rate = image.width / image.height;
                        maxHeight = Math.floor(Math.sqrt((this.dotSize * this.dotSize * maxHiddenDots) / rate));
                        if (rate > 1) {
                            logoHeight = maxHeight;
                            logoInnerHeight = maxHeight - 2 * borderWidth;
                            logoInnerWidth = Math.floor(logoInnerHeight * rate);
                            logoWidth = logoInnerWidth + borderWidth * 2;
                        }
                        else {
                            logoWidth = Math.floor(maxHeight * rate);
                            logoInnerWidth = logoWidth - borderWidth * 2;
                            logoInnerHeight = Math.floor(logoInnerWidth / rate);
                            logoHeight = logoInnerHeight + 2 * borderWidth;
                        }
                        xStart = (this.size - Math.ceil(logoWidth / this.dotSize)) / 2;
                        xEnd = this.size - xStart - 1;
                        yStart = (this.size - Math.ceil(logoHeight / this.dotSize)) / 2;
                        yEnd = this.size - yStart - 1;
                        this.inLogoRange = function (i, j) {
                            return i >= xStart && i <= xEnd && j >= yStart && j <= yEnd;
                        };
                        return [2 /*return*/, function () {
                                var cx = canvas.width / 2;
                                var cy = canvas.height / 2;
                                context.translate(cx, cy);
                                canvasRoundRect(context)(-logoWidth / 2, -logoHeight / 2, logoWidth, logoHeight, borderRadius);
                                this.context.fillStyle = bgColor;
                                this.context.fill();
                                // 使用image绘制可以避免某些跨域情况
                                // Use image drawing to avoid some cross-domain situations
                                var drawLogoWithImage = function () {
                                    context.drawImage(image, -logoInnerWidth / 2, -logoInnerHeight / 2, logoInnerWidth, logoInnerHeight);
                                };
                                // 使用canvas绘制以获得更多的功能
                                // Use canvas to draw more features, such as borderRadius
                                var drawLogoWithCanvas = function () {
                                    var canvasImage = document.createElement('canvas');
                                    canvasImage.width = logoInnerWidth;
                                    canvasImage.height = logoInnerHeight;
                                    canvasImage
                                        .getContext('2d')
                                        .drawImage(image, 0, 0, logoInnerWidth, logoInnerHeight);
                                    canvasRoundRect(context)(0, 0, logoInnerWidth, logoInnerHeight, logoRadius);
                                    // @ts-ignore
                                    context.fillStyle = context.createPattern(canvasImage, 'no-repeat');
                                    context.fill();
                                };
                                if (logoRadius) {
                                    context.translate(-logoInnerWidth / 2, -logoInnerHeight / 2);
                                    drawLogoWithCanvas();
                                    context.translate(-cx + logoInnerWidth / 2, -cy + logoInnerHeight / 2);
                                }
                                else {
                                    drawLogoWithImage();
                                    context.translate(-cx, -cy);
                                }
                            }];
                }
            });
        });
    };
    /**
     * 目標坐標是否為黑點？
     * Coordinate is dark dot ? 0 or 1
     */
    QRCanvas.prototype.isDark = function (x, y) {
        return this.qrcodeArray[x + y * this.size] === 1;
    };
    QRCanvas.prototype.isDisabled = function (x, y) {
        return this.qrcodeArray[x + y * this.size] === 2;
    };
    QRCanvas.prototype.setDisabled = function (x, y) {
        return this.qrcodeArray[x + y * this.size] = 2;
    };
    /**
     * 畫背景
     */
    QRCanvas.prototype.drawBackground = function () {
        var _a;
        var canvasContext = this.context;
        var nodeQrCodeOptions = this.options.nodeQrCodeOptions;
        var light = ((_a = nodeQrCodeOptions === null || nodeQrCodeOptions === void 0 ? void 0 : nodeQrCodeOptions.color) === null || _a === void 0 ? void 0 : _a.light) ||
            defaultOptions.nodeQrCodeOptions.color.light;
        if (canvasContext) {
            canvasContext.fillStyle = light;
            canvasContext.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
    };
    /**
     * 画点
     */
    QRCanvas.prototype.drawDots = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var canvasContext = this.context;
        if (canvasContext) {
            var count_1 = this.size;
            /**每个像素点宽度,整數 */
            var dotSize = this.dotSize;
            /**二维码起始位置x */
            var xBeginning = this.offset;
            /**二维码起始位置y */
            var yBeginning = this.offset;
            /**排除定位点 */
            var filterDots_1 = function (i, j) {
                var _a, _b, _c, _d, _e, _f;
                // 排除定位点外框
                if (((_a = squareMask[i]) === null || _a === void 0 ? void 0 : _a[j]) ||
                    ((_b = squareMask[i - count_1 + 7]) === null || _b === void 0 ? void 0 : _b[j]) ||
                    ((_c = squareMask[i]) === null || _c === void 0 ? void 0 : _c[j - count_1 + 7])) {
                    return false;
                }
                // 排除定位点
                if (((_d = dotMask[i]) === null || _d === void 0 ? void 0 : _d[j]) ||
                    ((_e = dotMask[i - count_1 + 7]) === null || _e === void 0 ? void 0 : _e[j]) ||
                    ((_f = dotMask[i]) === null || _f === void 0 ? void 0 : _f[j - count_1 + 7])) {
                    return false;
                }
                if (_this.inLogoRange && _this.inLogoRange(i, j))
                    return false;
                return true;
            };
            var dot = new QRDot({
                context: this.context,
                type: ((_a = this.options.dotsOptions) === null || _a === void 0 ? void 0 : _a.type) || defaultOptions.dotsOptions.type,
                dotSize: dotSize
            });
            canvasContext.fillStyle = canvasContext.strokeStyle =
                ((_b = this.options.dotsOptions) === null || _b === void 0 ? void 0 : _b.color) ||
                    ((_d = (_c = this.options.nodeQrCodeOptions) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.dark) ||
                    defaultOptions.dotsOptions.color;
            var _loop_1 = function (i) {
                var _loop_2 = function (j) {
                    if (!filterDots_1(i, j)) {
                        return "continue";
                    }
                    if (!this_1.isDark(i, j)) {
                        return "continue";
                    }
                    dot.draw(xBeginning + i * dotSize, yBeginning + j * dotSize, function (xOffset, yOffset) {
                        if (i + xOffset < 0 ||
                            j + yOffset < 0 ||
                            i + xOffset >= count_1 ||
                            j + yOffset >= count_1)
                            return null;
                        if (!filterDots_1(i + xOffset, j + yOffset))
                            return null;
                        return _this.isDark(i + xOffset, j + yOffset);
                    }, this_1, i, j);
                };
                for (var j = 0; j < count_1; j++) {
                    _loop_2(j);
                }
            };
            var this_1 = this;
            for (var i = 0; i < count_1; i++) {
                _loop_1(i);
            }
            canvasContext.fill();
        }
    };
    /**
     * 绘制角落定位图案
     */
    QRCanvas.prototype.drawCorners = function () {
        var _this = this;
        var canvasContext = this.context;
        if (canvasContext) {
            var nodeQrCodeOptions_1 = this.options.nodeQrCodeOptions;
            var margin = (nodeQrCodeOptions_1 === null || nodeQrCodeOptions_1 === void 0 ? void 0 : nodeQrCodeOptions_1.margin) || defaultOptions.nodeQrCodeOptions.margin;
            var count_2 = this.size;
            var width = this.options.width || defaultOptions.width;
            /**二维码除去margin的实际宽度 */
            var minSize = width - margin * 2;
            /**每个像素点宽度 */
            var dotSize_1 = Math.floor(minSize / count_2);
            /**二维码起始位置x */
            var xBeginning_1 = Math.floor((width - count_2 * dotSize_1) / 2);
            /**二维码起始位置y */
            var yBeginning_1 = Math.floor((width - count_2 * dotSize_1) / 2);
            [
                [0, 0],
                [1, 0],
                [0, 1]
            ].forEach(function (_a) {
                var _b;
                var _c = __read(_a, 2), column = _c[0], row = _c[1];
                var x = xBeginning_1 + column * dotSize_1 * (count_2 - 7);
                var y = yBeginning_1 + row * dotSize_1 * (count_2 - 7);
                var cornersOptions = _this.options.cornersOptions;
                var corner = new QRCorner(_this.context, cornersOptions.type || defaultOptions.cornersOptions.type, cornersOptions.color ||
                    ((_b = nodeQrCodeOptions_1 === null || nodeQrCodeOptions_1 === void 0 ? void 0 : nodeQrCodeOptions_1.color) === null || _b === void 0 ? void 0 : _b.dark) ||
                    defaultOptions.cornersOptions.color);
                corner.draw({
                    x: x,
                    y: y,
                    dotSize: _this.dotSize,
                    radius: cornersOptions.radius
                });
            });
        }
    };
    return QRCanvas;
}());

var version = "1.1.0";

var QrCodeWithLogo = /** @class */ (function () {
    function QrCodeWithLogo(options) {
        var _this = this;
        this.ifCanvasDrawed = false;
        this.ifImageCreated = false;
        this.drawImagePromiseResolve = [];
        this.drawImagePromiseReject = [];
        this.drawCanvasPromiseResolve = [];
        this.drawCanvasPromiseReject = [];
        this.defaultOption = {
            canvas: undefined,
            image: undefined,
            content: '',
            width: defaultOptions.width,
            download: defaultOptions.download,
            downloadName: defaultOptions.downloadName,
            nodeQrCodeOptions: {},
            cornersOptions: {},
            dotsOptions: {}
        };
        try {
            this.options = Object.assign(this.defaultOption, options);
            if (!this.options.canvas)
                this.options.canvas = document.createElement('canvas');
            if (!this.options.image)
                this.options.image = document.createElement('img');
            this._toCanvas()
                .then(function () {
                return _this._toImage();
            })
                .catch(function (error) {
                if ((options === null || options === void 0 ? void 0 : options.onError) && isFunction(options.onError)) {
                    options.onError(error);
                }
                _this.batchRunFunction('drawCanvasPromiseReject', error);
                _this.batchRunFunction('drawImagePromiseReject', error);
            });
        }
        catch (error) {
            if ((options === null || options === void 0 ? void 0 : options.onError) && isFunction(options.onError)) {
                options.onError(error);
            }
            this.batchRunFunction('drawCanvasPromiseReject', error);
            this.batchRunFunction('drawImagePromiseReject', error);
        }
    }
    QrCodeWithLogo.prototype.drawImagePromise = function () {
        var _this = this;
        if (this.ifImageCreated)
            return Promise.resolve();
        return new Promise(function (resolve, reject) {
            _this.drawImagePromiseResolve.push(resolve);
            _this.drawImagePromiseReject.push(reject);
        });
    };
    QrCodeWithLogo.prototype.drawCanvasPromise = function () {
        var _this = this;
        if (this.ifCanvasDrawed)
            return Promise.resolve();
        return new Promise(function (resolve, reject) {
            _this.drawCanvasPromiseResolve.push(resolve);
            _this.drawCanvasPromiseReject.push(reject);
        });
    };
    /**
     * Deprecated!
     */
    QrCodeWithLogo.prototype.toCanvas = function () {
        throw new Error('toCanvas has been Deprecated!');
    };
    /**
     * Deprecated!
     */
    QrCodeWithLogo.prototype.toImage = function () {
        throw new Error('toImage has been Deprecated!');
    };
    /**
     * draw canvas
     * @returns
     */
    QrCodeWithLogo.prototype._toCanvas = function () {
        var _this = this;
        var qrCanvas = new QRCanvas(this.options);
        return qrCanvas.init().then(function () {
            _this.ifCanvasDrawed = true;
            _this.batchRunFunction('drawCanvasPromiseResolve');
        });
    };
    /**
     * Get image base64 and set image's src attribute .
     * @returns
     */
    QrCodeWithLogo.prototype._toImage = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, toImage(this.options).then(function () {
                        _this.ifImageCreated = true;
                        _this.batchRunFunction('drawImagePromiseResolve');
                    })];
            });
        });
    };
    /**
     * 批量执行 resolve reject
     * @param name
     * @param err
     */
    QrCodeWithLogo.prototype.batchRunFunction = function (name, err) {
        if (err === void 0) { err = null; }
        var array = this[name];
        if (Array.isArray(array)) {
            array.forEach(function (fn) {
                if (isFunction(fn))
                    fn(err);
            });
            this[name].length = 0;
        }
    };
    QrCodeWithLogo.prototype.downloadImage = function () {
        return __awaiter(this, arguments, void 0, function (name) {
            if (name === void 0) { name = defaultOptions.downloadName; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.drawImagePromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, saveImage(this.options.image, name)];
                }
            });
        });
    };
    QrCodeWithLogo.prototype.getImage = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.drawImagePromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.options.image];
                }
            });
        });
    };
    QrCodeWithLogo.prototype.getCanvas = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.drawCanvasPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.options.canvas];
                }
            });
        });
    };
    QrCodeWithLogo.version = version;
    return QrCodeWithLogo;
}());

const cpslQrCodeCss = ":host{--qr-color:var(--cpsl-color-qr-fill);--qr-background-color:var(--cpsl-color-qr-background);--qr-border-color:var(--cpsl-color-qr-border);--qr-border-radius:var(--cpsl-border-radius-qr-code);--qr-border-width:0px;--qr-box-shadow:0px 0px 20px 0px rgba(0, 0, 0, 0.06);--qr-padding-top:12px;--qr-padding-end:12px;--qr-padding-bottom:12px;--qr-padding-start:12px;display:inline-block}.qr-container{-webkit-padding-start:var(--qr-padding-start);padding-inline-start:var(--qr-padding-start);-webkit-padding-end:var(--qr-padding-end);padding-inline-end:var(--qr-padding-end);padding-top:var(--qr-padding-top);padding-bottom:var(--qr-padding-bottom);box-sizing:border-box;color:var(--qr-color);border-style:solid;border-width:var(--qr-border-width);border-color:var(--qr-border-color);border-radius:var(--qr-border-radius);background:var(--qr-background-color);box-shadow:var(--qr-box-shadow)}.qr-code{width:100%;height:100%}";
const CpslQrCodeStyle0 = cpslQrCodeCss;

const CpslQrCode = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.url = undefined;
        this.imageSrc = undefined;
        this.size = 286;
        this.icon = undefined;
    }
    componentDidLoad() {
        const imageSrc = this.icon && typeof window !== undefined ? `data:image/svg+xml;base64,${window === null || window === void 0 ? void 0 : window.btoa(Icons[this.icon])}` : this.imageSrc;
        new QrCodeWithLogo({
            content: this.url,
            width: 1000,
            image: this.imgEl,
            logo: imageSrc
                ? {
                    src: imageSrc,
                    borderRadius: 16,
                    borderWidth: -20,
                }
                : '',
            dotsOptions: {
                type: 'dot',
            },
            cornersOptions: {
                type: 'rounded',
                radius: {
                    inner: 8,
                    outer: 32,
                },
            },
            nodeQrCodeOptions: {
                margin: 0,
                errorCorrectionLevel: 'H',
            },
        });
    }
    get imgEl() {
        return this.el.shadowRoot.getElementById('qr-code');
    }
    render() {
        return (h(Host, { key: '5d33fffc63f8435f8811909016ff6dd844f34ef1' }, h("div", { key: '8b0c863ee11da247165c8ca73aa53fb3b597c421', id: "qr-container", class: "qr-container", style: { width: `${this.size}px`, height: `${this.size}px` } }, h("img", { key: '700d4fd92201aee190a069cfbe89c124eb54e5c6', id: "qr-code", class: "qr-code" }))));
    }
    get el() { return getElement(this); }
};
CpslQrCode.style = CpslQrCodeStyle0;

const cpslRadioCss = ":host{--container-height:20px;--container-width:20px;--container-border-radius:var(--cpsl-border-radius-radio);--container-border-width-default:2px;--container-border-width-checked:5px;--container-background-color-default:var(--cpsl-color-radio-surface-default);--container-border-color-default:var(--cpsl-color-radio-border-default);--container-background-color-checked:var(--cpsl-color-radio-surface-checked);--container-border-color-checked:var(--cpsl-color-radio-border-checked);display:block;position:relative;height:var(--container-height);width:var(--container-width);cursor:pointer}input{position:absolute;width:100%;height:100%;margin:0px;opacity:0}span.container{display:inline-block;position:relative;box-sizing:border-box;width:100%;height:100%;border-radius:var(--container-border-radius);border:var(--container-border-width-default) solid;background:var(--container-background-color-default);border-color:var(--container-border-color-default);transition:all 0.15s ease-in-out}span.container.checked{background:var(--container-background-color-checked);border-color:var(--container-border-color-checked);border-width:var(--container-border-width-checked)}";
const CpslRadioStyle0 = cpslRadioCss;

const CpslRadio = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslRadioChanged = createEvent(this, "cpslRadioChanged", 7);
        this.handleRadioClick = () => {
            if (!this.checked) {
                this.cpslRadioChanged.emit(!this.checked);
            }
        };
        this.checked = undefined;
    }
    render() {
        return (h(Host, { key: 'a0440f0feb4b7a67517d1d8278e9bcbb2c7ef764' }, h("input", { key: '54dc5c3e64777504d5c851940d785a90de2d2882', type: "radio", checked: this.checked }), h("span", { key: 'dc5d326b957993e0a14ae6827751e946e141d3e6', onClick: this.handleRadioClick, class: { container: true, checked: this.checked } })));
    }
};
CpslRadio.style = CpslRadioStyle0;

const cpslSelectCss = ":host{--container-box-shadow:none;--container-box-shadow-color:var(--cpsl-color-select-border-placeholder);--container-border-color:var(--cpsl-color-select-border-active);--container-border-error-color:var(--cpsl-color-select-border-error);--container-background-color:var(--cpsl-color-select-surface-default);--container-background-color-disabled:var(--cpsl-color-select-surface-disabled);--container-border-width:1px;--container-border-radius:var(--cpsl-border-radius-select);--container-padding-top:0px;--container-padding-bottom:0px;--container-padding-end:12px;--container-padding-start:12px;--container-height:48px;--container-gap:8px;--dropdown-margin-top:4px;--dropdown-border-width:1px;--dropdown-border-radius:var(--cpsl-border-radius-select);--dropdown-border-color:var(--cpsl-color-select-dropdown-border);--optional-label-color:var(--cpsl-color-text-secondary);--label-color:var(--cpsl-color-text-primary);--label-font-size:var(--cpsl-font-size-body-s);--label-margin-bottom:0px;--helper-text-color:var(--cpsl-color-text-secondary);--helper-text-error-color:var(--cpsl-color-text-error);--helper-text-icon-color:var(--cpsl-color-text-secondary);--helper-text-icon-error-color:var(--cpsl-color-text-error);--helper-text-icon-size:16px;--helper-text-font-size:var(--cpsl-font-size-body-xs);--helper-text-margin-top:0px;--select-color:var(--cpsl-color-text-primary);--icon-height:24px;--icon-width:24px;display:flex;flex-direction:column;gap:4px;font-family:var(--cpsl-font-family, inherit)}input{box-sizing:border-box;position:absolute;width:100%;height:100%;margin:0px;opacity:0;top:0;left:0;z-index:-1;cursor:pointer}input.disabled{cursor:default}:host(:not(.has-value)){--container-border-color:var(--cpsl-color-select-border-placeholder);--select-color:var(--cpsl-color-text-secondary)}:host(.disabled){--container-background-color:var(--container-background-color-disabled);--select-background-color:var(--select-background-color-disabled);--select-color:var(--cpsl-color-text-disabled)}:host(.focused){--container-box-shadow:0px 0px 0px 2px var(--container-box-shadow-color);--container-border-color:var(--cpsl-color-select-border-active);--container-background-color:var(--cpsl-color-select-surface-default)}.select-container{-webkit-padding-start:var(--container-padding-start);padding-inline-start:var(--container-padding-start);-webkit-padding-end:var(--container-padding-end);padding-inline-end:var(--container-padding-end);padding-top:var(--container-padding-top);padding-bottom:var(--container-padding-bottom);position:relative;display:flex;align-items:center;justify-content:space-between;gap:8px;box-sizing:border-box;height:var(--container-height);gap:var(--container-gap);cursor:pointer;border-style:solid;border-width:var(--container-border-width);border-color:var(--container-border-color);border-radius:var(--container-border-radius);background:var(--container-background-color);box-shadow:var(--container-box-shadow)}.error-container{border-color:var(--container-border-error-color)}.label{display:inline-block;color:var(--label-color);font-size:var(--label-font-size);font-weight:500;margin-bottom:var(--label-margin-bottom)}.optional-label{display:inline-block;color:var(--optional-label-color);font-size:var(--label-font-size);font-weight:500}.helper-text-container{display:flex;align-items:center;gap:4px;color:var(--helper-text-color);font-size:var(--helper-text-font-size);font-weight:500;margin-top:var(--helper-text-margin-top)}.helper-text-container cpsl-icon{--height:var(--helper-text-icon-size);--width:var(--helper-text-icon-size);--icon-color:var(--helper-text-icon-color)}.error-text{color:var(--helper-text-error-color)}.error-text cpsl-icon{--icon-color:var(--helper-text-icon-error-color)}.selected-container-content{flex:1}.selected-container-content.hidden{display:none}.chevron{transition:transform 0.3s ease;transform:rotate(180deg);--icon-color:var(--cpsl-color-text-disabled);--height:var(--icon-height);--width:var(--icon-width)}.chevron.open{transform:rotate(0deg);--icon-color:var(--cpsl-color-text-primary)}.chevron.has-value{--icon-color:var(--cpsl-color-text-primary)}.selected-text{--color-override:var(--select-color)}.selected-text.placeholder{--color-override:var(--select-color)}.dropdown{margin-top:var(--dropdown-margin-top);border-style:solid;border-width:var(--dropdown-border-width);border-color:var(--dropdown-border-color);border-radius:var(--dropdown-border-radius);overflow:hidden}.dropdown ::slotted(*:last-child){--container-border-width:0px}.dropdown-inner{overflow:auto;max-height:calc(100vh - 32px);scrollbar-width:thin}.dropdown-inner ::slotted(cpsl-input){padding:8px}.search-container{position:sticky;top:0px;padding:8px;background-color:var(--cpsl-color-select-surface-default)}";
const CpslSelectStyle0 = cpslSelectCss;

const CpslSelect = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslBlur = createEvent(this, "cpslBlur", 7);
        this.cpslFocus = createEvent(this, "cpslFocus", 7);
        this.cpslSelectValueChange = createEvent(this, "cpslSelectValueChange", 7);
        this.cpslSearchChange = createEvent(this, "cpslSearchChange", 7);
        this.inputId = `cpsl-select-${inputIds++}`;
        this.onBlur = (ev) => {
            this.hasFocus = false;
            this.popoverEl.closePopover();
            this.cpslBlur.emit(ev);
        };
        this.onFocus = (ev) => {
            this.hasFocus = true;
            this.cpslFocus.emit(ev);
        };
        this.handleEnterPress = (ev) => {
            if (ev.key === 'Enter') {
                ev.preventDefault();
                this.el.dispatchEvent(new MouseEvent('mousedown'));
            }
        };
        this.selectItem = () => {
            var _a;
            const items = Array.from(this.el.querySelectorAll('cpsl-select-item'));
            items.forEach(item => {
                var _a;
                if (typeof this.selectedValue === 'string') {
                    if (item.value === this.selectedValue) {
                        item.setAttribute('selected', 'true');
                    }
                    else {
                        item.setAttribute('selected', 'false');
                    }
                }
                else {
                    if ((_a = this.selectedValue) === null || _a === void 0 ? void 0 : _a.includes(item.value)) {
                        item.setAttribute('selected', 'true');
                    }
                    else {
                        item.setAttribute('selected', 'false');
                    }
                }
            });
            this.hasSelectedItem = typeof this.selectedValue === 'string' ? !!this.selectedValue : !!((_a = this.selectedValue) === null || _a === void 0 ? void 0 : _a.length);
        };
        this.handleClickOutside = (event) => {
            if (this.hasFocus && !this.el.contains(event.target)) {
                this.hasFocus = false;
                typeof window !== 'undefined' && window.removeEventListener('click', this.handleClickOutside);
            }
        };
        this.handleClick = (e) => {
            var _a;
            const targetId = (_a = e.target.id) !== null && _a !== void 0 ? _a : '';
            if (targetId === 'ignore-click') {
                return;
            }
            if (!this.disabled) {
                this.hasFocus = true;
                typeof window !== 'undefined' && window.addEventListener('click', this.handleClickOutside);
            }
        };
        this.anchorEl = undefined;
        this.hasFocus = false;
        this.popoverOpen = false;
        this.hasSelectedItem = false;
        this.anchorElId = undefined;
        this.autoWidth = false;
        this.disabled = false;
        this.dropdownMaxHeight = undefined;
        this.errorText = undefined;
        this.formatValue = undefined;
        this.helperText = undefined;
        this.id = `${this.inputId}-trigger`;
        this.icon = 'chevronUp';
        this.label = undefined;
        this.multiple = undefined;
        this.noIconAnimation = undefined;
        this.placeholder = undefined;
        this.required = false;
        this.selectedValue = undefined;
        this.showFormattedSelectedItem = undefined;
        this.showOptionalLabel = false;
        this.showSearch = false;
        this.searchPlaceholder = undefined;
        this.selectedItemColor = 'primary';
        this.selectedItemVariant = 'bodyM';
        this.selectedItemWeight = 'regular';
    }
    onValueChange() {
        if (!this.multiple) {
            this.popoverEl.closePopover();
        }
    }
    handleValueChange() {
        this.selectItem();
    }
    selectItemClickHandler(event) {
        this.cpslSelectValueChange.emit(event.detail);
    }
    onPopoverOpen() {
        this.popoverOpen = true;
    }
    onPopoverClose() {
        this.popoverOpen = false;
    }
    componentDidLoad() {
        this.popoverEl = this.el.shadowRoot.querySelector(`cpsl-popover`);
        this.anchorEl = this.anchorElId ? document.getElementById(this.anchorElId) : this.el.shadowRoot.getElementById('select-container');
        this.selectItem();
    }
    render() {
        var _a, _b, _c, _d, _e;
        const selectedValueAsString = Array.isArray(this.selectedValue) ? this.selectedValue.join(', ') : this.selectedValue;
        return (h(Host, { key: 'f7c2db799e3462ef83fd0e7b29a3fd88a2d69e38', id: this.id, class: { 'disabled': this.disabled, 'focused': this.hasFocus, 'has-value': this.hasSelectedItem } }, this.label && (h("label", { key: '8629dcd2d81bbf631962f84c551b2e2a3c96dd33', class: "label", htmlFor: this.inputId }, this.label, this.required ? '*' : ' ', !this.required && this.showOptionalLabel ? h("span", { class: "optional-label" }, "(optional)") : '')), h("div", { key: 'f01a1d57e48256e4b1898beeebb4c01275966aa6', part: "select-container", id: "select-container", class: { 'select-container': true, 'error-container': Boolean(this.errorText) }, onMouseDown: this.handleClick }, this.hasSelectedItem && this.showFormattedSelectedItem && h("slot", { key: 'eb8a31b3254990d3f4165275561b21fe9e9abaf9', name: "selected-item" }), h("div", { key: 'a78cec861e87ac9702477bddf10ec4c66cf37626', class: { 'selected-container-content': true, 'hidden': this.hasSelectedItem && this.showFormattedSelectedItem }, id: "selected-container-content", style: {} }, (!this.hasSelectedItem || !this.showFormattedSelectedItem) && (h("cpsl-text", { key: '74fdd4ff8ad178376220d89890f507b304298be4', class: { 'selected-text': true, 'placeholder': !this.selectedValue }, part: "selected-text", color: this.selectedItemColor, variant: this.selectedItemVariant, weight: this.selectedItemWeight }, !this.selectedValue ? ((_a = this.placeholder) !== null && _a !== void 0 ? _a : 'Select') : ((_c = (_b = this.formatValue) === null || _b === void 0 ? void 0 : _b.call(this, this.selectedValue)) !== null && _c !== void 0 ? _c : selectedValueAsString)))), h("cpsl-icon", { key: '7f0f942c54e7b72279fbff7cba99b1a84105b912', part: "icon", class: { 'chevron': true, 'open': !this.noIconAnimation && this.popoverOpen, 'has-value': this.hasSelectedItem }, icon: this.icon }), h("input", { key: '43e2fbcd9d13168ecdd9fadb2047591480cf2c42', id: this.inputId, disabled: this.disabled, class: { disabled: this.disabled }, value: this.selectedValue, onFocus: this.onFocus, onBlur: this.onBlur, onKeyPress: this.handleEnterPress, inputmode: "none" }), h("cpsl-popover", { key: '926ef9d6f59215260143f133104e63a46ecedc1f', part: "popover", autoWidth: this.autoWidth, trigger: this.id, preventBlur: this.hasFocus, disabled: this.disabled, anchorEl: this.anchorEl }, h("div", { key: '90520534785a584d539d5ef8e49ff394d2f4c3d7', part: "dropdown", class: "dropdown" }, this.showSearch && (h("div", { key: 'e0cf6cf0e4d0c17981b78428ff3ceeb049cebba5', class: "search-container" }, h("cpsl-input", { key: 'e1d3bc0a68026b0cbbca0677a30b26934b6296be', onClick: e => e.stopPropagation(), placeholder: (_d = this.searchPlaceholder) !== null && _d !== void 0 ? _d : 'Search', value: "", onCpslInput: e => {
                e.stopPropagation();
                this.cpslSearchChange.emit(e.detail.value);
            } }))), h("div", { key: '4f12646017f6b9c95a717188d7329750e8bdf74e', class: "dropdown-inner", style: { maxHeight: `${this.dropdownMaxHeight}px` } }, h("slot", { key: '33fd8a222ea76686c6d00ed388decb5ab10b98d8', name: "items" }))))), (this.errorText || this.helperText) && (h("div", { key: 'f9e99bd7e2a4c4eb98ea540c2ba0ed9a1e0feb67', class: { 'helper-text-container': true, 'error-text': Boolean(this.errorText) } }, h("span", { key: 'eae52c7b8dad9a6f702abb01f9f8205d7a96a82d' }, (_e = this.errorText) !== null && _e !== void 0 ? _e : this.helperText)))));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "selectedValue": ["onValueChange", "handleValueChange"]
    }; }
};
let inputIds = 0;
CpslSelect.style = CpslSelectStyle0;

const cpslSelectItemCss = ":host{--outer-container-padding-start:8px;--outer-container-padding-end:8px;--outer-container-padding-top:8px;--outer-container-padding-bottom:8px;--container-background-color:var(--cpsl-color-select-surface-default);--container-hover-background-color:var(--cpsl-color-select-surface-hover);--container-border-radius:calc(var(--cpsl-border-radius-select) - 4px);--container-padding-start:8px;--container-padding-end:8px;--container-padding-top:8px;--container-padding-bottom:8px;display:block;font-family:var(--cpsl-font-family, inherit);color:var(--cpsl-color-text-primary);cursor:pointer}.inner-container{-webkit-padding-start:var(--container-padding-start);padding-inline-start:var(--container-padding-start);-webkit-padding-end:var(--container-padding-end);padding-inline-end:var(--container-padding-end);padding-top:var(--container-padding-top);padding-bottom:var(--container-padding-bottom);background-color:var(--container-background-color);border-radius:var(--container-border-radius);height:100%;display:flex;align-items:center}.outer-container{-webkit-padding-start:var(--outer-container-padding-start);padding-inline-start:var(--outer-container-padding-start);-webkit-padding-end:var(--outer-container-padding-end);padding-inline-end:var(--outer-container-padding-end);padding-top:var(--outer-container-padding-top);padding-bottom:var(--outer-container-padding-bottom);background-color:var(--container-background-color)}.outer-container:hover>.inner-container{background-color:var(--container-hover-background-color)}.selected{background-color:var(--container-hover-background-color)}:host(.in-select-box){--container-background-color:transparent;--container-hover-background-color:transparent;--container-border-width:0px;--container-padding-start:0px;--container-padding-end:0px;--container-padding-top:0px;--container-padding-bottom:0px;flex:1;height:100%}";
const CpslSelectItemStyle0 = cpslSelectItemCss;

const CpslSelectItem = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslSelectItemClick = createEvent(this, "cpslSelectItemClick", 7);
        this.handleItemClick = () => {
            this.cpslSelectItemClick.emit(this.value);
        };
        this.selected = undefined;
        this.value = undefined;
    }
    render() {
        return (h(Host, { key: '532ed86577783bc61c40a18de178e63d16cf24c1' }, h("div", { key: 'ebf183f51dc2082e853cda6f490ab1b1a2c72f99', part: "outer-container", class: "outer-container", onClick: this.handleItemClick }, h("div", { key: '1e2c94c4e4a61638fc7a0439a36672bc22f47d28', part: "inner-container", class: { 'inner-container': true, 'selected': this.selected } }, h("slot", { key: 'a5c01c9f324912eff3c7958370bbec29050e4f4a' })))));
    }
};
CpslSelectItem.style = CpslSelectItemStyle0;

const cpslSlideButtonCss = ":host{--slider-container-font-size:14px;--slider-container-height:44px;--slider-container-border-width:1px;--slider-container-box-shadow:0px 0px 4px 0px var(--cpsl-color-alpha-black-10) inset;--slider-container-start-background-color:var(--cpsl-color-slideButton-slider-container-start-background);--slider-container-end-background-color:var(--cpsl-color-slideButton-slider-container-end-background);--slider-container-start-border-color:var(--cpsl-color-slideButton-slider-container-start-border);--slider-container-end-border-color:var(--cpsl-color-slideButton-slider-container-end-border);--slider-border-width:1px;--slider-box-shadow:3px 0px 4px 0px var(--cpsl-color-alpha-black-16);--slider-border-color:var(--cpsl-color-slideButton-slider-border);--slider-background-color:var(--cpsl-color-slideButton-slider-background);--slider-color:var(--cpsl-color-slideButton-slider-text);--start-text-color:var(--cpsl-color-slideButton-start-text);--end-text-color:var(--cpsl-color-slideButton-end-text);font-family:var(--cpsl-font-family, inherit);display:block}.slider-container{overflow:hidden;position:relative;box-sizing:border-box;display:flex;align-items:center;font-size:var(--slider-container-font-size);font-weight:500;height:var(--slider-container-height);border-width:var(--slider-container-border-width);border-style:solid;border-radius:calc(var(--slider-container-height) / 2);box-shadow:var(--slider-container-box-shadow)}.slider-container-background{position:absolute;top:0;bottom:0;left:0;right:0}.start-slider-container-background{background:var(--slider-container-start-background-color);border-color:var(--slider-container-start-border-color);opacity:100%}.end-slider-container-background{background:var(--slider-container-end-background-color);border-color:var(--slider-container-end-border-color);opacity:0%}.start-text{user-select:none;color:var(--start-text-color);position:absolute;text-align:center;opacity:100%;width:calc(100% - var(--slider-container-height) - 8px - 16px);left:calc(var(--slider-container-height) - 4px + 8px)}.start-text.disabled{left:0;width:100%}.end-text{user-select:none;color:var(--end-text-color);position:absolute;text-align:center;opacity:0%;width:calc(100% - var(--slider-container-height) - 8px);left:16px}.icon{position:absolute}.start-icon{opacity:100%}.end-icon{opacity:0%}.slider{left:1px;cursor:pointer;box-sizing:border-box;display:flex;align-items:center;justify-content:center;position:absolute;z-index:10;height:calc(var(--slider-container-height) - 4px);width:calc(var(--slider-container-height) - 4px);color:var(--slider-color);background:var(--slider-background-color);border-width:var(--slider-border-width);border-style:solid;border-color:var(--slider-border-color);border-radius:100%;box-shadow:var(--slider-box-shadow)}.slider cpsl-icon{--icon-color:var(--slider-color)}.slider.disabled{visibility:hidden}";
const CpslSlideButtonStyle0 = cpslSlideButtonCss;

const CpslSlideButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslComplete = createEvent(this, "cpslComplete", 7);
        this.disabled = undefined;
        this.endIcon = undefined;
        this.endText = undefined;
        this.startIcon = undefined;
        this.startText = undefined;
    }
    componentDidLoad() {
        this.dragElement(this.el.shadowRoot.getElementById('slider'));
    }
    dragElement(el) {
        const pointerDown = (e) => {
            pos3 = e.clientX;
            switch (e.pointerType) {
                case 'mouse':
                    el.onmousedown = dragMouseDown;
                    break;
                default:
                    el.ontouchstart = dragTouchDown;
            }
        };
        const dragMouseDown = (e) => {
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementMouseDrag;
        };
        const dragTouchDown = (e) => {
            e.preventDefault();
            const touchLocation = e.targetTouches[0];
            // get the mouse cursor position at startup:
            pos3 = touchLocation.clientX;
            document.ontouchend = closeDragElement;
            // call a function whenever the cursor moves:
            document.ontouchmove = elementTouchDrag;
        };
        const elementMouseDrag = (e) => {
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos3 = e.clientX;
            // set the element's new position:
            finishElementDrag(pos1);
        };
        const elementTouchDrag = (e) => {
            e.preventDefault();
            const touchLocation = e.targetTouches[0];
            // calculate the new cursor position:
            pos1 = pos3 - touchLocation.clientX;
            pos3 = touchLocation.clientX;
            // set the element's new position:
            finishElementDrag(pos1);
        };
        const finishElementDrag = (pos) => {
            const newPos = el.offsetLeft - pos;
            if (newPos >= minX && newPos <= maxX) {
                const newPosPercent = Math.max(Math.min(Math.round((newPos / maxX) * 100) / 100, 100), 0);
                startTextEl.style.opacity = `${(1 - newPosPercent * 2) * 100}%`;
                endTextEl.style.opacity = `${newPosPercent * 100}%`;
                startIconEl.style.opacity = `${(1 - newPosPercent * 2) * 100}%`;
                endIconEl.style.opacity = `${newPosPercent * 100}%`;
                endBackgroundEl.style.opacity = `${newPosPercent * 100}%`;
                el.style.left = `${newPos}px`;
            }
        };
        const closeDragElement = () => {
            if (el.offsetLeft + sliderHeight >= containerWidth - sliderHeight / 2) {
                el.style.left = `${maxX}px`;
                startTextEl.style.opacity = '0%';
                endTextEl.style.opacity = '100%';
                startIconEl.style.opacity = '0%';
                endIconEl.style.opacity = '100%';
                endBackgroundEl.style.opacity = '100%';
                this.cpslComplete.emit(true);
            }
            else {
                el.style.left = `${minX}px`;
                startTextEl.style.opacity = '100%';
                endTextEl.style.opacity = '0%';
                startIconEl.style.opacity = '100%';
                endIconEl.style.opacity = '0%';
                endBackgroundEl.style.opacity = '0%';
            }
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
            document.ontouchend = null;
            document.ontouchmove = null;
        };
        const startIconEl = this.startIconEl;
        const endIconEl = this.endIconEl;
        const startTextEl = this.startTextEl;
        const endTextEl = this.endTextEl;
        const endBackgroundEl = this.endBackgroundEl;
        const sliderContainerEl = this.sliderContainerEl;
        const containerWidth = sliderContainerEl.clientWidth;
        const sliderHeight = el.getBoundingClientRect().height;
        // Offset min by 1 for 1px left padding
        const minX = 1;
        // Offset max by the slider width and 1px for padding
        const maxX = containerWidth - sliderHeight - 1;
        let pos1 = 0, pos3 = 0;
        el.onpointerdown = pointerDown;
    }
    get sliderContainerEl() {
        return this.el.shadowRoot.getElementById('slider-container');
    }
    get startTextEl() {
        return this.el.shadowRoot.getElementById('start-text');
    }
    get endTextEl() {
        return this.el.shadowRoot.getElementById('end-text');
    }
    get endBackgroundEl() {
        return this.el.shadowRoot.getElementById('end-slider-container-background');
    }
    get startIconEl() {
        return this.el.shadowRoot.getElementById('start-icon');
    }
    get endIconEl() {
        return this.el.shadowRoot.getElementById('end-icon');
    }
    render() {
        return (h(Host, { key: '4cd2c0e88b4836325857aecea70bd262018baefd' }, h("div", { key: 'eee70d9571d47c07478be116c7d738f6402393d0', id: "slider-container", class: "slider-container" }, h("div", { key: 'aff7fd5e09a95f45b4fde7628f4c400dc7753835', id: "start-slider-container-background", class: { 'start-slider-container-background': true, 'slider-container-background': true } }), h("div", { key: 'fd64d833e993529e49dc9abdae1ec260c8798f0b', id: "end-slider-container-background", class: { 'end-slider-container-background': true, 'slider-container-background': true } }), h("div", { key: '28d0e79995492aaf436d6457e9f35a2c0881fc11', id: "slider", class: { slider: true, disabled: this.disabled } }, h("cpsl-icon", { key: '4f12bd968a45fea838a70b9af5523ebf02706c55', id: "start-icon", class: { 'start-icon': true, 'icon': true }, icon: this.startIcon }), h("cpsl-icon", { key: 'a5ee6ff782cd7bf740643282aab6fdc9ed96c801', id: "end-icon", class: { 'end-icon': true, 'icon': true }, icon: this.endIcon })), h("span", { key: '031528feaecf081c11d593ad325f677c15f11e4a', id: "start-text", class: { 'start-text': true, 'disabled': this.disabled } }, this.startText), h("span", { key: '9029dac9f64836ff7649b26f3ff11cba5bfa1446', id: "end-text", class: "end-text" }, this.endText))));
    }
    get el() { return getElement(this); }
};
CpslSlideButton.style = CpslSlideButtonStyle0;

const cpslSpinnerCss = ":host{--width:54px;--height:54px;--bar-width:12px;--inner-width:calc(var(--width) / 2 - var(--bar-width));--bar-color:var(--cpsl-color-foreground-0);--background-color:var(--cpsl-color-background-0);width:var(--width);height:var(--height);display:flex;justify-content:center;align-items:center}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}100%{transform:rotate(360deg);-webkit-transform:rotate(360deg)}}@-moz-keyframes spin{100%{-moz-transform:rotate(360deg)}}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg)}50%{-webkit-transform:rotate(180deg)}100%{-webkit-transform:rotate(360deg)}}:host .loader{position:relative;width:100%;aspect-ratio:1;opacity:1;background:conic-gradient(transparent, transparent 12%, var(--bar-color));border-radius:50%;margin:auto;animation:spin 0.8s cubic-bezier(0.3, 0.5, 0.5, 0.5) infinite, opacity 0.2s;mask-image:radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0) var(--inner-width), black var(--inner-width))}:host .loader::before{content:\"\";position:absolute;border-radius:inherit;top:0;left:50%;transform:translateX(-50%);background:linear-gradient(to left, var(--bar-color) 50%, transparent 50%);width:var(--bar-width);aspect-ratio:1;animation:opacity 0.2s}:host .loader.error{background:var(--cpsl-color-utility-red);animation:opacity 0.2s}:host .loader.error::before{opacity:0}:host .loader.inactive{opacity:0;animation:none}:host .loader.inactive::before{opacity:0}";
const CpslSpinnerStyle0 = cpslSpinnerCss;

const CpslSpinner = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.variant = 'default';
        this.size = 54;
        this.barWidth = undefined;
        this.speed = 1;
    }
    render() {
        return (h(Host, { key: '218db1b832fb9968ce57b0ed96b19adfa746689d', style: {
                ['--height']: `${this.size}px`,
                ['--width']: `${this.size}px`,
                ['--bar-width']: `${this.barWidth ? this.barWidth : this.size * 0.12}px`,
            } }, h("div", { key: 'ac9f128fee0043c786334cd8dfeaa4753fad8736', class: { loader: true, [this.variant]: true } })));
    }
};
CpslSpinner.style = CpslSpinnerStyle0;

const cpslSwitchCss = ":host{--container-height:24px;--container-width:44px;--container-padding:2px;--container-border-radius:var(--cpsl-border-radius-switch);--container-background-color-default:var(--cpsl-color-switch-surface-default);--container-background-color-checked:var(--cpsl-color-switch-surface-checked);--thumb-size:calc(var(--container-height) - var(--container-padding) * 2);--thumb-border-radius:var(--cpsl-border-radius-switch);--thumb-background-color-default:var(--cpsl-color-switch-thumb-default);--thumb-background-color-checked:var(--cpsl-color-switch-thumb-checked);display:block;position:relative;height:var(--container-height);width:var(--container-width);cursor:pointer}input{position:absolute;width:100%;height:100%;margin:0px;opacity:0}span.container{display:inline-block;position:relative;box-sizing:border-box;width:100%;height:100%;padding:var(--container-padding);border-radius:var(--container-border-radius);background:var(--container-background-color-default);box-shadow:0px 1px 2px 0px rgba(0, 0, 0, 0.08) inset;transition:all 0.15s ease-in-out}span.container.checked{background:var(--container-background-color-checked);box-shadow:none}span.thumb{display:inline-block;position:relative;background:var(--thumb-background-color-default);box-shadow:0px 1px 1px 0px rgba(0, 0, 0, 0.1);height:var(--thumb-size);width:var(--thumb-size);border-radius:var(--thumb-border-radius);transform:translateX(0);left:0;transition:all 0.15s ease-in-out}span.thumb.checked{background:var(--thumb-background-color-checked);left:100%;transform:translateX(-100%)}";
const CpslSwitchStyle0 = cpslSwitchCss;

const CpslSwitch = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslSwitchChanged = createEvent(this, "cpslSwitchChanged", 7);
        this.handleSwitchClick = () => {
            this.cpslSwitchChanged.emit(!this.checked);
        };
        this.checked = undefined;
    }
    render() {
        return (h(Host, { key: '80395b6f36c5653c725a69883098d2822cb6d420' }, h("input", { key: 'b9f74ffce1f02b8efa28b47f60c82e549a87bd09', type: "checkbox", checked: this.checked }), h("span", { key: '1f0763f6aaca5f55a66620a59444a907dc837360', onClick: this.handleSwitchClick, class: { container: true, checked: this.checked } }, h("span", { key: '1804cbae3ea10091952722c6bfb50c6dd518fe0b', class: { thumb: true, checked: this.checked } }))));
    }
};
CpslSwitch.style = CpslSwitchStyle0;

const cpslTabCss = ":host{--tab-color:var(--cpsl-color-text-secondary);--tab-gap:2px;--tab-icon-height:16px;--tab-icon-width:16px;display:flex;flex:1 1 auto;align-items:center;cursor:pointer;z-index:10}:host ::slotted([slot=start]){--icon-color:var(--tab-color);--height:var(--tab-icon-height);--width:var(--tab-icon-width)}:host ::slotted([slot=end]){--icon-color:var(--tab-color);--height:var(--tab-icon-height);--width:var(--tab-icon-width)}:host(.selected){--tab-color:var(--cpsl-color-text-primary)}.tab-container{align-items:center;overflow:hidden;width:100%;text-overflow:ellipsis;text-align:center;white-space:nowrap;font-weight:500;color:var(--tab-color);display:flex;gap:var(--tab-gap);padding-top:var(--tab-top-padding);padding-bottom:var(--tab-bottom-padding);padding-left:var(--tab-left-padding);padding-right:var(--tab-right-padding)}.content{flex:1 1 auto}";
const CpslTabStyle0 = cpslTabCss;

const CpslTab = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslTabButtonClick = createEvent(this, "cpslTabButtonClick", 7);
        this.cpslTabButtonSizeChange = createEvent(this, "cpslTabButtonSizeChange", 7);
        this.onTabClicked = () => {
            this.cpslTabButtonClick.emit({ tab: this.tab, selected: this.selected });
        };
        this.selected = false;
        this.tab = undefined;
    }
    onTabsChanged(ev) {
        this.setSelected(ev);
    }
    onTabsInit(ev) {
        this.setSelected(ev);
    }
    componentDidLoad() {
        new MutationObserver(() => {
            this.cpslTabButtonSizeChange.emit({ tab: this.tab });
        }).observe(this.el, {
            attributes: true,
        });
    }
    setSelected(ev) {
        const dispatchedFrom = ev.target;
        const parent = this.el.parentElement;
        if (ev.composedPath().includes(parent) || (dispatchedFrom === null || dispatchedFrom === void 0 ? void 0 : dispatchedFrom.contains(this.el))) {
            this.selected = this.tab === ev.detail.tab;
        }
    }
    render() {
        return (h(Host, { key: 'dffbcb7a246b03dd586d05152b3c53d3d5af3f87', class: { selected: this.selected }, onClick: this.onTabClicked }, h("div", { key: 'a9606f29660d01f66f3474d2aa2efb99f83ee569', class: { 'tab-container': true } }, h("slot", { key: '0974381842769333c6a5cfa94e842feec5feaf56', name: "start" }), h("div", { key: 'b0d17ead876fab16b55b8a3176828ca76f553ead', class: "content" }, h("slot", { key: '6bdb9f6706881fee90d9a0cc759e29b65eeb3113' })), h("slot", { key: '7c9b87600f7e4fec0509bda1a080f3116c0fbbfe', name: "end" }))));
    }
    get el() { return getElement(this); }
};
CpslTab.style = CpslTabStyle0;

const cpslTableCss = ":host{--container-border-radius:var(--cpsl-border-radius-table-container);--container-border-color:var(--cpsl-color-background-16);--container-background-color:var(--cpsl-color-background-0);--container-border-width:1px;--container-header-padding-top:24px;--container-header-padding-bottom:24px;--container-header-padding-start:24px;--container-header-padding-end:24px;--container-header-border-width:1px;--container-header-border-color:var(--cpsl-color-background-16);--container-footer-padding-top:16px;--container-footer-padding-bottom:16px;--container-footer-padding-start:24px;--container-footer-padding-end:24px;--container-footer-border-width:1px;--container-footer-border-color:var(--cpsl-color-background-8);--table-header-padding-top:16px;--table-header-padding-bottom:16px;--table-header-padding-start:24px;--table-header-padding-end:24px;--table-header-background-color:var(--cpsl-color-background-4);--table-header-border-color:var(--cpsl-color-background-16);--table-header-border-width:1px;--table-content-padding-top:16px;--table-content-padding-bottom:16px;--table-content-padding-start:24px;--table-content-padding-end:24px;--table-content-border-color:var(--cpsl-color-background-8);--table-content-border-width:1px;display:block}:host cpsl-card{height:100%;--card-padding-top:0px;--card-padding-bottom:0px;--card-padding-start:0px;--card-padding-end:0px;--card-border-width:var(--container-border-width);--card-border-color:var(--container-border-color);--card-border-radius:var(--container-border-radius);--card-background-color:var(--container-background-color)}:host cpsl-card::part(card-container){height:100%;display:flex;flex-direction:column}.content{flex:1;overflow:auto;position:relative}.overlay{position:absolute;top:0;left:0;right:0;bottom:0;pointer-events:none}.overlay.horizontal-scroll:not(.vertical-scroll){box-shadow:-24px 0px 24px -24px rgba(0, 0, 0, 0.1) inset}.overlay.vertical-scroll:not(.horizontal-scroll){box-shadow:0px -24px 24px -24px rgba(0, 0, 0, 0.1) inset}.overlay.horizontal-scroll.vertical-scroll{box-shadow:-24px -24px 24px -24px rgba(0, 0, 0, 0.1) inset}.table-wrapper{overflow:auto;height:100%}.container-header{display:none;-webkit-padding-start:var(--container-header-padding-start);padding-inline-start:var(--container-header-padding-start);-webkit-padding-end:var(--container-header-padding-end);padding-inline-end:var(--container-header-padding-end);padding-top:var(--container-header-padding-top);padding-bottom:var(--container-header-padding-bottom);border-bottom:var(--container-header-border-width) solid var(--container-header-border-color)}.container-footer{display:none;-webkit-padding-start:var(--container-footer-padding-start);padding-inline-start:var(--container-footer-padding-start);-webkit-padding-end:var(--container-footer-padding-end);padding-inline-end:var(--container-footer-padding-end);padding-top:var(--container-footer-padding-top);padding-bottom:var(--container-footer-padding-bottom);border-top:var(--container-footer-border-width) solid var(--container-footer-border-color)}.shown{display:block}";
const CpslTableStyle0 = cpslTableCss;

const CpslTable = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.resizeOb = new ResizeObserver(entries => {
            // since we are observing only a single element, so we access the first element in entries array
            const rect = entries[0].contentRect;
            // current width & height
            const containerWidth = Math.round(rect.width);
            const containerHeight = Math.round(rect.height);
            const contentWidth = this.containerSlotEl.clientWidth;
            const contentHeight = this.containerSlotEl.clientHeight;
            if (contentWidth > containerWidth) {
                this.hasHorizontalScroll = true;
            }
            else {
                this.hasHorizontalScroll = false;
            }
            if (contentHeight > containerHeight) {
                this.hasVerticalScroll = true;
            }
            else {
                this.hasVerticalScroll = false;
            }
        });
        this.hasHorizontalScroll = false;
        this.hasVerticalScroll = false;
    }
    componentDidLoad() {
        this.resizeOb.observe(this.contentContainerEl);
    }
    get containerHeaderEl() {
        return this.el.querySelector('[slot="header"]');
    }
    get containerFooterEl() {
        return this.el.querySelector('[slot="footer"]');
    }
    get contentContainerEl() {
        return this.el.shadowRoot.getElementById('content-container');
    }
    get headerEl() {
        return this.el.shadowRoot.getElementById('header-container');
    }
    get containerSlotEl() {
        return this.el.querySelector('[slot="content"]');
    }
    get footerEl() {
        return this.el.shadowRoot.getElementById('footer-container');
    }
    render() {
        return (h(Host, { key: '144ebe0917ce215a128b6653c8ed47138be7b319' }, h("cpsl-card", { key: '8197bc383734a332a2e0ee7221a1990ba20b1f84', part: "table-container", style: { position: 'relative' } }, h("div", { key: 'dd8d0026515ce96a848ae4a6cdf5cdab7bb7ddf2', id: "header-container", class: { 'container-header': true, 'shown': Boolean(this.containerHeaderEl) } }, h("slot", { key: '1b5a2cbae0fa49bb0b5b4d89fef4b44ce8a46439', name: "header" })), h("div", { key: 'e22bd3b94832ded10fe7b152d2d0c68165853529', id: "content-container", class: { 'content': true, 'horizontal-scroll': this.hasHorizontalScroll, 'vertical-scroll': this.hasVerticalScroll }, part: "content" }, h("slot", { key: 'f1bbfc01f1c25f820d9d4846ac1a7f64c21ee03b', name: "content" })), this.headerEl && this.contentContainerEl && this.footerEl && (h("div", { key: 'ad1e130185b6621b763892ae693ffab1d6243ae5', style: { top: `${this.headerEl.clientHeight + 2}px`, height: `${this.contentContainerEl.clientHeight}px` }, class: { 'overlay': true, 'horizontal-scroll': this.hasHorizontalScroll, 'vertical-scroll': this.hasVerticalScroll } })), h("div", { key: 'fb8b26f5d97b3965c50676b0541a14f21c675fe6', id: "footer-container", class: { 'container-footer': true, 'shown': Boolean(this.containerFooterEl) } }, h("slot", { key: '70a40dfe9bb80e3c825c895d12cb971467898e6a', name: "footer" })))));
    }
    get el() { return getElement(this); }
};
CpslTable.style = CpslTableStyle0;

const cpslTabsCss = ":host{--tab-top-padding:5px;--tab-bottom-padding:5px;--tab-left-padding:16px;--tab-right-padding:16px;--tabs-border-radius:var(--cpsl-border-radius-tabs);--tabs-font-size:12px;--tabs-line-height:24px;--tabs-border-width:1px;--tabs-border-color:var(--cpsl-color-tabs-border);--tabs-background-color:var(--cpsl-color-tabs-background);--slider-background-color:var(--cpsl-color-tabs-slider-background);display:inline-block;width:fit-content;max-width:100%;font-family:var(--cpsl-font-family, inherit)}:host(.full-width){display:block}.tabs-container{position:relative;display:flex;overflow-x:scroll;overflow-y:hidden;border-width:var(--tabs-border-width);border-style:solid;border-color:var(--tabs-border-color);border-radius:var(--tabs-border-radius);background:var(--tabs-background-color);font-size:var(--tabs-font-size);line-height:var(--tabs-line-height);-ms-overflow-style:none;scrollbar-width:none}.tabs-container::-webkit-scrollbar{display:none}.slider{position:absolute;top:calc(var(--tabs-border-width) * -1);bottom:calc(var(--tabs-border-width) * -1);left:-1px;margin:4px;border-radius:var(--tabs-border-radius);background:var(--slider-background-color)}.loaded{transition:all 0.5s}";
const CpslTabsStyle0 = cpslTabsCss;

const CpslTabs = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.cpslTabsChanged = createEvent(this, "cpslTabsChanged", 7);
        this.cpslTabsInit = createEvent(this, "cpslTabsInit", 7);
        this.onTabClicked = (ev) => {
            const { tab } = ev.detail;
            if (tab !== this.selectedTab) {
                this.selectedTabRect = getTab(this.tabs, tab).getBoundingClientRect();
                this.cpslTabsChanged.emit({
                    tab,
                });
            }
        };
        this.selectedTabRect = undefined;
        this.loaded = false;
        this.fullWidth = undefined;
        this.selectedTab = undefined;
    }
    updateSlider() {
        // Allow component to condense or expand before recalculating silder
        setTimeout(() => {
            this.selectedTabRect = getTab(this.tabs, this.selectedTab).getBoundingClientRect();
        }, 50);
    }
    updateTab(newValue, oldValue) {
        if (Boolean(newValue) && !oldValue) {
            this.selectedTabRect = getTab(this.tabs, this.selectedTab).getBoundingClientRect();
        }
    }
    onTabSizeChange(ev) {
        const { tab } = ev.detail;
        if (tab === this.selectedTab) {
            this.selectedTabRect = getTab(this.tabs, tab).getBoundingClientRect();
        }
    }
    componentWillLoad() {
        var _a, _b;
        this.selectedTabRect = (_b = (_a = getTab(this.tabs, this.selectedTab)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : { width: 0, x: 0 };
        this.cpslTabsInit.emit({
            tab: this.selectedTab,
        });
    }
    componentDidLoad() {
        var _a, _b;
        this.selectedTabRect = (_b = (_a = getTab(this.tabs, this.selectedTab)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : { width: 0, x: 0 };
        // Allow slider to be rendered with the correct initial style before the transition is added
        setTimeout(() => {
            this.loaded = true;
        }, 50);
    }
    get tabs() {
        return Array.from(this.el.querySelectorAll('cpsl-tab'));
    }
    render() {
        const tabsPosition = this.el.getBoundingClientRect();
        // Get border width as a number
        const tabsBorderWidth = +getComputedStyle(this.el).getPropertyValue('--tabs-border-width').slice(0, -2);
        const selectedTabRect = this.selectedTabRect;
        return (h(Host, { key: '4a52ac10f673a907bde10ff86fabc15c0e8a2bf8', class: { 'full-width': this.fullWidth }, onCpslTabButtonClick: this.onTabClicked }, h("div", { key: '1473724b5b53e942082a1ba40148ba2f3595bdbd', class: "tabs-container" }, h("slot", { key: 'ac682db2fc58ceea90d55208b1617a90452c4f55' }), h("div", { key: '219d7e45a8403795f2a7fd1ba0b30833e4488691', class: { slider: true, loaded: this.loaded }, style: { width: `${selectedTabRect.width - 8}px`, left: `${selectedTabRect.x - tabsPosition.x - tabsBorderWidth}px` } }))));
    }
    get el() { return getElement(this); }
    static get watchers() { return {
        "fullWidth": ["updateSlider"],
        "selectedTab": ["updateTab"]
    }; }
};
const getTab = (tabs, tab) => {
    const tabEl = typeof tab === 'string' ? tabs.find(t => t.tab === tab) : tab;
    return tabEl;
};
CpslTabs.style = CpslTabsStyle0;

const cpslTextCss = ":host{display:block;font-family:var(--cpsl-font-family, inherit);padding:0px;margin:0px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-smooth:never;font-synthesis:none}:host(.primary){color:var(--color-override, var(--cpsl-color-text-primary))}:host(.primary)>p,:host(.primary) h1,:host(.primary) h2,:host(.primary) h3,:host(.primary) h4,:host(.primary) h5,:host(.primary) h6{color:var(--color-override, var(--cpsl-color-text-primary))}:host(.secondary){color:var(--color-override, var(--cpsl-color-text-secondary))}:host(.secondary)>p,:host(.secondary) h1,:host(.secondary) h2,:host(.secondary) h3,:host(.secondary) h4,:host(.secondary) h5,:host(.secondary) h6{color:var(--color-override, var(--cpsl-color-text-secondary))}:host(.tertiary){color:var(--color-override, var(--cpsl-color-text-tertiary))}:host(.tertiary)>p,:host(.tertiary) h1,:host(.tertiary) h2,:host(.tertiary) h3,:host(.tertiary) h4,:host(.tertiary) h5,:host(.tertiary) h6{color:var(--color-override, var(--cpsl-color-text-tertiary))}:host(.subtle){color:var(--color-override, var(--cpsl-color-text-subtle))}:host(.subtle)>p,:host(.subtle) h1,:host(.subtle) h2,:host(.subtle) h3,:host(.subtle) h4,:host(.subtle) h5,:host(.subtle) h6{color:var(--color-override, var(--cpsl-color-text-subtle))}:host(.inverted){color:var(--color-override, var(--cpsl-color-text-inverted))}:host(.inverted)>p,:host(.inverted) h1,:host(.inverted) h2,:host(.inverted) h3,:host(.inverted) h4,:host(.inverted) h5,:host(.inverted) h6{color:var(--color-override, var(--cpsl-color-text-inverted))}:host(.error){color:var(--color-override, var(--cpsl-color-text-error))}:host(.error)>p,:host(.error) h1,:host(.error) h2,:host(.error) h3,:host(.error) h4,:host(.error) h5,:host(.error) h6{color:var(--color-override, var(--cpsl-color-text-error))}:host(.contrast){color:var(--color-override, var(--cpsl-color-text-contrast))}:host(.contrast)>p,:host(.contrast) h1,:host(.contrast) h2,:host(.contrast) h3,:host(.contrast) h4,:host(.contrast) h5,:host(.contrast) h6{color:var(--color-override, var(--cpsl-color-text-contrast))}:host(.regular){font-weight:400}:host(.regular)>p,:host(.regular) h1,:host(.regular) h2,:host(.regular) h3,:host(.regular) h4,:host(.regular) h5,:host(.regular) h6{font-weight:400}:host(.medium){font-weight:500}:host(.medium)>p,:host(.medium) h1,:host(.medium) h2,:host(.medium) h3,:host(.medium) h4,:host(.medium) h5,:host(.medium) h6{font-weight:500}:host(.semi-bold){font-weight:600}:host(.semi-bold)>p,:host(.semi-bold) h1,:host(.semi-bold) h2,:host(.semi-bold) h3,:host(.semi-bold) h4,:host(.semi-bold) h5,:host(.semi-bold) h6{font-weight:600}:host(.bold){font-weight:700}:host(.bold)>p,:host(.bold) h1,:host(.bold) h2,:host(.bold) h3,:host(.bold) h4,:host(.bold) h5,:host(.bold) h6{font-weight:700}:host(.body-2xs){font-size:var(--cpsl-font-size-body-2xs)}:host(.body-2xs)>p,:host(.body-2xs) h1,:host(.body-2xs) h2,:host(.body-2xs) h3,:host(.body-2xs) h4,:host(.body-2xs) h5,:host(.body-2xs) h6{font-size:var(--cpsl-font-size-body-2xs)}:host(.body-xs){font-size:var(--cpsl-font-size-body-xs)}:host(.body-xs)>p,:host(.body-xs) h1,:host(.body-xs) h2,:host(.body-xs) h3,:host(.body-xs) h4,:host(.body-xs) h5,:host(.body-xs) h6{font-size:var(--cpsl-font-size-body-xs)}:host(.body-s){font-size:var(--cpsl-font-size-body-s);line-height:142.857%}:host(.body-s)>p,:host(.body-s) h1,:host(.body-s) h2,:host(.body-s) h3,:host(.body-s) h4,:host(.body-s) h5,:host(.body-s) h6{font-size:var(--cpsl-font-size-body-s);line-height:142.857%}:host(.body-m){font-size:var(--cpsl-font-size-body-m);line-height:150%}:host(.body-m)>p,:host(.body-m) h1,:host(.body-m) h2,:host(.body-m) h3,:host(.body-m) h4,:host(.body-m) h5,:host(.body-m) h6{font-size:var(--cpsl-font-size-body-m);line-height:150%}:host(.body-l){font-size:var(--cpsl-font-size-body-l);line-height:140%}:host(.body-l)>p,:host(.body-l) h1,:host(.body-l) h2,:host(.body-l) h3,:host(.body-l) h4,:host(.body-l) h5,:host(.body-l) h6{font-size:var(--cpsl-font-size-body-l);line-height:140%}:host(.body-xl){font-size:var(--cpsl-font-size-body-xl)}:host(.body-xl)>p,:host(.body-xl) h1,:host(.body-xl) h2,:host(.body-xl) h3,:host(.body-xl) h4,:host(.body-xl) h5,:host(.body-xl) h6{font-size:var(--cpsl-font-size-body-xl)}:host(.heading-xs){font-size:var(--cpsl-font-size-heading-xs)}:host(.heading-xs)>p,:host(.heading-xs) h1,:host(.heading-xs) h2,:host(.heading-xs) h3,:host(.heading-xs) h4,:host(.heading-xs) h5,:host(.heading-xs) h6{font-size:var(--cpsl-font-size-heading-xs)}:host(.heading-s){font-size:var(--cpsl-font-size-heading-s)}:host(.heading-s)>p,:host(.heading-s) h1,:host(.heading-s) h2,:host(.heading-s) h3,:host(.heading-s) h4,:host(.heading-s) h5,:host(.heading-s) h6{font-size:var(--cpsl-font-size-heading-s)}:host(.heading-m){font-size:var(--cpsl-font-size-heading-m);letter-spacing:-0.4px}:host(.heading-m)>p,:host(.heading-m) h1,:host(.heading-m) h2,:host(.heading-m) h3,:host(.heading-m) h4,:host(.heading-m) h5,:host(.heading-m) h6{font-size:var(--cpsl-font-size-heading-m);letter-spacing:-0.4px}:host(.heading-l){font-size:var(--cpsl-font-size-heading-l);letter-spacing:-1.12px}:host(.heading-l)>p,:host(.heading-l) h1,:host(.heading-l) h2,:host(.heading-l) h3,:host(.heading-l) h4,:host(.heading-l) h5,:host(.heading-l) h6{font-size:var(--cpsl-font-size-heading-l);letter-spacing:-1.12px}:host(.heading-xl){font-size:var(--cpsl-font-size-heading-xl);letter-spacing:-1.28px}:host(.heading-xl)>p,:host(.heading-xl) h1,:host(.heading-xl) h2,:host(.heading-xl) h3,:host(.heading-xl) h4,:host(.heading-xl) h5,:host(.heading-xl) h6{font-size:var(--cpsl-font-size-heading-xl);letter-spacing:-1.28px}:host(.heading-2xl){font-size:var(--cpsl-font-size-heading-2xl);letter-spacing:-1.44px}:host(.heading-2xl)>p,:host(.heading-2xl) h1,:host(.heading-2xl) h2,:host(.heading-2xl) h3,:host(.heading-2xl) h4,:host(.heading-2xl) h5,:host(.heading-2xl) h6{font-size:var(--cpsl-font-size-heading-2xl);letter-spacing:-1.44px}:host p,h1,h2,h3,h4,h5,h6{font-family:var(--cpsl-font-family, inherit);padding:0px;margin:0px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-smooth:never;font-synthesis:none}:host p::-moz-selection,h1::-moz-selection,h2::-moz-selection,h3::-moz-selection,h4::-moz-selection,h5::-moz-selection,h6::-moz-selection{color:var(--cpsl-color-text-inverted) !important;background:var(--cpsl-color-background-64) !important}:host p::selection,h1::selection,h2::selection,h3::selection,h4::selection,h5::selection,h6::selection{color:var(--cpsl-color-text-inverted) !important;background:var(--cpsl-color-background-64) !important}";
const CpslTextStyle0 = cpslTextCss;

const TEXT_EL_PART = 'text-element';
const CpslText = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.getContent = () => {
            switch (this.variant) {
                case 'headingXS': {
                    return (h("h6", { part: TEXT_EL_PART }, h("slot", null)));
                }
                case 'headingS': {
                    return (h("h5", { part: TEXT_EL_PART }, h("slot", null)));
                }
                case 'headingM': {
                    return (h("h4", { part: TEXT_EL_PART }, h("slot", null)));
                }
                case 'headingL': {
                    return (h("h3", { part: TEXT_EL_PART }, h("slot", null)));
                }
                case 'headingXL': {
                    return (h("h2", { part: TEXT_EL_PART }, h("slot", null)));
                }
                case 'heading2XL': {
                    return (h("h1", { part: TEXT_EL_PART }, h("slot", null)));
                }
                default: {
                    return (h("p", { part: TEXT_EL_PART }, h("slot", null)));
                }
            }
        };
        this.color = 'primary';
        this.variant = 'bodyM';
        this.weight = 'regular';
    }
    render() {
        return (h(Host, { key: '0fe34c3a91b7ac83a985eccbf47aa423c21123c1', class: {
                // COLORS
                'primary': this.color === 'primary',
                'secondary': this.color === 'secondary',
                'tertiary': this.color === 'tertiary',
                'subtle': this.color === 'subtle',
                'inverted': this.color === 'inverted',
                'error': this.color === 'error',
                'contrast': this.color === 'contrast',
                // WEIGHTS
                'medium': this.weight === 'medium',
                'semi-bold': this.weight === 'semiBold',
                'bold': this.weight === 'bold',
                // SIZES
                'body-2xs': this.variant === 'body2XS',
                'body-xs': this.variant === 'bodyXS',
                'body-s': this.variant === 'bodyS',
                'body-m': this.variant === 'bodyM',
                'body-l': this.variant === 'bodyL',
                'body-xl': this.variant === 'bodyXL',
                'heading-xs': this.variant === 'headingXS',
                'heading-s': this.variant === 'headingS',
                'heading-m': this.variant === 'headingM',
                'heading-l': this.variant === 'headingL',
                'heading-xl': this.variant === 'headingXL',
                'heading-2xl': this.variant === 'heading2XL',
            } }, this.getContent()));
    }
};
CpslText.style = CpslTextStyle0;

const cpslTileButtonCss = ":host{--button-icon-color:var(--cpsl-color-text-primary);--button-border-radius:var(--cpsl-border-radius-tile-button);--button-background-color:var(--cpsl-color-tile-button-surface-default);--button-border-color:var(--cpsl-color-tile-button-border);--button-width:72px;--button-height:56px;--button-gap:8px}:host :hover{--button-background-color:var(--cpsl-color-tile-button-surface-hover)}:host :active{--button-background-color:var(--cpsl-color-tile-button-surface-pressed)}.button-native{border-radius:var(--button-border-radius);-webkit-padding-start:var(--button-padding-start);padding-inline-start:var(--button-padding-start);-webkit-padding-end:var(--button-padding-end);padding-inline-end:var(--button-padding-end);padding-top:var(--button-padding-top);padding-bottom:var(--button-padding-bottom);border:1px solid transparent;cursor:pointer;background:var(--button-background-color);border-color:var(--button-border-color);display:flex;flex-direction:column;gap:var(--button-gap);align-items:center;justify-content:center;width:var(--button-width);height:var(--button-height);box-shadow:var(--button-box-shadow)}.button-native cpsl-icon{--icon-color:var(--button-icon-color);--height:var(--button-icon-height);--width:var(--button-icon-width)}";
const CpslTileButtonStyle0 = cpslTileButtonCss;

const CpslTileButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.src = undefined;
        this.icon = undefined;
    }
    render() {
        return (h(Host, { key: '5e9927f98dce681df1237a942d9e1d7fa121b607' }, h("button", { key: 'f555f7a1b3eafe29d67a65e014cdfd6305ffc2a4', class: "button-native" }, h("cpsl-icon", { key: '333bae4faf843a52c58e8b79234cb1e72a572a03', exportparts: "icon", src: this.src, icon: this.icon }), h("slot", { key: 'f56278acf1cc8298c7a06ecbdd8934498ed60e71' }))));
    }
};
CpslTileButton.style = CpslTileButtonStyle0;

export { CpslAlert as cpsl_alert, CpslAppBar as cpsl_app_bar, CpslAuthModal as cpsl_auth_modal, CpslAvatar as cpsl_avatar, CpslButton as cpsl_button, CpslButtonGroup as cpsl_button_group, CpslCard as cpsl_card, CpslCheckbox as cpsl_checkbox, CpslCodeInput as cpsl_code_input, CpslDivider as cpsl_divider, CpslDrawer as cpsl_drawer, CpslDropdown as cpsl_dropdown, CpslFileUpload as cpsl_file_upload, CpslIcon as cpsl_icon, CpslIconGroup as cpsl_icon_group, CpslInput as cpsl_input, CpslNavButtonGroup as cpsl_nav_button_group, CpslOverlay as cpsl_overlay, CpslPagination as cpsl_pagination, CpslPill as cpsl_pill, CpslPopover as cpsl_popover, CpslProgressIndicator as cpsl_progress_indicator, CpslQrCode as cpsl_qr_code, CpslRadio as cpsl_radio, CpslSelect as cpsl_select, CpslSelectItem as cpsl_select_item, CpslSlideButton as cpsl_slide_button, CpslSpinner as cpsl_spinner, CpslSwitch as cpsl_switch, CpslTab as cpsl_tab, CpslTable as cpsl_table, CpslTabs as cpsl_tabs, CpslText as cpsl_text, CpslTileButton as cpsl_tile_button };

//# sourceMappingURL=cpsl-alert_34.entry.js.map